(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire525f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire525f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7NZgr", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $5aeca1c8d8e01de6$export$6503ec6e8aabbaf; }, function (v) { return $5aeca1c8d8e01de6$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $5aeca1c8d8e01de6$export$f7ad0328861e2f03; }, function (v) { return $5aeca1c8d8e01de6$export$f7ad0328861e2f03 = v; });
var $5aeca1c8d8e01de6$export$6503ec6e8aabbaf;
var $5aeca1c8d8e01de6$export$f7ad0328861e2f03;
"use strict";
var $5aeca1c8d8e01de6$var$mapping = new Map();
function $5aeca1c8d8e01de6$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$5aeca1c8d8e01de6$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $5aeca1c8d8e01de6$var$resolve(id) {
    var resolved = $5aeca1c8d8e01de6$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$5aeca1c8d8e01de6$export$6503ec6e8aabbaf = $5aeca1c8d8e01de6$var$register;
$5aeca1c8d8e01de6$export$f7ad0328861e2f03 = $5aeca1c8d8e01de6$var$resolve;

});

parcelRegister("kdZVT", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $eb951013942afb07$export$bdfd709ae4826697; }, function (v) { return $eb951013942afb07$export$bdfd709ae4826697 = v; });
var $eb951013942afb07$export$bdfd709ae4826697;
var $eb951013942afb07$export$c9e73fbda7da57b6;
var $eb951013942afb07$export$5a759dc7a1cfb72a;
"use strict";
var $eb951013942afb07$var$bundleURL = {};
function $eb951013942afb07$var$getBundleURLCached(id) {
    var value = $eb951013942afb07$var$bundleURL[id];
    if (!value) {
        value = $eb951013942afb07$var$getBundleURL();
        $eb951013942afb07$var$bundleURL[id] = value;
    }
    return value;
}
function $eb951013942afb07$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $eb951013942afb07$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $eb951013942afb07$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $eb951013942afb07$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$eb951013942afb07$export$bdfd709ae4826697 = $eb951013942afb07$var$getBundleURLCached;
$eb951013942afb07$export$c9e73fbda7da57b6 = $eb951013942afb07$var$getBaseURL;
$eb951013942afb07$export$5a759dc7a1cfb72a = $eb951013942afb07$var$getOrigin;

});

parcelRegister("8wu30", function(module, exports) {
/* @preserve
 * Leaflet 1.9.4, a JS library for interactive maps. https://leafletjs.com
 * (c) 2010-2023 Vladimir Agafonkin, (c) 2010-2011 CloudMade
 */ (function(global, factory) {
    factory(module.exports);
})(module.exports, function(exports1) {
    "use strict";
    var version = "1.9.4";
    /*
   * @namespace Util
   *
   * Various utility functions, used by Leaflet internally.
   */ // @function extend(dest: Object, src?: Object): Object
    // Merges the properties of the `src` object (or multiple objects) into `dest` object and returns the latter. Has an `L.extend` shortcut.
    function extend(dest) {
        var i, j, len, src;
        for(j = 1, len = arguments.length; j < len; j++){
            src = arguments[j];
            for(i in src)dest[i] = src[i];
        }
        return dest;
    }
    // @function create(proto: Object, properties?: Object): Object
    // Compatibility polyfill for [Object.create](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/create)
    var create$2 = Object.create || function() {
        function F() {}
        return function(proto) {
            F.prototype = proto;
            return new F();
        };
    }();
    // @function bind(fn: Function, …): Function
    // Returns a new function bound to the arguments passed, like [Function.prototype.bind](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
    // Has a `L.bind()` shortcut.
    function bind(fn, obj) {
        var slice = Array.prototype.slice;
        if (fn.bind) return fn.bind.apply(fn, slice.call(arguments, 1));
        var args = slice.call(arguments, 2);
        return function() {
            return fn.apply(obj, args.length ? args.concat(slice.call(arguments)) : arguments);
        };
    }
    // @property lastId: Number
    // Last unique ID used by [`stamp()`](#util-stamp)
    var lastId = 0;
    // @function stamp(obj: Object): Number
    // Returns the unique ID of an object, assigning it one if it doesn't have it.
    function stamp(obj) {
        if (!("_leaflet_id" in obj)) obj["_leaflet_id"] = ++lastId;
        return obj._leaflet_id;
    }
    // @function throttle(fn: Function, time: Number, context: Object): Function
    // Returns a function which executes function `fn` with the given scope `context`
    // (so that the `this` keyword refers to `context` inside `fn`'s code). The function
    // `fn` will be called no more than one time per given amount of `time`. The arguments
    // received by the bound function will be any arguments passed when binding the
    // function, followed by any arguments passed when invoking the bound function.
    // Has an `L.throttle` shortcut.
    function throttle(fn, time, context) {
        var lock, args, wrapperFn, later;
        later = function() {
            // reset lock and call if queued
            lock = false;
            if (args) {
                wrapperFn.apply(context, args);
                args = false;
            }
        };
        wrapperFn = function() {
            if (lock) // called too soon, queue to call later
            args = arguments;
            else {
                // call and lock until later
                fn.apply(context, arguments);
                setTimeout(later, time);
                lock = true;
            }
        };
        return wrapperFn;
    }
    // @function wrapNum(num: Number, range: Number[], includeMax?: Boolean): Number
    // Returns the number `num` modulo `range` in such a way so it lies within
    // `range[0]` and `range[1]`. The returned value will be always smaller than
    // `range[1]` unless `includeMax` is set to `true`.
    function wrapNum(x, range, includeMax) {
        var max = range[1], min = range[0], d = max - min;
        return x === max && includeMax ? x : ((x - min) % d + d) % d + min;
    }
    // @function falseFn(): Function
    // Returns a function which always returns `false`.
    function falseFn() {
        return false;
    }
    // @function formatNum(num: Number, precision?: Number|false): Number
    // Returns the number `num` rounded with specified `precision`.
    // The default `precision` value is 6 decimal places.
    // `false` can be passed to skip any processing (can be useful to avoid round-off errors).
    function formatNum(num, precision) {
        if (precision === false) return num;
        var pow = Math.pow(10, precision === undefined ? 6 : precision);
        return Math.round(num * pow) / pow;
    }
    // @function trim(str: String): String
    // Compatibility polyfill for [String.prototype.trim](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim)
    function trim(str) {
        return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
    }
    // @function splitWords(str: String): String[]
    // Trims and splits the string on whitespace and returns the array of parts.
    function splitWords(str) {
        return trim(str).split(/\s+/);
    }
    // @function setOptions(obj: Object, options: Object): Object
    // Merges the given properties to the `options` of the `obj` object, returning the resulting options. See `Class options`. Has an `L.setOptions` shortcut.
    function setOptions(obj, options) {
        if (!Object.prototype.hasOwnProperty.call(obj, "options")) obj.options = obj.options ? create$2(obj.options) : {};
        for(var i in options)obj.options[i] = options[i];
        return obj.options;
    }
    // @function getParamString(obj: Object, existingUrl?: String, uppercase?: Boolean): String
    // Converts an object into a parameter URL string, e.g. `{a: "foo", b: "bar"}`
    // translates to `'?a=foo&b=bar'`. If `existingUrl` is set, the parameters will
    // be appended at the end. If `uppercase` is `true`, the parameter names will
    // be uppercased (e.g. `'?A=foo&B=bar'`)
    function getParamString(obj, existingUrl, uppercase) {
        var params = [];
        for(var i in obj)params.push(encodeURIComponent(uppercase ? i.toUpperCase() : i) + "=" + encodeURIComponent(obj[i]));
        return (!existingUrl || existingUrl.indexOf("?") === -1 ? "?" : "&") + params.join("&");
    }
    var templateRe = /\{ *([\w_ -]+) *\}/g;
    // @function template(str: String, data: Object): String
    // Simple templating facility, accepts a template string of the form `'Hello {a}, {b}'`
    // and a data object like `{a: 'foo', b: 'bar'}`, returns evaluated string
    // `('Hello foo, bar')`. You can also specify functions instead of strings for
    // data values — they will be evaluated passing `data` as an argument.
    function template(str, data) {
        return str.replace(templateRe, function(str, key) {
            var value = data[key];
            if (value === undefined) throw new Error("No value provided for variable " + str);
            else if (typeof value === "function") value = value(data);
            return value;
        });
    }
    // @function isArray(obj): Boolean
    // Compatibility polyfill for [Array.isArray](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray)
    var isArray = Array.isArray || function(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    // @function indexOf(array: Array, el: Object): Number
    // Compatibility polyfill for [Array.prototype.indexOf](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf)
    function indexOf(array, el) {
        for(var i = 0; i < array.length; i++){
            if (array[i] === el) return i;
        }
        return -1;
    }
    // @property emptyImageUrl: String
    // Data URI string containing a base64-encoded empty GIF image.
    // Used as a hack to free memory from unused images on WebKit-powered
    // mobile devices (by setting image `src` to this string).
    var emptyImageUrl = "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=";
    // inspired by https://paulirish.com/2011/requestanimationframe-for-smart-animating/
    function getPrefixed(name) {
        return window["webkit" + name] || window["moz" + name] || window["ms" + name];
    }
    var lastTime = 0;
    // fallback for IE 7-8
    function timeoutDefer(fn) {
        var time = +new Date(), timeToCall = Math.max(0, 16 - (time - lastTime));
        lastTime = time + timeToCall;
        return window.setTimeout(fn, timeToCall);
    }
    var requestFn = window.requestAnimationFrame || getPrefixed("RequestAnimationFrame") || timeoutDefer;
    var cancelFn = window.cancelAnimationFrame || getPrefixed("CancelAnimationFrame") || getPrefixed("CancelRequestAnimationFrame") || function(id) {
        window.clearTimeout(id);
    };
    // @function requestAnimFrame(fn: Function, context?: Object, immediate?: Boolean): Number
    // Schedules `fn` to be executed when the browser repaints. `fn` is bound to
    // `context` if given. When `immediate` is set, `fn` is called immediately if
    // the browser doesn't have native support for
    // [`window.requestAnimationFrame`](https://developer.mozilla.org/docs/Web/API/window/requestAnimationFrame),
    // otherwise it's delayed. Returns a request ID that can be used to cancel the request.
    function requestAnimFrame(fn, context, immediate) {
        if (immediate && requestFn === timeoutDefer) fn.call(context);
        else return requestFn.call(window, bind(fn, context));
    }
    // @function cancelAnimFrame(id: Number): undefined
    // Cancels a previous `requestAnimFrame`. See also [window.cancelAnimationFrame](https://developer.mozilla.org/docs/Web/API/window/cancelAnimationFrame).
    function cancelAnimFrame(id) {
        if (id) cancelFn.call(window, id);
    }
    var Util = {
        __proto__: null,
        extend: extend,
        create: create$2,
        bind: bind,
        get lastId () {
            return lastId;
        },
        stamp: stamp,
        throttle: throttle,
        wrapNum: wrapNum,
        falseFn: falseFn,
        formatNum: formatNum,
        trim: trim,
        splitWords: splitWords,
        setOptions: setOptions,
        getParamString: getParamString,
        template: template,
        isArray: isArray,
        indexOf: indexOf,
        emptyImageUrl: emptyImageUrl,
        requestFn: requestFn,
        cancelFn: cancelFn,
        requestAnimFrame: requestAnimFrame,
        cancelAnimFrame: cancelAnimFrame
    };
    // @class Class
    // @aka L.Class
    // @section
    // @uninheritable
    // Thanks to John Resig and Dean Edwards for inspiration!
    function Class() {}
    Class.extend = function(props) {
        // @function extend(props: Object): Function
        // [Extends the current class](#class-inheritance) given the properties to be included.
        // Returns a Javascript function that is a class constructor (to be called with `new`).
        var NewClass = function() {
            setOptions(this);
            // call the constructor
            if (this.initialize) this.initialize.apply(this, arguments);
            // call all constructor hooks
            this.callInitHooks();
        };
        var parentProto = NewClass.__super__ = this.prototype;
        var proto = create$2(parentProto);
        proto.constructor = NewClass;
        NewClass.prototype = proto;
        // inherit parent's statics
        for(var i in this)if (Object.prototype.hasOwnProperty.call(this, i) && i !== "prototype" && i !== "__super__") NewClass[i] = this[i];
        // mix static properties into the class
        if (props.statics) extend(NewClass, props.statics);
        // mix includes into the prototype
        if (props.includes) {
            checkDeprecatedMixinEvents(props.includes);
            extend.apply(null, [
                proto
            ].concat(props.includes));
        }
        // mix given properties into the prototype
        extend(proto, props);
        delete proto.statics;
        delete proto.includes;
        // merge options
        if (proto.options) {
            proto.options = parentProto.options ? create$2(parentProto.options) : {};
            extend(proto.options, props.options);
        }
        proto._initHooks = [];
        // add method for calling all hooks
        proto.callInitHooks = function() {
            if (this._initHooksCalled) return;
            if (parentProto.callInitHooks) parentProto.callInitHooks.call(this);
            this._initHooksCalled = true;
            for(var i = 0, len = proto._initHooks.length; i < len; i++)proto._initHooks[i].call(this);
        };
        return NewClass;
    };
    // @function include(properties: Object): this
    // [Includes a mixin](#class-includes) into the current class.
    Class.include = function(props) {
        var parentOptions = this.prototype.options;
        extend(this.prototype, props);
        if (props.options) {
            this.prototype.options = parentOptions;
            this.mergeOptions(props.options);
        }
        return this;
    };
    // @function mergeOptions(options: Object): this
    // [Merges `options`](#class-options) into the defaults of the class.
    Class.mergeOptions = function(options) {
        extend(this.prototype.options, options);
        return this;
    };
    // @function addInitHook(fn: Function): this
    // Adds a [constructor hook](#class-constructor-hooks) to the class.
    Class.addInitHook = function(fn) {
        var args = Array.prototype.slice.call(arguments, 1);
        var init = typeof fn === "function" ? fn : function() {
            this[fn].apply(this, args);
        };
        this.prototype._initHooks = this.prototype._initHooks || [];
        this.prototype._initHooks.push(init);
        return this;
    };
    function checkDeprecatedMixinEvents(includes) {
        /* global L: true */ if (typeof L === "undefined" || !L || !L.Mixin) return;
        includes = isArray(includes) ? includes : [
            includes
        ];
        for(var i = 0; i < includes.length; i++)if (includes[i] === L.Mixin.Events) console.warn("Deprecated include of L.Mixin.Events: this property will be removed in future releases, please inherit from L.Evented instead.", new Error().stack);
    }
    /*
   * @class Evented
   * @aka L.Evented
   * @inherits Class
   *
   * A set of methods shared between event-powered classes (like `Map` and `Marker`). Generally, events allow you to execute some function when something happens with an object (e.g. the user clicks on the map, causing the map to fire `'click'` event).
   *
   * @example
   *
   * ```js
   * map.on('click', function(e) {
   * 	alert(e.latlng);
   * } );
   * ```
   *
   * Leaflet deals with event listeners by reference, so if you want to add a listener and then remove it, define it as a function:
   *
   * ```js
   * function onClick(e) { ... }
   *
   * map.on('click', onClick);
   * map.off('click', onClick);
   * ```
   */ var Events = {
        /* @method on(type: String, fn: Function, context?: Object): this
  	 * Adds a listener function (`fn`) to a particular event type of the object. You can optionally specify the context of the listener (object the this keyword will point to). You can also pass several space-separated types (e.g. `'click dblclick'`).
  	 *
  	 * @alternative
  	 * @method on(eventMap: Object): this
  	 * Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
  	 */ on: function(types, fn, context) {
            // types can be a map of types/handlers
            if (typeof types === "object") for(var type in types)// we don't process space-separated events here for performance;
            // it's a hot path since Layer uses the on(obj) syntax
            this._on(type, types[type], fn);
            else {
                // types can be a string of space-separated words
                types = splitWords(types);
                for(var i = 0, len = types.length; i < len; i++)this._on(types[i], fn, context);
            }
            return this;
        },
        /* @method off(type: String, fn?: Function, context?: Object): this
  	 * Removes a previously added listener function. If no function is specified, it will remove all the listeners of that particular event from the object. Note that if you passed a custom context to `on`, you must pass the same context to `off` in order to remove the listener.
  	 *
  	 * @alternative
  	 * @method off(eventMap: Object): this
  	 * Removes a set of type/listener pairs.
  	 *
  	 * @alternative
  	 * @method off: this
  	 * Removes all listeners to all events on the object. This includes implicitly attached events.
  	 */ off: function(types, fn, context) {
            if (!arguments.length) // clear all listeners if called without arguments
            delete this._events;
            else if (typeof types === "object") for(var type in types)this._off(type, types[type], fn);
            else {
                types = splitWords(types);
                var removeAll = arguments.length === 1;
                for(var i = 0, len = types.length; i < len; i++)if (removeAll) this._off(types[i]);
                else this._off(types[i], fn, context);
            }
            return this;
        },
        // attach listener (without syntactic sugar now)
        _on: function(type, fn, context, _once) {
            if (typeof fn !== "function") {
                console.warn("wrong listener type: " + typeof fn);
                return;
            }
            // check if fn already there
            if (this._listens(type, fn, context) !== false) return;
            if (context === this) // Less memory footprint.
            context = undefined;
            var newListener = {
                fn: fn,
                ctx: context
            };
            if (_once) newListener.once = true;
            this._events = this._events || {};
            this._events[type] = this._events[type] || [];
            this._events[type].push(newListener);
        },
        _off: function(type, fn, context) {
            var listeners, i, len;
            if (!this._events) return;
            listeners = this._events[type];
            if (!listeners) return;
            if (arguments.length === 1) {
                if (this._firingCount) // Set all removed listeners to noop
                // so they are not called if remove happens in fire
                for(i = 0, len = listeners.length; i < len; i++)listeners[i].fn = falseFn;
                // clear all listeners for a type if function isn't specified
                delete this._events[type];
                return;
            }
            if (typeof fn !== "function") {
                console.warn("wrong listener type: " + typeof fn);
                return;
            }
            // find fn and remove it
            var index = this._listens(type, fn, context);
            if (index !== false) {
                var listener = listeners[index];
                if (this._firingCount) {
                    // set the removed listener to noop so that's not called if remove happens in fire
                    listener.fn = falseFn;
                    /* copy array in case events are being fired */ this._events[type] = listeners = listeners.slice();
                }
                listeners.splice(index, 1);
            }
        },
        // @method fire(type: String, data?: Object, propagate?: Boolean): this
        // Fires an event of the specified type. You can optionally provide a data
        // object — the first argument of the listener function will contain its
        // properties. The event can optionally be propagated to event parents.
        fire: function(type, data, propagate) {
            if (!this.listens(type, propagate)) return this;
            var event = extend({}, data, {
                type: type,
                target: this,
                sourceTarget: data && data.sourceTarget || this
            });
            if (this._events) {
                var listeners = this._events[type];
                if (listeners) {
                    this._firingCount = this._firingCount + 1 || 1;
                    for(var i = 0, len = listeners.length; i < len; i++){
                        var l = listeners[i];
                        // off overwrites l.fn, so we need to copy fn to a var
                        var fn = l.fn;
                        if (l.once) this.off(type, fn, l.ctx);
                        fn.call(l.ctx || this, event);
                    }
                    this._firingCount--;
                }
            }
            if (propagate) // propagate the event to parents (set with addEventParent)
            this._propagateEvent(event);
            return this;
        },
        // @method listens(type: String, propagate?: Boolean): Boolean
        // @method listens(type: String, fn: Function, context?: Object, propagate?: Boolean): Boolean
        // Returns `true` if a particular event type has any listeners attached to it.
        // The verification can optionally be propagated, it will return `true` if parents have the listener attached to it.
        listens: function(type, fn, context, propagate) {
            if (typeof type !== "string") console.warn('"string" type argument expected');
            // we don't overwrite the input `fn` value, because we need to use it for propagation
            var _fn = fn;
            if (typeof fn !== "function") {
                propagate = !!fn;
                _fn = undefined;
                context = undefined;
            }
            var listeners = this._events && this._events[type];
            if (listeners && listeners.length) {
                if (this._listens(type, _fn, context) !== false) return true;
            }
            if (propagate) // also check parents for listeners if event propagates
            for(var id in this._eventParents){
                if (this._eventParents[id].listens(type, fn, context, propagate)) return true;
            }
            return false;
        },
        // returns the index (number) or false
        _listens: function(type, fn, context) {
            if (!this._events) return false;
            var listeners = this._events[type] || [];
            if (!fn) return !!listeners.length;
            if (context === this) // Less memory footprint.
            context = undefined;
            for(var i = 0, len = listeners.length; i < len; i++){
                if (listeners[i].fn === fn && listeners[i].ctx === context) return i;
            }
            return false;
        },
        // @method once(…): this
        // Behaves as [`on(…)`](#evented-on), except the listener will only get fired once and then removed.
        once: function(types, fn, context) {
            // types can be a map of types/handlers
            if (typeof types === "object") for(var type in types)// we don't process space-separated events here for performance;
            // it's a hot path since Layer uses the on(obj) syntax
            this._on(type, types[type], fn, true);
            else {
                // types can be a string of space-separated words
                types = splitWords(types);
                for(var i = 0, len = types.length; i < len; i++)this._on(types[i], fn, context, true);
            }
            return this;
        },
        // @method addEventParent(obj: Evented): this
        // Adds an event parent - an `Evented` that will receive propagated events
        addEventParent: function(obj) {
            this._eventParents = this._eventParents || {};
            this._eventParents[stamp(obj)] = obj;
            return this;
        },
        // @method removeEventParent(obj: Evented): this
        // Removes an event parent, so it will stop receiving propagated events
        removeEventParent: function(obj) {
            if (this._eventParents) delete this._eventParents[stamp(obj)];
            return this;
        },
        _propagateEvent: function(e) {
            for(var id in this._eventParents)this._eventParents[id].fire(e.type, extend({
                layer: e.target,
                propagatedFrom: e.target
            }, e), true);
        }
    };
    // aliases; we should ditch those eventually
    // @method addEventListener(…): this
    // Alias to [`on(…)`](#evented-on)
    Events.addEventListener = Events.on;
    // @method removeEventListener(…): this
    // Alias to [`off(…)`](#evented-off)
    // @method clearAllEventListeners(…): this
    // Alias to [`off()`](#evented-off)
    Events.removeEventListener = Events.clearAllEventListeners = Events.off;
    // @method addOneTimeEventListener(…): this
    // Alias to [`once(…)`](#evented-once)
    Events.addOneTimeEventListener = Events.once;
    // @method fireEvent(…): this
    // Alias to [`fire(…)`](#evented-fire)
    Events.fireEvent = Events.fire;
    // @method hasEventListeners(…): Boolean
    // Alias to [`listens(…)`](#evented-listens)
    Events.hasEventListeners = Events.listens;
    var Evented = Class.extend(Events);
    /*
   * @class Point
   * @aka L.Point
   *
   * Represents a point with `x` and `y` coordinates in pixels.
   *
   * @example
   *
   * ```js
   * var point = L.point(200, 300);
   * ```
   *
   * All Leaflet methods and options that accept `Point` objects also accept them in a simple Array form (unless noted otherwise), so these lines are equivalent:
   *
   * ```js
   * map.panBy([200, 300]);
   * map.panBy(L.point(200, 300));
   * ```
   *
   * Note that `Point` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function Point(x, y, round) {
        // @property x: Number; The `x` coordinate of the point
        this.x = round ? Math.round(x) : x;
        // @property y: Number; The `y` coordinate of the point
        this.y = round ? Math.round(y) : y;
    }
    var trunc = Math.trunc || function(v) {
        return v > 0 ? Math.floor(v) : Math.ceil(v);
    };
    Point.prototype = {
        // @method clone(): Point
        // Returns a copy of the current point.
        clone: function() {
            return new Point(this.x, this.y);
        },
        // @method add(otherPoint: Point): Point
        // Returns the result of addition of the current and the given points.
        add: function(point) {
            // non-destructive, returns a new point
            return this.clone()._add(toPoint(point));
        },
        _add: function(point) {
            // destructive, used directly for performance in situations where it's safe to modify existing point
            this.x += point.x;
            this.y += point.y;
            return this;
        },
        // @method subtract(otherPoint: Point): Point
        // Returns the result of subtraction of the given point from the current.
        subtract: function(point) {
            return this.clone()._subtract(toPoint(point));
        },
        _subtract: function(point) {
            this.x -= point.x;
            this.y -= point.y;
            return this;
        },
        // @method divideBy(num: Number): Point
        // Returns the result of division of the current point by the given number.
        divideBy: function(num) {
            return this.clone()._divideBy(num);
        },
        _divideBy: function(num) {
            this.x /= num;
            this.y /= num;
            return this;
        },
        // @method multiplyBy(num: Number): Point
        // Returns the result of multiplication of the current point by the given number.
        multiplyBy: function(num) {
            return this.clone()._multiplyBy(num);
        },
        _multiplyBy: function(num) {
            this.x *= num;
            this.y *= num;
            return this;
        },
        // @method scaleBy(scale: Point): Point
        // Multiply each coordinate of the current point by each coordinate of
        // `scale`. In linear algebra terms, multiply the point by the
        // [scaling matrix](https://en.wikipedia.org/wiki/Scaling_%28geometry%29#Matrix_representation)
        // defined by `scale`.
        scaleBy: function(point) {
            return new Point(this.x * point.x, this.y * point.y);
        },
        // @method unscaleBy(scale: Point): Point
        // Inverse of `scaleBy`. Divide each coordinate of the current point by
        // each coordinate of `scale`.
        unscaleBy: function(point) {
            return new Point(this.x / point.x, this.y / point.y);
        },
        // @method round(): Point
        // Returns a copy of the current point with rounded coordinates.
        round: function() {
            return this.clone()._round();
        },
        _round: function() {
            this.x = Math.round(this.x);
            this.y = Math.round(this.y);
            return this;
        },
        // @method floor(): Point
        // Returns a copy of the current point with floored coordinates (rounded down).
        floor: function() {
            return this.clone()._floor();
        },
        _floor: function() {
            this.x = Math.floor(this.x);
            this.y = Math.floor(this.y);
            return this;
        },
        // @method ceil(): Point
        // Returns a copy of the current point with ceiled coordinates (rounded up).
        ceil: function() {
            return this.clone()._ceil();
        },
        _ceil: function() {
            this.x = Math.ceil(this.x);
            this.y = Math.ceil(this.y);
            return this;
        },
        // @method trunc(): Point
        // Returns a copy of the current point with truncated coordinates (rounded towards zero).
        trunc: function() {
            return this.clone()._trunc();
        },
        _trunc: function() {
            this.x = trunc(this.x);
            this.y = trunc(this.y);
            return this;
        },
        // @method distanceTo(otherPoint: Point): Number
        // Returns the cartesian distance between the current and the given points.
        distanceTo: function(point) {
            point = toPoint(point);
            var x = point.x - this.x, y = point.y - this.y;
            return Math.sqrt(x * x + y * y);
        },
        // @method equals(otherPoint: Point): Boolean
        // Returns `true` if the given point has the same coordinates.
        equals: function(point) {
            point = toPoint(point);
            return point.x === this.x && point.y === this.y;
        },
        // @method contains(otherPoint: Point): Boolean
        // Returns `true` if both coordinates of the given point are less than the corresponding current point coordinates (in absolute values).
        contains: function(point) {
            point = toPoint(point);
            return Math.abs(point.x) <= Math.abs(this.x) && Math.abs(point.y) <= Math.abs(this.y);
        },
        // @method toString(): String
        // Returns a string representation of the point for debugging purposes.
        toString: function() {
            return "Point(" + formatNum(this.x) + ", " + formatNum(this.y) + ")";
        }
    };
    // @factory L.point(x: Number, y: Number, round?: Boolean)
    // Creates a Point object with the given `x` and `y` coordinates. If optional `round` is set to true, rounds the `x` and `y` values.
    // @alternative
    // @factory L.point(coords: Number[])
    // Expects an array of the form `[x, y]` instead.
    // @alternative
    // @factory L.point(coords: Object)
    // Expects a plain object of the form `{x: Number, y: Number}` instead.
    function toPoint(x, y, round) {
        if (x instanceof Point) return x;
        if (isArray(x)) return new Point(x[0], x[1]);
        if (x === undefined || x === null) return x;
        if (typeof x === "object" && "x" in x && "y" in x) return new Point(x.x, x.y);
        return new Point(x, y, round);
    }
    /*
   * @class Bounds
   * @aka L.Bounds
   *
   * Represents a rectangular area in pixel coordinates.
   *
   * @example
   *
   * ```js
   * var p1 = L.point(10, 10),
   * p2 = L.point(40, 60),
   * bounds = L.bounds(p1, p2);
   * ```
   *
   * All Leaflet methods that accept `Bounds` objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
   *
   * ```js
   * otherBounds.intersects([[10, 10], [40, 60]]);
   * ```
   *
   * Note that `Bounds` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function Bounds(a, b) {
        if (!a) return;
        var points = b ? [
            a,
            b
        ] : a;
        for(var i = 0, len = points.length; i < len; i++)this.extend(points[i]);
    }
    Bounds.prototype = {
        // @method extend(point: Point): this
        // Extends the bounds to contain the given point.
        // @alternative
        // @method extend(otherBounds: Bounds): this
        // Extend the bounds to contain the given bounds
        extend: function(obj) {
            var min2, max2;
            if (!obj) return this;
            if (obj instanceof Point || typeof obj[0] === "number" || "x" in obj) min2 = max2 = toPoint(obj);
            else {
                obj = toBounds(obj);
                min2 = obj.min;
                max2 = obj.max;
                if (!min2 || !max2) return this;
            }
            // @property min: Point
            // The top left corner of the rectangle.
            // @property max: Point
            // The bottom right corner of the rectangle.
            if (!this.min && !this.max) {
                this.min = min2.clone();
                this.max = max2.clone();
            } else {
                this.min.x = Math.min(min2.x, this.min.x);
                this.max.x = Math.max(max2.x, this.max.x);
                this.min.y = Math.min(min2.y, this.min.y);
                this.max.y = Math.max(max2.y, this.max.y);
            }
            return this;
        },
        // @method getCenter(round?: Boolean): Point
        // Returns the center point of the bounds.
        getCenter: function(round) {
            return toPoint((this.min.x + this.max.x) / 2, (this.min.y + this.max.y) / 2, round);
        },
        // @method getBottomLeft(): Point
        // Returns the bottom-left point of the bounds.
        getBottomLeft: function() {
            return toPoint(this.min.x, this.max.y);
        },
        // @method getTopRight(): Point
        // Returns the top-right point of the bounds.
        getTopRight: function() {
            return toPoint(this.max.x, this.min.y);
        },
        // @method getTopLeft(): Point
        // Returns the top-left point of the bounds (i.e. [`this.min`](#bounds-min)).
        getTopLeft: function() {
            return this.min; // left, top
        },
        // @method getBottomRight(): Point
        // Returns the bottom-right point of the bounds (i.e. [`this.max`](#bounds-max)).
        getBottomRight: function() {
            return this.max; // right, bottom
        },
        // @method getSize(): Point
        // Returns the size of the given bounds
        getSize: function() {
            return this.max.subtract(this.min);
        },
        // @method contains(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle contains the given one.
        // @alternative
        // @method contains(point: Point): Boolean
        // Returns `true` if the rectangle contains the given point.
        contains: function(obj) {
            var min, max;
            if (typeof obj[0] === "number" || obj instanceof Point) obj = toPoint(obj);
            else obj = toBounds(obj);
            if (obj instanceof Bounds) {
                min = obj.min;
                max = obj.max;
            } else min = max = obj;
            return min.x >= this.min.x && max.x <= this.max.x && min.y >= this.min.y && max.y <= this.max.y;
        },
        // @method intersects(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle intersects the given bounds. Two bounds
        // intersect if they have at least one point in common.
        intersects: function(bounds) {
            bounds = toBounds(bounds);
            var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xIntersects = max2.x >= min.x && min2.x <= max.x, yIntersects = max2.y >= min.y && min2.y <= max.y;
            return xIntersects && yIntersects;
        },
        // @method overlaps(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle overlaps the given bounds. Two bounds
        // overlap if their intersection is an area.
        overlaps: function(bounds) {
            bounds = toBounds(bounds);
            var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xOverlaps = max2.x > min.x && min2.x < max.x, yOverlaps = max2.y > min.y && min2.y < max.y;
            return xOverlaps && yOverlaps;
        },
        // @method isValid(): Boolean
        // Returns `true` if the bounds are properly initialized.
        isValid: function() {
            return !!(this.min && this.max);
        },
        // @method pad(bufferRatio: Number): Bounds
        // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
        // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
        // Negative values will retract the bounds.
        pad: function(bufferRatio) {
            var min = this.min, max = this.max, heightBuffer = Math.abs(min.x - max.x) * bufferRatio, widthBuffer = Math.abs(min.y - max.y) * bufferRatio;
            return toBounds(toPoint(min.x - heightBuffer, min.y - widthBuffer), toPoint(max.x + heightBuffer, max.y + widthBuffer));
        },
        // @method equals(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle is equivalent to the given bounds.
        equals: function(bounds) {
            if (!bounds) return false;
            bounds = toBounds(bounds);
            return this.min.equals(bounds.getTopLeft()) && this.max.equals(bounds.getBottomRight());
        }
    };
    // @factory L.bounds(corner1: Point, corner2: Point)
    // Creates a Bounds object from two corners coordinate pairs.
    // @alternative
    // @factory L.bounds(points: Point[])
    // Creates a Bounds object from the given array of points.
    function toBounds(a, b) {
        if (!a || a instanceof Bounds) return a;
        return new Bounds(a, b);
    }
    /*
   * @class LatLngBounds
   * @aka L.LatLngBounds
   *
   * Represents a rectangular geographical area on a map.
   *
   * @example
   *
   * ```js
   * var corner1 = L.latLng(40.712, -74.227),
   * corner2 = L.latLng(40.774, -74.125),
   * bounds = L.latLngBounds(corner1, corner2);
   * ```
   *
   * All Leaflet methods that accept LatLngBounds objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
   *
   * ```js
   * map.fitBounds([
   * 	[40.712, -74.227],
   * 	[40.774, -74.125]
   * ]);
   * ```
   *
   * Caution: if the area crosses the antimeridian (often confused with the International Date Line), you must specify corners _outside_ the [-180, 180] degrees longitude range.
   *
   * Note that `LatLngBounds` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function LatLngBounds(corner1, corner2) {
        if (!corner1) return;
        var latlngs = corner2 ? [
            corner1,
            corner2
        ] : corner1;
        for(var i = 0, len = latlngs.length; i < len; i++)this.extend(latlngs[i]);
    }
    LatLngBounds.prototype = {
        // @method extend(latlng: LatLng): this
        // Extend the bounds to contain the given point
        // @alternative
        // @method extend(otherBounds: LatLngBounds): this
        // Extend the bounds to contain the given bounds
        extend: function(obj) {
            var sw = this._southWest, ne = this._northEast, sw2, ne2;
            if (obj instanceof LatLng) {
                sw2 = obj;
                ne2 = obj;
            } else if (obj instanceof LatLngBounds) {
                sw2 = obj._southWest;
                ne2 = obj._northEast;
                if (!sw2 || !ne2) return this;
            } else return obj ? this.extend(toLatLng(obj) || toLatLngBounds(obj)) : this;
            if (!sw && !ne) {
                this._southWest = new LatLng(sw2.lat, sw2.lng);
                this._northEast = new LatLng(ne2.lat, ne2.lng);
            } else {
                sw.lat = Math.min(sw2.lat, sw.lat);
                sw.lng = Math.min(sw2.lng, sw.lng);
                ne.lat = Math.max(ne2.lat, ne.lat);
                ne.lng = Math.max(ne2.lng, ne.lng);
            }
            return this;
        },
        // @method pad(bufferRatio: Number): LatLngBounds
        // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
        // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
        // Negative values will retract the bounds.
        pad: function(bufferRatio) {
            var sw = this._southWest, ne = this._northEast, heightBuffer = Math.abs(sw.lat - ne.lat) * bufferRatio, widthBuffer = Math.abs(sw.lng - ne.lng) * bufferRatio;
            return new LatLngBounds(new LatLng(sw.lat - heightBuffer, sw.lng - widthBuffer), new LatLng(ne.lat + heightBuffer, ne.lng + widthBuffer));
        },
        // @method getCenter(): LatLng
        // Returns the center point of the bounds.
        getCenter: function() {
            return new LatLng((this._southWest.lat + this._northEast.lat) / 2, (this._southWest.lng + this._northEast.lng) / 2);
        },
        // @method getSouthWest(): LatLng
        // Returns the south-west point of the bounds.
        getSouthWest: function() {
            return this._southWest;
        },
        // @method getNorthEast(): LatLng
        // Returns the north-east point of the bounds.
        getNorthEast: function() {
            return this._northEast;
        },
        // @method getNorthWest(): LatLng
        // Returns the north-west point of the bounds.
        getNorthWest: function() {
            return new LatLng(this.getNorth(), this.getWest());
        },
        // @method getSouthEast(): LatLng
        // Returns the south-east point of the bounds.
        getSouthEast: function() {
            return new LatLng(this.getSouth(), this.getEast());
        },
        // @method getWest(): Number
        // Returns the west longitude of the bounds
        getWest: function() {
            return this._southWest.lng;
        },
        // @method getSouth(): Number
        // Returns the south latitude of the bounds
        getSouth: function() {
            return this._southWest.lat;
        },
        // @method getEast(): Number
        // Returns the east longitude of the bounds
        getEast: function() {
            return this._northEast.lng;
        },
        // @method getNorth(): Number
        // Returns the north latitude of the bounds
        getNorth: function() {
            return this._northEast.lat;
        },
        // @method contains(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle contains the given one.
        // @alternative
        // @method contains (latlng: LatLng): Boolean
        // Returns `true` if the rectangle contains the given point.
        contains: function(obj) {
            if (typeof obj[0] === "number" || obj instanceof LatLng || "lat" in obj) obj = toLatLng(obj);
            else obj = toLatLngBounds(obj);
            var sw = this._southWest, ne = this._northEast, sw2, ne2;
            if (obj instanceof LatLngBounds) {
                sw2 = obj.getSouthWest();
                ne2 = obj.getNorthEast();
            } else sw2 = ne2 = obj;
            return sw2.lat >= sw.lat && ne2.lat <= ne.lat && sw2.lng >= sw.lng && ne2.lng <= ne.lng;
        },
        // @method intersects(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle intersects the given bounds. Two bounds intersect if they have at least one point in common.
        intersects: function(bounds) {
            bounds = toLatLngBounds(bounds);
            var sw = this._southWest, ne = this._northEast, sw2 = bounds.getSouthWest(), ne2 = bounds.getNorthEast(), latIntersects = ne2.lat >= sw.lat && sw2.lat <= ne.lat, lngIntersects = ne2.lng >= sw.lng && sw2.lng <= ne.lng;
            return latIntersects && lngIntersects;
        },
        // @method overlaps(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle overlaps the given bounds. Two bounds overlap if their intersection is an area.
        overlaps: function(bounds) {
            bounds = toLatLngBounds(bounds);
            var sw = this._southWest, ne = this._northEast, sw2 = bounds.getSouthWest(), ne2 = bounds.getNorthEast(), latOverlaps = ne2.lat > sw.lat && sw2.lat < ne.lat, lngOverlaps = ne2.lng > sw.lng && sw2.lng < ne.lng;
            return latOverlaps && lngOverlaps;
        },
        // @method toBBoxString(): String
        // Returns a string with bounding box coordinates in a 'southwest_lng,southwest_lat,northeast_lng,northeast_lat' format. Useful for sending requests to web services that return geo data.
        toBBoxString: function() {
            return [
                this.getWest(),
                this.getSouth(),
                this.getEast(),
                this.getNorth()
            ].join(",");
        },
        // @method equals(otherBounds: LatLngBounds, maxMargin?: Number): Boolean
        // Returns `true` if the rectangle is equivalent (within a small margin of error) to the given bounds. The margin of error can be overridden by setting `maxMargin` to a small number.
        equals: function(bounds, maxMargin) {
            if (!bounds) return false;
            bounds = toLatLngBounds(bounds);
            return this._southWest.equals(bounds.getSouthWest(), maxMargin) && this._northEast.equals(bounds.getNorthEast(), maxMargin);
        },
        // @method isValid(): Boolean
        // Returns `true` if the bounds are properly initialized.
        isValid: function() {
            return !!(this._southWest && this._northEast);
        }
    };
    // TODO International date line?
    // @factory L.latLngBounds(corner1: LatLng, corner2: LatLng)
    // Creates a `LatLngBounds` object by defining two diagonally opposite corners of the rectangle.
    // @alternative
    // @factory L.latLngBounds(latlngs: LatLng[])
    // Creates a `LatLngBounds` object defined by the geographical points it contains. Very useful for zooming the map to fit a particular set of locations with [`fitBounds`](#map-fitbounds).
    function toLatLngBounds(a, b) {
        if (a instanceof LatLngBounds) return a;
        return new LatLngBounds(a, b);
    }
    /* @class LatLng
   * @aka L.LatLng
   *
   * Represents a geographical point with a certain latitude and longitude.
   *
   * @example
   *
   * ```
   * var latlng = L.latLng(50.5, 30.5);
   * ```
   *
   * All Leaflet methods that accept LatLng objects also accept them in a simple Array form and simple object form (unless noted otherwise), so these lines are equivalent:
   *
   * ```
   * map.panTo([50, 30]);
   * map.panTo({lon: 30, lat: 50});
   * map.panTo({lat: 50, lng: 30});
   * map.panTo(L.latLng(50, 30));
   * ```
   *
   * Note that `LatLng` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function LatLng(lat, lng, alt) {
        if (isNaN(lat) || isNaN(lng)) throw new Error("Invalid LatLng object: (" + lat + ", " + lng + ")");
        // @property lat: Number
        // Latitude in degrees
        this.lat = +lat;
        // @property lng: Number
        // Longitude in degrees
        this.lng = +lng;
        // @property alt: Number
        // Altitude in meters (optional)
        if (alt !== undefined) this.alt = +alt;
    }
    LatLng.prototype = {
        // @method equals(otherLatLng: LatLng, maxMargin?: Number): Boolean
        // Returns `true` if the given `LatLng` point is at the same position (within a small margin of error). The margin of error can be overridden by setting `maxMargin` to a small number.
        equals: function(obj, maxMargin) {
            if (!obj) return false;
            obj = toLatLng(obj);
            var margin = Math.max(Math.abs(this.lat - obj.lat), Math.abs(this.lng - obj.lng));
            return margin <= (maxMargin === undefined ? 1.0E-9 : maxMargin);
        },
        // @method toString(): String
        // Returns a string representation of the point (for debugging purposes).
        toString: function(precision) {
            return "LatLng(" + formatNum(this.lat, precision) + ", " + formatNum(this.lng, precision) + ")";
        },
        // @method distanceTo(otherLatLng: LatLng): Number
        // Returns the distance (in meters) to the given `LatLng` calculated using the [Spherical Law of Cosines](https://en.wikipedia.org/wiki/Spherical_law_of_cosines).
        distanceTo: function(other) {
            return Earth.distance(this, toLatLng(other));
        },
        // @method wrap(): LatLng
        // Returns a new `LatLng` object with the longitude wrapped so it's always between -180 and +180 degrees.
        wrap: function() {
            return Earth.wrapLatLng(this);
        },
        // @method toBounds(sizeInMeters: Number): LatLngBounds
        // Returns a new `LatLngBounds` object in which each boundary is `sizeInMeters/2` meters apart from the `LatLng`.
        toBounds: function(sizeInMeters) {
            var latAccuracy = 180 * sizeInMeters / 40075017, lngAccuracy = latAccuracy / Math.cos(Math.PI / 180 * this.lat);
            return toLatLngBounds([
                this.lat - latAccuracy,
                this.lng - lngAccuracy
            ], [
                this.lat + latAccuracy,
                this.lng + lngAccuracy
            ]);
        },
        clone: function() {
            return new LatLng(this.lat, this.lng, this.alt);
        }
    };
    // @factory L.latLng(latitude: Number, longitude: Number, altitude?: Number): LatLng
    // Creates an object representing a geographical point with the given latitude and longitude (and optionally altitude).
    // @alternative
    // @factory L.latLng(coords: Array): LatLng
    // Expects an array of the form `[Number, Number]` or `[Number, Number, Number]` instead.
    // @alternative
    // @factory L.latLng(coords: Object): LatLng
    // Expects an plain object of the form `{lat: Number, lng: Number}` or `{lat: Number, lng: Number, alt: Number}` instead.
    function toLatLng(a, b, c) {
        if (a instanceof LatLng) return a;
        if (isArray(a) && typeof a[0] !== "object") {
            if (a.length === 3) return new LatLng(a[0], a[1], a[2]);
            if (a.length === 2) return new LatLng(a[0], a[1]);
            return null;
        }
        if (a === undefined || a === null) return a;
        if (typeof a === "object" && "lat" in a) return new LatLng(a.lat, "lng" in a ? a.lng : a.lon, a.alt);
        if (b === undefined) return null;
        return new LatLng(a, b, c);
    }
    /*
   * @namespace CRS
   * @crs L.CRS.Base
   * Object that defines coordinate reference systems for projecting
   * geographical points into pixel (screen) coordinates and back (and to
   * coordinates in other units for [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services). See
   * [spatial reference system](https://en.wikipedia.org/wiki/Spatial_reference_system).
   *
   * Leaflet defines the most usual CRSs by default. If you want to use a
   * CRS not defined by default, take a look at the
   * [Proj4Leaflet](https://github.com/kartena/Proj4Leaflet) plugin.
   *
   * Note that the CRS instances do not inherit from Leaflet's `Class` object,
   * and can't be instantiated. Also, new classes can't inherit from them,
   * and methods can't be added to them with the `include` function.
   */ var CRS = {
        // @method latLngToPoint(latlng: LatLng, zoom: Number): Point
        // Projects geographical coordinates into pixel coordinates for a given zoom.
        latLngToPoint: function(latlng, zoom) {
            var projectedPoint = this.projection.project(latlng), scale = this.scale(zoom);
            return this.transformation._transform(projectedPoint, scale);
        },
        // @method pointToLatLng(point: Point, zoom: Number): LatLng
        // The inverse of `latLngToPoint`. Projects pixel coordinates on a given
        // zoom into geographical coordinates.
        pointToLatLng: function(point, zoom) {
            var scale = this.scale(zoom), untransformedPoint = this.transformation.untransform(point, scale);
            return this.projection.unproject(untransformedPoint);
        },
        // @method project(latlng: LatLng): Point
        // Projects geographical coordinates into coordinates in units accepted for
        // this CRS (e.g. meters for EPSG:3857, for passing it to WMS services).
        project: function(latlng) {
            return this.projection.project(latlng);
        },
        // @method unproject(point: Point): LatLng
        // Given a projected coordinate returns the corresponding LatLng.
        // The inverse of `project`.
        unproject: function(point) {
            return this.projection.unproject(point);
        },
        // @method scale(zoom: Number): Number
        // Returns the scale used when transforming projected coordinates into
        // pixel coordinates for a particular zoom. For example, it returns
        // `256 * 2^zoom` for Mercator-based CRS.
        scale: function(zoom) {
            return 256 * Math.pow(2, zoom);
        },
        // @method zoom(scale: Number): Number
        // Inverse of `scale()`, returns the zoom level corresponding to a scale
        // factor of `scale`.
        zoom: function(scale) {
            return Math.log(scale / 256) / Math.LN2;
        },
        // @method getProjectedBounds(zoom: Number): Bounds
        // Returns the projection's bounds scaled and transformed for the provided `zoom`.
        getProjectedBounds: function(zoom) {
            if (this.infinite) return null;
            var b = this.projection.bounds, s = this.scale(zoom), min = this.transformation.transform(b.min, s), max = this.transformation.transform(b.max, s);
            return new Bounds(min, max);
        },
        // @method distance(latlng1: LatLng, latlng2: LatLng): Number
        // Returns the distance between two geographical coordinates.
        // @property code: String
        // Standard code name of the CRS passed into WMS services (e.g. `'EPSG:3857'`)
        //
        // @property wrapLng: Number[]
        // An array of two numbers defining whether the longitude (horizontal) coordinate
        // axis wraps around a given range and how. Defaults to `[-180, 180]` in most
        // geographical CRSs. If `undefined`, the longitude axis does not wrap around.
        //
        // @property wrapLat: Number[]
        // Like `wrapLng`, but for the latitude (vertical) axis.
        // wrapLng: [min, max],
        // wrapLat: [min, max],
        // @property infinite: Boolean
        // If true, the coordinate space will be unbounded (infinite in both axes)
        infinite: false,
        // @method wrapLatLng(latlng: LatLng): LatLng
        // Returns a `LatLng` where lat and lng has been wrapped according to the
        // CRS's `wrapLat` and `wrapLng` properties, if they are outside the CRS's bounds.
        wrapLatLng: function(latlng) {
            var lng = this.wrapLng ? wrapNum(latlng.lng, this.wrapLng, true) : latlng.lng, lat = this.wrapLat ? wrapNum(latlng.lat, this.wrapLat, true) : latlng.lat, alt = latlng.alt;
            return new LatLng(lat, lng, alt);
        },
        // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
        // Returns a `LatLngBounds` with the same size as the given one, ensuring
        // that its center is within the CRS's bounds.
        // Only accepts actual `L.LatLngBounds` instances, not arrays.
        wrapLatLngBounds: function(bounds) {
            var center = bounds.getCenter(), newCenter = this.wrapLatLng(center), latShift = center.lat - newCenter.lat, lngShift = center.lng - newCenter.lng;
            if (latShift === 0 && lngShift === 0) return bounds;
            var sw = bounds.getSouthWest(), ne = bounds.getNorthEast(), newSw = new LatLng(sw.lat - latShift, sw.lng - lngShift), newNe = new LatLng(ne.lat - latShift, ne.lng - lngShift);
            return new LatLngBounds(newSw, newNe);
        }
    };
    /*
   * @namespace CRS
   * @crs L.CRS.Earth
   *
   * Serves as the base for CRS that are global such that they cover the earth.
   * Can only be used as the base for other CRS and cannot be used directly,
   * since it does not have a `code`, `projection` or `transformation`. `distance()` returns
   * meters.
   */ var Earth = extend({}, CRS, {
        wrapLng: [
            -180,
            180
        ],
        // Mean Earth Radius, as recommended for use by
        // the International Union of Geodesy and Geophysics,
        // see https://rosettacode.org/wiki/Haversine_formula
        R: 6371000,
        // distance between two geographical points using spherical law of cosines approximation
        distance: function(latlng1, latlng2) {
            var rad = Math.PI / 180, lat1 = latlng1.lat * rad, lat2 = latlng2.lat * rad, sinDLat = Math.sin((latlng2.lat - latlng1.lat) * rad / 2), sinDLon = Math.sin((latlng2.lng - latlng1.lng) * rad / 2), a = sinDLat * sinDLat + Math.cos(lat1) * Math.cos(lat2) * sinDLon * sinDLon, c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            return this.R * c;
        }
    });
    /*
   * @namespace Projection
   * @projection L.Projection.SphericalMercator
   *
   * Spherical Mercator projection — the most common projection for online maps,
   * used by almost all free and commercial tile providers. Assumes that Earth is
   * a sphere. Used by the `EPSG:3857` CRS.
   */ var earthRadius = 6378137;
    var SphericalMercator = {
        R: earthRadius,
        MAX_LATITUDE: 85.0511287798,
        project: function(latlng) {
            var d = Math.PI / 180, max = this.MAX_LATITUDE, lat = Math.max(Math.min(max, latlng.lat), -max), sin = Math.sin(lat * d);
            return new Point(this.R * latlng.lng * d, this.R * Math.log((1 + sin) / (1 - sin)) / 2);
        },
        unproject: function(point) {
            var d = 180 / Math.PI;
            return new LatLng((2 * Math.atan(Math.exp(point.y / this.R)) - Math.PI / 2) * d, point.x * d / this.R);
        },
        bounds: function() {
            var d = earthRadius * Math.PI;
            return new Bounds([
                -d,
                -d
            ], [
                d,
                d
            ]);
        }()
    };
    /*
   * @class Transformation
   * @aka L.Transformation
   *
   * Represents an affine transformation: a set of coefficients `a`, `b`, `c`, `d`
   * for transforming a point of a form `(x, y)` into `(a*x + b, c*y + d)` and doing
   * the reverse. Used by Leaflet in its projections code.
   *
   * @example
   *
   * ```js
   * var transformation = L.transformation(2, 5, -1, 10),
   * 	p = L.point(1, 2),
   * 	p2 = transformation.transform(p), //  L.point(7, 8)
   * 	p3 = transformation.untransform(p2); //  L.point(1, 2)
   * ```
   */ // factory new L.Transformation(a: Number, b: Number, c: Number, d: Number)
    // Creates a `Transformation` object with the given coefficients.
    function Transformation(a, b, c, d) {
        if (isArray(a)) {
            // use array properties
            this._a = a[0];
            this._b = a[1];
            this._c = a[2];
            this._d = a[3];
            return;
        }
        this._a = a;
        this._b = b;
        this._c = c;
        this._d = d;
    }
    Transformation.prototype = {
        // @method transform(point: Point, scale?: Number): Point
        // Returns a transformed point, optionally multiplied by the given scale.
        // Only accepts actual `L.Point` instances, not arrays.
        transform: function(point, scale) {
            return this._transform(point.clone(), scale);
        },
        // destructive transform (faster)
        _transform: function(point, scale) {
            scale = scale || 1;
            point.x = scale * (this._a * point.x + this._b);
            point.y = scale * (this._c * point.y + this._d);
            return point;
        },
        // @method untransform(point: Point, scale?: Number): Point
        // Returns the reverse transformation of the given point, optionally divided
        // by the given scale. Only accepts actual `L.Point` instances, not arrays.
        untransform: function(point, scale) {
            scale = scale || 1;
            return new Point((point.x / scale - this._b) / this._a, (point.y / scale - this._d) / this._c);
        }
    };
    // factory L.transformation(a: Number, b: Number, c: Number, d: Number)
    // @factory L.transformation(a: Number, b: Number, c: Number, d: Number)
    // Instantiates a Transformation object with the given coefficients.
    // @alternative
    // @factory L.transformation(coefficients: Array): Transformation
    // Expects an coefficients array of the form
    // `[a: Number, b: Number, c: Number, d: Number]`.
    function toTransformation(a, b, c, d) {
        return new Transformation(a, b, c, d);
    }
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG3857
   *
   * The most common CRS for online maps, used by almost all free and commercial
   * tile providers. Uses Spherical Mercator projection. Set in by default in
   * Map's `crs` option.
   */ var EPSG3857 = extend({}, Earth, {
        code: "EPSG:3857",
        projection: SphericalMercator,
        transformation: function() {
            var scale = 0.5 / (Math.PI * SphericalMercator.R);
            return toTransformation(scale, 0.5, -scale, 0.5);
        }()
    });
    var EPSG900913 = extend({}, EPSG3857, {
        code: "EPSG:900913"
    });
    // @namespace SVG; @section
    // There are several static functions which can be called without instantiating L.SVG:
    // @function create(name: String): SVGElement
    // Returns a instance of [SVGElement](https://developer.mozilla.org/docs/Web/API/SVGElement),
    // corresponding to the class name passed. For example, using 'line' will return
    // an instance of [SVGLineElement](https://developer.mozilla.org/docs/Web/API/SVGLineElement).
    function svgCreate(name) {
        return document.createElementNS("http://www.w3.org/2000/svg", name);
    }
    // @function pointsToPath(rings: Point[], closed: Boolean): String
    // Generates a SVG path string for multiple rings, with each ring turning
    // into "M..L..L.." instructions
    function pointsToPath(rings, closed) {
        var str = "", i, j, len, len2, points, p;
        for(i = 0, len = rings.length; i < len; i++){
            points = rings[i];
            for(j = 0, len2 = points.length; j < len2; j++){
                p = points[j];
                str += (j ? "L" : "M") + p.x + " " + p.y;
            }
            // closes the ring for polygons; "x" is VML syntax
            str += closed ? Browser.svg ? "z" : "x" : "";
        }
        // SVG complains about empty path strings
        return str || "M0 0";
    }
    /*
   * @namespace Browser
   * @aka L.Browser
   *
   * A namespace with static properties for browser/feature detection used by Leaflet internally.
   *
   * @example
   *
   * ```js
   * if (L.Browser.ielt9) {
   *   alert('Upgrade your browser, dude!');
   * }
   * ```
   */ var style = document.documentElement.style;
    // @property ie: Boolean; `true` for all Internet Explorer versions (not Edge).
    var ie = "ActiveXObject" in window;
    // @property ielt9: Boolean; `true` for Internet Explorer versions less than 9.
    var ielt9 = ie && !document.addEventListener;
    // @property edge: Boolean; `true` for the Edge web browser.
    var edge = "msLaunchUri" in navigator && !("documentMode" in document);
    // @property webkit: Boolean;
    // `true` for webkit-based browsers like Chrome and Safari (including mobile versions).
    var webkit = userAgentContains("webkit");
    // @property android: Boolean
    // **Deprecated.** `true` for any browser running on an Android platform.
    var android = userAgentContains("android");
    // @property android23: Boolean; **Deprecated.** `true` for browsers running on Android 2 or Android 3.
    var android23 = userAgentContains("android 2") || userAgentContains("android 3");
    /* See https://stackoverflow.com/a/17961266 for details on detecting stock Android */ var webkitVer = parseInt(/WebKit\/([0-9]+)|$/.exec(navigator.userAgent)[1], 10); // also matches AppleWebKit
    // @property androidStock: Boolean; **Deprecated.** `true` for the Android stock browser (i.e. not Chrome)
    var androidStock = android && userAgentContains("Google") && webkitVer < 537 && !("AudioNode" in window);
    // @property opera: Boolean; `true` for the Opera browser
    var opera = !!window.opera;
    // @property chrome: Boolean; `true` for the Chrome browser.
    var chrome = !edge && userAgentContains("chrome");
    // @property gecko: Boolean; `true` for gecko-based browsers like Firefox.
    var gecko = userAgentContains("gecko") && !webkit && !opera && !ie;
    // @property safari: Boolean; `true` for the Safari browser.
    var safari = !chrome && userAgentContains("safari");
    var phantom = userAgentContains("phantom");
    // @property opera12: Boolean
    // `true` for the Opera browser supporting CSS transforms (version 12 or later).
    var opera12 = "OTransition" in style;
    // @property win: Boolean; `true` when the browser is running in a Windows platform
    var win = navigator.platform.indexOf("Win") === 0;
    // @property ie3d: Boolean; `true` for all Internet Explorer versions supporting CSS transforms.
    var ie3d = ie && "transition" in style;
    // @property webkit3d: Boolean; `true` for webkit-based browsers supporting CSS transforms.
    var webkit3d = "WebKitCSSMatrix" in window && "m11" in new window.WebKitCSSMatrix() && !android23;
    // @property gecko3d: Boolean; `true` for gecko-based browsers supporting CSS transforms.
    var gecko3d = "MozPerspective" in style;
    // @property any3d: Boolean
    // `true` for all browsers supporting CSS transforms.
    var any3d = !window.L_DISABLE_3D && (ie3d || webkit3d || gecko3d) && !opera12 && !phantom;
    // @property mobile: Boolean; `true` for all browsers running in a mobile device.
    var mobile = typeof orientation !== "undefined" || userAgentContains("mobile");
    // @property mobileWebkit: Boolean; `true` for all webkit-based browsers in a mobile device.
    var mobileWebkit = mobile && webkit;
    // @property mobileWebkit3d: Boolean
    // `true` for all webkit-based browsers in a mobile device supporting CSS transforms.
    var mobileWebkit3d = mobile && webkit3d;
    // @property msPointer: Boolean
    // `true` for browsers implementing the Microsoft touch events model (notably IE10).
    var msPointer = !window.PointerEvent && window.MSPointerEvent;
    // @property pointer: Boolean
    // `true` for all browsers supporting [pointer events](https://msdn.microsoft.com/en-us/library/dn433244%28v=vs.85%29.aspx).
    var pointer = !!(window.PointerEvent || msPointer);
    // @property touchNative: Boolean
    // `true` for all browsers supporting [touch events](https://developer.mozilla.org/docs/Web/API/Touch_events).
    // **This does not necessarily mean** that the browser is running in a computer with
    // a touchscreen, it only means that the browser is capable of understanding
    // touch events.
    var touchNative = "ontouchstart" in window || !!window.TouchEvent;
    // @property touch: Boolean
    // `true` for all browsers supporting either [touch](#browser-touch) or [pointer](#browser-pointer) events.
    // Note: pointer events will be preferred (if available), and processed for all `touch*` listeners.
    var touch = !window.L_NO_TOUCH && (touchNative || pointer);
    // @property mobileOpera: Boolean; `true` for the Opera browser in a mobile device.
    var mobileOpera = mobile && opera;
    // @property mobileGecko: Boolean
    // `true` for gecko-based browsers running in a mobile device.
    var mobileGecko = mobile && gecko;
    // @property retina: Boolean
    // `true` for browsers on a high-resolution "retina" screen or on any screen when browser's display zoom is more than 100%.
    var retina = (window.devicePixelRatio || window.screen.deviceXDPI / window.screen.logicalXDPI) > 1;
    // @property passiveEvents: Boolean
    // `true` for browsers that support passive events.
    var passiveEvents = function() {
        var supportsPassiveOption = false;
        try {
            var opts = Object.defineProperty({}, "passive", {
                get: function() {
                    supportsPassiveOption = true;
                }
            });
            window.addEventListener("testPassiveEventSupport", falseFn, opts);
            window.removeEventListener("testPassiveEventSupport", falseFn, opts);
        } catch (e) {
        // Errors can safely be ignored since this is only a browser support test.
        }
        return supportsPassiveOption;
    }();
    // @property canvas: Boolean
    // `true` when the browser supports [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
    var canvas$1 = function() {
        return !!document.createElement("canvas").getContext;
    }();
    // @property svg: Boolean
    // `true` when the browser supports [SVG](https://developer.mozilla.org/docs/Web/SVG).
    var svg$1 = !!(document.createElementNS && svgCreate("svg").createSVGRect);
    var inlineSvg = !!svg$1 && function() {
        var div = document.createElement("div");
        div.innerHTML = "<svg/>";
        return (div.firstChild && div.firstChild.namespaceURI) === "http://www.w3.org/2000/svg";
    }();
    // @property vml: Boolean
    // `true` if the browser supports [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language).
    var vml = !svg$1 && function() {
        try {
            var div = document.createElement("div");
            div.innerHTML = '<v:shape adj="1"/>';
            var shape = div.firstChild;
            shape.style.behavior = "url(#default#VML)";
            return shape && typeof shape.adj === "object";
        } catch (e) {
            return false;
        }
    }();
    // @property mac: Boolean; `true` when the browser is running in a Mac platform
    var mac = navigator.platform.indexOf("Mac") === 0;
    // @property mac: Boolean; `true` when the browser is running in a Linux platform
    var linux = navigator.platform.indexOf("Linux") === 0;
    function userAgentContains(str) {
        return navigator.userAgent.toLowerCase().indexOf(str) >= 0;
    }
    var Browser = {
        ie: ie,
        ielt9: ielt9,
        edge: edge,
        webkit: webkit,
        android: android,
        android23: android23,
        androidStock: androidStock,
        opera: opera,
        chrome: chrome,
        gecko: gecko,
        safari: safari,
        phantom: phantom,
        opera12: opera12,
        win: win,
        ie3d: ie3d,
        webkit3d: webkit3d,
        gecko3d: gecko3d,
        any3d: any3d,
        mobile: mobile,
        mobileWebkit: mobileWebkit,
        mobileWebkit3d: mobileWebkit3d,
        msPointer: msPointer,
        pointer: pointer,
        touch: touch,
        touchNative: touchNative,
        mobileOpera: mobileOpera,
        mobileGecko: mobileGecko,
        retina: retina,
        passiveEvents: passiveEvents,
        canvas: canvas$1,
        svg: svg$1,
        vml: vml,
        inlineSvg: inlineSvg,
        mac: mac,
        linux: linux
    };
    /*
   * Extends L.DomEvent to provide touch support for Internet Explorer and Windows-based devices.
   */ var POINTER_DOWN = Browser.msPointer ? "MSPointerDown" : "pointerdown";
    var POINTER_MOVE = Browser.msPointer ? "MSPointerMove" : "pointermove";
    var POINTER_UP = Browser.msPointer ? "MSPointerUp" : "pointerup";
    var POINTER_CANCEL = Browser.msPointer ? "MSPointerCancel" : "pointercancel";
    var pEvent = {
        touchstart: POINTER_DOWN,
        touchmove: POINTER_MOVE,
        touchend: POINTER_UP,
        touchcancel: POINTER_CANCEL
    };
    var handle = {
        touchstart: _onPointerStart,
        touchmove: _handlePointer,
        touchend: _handlePointer,
        touchcancel: _handlePointer
    };
    var _pointers = {};
    var _pointerDocListener = false;
    // Provides a touch events wrapper for (ms)pointer events.
    // ref https://www.w3.org/TR/pointerevents/ https://www.w3.org/Bugs/Public/show_bug.cgi?id=22890
    function addPointerListener(obj, type, handler) {
        if (type === "touchstart") _addPointerDocListener();
        if (!handle[type]) {
            console.warn("wrong event specified:", type);
            return falseFn;
        }
        handler = handle[type].bind(this, handler);
        obj.addEventListener(pEvent[type], handler, false);
        return handler;
    }
    function removePointerListener(obj, type, handler) {
        if (!pEvent[type]) {
            console.warn("wrong event specified:", type);
            return;
        }
        obj.removeEventListener(pEvent[type], handler, false);
    }
    function _globalPointerDown(e) {
        _pointers[e.pointerId] = e;
    }
    function _globalPointerMove(e) {
        if (_pointers[e.pointerId]) _pointers[e.pointerId] = e;
    }
    function _globalPointerUp(e) {
        delete _pointers[e.pointerId];
    }
    function _addPointerDocListener() {
        // need to keep track of what pointers and how many are active to provide e.touches emulation
        if (!_pointerDocListener) {
            // we listen document as any drags that end by moving the touch off the screen get fired there
            document.addEventListener(POINTER_DOWN, _globalPointerDown, true);
            document.addEventListener(POINTER_MOVE, _globalPointerMove, true);
            document.addEventListener(POINTER_UP, _globalPointerUp, true);
            document.addEventListener(POINTER_CANCEL, _globalPointerUp, true);
            _pointerDocListener = true;
        }
    }
    function _handlePointer(handler, e) {
        if (e.pointerType === (e.MSPOINTER_TYPE_MOUSE || "mouse")) return;
        e.touches = [];
        for(var i in _pointers)e.touches.push(_pointers[i]);
        e.changedTouches = [
            e
        ];
        handler(e);
    }
    function _onPointerStart(handler, e) {
        // IE10 specific: MsTouch needs preventDefault. See #2000
        if (e.MSPOINTER_TYPE_TOUCH && e.pointerType === e.MSPOINTER_TYPE_TOUCH) preventDefault(e);
        _handlePointer(handler, e);
    }
    /*
   * Extends the event handling code with double tap support for mobile browsers.
   *
   * Note: currently most browsers fire native dblclick, with only a few exceptions
   * (see https://github.com/Leaflet/Leaflet/issues/7012#issuecomment-595087386)
   */ function makeDblclick(event) {
        // in modern browsers `type` cannot be just overridden:
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Getter_only
        var newEvent = {}, prop, i;
        for(i in event){
            prop = event[i];
            newEvent[i] = prop && prop.bind ? prop.bind(event) : prop;
        }
        event = newEvent;
        newEvent.type = "dblclick";
        newEvent.detail = 2;
        newEvent.isTrusted = false;
        newEvent._simulated = true; // for debug purposes
        return newEvent;
    }
    var delay = 200;
    function addDoubleTapListener(obj, handler) {
        // Most browsers handle double tap natively
        obj.addEventListener("dblclick", handler);
        // On some platforms the browser doesn't fire native dblclicks for touch events.
        // It seems that in all such cases `detail` property of `click` event is always `1`.
        // So here we rely on that fact to avoid excessive 'dblclick' simulation when not needed.
        var last = 0, detail;
        function simDblclick(e) {
            if (e.detail !== 1) {
                detail = e.detail; // keep in sync to avoid false dblclick in some cases
                return;
            }
            if (e.pointerType === "mouse" || e.sourceCapabilities && !e.sourceCapabilities.firesTouchEvents) return;
            // When clicking on an <input>, the browser generates a click on its
            // <label> (and vice versa) triggering two clicks in quick succession.
            // This ignores clicks on elements which are a label with a 'for'
            // attribute (or children of such a label), but not children of
            // a <input>.
            var path = getPropagationPath(e);
            if (path.some(function(el) {
                return el instanceof HTMLLabelElement && el.attributes.for;
            }) && !path.some(function(el) {
                return el instanceof HTMLInputElement || el instanceof HTMLSelectElement;
            })) return;
            var now = Date.now();
            if (now - last <= delay) {
                detail++;
                if (detail === 2) handler(makeDblclick(e));
            } else detail = 1;
            last = now;
        }
        obj.addEventListener("click", simDblclick);
        return {
            dblclick: handler,
            simDblclick: simDblclick
        };
    }
    function removeDoubleTapListener(obj, handlers) {
        obj.removeEventListener("dblclick", handlers.dblclick);
        obj.removeEventListener("click", handlers.simDblclick);
    }
    /*
   * @namespace DomUtil
   *
   * Utility functions to work with the [DOM](https://developer.mozilla.org/docs/Web/API/Document_Object_Model)
   * tree, used by Leaflet internally.
   *
   * Most functions expecting or returning a `HTMLElement` also work for
   * SVG elements. The only difference is that classes refer to CSS classes
   * in HTML and SVG classes in SVG.
   */ // @property TRANSFORM: String
    // Vendor-prefixed transform style name (e.g. `'webkitTransform'` for WebKit).
    var TRANSFORM = testProp([
        "transform",
        "webkitTransform",
        "OTransform",
        "MozTransform",
        "msTransform"
    ]);
    // webkitTransition comes first because some browser versions that drop vendor prefix don't do
    // the same for the transitionend event, in particular the Android 4.1 stock browser
    // @property TRANSITION: String
    // Vendor-prefixed transition style name.
    var TRANSITION = testProp([
        "webkitTransition",
        "transition",
        "OTransition",
        "MozTransition",
        "msTransition"
    ]);
    // @property TRANSITION_END: String
    // Vendor-prefixed transitionend event name.
    var TRANSITION_END = TRANSITION === "webkitTransition" || TRANSITION === "OTransition" ? TRANSITION + "End" : "transitionend";
    // @function get(id: String|HTMLElement): HTMLElement
    // Returns an element given its DOM id, or returns the element itself
    // if it was passed directly.
    function get(id) {
        return typeof id === "string" ? document.getElementById(id) : id;
    }
    // @function getStyle(el: HTMLElement, styleAttrib: String): String
    // Returns the value for a certain style attribute on an element,
    // including computed values or values set through CSS.
    function getStyle(el, style) {
        var value = el.style[style] || el.currentStyle && el.currentStyle[style];
        if ((!value || value === "auto") && document.defaultView) {
            var css = document.defaultView.getComputedStyle(el, null);
            value = css ? css[style] : null;
        }
        return value === "auto" ? null : value;
    }
    // @function create(tagName: String, className?: String, container?: HTMLElement): HTMLElement
    // Creates an HTML element with `tagName`, sets its class to `className`, and optionally appends it to `container` element.
    function create$1(tagName, className, container) {
        var el = document.createElement(tagName);
        el.className = className || "";
        if (container) container.appendChild(el);
        return el;
    }
    // @function remove(el: HTMLElement)
    // Removes `el` from its parent element
    function remove(el) {
        var parent = el.parentNode;
        if (parent) parent.removeChild(el);
    }
    // @function empty(el: HTMLElement)
    // Removes all of `el`'s children elements from `el`
    function empty(el) {
        while(el.firstChild)el.removeChild(el.firstChild);
    }
    // @function toFront(el: HTMLElement)
    // Makes `el` the last child of its parent, so it renders in front of the other children.
    function toFront(el) {
        var parent = el.parentNode;
        if (parent && parent.lastChild !== el) parent.appendChild(el);
    }
    // @function toBack(el: HTMLElement)
    // Makes `el` the first child of its parent, so it renders behind the other children.
    function toBack(el) {
        var parent = el.parentNode;
        if (parent && parent.firstChild !== el) parent.insertBefore(el, parent.firstChild);
    }
    // @function hasClass(el: HTMLElement, name: String): Boolean
    // Returns `true` if the element's class attribute contains `name`.
    function hasClass(el, name) {
        if (el.classList !== undefined) return el.classList.contains(name);
        var className = getClass(el);
        return className.length > 0 && new RegExp("(^|\\s)" + name + "(\\s|$)").test(className);
    }
    // @function addClass(el: HTMLElement, name: String)
    // Adds `name` to the element's class attribute.
    function addClass(el, name) {
        if (el.classList !== undefined) {
            var classes = splitWords(name);
            for(var i = 0, len = classes.length; i < len; i++)el.classList.add(classes[i]);
        } else if (!hasClass(el, name)) {
            var className = getClass(el);
            setClass(el, (className ? className + " " : "") + name);
        }
    }
    // @function removeClass(el: HTMLElement, name: String)
    // Removes `name` from the element's class attribute.
    function removeClass(el, name) {
        if (el.classList !== undefined) el.classList.remove(name);
        else setClass(el, trim((" " + getClass(el) + " ").replace(" " + name + " ", " ")));
    }
    // @function setClass(el: HTMLElement, name: String)
    // Sets the element's class.
    function setClass(el, name) {
        if (el.className.baseVal === undefined) el.className = name;
        else // in case of SVG element
        el.className.baseVal = name;
    }
    // @function getClass(el: HTMLElement): String
    // Returns the element's class.
    function getClass(el) {
        // Check if the element is an SVGElementInstance and use the correspondingElement instead
        // (Required for linked SVG elements in IE11.)
        if (el.correspondingElement) el = el.correspondingElement;
        return el.className.baseVal === undefined ? el.className : el.className.baseVal;
    }
    // @function setOpacity(el: HTMLElement, opacity: Number)
    // Set the opacity of an element (including old IE support).
    // `opacity` must be a number from `0` to `1`.
    function setOpacity(el, value) {
        if ("opacity" in el.style) el.style.opacity = value;
        else if ("filter" in el.style) _setOpacityIE(el, value);
    }
    function _setOpacityIE(el, value) {
        var filter = false, filterName = "DXImageTransform.Microsoft.Alpha";
        // filters collection throws an error if we try to retrieve a filter that doesn't exist
        try {
            filter = el.filters.item(filterName);
        } catch (e) {
            // don't set opacity to 1 if we haven't already set an opacity,
            // it isn't needed and breaks transparent pngs.
            if (value === 1) return;
        }
        value = Math.round(value * 100);
        if (filter) {
            filter.Enabled = value !== 100;
            filter.Opacity = value;
        } else el.style.filter += " progid:" + filterName + "(opacity=" + value + ")";
    }
    // @function testProp(props: String[]): String|false
    // Goes through the array of style names and returns the first name
    // that is a valid style name for an element. If no such name is found,
    // it returns false. Useful for vendor-prefixed styles like `transform`.
    function testProp(props) {
        var style = document.documentElement.style;
        for(var i = 0; i < props.length; i++){
            if (props[i] in style) return props[i];
        }
        return false;
    }
    // @function setTransform(el: HTMLElement, offset: Point, scale?: Number)
    // Resets the 3D CSS transform of `el` so it is translated by `offset` pixels
    // and optionally scaled by `scale`. Does not have an effect if the
    // browser doesn't support 3D CSS transforms.
    function setTransform(el, offset, scale) {
        var pos = offset || new Point(0, 0);
        el.style[TRANSFORM] = (Browser.ie3d ? "translate(" + pos.x + "px," + pos.y + "px)" : "translate3d(" + pos.x + "px," + pos.y + "px,0)") + (scale ? " scale(" + scale + ")" : "");
    }
    // @function setPosition(el: HTMLElement, position: Point)
    // Sets the position of `el` to coordinates specified by `position`,
    // using CSS translate or top/left positioning depending on the browser
    // (used by Leaflet internally to position its layers).
    function setPosition(el, point) {
        /*eslint-disable */ el._leaflet_pos = point;
        /* eslint-enable */ if (Browser.any3d) setTransform(el, point);
        else {
            el.style.left = point.x + "px";
            el.style.top = point.y + "px";
        }
    }
    // @function getPosition(el: HTMLElement): Point
    // Returns the coordinates of an element previously positioned with setPosition.
    function getPosition(el) {
        // this method is only used for elements previously positioned using setPosition,
        // so it's safe to cache the position for performance
        return el._leaflet_pos || new Point(0, 0);
    }
    // @function disableTextSelection()
    // Prevents the user from generating `selectstart` DOM events, usually generated
    // when the user drags the mouse through a page with text. Used internally
    // by Leaflet to override the behaviour of any click-and-drag interaction on
    // the map. Affects drag interactions on the whole document.
    // @function enableTextSelection()
    // Cancels the effects of a previous [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection).
    var disableTextSelection;
    var enableTextSelection;
    var _userSelect;
    if ("onselectstart" in document) {
        disableTextSelection = function() {
            on(window, "selectstart", preventDefault);
        };
        enableTextSelection = function() {
            off(window, "selectstart", preventDefault);
        };
    } else {
        var userSelectProperty = testProp([
            "userSelect",
            "WebkitUserSelect",
            "OUserSelect",
            "MozUserSelect",
            "msUserSelect"
        ]);
        disableTextSelection = function() {
            if (userSelectProperty) {
                var style = document.documentElement.style;
                _userSelect = style[userSelectProperty];
                style[userSelectProperty] = "none";
            }
        };
        enableTextSelection = function() {
            if (userSelectProperty) {
                document.documentElement.style[userSelectProperty] = _userSelect;
                _userSelect = undefined;
            }
        };
    }
    // @function disableImageDrag()
    // As [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection), but
    // for `dragstart` DOM events, usually generated when the user drags an image.
    function disableImageDrag() {
        on(window, "dragstart", preventDefault);
    }
    // @function enableImageDrag()
    // Cancels the effects of a previous [`L.DomUtil.disableImageDrag`](#domutil-disabletextselection).
    function enableImageDrag() {
        off(window, "dragstart", preventDefault);
    }
    var _outlineElement, _outlineStyle;
    // @function preventOutline(el: HTMLElement)
    // Makes the [outline](https://developer.mozilla.org/docs/Web/CSS/outline)
    // of the element `el` invisible. Used internally by Leaflet to prevent
    // focusable elements from displaying an outline when the user performs a
    // drag interaction on them.
    function preventOutline(element) {
        while(element.tabIndex === -1)element = element.parentNode;
        if (!element.style) return;
        restoreOutline();
        _outlineElement = element;
        _outlineStyle = element.style.outlineStyle;
        element.style.outlineStyle = "none";
        on(window, "keydown", restoreOutline);
    }
    // @function restoreOutline()
    // Cancels the effects of a previous [`L.DomUtil.preventOutline`]().
    function restoreOutline() {
        if (!_outlineElement) return;
        _outlineElement.style.outlineStyle = _outlineStyle;
        _outlineElement = undefined;
        _outlineStyle = undefined;
        off(window, "keydown", restoreOutline);
    }
    // @function getSizedParentNode(el: HTMLElement): HTMLElement
    // Finds the closest parent node which size (width and height) is not null.
    function getSizedParentNode(element) {
        do element = element.parentNode;
        while ((!element.offsetWidth || !element.offsetHeight) && element !== document.body);
        return element;
    }
    // @function getScale(el: HTMLElement): Object
    // Computes the CSS scale currently applied on the element.
    // Returns an object with `x` and `y` members as horizontal and vertical scales respectively,
    // and `boundingClientRect` as the result of [`getBoundingClientRect()`](https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect).
    function getScale(element) {
        var rect = element.getBoundingClientRect(); // Read-only in old browsers.
        return {
            x: rect.width / element.offsetWidth || 1,
            y: rect.height / element.offsetHeight || 1,
            boundingClientRect: rect
        };
    }
    var DomUtil = {
        __proto__: null,
        TRANSFORM: TRANSFORM,
        TRANSITION: TRANSITION,
        TRANSITION_END: TRANSITION_END,
        get: get,
        getStyle: getStyle,
        create: create$1,
        remove: remove,
        empty: empty,
        toFront: toFront,
        toBack: toBack,
        hasClass: hasClass,
        addClass: addClass,
        removeClass: removeClass,
        setClass: setClass,
        getClass: getClass,
        setOpacity: setOpacity,
        testProp: testProp,
        setTransform: setTransform,
        setPosition: setPosition,
        getPosition: getPosition,
        get disableTextSelection () {
            return disableTextSelection;
        },
        get enableTextSelection () {
            return enableTextSelection;
        },
        disableImageDrag: disableImageDrag,
        enableImageDrag: enableImageDrag,
        preventOutline: preventOutline,
        restoreOutline: restoreOutline,
        getSizedParentNode: getSizedParentNode,
        getScale: getScale
    };
    /*
   * @namespace DomEvent
   * Utility functions to work with the [DOM events](https://developer.mozilla.org/docs/Web/API/Event), used by Leaflet internally.
   */ // Inspired by John Resig, Dean Edwards and YUI addEvent implementations.
    // @function on(el: HTMLElement, types: String, fn: Function, context?: Object): this
    // Adds a listener function (`fn`) to a particular DOM event type of the
    // element `el`. You can optionally specify the context of the listener
    // (object the `this` keyword will point to). You can also pass several
    // space-separated types (e.g. `'click dblclick'`).
    // @alternative
    // @function on(el: HTMLElement, eventMap: Object, context?: Object): this
    // Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
    function on(obj, types, fn, context) {
        if (types && typeof types === "object") for(var type in types)addOne(obj, type, types[type], fn);
        else {
            types = splitWords(types);
            for(var i = 0, len = types.length; i < len; i++)addOne(obj, types[i], fn, context);
        }
        return this;
    }
    var eventsKey = "_leaflet_events";
    // @function off(el: HTMLElement, types: String, fn: Function, context?: Object): this
    // Removes a previously added listener function.
    // Note that if you passed a custom context to on, you must pass the same
    // context to `off` in order to remove the listener.
    // @alternative
    // @function off(el: HTMLElement, eventMap: Object, context?: Object): this
    // Removes a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
    // @alternative
    // @function off(el: HTMLElement, types: String): this
    // Removes all previously added listeners of given types.
    // @alternative
    // @function off(el: HTMLElement): this
    // Removes all previously added listeners from given HTMLElement
    function off(obj, types, fn, context) {
        if (arguments.length === 1) {
            batchRemove(obj);
            delete obj[eventsKey];
        } else if (types && typeof types === "object") for(var type in types)removeOne(obj, type, types[type], fn);
        else {
            types = splitWords(types);
            if (arguments.length === 2) batchRemove(obj, function(type) {
                return indexOf(types, type) !== -1;
            });
            else for(var i = 0, len = types.length; i < len; i++)removeOne(obj, types[i], fn, context);
        }
        return this;
    }
    function batchRemove(obj, filterFn) {
        for(var id in obj[eventsKey]){
            var type = id.split(/\d/)[0];
            if (!filterFn || filterFn(type)) removeOne(obj, type, null, null, id);
        }
    }
    var mouseSubst = {
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        wheel: !("onwheel" in window) && "mousewheel"
    };
    function addOne(obj, type, fn, context) {
        var id = type + stamp(fn) + (context ? "_" + stamp(context) : "");
        if (obj[eventsKey] && obj[eventsKey][id]) return this;
        var handler = function(e) {
            return fn.call(context || obj, e || window.event);
        };
        var originalHandler = handler;
        if (!Browser.touchNative && Browser.pointer && type.indexOf("touch") === 0) // Needs DomEvent.Pointer.js
        handler = addPointerListener(obj, type, handler);
        else if (Browser.touch && type === "dblclick") handler = addDoubleTapListener(obj, handler);
        else if ("addEventListener" in obj) {
            if (type === "touchstart" || type === "touchmove" || type === "wheel" || type === "mousewheel") obj.addEventListener(mouseSubst[type] || type, handler, Browser.passiveEvents ? {
                passive: false
            } : false);
            else if (type === "mouseenter" || type === "mouseleave") {
                handler = function(e) {
                    e = e || window.event;
                    if (isExternalTarget(obj, e)) originalHandler(e);
                };
                obj.addEventListener(mouseSubst[type], handler, false);
            } else obj.addEventListener(type, originalHandler, false);
        } else obj.attachEvent("on" + type, handler);
        obj[eventsKey] = obj[eventsKey] || {};
        obj[eventsKey][id] = handler;
    }
    function removeOne(obj, type, fn, context, id) {
        id = id || type + stamp(fn) + (context ? "_" + stamp(context) : "");
        var handler = obj[eventsKey] && obj[eventsKey][id];
        if (!handler) return this;
        if (!Browser.touchNative && Browser.pointer && type.indexOf("touch") === 0) removePointerListener(obj, type, handler);
        else if (Browser.touch && type === "dblclick") removeDoubleTapListener(obj, handler);
        else if ("removeEventListener" in obj) obj.removeEventListener(mouseSubst[type] || type, handler, false);
        else obj.detachEvent("on" + type, handler);
        obj[eventsKey][id] = null;
    }
    // @function stopPropagation(ev: DOMEvent): this
    // Stop the given event from propagation to parent elements. Used inside the listener functions:
    // ```js
    // L.DomEvent.on(div, 'click', function (ev) {
    // 	L.DomEvent.stopPropagation(ev);
    // });
    // ```
    function stopPropagation(e) {
        if (e.stopPropagation) e.stopPropagation();
        else if (e.originalEvent) e.originalEvent._stopped = true;
        else e.cancelBubble = true;
        return this;
    }
    // @function disableScrollPropagation(el: HTMLElement): this
    // Adds `stopPropagation` to the element's `'wheel'` events (plus browser variants).
    function disableScrollPropagation(el) {
        addOne(el, "wheel", stopPropagation);
        return this;
    }
    // @function disableClickPropagation(el: HTMLElement): this
    // Adds `stopPropagation` to the element's `'click'`, `'dblclick'`, `'contextmenu'`,
    // `'mousedown'` and `'touchstart'` events (plus browser variants).
    function disableClickPropagation(el) {
        on(el, "mousedown touchstart dblclick contextmenu", stopPropagation);
        el["_leaflet_disable_click"] = true;
        return this;
    }
    // @function preventDefault(ev: DOMEvent): this
    // Prevents the default action of the DOM Event `ev` from happening (such as
    // following a link in the href of the a element, or doing a POST request
    // with page reload when a `<form>` is submitted).
    // Use it inside listener functions.
    function preventDefault(e) {
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return this;
    }
    // @function stop(ev: DOMEvent): this
    // Does `stopPropagation` and `preventDefault` at the same time.
    function stop(e) {
        preventDefault(e);
        stopPropagation(e);
        return this;
    }
    // @function getPropagationPath(ev: DOMEvent): Array
    // Compatibility polyfill for [`Event.composedPath()`](https://developer.mozilla.org/en-US/docs/Web/API/Event/composedPath).
    // Returns an array containing the `HTMLElement`s that the given DOM event
    // should propagate to (if not stopped).
    function getPropagationPath(ev) {
        if (ev.composedPath) return ev.composedPath();
        var path = [];
        var el = ev.target;
        while(el){
            path.push(el);
            el = el.parentNode;
        }
        return path;
    }
    // @function getMousePosition(ev: DOMEvent, container?: HTMLElement): Point
    // Gets normalized mouse position from a DOM event relative to the
    // `container` (border excluded) or to the whole page if not specified.
    function getMousePosition(e, container) {
        if (!container) return new Point(e.clientX, e.clientY);
        var scale = getScale(container), offset = scale.boundingClientRect; // left and top  values are in page scale (like the event clientX/Y)
        return new Point(// offset.left/top values are in page scale (like clientX/Y),
        // whereas clientLeft/Top (border width) values are the original values (before CSS scale applies).
        (e.clientX - offset.left) / scale.x - container.clientLeft, (e.clientY - offset.top) / scale.y - container.clientTop);
    }
    //  except , Safari and
    // We need double the scroll pixels (see #7403 and #4538) for all Browsers
    // except OSX (Mac) -> 3x, Chrome running on Linux 1x
    var wheelPxFactor = Browser.linux && Browser.chrome ? window.devicePixelRatio : Browser.mac ? window.devicePixelRatio * 3 : window.devicePixelRatio > 0 ? 2 * window.devicePixelRatio : 1;
    // @function getWheelDelta(ev: DOMEvent): Number
    // Gets normalized wheel delta from a wheel DOM event, in vertical
    // pixels scrolled (negative if scrolling down).
    // Events from pointing devices without precise scrolling are mapped to
    // a best guess of 60 pixels.
    function getWheelDelta(e) {
        return Browser.edge ? e.wheelDeltaY / 2 : e.deltaY && e.deltaMode === 0 ? -e.deltaY / wheelPxFactor : e.deltaY && e.deltaMode === 1 ? -e.deltaY * 20 : e.deltaY && e.deltaMode === 2 ? -e.deltaY * 60 : e.deltaX || e.deltaZ ? 0 : e.wheelDelta ? (e.wheelDeltaY || e.wheelDelta) / 2 : e.detail && Math.abs(e.detail) < 32765 ? -e.detail * 20 : e.detail ? e.detail / -32765 * 60 : 0;
    }
    // check if element really left/entered the event target (for mouseenter/mouseleave)
    function isExternalTarget(el, e) {
        var related = e.relatedTarget;
        if (!related) return true;
        try {
            while(related && related !== el)related = related.parentNode;
        } catch (err) {
            return false;
        }
        return related !== el;
    }
    var DomEvent = {
        __proto__: null,
        on: on,
        off: off,
        stopPropagation: stopPropagation,
        disableScrollPropagation: disableScrollPropagation,
        disableClickPropagation: disableClickPropagation,
        preventDefault: preventDefault,
        stop: stop,
        getPropagationPath: getPropagationPath,
        getMousePosition: getMousePosition,
        getWheelDelta: getWheelDelta,
        isExternalTarget: isExternalTarget,
        addListener: on,
        removeListener: off
    };
    /*
   * @class PosAnimation
   * @aka L.PosAnimation
   * @inherits Evented
   * Used internally for panning animations, utilizing CSS3 Transitions for modern browsers and a timer fallback for IE6-9.
   *
   * @example
   * ```js
   * var myPositionMarker = L.marker([48.864716, 2.294694]).addTo(map);
   *
   * myPositionMarker.on("click", function() {
   * 	var pos = map.latLngToLayerPoint(myPositionMarker.getLatLng());
   * 	pos.y -= 25;
   * 	var fx = new L.PosAnimation();
   *
   * 	fx.once('end',function() {
   * 		pos.y += 25;
   * 		fx.run(myPositionMarker._icon, pos, 0.8);
   * 	});
   *
   * 	fx.run(myPositionMarker._icon, pos, 0.3);
   * });
   *
   * ```
   *
   * @constructor L.PosAnimation()
   * Creates a `PosAnimation` object.
   *
   */ var PosAnimation = Evented.extend({
        // @method run(el: HTMLElement, newPos: Point, duration?: Number, easeLinearity?: Number)
        // Run an animation of a given element to a new position, optionally setting
        // duration in seconds (`0.25` by default) and easing linearity factor (3rd
        // argument of the [cubic bezier curve](https://cubic-bezier.com/#0,0,.5,1),
        // `0.5` by default).
        run: function(el, newPos, duration, easeLinearity) {
            this.stop();
            this._el = el;
            this._inProgress = true;
            this._duration = duration || 0.25;
            this._easeOutPower = 1 / Math.max(easeLinearity || 0.5, 0.2);
            this._startPos = getPosition(el);
            this._offset = newPos.subtract(this._startPos);
            this._startTime = +new Date();
            // @event start: Event
            // Fired when the animation starts
            this.fire("start");
            this._animate();
        },
        // @method stop()
        // Stops the animation (if currently running).
        stop: function() {
            if (!this._inProgress) return;
            this._step(true);
            this._complete();
        },
        _animate: function() {
            // animation loop
            this._animId = requestAnimFrame(this._animate, this);
            this._step();
        },
        _step: function(round) {
            var elapsed = +new Date() - this._startTime, duration = this._duration * 1000;
            if (elapsed < duration) this._runFrame(this._easeOut(elapsed / duration), round);
            else {
                this._runFrame(1);
                this._complete();
            }
        },
        _runFrame: function(progress, round) {
            var pos = this._startPos.add(this._offset.multiplyBy(progress));
            if (round) pos._round();
            setPosition(this._el, pos);
            // @event step: Event
            // Fired continuously during the animation.
            this.fire("step");
        },
        _complete: function() {
            cancelAnimFrame(this._animId);
            this._inProgress = false;
            // @event end: Event
            // Fired when the animation ends.
            this.fire("end");
        },
        _easeOut: function(t) {
            return 1 - Math.pow(1 - t, this._easeOutPower);
        }
    });
    /*
   * @class Map
   * @aka L.Map
   * @inherits Evented
   *
   * The central class of the API — it is used to create a map on a page and manipulate it.
   *
   * @example
   *
   * ```js
   * // initialize the map on the "map" div with a given center and zoom
   * var map = L.map('map', {
   * 	center: [51.505, -0.09],
   * 	zoom: 13
   * });
   * ```
   *
   */ var Map = Evented.extend({
        options: {
            // @section Map State Options
            // @option crs: CRS = L.CRS.EPSG3857
            // The [Coordinate Reference System](#crs) to use. Don't change this if you're not
            // sure what it means.
            crs: EPSG3857,
            // @option center: LatLng = undefined
            // Initial geographic center of the map
            center: undefined,
            // @option zoom: Number = undefined
            // Initial map zoom level
            zoom: undefined,
            // @option minZoom: Number = *
            // Minimum zoom level of the map.
            // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
            // the lowest of their `minZoom` options will be used instead.
            minZoom: undefined,
            // @option maxZoom: Number = *
            // Maximum zoom level of the map.
            // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
            // the highest of their `maxZoom` options will be used instead.
            maxZoom: undefined,
            // @option layers: Layer[] = []
            // Array of layers that will be added to the map initially
            layers: [],
            // @option maxBounds: LatLngBounds = null
            // When this option is set, the map restricts the view to the given
            // geographical bounds, bouncing the user back if the user tries to pan
            // outside the view. To set the restriction dynamically, use
            // [`setMaxBounds`](#map-setmaxbounds) method.
            maxBounds: undefined,
            // @option renderer: Renderer = *
            // The default method for drawing vector layers on the map. `L.SVG`
            // or `L.Canvas` by default depending on browser support.
            renderer: undefined,
            // @section Animation Options
            // @option zoomAnimation: Boolean = true
            // Whether the map zoom animation is enabled. By default it's enabled
            // in all browsers that support CSS3 Transitions except Android.
            zoomAnimation: true,
            // @option zoomAnimationThreshold: Number = 4
            // Won't animate zoom if the zoom difference exceeds this value.
            zoomAnimationThreshold: 4,
            // @option fadeAnimation: Boolean = true
            // Whether the tile fade animation is enabled. By default it's enabled
            // in all browsers that support CSS3 Transitions except Android.
            fadeAnimation: true,
            // @option markerZoomAnimation: Boolean = true
            // Whether markers animate their zoom with the zoom animation, if disabled
            // they will disappear for the length of the animation. By default it's
            // enabled in all browsers that support CSS3 Transitions except Android.
            markerZoomAnimation: true,
            // @option transform3DLimit: Number = 2^23
            // Defines the maximum size of a CSS translation transform. The default
            // value should not be changed unless a web browser positions layers in
            // the wrong place after doing a large `panBy`.
            transform3DLimit: 8388608,
            // @section Interaction Options
            // @option zoomSnap: Number = 1
            // Forces the map's zoom level to always be a multiple of this, particularly
            // right after a [`fitBounds()`](#map-fitbounds) or a pinch-zoom.
            // By default, the zoom level snaps to the nearest integer; lower values
            // (e.g. `0.5` or `0.1`) allow for greater granularity. A value of `0`
            // means the zoom level will not be snapped after `fitBounds` or a pinch-zoom.
            zoomSnap: 1,
            // @option zoomDelta: Number = 1
            // Controls how much the map's zoom level will change after a
            // [`zoomIn()`](#map-zoomin), [`zoomOut()`](#map-zoomout), pressing `+`
            // or `-` on the keyboard, or using the [zoom controls](#control-zoom).
            // Values smaller than `1` (e.g. `0.5`) allow for greater granularity.
            zoomDelta: 1,
            // @option trackResize: Boolean = true
            // Whether the map automatically handles browser window resize to update itself.
            trackResize: true
        },
        initialize: function(id, options) {
            options = setOptions(this, options);
            // Make sure to assign internal flags at the beginning,
            // to avoid inconsistent state in some edge cases.
            this._handlers = [];
            this._layers = {};
            this._zoomBoundLayers = {};
            this._sizeChanged = true;
            this._initContainer(id);
            this._initLayout();
            // hack for https://github.com/Leaflet/Leaflet/issues/1980
            this._onResize = bind(this._onResize, this);
            this._initEvents();
            if (options.maxBounds) this.setMaxBounds(options.maxBounds);
            if (options.zoom !== undefined) this._zoom = this._limitZoom(options.zoom);
            if (options.center && options.zoom !== undefined) this.setView(toLatLng(options.center), options.zoom, {
                reset: true
            });
            this.callInitHooks();
            // don't animate on browsers without hardware-accelerated transitions or old Android/Opera
            this._zoomAnimated = TRANSITION && Browser.any3d && !Browser.mobileOpera && this.options.zoomAnimation;
            // zoom transitions run with the same duration for all layers, so if one of transitionend events
            // happens after starting zoom animation (propagating to the map pane), we know that it ended globally
            if (this._zoomAnimated) {
                this._createAnimProxy();
                on(this._proxy, TRANSITION_END, this._catchTransitionEnd, this);
            }
            this._addLayers(this.options.layers);
        },
        // @section Methods for modifying map state
        // @method setView(center: LatLng, zoom: Number, options?: Zoom/pan options): this
        // Sets the view of the map (geographical center and zoom) with the given
        // animation options.
        setView: function(center, zoom, options) {
            zoom = zoom === undefined ? this._zoom : this._limitZoom(zoom);
            center = this._limitCenter(toLatLng(center), zoom, this.options.maxBounds);
            options = options || {};
            this._stop();
            if (this._loaded && !options.reset && options !== true) {
                if (options.animate !== undefined) {
                    options.zoom = extend({
                        animate: options.animate
                    }, options.zoom);
                    options.pan = extend({
                        animate: options.animate,
                        duration: options.duration
                    }, options.pan);
                }
                // try animating pan or zoom
                var moved = this._zoom !== zoom ? this._tryAnimatedZoom && this._tryAnimatedZoom(center, zoom, options.zoom) : this._tryAnimatedPan(center, options.pan);
                if (moved) {
                    // prevent resize handler call, the view will refresh after animation anyway
                    clearTimeout(this._sizeTimer);
                    return this;
                }
            }
            // animation didn't start, just reset the map view
            this._resetView(center, zoom, options.pan && options.pan.noMoveStart);
            return this;
        },
        // @method setZoom(zoom: Number, options?: Zoom/pan options): this
        // Sets the zoom of the map.
        setZoom: function(zoom, options) {
            if (!this._loaded) {
                this._zoom = zoom;
                return this;
            }
            return this.setView(this.getCenter(), zoom, {
                zoom: options
            });
        },
        // @method zoomIn(delta?: Number, options?: Zoom options): this
        // Increases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
        zoomIn: function(delta, options) {
            delta = delta || (Browser.any3d ? this.options.zoomDelta : 1);
            return this.setZoom(this._zoom + delta, options);
        },
        // @method zoomOut(delta?: Number, options?: Zoom options): this
        // Decreases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
        zoomOut: function(delta, options) {
            delta = delta || (Browser.any3d ? this.options.zoomDelta : 1);
            return this.setZoom(this._zoom - delta, options);
        },
        // @method setZoomAround(latlng: LatLng, zoom: Number, options: Zoom options): this
        // Zooms the map while keeping a specified geographical point on the map
        // stationary (e.g. used internally for scroll zoom and double-click zoom).
        // @alternative
        // @method setZoomAround(offset: Point, zoom: Number, options: Zoom options): this
        // Zooms the map while keeping a specified pixel on the map (relative to the top-left corner) stationary.
        setZoomAround: function(latlng, zoom, options) {
            var scale = this.getZoomScale(zoom), viewHalf = this.getSize().divideBy(2), containerPoint = latlng instanceof Point ? latlng : this.latLngToContainerPoint(latlng), centerOffset = containerPoint.subtract(viewHalf).multiplyBy(1 - 1 / scale), newCenter = this.containerPointToLatLng(viewHalf.add(centerOffset));
            return this.setView(newCenter, zoom, {
                zoom: options
            });
        },
        _getBoundsCenterZoom: function(bounds, options) {
            options = options || {};
            bounds = bounds.getBounds ? bounds.getBounds() : toLatLngBounds(bounds);
            var paddingTL = toPoint(options.paddingTopLeft || options.padding || [
                0,
                0
            ]), paddingBR = toPoint(options.paddingBottomRight || options.padding || [
                0,
                0
            ]), zoom = this.getBoundsZoom(bounds, false, paddingTL.add(paddingBR));
            zoom = typeof options.maxZoom === "number" ? Math.min(options.maxZoom, zoom) : zoom;
            if (zoom === Infinity) return {
                center: bounds.getCenter(),
                zoom: zoom
            };
            var paddingOffset = paddingBR.subtract(paddingTL).divideBy(2), swPoint = this.project(bounds.getSouthWest(), zoom), nePoint = this.project(bounds.getNorthEast(), zoom), center = this.unproject(swPoint.add(nePoint).divideBy(2).add(paddingOffset), zoom);
            return {
                center: center,
                zoom: zoom
            };
        },
        // @method fitBounds(bounds: LatLngBounds, options?: fitBounds options): this
        // Sets a map view that contains the given geographical bounds with the
        // maximum zoom level possible.
        fitBounds: function(bounds, options) {
            bounds = toLatLngBounds(bounds);
            if (!bounds.isValid()) throw new Error("Bounds are not valid.");
            var target = this._getBoundsCenterZoom(bounds, options);
            return this.setView(target.center, target.zoom, options);
        },
        // @method fitWorld(options?: fitBounds options): this
        // Sets a map view that mostly contains the whole world with the maximum
        // zoom level possible.
        fitWorld: function(options) {
            return this.fitBounds([
                [
                    -90,
                    -180
                ],
                [
                    90,
                    180
                ]
            ], options);
        },
        // @method panTo(latlng: LatLng, options?: Pan options): this
        // Pans the map to a given center.
        panTo: function(center, options) {
            return this.setView(center, this._zoom, {
                pan: options
            });
        },
        // @method panBy(offset: Point, options?: Pan options): this
        // Pans the map by a given number of pixels (animated).
        panBy: function(offset, options) {
            offset = toPoint(offset).round();
            options = options || {};
            if (!offset.x && !offset.y) return this.fire("moveend");
            // If we pan too far, Chrome gets issues with tiles
            // and makes them disappear or appear in the wrong place (slightly offset) #2602
            if (options.animate !== true && !this.getSize().contains(offset)) {
                this._resetView(this.unproject(this.project(this.getCenter()).add(offset)), this.getZoom());
                return this;
            }
            if (!this._panAnim) {
                this._panAnim = new PosAnimation();
                this._panAnim.on({
                    "step": this._onPanTransitionStep,
                    "end": this._onPanTransitionEnd
                }, this);
            }
            // don't fire movestart if animating inertia
            if (!options.noMoveStart) this.fire("movestart");
            // animate pan unless animate: false specified
            if (options.animate !== false) {
                addClass(this._mapPane, "leaflet-pan-anim");
                var newPos = this._getMapPanePos().subtract(offset).round();
                this._panAnim.run(this._mapPane, newPos, options.duration || 0.25, options.easeLinearity);
            } else {
                this._rawPanBy(offset);
                this.fire("move").fire("moveend");
            }
            return this;
        },
        // @method flyTo(latlng: LatLng, zoom?: Number, options?: Zoom/pan options): this
        // Sets the view of the map (geographical center and zoom) performing a smooth
        // pan-zoom animation.
        flyTo: function(targetCenter, targetZoom, options) {
            options = options || {};
            if (options.animate === false || !Browser.any3d) return this.setView(targetCenter, targetZoom, options);
            this._stop();
            var from = this.project(this.getCenter()), to = this.project(targetCenter), size = this.getSize(), startZoom = this._zoom;
            targetCenter = toLatLng(targetCenter);
            targetZoom = targetZoom === undefined ? startZoom : targetZoom;
            var w0 = Math.max(size.x, size.y), w1 = w0 * this.getZoomScale(startZoom, targetZoom), u1 = to.distanceTo(from) || 1, rho = 1.42, rho2 = rho * rho;
            function r(i) {
                var s1 = i ? -1 : 1, s2 = i ? w1 : w0, t1 = w1 * w1 - w0 * w0 + s1 * rho2 * rho2 * u1 * u1, b1 = 2 * s2 * rho2 * u1, b = t1 / b1, sq = Math.sqrt(b * b + 1) - b;
                // workaround for floating point precision bug when sq = 0, log = -Infinite,
                // thus triggering an infinite loop in flyTo
                var log = sq < 0.000000001 ? -18 : Math.log(sq);
                return log;
            }
            function sinh(n) {
                return (Math.exp(n) - Math.exp(-n)) / 2;
            }
            function cosh(n) {
                return (Math.exp(n) + Math.exp(-n)) / 2;
            }
            function tanh(n) {
                return sinh(n) / cosh(n);
            }
            var r0 = r(0);
            function w(s) {
                return w0 * (cosh(r0) / cosh(r0 + rho * s));
            }
            function u(s) {
                return w0 * (cosh(r0) * tanh(r0 + rho * s) - sinh(r0)) / rho2;
            }
            function easeOut(t) {
                return 1 - Math.pow(1 - t, 1.5);
            }
            var start = Date.now(), S = (r(1) - r0) / rho, duration = options.duration ? 1000 * options.duration : 1000 * S * 0.8;
            function frame() {
                var t = (Date.now() - start) / duration, s = easeOut(t) * S;
                if (t <= 1) {
                    this._flyToFrame = requestAnimFrame(frame, this);
                    this._move(this.unproject(from.add(to.subtract(from).multiplyBy(u(s) / u1)), startZoom), this.getScaleZoom(w0 / w(s), startZoom), {
                        flyTo: true
                    });
                } else this._move(targetCenter, targetZoom)._moveEnd(true);
            }
            this._moveStart(true, options.noMoveStart);
            frame.call(this);
            return this;
        },
        // @method flyToBounds(bounds: LatLngBounds, options?: fitBounds options): this
        // Sets the view of the map with a smooth animation like [`flyTo`](#map-flyto),
        // but takes a bounds parameter like [`fitBounds`](#map-fitbounds).
        flyToBounds: function(bounds, options) {
            var target = this._getBoundsCenterZoom(bounds, options);
            return this.flyTo(target.center, target.zoom, options);
        },
        // @method setMaxBounds(bounds: LatLngBounds): this
        // Restricts the map view to the given bounds (see the [maxBounds](#map-maxbounds) option).
        setMaxBounds: function(bounds) {
            bounds = toLatLngBounds(bounds);
            if (this.listens("moveend", this._panInsideMaxBounds)) this.off("moveend", this._panInsideMaxBounds);
            if (!bounds.isValid()) {
                this.options.maxBounds = null;
                return this;
            }
            this.options.maxBounds = bounds;
            if (this._loaded) this._panInsideMaxBounds();
            return this.on("moveend", this._panInsideMaxBounds);
        },
        // @method setMinZoom(zoom: Number): this
        // Sets the lower limit for the available zoom levels (see the [minZoom](#map-minzoom) option).
        setMinZoom: function(zoom) {
            var oldZoom = this.options.minZoom;
            this.options.minZoom = zoom;
            if (this._loaded && oldZoom !== zoom) {
                this.fire("zoomlevelschange");
                if (this.getZoom() < this.options.minZoom) return this.setZoom(zoom);
            }
            return this;
        },
        // @method setMaxZoom(zoom: Number): this
        // Sets the upper limit for the available zoom levels (see the [maxZoom](#map-maxzoom) option).
        setMaxZoom: function(zoom) {
            var oldZoom = this.options.maxZoom;
            this.options.maxZoom = zoom;
            if (this._loaded && oldZoom !== zoom) {
                this.fire("zoomlevelschange");
                if (this.getZoom() > this.options.maxZoom) return this.setZoom(zoom);
            }
            return this;
        },
        // @method panInsideBounds(bounds: LatLngBounds, options?: Pan options): this
        // Pans the map to the closest view that would lie inside the given bounds (if it's not already), controlling the animation using the options specific, if any.
        panInsideBounds: function(bounds, options) {
            this._enforcingBounds = true;
            var center = this.getCenter(), newCenter = this._limitCenter(center, this._zoom, toLatLngBounds(bounds));
            if (!center.equals(newCenter)) this.panTo(newCenter, options);
            this._enforcingBounds = false;
            return this;
        },
        // @method panInside(latlng: LatLng, options?: padding options): this
        // Pans the map the minimum amount to make the `latlng` visible. Use
        // padding options to fit the display to more restricted bounds.
        // If `latlng` is already within the (optionally padded) display bounds,
        // the map will not be panned.
        panInside: function(latlng, options) {
            options = options || {};
            var paddingTL = toPoint(options.paddingTopLeft || options.padding || [
                0,
                0
            ]), paddingBR = toPoint(options.paddingBottomRight || options.padding || [
                0,
                0
            ]), pixelCenter = this.project(this.getCenter()), pixelPoint = this.project(latlng), pixelBounds = this.getPixelBounds(), paddedBounds = toBounds([
                pixelBounds.min.add(paddingTL),
                pixelBounds.max.subtract(paddingBR)
            ]), paddedSize = paddedBounds.getSize();
            if (!paddedBounds.contains(pixelPoint)) {
                this._enforcingBounds = true;
                var centerOffset = pixelPoint.subtract(paddedBounds.getCenter());
                var offset = paddedBounds.extend(pixelPoint).getSize().subtract(paddedSize);
                pixelCenter.x += centerOffset.x < 0 ? -offset.x : offset.x;
                pixelCenter.y += centerOffset.y < 0 ? -offset.y : offset.y;
                this.panTo(this.unproject(pixelCenter), options);
                this._enforcingBounds = false;
            }
            return this;
        },
        // @method invalidateSize(options: Zoom/pan options): this
        // Checks if the map container size changed and updates the map if so —
        // call it after you've changed the map size dynamically, also animating
        // pan by default. If `options.pan` is `false`, panning will not occur.
        // If `options.debounceMoveend` is `true`, it will delay `moveend` event so
        // that it doesn't happen often even if the method is called many
        // times in a row.
        // @alternative
        // @method invalidateSize(animate: Boolean): this
        // Checks if the map container size changed and updates the map if so —
        // call it after you've changed the map size dynamically, also animating
        // pan by default.
        invalidateSize: function(options) {
            if (!this._loaded) return this;
            options = extend({
                animate: false,
                pan: true
            }, options === true ? {
                animate: true
            } : options);
            var oldSize = this.getSize();
            this._sizeChanged = true;
            this._lastCenter = null;
            var newSize = this.getSize(), oldCenter = oldSize.divideBy(2).round(), newCenter = newSize.divideBy(2).round(), offset = oldCenter.subtract(newCenter);
            if (!offset.x && !offset.y) return this;
            if (options.animate && options.pan) this.panBy(offset);
            else {
                if (options.pan) this._rawPanBy(offset);
                this.fire("move");
                if (options.debounceMoveend) {
                    clearTimeout(this._sizeTimer);
                    this._sizeTimer = setTimeout(bind(this.fire, this, "moveend"), 200);
                } else this.fire("moveend");
            }
            // @section Map state change events
            // @event resize: ResizeEvent
            // Fired when the map is resized.
            return this.fire("resize", {
                oldSize: oldSize,
                newSize: newSize
            });
        },
        // @section Methods for modifying map state
        // @method stop(): this
        // Stops the currently running `panTo` or `flyTo` animation, if any.
        stop: function() {
            this.setZoom(this._limitZoom(this._zoom));
            if (!this.options.zoomSnap) this.fire("viewreset");
            return this._stop();
        },
        // @section Geolocation methods
        // @method locate(options?: Locate options): this
        // Tries to locate the user using the Geolocation API, firing a [`locationfound`](#map-locationfound)
        // event with location data on success or a [`locationerror`](#map-locationerror) event on failure,
        // and optionally sets the map view to the user's location with respect to
        // detection accuracy (or to the world view if geolocation failed).
        // Note that, if your page doesn't use HTTPS, this method will fail in
        // modern browsers ([Chrome 50 and newer](https://sites.google.com/a/chromium.org/dev/Home/chromium-security/deprecating-powerful-features-on-insecure-origins))
        // See `Locate options` for more details.
        locate: function(options) {
            options = this._locateOptions = extend({
                timeout: 10000,
                watch: false
            }, options);
            if (!("geolocation" in navigator)) {
                this._handleGeolocationError({
                    code: 0,
                    message: "Geolocation not supported."
                });
                return this;
            }
            var onResponse = bind(this._handleGeolocationResponse, this), onError = bind(this._handleGeolocationError, this);
            if (options.watch) this._locationWatchId = navigator.geolocation.watchPosition(onResponse, onError, options);
            else navigator.geolocation.getCurrentPosition(onResponse, onError, options);
            return this;
        },
        // @method stopLocate(): this
        // Stops watching location previously initiated by `map.locate({watch: true})`
        // and aborts resetting the map view if map.locate was called with
        // `{setView: true}`.
        stopLocate: function() {
            if (navigator.geolocation && navigator.geolocation.clearWatch) navigator.geolocation.clearWatch(this._locationWatchId);
            if (this._locateOptions) this._locateOptions.setView = false;
            return this;
        },
        _handleGeolocationError: function(error) {
            if (!this._container._leaflet_id) return;
            var c = error.code, message = error.message || (c === 1 ? "permission denied" : c === 2 ? "position unavailable" : "timeout");
            if (this._locateOptions.setView && !this._loaded) this.fitWorld();
            // @section Location events
            // @event locationerror: ErrorEvent
            // Fired when geolocation (using the [`locate`](#map-locate) method) failed.
            this.fire("locationerror", {
                code: c,
                message: "Geolocation error: " + message + "."
            });
        },
        _handleGeolocationResponse: function(pos) {
            if (!this._container._leaflet_id) return;
            var lat = pos.coords.latitude, lng = pos.coords.longitude, latlng = new LatLng(lat, lng), bounds = latlng.toBounds(pos.coords.accuracy * 2), options = this._locateOptions;
            if (options.setView) {
                var zoom = this.getBoundsZoom(bounds);
                this.setView(latlng, options.maxZoom ? Math.min(zoom, options.maxZoom) : zoom);
            }
            var data = {
                latlng: latlng,
                bounds: bounds,
                timestamp: pos.timestamp
            };
            for(var i in pos.coords)if (typeof pos.coords[i] === "number") data[i] = pos.coords[i];
            // @event locationfound: LocationEvent
            // Fired when geolocation (using the [`locate`](#map-locate) method)
            // went successfully.
            this.fire("locationfound", data);
        },
        // TODO Appropriate docs section?
        // @section Other Methods
        // @method addHandler(name: String, HandlerClass: Function): this
        // Adds a new `Handler` to the map, given its name and constructor function.
        addHandler: function(name, HandlerClass) {
            if (!HandlerClass) return this;
            var handler = this[name] = new HandlerClass(this);
            this._handlers.push(handler);
            if (this.options[name]) handler.enable();
            return this;
        },
        // @method remove(): this
        // Destroys the map and clears all related event listeners.
        remove: function() {
            this._initEvents(true);
            if (this.options.maxBounds) this.off("moveend", this._panInsideMaxBounds);
            if (this._containerId !== this._container._leaflet_id) throw new Error("Map container is being reused by another instance");
            try {
                // throws error in IE6-8
                delete this._container._leaflet_id;
                delete this._containerId;
            } catch (e) {
                /*eslint-disable */ this._container._leaflet_id = undefined;
                /* eslint-enable */ this._containerId = undefined;
            }
            if (this._locationWatchId !== undefined) this.stopLocate();
            this._stop();
            remove(this._mapPane);
            if (this._clearControlPos) this._clearControlPos();
            if (this._resizeRequest) {
                cancelAnimFrame(this._resizeRequest);
                this._resizeRequest = null;
            }
            this._clearHandlers();
            if (this._loaded) // @section Map state change events
            // @event unload: Event
            // Fired when the map is destroyed with [remove](#map-remove) method.
            this.fire("unload");
            var i;
            for(i in this._layers)this._layers[i].remove();
            for(i in this._panes)remove(this._panes[i]);
            this._layers = [];
            this._panes = [];
            delete this._mapPane;
            delete this._renderer;
            return this;
        },
        // @section Other Methods
        // @method createPane(name: String, container?: HTMLElement): HTMLElement
        // Creates a new [map pane](#map-pane) with the given name if it doesn't exist already,
        // then returns it. The pane is created as a child of `container`, or
        // as a child of the main map pane if not set.
        createPane: function(name, container) {
            var className = "leaflet-pane" + (name ? " leaflet-" + name.replace("Pane", "") + "-pane" : ""), pane = create$1("div", className, container || this._mapPane);
            if (name) this._panes[name] = pane;
            return pane;
        },
        // @section Methods for Getting Map State
        // @method getCenter(): LatLng
        // Returns the geographical center of the map view
        getCenter: function() {
            this._checkIfLoaded();
            if (this._lastCenter && !this._moved()) return this._lastCenter.clone();
            return this.layerPointToLatLng(this._getCenterLayerPoint());
        },
        // @method getZoom(): Number
        // Returns the current zoom level of the map view
        getZoom: function() {
            return this._zoom;
        },
        // @method getBounds(): LatLngBounds
        // Returns the geographical bounds visible in the current map view
        getBounds: function() {
            var bounds = this.getPixelBounds(), sw = this.unproject(bounds.getBottomLeft()), ne = this.unproject(bounds.getTopRight());
            return new LatLngBounds(sw, ne);
        },
        // @method getMinZoom(): Number
        // Returns the minimum zoom level of the map (if set in the `minZoom` option of the map or of any layers), or `0` by default.
        getMinZoom: function() {
            return this.options.minZoom === undefined ? this._layersMinZoom || 0 : this.options.minZoom;
        },
        // @method getMaxZoom(): Number
        // Returns the maximum zoom level of the map (if set in the `maxZoom` option of the map or of any layers).
        getMaxZoom: function() {
            return this.options.maxZoom === undefined ? this._layersMaxZoom === undefined ? Infinity : this._layersMaxZoom : this.options.maxZoom;
        },
        // @method getBoundsZoom(bounds: LatLngBounds, inside?: Boolean, padding?: Point): Number
        // Returns the maximum zoom level on which the given bounds fit to the map
        // view in its entirety. If `inside` (optional) is set to `true`, the method
        // instead returns the minimum zoom level on which the map view fits into
        // the given bounds in its entirety.
        getBoundsZoom: function(bounds, inside, padding) {
            bounds = toLatLngBounds(bounds);
            padding = toPoint(padding || [
                0,
                0
            ]);
            var zoom = this.getZoom() || 0, min = this.getMinZoom(), max = this.getMaxZoom(), nw = bounds.getNorthWest(), se = bounds.getSouthEast(), size = this.getSize().subtract(padding), boundsSize = toBounds(this.project(se, zoom), this.project(nw, zoom)).getSize(), snap = Browser.any3d ? this.options.zoomSnap : 1, scalex = size.x / boundsSize.x, scaley = size.y / boundsSize.y, scale = inside ? Math.max(scalex, scaley) : Math.min(scalex, scaley);
            zoom = this.getScaleZoom(scale, zoom);
            if (snap) {
                zoom = Math.round(zoom / (snap / 100)) * (snap / 100); // don't jump if within 1% of a snap level
                zoom = inside ? Math.ceil(zoom / snap) * snap : Math.floor(zoom / snap) * snap;
            }
            return Math.max(min, Math.min(max, zoom));
        },
        // @method getSize(): Point
        // Returns the current size of the map container (in pixels).
        getSize: function() {
            if (!this._size || this._sizeChanged) {
                this._size = new Point(this._container.clientWidth || 0, this._container.clientHeight || 0);
                this._sizeChanged = false;
            }
            return this._size.clone();
        },
        // @method getPixelBounds(): Bounds
        // Returns the bounds of the current map view in projected pixel
        // coordinates (sometimes useful in layer and overlay implementations).
        getPixelBounds: function(center, zoom) {
            var topLeftPoint = this._getTopLeftPoint(center, zoom);
            return new Bounds(topLeftPoint, topLeftPoint.add(this.getSize()));
        },
        // TODO: Check semantics - isn't the pixel origin the 0,0 coord relative to
        // the map pane? "left point of the map layer" can be confusing, specially
        // since there can be negative offsets.
        // @method getPixelOrigin(): Point
        // Returns the projected pixel coordinates of the top left point of
        // the map layer (useful in custom layer and overlay implementations).
        getPixelOrigin: function() {
            this._checkIfLoaded();
            return this._pixelOrigin;
        },
        // @method getPixelWorldBounds(zoom?: Number): Bounds
        // Returns the world's bounds in pixel coordinates for zoom level `zoom`.
        // If `zoom` is omitted, the map's current zoom level is used.
        getPixelWorldBounds: function(zoom) {
            return this.options.crs.getProjectedBounds(zoom === undefined ? this.getZoom() : zoom);
        },
        // @section Other Methods
        // @method getPane(pane: String|HTMLElement): HTMLElement
        // Returns a [map pane](#map-pane), given its name or its HTML element (its identity).
        getPane: function(pane) {
            return typeof pane === "string" ? this._panes[pane] : pane;
        },
        // @method getPanes(): Object
        // Returns a plain object containing the names of all [panes](#map-pane) as keys and
        // the panes as values.
        getPanes: function() {
            return this._panes;
        },
        // @method getContainer: HTMLElement
        // Returns the HTML element that contains the map.
        getContainer: function() {
            return this._container;
        },
        // @section Conversion Methods
        // @method getZoomScale(toZoom: Number, fromZoom: Number): Number
        // Returns the scale factor to be applied to a map transition from zoom level
        // `fromZoom` to `toZoom`. Used internally to help with zoom animations.
        getZoomScale: function(toZoom, fromZoom) {
            // TODO replace with universal implementation after refactoring projections
            var crs = this.options.crs;
            fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
            return crs.scale(toZoom) / crs.scale(fromZoom);
        },
        // @method getScaleZoom(scale: Number, fromZoom: Number): Number
        // Returns the zoom level that the map would end up at, if it is at `fromZoom`
        // level and everything is scaled by a factor of `scale`. Inverse of
        // [`getZoomScale`](#map-getZoomScale).
        getScaleZoom: function(scale, fromZoom) {
            var crs = this.options.crs;
            fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
            var zoom = crs.zoom(scale * crs.scale(fromZoom));
            return isNaN(zoom) ? Infinity : zoom;
        },
        // @method project(latlng: LatLng, zoom: Number): Point
        // Projects a geographical coordinate `LatLng` according to the projection
        // of the map's CRS, then scales it according to `zoom` and the CRS's
        // `Transformation`. The result is pixel coordinate relative to
        // the CRS origin.
        project: function(latlng, zoom) {
            zoom = zoom === undefined ? this._zoom : zoom;
            return this.options.crs.latLngToPoint(toLatLng(latlng), zoom);
        },
        // @method unproject(point: Point, zoom: Number): LatLng
        // Inverse of [`project`](#map-project).
        unproject: function(point, zoom) {
            zoom = zoom === undefined ? this._zoom : zoom;
            return this.options.crs.pointToLatLng(toPoint(point), zoom);
        },
        // @method layerPointToLatLng(point: Point): LatLng
        // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
        // returns the corresponding geographical coordinate (for the current zoom level).
        layerPointToLatLng: function(point) {
            var projectedPoint = toPoint(point).add(this.getPixelOrigin());
            return this.unproject(projectedPoint);
        },
        // @method latLngToLayerPoint(latlng: LatLng): Point
        // Given a geographical coordinate, returns the corresponding pixel coordinate
        // relative to the [origin pixel](#map-getpixelorigin).
        latLngToLayerPoint: function(latlng) {
            var projectedPoint = this.project(toLatLng(latlng))._round();
            return projectedPoint._subtract(this.getPixelOrigin());
        },
        // @method wrapLatLng(latlng: LatLng): LatLng
        // Returns a `LatLng` where `lat` and `lng` has been wrapped according to the
        // map's CRS's `wrapLat` and `wrapLng` properties, if they are outside the
        // CRS's bounds.
        // By default this means longitude is wrapped around the dateline so its
        // value is between -180 and +180 degrees.
        wrapLatLng: function(latlng) {
            return this.options.crs.wrapLatLng(toLatLng(latlng));
        },
        // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
        // Returns a `LatLngBounds` with the same size as the given one, ensuring that
        // its center is within the CRS's bounds.
        // By default this means the center longitude is wrapped around the dateline so its
        // value is between -180 and +180 degrees, and the majority of the bounds
        // overlaps the CRS's bounds.
        wrapLatLngBounds: function(latlng) {
            return this.options.crs.wrapLatLngBounds(toLatLngBounds(latlng));
        },
        // @method distance(latlng1: LatLng, latlng2: LatLng): Number
        // Returns the distance between two geographical coordinates according to
        // the map's CRS. By default this measures distance in meters.
        distance: function(latlng1, latlng2) {
            return this.options.crs.distance(toLatLng(latlng1), toLatLng(latlng2));
        },
        // @method containerPointToLayerPoint(point: Point): Point
        // Given a pixel coordinate relative to the map container, returns the corresponding
        // pixel coordinate relative to the [origin pixel](#map-getpixelorigin).
        containerPointToLayerPoint: function(point) {
            return toPoint(point).subtract(this._getMapPanePos());
        },
        // @method layerPointToContainerPoint(point: Point): Point
        // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
        // returns the corresponding pixel coordinate relative to the map container.
        layerPointToContainerPoint: function(point) {
            return toPoint(point).add(this._getMapPanePos());
        },
        // @method containerPointToLatLng(point: Point): LatLng
        // Given a pixel coordinate relative to the map container, returns
        // the corresponding geographical coordinate (for the current zoom level).
        containerPointToLatLng: function(point) {
            var layerPoint = this.containerPointToLayerPoint(toPoint(point));
            return this.layerPointToLatLng(layerPoint);
        },
        // @method latLngToContainerPoint(latlng: LatLng): Point
        // Given a geographical coordinate, returns the corresponding pixel coordinate
        // relative to the map container.
        latLngToContainerPoint: function(latlng) {
            return this.layerPointToContainerPoint(this.latLngToLayerPoint(toLatLng(latlng)));
        },
        // @method mouseEventToContainerPoint(ev: MouseEvent): Point
        // Given a MouseEvent object, returns the pixel coordinate relative to the
        // map container where the event took place.
        mouseEventToContainerPoint: function(e) {
            return getMousePosition(e, this._container);
        },
        // @method mouseEventToLayerPoint(ev: MouseEvent): Point
        // Given a MouseEvent object, returns the pixel coordinate relative to
        // the [origin pixel](#map-getpixelorigin) where the event took place.
        mouseEventToLayerPoint: function(e) {
            return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(e));
        },
        // @method mouseEventToLatLng(ev: MouseEvent): LatLng
        // Given a MouseEvent object, returns geographical coordinate where the
        // event took place.
        mouseEventToLatLng: function(e) {
            return this.layerPointToLatLng(this.mouseEventToLayerPoint(e));
        },
        // map initialization methods
        _initContainer: function(id) {
            var container = this._container = get(id);
            if (!container) throw new Error("Map container not found.");
            else if (container._leaflet_id) throw new Error("Map container is already initialized.");
            on(container, "scroll", this._onScroll, this);
            this._containerId = stamp(container);
        },
        _initLayout: function() {
            var container = this._container;
            this._fadeAnimated = this.options.fadeAnimation && Browser.any3d;
            addClass(container, "leaflet-container" + (Browser.touch ? " leaflet-touch" : "") + (Browser.retina ? " leaflet-retina" : "") + (Browser.ielt9 ? " leaflet-oldie" : "") + (Browser.safari ? " leaflet-safari" : "") + (this._fadeAnimated ? " leaflet-fade-anim" : ""));
            var position = getStyle(container, "position");
            if (position !== "absolute" && position !== "relative" && position !== "fixed" && position !== "sticky") container.style.position = "relative";
            this._initPanes();
            if (this._initControlPos) this._initControlPos();
        },
        _initPanes: function() {
            var panes = this._panes = {};
            this._paneRenderers = {};
            // @section
            //
            // Panes are DOM elements used to control the ordering of layers on the map. You
            // can access panes with [`map.getPane`](#map-getpane) or
            // [`map.getPanes`](#map-getpanes) methods. New panes can be created with the
            // [`map.createPane`](#map-createpane) method.
            //
            // Every map has the following default panes that differ only in zIndex.
            //
            // @pane mapPane: HTMLElement = 'auto'
            // Pane that contains all other map panes
            this._mapPane = this.createPane("mapPane", this._container);
            setPosition(this._mapPane, new Point(0, 0));
            // @pane tilePane: HTMLElement = 200
            // Pane for `GridLayer`s and `TileLayer`s
            this.createPane("tilePane");
            // @pane overlayPane: HTMLElement = 400
            // Pane for vectors (`Path`s, like `Polyline`s and `Polygon`s), `ImageOverlay`s and `VideoOverlay`s
            this.createPane("overlayPane");
            // @pane shadowPane: HTMLElement = 500
            // Pane for overlay shadows (e.g. `Marker` shadows)
            this.createPane("shadowPane");
            // @pane markerPane: HTMLElement = 600
            // Pane for `Icon`s of `Marker`s
            this.createPane("markerPane");
            // @pane tooltipPane: HTMLElement = 650
            // Pane for `Tooltip`s.
            this.createPane("tooltipPane");
            // @pane popupPane: HTMLElement = 700
            // Pane for `Popup`s.
            this.createPane("popupPane");
            if (!this.options.markerZoomAnimation) {
                addClass(panes.markerPane, "leaflet-zoom-hide");
                addClass(panes.shadowPane, "leaflet-zoom-hide");
            }
        },
        // private methods that modify map state
        // @section Map state change events
        _resetView: function(center, zoom, noMoveStart) {
            setPosition(this._mapPane, new Point(0, 0));
            var loading = !this._loaded;
            this._loaded = true;
            zoom = this._limitZoom(zoom);
            this.fire("viewprereset");
            var zoomChanged = this._zoom !== zoom;
            this._moveStart(zoomChanged, noMoveStart)._move(center, zoom)._moveEnd(zoomChanged);
            // @event viewreset: Event
            // Fired when the map needs to redraw its content (this usually happens
            // on map zoom or load). Very useful for creating custom overlays.
            this.fire("viewreset");
            // @event load: Event
            // Fired when the map is initialized (when its center and zoom are set
            // for the first time).
            if (loading) this.fire("load");
        },
        _moveStart: function(zoomChanged, noMoveStart) {
            // @event zoomstart: Event
            // Fired when the map zoom is about to change (e.g. before zoom animation).
            // @event movestart: Event
            // Fired when the view of the map starts changing (e.g. user starts dragging the map).
            if (zoomChanged) this.fire("zoomstart");
            if (!noMoveStart) this.fire("movestart");
            return this;
        },
        _move: function(center, zoom, data, supressEvent) {
            if (zoom === undefined) zoom = this._zoom;
            var zoomChanged = this._zoom !== zoom;
            this._zoom = zoom;
            this._lastCenter = center;
            this._pixelOrigin = this._getNewPixelOrigin(center);
            if (!supressEvent) {
                // @event zoom: Event
                // Fired repeatedly during any change in zoom level,
                // including zoom and fly animations.
                if (zoomChanged || data && data.pinch) this.fire("zoom", data);
                // @event move: Event
                // Fired repeatedly during any movement of the map,
                // including pan and fly animations.
                this.fire("move", data);
            } else if (data && data.pinch) this.fire("zoom", data);
            return this;
        },
        _moveEnd: function(zoomChanged) {
            // @event zoomend: Event
            // Fired when the map zoom changed, after any animations.
            if (zoomChanged) this.fire("zoomend");
            // @event moveend: Event
            // Fired when the center of the map stops changing
            // (e.g. user stopped dragging the map or after non-centered zoom).
            return this.fire("moveend");
        },
        _stop: function() {
            cancelAnimFrame(this._flyToFrame);
            if (this._panAnim) this._panAnim.stop();
            return this;
        },
        _rawPanBy: function(offset) {
            setPosition(this._mapPane, this._getMapPanePos().subtract(offset));
        },
        _getZoomSpan: function() {
            return this.getMaxZoom() - this.getMinZoom();
        },
        _panInsideMaxBounds: function() {
            if (!this._enforcingBounds) this.panInsideBounds(this.options.maxBounds);
        },
        _checkIfLoaded: function() {
            if (!this._loaded) throw new Error("Set map center and zoom first.");
        },
        // DOM event handling
        // @section Interaction events
        _initEvents: function(remove) {
            this._targets = {};
            this._targets[stamp(this._container)] = this;
            var onOff = remove ? off : on;
            // @event click: MouseEvent
            // Fired when the user clicks (or taps) the map.
            // @event dblclick: MouseEvent
            // Fired when the user double-clicks (or double-taps) the map.
            // @event mousedown: MouseEvent
            // Fired when the user pushes the mouse button on the map.
            // @event mouseup: MouseEvent
            // Fired when the user releases the mouse button on the map.
            // @event mouseover: MouseEvent
            // Fired when the mouse enters the map.
            // @event mouseout: MouseEvent
            // Fired when the mouse leaves the map.
            // @event mousemove: MouseEvent
            // Fired while the mouse moves over the map.
            // @event contextmenu: MouseEvent
            // Fired when the user pushes the right mouse button on the map, prevents
            // default browser context menu from showing if there are listeners on
            // this event. Also fired on mobile when the user holds a single touch
            // for a second (also called long press).
            // @event keypress: KeyboardEvent
            // Fired when the user presses a key from the keyboard that produces a character value while the map is focused.
            // @event keydown: KeyboardEvent
            // Fired when the user presses a key from the keyboard while the map is focused. Unlike the `keypress` event,
            // the `keydown` event is fired for keys that produce a character value and for keys
            // that do not produce a character value.
            // @event keyup: KeyboardEvent
            // Fired when the user releases a key from the keyboard while the map is focused.
            onOff(this._container, "click dblclick mousedown mouseup mouseover mouseout mousemove contextmenu keypress keydown keyup", this._handleDOMEvent, this);
            if (this.options.trackResize) onOff(window, "resize", this._onResize, this);
            if (Browser.any3d && this.options.transform3DLimit) (remove ? this.off : this.on).call(this, "moveend", this._onMoveEnd);
        },
        _onResize: function() {
            cancelAnimFrame(this._resizeRequest);
            this._resizeRequest = requestAnimFrame(function() {
                this.invalidateSize({
                    debounceMoveend: true
                });
            }, this);
        },
        _onScroll: function() {
            this._container.scrollTop = 0;
            this._container.scrollLeft = 0;
        },
        _onMoveEnd: function() {
            var pos = this._getMapPanePos();
            if (Math.max(Math.abs(pos.x), Math.abs(pos.y)) >= this.options.transform3DLimit) // https://bugzilla.mozilla.org/show_bug.cgi?id=1203873 but Webkit also have
            // a pixel offset on very high values, see: https://jsfiddle.net/dg6r5hhb/
            this._resetView(this.getCenter(), this.getZoom());
        },
        _findEventTargets: function(e, type) {
            var targets = [], target, isHover = type === "mouseout" || type === "mouseover", src = e.target || e.srcElement, dragging = false;
            while(src){
                target = this._targets[stamp(src)];
                if (target && (type === "click" || type === "preclick") && this._draggableMoved(target)) {
                    // Prevent firing click after you just dragged an object.
                    dragging = true;
                    break;
                }
                if (target && target.listens(type, true)) {
                    if (isHover && !isExternalTarget(src, e)) break;
                    targets.push(target);
                    if (isHover) break;
                }
                if (src === this._container) break;
                src = src.parentNode;
            }
            if (!targets.length && !dragging && !isHover && this.listens(type, true)) targets = [
                this
            ];
            return targets;
        },
        _isClickDisabled: function(el) {
            while(el && el !== this._container){
                if (el["_leaflet_disable_click"]) return true;
                el = el.parentNode;
            }
        },
        _handleDOMEvent: function(e) {
            var el = e.target || e.srcElement;
            if (!this._loaded || el["_leaflet_disable_events"] || e.type === "click" && this._isClickDisabled(el)) return;
            var type = e.type;
            if (type === "mousedown") // prevents outline when clicking on keyboard-focusable element
            preventOutline(el);
            this._fireDOMEvent(e, type);
        },
        _mouseEvents: [
            "click",
            "dblclick",
            "mouseover",
            "mouseout",
            "contextmenu"
        ],
        _fireDOMEvent: function(e, type, canvasTargets) {
            if (e.type === "click") {
                // Fire a synthetic 'preclick' event which propagates up (mainly for closing popups).
                // @event preclick: MouseEvent
                // Fired before mouse click on the map (sometimes useful when you
                // want something to happen on click before any existing click
                // handlers start running).
                var synth = extend({}, e);
                synth.type = "preclick";
                this._fireDOMEvent(synth, synth.type, canvasTargets);
            }
            // Find the layer the event is propagating from and its parents.
            var targets = this._findEventTargets(e, type);
            if (canvasTargets) {
                var filtered = []; // pick only targets with listeners
                for(var i = 0; i < canvasTargets.length; i++)if (canvasTargets[i].listens(type, true)) filtered.push(canvasTargets[i]);
                targets = filtered.concat(targets);
            }
            if (!targets.length) return;
            if (type === "contextmenu") preventDefault(e);
            var target = targets[0];
            var data = {
                originalEvent: e
            };
            if (e.type !== "keypress" && e.type !== "keydown" && e.type !== "keyup") {
                var isMarker = target.getLatLng && (!target._radius || target._radius <= 10);
                data.containerPoint = isMarker ? this.latLngToContainerPoint(target.getLatLng()) : this.mouseEventToContainerPoint(e);
                data.layerPoint = this.containerPointToLayerPoint(data.containerPoint);
                data.latlng = isMarker ? target.getLatLng() : this.layerPointToLatLng(data.layerPoint);
            }
            for(i = 0; i < targets.length; i++){
                targets[i].fire(type, data, true);
                if (data.originalEvent._stopped || targets[i].options.bubblingMouseEvents === false && indexOf(this._mouseEvents, type) !== -1) return;
            }
        },
        _draggableMoved: function(obj) {
            obj = obj.dragging && obj.dragging.enabled() ? obj : this;
            return obj.dragging && obj.dragging.moved() || this.boxZoom && this.boxZoom.moved();
        },
        _clearHandlers: function() {
            for(var i = 0, len = this._handlers.length; i < len; i++)this._handlers[i].disable();
        },
        // @section Other Methods
        // @method whenReady(fn: Function, context?: Object): this
        // Runs the given function `fn` when the map gets initialized with
        // a view (center and zoom) and at least one layer, or immediately
        // if it's already initialized, optionally passing a function context.
        whenReady: function(callback, context) {
            if (this._loaded) callback.call(context || this, {
                target: this
            });
            else this.on("load", callback, context);
            return this;
        },
        // private methods for getting map state
        _getMapPanePos: function() {
            return getPosition(this._mapPane) || new Point(0, 0);
        },
        _moved: function() {
            var pos = this._getMapPanePos();
            return pos && !pos.equals([
                0,
                0
            ]);
        },
        _getTopLeftPoint: function(center, zoom) {
            var pixelOrigin = center && zoom !== undefined ? this._getNewPixelOrigin(center, zoom) : this.getPixelOrigin();
            return pixelOrigin.subtract(this._getMapPanePos());
        },
        _getNewPixelOrigin: function(center, zoom) {
            var viewHalf = this.getSize()._divideBy(2);
            return this.project(center, zoom)._subtract(viewHalf)._add(this._getMapPanePos())._round();
        },
        _latLngToNewLayerPoint: function(latlng, zoom, center) {
            var topLeft = this._getNewPixelOrigin(center, zoom);
            return this.project(latlng, zoom)._subtract(topLeft);
        },
        _latLngBoundsToNewLayerBounds: function(latLngBounds, zoom, center) {
            var topLeft = this._getNewPixelOrigin(center, zoom);
            return toBounds([
                this.project(latLngBounds.getSouthWest(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getNorthWest(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getSouthEast(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getNorthEast(), zoom)._subtract(topLeft)
            ]);
        },
        // layer point of the current center
        _getCenterLayerPoint: function() {
            return this.containerPointToLayerPoint(this.getSize()._divideBy(2));
        },
        // offset of the specified place to the current center in pixels
        _getCenterOffset: function(latlng) {
            return this.latLngToLayerPoint(latlng).subtract(this._getCenterLayerPoint());
        },
        // adjust center for view to get inside bounds
        _limitCenter: function(center, zoom, bounds) {
            if (!bounds) return center;
            var centerPoint = this.project(center, zoom), viewHalf = this.getSize().divideBy(2), viewBounds = new Bounds(centerPoint.subtract(viewHalf), centerPoint.add(viewHalf)), offset = this._getBoundsOffset(viewBounds, bounds, zoom);
            // If offset is less than a pixel, ignore.
            // This prevents unstable projections from getting into
            // an infinite loop of tiny offsets.
            if (Math.abs(offset.x) <= 1 && Math.abs(offset.y) <= 1) return center;
            return this.unproject(centerPoint.add(offset), zoom);
        },
        // adjust offset for view to get inside bounds
        _limitOffset: function(offset, bounds) {
            if (!bounds) return offset;
            var viewBounds = this.getPixelBounds(), newBounds = new Bounds(viewBounds.min.add(offset), viewBounds.max.add(offset));
            return offset.add(this._getBoundsOffset(newBounds, bounds));
        },
        // returns offset needed for pxBounds to get inside maxBounds at a specified zoom
        _getBoundsOffset: function(pxBounds, maxBounds, zoom) {
            var projectedMaxBounds = toBounds(this.project(maxBounds.getNorthEast(), zoom), this.project(maxBounds.getSouthWest(), zoom)), minOffset = projectedMaxBounds.min.subtract(pxBounds.min), maxOffset = projectedMaxBounds.max.subtract(pxBounds.max), dx = this._rebound(minOffset.x, -maxOffset.x), dy = this._rebound(minOffset.y, -maxOffset.y);
            return new Point(dx, dy);
        },
        _rebound: function(left, right) {
            return left + right > 0 ? Math.round(left - right) / 2 : Math.max(0, Math.ceil(left)) - Math.max(0, Math.floor(right));
        },
        _limitZoom: function(zoom) {
            var min = this.getMinZoom(), max = this.getMaxZoom(), snap = Browser.any3d ? this.options.zoomSnap : 1;
            if (snap) zoom = Math.round(zoom / snap) * snap;
            return Math.max(min, Math.min(max, zoom));
        },
        _onPanTransitionStep: function() {
            this.fire("move");
        },
        _onPanTransitionEnd: function() {
            removeClass(this._mapPane, "leaflet-pan-anim");
            this.fire("moveend");
        },
        _tryAnimatedPan: function(center, options) {
            // difference between the new and current centers in pixels
            var offset = this._getCenterOffset(center)._trunc();
            // don't animate too far unless animate: true specified in options
            if ((options && options.animate) !== true && !this.getSize().contains(offset)) return false;
            this.panBy(offset, options);
            return true;
        },
        _createAnimProxy: function() {
            var proxy = this._proxy = create$1("div", "leaflet-proxy leaflet-zoom-animated");
            this._panes.mapPane.appendChild(proxy);
            this.on("zoomanim", function(e) {
                var prop = TRANSFORM, transform = this._proxy.style[prop];
                setTransform(this._proxy, this.project(e.center, e.zoom), this.getZoomScale(e.zoom, 1));
                // workaround for case when transform is the same and so transitionend event is not fired
                if (transform === this._proxy.style[prop] && this._animatingZoom) this._onZoomTransitionEnd();
            }, this);
            this.on("load moveend", this._animMoveEnd, this);
            this._on("unload", this._destroyAnimProxy, this);
        },
        _destroyAnimProxy: function() {
            remove(this._proxy);
            this.off("load moveend", this._animMoveEnd, this);
            delete this._proxy;
        },
        _animMoveEnd: function() {
            var c = this.getCenter(), z = this.getZoom();
            setTransform(this._proxy, this.project(c, z), this.getZoomScale(z, 1));
        },
        _catchTransitionEnd: function(e) {
            if (this._animatingZoom && e.propertyName.indexOf("transform") >= 0) this._onZoomTransitionEnd();
        },
        _nothingToAnimate: function() {
            return !this._container.getElementsByClassName("leaflet-zoom-animated").length;
        },
        _tryAnimatedZoom: function(center, zoom, options) {
            if (this._animatingZoom) return true;
            options = options || {};
            // don't animate if disabled, not supported or zoom difference is too large
            if (!this._zoomAnimated || options.animate === false || this._nothingToAnimate() || Math.abs(zoom - this._zoom) > this.options.zoomAnimationThreshold) return false;
            // offset is the pixel coords of the zoom origin relative to the current center
            var scale = this.getZoomScale(zoom), offset = this._getCenterOffset(center)._divideBy(1 - 1 / scale);
            // don't animate if the zoom origin isn't within one screen from the current center, unless forced
            if (options.animate !== true && !this.getSize().contains(offset)) return false;
            requestAnimFrame(function() {
                this._moveStart(true, options.noMoveStart || false)._animateZoom(center, zoom, true);
            }, this);
            return true;
        },
        _animateZoom: function(center, zoom, startAnim, noUpdate) {
            if (!this._mapPane) return;
            if (startAnim) {
                this._animatingZoom = true;
                // remember what center/zoom to set after animation
                this._animateToCenter = center;
                this._animateToZoom = zoom;
                addClass(this._mapPane, "leaflet-zoom-anim");
            }
            // @section Other Events
            // @event zoomanim: ZoomAnimEvent
            // Fired at least once per zoom animation. For continuous zoom, like pinch zooming, fired once per frame during zoom.
            this.fire("zoomanim", {
                center: center,
                zoom: zoom,
                noUpdate: noUpdate
            });
            if (!this._tempFireZoomEvent) this._tempFireZoomEvent = this._zoom !== this._animateToZoom;
            this._move(this._animateToCenter, this._animateToZoom, undefined, true);
            // Work around webkit not firing 'transitionend', see https://github.com/Leaflet/Leaflet/issues/3689, 2693
            setTimeout(bind(this._onZoomTransitionEnd, this), 250);
        },
        _onZoomTransitionEnd: function() {
            if (!this._animatingZoom) return;
            if (this._mapPane) removeClass(this._mapPane, "leaflet-zoom-anim");
            this._animatingZoom = false;
            this._move(this._animateToCenter, this._animateToZoom, undefined, true);
            if (this._tempFireZoomEvent) this.fire("zoom");
            delete this._tempFireZoomEvent;
            this.fire("move");
            this._moveEnd(true);
        }
    });
    // @section
    // @factory L.map(id: String, options?: Map options)
    // Instantiates a map object given the DOM ID of a `<div>` element
    // and optionally an object literal with `Map options`.
    //
    // @alternative
    // @factory L.map(el: HTMLElement, options?: Map options)
    // Instantiates a map object given an instance of a `<div>` HTML element
    // and optionally an object literal with `Map options`.
    function createMap(id, options) {
        return new Map(id, options);
    }
    /*
   * @class Control
   * @aka L.Control
   * @inherits Class
   *
   * L.Control is a base class for implementing map controls. Handles positioning.
   * All other controls extend from this class.
   */ var Control = Class.extend({
        // @section
        // @aka Control Options
        options: {
            // @option position: String = 'topright'
            // The position of the control (one of the map corners). Possible values are `'topleft'`,
            // `'topright'`, `'bottomleft'` or `'bottomright'`
            position: "topright"
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        /* @section
  	 * Classes extending L.Control will inherit the following methods:
  	 *
  	 * @method getPosition: string
  	 * Returns the position of the control.
  	 */ getPosition: function() {
            return this.options.position;
        },
        // @method setPosition(position: string): this
        // Sets the position of the control.
        setPosition: function(position) {
            var map = this._map;
            if (map) map.removeControl(this);
            this.options.position = position;
            if (map) map.addControl(this);
            return this;
        },
        // @method getContainer: HTMLElement
        // Returns the HTMLElement that contains the control.
        getContainer: function() {
            return this._container;
        },
        // @method addTo(map: Map): this
        // Adds the control to the given map.
        addTo: function(map) {
            this.remove();
            this._map = map;
            var container = this._container = this.onAdd(map), pos = this.getPosition(), corner = map._controlCorners[pos];
            addClass(container, "leaflet-control");
            if (pos.indexOf("bottom") !== -1) corner.insertBefore(container, corner.firstChild);
            else corner.appendChild(container);
            this._map.on("unload", this.remove, this);
            return this;
        },
        // @method remove: this
        // Removes the control from the map it is currently active on.
        remove: function() {
            if (!this._map) return this;
            remove(this._container);
            if (this.onRemove) this.onRemove(this._map);
            this._map.off("unload", this.remove, this);
            this._map = null;
            return this;
        },
        _refocusOnMap: function(e) {
            // if map exists and event is not a keyboard event
            if (this._map && e && e.screenX > 0 && e.screenY > 0) this._map.getContainer().focus();
        }
    });
    var control = function(options) {
        return new Control(options);
    };
    /* @section Extension methods
   * @uninheritable
   *
   * Every control should extend from `L.Control` and (re-)implement the following methods.
   *
   * @method onAdd(map: Map): HTMLElement
   * Should return the container DOM element for the control and add listeners on relevant map events. Called on [`control.addTo(map)`](#control-addTo).
   *
   * @method onRemove(map: Map)
   * Optional method. Should contain all clean up code that removes the listeners previously added in [`onAdd`](#control-onadd). Called on [`control.remove()`](#control-remove).
   */ /* @namespace Map
   * @section Methods for Layers and Controls
   */ Map.include({
        // @method addControl(control: Control): this
        // Adds the given control to the map
        addControl: function(control) {
            control.addTo(this);
            return this;
        },
        // @method removeControl(control: Control): this
        // Removes the given control from the map
        removeControl: function(control) {
            control.remove();
            return this;
        },
        _initControlPos: function() {
            var corners = this._controlCorners = {}, l = "leaflet-", container = this._controlContainer = create$1("div", l + "control-container", this._container);
            function createCorner(vSide, hSide) {
                var className = l + vSide + " " + l + hSide;
                corners[vSide + hSide] = create$1("div", className, container);
            }
            createCorner("top", "left");
            createCorner("top", "right");
            createCorner("bottom", "left");
            createCorner("bottom", "right");
        },
        _clearControlPos: function() {
            for(var i in this._controlCorners)remove(this._controlCorners[i]);
            remove(this._controlContainer);
            delete this._controlCorners;
            delete this._controlContainer;
        }
    });
    /*
   * @class Control.Layers
   * @aka L.Control.Layers
   * @inherits Control
   *
   * The layers control gives users the ability to switch between different base layers and switch overlays on/off (check out the [detailed example](https://leafletjs.com/examples/layers-control/)). Extends `Control`.
   *
   * @example
   *
   * ```js
   * var baseLayers = {
   * 	"Mapbox": mapbox,
   * 	"OpenStreetMap": osm
   * };
   *
   * var overlays = {
   * 	"Marker": marker,
   * 	"Roads": roadsLayer
   * };
   *
   * L.control.layers(baseLayers, overlays).addTo(map);
   * ```
   *
   * The `baseLayers` and `overlays` parameters are object literals with layer names as keys and `Layer` objects as values:
   *
   * ```js
   * {
   *     "<someName1>": layer1,
   *     "<someName2>": layer2
   * }
   * ```
   *
   * The layer names can contain HTML, which allows you to add additional styling to the items:
   *
   * ```js
   * {"<img src='my-layer-icon' /> <span class='my-layer-item'>My Layer</span>": myLayer}
   * ```
   */ var Layers = Control.extend({
        // @section
        // @aka Control.Layers options
        options: {
            // @option collapsed: Boolean = true
            // If `true`, the control will be collapsed into an icon and expanded on mouse hover, touch, or keyboard activation.
            collapsed: true,
            position: "topright",
            // @option autoZIndex: Boolean = true
            // If `true`, the control will assign zIndexes in increasing order to all of its layers so that the order is preserved when switching them on/off.
            autoZIndex: true,
            // @option hideSingleBase: Boolean = false
            // If `true`, the base layers in the control will be hidden when there is only one.
            hideSingleBase: false,
            // @option sortLayers: Boolean = false
            // Whether to sort the layers. When `false`, layers will keep the order
            // in which they were added to the control.
            sortLayers: false,
            // @option sortFunction: Function = *
            // A [compare function](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/sort)
            // that will be used for sorting the layers, when `sortLayers` is `true`.
            // The function receives both the `L.Layer` instances and their names, as in
            // `sortFunction(layerA, layerB, nameA, nameB)`.
            // By default, it sorts layers alphabetically by their name.
            sortFunction: function(layerA, layerB, nameA, nameB) {
                return nameA < nameB ? -1 : nameB < nameA ? 1 : 0;
            }
        },
        initialize: function(baseLayers, overlays, options) {
            setOptions(this, options);
            this._layerControlInputs = [];
            this._layers = [];
            this._lastZIndex = 0;
            this._handlingClick = false;
            this._preventClick = false;
            for(var i in baseLayers)this._addLayer(baseLayers[i], i);
            for(i in overlays)this._addLayer(overlays[i], i, true);
        },
        onAdd: function(map) {
            this._initLayout();
            this._update();
            this._map = map;
            map.on("zoomend", this._checkDisabledLayers, this);
            for(var i = 0; i < this._layers.length; i++)this._layers[i].layer.on("add remove", this._onLayerChange, this);
            return this._container;
        },
        addTo: function(map) {
            Control.prototype.addTo.call(this, map);
            // Trigger expand after Layers Control has been inserted into DOM so that is now has an actual height.
            return this._expandIfNotCollapsed();
        },
        onRemove: function() {
            this._map.off("zoomend", this._checkDisabledLayers, this);
            for(var i = 0; i < this._layers.length; i++)this._layers[i].layer.off("add remove", this._onLayerChange, this);
        },
        // @method addBaseLayer(layer: Layer, name: String): this
        // Adds a base layer (radio button entry) with the given name to the control.
        addBaseLayer: function(layer, name) {
            this._addLayer(layer, name);
            return this._map ? this._update() : this;
        },
        // @method addOverlay(layer: Layer, name: String): this
        // Adds an overlay (checkbox entry) with the given name to the control.
        addOverlay: function(layer, name) {
            this._addLayer(layer, name, true);
            return this._map ? this._update() : this;
        },
        // @method removeLayer(layer: Layer): this
        // Remove the given layer from the control.
        removeLayer: function(layer) {
            layer.off("add remove", this._onLayerChange, this);
            var obj = this._getLayer(stamp(layer));
            if (obj) this._layers.splice(this._layers.indexOf(obj), 1);
            return this._map ? this._update() : this;
        },
        // @method expand(): this
        // Expand the control container if collapsed.
        expand: function() {
            addClass(this._container, "leaflet-control-layers-expanded");
            this._section.style.height = null;
            var acceptableHeight = this._map.getSize().y - (this._container.offsetTop + 50);
            if (acceptableHeight < this._section.clientHeight) {
                addClass(this._section, "leaflet-control-layers-scrollbar");
                this._section.style.height = acceptableHeight + "px";
            } else removeClass(this._section, "leaflet-control-layers-scrollbar");
            this._checkDisabledLayers();
            return this;
        },
        // @method collapse(): this
        // Collapse the control container if expanded.
        collapse: function() {
            removeClass(this._container, "leaflet-control-layers-expanded");
            return this;
        },
        _initLayout: function() {
            var className = "leaflet-control-layers", container = this._container = create$1("div", className), collapsed = this.options.collapsed;
            // makes this work on IE touch devices by stopping it from firing a mouseout event when the touch is released
            container.setAttribute("aria-haspopup", true);
            disableClickPropagation(container);
            disableScrollPropagation(container);
            var section = this._section = create$1("section", className + "-list");
            if (collapsed) {
                this._map.on("click", this.collapse, this);
                on(container, {
                    mouseenter: this._expandSafely,
                    mouseleave: this.collapse
                }, this);
            }
            var link = this._layersLink = create$1("a", className + "-toggle", container);
            link.href = "#";
            link.title = "Layers";
            link.setAttribute("role", "button");
            on(link, {
                keydown: function(e) {
                    if (e.keyCode === 13) this._expandSafely();
                },
                // Certain screen readers intercept the key event and instead send a click event
                click: function(e) {
                    preventDefault(e);
                    this._expandSafely();
                }
            }, this);
            if (!collapsed) this.expand();
            this._baseLayersList = create$1("div", className + "-base", section);
            this._separator = create$1("div", className + "-separator", section);
            this._overlaysList = create$1("div", className + "-overlays", section);
            container.appendChild(section);
        },
        _getLayer: function(id) {
            for(var i = 0; i < this._layers.length; i++){
                if (this._layers[i] && stamp(this._layers[i].layer) === id) return this._layers[i];
            }
        },
        _addLayer: function(layer, name, overlay) {
            if (this._map) layer.on("add remove", this._onLayerChange, this);
            this._layers.push({
                layer: layer,
                name: name,
                overlay: overlay
            });
            if (this.options.sortLayers) this._layers.sort(bind(function(a, b) {
                return this.options.sortFunction(a.layer, b.layer, a.name, b.name);
            }, this));
            if (this.options.autoZIndex && layer.setZIndex) {
                this._lastZIndex++;
                layer.setZIndex(this._lastZIndex);
            }
            this._expandIfNotCollapsed();
        },
        _update: function() {
            if (!this._container) return this;
            empty(this._baseLayersList);
            empty(this._overlaysList);
            this._layerControlInputs = [];
            var baseLayersPresent, overlaysPresent, i, obj, baseLayersCount = 0;
            for(i = 0; i < this._layers.length; i++){
                obj = this._layers[i];
                this._addItem(obj);
                overlaysPresent = overlaysPresent || obj.overlay;
                baseLayersPresent = baseLayersPresent || !obj.overlay;
                baseLayersCount += !obj.overlay ? 1 : 0;
            }
            // Hide base layers section if there's only one layer.
            if (this.options.hideSingleBase) {
                baseLayersPresent = baseLayersPresent && baseLayersCount > 1;
                this._baseLayersList.style.display = baseLayersPresent ? "" : "none";
            }
            this._separator.style.display = overlaysPresent && baseLayersPresent ? "" : "none";
            return this;
        },
        _onLayerChange: function(e) {
            if (!this._handlingClick) this._update();
            var obj = this._getLayer(stamp(e.target));
            // @namespace Map
            // @section Layer events
            // @event baselayerchange: LayersControlEvent
            // Fired when the base layer is changed through the [layers control](#control-layers).
            // @event overlayadd: LayersControlEvent
            // Fired when an overlay is selected through the [layers control](#control-layers).
            // @event overlayremove: LayersControlEvent
            // Fired when an overlay is deselected through the [layers control](#control-layers).
            // @namespace Control.Layers
            var type = obj.overlay ? e.type === "add" ? "overlayadd" : "overlayremove" : e.type === "add" ? "baselayerchange" : null;
            if (type) this._map.fire(type, obj);
        },
        // IE7 bugs out if you create a radio dynamically, so you have to do it this hacky way (see https://stackoverflow.com/a/119079)
        _createRadioElement: function(name, checked) {
            var radioHtml = '<input type="radio" class="leaflet-control-layers-selector" name="' + name + '"' + (checked ? ' checked="checked"' : "") + "/>";
            var radioFragment = document.createElement("div");
            radioFragment.innerHTML = radioHtml;
            return radioFragment.firstChild;
        },
        _addItem: function(obj) {
            var label = document.createElement("label"), checked = this._map.hasLayer(obj.layer), input;
            if (obj.overlay) {
                input = document.createElement("input");
                input.type = "checkbox";
                input.className = "leaflet-control-layers-selector";
                input.defaultChecked = checked;
            } else input = this._createRadioElement("leaflet-base-layers_" + stamp(this), checked);
            this._layerControlInputs.push(input);
            input.layerId = stamp(obj.layer);
            on(input, "click", this._onInputClick, this);
            var name = document.createElement("span");
            name.innerHTML = " " + obj.name;
            // Helps from preventing layer control flicker when checkboxes are disabled
            // https://github.com/Leaflet/Leaflet/issues/2771
            var holder = document.createElement("span");
            label.appendChild(holder);
            holder.appendChild(input);
            holder.appendChild(name);
            var container = obj.overlay ? this._overlaysList : this._baseLayersList;
            container.appendChild(label);
            this._checkDisabledLayers();
            return label;
        },
        _onInputClick: function() {
            // expanding the control on mobile with a click can cause adding a layer - we don't want this
            if (this._preventClick) return;
            var inputs = this._layerControlInputs, input, layer;
            var addedLayers = [], removedLayers = [];
            this._handlingClick = true;
            for(var i = inputs.length - 1; i >= 0; i--){
                input = inputs[i];
                layer = this._getLayer(input.layerId).layer;
                if (input.checked) addedLayers.push(layer);
                else if (!input.checked) removedLayers.push(layer);
            }
            // Bugfix issue 2318: Should remove all old layers before readding new ones
            for(i = 0; i < removedLayers.length; i++)if (this._map.hasLayer(removedLayers[i])) this._map.removeLayer(removedLayers[i]);
            for(i = 0; i < addedLayers.length; i++)if (!this._map.hasLayer(addedLayers[i])) this._map.addLayer(addedLayers[i]);
            this._handlingClick = false;
            this._refocusOnMap();
        },
        _checkDisabledLayers: function() {
            var inputs = this._layerControlInputs, input, layer, zoom = this._map.getZoom();
            for(var i = inputs.length - 1; i >= 0; i--){
                input = inputs[i];
                layer = this._getLayer(input.layerId).layer;
                input.disabled = layer.options.minZoom !== undefined && zoom < layer.options.minZoom || layer.options.maxZoom !== undefined && zoom > layer.options.maxZoom;
            }
        },
        _expandIfNotCollapsed: function() {
            if (this._map && !this.options.collapsed) this.expand();
            return this;
        },
        _expandSafely: function() {
            var section = this._section;
            this._preventClick = true;
            on(section, "click", preventDefault);
            this.expand();
            var that = this;
            setTimeout(function() {
                off(section, "click", preventDefault);
                that._preventClick = false;
            });
        }
    });
    // @factory L.control.layers(baselayers?: Object, overlays?: Object, options?: Control.Layers options)
    // Creates a layers control with the given layers. Base layers will be switched with radio buttons, while overlays will be switched with checkboxes. Note that all base layers should be passed in the base layers object, but only one should be added to the map during map instantiation.
    var layers = function(baseLayers, overlays, options) {
        return new Layers(baseLayers, overlays, options);
    };
    /*
   * @class Control.Zoom
   * @aka L.Control.Zoom
   * @inherits Control
   *
   * A basic zoom control with two buttons (zoom in and zoom out). It is put on the map by default unless you set its [`zoomControl` option](#map-zoomcontrol) to `false`. Extends `Control`.
   */ var Zoom = Control.extend({
        // @section
        // @aka Control.Zoom options
        options: {
            position: "topleft",
            // @option zoomInText: String = '<span aria-hidden="true">+</span>'
            // The text set on the 'zoom in' button.
            zoomInText: '<span aria-hidden="true">+</span>',
            // @option zoomInTitle: String = 'Zoom in'
            // The title set on the 'zoom in' button.
            zoomInTitle: "Zoom in",
            // @option zoomOutText: String = '<span aria-hidden="true">&#x2212;</span>'
            // The text set on the 'zoom out' button.
            zoomOutText: '<span aria-hidden="true">&#x2212;</span>',
            // @option zoomOutTitle: String = 'Zoom out'
            // The title set on the 'zoom out' button.
            zoomOutTitle: "Zoom out"
        },
        onAdd: function(map) {
            var zoomName = "leaflet-control-zoom", container = create$1("div", zoomName + " leaflet-bar"), options = this.options;
            this._zoomInButton = this._createButton(options.zoomInText, options.zoomInTitle, zoomName + "-in", container, this._zoomIn);
            this._zoomOutButton = this._createButton(options.zoomOutText, options.zoomOutTitle, zoomName + "-out", container, this._zoomOut);
            this._updateDisabled();
            map.on("zoomend zoomlevelschange", this._updateDisabled, this);
            return container;
        },
        onRemove: function(map) {
            map.off("zoomend zoomlevelschange", this._updateDisabled, this);
        },
        disable: function() {
            this._disabled = true;
            this._updateDisabled();
            return this;
        },
        enable: function() {
            this._disabled = false;
            this._updateDisabled();
            return this;
        },
        _zoomIn: function(e) {
            if (!this._disabled && this._map._zoom < this._map.getMaxZoom()) this._map.zoomIn(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
        },
        _zoomOut: function(e) {
            if (!this._disabled && this._map._zoom > this._map.getMinZoom()) this._map.zoomOut(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
        },
        _createButton: function(html, title, className, container, fn) {
            var link = create$1("a", className, container);
            link.innerHTML = html;
            link.href = "#";
            link.title = title;
            /*
  		 * Will force screen readers like VoiceOver to read this as "Zoom in - button"
  		 */ link.setAttribute("role", "button");
            link.setAttribute("aria-label", title);
            disableClickPropagation(link);
            on(link, "click", stop);
            on(link, "click", fn, this);
            on(link, "click", this._refocusOnMap, this);
            return link;
        },
        _updateDisabled: function() {
            var map = this._map, className = "leaflet-disabled";
            removeClass(this._zoomInButton, className);
            removeClass(this._zoomOutButton, className);
            this._zoomInButton.setAttribute("aria-disabled", "false");
            this._zoomOutButton.setAttribute("aria-disabled", "false");
            if (this._disabled || map._zoom === map.getMinZoom()) {
                addClass(this._zoomOutButton, className);
                this._zoomOutButton.setAttribute("aria-disabled", "true");
            }
            if (this._disabled || map._zoom === map.getMaxZoom()) {
                addClass(this._zoomInButton, className);
                this._zoomInButton.setAttribute("aria-disabled", "true");
            }
        }
    });
    // @namespace Map
    // @section Control options
    // @option zoomControl: Boolean = true
    // Whether a [zoom control](#control-zoom) is added to the map by default.
    Map.mergeOptions({
        zoomControl: true
    });
    Map.addInitHook(function() {
        if (this.options.zoomControl) {
            // @section Controls
            // @property zoomControl: Control.Zoom
            // The default zoom control (only available if the
            // [`zoomControl` option](#map-zoomcontrol) was `true` when creating the map).
            this.zoomControl = new Zoom();
            this.addControl(this.zoomControl);
        }
    });
    // @namespace Control.Zoom
    // @factory L.control.zoom(options: Control.Zoom options)
    // Creates a zoom control
    var zoom = function(options) {
        return new Zoom(options);
    };
    /*
   * @class Control.Scale
   * @aka L.Control.Scale
   * @inherits Control
   *
   * A simple scale control that shows the scale of the current center of screen in metric (m/km) and imperial (mi/ft) systems. Extends `Control`.
   *
   * @example
   *
   * ```js
   * L.control.scale().addTo(map);
   * ```
   */ var Scale = Control.extend({
        // @section
        // @aka Control.Scale options
        options: {
            position: "bottomleft",
            // @option maxWidth: Number = 100
            // Maximum width of the control in pixels. The width is set dynamically to show round values (e.g. 100, 200, 500).
            maxWidth: 100,
            // @option metric: Boolean = True
            // Whether to show the metric scale line (m/km).
            metric: true,
            // @option imperial: Boolean = True
            // Whether to show the imperial scale line (mi/ft).
            imperial: true
        },
        onAdd: function(map) {
            var className = "leaflet-control-scale", container = create$1("div", className), options = this.options;
            this._addScales(options, className + "-line", container);
            map.on(options.updateWhenIdle ? "moveend" : "move", this._update, this);
            map.whenReady(this._update, this);
            return container;
        },
        onRemove: function(map) {
            map.off(this.options.updateWhenIdle ? "moveend" : "move", this._update, this);
        },
        _addScales: function(options, className, container) {
            if (options.metric) this._mScale = create$1("div", className, container);
            if (options.imperial) this._iScale = create$1("div", className, container);
        },
        _update: function() {
            var map = this._map, y = map.getSize().y / 2;
            var maxMeters = map.distance(map.containerPointToLatLng([
                0,
                y
            ]), map.containerPointToLatLng([
                this.options.maxWidth,
                y
            ]));
            this._updateScales(maxMeters);
        },
        _updateScales: function(maxMeters) {
            if (this.options.metric && maxMeters) this._updateMetric(maxMeters);
            if (this.options.imperial && maxMeters) this._updateImperial(maxMeters);
        },
        _updateMetric: function(maxMeters) {
            var meters = this._getRoundNum(maxMeters), label = meters < 1000 ? meters + " m" : meters / 1000 + " km";
            this._updateScale(this._mScale, label, meters / maxMeters);
        },
        _updateImperial: function(maxMeters) {
            var maxFeet = maxMeters * 3.2808399, maxMiles, miles, feet;
            if (maxFeet > 5280) {
                maxMiles = maxFeet / 5280;
                miles = this._getRoundNum(maxMiles);
                this._updateScale(this._iScale, miles + " mi", miles / maxMiles);
            } else {
                feet = this._getRoundNum(maxFeet);
                this._updateScale(this._iScale, feet + " ft", feet / maxFeet);
            }
        },
        _updateScale: function(scale, text, ratio) {
            scale.style.width = Math.round(this.options.maxWidth * ratio) + "px";
            scale.innerHTML = text;
        },
        _getRoundNum: function(num) {
            var pow10 = Math.pow(10, (Math.floor(num) + "").length - 1), d = num / pow10;
            d = d >= 10 ? 10 : d >= 5 ? 5 : d >= 3 ? 3 : d >= 2 ? 2 : 1;
            return pow10 * d;
        }
    });
    // @factory L.control.scale(options?: Control.Scale options)
    // Creates an scale control with the given options.
    var scale = function(options) {
        return new Scale(options);
    };
    var ukrainianFlag = '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" class="leaflet-attribution-flag"><path fill="#4C7BE1" d="M0 0h12v4H0z"/><path fill="#FFD500" d="M0 4h12v3H0z"/><path fill="#E0BC00" d="M0 7h12v1H0z"/></svg>';
    /*
   * @class Control.Attribution
   * @aka L.Control.Attribution
   * @inherits Control
   *
   * The attribution control allows you to display attribution data in a small text box on a map. It is put on the map by default unless you set its [`attributionControl` option](#map-attributioncontrol) to `false`, and it fetches attribution texts from layers with the [`getAttribution` method](#layer-getattribution) automatically. Extends Control.
   */ var Attribution = Control.extend({
        // @section
        // @aka Control.Attribution options
        options: {
            position: "bottomright",
            // @option prefix: String|false = 'Leaflet'
            // The HTML text shown before the attributions. Pass `false` to disable.
            prefix: '<a href="https://leafletjs.com" title="A JavaScript library for interactive maps">' + (Browser.inlineSvg ? ukrainianFlag + " " : "") + "Leaflet</a>"
        },
        initialize: function(options) {
            setOptions(this, options);
            this._attributions = {};
        },
        onAdd: function(map) {
            map.attributionControl = this;
            this._container = create$1("div", "leaflet-control-attribution");
            disableClickPropagation(this._container);
            // TODO ugly, refactor
            for(var i in map._layers)if (map._layers[i].getAttribution) this.addAttribution(map._layers[i].getAttribution());
            this._update();
            map.on("layeradd", this._addAttribution, this);
            return this._container;
        },
        onRemove: function(map) {
            map.off("layeradd", this._addAttribution, this);
        },
        _addAttribution: function(ev) {
            if (ev.layer.getAttribution) {
                this.addAttribution(ev.layer.getAttribution());
                ev.layer.once("remove", function() {
                    this.removeAttribution(ev.layer.getAttribution());
                }, this);
            }
        },
        // @method setPrefix(prefix: String|false): this
        // The HTML text shown before the attributions. Pass `false` to disable.
        setPrefix: function(prefix) {
            this.options.prefix = prefix;
            this._update();
            return this;
        },
        // @method addAttribution(text: String): this
        // Adds an attribution text (e.g. `'&copy; OpenStreetMap contributors'`).
        addAttribution: function(text) {
            if (!text) return this;
            if (!this._attributions[text]) this._attributions[text] = 0;
            this._attributions[text]++;
            this._update();
            return this;
        },
        // @method removeAttribution(text: String): this
        // Removes an attribution text.
        removeAttribution: function(text) {
            if (!text) return this;
            if (this._attributions[text]) {
                this._attributions[text]--;
                this._update();
            }
            return this;
        },
        _update: function() {
            if (!this._map) return;
            var attribs = [];
            for(var i in this._attributions)if (this._attributions[i]) attribs.push(i);
            var prefixAndAttribs = [];
            if (this.options.prefix) prefixAndAttribs.push(this.options.prefix);
            if (attribs.length) prefixAndAttribs.push(attribs.join(", "));
            this._container.innerHTML = prefixAndAttribs.join(' <span aria-hidden="true">|</span> ');
        }
    });
    // @namespace Map
    // @section Control options
    // @option attributionControl: Boolean = true
    // Whether a [attribution control](#control-attribution) is added to the map by default.
    Map.mergeOptions({
        attributionControl: true
    });
    Map.addInitHook(function() {
        if (this.options.attributionControl) new Attribution().addTo(this);
    });
    // @namespace Control.Attribution
    // @factory L.control.attribution(options: Control.Attribution options)
    // Creates an attribution control.
    var attribution = function(options) {
        return new Attribution(options);
    };
    Control.Layers = Layers;
    Control.Zoom = Zoom;
    Control.Scale = Scale;
    Control.Attribution = Attribution;
    control.layers = layers;
    control.zoom = zoom;
    control.scale = scale;
    control.attribution = attribution;
    /*
  	L.Handler is a base class for handler classes that are used internally to inject
  	interaction features like dragging to classes like Map and Marker.
  */ // @class Handler
    // @aka L.Handler
    // Abstract class for map interaction handlers
    var Handler = Class.extend({
        initialize: function(map) {
            this._map = map;
        },
        // @method enable(): this
        // Enables the handler
        enable: function() {
            if (this._enabled) return this;
            this._enabled = true;
            this.addHooks();
            return this;
        },
        // @method disable(): this
        // Disables the handler
        disable: function() {
            if (!this._enabled) return this;
            this._enabled = false;
            this.removeHooks();
            return this;
        },
        // @method enabled(): Boolean
        // Returns `true` if the handler is enabled
        enabled: function() {
            return !!this._enabled;
        }
    });
    // @section There is static function which can be called without instantiating L.Handler:
    // @function addTo(map: Map, name: String): this
    // Adds a new Handler to the given map with the given name.
    Handler.addTo = function(map, name) {
        map.addHandler(name, this);
        return this;
    };
    var Mixin = {
        Events: Events
    };
    /*
   * @class Draggable
   * @aka L.Draggable
   * @inherits Evented
   *
   * A class for making DOM elements draggable (including touch support).
   * Used internally for map and marker dragging. Only works for elements
   * that were positioned with [`L.DomUtil.setPosition`](#domutil-setposition).
   *
   * @example
   * ```js
   * var draggable = new L.Draggable(elementToDrag);
   * draggable.enable();
   * ```
   */ var START = Browser.touch ? "touchstart mousedown" : "mousedown";
    var Draggable = Evented.extend({
        options: {
            // @section
            // @aka Draggable options
            // @option clickTolerance: Number = 3
            // The max number of pixels a user can shift the mouse pointer during a click
            // for it to be considered a valid click (as opposed to a mouse drag).
            clickTolerance: 3
        },
        // @constructor L.Draggable(el: HTMLElement, dragHandle?: HTMLElement, preventOutline?: Boolean, options?: Draggable options)
        // Creates a `Draggable` object for moving `el` when you start dragging the `dragHandle` element (equals `el` itself by default).
        initialize: function(element, dragStartTarget, preventOutline, options) {
            setOptions(this, options);
            this._element = element;
            this._dragStartTarget = dragStartTarget || element;
            this._preventOutline = preventOutline;
        },
        // @method enable()
        // Enables the dragging ability
        enable: function() {
            if (this._enabled) return;
            on(this._dragStartTarget, START, this._onDown, this);
            this._enabled = true;
        },
        // @method disable()
        // Disables the dragging ability
        disable: function() {
            if (!this._enabled) return;
            // If we're currently dragging this draggable,
            // disabling it counts as first ending the drag.
            if (Draggable._dragging === this) this.finishDrag(true);
            off(this._dragStartTarget, START, this._onDown, this);
            this._enabled = false;
            this._moved = false;
        },
        _onDown: function(e) {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            this._moved = false;
            if (hasClass(this._element, "leaflet-zoom-anim")) return;
            if (e.touches && e.touches.length !== 1) {
                // Finish dragging to avoid conflict with touchZoom
                if (Draggable._dragging === this) this.finishDrag();
                return;
            }
            if (Draggable._dragging || e.shiftKey || e.which !== 1 && e.button !== 1 && !e.touches) return;
            Draggable._dragging = this; // Prevent dragging multiple objects at once.
            if (this._preventOutline) preventOutline(this._element);
            disableImageDrag();
            disableTextSelection();
            if (this._moving) return;
            // @event down: Event
            // Fired when a drag is about to start.
            this.fire("down");
            var first = e.touches ? e.touches[0] : e, sizedParent = getSizedParentNode(this._element);
            this._startPoint = new Point(first.clientX, first.clientY);
            this._startPos = getPosition(this._element);
            // Cache the scale, so that we can continuously compensate for it during drag (_onMove).
            this._parentScale = getScale(sizedParent);
            var mouseevent = e.type === "mousedown";
            on(document, mouseevent ? "mousemove" : "touchmove", this._onMove, this);
            on(document, mouseevent ? "mouseup" : "touchend touchcancel", this._onUp, this);
        },
        _onMove: function(e) {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            if (e.touches && e.touches.length > 1) {
                this._moved = true;
                return;
            }
            var first = e.touches && e.touches.length === 1 ? e.touches[0] : e, offset = new Point(first.clientX, first.clientY)._subtract(this._startPoint);
            if (!offset.x && !offset.y) return;
            if (Math.abs(offset.x) + Math.abs(offset.y) < this.options.clickTolerance) return;
            // We assume that the parent container's position, border and scale do not change for the duration of the drag.
            // Therefore there is no need to account for the position and border (they are eliminated by the subtraction)
            // and we can use the cached value for the scale.
            offset.x /= this._parentScale.x;
            offset.y /= this._parentScale.y;
            preventDefault(e);
            if (!this._moved) {
                // @event dragstart: Event
                // Fired when a drag starts
                this.fire("dragstart");
                this._moved = true;
                addClass(document.body, "leaflet-dragging");
                this._lastTarget = e.target || e.srcElement;
                // IE and Edge do not give the <use> element, so fetch it
                // if necessary
                if (window.SVGElementInstance && this._lastTarget instanceof window.SVGElementInstance) this._lastTarget = this._lastTarget.correspondingUseElement;
                addClass(this._lastTarget, "leaflet-drag-target");
            }
            this._newPos = this._startPos.add(offset);
            this._moving = true;
            this._lastEvent = e;
            this._updatePosition();
        },
        _updatePosition: function() {
            var e = {
                originalEvent: this._lastEvent
            };
            // @event predrag: Event
            // Fired continuously during dragging *before* each corresponding
            // update of the element's position.
            this.fire("predrag", e);
            setPosition(this._element, this._newPos);
            // @event drag: Event
            // Fired continuously during dragging.
            this.fire("drag", e);
        },
        _onUp: function() {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            this.finishDrag();
        },
        finishDrag: function(noInertia) {
            removeClass(document.body, "leaflet-dragging");
            if (this._lastTarget) {
                removeClass(this._lastTarget, "leaflet-drag-target");
                this._lastTarget = null;
            }
            off(document, "mousemove touchmove", this._onMove, this);
            off(document, "mouseup touchend touchcancel", this._onUp, this);
            enableImageDrag();
            enableTextSelection();
            var fireDragend = this._moved && this._moving;
            this._moving = false;
            Draggable._dragging = false;
            if (fireDragend) // @event dragend: DragEndEvent
            // Fired when the drag ends.
            this.fire("dragend", {
                noInertia: noInertia,
                distance: this._newPos.distanceTo(this._startPos)
            });
        }
    });
    /*
   * @namespace PolyUtil
   * Various utility functions for polygon geometries.
   */ /* @function clipPolygon(points: Point[], bounds: Bounds, round?: Boolean): Point[]
   * Clips the polygon geometry defined by the given `points` by the given bounds (using the [Sutherland-Hodgman algorithm](https://en.wikipedia.org/wiki/Sutherland%E2%80%93Hodgman_algorithm)).
   * Used by Leaflet to only show polygon points that are on the screen or near, increasing
   * performance. Note that polygon points needs different algorithm for clipping
   * than polyline, so there's a separate method for it.
   */ function clipPolygon(points, bounds, round) {
        var clippedPoints, edges = [
            1,
            4,
            2,
            8
        ], i, j, k, a, b, len, edge, p;
        for(i = 0, len = points.length; i < len; i++)points[i]._code = _getBitCode(points[i], bounds);
        // for each edge (left, bottom, right, top)
        for(k = 0; k < 4; k++){
            edge = edges[k];
            clippedPoints = [];
            for(i = 0, len = points.length, j = len - 1; i < len; j = i++){
                a = points[i];
                b = points[j];
                // if a is inside the clip window
                if (!(a._code & edge)) {
                    // if b is outside the clip window (a->b goes out of screen)
                    if (b._code & edge) {
                        p = _getEdgeIntersection(b, a, edge, bounds, round);
                        p._code = _getBitCode(p, bounds);
                        clippedPoints.push(p);
                    }
                    clippedPoints.push(a);
                // else if b is inside the clip window (a->b enters the screen)
                } else if (!(b._code & edge)) {
                    p = _getEdgeIntersection(b, a, edge, bounds, round);
                    p._code = _getBitCode(p, bounds);
                    clippedPoints.push(p);
                }
            }
            points = clippedPoints;
        }
        return points;
    }
    /* @function polygonCenter(latlngs: LatLng[], crs: CRS): LatLng
   * Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the passed LatLngs (first ring) from a polygon.
   */ function polygonCenter(latlngs, crs) {
        var i, j, p1, p2, f, area, x, y, center;
        if (!latlngs || latlngs.length === 0) throw new Error("latlngs not passed");
        if (!isFlat(latlngs)) {
            console.warn("latlngs are not flat! Only the first ring will be used");
            latlngs = latlngs[0];
        }
        var centroidLatLng = toLatLng([
            0,
            0
        ]);
        var bounds = toLatLngBounds(latlngs);
        var areaBounds = bounds.getNorthWest().distanceTo(bounds.getSouthWest()) * bounds.getNorthEast().distanceTo(bounds.getNorthWest());
        // tests showed that below 1700 rounding errors are happening
        if (areaBounds < 1700) // getting a inexact center, to move the latlngs near to [0, 0] to prevent rounding errors
        centroidLatLng = centroid(latlngs);
        var len = latlngs.length;
        var points = [];
        for(i = 0; i < len; i++){
            var latlng = toLatLng(latlngs[i]);
            points.push(crs.project(toLatLng([
                latlng.lat - centroidLatLng.lat,
                latlng.lng - centroidLatLng.lng
            ])));
        }
        area = x = y = 0;
        // polygon centroid algorithm;
        for(i = 0, j = len - 1; i < len; j = i++){
            p1 = points[i];
            p2 = points[j];
            f = p1.y * p2.x - p2.y * p1.x;
            x += (p1.x + p2.x) * f;
            y += (p1.y + p2.y) * f;
            area += f * 3;
        }
        if (area === 0) // Polygon is so small that all points are on same pixel.
        center = points[0];
        else center = [
            x / area,
            y / area
        ];
        var latlngCenter = crs.unproject(toPoint(center));
        return toLatLng([
            latlngCenter.lat + centroidLatLng.lat,
            latlngCenter.lng + centroidLatLng.lng
        ]);
    }
    /* @function centroid(latlngs: LatLng[]): LatLng
   * Returns the 'center of mass' of the passed LatLngs.
   */ function centroid(coords) {
        var latSum = 0;
        var lngSum = 0;
        var len = 0;
        for(var i = 0; i < coords.length; i++){
            var latlng = toLatLng(coords[i]);
            latSum += latlng.lat;
            lngSum += latlng.lng;
            len++;
        }
        return toLatLng([
            latSum / len,
            lngSum / len
        ]);
    }
    var PolyUtil = {
        __proto__: null,
        clipPolygon: clipPolygon,
        polygonCenter: polygonCenter,
        centroid: centroid
    };
    /*
   * @namespace LineUtil
   *
   * Various utility functions for polyline points processing, used by Leaflet internally to make polylines lightning-fast.
   */ // Simplify polyline with vertex reduction and Douglas-Peucker simplification.
    // Improves rendering performance dramatically by lessening the number of points to draw.
    // @function simplify(points: Point[], tolerance: Number): Point[]
    // Dramatically reduces the number of points in a polyline while retaining
    // its shape and returns a new array of simplified points, using the
    // [Ramer-Douglas-Peucker algorithm](https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm).
    // Used for a huge performance boost when processing/displaying Leaflet polylines for
    // each zoom level and also reducing visual noise. tolerance affects the amount of
    // simplification (lesser value means higher quality but slower and with more points).
    // Also released as a separated micro-library [Simplify.js](https://mourner.github.io/simplify-js/).
    function simplify(points, tolerance) {
        if (!tolerance || !points.length) return points.slice();
        var sqTolerance = tolerance * tolerance;
        // stage 1: vertex reduction
        points = _reducePoints(points, sqTolerance);
        // stage 2: Douglas-Peucker simplification
        points = _simplifyDP(points, sqTolerance);
        return points;
    }
    // @function pointToSegmentDistance(p: Point, p1: Point, p2: Point): Number
    // Returns the distance between point `p` and segment `p1` to `p2`.
    function pointToSegmentDistance(p, p1, p2) {
        return Math.sqrt(_sqClosestPointOnSegment(p, p1, p2, true));
    }
    // @function closestPointOnSegment(p: Point, p1: Point, p2: Point): Number
    // Returns the closest point from a point `p` on a segment `p1` to `p2`.
    function closestPointOnSegment(p, p1, p2) {
        return _sqClosestPointOnSegment(p, p1, p2);
    }
    // Ramer-Douglas-Peucker simplification, see https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm
    function _simplifyDP(points, sqTolerance) {
        var len = points.length, ArrayConstructor = typeof Uint8Array !== "undefined" ? Uint8Array : Array, markers = new ArrayConstructor(len);
        markers[0] = markers[len - 1] = 1;
        _simplifyDPStep(points, markers, sqTolerance, 0, len - 1);
        var i, newPoints = [];
        for(i = 0; i < len; i++)if (markers[i]) newPoints.push(points[i]);
        return newPoints;
    }
    function _simplifyDPStep(points, markers, sqTolerance, first, last) {
        var maxSqDist = 0, index, i, sqDist;
        for(i = first + 1; i <= last - 1; i++){
            sqDist = _sqClosestPointOnSegment(points[i], points[first], points[last], true);
            if (sqDist > maxSqDist) {
                index = i;
                maxSqDist = sqDist;
            }
        }
        if (maxSqDist > sqTolerance) {
            markers[index] = 1;
            _simplifyDPStep(points, markers, sqTolerance, first, index);
            _simplifyDPStep(points, markers, sqTolerance, index, last);
        }
    }
    // reduce points that are too close to each other to a single point
    function _reducePoints(points, sqTolerance) {
        var reducedPoints = [
            points[0]
        ];
        for(var i = 1, prev = 0, len = points.length; i < len; i++)if (_sqDist(points[i], points[prev]) > sqTolerance) {
            reducedPoints.push(points[i]);
            prev = i;
        }
        if (prev < len - 1) reducedPoints.push(points[len - 1]);
        return reducedPoints;
    }
    var _lastCode;
    // @function clipSegment(a: Point, b: Point, bounds: Bounds, useLastCode?: Boolean, round?: Boolean): Point[]|Boolean
    // Clips the segment a to b by rectangular bounds with the
    // [Cohen-Sutherland algorithm](https://en.wikipedia.org/wiki/Cohen%E2%80%93Sutherland_algorithm)
    // (modifying the segment points directly!). Used by Leaflet to only show polyline
    // points that are on the screen or near, increasing performance.
    function clipSegment(a, b, bounds, useLastCode, round) {
        var codeA = useLastCode ? _lastCode : _getBitCode(a, bounds), codeB = _getBitCode(b, bounds), codeOut, p, newCode;
        // save 2nd code to avoid calculating it on the next segment
        _lastCode = codeB;
        while(true){
            // if a,b is inside the clip window (trivial accept)
            if (!(codeA | codeB)) return [
                a,
                b
            ];
            // if a,b is outside the clip window (trivial reject)
            if (codeA & codeB) return false;
            // other cases
            codeOut = codeA || codeB;
            p = _getEdgeIntersection(a, b, codeOut, bounds, round);
            newCode = _getBitCode(p, bounds);
            if (codeOut === codeA) {
                a = p;
                codeA = newCode;
            } else {
                b = p;
                codeB = newCode;
            }
        }
    }
    function _getEdgeIntersection(a, b, code, bounds, round) {
        var dx = b.x - a.x, dy = b.y - a.y, min = bounds.min, max = bounds.max, x, y;
        if (code & 8) {
            x = a.x + dx * (max.y - a.y) / dy;
            y = max.y;
        } else if (code & 4) {
            x = a.x + dx * (min.y - a.y) / dy;
            y = min.y;
        } else if (code & 2) {
            x = max.x;
            y = a.y + dy * (max.x - a.x) / dx;
        } else if (code & 1) {
            x = min.x;
            y = a.y + dy * (min.x - a.x) / dx;
        }
        return new Point(x, y, round);
    }
    function _getBitCode(p, bounds) {
        var code = 0;
        if (p.x < bounds.min.x) code |= 1;
        else if (p.x > bounds.max.x) code |= 2;
        if (p.y < bounds.min.y) code |= 4;
        else if (p.y > bounds.max.y) code |= 8;
        return code;
    }
    // square distance (to avoid unnecessary Math.sqrt calls)
    function _sqDist(p1, p2) {
        var dx = p2.x - p1.x, dy = p2.y - p1.y;
        return dx * dx + dy * dy;
    }
    // return closest point on segment or distance to that point
    function _sqClosestPointOnSegment(p, p1, p2, sqDist) {
        var x = p1.x, y = p1.y, dx = p2.x - x, dy = p2.y - y, dot = dx * dx + dy * dy, t;
        if (dot > 0) {
            t = ((p.x - x) * dx + (p.y - y) * dy) / dot;
            if (t > 1) {
                x = p2.x;
                y = p2.y;
            } else if (t > 0) {
                x += dx * t;
                y += dy * t;
            }
        }
        dx = p.x - x;
        dy = p.y - y;
        return sqDist ? dx * dx + dy * dy : new Point(x, y);
    }
    // @function isFlat(latlngs: LatLng[]): Boolean
    // Returns true if `latlngs` is a flat array, false is nested.
    function isFlat(latlngs) {
        return !isArray(latlngs[0]) || typeof latlngs[0][0] !== "object" && typeof latlngs[0][0] !== "undefined";
    }
    function _flat(latlngs) {
        console.warn("Deprecated use of _flat, please use L.LineUtil.isFlat instead.");
        return isFlat(latlngs);
    }
    /* @function polylineCenter(latlngs: LatLng[], crs: CRS): LatLng
   * Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the passed LatLngs (first ring) from a polyline.
   */ function polylineCenter(latlngs, crs) {
        var i, halfDist, segDist, dist, p1, p2, ratio, center;
        if (!latlngs || latlngs.length === 0) throw new Error("latlngs not passed");
        if (!isFlat(latlngs)) {
            console.warn("latlngs are not flat! Only the first ring will be used");
            latlngs = latlngs[0];
        }
        var centroidLatLng = toLatLng([
            0,
            0
        ]);
        var bounds = toLatLngBounds(latlngs);
        var areaBounds = bounds.getNorthWest().distanceTo(bounds.getSouthWest()) * bounds.getNorthEast().distanceTo(bounds.getNorthWest());
        // tests showed that below 1700 rounding errors are happening
        if (areaBounds < 1700) // getting a inexact center, to move the latlngs near to [0, 0] to prevent rounding errors
        centroidLatLng = centroid(latlngs);
        var len = latlngs.length;
        var points = [];
        for(i = 0; i < len; i++){
            var latlng = toLatLng(latlngs[i]);
            points.push(crs.project(toLatLng([
                latlng.lat - centroidLatLng.lat,
                latlng.lng - centroidLatLng.lng
            ])));
        }
        for(i = 0, halfDist = 0; i < len - 1; i++)halfDist += points[i].distanceTo(points[i + 1]) / 2;
        // The line is so small in the current view that all points are on the same pixel.
        if (halfDist === 0) center = points[0];
        else for(i = 0, dist = 0; i < len - 1; i++){
            p1 = points[i];
            p2 = points[i + 1];
            segDist = p1.distanceTo(p2);
            dist += segDist;
            if (dist > halfDist) {
                ratio = (dist - halfDist) / segDist;
                center = [
                    p2.x - ratio * (p2.x - p1.x),
                    p2.y - ratio * (p2.y - p1.y)
                ];
                break;
            }
        }
        var latlngCenter = crs.unproject(toPoint(center));
        return toLatLng([
            latlngCenter.lat + centroidLatLng.lat,
            latlngCenter.lng + centroidLatLng.lng
        ]);
    }
    var LineUtil = {
        __proto__: null,
        simplify: simplify,
        pointToSegmentDistance: pointToSegmentDistance,
        closestPointOnSegment: closestPointOnSegment,
        clipSegment: clipSegment,
        _getEdgeIntersection: _getEdgeIntersection,
        _getBitCode: _getBitCode,
        _sqClosestPointOnSegment: _sqClosestPointOnSegment,
        isFlat: isFlat,
        _flat: _flat,
        polylineCenter: polylineCenter
    };
    /*
   * @namespace Projection
   * @section
   * Leaflet comes with a set of already defined Projections out of the box:
   *
   * @projection L.Projection.LonLat
   *
   * Equirectangular, or Plate Carree projection — the most simple projection,
   * mostly used by GIS enthusiasts. Directly maps `x` as longitude, and `y` as
   * latitude. Also suitable for flat worlds, e.g. game maps. Used by the
   * `EPSG:4326` and `Simple` CRS.
   */ var LonLat = {
        project: function(latlng) {
            return new Point(latlng.lng, latlng.lat);
        },
        unproject: function(point) {
            return new LatLng(point.y, point.x);
        },
        bounds: new Bounds([
            -180,
            -90
        ], [
            180,
            90
        ])
    };
    /*
   * @namespace Projection
   * @projection L.Projection.Mercator
   *
   * Elliptical Mercator projection — more complex than Spherical Mercator. Assumes that Earth is an ellipsoid. Used by the EPSG:3395 CRS.
   */ var Mercator = {
        R: 6378137,
        R_MINOR: 6356752.314245179,
        bounds: new Bounds([
            -20037508.34279,
            -15496570.73972
        ], [
            20037508.34279,
            18764656.23138
        ]),
        project: function(latlng) {
            var d = Math.PI / 180, r = this.R, y = latlng.lat * d, tmp = this.R_MINOR / r, e = Math.sqrt(1 - tmp * tmp), con = e * Math.sin(y);
            var ts = Math.tan(Math.PI / 4 - y / 2) / Math.pow((1 - con) / (1 + con), e / 2);
            y = -r * Math.log(Math.max(ts, 1E-10));
            return new Point(latlng.lng * d * r, y);
        },
        unproject: function(point) {
            var d = 180 / Math.PI, r = this.R, tmp = this.R_MINOR / r, e = Math.sqrt(1 - tmp * tmp), ts = Math.exp(-point.y / r), phi = Math.PI / 2 - 2 * Math.atan(ts);
            for(var i = 0, dphi = 0.1, con; i < 15 && Math.abs(dphi) > 1e-7; i++){
                con = e * Math.sin(phi);
                con = Math.pow((1 - con) / (1 + con), e / 2);
                dphi = Math.PI / 2 - 2 * Math.atan(ts * con) - phi;
                phi += dphi;
            }
            return new LatLng(phi * d, point.x * d / r);
        }
    };
    /*
   * @class Projection

   * An object with methods for projecting geographical coordinates of the world onto
   * a flat surface (and back). See [Map projection](https://en.wikipedia.org/wiki/Map_projection).

   * @property bounds: Bounds
   * The bounds (specified in CRS units) where the projection is valid

   * @method project(latlng: LatLng): Point
   * Projects geographical coordinates into a 2D point.
   * Only accepts actual `L.LatLng` instances, not arrays.

   * @method unproject(point: Point): LatLng
   * The inverse of `project`. Projects a 2D point into a geographical location.
   * Only accepts actual `L.Point` instances, not arrays.

   * Note that the projection instances do not inherit from Leaflet's `Class` object,
   * and can't be instantiated. Also, new classes can't inherit from them,
   * and methods can't be added to them with the `include` function.

   */ var index = {
        __proto__: null,
        LonLat: LonLat,
        Mercator: Mercator,
        SphericalMercator: SphericalMercator
    };
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG3395
   *
   * Rarely used by some commercial tile providers. Uses Elliptical Mercator projection.
   */ var EPSG3395 = extend({}, Earth, {
        code: "EPSG:3395",
        projection: Mercator,
        transformation: function() {
            var scale = 0.5 / (Math.PI * Mercator.R);
            return toTransformation(scale, 0.5, -scale, 0.5);
        }()
    });
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG4326
   *
   * A common CRS among GIS enthusiasts. Uses simple Equirectangular projection.
   *
   * Leaflet 1.0.x complies with the [TMS coordinate scheme for EPSG:4326](https://wiki.osgeo.org/wiki/Tile_Map_Service_Specification#global-geodetic),
   * which is a breaking change from 0.7.x behaviour.  If you are using a `TileLayer`
   * with this CRS, ensure that there are two 256x256 pixel tiles covering the
   * whole earth at zoom level zero, and that the tile coordinate origin is (-180,+90),
   * or (-180,-90) for `TileLayer`s with [the `tms` option](#tilelayer-tms) set.
   */ var EPSG4326 = extend({}, Earth, {
        code: "EPSG:4326",
        projection: LonLat,
        transformation: toTransformation(1 / 180, 1, -1 / 180, 0.5)
    });
    /*
   * @namespace CRS
   * @crs L.CRS.Simple
   *
   * A simple CRS that maps longitude and latitude into `x` and `y` directly.
   * May be used for maps of flat surfaces (e.g. game maps). Note that the `y`
   * axis should still be inverted (going from bottom to top). `distance()` returns
   * simple euclidean distance.
   */ var Simple = extend({}, CRS, {
        projection: LonLat,
        transformation: toTransformation(1, 0, -1, 0),
        scale: function(zoom) {
            return Math.pow(2, zoom);
        },
        zoom: function(scale) {
            return Math.log(scale) / Math.LN2;
        },
        distance: function(latlng1, latlng2) {
            var dx = latlng2.lng - latlng1.lng, dy = latlng2.lat - latlng1.lat;
            return Math.sqrt(dx * dx + dy * dy);
        },
        infinite: true
    });
    CRS.Earth = Earth;
    CRS.EPSG3395 = EPSG3395;
    CRS.EPSG3857 = EPSG3857;
    CRS.EPSG900913 = EPSG900913;
    CRS.EPSG4326 = EPSG4326;
    CRS.Simple = Simple;
    /*
   * @class Layer
   * @inherits Evented
   * @aka L.Layer
   * @aka ILayer
   *
   * A set of methods from the Layer base class that all Leaflet layers use.
   * Inherits all methods, options and events from `L.Evented`.
   *
   * @example
   *
   * ```js
   * var layer = L.marker(latlng).addTo(map);
   * layer.addTo(map);
   * layer.remove();
   * ```
   *
   * @event add: Event
   * Fired after the layer is added to a map
   *
   * @event remove: Event
   * Fired after the layer is removed from a map
   */ var Layer = Evented.extend({
        // Classes extending `L.Layer` will inherit the following options:
        options: {
            // @option pane: String = 'overlayPane'
            // By default the layer will be added to the map's [overlay pane](#map-overlaypane). Overriding this option will cause the layer to be placed on another pane by default.
            pane: "overlayPane",
            // @option attribution: String = null
            // String to be shown in the attribution control, e.g. "© OpenStreetMap contributors". It describes the layer data and is often a legal obligation towards copyright holders and tile providers.
            attribution: null,
            bubblingMouseEvents: true
        },
        /* @section
  	 * Classes extending `L.Layer` will inherit the following methods:
  	 *
  	 * @method addTo(map: Map|LayerGroup): this
  	 * Adds the layer to the given map or layer group.
  	 */ addTo: function(map) {
            map.addLayer(this);
            return this;
        },
        // @method remove: this
        // Removes the layer from the map it is currently active on.
        remove: function() {
            return this.removeFrom(this._map || this._mapToAdd);
        },
        // @method removeFrom(map: Map): this
        // Removes the layer from the given map
        //
        // @alternative
        // @method removeFrom(group: LayerGroup): this
        // Removes the layer from the given `LayerGroup`
        removeFrom: function(obj) {
            if (obj) obj.removeLayer(this);
            return this;
        },
        // @method getPane(name? : String): HTMLElement
        // Returns the `HTMLElement` representing the named pane on the map. If `name` is omitted, returns the pane for this layer.
        getPane: function(name) {
            return this._map.getPane(name ? this.options[name] || name : this.options.pane);
        },
        addInteractiveTarget: function(targetEl) {
            this._map._targets[stamp(targetEl)] = this;
            return this;
        },
        removeInteractiveTarget: function(targetEl) {
            delete this._map._targets[stamp(targetEl)];
            return this;
        },
        // @method getAttribution: String
        // Used by the `attribution control`, returns the [attribution option](#gridlayer-attribution).
        getAttribution: function() {
            return this.options.attribution;
        },
        _layerAdd: function(e) {
            var map = e.target;
            // check in case layer gets added and then removed before the map is ready
            if (!map.hasLayer(this)) return;
            this._map = map;
            this._zoomAnimated = map._zoomAnimated;
            if (this.getEvents) {
                var events = this.getEvents();
                map.on(events, this);
                this.once("remove", function() {
                    map.off(events, this);
                }, this);
            }
            this.onAdd(map);
            this.fire("add");
            map.fire("layeradd", {
                layer: this
            });
        }
    });
    /* @section Extension methods
   * @uninheritable
   *
   * Every layer should extend from `L.Layer` and (re-)implement the following methods.
   *
   * @method onAdd(map: Map): this
   * Should contain code that creates DOM elements for the layer, adds them to `map panes` where they should belong and puts listeners on relevant map events. Called on [`map.addLayer(layer)`](#map-addlayer).
   *
   * @method onRemove(map: Map): this
   * Should contain all clean up code that removes the layer's elements from the DOM and removes listeners previously added in [`onAdd`](#layer-onadd). Called on [`map.removeLayer(layer)`](#map-removelayer).
   *
   * @method getEvents(): Object
   * This optional method should return an object like `{ viewreset: this._reset }` for [`addEventListener`](#evented-addeventlistener). The event handlers in this object will be automatically added and removed from the map with your layer.
   *
   * @method getAttribution(): String
   * This optional method should return a string containing HTML to be shown on the `Attribution control` whenever the layer is visible.
   *
   * @method beforeAdd(map: Map): this
   * Optional method. Called on [`map.addLayer(layer)`](#map-addlayer), before the layer is added to the map, before events are initialized, without waiting until the map is in a usable state. Use for early initialization only.
   */ /* @namespace Map
   * @section Layer events
   *
   * @event layeradd: LayerEvent
   * Fired when a new layer is added to the map.
   *
   * @event layerremove: LayerEvent
   * Fired when some layer is removed from the map
   *
   * @section Methods for Layers and Controls
   */ Map.include({
        // @method addLayer(layer: Layer): this
        // Adds the given layer to the map
        addLayer: function(layer) {
            if (!layer._layerAdd) throw new Error("The provided object is not a Layer.");
            var id = stamp(layer);
            if (this._layers[id]) return this;
            this._layers[id] = layer;
            layer._mapToAdd = this;
            if (layer.beforeAdd) layer.beforeAdd(this);
            this.whenReady(layer._layerAdd, layer);
            return this;
        },
        // @method removeLayer(layer: Layer): this
        // Removes the given layer from the map.
        removeLayer: function(layer) {
            var id = stamp(layer);
            if (!this._layers[id]) return this;
            if (this._loaded) layer.onRemove(this);
            delete this._layers[id];
            if (this._loaded) {
                this.fire("layerremove", {
                    layer: layer
                });
                layer.fire("remove");
            }
            layer._map = layer._mapToAdd = null;
            return this;
        },
        // @method hasLayer(layer: Layer): Boolean
        // Returns `true` if the given layer is currently added to the map
        hasLayer: function(layer) {
            return stamp(layer) in this._layers;
        },
        /* @method eachLayer(fn: Function, context?: Object): this
  	 * Iterates over the layers of the map, optionally specifying context of the iterator function.
  	 * ```
  	 * map.eachLayer(function(layer){
  	 *     layer.bindPopup('Hello');
  	 * });
  	 * ```
  	 */ eachLayer: function(method, context) {
            for(var i in this._layers)method.call(context, this._layers[i]);
            return this;
        },
        _addLayers: function(layers) {
            layers = layers ? isArray(layers) ? layers : [
                layers
            ] : [];
            for(var i = 0, len = layers.length; i < len; i++)this.addLayer(layers[i]);
        },
        _addZoomLimit: function(layer) {
            if (!isNaN(layer.options.maxZoom) || !isNaN(layer.options.minZoom)) {
                this._zoomBoundLayers[stamp(layer)] = layer;
                this._updateZoomLevels();
            }
        },
        _removeZoomLimit: function(layer) {
            var id = stamp(layer);
            if (this._zoomBoundLayers[id]) {
                delete this._zoomBoundLayers[id];
                this._updateZoomLevels();
            }
        },
        _updateZoomLevels: function() {
            var minZoom = Infinity, maxZoom = -Infinity, oldZoomSpan = this._getZoomSpan();
            for(var i in this._zoomBoundLayers){
                var options = this._zoomBoundLayers[i].options;
                minZoom = options.minZoom === undefined ? minZoom : Math.min(minZoom, options.minZoom);
                maxZoom = options.maxZoom === undefined ? maxZoom : Math.max(maxZoom, options.maxZoom);
            }
            this._layersMaxZoom = maxZoom === -Infinity ? undefined : maxZoom;
            this._layersMinZoom = minZoom === Infinity ? undefined : minZoom;
            // @section Map state change events
            // @event zoomlevelschange: Event
            // Fired when the number of zoomlevels on the map is changed due
            // to adding or removing a layer.
            if (oldZoomSpan !== this._getZoomSpan()) this.fire("zoomlevelschange");
            if (this.options.maxZoom === undefined && this._layersMaxZoom && this.getZoom() > this._layersMaxZoom) this.setZoom(this._layersMaxZoom);
            if (this.options.minZoom === undefined && this._layersMinZoom && this.getZoom() < this._layersMinZoom) this.setZoom(this._layersMinZoom);
        }
    });
    /*
   * @class LayerGroup
   * @aka L.LayerGroup
   * @inherits Interactive layer
   *
   * Used to group several layers and handle them as one. If you add it to the map,
   * any layers added or removed from the group will be added/removed on the map as
   * well. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * L.layerGroup([marker1, marker2])
   * 	.addLayer(polyline)
   * 	.addTo(map);
   * ```
   */ var LayerGroup = Layer.extend({
        initialize: function(layers, options) {
            setOptions(this, options);
            this._layers = {};
            var i, len;
            if (layers) for(i = 0, len = layers.length; i < len; i++)this.addLayer(layers[i]);
        },
        // @method addLayer(layer: Layer): this
        // Adds the given layer to the group.
        addLayer: function(layer) {
            var id = this.getLayerId(layer);
            this._layers[id] = layer;
            if (this._map) this._map.addLayer(layer);
            return this;
        },
        // @method removeLayer(layer: Layer): this
        // Removes the given layer from the group.
        // @alternative
        // @method removeLayer(id: Number): this
        // Removes the layer with the given internal ID from the group.
        removeLayer: function(layer) {
            var id = layer in this._layers ? layer : this.getLayerId(layer);
            if (this._map && this._layers[id]) this._map.removeLayer(this._layers[id]);
            delete this._layers[id];
            return this;
        },
        // @method hasLayer(layer: Layer): Boolean
        // Returns `true` if the given layer is currently added to the group.
        // @alternative
        // @method hasLayer(id: Number): Boolean
        // Returns `true` if the given internal ID is currently added to the group.
        hasLayer: function(layer) {
            var layerId = typeof layer === "number" ? layer : this.getLayerId(layer);
            return layerId in this._layers;
        },
        // @method clearLayers(): this
        // Removes all the layers from the group.
        clearLayers: function() {
            return this.eachLayer(this.removeLayer, this);
        },
        // @method invoke(methodName: String, …): this
        // Calls `methodName` on every layer contained in this group, passing any
        // additional parameters. Has no effect if the layers contained do not
        // implement `methodName`.
        invoke: function(methodName) {
            var args = Array.prototype.slice.call(arguments, 1), i, layer;
            for(i in this._layers){
                layer = this._layers[i];
                if (layer[methodName]) layer[methodName].apply(layer, args);
            }
            return this;
        },
        onAdd: function(map) {
            this.eachLayer(map.addLayer, map);
        },
        onRemove: function(map) {
            this.eachLayer(map.removeLayer, map);
        },
        // @method eachLayer(fn: Function, context?: Object): this
        // Iterates over the layers of the group, optionally specifying context of the iterator function.
        // ```js
        // group.eachLayer(function (layer) {
        // 	layer.bindPopup('Hello');
        // });
        // ```
        eachLayer: function(method, context) {
            for(var i in this._layers)method.call(context, this._layers[i]);
            return this;
        },
        // @method getLayer(id: Number): Layer
        // Returns the layer with the given internal ID.
        getLayer: function(id) {
            return this._layers[id];
        },
        // @method getLayers(): Layer[]
        // Returns an array of all the layers added to the group.
        getLayers: function() {
            var layers = [];
            this.eachLayer(layers.push, layers);
            return layers;
        },
        // @method setZIndex(zIndex: Number): this
        // Calls `setZIndex` on every layer contained in this group, passing the z-index.
        setZIndex: function(zIndex) {
            return this.invoke("setZIndex", zIndex);
        },
        // @method getLayerId(layer: Layer): Number
        // Returns the internal ID for a layer
        getLayerId: function(layer) {
            return stamp(layer);
        }
    });
    // @factory L.layerGroup(layers?: Layer[], options?: Object)
    // Create a layer group, optionally given an initial set of layers and an `options` object.
    var layerGroup = function(layers, options) {
        return new LayerGroup(layers, options);
    };
    /*
   * @class FeatureGroup
   * @aka L.FeatureGroup
   * @inherits LayerGroup
   *
   * Extended `LayerGroup` that makes it easier to do the same thing to all its member layers:
   *  * [`bindPopup`](#layer-bindpopup) binds a popup to all of the layers at once (likewise with [`bindTooltip`](#layer-bindtooltip))
   *  * Events are propagated to the `FeatureGroup`, so if the group has an event
   * handler, it will handle events from any of the layers. This includes mouse events
   * and custom events.
   *  * Has `layeradd` and `layerremove` events
   *
   * @example
   *
   * ```js
   * L.featureGroup([marker1, marker2, polyline])
   * 	.bindPopup('Hello world!')
   * 	.on('click', function() { alert('Clicked on a member of the group!'); })
   * 	.addTo(map);
   * ```
   */ var FeatureGroup = LayerGroup.extend({
        addLayer: function(layer) {
            if (this.hasLayer(layer)) return this;
            layer.addEventParent(this);
            LayerGroup.prototype.addLayer.call(this, layer);
            // @event layeradd: LayerEvent
            // Fired when a layer is added to this `FeatureGroup`
            return this.fire("layeradd", {
                layer: layer
            });
        },
        removeLayer: function(layer) {
            if (!this.hasLayer(layer)) return this;
            if (layer in this._layers) layer = this._layers[layer];
            layer.removeEventParent(this);
            LayerGroup.prototype.removeLayer.call(this, layer);
            // @event layerremove: LayerEvent
            // Fired when a layer is removed from this `FeatureGroup`
            return this.fire("layerremove", {
                layer: layer
            });
        },
        // @method setStyle(style: Path options): this
        // Sets the given path options to each layer of the group that has a `setStyle` method.
        setStyle: function(style) {
            return this.invoke("setStyle", style);
        },
        // @method bringToFront(): this
        // Brings the layer group to the top of all other layers
        bringToFront: function() {
            return this.invoke("bringToFront");
        },
        // @method bringToBack(): this
        // Brings the layer group to the back of all other layers
        bringToBack: function() {
            return this.invoke("bringToBack");
        },
        // @method getBounds(): LatLngBounds
        // Returns the LatLngBounds of the Feature Group (created from bounds and coordinates of its children).
        getBounds: function() {
            var bounds = new LatLngBounds();
            for(var id in this._layers){
                var layer = this._layers[id];
                bounds.extend(layer.getBounds ? layer.getBounds() : layer.getLatLng());
            }
            return bounds;
        }
    });
    // @factory L.featureGroup(layers?: Layer[], options?: Object)
    // Create a feature group, optionally given an initial set of layers and an `options` object.
    var featureGroup = function(layers, options) {
        return new FeatureGroup(layers, options);
    };
    /*
   * @class Icon
   * @aka L.Icon
   *
   * Represents an icon to provide when creating a marker.
   *
   * @example
   *
   * ```js
   * var myIcon = L.icon({
   *     iconUrl: 'my-icon.png',
   *     iconRetinaUrl: 'my-icon@2x.png',
   *     iconSize: [38, 95],
   *     iconAnchor: [22, 94],
   *     popupAnchor: [-3, -76],
   *     shadowUrl: 'my-icon-shadow.png',
   *     shadowRetinaUrl: 'my-icon-shadow@2x.png',
   *     shadowSize: [68, 95],
   *     shadowAnchor: [22, 94]
   * });
   *
   * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
   * ```
   *
   * `L.Icon.Default` extends `L.Icon` and is the blue icon Leaflet uses for markers by default.
   *
   */ var Icon = Class.extend({
        /* @section
  	 * @aka Icon options
  	 *
  	 * @option iconUrl: String = null
  	 * **(required)** The URL to the icon image (absolute or relative to your script path).
  	 *
  	 * @option iconRetinaUrl: String = null
  	 * The URL to a retina sized version of the icon image (absolute or relative to your
  	 * script path). Used for Retina screen devices.
  	 *
  	 * @option iconSize: Point = null
  	 * Size of the icon image in pixels.
  	 *
  	 * @option iconAnchor: Point = null
  	 * The coordinates of the "tip" of the icon (relative to its top left corner). The icon
  	 * will be aligned so that this point is at the marker's geographical location. Centered
  	 * by default if size is specified, also can be set in CSS with negative margins.
  	 *
  	 * @option popupAnchor: Point = [0, 0]
  	 * The coordinates of the point from which popups will "open", relative to the icon anchor.
  	 *
  	 * @option tooltipAnchor: Point = [0, 0]
  	 * The coordinates of the point from which tooltips will "open", relative to the icon anchor.
  	 *
  	 * @option shadowUrl: String = null
  	 * The URL to the icon shadow image. If not specified, no shadow image will be created.
  	 *
  	 * @option shadowRetinaUrl: String = null
  	 *
  	 * @option shadowSize: Point = null
  	 * Size of the shadow image in pixels.
  	 *
  	 * @option shadowAnchor: Point = null
  	 * The coordinates of the "tip" of the shadow (relative to its top left corner) (the same
  	 * as iconAnchor if not specified).
  	 *
  	 * @option className: String = ''
  	 * A custom class name to assign to both icon and shadow images. Empty by default.
  	 */ options: {
            popupAnchor: [
                0,
                0
            ],
            tooltipAnchor: [
                0,
                0
            ],
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the tiles.
            // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        // @method createIcon(oldIcon?: HTMLElement): HTMLElement
        // Called internally when the icon has to be shown, returns a `<img>` HTML element
        // styled according to the options.
        createIcon: function(oldIcon) {
            return this._createIcon("icon", oldIcon);
        },
        // @method createShadow(oldIcon?: HTMLElement): HTMLElement
        // As `createIcon`, but for the shadow beneath it.
        createShadow: function(oldIcon) {
            return this._createIcon("shadow", oldIcon);
        },
        _createIcon: function(name, oldIcon) {
            var src = this._getIconUrl(name);
            if (!src) {
                if (name === "icon") throw new Error("iconUrl not set in Icon options (see the docs).");
                return null;
            }
            var img = this._createImg(src, oldIcon && oldIcon.tagName === "IMG" ? oldIcon : null);
            this._setIconStyles(img, name);
            if (this.options.crossOrigin || this.options.crossOrigin === "") img.crossOrigin = this.options.crossOrigin === true ? "" : this.options.crossOrigin;
            return img;
        },
        _setIconStyles: function(img, name) {
            var options = this.options;
            var sizeOption = options[name + "Size"];
            if (typeof sizeOption === "number") sizeOption = [
                sizeOption,
                sizeOption
            ];
            var size = toPoint(sizeOption), anchor = toPoint(name === "shadow" && options.shadowAnchor || options.iconAnchor || size && size.divideBy(2, true));
            img.className = "leaflet-marker-" + name + " " + (options.className || "");
            if (anchor) {
                img.style.marginLeft = -anchor.x + "px";
                img.style.marginTop = -anchor.y + "px";
            }
            if (size) {
                img.style.width = size.x + "px";
                img.style.height = size.y + "px";
            }
        },
        _createImg: function(src, el) {
            el = el || document.createElement("img");
            el.src = src;
            return el;
        },
        _getIconUrl: function(name) {
            return Browser.retina && this.options[name + "RetinaUrl"] || this.options[name + "Url"];
        }
    });
    // @factory L.icon(options: Icon options)
    // Creates an icon instance with the given options.
    function icon(options) {
        return new Icon(options);
    }
    /*
   * @miniclass Icon.Default (Icon)
   * @aka L.Icon.Default
   * @section
   *
   * A trivial subclass of `Icon`, represents the icon to use in `Marker`s when
   * no icon is specified. Points to the blue marker image distributed with Leaflet
   * releases.
   *
   * In order to customize the default icon, just change the properties of `L.Icon.Default.prototype.options`
   * (which is a set of `Icon options`).
   *
   * If you want to _completely_ replace the default icon, override the
   * `L.Marker.prototype.options.icon` with your own icon instead.
   */ var IconDefault = Icon.extend({
        options: {
            iconUrl: "marker-icon.png",
            iconRetinaUrl: "marker-icon-2x.png",
            shadowUrl: "marker-shadow.png",
            iconSize: [
                25,
                41
            ],
            iconAnchor: [
                12,
                41
            ],
            popupAnchor: [
                1,
                -34
            ],
            tooltipAnchor: [
                16,
                -28
            ],
            shadowSize: [
                41,
                41
            ]
        },
        _getIconUrl: function(name) {
            if (typeof IconDefault.imagePath !== "string") IconDefault.imagePath = this._detectIconPath();
            // @option imagePath: String
            // `Icon.Default` will try to auto-detect the location of the
            // blue icon images. If you are placing these images in a non-standard
            // way, set this option to point to the right path.
            return (this.options.imagePath || IconDefault.imagePath) + Icon.prototype._getIconUrl.call(this, name);
        },
        _stripUrl: function(path) {
            var strip = function(str, re, idx) {
                var match = re.exec(str);
                return match && match[idx];
            };
            path = strip(path, /^url\((['"])?(.+)\1\)$/, 2);
            return path && strip(path, /^(.*)marker-icon\.png$/, 1);
        },
        _detectIconPath: function() {
            var el = create$1("div", "leaflet-default-icon-path", document.body);
            var path = getStyle(el, "background-image") || getStyle(el, "backgroundImage"); // IE8
            document.body.removeChild(el);
            path = this._stripUrl(path);
            if (path) return path;
            var link = document.querySelector('link[href$="leaflet.css"]');
            if (!link) return "";
            return link.href.substring(0, link.href.length - 11 - 1);
        }
    });
    /*
   * L.Handler.MarkerDrag is used internally by L.Marker to make the markers draggable.
   */ /* @namespace Marker
   * @section Interaction handlers
   *
   * Interaction handlers are properties of a marker instance that allow you to control interaction behavior in runtime, enabling or disabling certain features such as dragging (see `Handler` methods). Example:
   *
   * ```js
   * marker.dragging.disable();
   * ```
   *
   * @property dragging: Handler
   * Marker dragging handler (by both mouse and touch). Only valid when the marker is on the map (Otherwise set [`marker.options.draggable`](#marker-draggable)).
   */ var MarkerDrag = Handler.extend({
        initialize: function(marker) {
            this._marker = marker;
        },
        addHooks: function() {
            var icon = this._marker._icon;
            if (!this._draggable) this._draggable = new Draggable(icon, icon, true);
            this._draggable.on({
                dragstart: this._onDragStart,
                predrag: this._onPreDrag,
                drag: this._onDrag,
                dragend: this._onDragEnd
            }, this).enable();
            addClass(icon, "leaflet-marker-draggable");
        },
        removeHooks: function() {
            this._draggable.off({
                dragstart: this._onDragStart,
                predrag: this._onPreDrag,
                drag: this._onDrag,
                dragend: this._onDragEnd
            }, this).disable();
            if (this._marker._icon) removeClass(this._marker._icon, "leaflet-marker-draggable");
        },
        moved: function() {
            return this._draggable && this._draggable._moved;
        },
        _adjustPan: function(e) {
            var marker = this._marker, map = marker._map, speed = this._marker.options.autoPanSpeed, padding = this._marker.options.autoPanPadding, iconPos = getPosition(marker._icon), bounds = map.getPixelBounds(), origin = map.getPixelOrigin();
            var panBounds = toBounds(bounds.min._subtract(origin).add(padding), bounds.max._subtract(origin).subtract(padding));
            if (!panBounds.contains(iconPos)) {
                // Compute incremental movement
                var movement = toPoint((Math.max(panBounds.max.x, iconPos.x) - panBounds.max.x) / (bounds.max.x - panBounds.max.x) - (Math.min(panBounds.min.x, iconPos.x) - panBounds.min.x) / (bounds.min.x - panBounds.min.x), (Math.max(panBounds.max.y, iconPos.y) - panBounds.max.y) / (bounds.max.y - panBounds.max.y) - (Math.min(panBounds.min.y, iconPos.y) - panBounds.min.y) / (bounds.min.y - panBounds.min.y)).multiplyBy(speed);
                map.panBy(movement, {
                    animate: false
                });
                this._draggable._newPos._add(movement);
                this._draggable._startPos._add(movement);
                setPosition(marker._icon, this._draggable._newPos);
                this._onDrag(e);
                this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
            }
        },
        _onDragStart: function() {
            // @section Dragging events
            // @event dragstart: Event
            // Fired when the user starts dragging the marker.
            // @event movestart: Event
            // Fired when the marker starts moving (because of dragging).
            this._oldLatLng = this._marker.getLatLng();
            // When using ES6 imports it could not be set when `Popup` was not imported as well
            this._marker.closePopup && this._marker.closePopup();
            this._marker.fire("movestart").fire("dragstart");
        },
        _onPreDrag: function(e) {
            if (this._marker.options.autoPan) {
                cancelAnimFrame(this._panRequest);
                this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
            }
        },
        _onDrag: function(e) {
            var marker = this._marker, shadow = marker._shadow, iconPos = getPosition(marker._icon), latlng = marker._map.layerPointToLatLng(iconPos);
            // update shadow position
            if (shadow) setPosition(shadow, iconPos);
            marker._latlng = latlng;
            e.latlng = latlng;
            e.oldLatLng = this._oldLatLng;
            // @event drag: Event
            // Fired repeatedly while the user drags the marker.
            marker.fire("move", e).fire("drag", e);
        },
        _onDragEnd: function(e) {
            // @event dragend: DragEndEvent
            // Fired when the user stops dragging the marker.
            cancelAnimFrame(this._panRequest);
            // @event moveend: Event
            // Fired when the marker stops moving (because of dragging).
            delete this._oldLatLng;
            this._marker.fire("moveend").fire("dragend", e);
        }
    });
    /*
   * @class Marker
   * @inherits Interactive layer
   * @aka L.Marker
   * L.Marker is used to display clickable/draggable icons on the map. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * L.marker([50.5, 30.5]).addTo(map);
   * ```
   */ var Marker = Layer.extend({
        // @section
        // @aka Marker options
        options: {
            // @option icon: Icon = *
            // Icon instance to use for rendering the marker.
            // See [Icon documentation](#L.Icon) for details on how to customize the marker icon.
            // If not specified, a common instance of `L.Icon.Default` is used.
            icon: new IconDefault(),
            // Option inherited from "Interactive layer" abstract class
            interactive: true,
            // @option keyboard: Boolean = true
            // Whether the marker can be tabbed to with a keyboard and clicked by pressing enter.
            keyboard: true,
            // @option title: String = ''
            // Text for the browser tooltip that appear on marker hover (no tooltip by default).
            // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
            title: "",
            // @option alt: String = 'Marker'
            // Text for the `alt` attribute of the icon image.
            // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
            alt: "Marker",
            // @option zIndexOffset: Number = 0
            // By default, marker images zIndex is set automatically based on its latitude. Use this option if you want to put the marker on top of all others (or below), specifying a high value like `1000` (or high negative value, respectively).
            zIndexOffset: 0,
            // @option opacity: Number = 1.0
            // The opacity of the marker.
            opacity: 1,
            // @option riseOnHover: Boolean = false
            // If `true`, the marker will get on top of others when you hover the mouse over it.
            riseOnHover: false,
            // @option riseOffset: Number = 250
            // The z-index offset used for the `riseOnHover` feature.
            riseOffset: 250,
            // @option pane: String = 'markerPane'
            // `Map pane` where the markers icon will be added.
            pane: "markerPane",
            // @option shadowPane: String = 'shadowPane'
            // `Map pane` where the markers shadow will be added.
            shadowPane: "shadowPane",
            // @option bubblingMouseEvents: Boolean = false
            // When `true`, a mouse event on this marker will trigger the same event on the map
            // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
            bubblingMouseEvents: false,
            // @option autoPanOnFocus: Boolean = true
            // When `true`, the map will pan whenever the marker is focused (via
            // e.g. pressing `tab` on the keyboard) to ensure the marker is
            // visible within the map's bounds
            autoPanOnFocus: true,
            // @section Draggable marker options
            // @option draggable: Boolean = false
            // Whether the marker is draggable with mouse/touch or not.
            draggable: false,
            // @option autoPan: Boolean = false
            // Whether to pan the map when dragging this marker near its edge or not.
            autoPan: false,
            // @option autoPanPadding: Point = Point(50, 50)
            // Distance (in pixels to the left/right and to the top/bottom) of the
            // map edge to start panning the map.
            autoPanPadding: [
                50,
                50
            ],
            // @option autoPanSpeed: Number = 10
            // Number of pixels the map should pan by.
            autoPanSpeed: 10
        },
        /* @section
  	 *
  	 * In addition to [shared layer methods](#Layer) like `addTo()` and `remove()` and [popup methods](#Popup) like bindPopup() you can also use the following methods:
  	 */ initialize: function(latlng, options) {
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
        },
        onAdd: function(map) {
            this._zoomAnimated = this._zoomAnimated && map.options.markerZoomAnimation;
            if (this._zoomAnimated) map.on("zoomanim", this._animateZoom, this);
            this._initIcon();
            this.update();
        },
        onRemove: function(map) {
            if (this.dragging && this.dragging.enabled()) {
                this.options.draggable = true;
                this.dragging.removeHooks();
            }
            delete this.dragging;
            if (this._zoomAnimated) map.off("zoomanim", this._animateZoom, this);
            this._removeIcon();
            this._removeShadow();
        },
        getEvents: function() {
            return {
                zoom: this.update,
                viewreset: this.update
            };
        },
        // @method getLatLng: LatLng
        // Returns the current geographical position of the marker.
        getLatLng: function() {
            return this._latlng;
        },
        // @method setLatLng(latlng: LatLng): this
        // Changes the marker position to the given point.
        setLatLng: function(latlng) {
            var oldLatLng = this._latlng;
            this._latlng = toLatLng(latlng);
            this.update();
            // @event move: Event
            // Fired when the marker is moved via [`setLatLng`](#marker-setlatlng) or by [dragging](#marker-dragging). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
            return this.fire("move", {
                oldLatLng: oldLatLng,
                latlng: this._latlng
            });
        },
        // @method setZIndexOffset(offset: Number): this
        // Changes the [zIndex offset](#marker-zindexoffset) of the marker.
        setZIndexOffset: function(offset) {
            this.options.zIndexOffset = offset;
            return this.update();
        },
        // @method getIcon: Icon
        // Returns the current icon used by the marker
        getIcon: function() {
            return this.options.icon;
        },
        // @method setIcon(icon: Icon): this
        // Changes the marker icon.
        setIcon: function(icon) {
            this.options.icon = icon;
            if (this._map) {
                this._initIcon();
                this.update();
            }
            if (this._popup) this.bindPopup(this._popup, this._popup.options);
            return this;
        },
        getElement: function() {
            return this._icon;
        },
        update: function() {
            if (this._icon && this._map) {
                var pos = this._map.latLngToLayerPoint(this._latlng).round();
                this._setPos(pos);
            }
            return this;
        },
        _initIcon: function() {
            var options = this.options, classToAdd = "leaflet-zoom-" + (this._zoomAnimated ? "animated" : "hide");
            var icon = options.icon.createIcon(this._icon), addIcon = false;
            // if we're not reusing the icon, remove the old one and init new one
            if (icon !== this._icon) {
                if (this._icon) this._removeIcon();
                addIcon = true;
                if (options.title) icon.title = options.title;
                if (icon.tagName === "IMG") icon.alt = options.alt || "";
            }
            addClass(icon, classToAdd);
            if (options.keyboard) {
                icon.tabIndex = "0";
                icon.setAttribute("role", "button");
            }
            this._icon = icon;
            if (options.riseOnHover) this.on({
                mouseover: this._bringToFront,
                mouseout: this._resetZIndex
            });
            if (this.options.autoPanOnFocus) on(icon, "focus", this._panOnFocus, this);
            var newShadow = options.icon.createShadow(this._shadow), addShadow = false;
            if (newShadow !== this._shadow) {
                this._removeShadow();
                addShadow = true;
            }
            if (newShadow) {
                addClass(newShadow, classToAdd);
                newShadow.alt = "";
            }
            this._shadow = newShadow;
            if (options.opacity < 1) this._updateOpacity();
            if (addIcon) this.getPane().appendChild(this._icon);
            this._initInteraction();
            if (newShadow && addShadow) this.getPane(options.shadowPane).appendChild(this._shadow);
        },
        _removeIcon: function() {
            if (this.options.riseOnHover) this.off({
                mouseover: this._bringToFront,
                mouseout: this._resetZIndex
            });
            if (this.options.autoPanOnFocus) off(this._icon, "focus", this._panOnFocus, this);
            remove(this._icon);
            this.removeInteractiveTarget(this._icon);
            this._icon = null;
        },
        _removeShadow: function() {
            if (this._shadow) remove(this._shadow);
            this._shadow = null;
        },
        _setPos: function(pos) {
            if (this._icon) setPosition(this._icon, pos);
            if (this._shadow) setPosition(this._shadow, pos);
            this._zIndex = pos.y + this.options.zIndexOffset;
            this._resetZIndex();
        },
        _updateZIndex: function(offset) {
            if (this._icon) this._icon.style.zIndex = this._zIndex + offset;
        },
        _animateZoom: function(opt) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, opt.zoom, opt.center).round();
            this._setPos(pos);
        },
        _initInteraction: function() {
            if (!this.options.interactive) return;
            addClass(this._icon, "leaflet-interactive");
            this.addInteractiveTarget(this._icon);
            if (MarkerDrag) {
                var draggable = this.options.draggable;
                if (this.dragging) {
                    draggable = this.dragging.enabled();
                    this.dragging.disable();
                }
                this.dragging = new MarkerDrag(this);
                if (draggable) this.dragging.enable();
            }
        },
        // @method setOpacity(opacity: Number): this
        // Changes the opacity of the marker.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._map) this._updateOpacity();
            return this;
        },
        _updateOpacity: function() {
            var opacity = this.options.opacity;
            if (this._icon) setOpacity(this._icon, opacity);
            if (this._shadow) setOpacity(this._shadow, opacity);
        },
        _bringToFront: function() {
            this._updateZIndex(this.options.riseOffset);
        },
        _resetZIndex: function() {
            this._updateZIndex(0);
        },
        _panOnFocus: function() {
            var map = this._map;
            if (!map) return;
            var iconOpts = this.options.icon.options;
            var size = iconOpts.iconSize ? toPoint(iconOpts.iconSize) : toPoint(0, 0);
            var anchor = iconOpts.iconAnchor ? toPoint(iconOpts.iconAnchor) : toPoint(0, 0);
            map.panInside(this._latlng, {
                paddingTopLeft: anchor,
                paddingBottomRight: size.subtract(anchor)
            });
        },
        _getPopupAnchor: function() {
            return this.options.icon.options.popupAnchor;
        },
        _getTooltipAnchor: function() {
            return this.options.icon.options.tooltipAnchor;
        }
    });
    // factory L.marker(latlng: LatLng, options? : Marker options)
    // @factory L.marker(latlng: LatLng, options? : Marker options)
    // Instantiates a Marker object given a geographical point and optionally an options object.
    function marker(latlng, options) {
        return new Marker(latlng, options);
    }
    /*
   * @class Path
   * @aka L.Path
   * @inherits Interactive layer
   *
   * An abstract class that contains options and constants shared between vector
   * overlays (Polygon, Polyline, Circle). Do not use it directly. Extends `Layer`.
   */ var Path = Layer.extend({
        // @section
        // @aka Path options
        options: {
            // @option stroke: Boolean = true
            // Whether to draw stroke along the path. Set it to `false` to disable borders on polygons or circles.
            stroke: true,
            // @option color: String = '#3388ff'
            // Stroke color
            color: "#3388ff",
            // @option weight: Number = 3
            // Stroke width in pixels
            weight: 3,
            // @option opacity: Number = 1.0
            // Stroke opacity
            opacity: 1,
            // @option lineCap: String= 'round'
            // A string that defines [shape to be used at the end](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linecap) of the stroke.
            lineCap: "round",
            // @option lineJoin: String = 'round'
            // A string that defines [shape to be used at the corners](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linejoin) of the stroke.
            lineJoin: "round",
            // @option dashArray: String = null
            // A string that defines the stroke [dash pattern](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dasharray). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
            dashArray: null,
            // @option dashOffset: String = null
            // A string that defines the [distance into the dash pattern to start the dash](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dashoffset). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
            dashOffset: null,
            // @option fill: Boolean = depends
            // Whether to fill the path with color. Set it to `false` to disable filling on polygons or circles.
            fill: false,
            // @option fillColor: String = *
            // Fill color. Defaults to the value of the [`color`](#path-color) option
            fillColor: null,
            // @option fillOpacity: Number = 0.2
            // Fill opacity.
            fillOpacity: 0.2,
            // @option fillRule: String = 'evenodd'
            // A string that defines [how the inside of a shape](https://developer.mozilla.org/docs/Web/SVG/Attribute/fill-rule) is determined.
            fillRule: "evenodd",
            // className: '',
            // Option inherited from "Interactive layer" abstract class
            interactive: true,
            // @option bubblingMouseEvents: Boolean = true
            // When `true`, a mouse event on this path will trigger the same event on the map
            // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
            bubblingMouseEvents: true
        },
        beforeAdd: function(map) {
            // Renderer is set here because we need to call renderer.getEvents
            // before this.getEvents.
            this._renderer = map.getRenderer(this);
        },
        onAdd: function() {
            this._renderer._initPath(this);
            this._reset();
            this._renderer._addPath(this);
        },
        onRemove: function() {
            this._renderer._removePath(this);
        },
        // @method redraw(): this
        // Redraws the layer. Sometimes useful after you changed the coordinates that the path uses.
        redraw: function() {
            if (this._map) this._renderer._updatePath(this);
            return this;
        },
        // @method setStyle(style: Path options): this
        // Changes the appearance of a Path based on the options in the `Path options` object.
        setStyle: function(style) {
            setOptions(this, style);
            if (this._renderer) {
                this._renderer._updateStyle(this);
                if (this.options.stroke && style && Object.prototype.hasOwnProperty.call(style, "weight")) this._updateBounds();
            }
            return this;
        },
        // @method bringToFront(): this
        // Brings the layer to the top of all path layers.
        bringToFront: function() {
            if (this._renderer) this._renderer._bringToFront(this);
            return this;
        },
        // @method bringToBack(): this
        // Brings the layer to the bottom of all path layers.
        bringToBack: function() {
            if (this._renderer) this._renderer._bringToBack(this);
            return this;
        },
        getElement: function() {
            return this._path;
        },
        _reset: function() {
            // defined in child classes
            this._project();
            this._update();
        },
        _clickTolerance: function() {
            // used when doing hit detection for Canvas layers
            return (this.options.stroke ? this.options.weight / 2 : 0) + (this._renderer.options.tolerance || 0);
        }
    });
    /*
   * @class CircleMarker
   * @aka L.CircleMarker
   * @inherits Path
   *
   * A circle of a fixed size with radius specified in pixels. Extends `Path`.
   */ var CircleMarker = Path.extend({
        // @section
        // @aka CircleMarker options
        options: {
            fill: true,
            // @option radius: Number = 10
            // Radius of the circle marker, in pixels
            radius: 10
        },
        initialize: function(latlng, options) {
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
            this._radius = this.options.radius;
        },
        // @method setLatLng(latLng: LatLng): this
        // Sets the position of a circle marker to a new location.
        setLatLng: function(latlng) {
            var oldLatLng = this._latlng;
            this._latlng = toLatLng(latlng);
            this.redraw();
            // @event move: Event
            // Fired when the marker is moved via [`setLatLng`](#circlemarker-setlatlng). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
            return this.fire("move", {
                oldLatLng: oldLatLng,
                latlng: this._latlng
            });
        },
        // @method getLatLng(): LatLng
        // Returns the current geographical position of the circle marker
        getLatLng: function() {
            return this._latlng;
        },
        // @method setRadius(radius: Number): this
        // Sets the radius of a circle marker. Units are in pixels.
        setRadius: function(radius) {
            this.options.radius = this._radius = radius;
            return this.redraw();
        },
        // @method getRadius(): Number
        // Returns the current radius of the circle
        getRadius: function() {
            return this._radius;
        },
        setStyle: function(options) {
            var radius = options && options.radius || this._radius;
            Path.prototype.setStyle.call(this, options);
            this.setRadius(radius);
            return this;
        },
        _project: function() {
            this._point = this._map.latLngToLayerPoint(this._latlng);
            this._updateBounds();
        },
        _updateBounds: function() {
            var r = this._radius, r2 = this._radiusY || r, w = this._clickTolerance(), p = [
                r + w,
                r2 + w
            ];
            this._pxBounds = new Bounds(this._point.subtract(p), this._point.add(p));
        },
        _update: function() {
            if (this._map) this._updatePath();
        },
        _updatePath: function() {
            this._renderer._updateCircle(this);
        },
        _empty: function() {
            return this._radius && !this._renderer._bounds.intersects(this._pxBounds);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p) {
            return p.distanceTo(this._point) <= this._radius + this._clickTolerance();
        }
    });
    // @factory L.circleMarker(latlng: LatLng, options?: CircleMarker options)
    // Instantiates a circle marker object given a geographical point, and an optional options object.
    function circleMarker(latlng, options) {
        return new CircleMarker(latlng, options);
    }
    /*
   * @class Circle
   * @aka L.Circle
   * @inherits CircleMarker
   *
   * A class for drawing circle overlays on a map. Extends `CircleMarker`.
   *
   * It's an approximation and starts to diverge from a real circle closer to poles (due to projection distortion).
   *
   * @example
   *
   * ```js
   * L.circle([50.5, 30.5], {radius: 200}).addTo(map);
   * ```
   */ var Circle = CircleMarker.extend({
        initialize: function(latlng, options, legacyOptions) {
            if (typeof options === "number") // Backwards compatibility with 0.7.x factory (latlng, radius, options?)
            options = extend({}, legacyOptions, {
                radius: options
            });
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
            if (isNaN(this.options.radius)) throw new Error("Circle radius cannot be NaN");
            // @section
            // @aka Circle options
            // @option radius: Number; Radius of the circle, in meters.
            this._mRadius = this.options.radius;
        },
        // @method setRadius(radius: Number): this
        // Sets the radius of a circle. Units are in meters.
        setRadius: function(radius) {
            this._mRadius = radius;
            return this.redraw();
        },
        // @method getRadius(): Number
        // Returns the current radius of a circle. Units are in meters.
        getRadius: function() {
            return this._mRadius;
        },
        // @method getBounds(): LatLngBounds
        // Returns the `LatLngBounds` of the path.
        getBounds: function() {
            var half = [
                this._radius,
                this._radiusY || this._radius
            ];
            return new LatLngBounds(this._map.layerPointToLatLng(this._point.subtract(half)), this._map.layerPointToLatLng(this._point.add(half)));
        },
        setStyle: Path.prototype.setStyle,
        _project: function() {
            var lng = this._latlng.lng, lat = this._latlng.lat, map = this._map, crs = map.options.crs;
            if (crs.distance === Earth.distance) {
                var d = Math.PI / 180, latR = this._mRadius / Earth.R / d, top = map.project([
                    lat + latR,
                    lng
                ]), bottom = map.project([
                    lat - latR,
                    lng
                ]), p = top.add(bottom).divideBy(2), lat2 = map.unproject(p).lat, lngR = Math.acos((Math.cos(latR * d) - Math.sin(lat * d) * Math.sin(lat2 * d)) / (Math.cos(lat * d) * Math.cos(lat2 * d))) / d;
                if (isNaN(lngR) || lngR === 0) lngR = latR / Math.cos(Math.PI / 180 * lat); // Fallback for edge case, #2425
                this._point = p.subtract(map.getPixelOrigin());
                this._radius = isNaN(lngR) ? 0 : p.x - map.project([
                    lat2,
                    lng - lngR
                ]).x;
                this._radiusY = p.y - top.y;
            } else {
                var latlng2 = crs.unproject(crs.project(this._latlng).subtract([
                    this._mRadius,
                    0
                ]));
                this._point = map.latLngToLayerPoint(this._latlng);
                this._radius = this._point.x - map.latLngToLayerPoint(latlng2).x;
            }
            this._updateBounds();
        }
    });
    // @factory L.circle(latlng: LatLng, options?: Circle options)
    // Instantiates a circle object given a geographical point, and an options object
    // which contains the circle radius.
    // @alternative
    // @factory L.circle(latlng: LatLng, radius: Number, options?: Circle options)
    // Obsolete way of instantiating a circle, for compatibility with 0.7.x code.
    // Do not use in new applications or plugins.
    function circle(latlng, options, legacyOptions) {
        return new Circle(latlng, options, legacyOptions);
    }
    /*
   * @class Polyline
   * @aka L.Polyline
   * @inherits Path
   *
   * A class for drawing polyline overlays on a map. Extends `Path`.
   *
   * @example
   *
   * ```js
   * // create a red polyline from an array of LatLng points
   * var latlngs = [
   * 	[45.51, -122.68],
   * 	[37.77, -122.43],
   * 	[34.04, -118.2]
   * ];
   *
   * var polyline = L.polyline(latlngs, {color: 'red'}).addTo(map);
   *
   * // zoom the map to the polyline
   * map.fitBounds(polyline.getBounds());
   * ```
   *
   * You can also pass a multi-dimensional array to represent a `MultiPolyline` shape:
   *
   * ```js
   * // create a red polyline from an array of arrays of LatLng points
   * var latlngs = [
   * 	[[45.51, -122.68],
   * 	 [37.77, -122.43],
   * 	 [34.04, -118.2]],
   * 	[[40.78, -73.91],
   * 	 [41.83, -87.62],
   * 	 [32.76, -96.72]]
   * ];
   * ```
   */ var Polyline = Path.extend({
        // @section
        // @aka Polyline options
        options: {
            // @option smoothFactor: Number = 1.0
            // How much to simplify the polyline on each zoom level. More means
            // better performance and smoother look, and less means more accurate representation.
            smoothFactor: 1.0,
            // @option noClip: Boolean = false
            // Disable polyline clipping.
            noClip: false
        },
        initialize: function(latlngs, options) {
            setOptions(this, options);
            this._setLatLngs(latlngs);
        },
        // @method getLatLngs(): LatLng[]
        // Returns an array of the points in the path, or nested arrays of points in case of multi-polyline.
        getLatLngs: function() {
            return this._latlngs;
        },
        // @method setLatLngs(latlngs: LatLng[]): this
        // Replaces all the points in the polyline with the given array of geographical points.
        setLatLngs: function(latlngs) {
            this._setLatLngs(latlngs);
            return this.redraw();
        },
        // @method isEmpty(): Boolean
        // Returns `true` if the Polyline has no LatLngs.
        isEmpty: function() {
            return !this._latlngs.length;
        },
        // @method closestLayerPoint(p: Point): Point
        // Returns the point closest to `p` on the Polyline.
        closestLayerPoint: function(p) {
            var minDistance = Infinity, minPoint = null, closest = _sqClosestPointOnSegment, p1, p2;
            for(var j = 0, jLen = this._parts.length; j < jLen; j++){
                var points = this._parts[j];
                for(var i = 1, len = points.length; i < len; i++){
                    p1 = points[i - 1];
                    p2 = points[i];
                    var sqDist = closest(p, p1, p2, true);
                    if (sqDist < minDistance) {
                        minDistance = sqDist;
                        minPoint = closest(p, p1, p2);
                    }
                }
            }
            if (minPoint) minPoint.distance = Math.sqrt(minDistance);
            return minPoint;
        },
        // @method getCenter(): LatLng
        // Returns the center ([centroid](https://en.wikipedia.org/wiki/Centroid)) of the polyline.
        getCenter: function() {
            // throws error when not yet added to map as this center calculation requires projected coordinates
            if (!this._map) throw new Error("Must add layer to map before using getCenter()");
            return polylineCenter(this._defaultShape(), this._map.options.crs);
        },
        // @method getBounds(): LatLngBounds
        // Returns the `LatLngBounds` of the path.
        getBounds: function() {
            return this._bounds;
        },
        // @method addLatLng(latlng: LatLng, latlngs?: LatLng[]): this
        // Adds a given point to the polyline. By default, adds to the first ring of
        // the polyline in case of a multi-polyline, but can be overridden by passing
        // a specific ring as a LatLng array (that you can earlier access with [`getLatLngs`](#polyline-getlatlngs)).
        addLatLng: function(latlng, latlngs) {
            latlngs = latlngs || this._defaultShape();
            latlng = toLatLng(latlng);
            latlngs.push(latlng);
            this._bounds.extend(latlng);
            return this.redraw();
        },
        _setLatLngs: function(latlngs) {
            this._bounds = new LatLngBounds();
            this._latlngs = this._convertLatLngs(latlngs);
        },
        _defaultShape: function() {
            return isFlat(this._latlngs) ? this._latlngs : this._latlngs[0];
        },
        // recursively convert latlngs input into actual LatLng instances; calculate bounds along the way
        _convertLatLngs: function(latlngs) {
            var result = [], flat = isFlat(latlngs);
            for(var i = 0, len = latlngs.length; i < len; i++)if (flat) {
                result[i] = toLatLng(latlngs[i]);
                this._bounds.extend(result[i]);
            } else result[i] = this._convertLatLngs(latlngs[i]);
            return result;
        },
        _project: function() {
            var pxBounds = new Bounds();
            this._rings = [];
            this._projectLatlngs(this._latlngs, this._rings, pxBounds);
            if (this._bounds.isValid() && pxBounds.isValid()) {
                this._rawPxBounds = pxBounds;
                this._updateBounds();
            }
        },
        _updateBounds: function() {
            var w = this._clickTolerance(), p = new Point(w, w);
            if (!this._rawPxBounds) return;
            this._pxBounds = new Bounds([
                this._rawPxBounds.min.subtract(p),
                this._rawPxBounds.max.add(p)
            ]);
        },
        // recursively turns latlngs into a set of rings with projected coordinates
        _projectLatlngs: function(latlngs, result, projectedBounds) {
            var flat = latlngs[0] instanceof LatLng, len = latlngs.length, i, ring;
            if (flat) {
                ring = [];
                for(i = 0; i < len; i++){
                    ring[i] = this._map.latLngToLayerPoint(latlngs[i]);
                    projectedBounds.extend(ring[i]);
                }
                result.push(ring);
            } else for(i = 0; i < len; i++)this._projectLatlngs(latlngs[i], result, projectedBounds);
        },
        // clip polyline by renderer bounds so that we have less to render for performance
        _clipPoints: function() {
            var bounds = this._renderer._bounds;
            this._parts = [];
            if (!this._pxBounds || !this._pxBounds.intersects(bounds)) return;
            if (this.options.noClip) {
                this._parts = this._rings;
                return;
            }
            var parts = this._parts, i, j, k, len, len2, segment, points;
            for(i = 0, k = 0, len = this._rings.length; i < len; i++){
                points = this._rings[i];
                for(j = 0, len2 = points.length; j < len2 - 1; j++){
                    segment = clipSegment(points[j], points[j + 1], bounds, j, true);
                    if (!segment) continue;
                    parts[k] = parts[k] || [];
                    parts[k].push(segment[0]);
                    // if segment goes out of screen, or it's the last one, it's the end of the line part
                    if (segment[1] !== points[j + 1] || j === len2 - 2) {
                        parts[k].push(segment[1]);
                        k++;
                    }
                }
            }
        },
        // simplify each clipped part of the polyline for performance
        _simplifyPoints: function() {
            var parts = this._parts, tolerance = this.options.smoothFactor;
            for(var i = 0, len = parts.length; i < len; i++)parts[i] = simplify(parts[i], tolerance);
        },
        _update: function() {
            if (!this._map) return;
            this._clipPoints();
            this._simplifyPoints();
            this._updatePath();
        },
        _updatePath: function() {
            this._renderer._updatePoly(this);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p, closed) {
            var i, j, k, len, len2, part, w = this._clickTolerance();
            if (!this._pxBounds || !this._pxBounds.contains(p)) return false;
            // hit detection for polylines
            for(i = 0, len = this._parts.length; i < len; i++){
                part = this._parts[i];
                for(j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++){
                    if (!closed && j === 0) continue;
                    if (pointToSegmentDistance(p, part[k], part[j]) <= w) return true;
                }
            }
            return false;
        }
    });
    // @factory L.polyline(latlngs: LatLng[], options?: Polyline options)
    // Instantiates a polyline object given an array of geographical points and
    // optionally an options object. You can create a `Polyline` object with
    // multiple separate lines (`MultiPolyline`) by passing an array of arrays
    // of geographic points.
    function polyline(latlngs, options) {
        return new Polyline(latlngs, options);
    }
    // Retrocompat. Allow plugins to support Leaflet versions before and after 1.1.
    Polyline._flat = _flat;
    /*
   * @class Polygon
   * @aka L.Polygon
   * @inherits Polyline
   *
   * A class for drawing polygon overlays on a map. Extends `Polyline`.
   *
   * Note that points you pass when creating a polygon shouldn't have an additional last point equal to the first one — it's better to filter out such points.
   *
   *
   * @example
   *
   * ```js
   * // create a red polygon from an array of LatLng points
   * var latlngs = [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]];
   *
   * var polygon = L.polygon(latlngs, {color: 'red'}).addTo(map);
   *
   * // zoom the map to the polygon
   * map.fitBounds(polygon.getBounds());
   * ```
   *
   * You can also pass an array of arrays of latlngs, with the first array representing the outer shape and the other arrays representing holes in the outer shape:
   *
   * ```js
   * var latlngs = [
   *   [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
   *   [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
   * ];
   * ```
   *
   * Additionally, you can pass a multi-dimensional array to represent a MultiPolygon shape.
   *
   * ```js
   * var latlngs = [
   *   [ // first polygon
   *     [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
   *     [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
   *   ],
   *   [ // second polygon
   *     [[41, -111.03],[45, -111.04],[45, -104.05],[41, -104.05]]
   *   ]
   * ];
   * ```
   */ var Polygon = Polyline.extend({
        options: {
            fill: true
        },
        isEmpty: function() {
            return !this._latlngs.length || !this._latlngs[0].length;
        },
        // @method getCenter(): LatLng
        // Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the Polygon.
        getCenter: function() {
            // throws error when not yet added to map as this center calculation requires projected coordinates
            if (!this._map) throw new Error("Must add layer to map before using getCenter()");
            return polygonCenter(this._defaultShape(), this._map.options.crs);
        },
        _convertLatLngs: function(latlngs) {
            var result = Polyline.prototype._convertLatLngs.call(this, latlngs), len = result.length;
            // remove last point if it equals first one
            if (len >= 2 && result[0] instanceof LatLng && result[0].equals(result[len - 1])) result.pop();
            return result;
        },
        _setLatLngs: function(latlngs) {
            Polyline.prototype._setLatLngs.call(this, latlngs);
            if (isFlat(this._latlngs)) this._latlngs = [
                this._latlngs
            ];
        },
        _defaultShape: function() {
            return isFlat(this._latlngs[0]) ? this._latlngs[0] : this._latlngs[0][0];
        },
        _clipPoints: function() {
            // polygons need a different clipping algorithm so we redefine that
            var bounds = this._renderer._bounds, w = this.options.weight, p = new Point(w, w);
            // increase clip padding by stroke width to avoid stroke on clip edges
            bounds = new Bounds(bounds.min.subtract(p), bounds.max.add(p));
            this._parts = [];
            if (!this._pxBounds || !this._pxBounds.intersects(bounds)) return;
            if (this.options.noClip) {
                this._parts = this._rings;
                return;
            }
            for(var i = 0, len = this._rings.length, clipped; i < len; i++){
                clipped = clipPolygon(this._rings[i], bounds, true);
                if (clipped.length) this._parts.push(clipped);
            }
        },
        _updatePath: function() {
            this._renderer._updatePoly(this, true);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p) {
            var inside = false, part, p1, p2, i, j, k, len, len2;
            if (!this._pxBounds || !this._pxBounds.contains(p)) return false;
            // ray casting algorithm for detecting if point is in polygon
            for(i = 0, len = this._parts.length; i < len; i++){
                part = this._parts[i];
                for(j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++){
                    p1 = part[j];
                    p2 = part[k];
                    if (p1.y > p.y !== p2.y > p.y && p.x < (p2.x - p1.x) * (p.y - p1.y) / (p2.y - p1.y) + p1.x) inside = !inside;
                }
            }
            // also check if it's on polygon stroke
            return inside || Polyline.prototype._containsPoint.call(this, p, true);
        }
    });
    // @factory L.polygon(latlngs: LatLng[], options?: Polyline options)
    function polygon(latlngs, options) {
        return new Polygon(latlngs, options);
    }
    /*
   * @class GeoJSON
   * @aka L.GeoJSON
   * @inherits FeatureGroup
   *
   * Represents a GeoJSON object or an array of GeoJSON objects. Allows you to parse
   * GeoJSON data and display it on the map. Extends `FeatureGroup`.
   *
   * @example
   *
   * ```js
   * L.geoJSON(data, {
   * 	style: function (feature) {
   * 		return {color: feature.properties.color};
   * 	}
   * }).bindPopup(function (layer) {
   * 	return layer.feature.properties.description;
   * }).addTo(map);
   * ```
   */ var GeoJSON = FeatureGroup.extend({
        /* @section
  	 * @aka GeoJSON options
  	 *
  	 * @option pointToLayer: Function = *
  	 * A `Function` defining how GeoJSON points spawn Leaflet layers. It is internally
  	 * called when data is added, passing the GeoJSON point feature and its `LatLng`.
  	 * The default is to spawn a default `Marker`:
  	 * ```js
  	 * function(geoJsonPoint, latlng) {
  	 * 	return L.marker(latlng);
  	 * }
  	 * ```
  	 *
  	 * @option style: Function = *
  	 * A `Function` defining the `Path options` for styling GeoJSON lines and polygons,
  	 * called internally when data is added.
  	 * The default value is to not override any defaults:
  	 * ```js
  	 * function (geoJsonFeature) {
  	 * 	return {}
  	 * }
  	 * ```
  	 *
  	 * @option onEachFeature: Function = *
  	 * A `Function` that will be called once for each created `Feature`, after it has
  	 * been created and styled. Useful for attaching events and popups to features.
  	 * The default is to do nothing with the newly created layers:
  	 * ```js
  	 * function (feature, layer) {}
  	 * ```
  	 *
  	 * @option filter: Function = *
  	 * A `Function` that will be used to decide whether to include a feature or not.
  	 * The default is to include all features:
  	 * ```js
  	 * function (geoJsonFeature) {
  	 * 	return true;
  	 * }
  	 * ```
  	 * Note: dynamically changing the `filter` option will have effect only on newly
  	 * added data. It will _not_ re-evaluate already included features.
  	 *
  	 * @option coordsToLatLng: Function = *
  	 * A `Function` that will be used for converting GeoJSON coordinates to `LatLng`s.
  	 * The default is the `coordsToLatLng` static method.
  	 *
  	 * @option markersInheritOptions: Boolean = false
  	 * Whether default Markers for "Point" type Features inherit from group options.
  	 */ initialize: function(geojson, options) {
            setOptions(this, options);
            this._layers = {};
            if (geojson) this.addData(geojson);
        },
        // @method addData( <GeoJSON> data ): this
        // Adds a GeoJSON object to the layer.
        addData: function(geojson) {
            var features = isArray(geojson) ? geojson : geojson.features, i, len, feature;
            if (features) {
                for(i = 0, len = features.length; i < len; i++){
                    // only add this if geometry or geometries are set and not null
                    feature = features[i];
                    if (feature.geometries || feature.geometry || feature.features || feature.coordinates) this.addData(feature);
                }
                return this;
            }
            var options = this.options;
            if (options.filter && !options.filter(geojson)) return this;
            var layer = geometryToLayer(geojson, options);
            if (!layer) return this;
            layer.feature = asFeature(geojson);
            layer.defaultOptions = layer.options;
            this.resetStyle(layer);
            if (options.onEachFeature) options.onEachFeature(geojson, layer);
            return this.addLayer(layer);
        },
        // @method resetStyle( <Path> layer? ): this
        // Resets the given vector layer's style to the original GeoJSON style, useful for resetting style after hover events.
        // If `layer` is omitted, the style of all features in the current layer is reset.
        resetStyle: function(layer) {
            if (layer === undefined) return this.eachLayer(this.resetStyle, this);
            // reset any custom styles
            layer.options = extend({}, layer.defaultOptions);
            this._setLayerStyle(layer, this.options.style);
            return this;
        },
        // @method setStyle( <Function> style ): this
        // Changes styles of GeoJSON vector layers with the given style function.
        setStyle: function(style) {
            return this.eachLayer(function(layer) {
                this._setLayerStyle(layer, style);
            }, this);
        },
        _setLayerStyle: function(layer, style) {
            if (layer.setStyle) {
                if (typeof style === "function") style = style(layer.feature);
                layer.setStyle(style);
            }
        }
    });
    // @section
    // There are several static functions which can be called without instantiating L.GeoJSON:
    // @function geometryToLayer(featureData: Object, options?: GeoJSON options): Layer
    // Creates a `Layer` from a given GeoJSON feature. Can use a custom
    // [`pointToLayer`](#geojson-pointtolayer) and/or [`coordsToLatLng`](#geojson-coordstolatlng)
    // functions if provided as options.
    function geometryToLayer(geojson, options) {
        var geometry = geojson.type === "Feature" ? geojson.geometry : geojson, coords = geometry ? geometry.coordinates : null, layers = [], pointToLayer = options && options.pointToLayer, _coordsToLatLng = options && options.coordsToLatLng || coordsToLatLng, latlng, latlngs, i, len;
        if (!coords && !geometry) return null;
        switch(geometry.type){
            case "Point":
                latlng = _coordsToLatLng(coords);
                return _pointToLayer(pointToLayer, geojson, latlng, options);
            case "MultiPoint":
                for(i = 0, len = coords.length; i < len; i++){
                    latlng = _coordsToLatLng(coords[i]);
                    layers.push(_pointToLayer(pointToLayer, geojson, latlng, options));
                }
                return new FeatureGroup(layers);
            case "LineString":
            case "MultiLineString":
                latlngs = coordsToLatLngs(coords, geometry.type === "LineString" ? 0 : 1, _coordsToLatLng);
                return new Polyline(latlngs, options);
            case "Polygon":
            case "MultiPolygon":
                latlngs = coordsToLatLngs(coords, geometry.type === "Polygon" ? 1 : 2, _coordsToLatLng);
                return new Polygon(latlngs, options);
            case "GeometryCollection":
                for(i = 0, len = geometry.geometries.length; i < len; i++){
                    var geoLayer = geometryToLayer({
                        geometry: geometry.geometries[i],
                        type: "Feature",
                        properties: geojson.properties
                    }, options);
                    if (geoLayer) layers.push(geoLayer);
                }
                return new FeatureGroup(layers);
            case "FeatureCollection":
                for(i = 0, len = geometry.features.length; i < len; i++){
                    var featureLayer = geometryToLayer(geometry.features[i], options);
                    if (featureLayer) layers.push(featureLayer);
                }
                return new FeatureGroup(layers);
            default:
                throw new Error("Invalid GeoJSON object.");
        }
    }
    function _pointToLayer(pointToLayerFn, geojson, latlng, options) {
        return pointToLayerFn ? pointToLayerFn(geojson, latlng) : new Marker(latlng, options && options.markersInheritOptions && options);
    }
    // @function coordsToLatLng(coords: Array): LatLng
    // Creates a `LatLng` object from an array of 2 numbers (longitude, latitude)
    // or 3 numbers (longitude, latitude, altitude) used in GeoJSON for points.
    function coordsToLatLng(coords) {
        return new LatLng(coords[1], coords[0], coords[2]);
    }
    // @function coordsToLatLngs(coords: Array, levelsDeep?: Number, coordsToLatLng?: Function): Array
    // Creates a multidimensional array of `LatLng`s from a GeoJSON coordinates array.
    // `levelsDeep` specifies the nesting level (0 is for an array of points, 1 for an array of arrays of points, etc., 0 by default).
    // Can use a custom [`coordsToLatLng`](#geojson-coordstolatlng) function.
    function coordsToLatLngs(coords, levelsDeep, _coordsToLatLng) {
        var latlngs = [];
        for(var i = 0, len = coords.length, latlng; i < len; i++){
            latlng = levelsDeep ? coordsToLatLngs(coords[i], levelsDeep - 1, _coordsToLatLng) : (_coordsToLatLng || coordsToLatLng)(coords[i]);
            latlngs.push(latlng);
        }
        return latlngs;
    }
    // @function latLngToCoords(latlng: LatLng, precision?: Number|false): Array
    // Reverse of [`coordsToLatLng`](#geojson-coordstolatlng)
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function.
    function latLngToCoords(latlng, precision) {
        latlng = toLatLng(latlng);
        return latlng.alt !== undefined ? [
            formatNum(latlng.lng, precision),
            formatNum(latlng.lat, precision),
            formatNum(latlng.alt, precision)
        ] : [
            formatNum(latlng.lng, precision),
            formatNum(latlng.lat, precision)
        ];
    }
    // @function latLngsToCoords(latlngs: Array, levelsDeep?: Number, closed?: Boolean, precision?: Number|false): Array
    // Reverse of [`coordsToLatLngs`](#geojson-coordstolatlngs)
    // `closed` determines whether the first point should be appended to the end of the array to close the feature, only used when `levelsDeep` is 0. False by default.
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function.
    function latLngsToCoords(latlngs, levelsDeep, closed, precision) {
        var coords = [];
        for(var i = 0, len = latlngs.length; i < len; i++)// Check for flat arrays required to ensure unbalanced arrays are correctly converted in recursion
        coords.push(levelsDeep ? latLngsToCoords(latlngs[i], isFlat(latlngs[i]) ? 0 : levelsDeep - 1, closed, precision) : latLngToCoords(latlngs[i], precision));
        if (!levelsDeep && closed && coords.length > 0) coords.push(coords[0].slice());
        return coords;
    }
    function getFeature(layer, newGeometry) {
        return layer.feature ? extend({}, layer.feature, {
            geometry: newGeometry
        }) : asFeature(newGeometry);
    }
    // @function asFeature(geojson: Object): Object
    // Normalize GeoJSON geometries/features into GeoJSON features.
    function asFeature(geojson) {
        if (geojson.type === "Feature" || geojson.type === "FeatureCollection") return geojson;
        return {
            type: "Feature",
            properties: {},
            geometry: geojson
        };
    }
    var PointToGeoJSON = {
        toGeoJSON: function(precision) {
            return getFeature(this, {
                type: "Point",
                coordinates: latLngToCoords(this.getLatLng(), precision)
            });
        }
    };
    // @namespace Marker
    // @section Other methods
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the marker (as a GeoJSON `Point` Feature).
    Marker.include(PointToGeoJSON);
    // @namespace CircleMarker
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the circle marker (as a GeoJSON `Point` Feature).
    Circle.include(PointToGeoJSON);
    CircleMarker.include(PointToGeoJSON);
    // @namespace Polyline
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the polyline (as a GeoJSON `LineString` or `MultiLineString` Feature).
    Polyline.include({
        toGeoJSON: function(precision) {
            var multi = !isFlat(this._latlngs);
            var coords = latLngsToCoords(this._latlngs, multi ? 1 : 0, false, precision);
            return getFeature(this, {
                type: (multi ? "Multi" : "") + "LineString",
                coordinates: coords
            });
        }
    });
    // @namespace Polygon
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the polygon (as a GeoJSON `Polygon` or `MultiPolygon` Feature).
    Polygon.include({
        toGeoJSON: function(precision) {
            var holes = !isFlat(this._latlngs), multi = holes && !isFlat(this._latlngs[0]);
            var coords = latLngsToCoords(this._latlngs, multi ? 2 : holes ? 1 : 0, true, precision);
            if (!holes) coords = [
                coords
            ];
            return getFeature(this, {
                type: (multi ? "Multi" : "") + "Polygon",
                coordinates: coords
            });
        }
    });
    // @namespace LayerGroup
    LayerGroup.include({
        toMultiPoint: function(precision) {
            var coords = [];
            this.eachLayer(function(layer) {
                coords.push(layer.toGeoJSON(precision).geometry.coordinates);
            });
            return getFeature(this, {
                type: "MultiPoint",
                coordinates: coords
            });
        },
        // @method toGeoJSON(precision?: Number|false): Object
        // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
        // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the layer group (as a GeoJSON `FeatureCollection`, `GeometryCollection`, or `MultiPoint`).
        toGeoJSON: function(precision) {
            var type = this.feature && this.feature.geometry && this.feature.geometry.type;
            if (type === "MultiPoint") return this.toMultiPoint(precision);
            var isGeometryCollection = type === "GeometryCollection", jsons = [];
            this.eachLayer(function(layer) {
                if (layer.toGeoJSON) {
                    var json = layer.toGeoJSON(precision);
                    if (isGeometryCollection) jsons.push(json.geometry);
                    else {
                        var feature = asFeature(json);
                        // Squash nested feature collections
                        if (feature.type === "FeatureCollection") jsons.push.apply(jsons, feature.features);
                        else jsons.push(feature);
                    }
                }
            });
            if (isGeometryCollection) return getFeature(this, {
                geometries: jsons,
                type: "GeometryCollection"
            });
            return {
                type: "FeatureCollection",
                features: jsons
            };
        }
    });
    // @namespace GeoJSON
    // @factory L.geoJSON(geojson?: Object, options?: GeoJSON options)
    // Creates a GeoJSON layer. Optionally accepts an object in
    // [GeoJSON format](https://tools.ietf.org/html/rfc7946) to display on the map
    // (you can alternatively add it later with `addData` method) and an `options` object.
    function geoJSON(geojson, options) {
        return new GeoJSON(geojson, options);
    }
    // Backward compatibility.
    var geoJson = geoJSON;
    /*
   * @class ImageOverlay
   * @aka L.ImageOverlay
   * @inherits Interactive layer
   *
   * Used to load and display a single image over specific bounds of the map. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * var imageUrl = 'https://maps.lib.utexas.edu/maps/historical/newark_nj_1922.jpg',
   * 	imageBounds = [[40.712216, -74.22655], [40.773941, -74.12544]];
   * L.imageOverlay(imageUrl, imageBounds).addTo(map);
   * ```
   */ var ImageOverlay = Layer.extend({
        // @section
        // @aka ImageOverlay options
        options: {
            // @option opacity: Number = 1.0
            // The opacity of the image overlay.
            opacity: 1,
            // @option alt: String = ''
            // Text for the `alt` attribute of the image (useful for accessibility).
            alt: "",
            // @option interactive: Boolean = false
            // If `true`, the image overlay will emit [mouse events](#interactive-layer) when clicked or hovered.
            interactive: false,
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the image.
            // If a String is provided, the image will have its crossOrigin attribute set to the String provided. This is needed if you want to access image pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false,
            // @option errorOverlayUrl: String = ''
            // URL to the overlay image to show in place of the overlay that failed to load.
            errorOverlayUrl: "",
            // @option zIndex: Number = 1
            // The explicit [zIndex](https://developer.mozilla.org/docs/Web/CSS/CSS_Positioning/Understanding_z_index) of the overlay layer.
            zIndex: 1,
            // @option className: String = ''
            // A custom class name to assign to the image. Empty by default.
            className: ""
        },
        initialize: function(url, bounds, options) {
            this._url = url;
            this._bounds = toLatLngBounds(bounds);
            setOptions(this, options);
        },
        onAdd: function() {
            if (!this._image) {
                this._initImage();
                if (this.options.opacity < 1) this._updateOpacity();
            }
            if (this.options.interactive) {
                addClass(this._image, "leaflet-interactive");
                this.addInteractiveTarget(this._image);
            }
            this.getPane().appendChild(this._image);
            this._reset();
        },
        onRemove: function() {
            remove(this._image);
            if (this.options.interactive) this.removeInteractiveTarget(this._image);
        },
        // @method setOpacity(opacity: Number): this
        // Sets the opacity of the overlay.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._image) this._updateOpacity();
            return this;
        },
        setStyle: function(styleOpts) {
            if (styleOpts.opacity) this.setOpacity(styleOpts.opacity);
            return this;
        },
        // @method bringToFront(): this
        // Brings the layer to the top of all overlays.
        bringToFront: function() {
            if (this._map) toFront(this._image);
            return this;
        },
        // @method bringToBack(): this
        // Brings the layer to the bottom of all overlays.
        bringToBack: function() {
            if (this._map) toBack(this._image);
            return this;
        },
        // @method setUrl(url: String): this
        // Changes the URL of the image.
        setUrl: function(url) {
            this._url = url;
            if (this._image) this._image.src = url;
            return this;
        },
        // @method setBounds(bounds: LatLngBounds): this
        // Update the bounds that this ImageOverlay covers
        setBounds: function(bounds) {
            this._bounds = toLatLngBounds(bounds);
            if (this._map) this._reset();
            return this;
        },
        getEvents: function() {
            var events = {
                zoom: this._reset,
                viewreset: this._reset
            };
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @method setZIndex(value: Number): this
        // Changes the [zIndex](#imageoverlay-zindex) of the image overlay.
        setZIndex: function(value) {
            this.options.zIndex = value;
            this._updateZIndex();
            return this;
        },
        // @method getBounds(): LatLngBounds
        // Get the bounds that this ImageOverlay covers
        getBounds: function() {
            return this._bounds;
        },
        // @method getElement(): HTMLElement
        // Returns the instance of [`HTMLImageElement`](https://developer.mozilla.org/docs/Web/API/HTMLImageElement)
        // used by this overlay.
        getElement: function() {
            return this._image;
        },
        _initImage: function() {
            var wasElementSupplied = this._url.tagName === "IMG";
            var img = this._image = wasElementSupplied ? this._url : create$1("img");
            addClass(img, "leaflet-image-layer");
            if (this._zoomAnimated) addClass(img, "leaflet-zoom-animated");
            if (this.options.className) addClass(img, this.options.className);
            img.onselectstart = falseFn;
            img.onmousemove = falseFn;
            // @event load: Event
            // Fired when the ImageOverlay layer has loaded its image
            img.onload = bind(this.fire, this, "load");
            img.onerror = bind(this._overlayOnError, this, "error");
            if (this.options.crossOrigin || this.options.crossOrigin === "") img.crossOrigin = this.options.crossOrigin === true ? "" : this.options.crossOrigin;
            if (this.options.zIndex) this._updateZIndex();
            if (wasElementSupplied) {
                this._url = img.src;
                return;
            }
            img.src = this._url;
            img.alt = this.options.alt;
        },
        _animateZoom: function(e) {
            var scale = this._map.getZoomScale(e.zoom), offset = this._map._latLngBoundsToNewLayerBounds(this._bounds, e.zoom, e.center).min;
            setTransform(this._image, offset, scale);
        },
        _reset: function() {
            var image = this._image, bounds = new Bounds(this._map.latLngToLayerPoint(this._bounds.getNorthWest()), this._map.latLngToLayerPoint(this._bounds.getSouthEast())), size = bounds.getSize();
            setPosition(image, bounds.min);
            image.style.width = size.x + "px";
            image.style.height = size.y + "px";
        },
        _updateOpacity: function() {
            setOpacity(this._image, this.options.opacity);
        },
        _updateZIndex: function() {
            if (this._image && this.options.zIndex !== undefined && this.options.zIndex !== null) this._image.style.zIndex = this.options.zIndex;
        },
        _overlayOnError: function() {
            // @event error: Event
            // Fired when the ImageOverlay layer fails to load its image
            this.fire("error");
            var errorUrl = this.options.errorOverlayUrl;
            if (errorUrl && this._url !== errorUrl) {
                this._url = errorUrl;
                this._image.src = errorUrl;
            }
        },
        // @method getCenter(): LatLng
        // Returns the center of the ImageOverlay.
        getCenter: function() {
            return this._bounds.getCenter();
        }
    });
    // @factory L.imageOverlay(imageUrl: String, bounds: LatLngBounds, options?: ImageOverlay options)
    // Instantiates an image overlay object given the URL of the image and the
    // geographical bounds it is tied to.
    var imageOverlay = function(url, bounds, options) {
        return new ImageOverlay(url, bounds, options);
    };
    /*
   * @class VideoOverlay
   * @aka L.VideoOverlay
   * @inherits ImageOverlay
   *
   * Used to load and display a video player over specific bounds of the map. Extends `ImageOverlay`.
   *
   * A video overlay uses the [`<video>`](https://developer.mozilla.org/docs/Web/HTML/Element/video)
   * HTML5 element.
   *
   * @example
   *
   * ```js
   * var videoUrl = 'https://www.mapbox.com/bites/00188/patricia_nasa.webm',
   * 	videoBounds = [[ 32, -130], [ 13, -100]];
   * L.videoOverlay(videoUrl, videoBounds ).addTo(map);
   * ```
   */ var VideoOverlay = ImageOverlay.extend({
        // @section
        // @aka VideoOverlay options
        options: {
            // @option autoplay: Boolean = true
            // Whether the video starts playing automatically when loaded.
            // On some browsers autoplay will only work with `muted: true`
            autoplay: true,
            // @option loop: Boolean = true
            // Whether the video will loop back to the beginning when played.
            loop: true,
            // @option keepAspectRatio: Boolean = true
            // Whether the video will save aspect ratio after the projection.
            // Relevant for supported browsers. See [browser compatibility](https://developer.mozilla.org/en-US/docs/Web/CSS/object-fit)
            keepAspectRatio: true,
            // @option muted: Boolean = false
            // Whether the video starts on mute when loaded.
            muted: false,
            // @option playsInline: Boolean = true
            // Mobile browsers will play the video right where it is instead of open it up in fullscreen mode.
            playsInline: true
        },
        _initImage: function() {
            var wasElementSupplied = this._url.tagName === "VIDEO";
            var vid = this._image = wasElementSupplied ? this._url : create$1("video");
            addClass(vid, "leaflet-image-layer");
            if (this._zoomAnimated) addClass(vid, "leaflet-zoom-animated");
            if (this.options.className) addClass(vid, this.options.className);
            vid.onselectstart = falseFn;
            vid.onmousemove = falseFn;
            // @event load: Event
            // Fired when the video has finished loading the first frame
            vid.onloadeddata = bind(this.fire, this, "load");
            if (wasElementSupplied) {
                var sourceElements = vid.getElementsByTagName("source");
                var sources = [];
                for(var j = 0; j < sourceElements.length; j++)sources.push(sourceElements[j].src);
                this._url = sourceElements.length > 0 ? sources : [
                    vid.src
                ];
                return;
            }
            if (!isArray(this._url)) this._url = [
                this._url
            ];
            if (!this.options.keepAspectRatio && Object.prototype.hasOwnProperty.call(vid.style, "objectFit")) vid.style["objectFit"] = "fill";
            vid.autoplay = !!this.options.autoplay;
            vid.loop = !!this.options.loop;
            vid.muted = !!this.options.muted;
            vid.playsInline = !!this.options.playsInline;
            for(var i = 0; i < this._url.length; i++){
                var source = create$1("source");
                source.src = this._url[i];
                vid.appendChild(source);
            }
        }
    });
    // @factory L.videoOverlay(video: String|Array|HTMLVideoElement, bounds: LatLngBounds, options?: VideoOverlay options)
    // Instantiates an image overlay object given the URL of the video (or array of URLs, or even a video element) and the
    // geographical bounds it is tied to.
    function videoOverlay(video, bounds, options) {
        return new VideoOverlay(video, bounds, options);
    }
    /*
   * @class SVGOverlay
   * @aka L.SVGOverlay
   * @inherits ImageOverlay
   *
   * Used to load, display and provide DOM access to an SVG file over specific bounds of the map. Extends `ImageOverlay`.
   *
   * An SVG overlay uses the [`<svg>`](https://developer.mozilla.org/docs/Web/SVG/Element/svg) element.
   *
   * @example
   *
   * ```js
   * var svgElement = document.createElementNS("http://www.w3.org/2000/svg", "svg");
   * svgElement.setAttribute('xmlns', "http://www.w3.org/2000/svg");
   * svgElement.setAttribute('viewBox', "0 0 200 200");
   * svgElement.innerHTML = '<rect width="200" height="200"/><rect x="75" y="23" width="50" height="50" style="fill:red"/><rect x="75" y="123" width="50" height="50" style="fill:#0013ff"/>';
   * var svgElementBounds = [ [ 32, -130 ], [ 13, -100 ] ];
   * L.svgOverlay(svgElement, svgElementBounds).addTo(map);
   * ```
   */ var SVGOverlay = ImageOverlay.extend({
        _initImage: function() {
            var el = this._image = this._url;
            addClass(el, "leaflet-image-layer");
            if (this._zoomAnimated) addClass(el, "leaflet-zoom-animated");
            if (this.options.className) addClass(el, this.options.className);
            el.onselectstart = falseFn;
            el.onmousemove = falseFn;
        }
    });
    // @factory L.svgOverlay(svg: String|SVGElement, bounds: LatLngBounds, options?: SVGOverlay options)
    // Instantiates an image overlay object given an SVG element and the geographical bounds it is tied to.
    // A viewBox attribute is required on the SVG element to zoom in and out properly.
    function svgOverlay(el, bounds, options) {
        return new SVGOverlay(el, bounds, options);
    }
    /*
   * @class DivOverlay
   * @inherits Interactive layer
   * @aka L.DivOverlay
   * Base model for L.Popup and L.Tooltip. Inherit from it for custom overlays like plugins.
   */ // @namespace DivOverlay
    var DivOverlay = Layer.extend({
        // @section
        // @aka DivOverlay options
        options: {
            // @option interactive: Boolean = false
            // If true, the popup/tooltip will listen to the mouse events.
            interactive: false,
            // @option offset: Point = Point(0, 0)
            // The offset of the overlay position.
            offset: [
                0,
                0
            ],
            // @option className: String = ''
            // A custom CSS class name to assign to the overlay.
            className: "",
            // @option pane: String = undefined
            // `Map pane` where the overlay will be added.
            pane: undefined,
            // @option content: String|HTMLElement|Function = ''
            // Sets the HTML content of the overlay while initializing. If a function is passed the source layer will be
            // passed to the function. The function should return a `String` or `HTMLElement` to be used in the overlay.
            content: ""
        },
        initialize: function(options, source) {
            if (options && (options instanceof LatLng || isArray(options))) {
                this._latlng = toLatLng(options);
                setOptions(this, source);
            } else {
                setOptions(this, options);
                this._source = source;
            }
            if (this.options.content) this._content = this.options.content;
        },
        // @method openOn(map: Map): this
        // Adds the overlay to the map.
        // Alternative to `map.openPopup(popup)`/`.openTooltip(tooltip)`.
        openOn: function(map) {
            map = arguments.length ? map : this._source._map; // experimental, not the part of public api
            if (!map.hasLayer(this)) map.addLayer(this);
            return this;
        },
        // @method close(): this
        // Closes the overlay.
        // Alternative to `map.closePopup(popup)`/`.closeTooltip(tooltip)`
        // and `layer.closePopup()`/`.closeTooltip()`.
        close: function() {
            if (this._map) this._map.removeLayer(this);
            return this;
        },
        // @method toggle(layer?: Layer): this
        // Opens or closes the overlay bound to layer depending on its current state.
        // Argument may be omitted only for overlay bound to layer.
        // Alternative to `layer.togglePopup()`/`.toggleTooltip()`.
        toggle: function(layer) {
            if (this._map) this.close();
            else {
                if (arguments.length) this._source = layer;
                else layer = this._source;
                this._prepareOpen();
                // open the overlay on the map
                this.openOn(layer._map);
            }
            return this;
        },
        onAdd: function(map) {
            this._zoomAnimated = map._zoomAnimated;
            if (!this._container) this._initLayout();
            if (map._fadeAnimated) setOpacity(this._container, 0);
            clearTimeout(this._removeTimeout);
            this.getPane().appendChild(this._container);
            this.update();
            if (map._fadeAnimated) setOpacity(this._container, 1);
            this.bringToFront();
            if (this.options.interactive) {
                addClass(this._container, "leaflet-interactive");
                this.addInteractiveTarget(this._container);
            }
        },
        onRemove: function(map) {
            if (map._fadeAnimated) {
                setOpacity(this._container, 0);
                this._removeTimeout = setTimeout(bind(remove, undefined, this._container), 200);
            } else remove(this._container);
            if (this.options.interactive) {
                removeClass(this._container, "leaflet-interactive");
                this.removeInteractiveTarget(this._container);
            }
        },
        // @namespace DivOverlay
        // @method getLatLng: LatLng
        // Returns the geographical point of the overlay.
        getLatLng: function() {
            return this._latlng;
        },
        // @method setLatLng(latlng: LatLng): this
        // Sets the geographical point where the overlay will open.
        setLatLng: function(latlng) {
            this._latlng = toLatLng(latlng);
            if (this._map) {
                this._updatePosition();
                this._adjustPan();
            }
            return this;
        },
        // @method getContent: String|HTMLElement
        // Returns the content of the overlay.
        getContent: function() {
            return this._content;
        },
        // @method setContent(htmlContent: String|HTMLElement|Function): this
        // Sets the HTML content of the overlay. If a function is passed the source layer will be passed to the function.
        // The function should return a `String` or `HTMLElement` to be used in the overlay.
        setContent: function(content) {
            this._content = content;
            this.update();
            return this;
        },
        // @method getElement: String|HTMLElement
        // Returns the HTML container of the overlay.
        getElement: function() {
            return this._container;
        },
        // @method update: null
        // Updates the overlay content, layout and position. Useful for updating the overlay after something inside changed, e.g. image loaded.
        update: function() {
            if (!this._map) return;
            this._container.style.visibility = "hidden";
            this._updateContent();
            this._updateLayout();
            this._updatePosition();
            this._container.style.visibility = "";
            this._adjustPan();
        },
        getEvents: function() {
            var events = {
                zoom: this._updatePosition,
                viewreset: this._updatePosition
            };
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @method isOpen: Boolean
        // Returns `true` when the overlay is visible on the map.
        isOpen: function() {
            return !!this._map && this._map.hasLayer(this);
        },
        // @method bringToFront: this
        // Brings this overlay in front of other overlays (in the same map pane).
        bringToFront: function() {
            if (this._map) toFront(this._container);
            return this;
        },
        // @method bringToBack: this
        // Brings this overlay to the back of other overlays (in the same map pane).
        bringToBack: function() {
            if (this._map) toBack(this._container);
            return this;
        },
        // prepare bound overlay to open: update latlng pos / content source (for FeatureGroup)
        _prepareOpen: function(latlng) {
            var source = this._source;
            if (!source._map) return false;
            if (source instanceof FeatureGroup) {
                source = null;
                var layers = this._source._layers;
                for(var id in layers)if (layers[id]._map) {
                    source = layers[id];
                    break;
                }
                if (!source) return false;
                 // Unable to get source layer.
                // set overlay source to this layer
                this._source = source;
            }
            if (!latlng) {
                if (source.getCenter) latlng = source.getCenter();
                else if (source.getLatLng) latlng = source.getLatLng();
                else if (source.getBounds) latlng = source.getBounds().getCenter();
                else throw new Error("Unable to get source layer LatLng.");
            }
            this.setLatLng(latlng);
            if (this._map) // update the overlay (content, layout, etc...)
            this.update();
            return true;
        },
        _updateContent: function() {
            if (!this._content) return;
            var node = this._contentNode;
            var content = typeof this._content === "function" ? this._content(this._source || this) : this._content;
            if (typeof content === "string") node.innerHTML = content;
            else {
                while(node.hasChildNodes())node.removeChild(node.firstChild);
                node.appendChild(content);
            }
            // @namespace DivOverlay
            // @section DivOverlay events
            // @event contentupdate: Event
            // Fired when the content of the overlay is updated
            this.fire("contentupdate");
        },
        _updatePosition: function() {
            if (!this._map) return;
            var pos = this._map.latLngToLayerPoint(this._latlng), offset = toPoint(this.options.offset), anchor = this._getAnchor();
            if (this._zoomAnimated) setPosition(this._container, pos.add(anchor));
            else offset = offset.add(pos).add(anchor);
            var bottom = this._containerBottom = -offset.y, left = this._containerLeft = -Math.round(this._containerWidth / 2) + offset.x;
            // bottom position the overlay in case the height of the overlay changes (images loading etc)
            this._container.style.bottom = bottom + "px";
            this._container.style.left = left + "px";
        },
        _getAnchor: function() {
            return [
                0,
                0
            ];
        }
    });
    Map.include({
        _initOverlay: function(OverlayClass, content, latlng, options) {
            var overlay = content;
            if (!(overlay instanceof OverlayClass)) overlay = new OverlayClass(options).setContent(content);
            if (latlng) overlay.setLatLng(latlng);
            return overlay;
        }
    });
    Layer.include({
        _initOverlay: function(OverlayClass, old, content, options) {
            var overlay = content;
            if (overlay instanceof OverlayClass) {
                setOptions(overlay, options);
                overlay._source = this;
            } else {
                overlay = old && !options ? old : new OverlayClass(options, this);
                overlay.setContent(content);
            }
            return overlay;
        }
    });
    /*
   * @class Popup
   * @inherits DivOverlay
   * @aka L.Popup
   * Used to open popups in certain places of the map. Use [Map.openPopup](#map-openpopup) to
   * open popups while making sure that only one popup is open at one time
   * (recommended for usability), or use [Map.addLayer](#map-addlayer) to open as many as you want.
   *
   * @example
   *
   * If you want to just bind a popup to marker click and then open it, it's really easy:
   *
   * ```js
   * marker.bindPopup(popupContent).openPopup();
   * ```
   * Path overlays like polylines also have a `bindPopup` method.
   *
   * A popup can be also standalone:
   *
   * ```js
   * var popup = L.popup()
   * 	.setLatLng(latlng)
   * 	.setContent('<p>Hello world!<br />This is a nice popup.</p>')
   * 	.openOn(map);
   * ```
   * or
   * ```js
   * var popup = L.popup(latlng, {content: '<p>Hello world!<br />This is a nice popup.</p>')
   * 	.openOn(map);
   * ```
   */ // @namespace Popup
    var Popup = DivOverlay.extend({
        // @section
        // @aka Popup options
        options: {
            // @option pane: String = 'popupPane'
            // `Map pane` where the popup will be added.
            pane: "popupPane",
            // @option offset: Point = Point(0, 7)
            // The offset of the popup position.
            offset: [
                0,
                7
            ],
            // @option maxWidth: Number = 300
            // Max width of the popup, in pixels.
            maxWidth: 300,
            // @option minWidth: Number = 50
            // Min width of the popup, in pixels.
            minWidth: 50,
            // @option maxHeight: Number = null
            // If set, creates a scrollable container of the given height
            // inside a popup if its content exceeds it.
            // The scrollable container can be styled using the
            // `leaflet-popup-scrolled` CSS class selector.
            maxHeight: null,
            // @option autoPan: Boolean = true
            // Set it to `false` if you don't want the map to do panning animation
            // to fit the opened popup.
            autoPan: true,
            // @option autoPanPaddingTopLeft: Point = null
            // The margin between the popup and the top left corner of the map
            // view after autopanning was performed.
            autoPanPaddingTopLeft: null,
            // @option autoPanPaddingBottomRight: Point = null
            // The margin between the popup and the bottom right corner of the map
            // view after autopanning was performed.
            autoPanPaddingBottomRight: null,
            // @option autoPanPadding: Point = Point(5, 5)
            // Equivalent of setting both top left and bottom right autopan padding to the same value.
            autoPanPadding: [
                5,
                5
            ],
            // @option keepInView: Boolean = false
            // Set it to `true` if you want to prevent users from panning the popup
            // off of the screen while it is open.
            keepInView: false,
            // @option closeButton: Boolean = true
            // Controls the presence of a close button in the popup.
            closeButton: true,
            // @option autoClose: Boolean = true
            // Set it to `false` if you want to override the default behavior of
            // the popup closing when another popup is opened.
            autoClose: true,
            // @option closeOnEscapeKey: Boolean = true
            // Set it to `false` if you want to override the default behavior of
            // the ESC key for closing of the popup.
            closeOnEscapeKey: true,
            // @option closeOnClick: Boolean = *
            // Set it if you want to override the default behavior of the popup closing when user clicks
            // on the map. Defaults to the map's [`closePopupOnClick`](#map-closepopuponclick) option.
            // @option className: String = ''
            // A custom CSS class name to assign to the popup.
            className: ""
        },
        // @namespace Popup
        // @method openOn(map: Map): this
        // Alternative to `map.openPopup(popup)`.
        // Adds the popup to the map and closes the previous one.
        openOn: function(map) {
            map = arguments.length ? map : this._source._map; // experimental, not the part of public api
            if (!map.hasLayer(this) && map._popup && map._popup.options.autoClose) map.removeLayer(map._popup);
            map._popup = this;
            return DivOverlay.prototype.openOn.call(this, map);
        },
        onAdd: function(map) {
            DivOverlay.prototype.onAdd.call(this, map);
            // @namespace Map
            // @section Popup events
            // @event popupopen: PopupEvent
            // Fired when a popup is opened in the map
            map.fire("popupopen", {
                popup: this
            });
            if (this._source) {
                // @namespace Layer
                // @section Popup events
                // @event popupopen: PopupEvent
                // Fired when a popup bound to this layer is opened
                this._source.fire("popupopen", {
                    popup: this
                }, true);
                // For non-path layers, we toggle the popup when clicking
                // again the layer, so prevent the map to reopen it.
                if (!(this._source instanceof Path)) this._source.on("preclick", stopPropagation);
            }
        },
        onRemove: function(map) {
            DivOverlay.prototype.onRemove.call(this, map);
            // @namespace Map
            // @section Popup events
            // @event popupclose: PopupEvent
            // Fired when a popup in the map is closed
            map.fire("popupclose", {
                popup: this
            });
            if (this._source) {
                // @namespace Layer
                // @section Popup events
                // @event popupclose: PopupEvent
                // Fired when a popup bound to this layer is closed
                this._source.fire("popupclose", {
                    popup: this
                }, true);
                if (!(this._source instanceof Path)) this._source.off("preclick", stopPropagation);
            }
        },
        getEvents: function() {
            var events = DivOverlay.prototype.getEvents.call(this);
            if (this.options.closeOnClick !== undefined ? this.options.closeOnClick : this._map.options.closePopupOnClick) events.preclick = this.close;
            if (this.options.keepInView) events.moveend = this._adjustPan;
            return events;
        },
        _initLayout: function() {
            var prefix = "leaflet-popup", container = this._container = create$1("div", prefix + " " + (this.options.className || "") + " leaflet-zoom-animated");
            var wrapper = this._wrapper = create$1("div", prefix + "-content-wrapper", container);
            this._contentNode = create$1("div", prefix + "-content", wrapper);
            disableClickPropagation(container);
            disableScrollPropagation(this._contentNode);
            on(container, "contextmenu", stopPropagation);
            this._tipContainer = create$1("div", prefix + "-tip-container", container);
            this._tip = create$1("div", prefix + "-tip", this._tipContainer);
            if (this.options.closeButton) {
                var closeButton = this._closeButton = create$1("a", prefix + "-close-button", container);
                closeButton.setAttribute("role", "button"); // overrides the implicit role=link of <a> elements #7399
                closeButton.setAttribute("aria-label", "Close popup");
                closeButton.href = "#close";
                closeButton.innerHTML = '<span aria-hidden="true">&#215;</span>';
                on(closeButton, "click", function(ev) {
                    preventDefault(ev);
                    this.close();
                }, this);
            }
        },
        _updateLayout: function() {
            var container = this._contentNode, style = container.style;
            style.width = "";
            style.whiteSpace = "nowrap";
            var width = container.offsetWidth;
            width = Math.min(width, this.options.maxWidth);
            width = Math.max(width, this.options.minWidth);
            style.width = width + 1 + "px";
            style.whiteSpace = "";
            style.height = "";
            var height = container.offsetHeight, maxHeight = this.options.maxHeight, scrolledClass = "leaflet-popup-scrolled";
            if (maxHeight && height > maxHeight) {
                style.height = maxHeight + "px";
                addClass(container, scrolledClass);
            } else removeClass(container, scrolledClass);
            this._containerWidth = this._container.offsetWidth;
        },
        _animateZoom: function(e) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center), anchor = this._getAnchor();
            setPosition(this._container, pos.add(anchor));
        },
        _adjustPan: function() {
            if (!this.options.autoPan) return;
            if (this._map._panAnim) this._map._panAnim.stop();
            // We can endlessly recurse if keepInView is set and the view resets.
            // Let's guard against that by exiting early if we're responding to our own autopan.
            if (this._autopanning) {
                this._autopanning = false;
                return;
            }
            var map = this._map, marginBottom = parseInt(getStyle(this._container, "marginBottom"), 10) || 0, containerHeight = this._container.offsetHeight + marginBottom, containerWidth = this._containerWidth, layerPos = new Point(this._containerLeft, -containerHeight - this._containerBottom);
            layerPos._add(getPosition(this._container));
            var containerPos = map.layerPointToContainerPoint(layerPos), padding = toPoint(this.options.autoPanPadding), paddingTL = toPoint(this.options.autoPanPaddingTopLeft || padding), paddingBR = toPoint(this.options.autoPanPaddingBottomRight || padding), size = map.getSize(), dx = 0, dy = 0;
            if (containerPos.x + containerWidth + paddingBR.x > size.x) dx = containerPos.x + containerWidth - size.x + paddingBR.x;
            if (containerPos.x - dx - paddingTL.x < 0) dx = containerPos.x - paddingTL.x;
            if (containerPos.y + containerHeight + paddingBR.y > size.y) dy = containerPos.y + containerHeight - size.y + paddingBR.y;
            if (containerPos.y - dy - paddingTL.y < 0) dy = containerPos.y - paddingTL.y;
            // @namespace Map
            // @section Popup events
            // @event autopanstart: Event
            // Fired when the map starts autopanning when opening a popup.
            if (dx || dy) {
                // Track that we're autopanning, as this function will be re-ran on moveend
                if (this.options.keepInView) this._autopanning = true;
                map.fire("autopanstart").panBy([
                    dx,
                    dy
                ]);
            }
        },
        _getAnchor: function() {
            // Where should we anchor the popup on the source layer?
            return toPoint(this._source && this._source._getPopupAnchor ? this._source._getPopupAnchor() : [
                0,
                0
            ]);
        }
    });
    // @namespace Popup
    // @factory L.popup(options?: Popup options, source?: Layer)
    // Instantiates a `Popup` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the popup with a reference to the Layer to which it refers.
    // @alternative
    // @factory L.popup(latlng: LatLng, options?: Popup options)
    // Instantiates a `Popup` object given `latlng` where the popup will open and an optional `options` object that describes its appearance and location.
    var popup = function(options, source) {
        return new Popup(options, source);
    };
    /* @namespace Map
   * @section Interaction Options
   * @option closePopupOnClick: Boolean = true
   * Set it to `false` if you don't want popups to close when user clicks the map.
   */ Map.mergeOptions({
        closePopupOnClick: true
    });
    // @namespace Map
    // @section Methods for Layers and Controls
    Map.include({
        // @method openPopup(popup: Popup): this
        // Opens the specified popup while closing the previously opened (to make sure only one is opened at one time for usability).
        // @alternative
        // @method openPopup(content: String|HTMLElement, latlng: LatLng, options?: Popup options): this
        // Creates a popup with the specified content and options and opens it in the given point on a map.
        openPopup: function(popup, latlng, options) {
            this._initOverlay(Popup, popup, latlng, options).openOn(this);
            return this;
        },
        // @method closePopup(popup?: Popup): this
        // Closes the popup previously opened with [openPopup](#map-openpopup) (or the given one).
        closePopup: function(popup) {
            popup = arguments.length ? popup : this._popup;
            if (popup) popup.close();
            return this;
        }
    });
    /*
   * @namespace Layer
   * @section Popup methods example
   *
   * All layers share a set of methods convenient for binding popups to it.
   *
   * ```js
   * var layer = L.Polygon(latlngs).bindPopup('Hi There!').addTo(map);
   * layer.openPopup();
   * layer.closePopup();
   * ```
   *
   * Popups will also be automatically opened when the layer is clicked on and closed when the layer is removed from the map or another popup is opened.
   */ // @section Popup methods
    Layer.include({
        // @method bindPopup(content: String|HTMLElement|Function|Popup, options?: Popup options): this
        // Binds a popup to the layer with the passed `content` and sets up the
        // necessary event listeners. If a `Function` is passed it will receive
        // the layer as the first argument and should return a `String` or `HTMLElement`.
        bindPopup: function(content, options) {
            this._popup = this._initOverlay(Popup, this._popup, content, options);
            if (!this._popupHandlersAdded) {
                this.on({
                    click: this._openPopup,
                    keypress: this._onKeyPress,
                    remove: this.closePopup,
                    move: this._movePopup
                });
                this._popupHandlersAdded = true;
            }
            return this;
        },
        // @method unbindPopup(): this
        // Removes the popup previously bound with `bindPopup`.
        unbindPopup: function() {
            if (this._popup) {
                this.off({
                    click: this._openPopup,
                    keypress: this._onKeyPress,
                    remove: this.closePopup,
                    move: this._movePopup
                });
                this._popupHandlersAdded = false;
                this._popup = null;
            }
            return this;
        },
        // @method openPopup(latlng?: LatLng): this
        // Opens the bound popup at the specified `latlng` or at the default popup anchor if no `latlng` is passed.
        openPopup: function(latlng) {
            if (this._popup) {
                if (!(this instanceof FeatureGroup)) this._popup._source = this;
                if (this._popup._prepareOpen(latlng || this._latlng)) // open the popup on the map
                this._popup.openOn(this._map);
            }
            return this;
        },
        // @method closePopup(): this
        // Closes the popup bound to this layer if it is open.
        closePopup: function() {
            if (this._popup) this._popup.close();
            return this;
        },
        // @method togglePopup(): this
        // Opens or closes the popup bound to this layer depending on its current state.
        togglePopup: function() {
            if (this._popup) this._popup.toggle(this);
            return this;
        },
        // @method isPopupOpen(): boolean
        // Returns `true` if the popup bound to this layer is currently open.
        isPopupOpen: function() {
            return this._popup ? this._popup.isOpen() : false;
        },
        // @method setPopupContent(content: String|HTMLElement|Popup): this
        // Sets the content of the popup bound to this layer.
        setPopupContent: function(content) {
            if (this._popup) this._popup.setContent(content);
            return this;
        },
        // @method getPopup(): Popup
        // Returns the popup bound to this layer.
        getPopup: function() {
            return this._popup;
        },
        _openPopup: function(e) {
            if (!this._popup || !this._map) return;
            // prevent map click
            stop(e);
            var target = e.layer || e.target;
            if (this._popup._source === target && !(target instanceof Path)) {
                // treat it like a marker and figure out
                // if we should toggle it open/closed
                if (this._map.hasLayer(this._popup)) this.closePopup();
                else this.openPopup(e.latlng);
                return;
            }
            this._popup._source = target;
            this.openPopup(e.latlng);
        },
        _movePopup: function(e) {
            this._popup.setLatLng(e.latlng);
        },
        _onKeyPress: function(e) {
            if (e.originalEvent.keyCode === 13) this._openPopup(e);
        }
    });
    /*
   * @class Tooltip
   * @inherits DivOverlay
   * @aka L.Tooltip
   * Used to display small texts on top of map layers.
   *
   * @example
   * If you want to just bind a tooltip to marker:
   *
   * ```js
   * marker.bindTooltip("my tooltip text").openTooltip();
   * ```
   * Path overlays like polylines also have a `bindTooltip` method.
   *
   * A tooltip can be also standalone:
   *
   * ```js
   * var tooltip = L.tooltip()
   * 	.setLatLng(latlng)
   * 	.setContent('Hello world!<br />This is a nice tooltip.')
   * 	.addTo(map);
   * ```
   * or
   * ```js
   * var tooltip = L.tooltip(latlng, {content: 'Hello world!<br />This is a nice tooltip.'})
   * 	.addTo(map);
   * ```
   *
   *
   * Note about tooltip offset. Leaflet takes two options in consideration
   * for computing tooltip offsetting:
   * - the `offset` Tooltip option: it defaults to [0, 0], and it's specific to one tooltip.
   *   Add a positive x offset to move the tooltip to the right, and a positive y offset to
   *   move it to the bottom. Negatives will move to the left and top.
   * - the `tooltipAnchor` Icon option: this will only be considered for Marker. You
   *   should adapt this value if you use a custom icon.
   */ // @namespace Tooltip
    var Tooltip = DivOverlay.extend({
        // @section
        // @aka Tooltip options
        options: {
            // @option pane: String = 'tooltipPane'
            // `Map pane` where the tooltip will be added.
            pane: "tooltipPane",
            // @option offset: Point = Point(0, 0)
            // Optional offset of the tooltip position.
            offset: [
                0,
                0
            ],
            // @option direction: String = 'auto'
            // Direction where to open the tooltip. Possible values are: `right`, `left`,
            // `top`, `bottom`, `center`, `auto`.
            // `auto` will dynamically switch between `right` and `left` according to the tooltip
            // position on the map.
            direction: "auto",
            // @option permanent: Boolean = false
            // Whether to open the tooltip permanently or only on mouseover.
            permanent: false,
            // @option sticky: Boolean = false
            // If true, the tooltip will follow the mouse instead of being fixed at the feature center.
            sticky: false,
            // @option opacity: Number = 0.9
            // Tooltip container opacity.
            opacity: 0.9
        },
        onAdd: function(map) {
            DivOverlay.prototype.onAdd.call(this, map);
            this.setOpacity(this.options.opacity);
            // @namespace Map
            // @section Tooltip events
            // @event tooltipopen: TooltipEvent
            // Fired when a tooltip is opened in the map.
            map.fire("tooltipopen", {
                tooltip: this
            });
            if (this._source) {
                this.addEventParent(this._source);
                // @namespace Layer
                // @section Tooltip events
                // @event tooltipopen: TooltipEvent
                // Fired when a tooltip bound to this layer is opened.
                this._source.fire("tooltipopen", {
                    tooltip: this
                }, true);
            }
        },
        onRemove: function(map) {
            DivOverlay.prototype.onRemove.call(this, map);
            // @namespace Map
            // @section Tooltip events
            // @event tooltipclose: TooltipEvent
            // Fired when a tooltip in the map is closed.
            map.fire("tooltipclose", {
                tooltip: this
            });
            if (this._source) {
                this.removeEventParent(this._source);
                // @namespace Layer
                // @section Tooltip events
                // @event tooltipclose: TooltipEvent
                // Fired when a tooltip bound to this layer is closed.
                this._source.fire("tooltipclose", {
                    tooltip: this
                }, true);
            }
        },
        getEvents: function() {
            var events = DivOverlay.prototype.getEvents.call(this);
            if (!this.options.permanent) events.preclick = this.close;
            return events;
        },
        _initLayout: function() {
            var prefix = "leaflet-tooltip", className = prefix + " " + (this.options.className || "") + " leaflet-zoom-" + (this._zoomAnimated ? "animated" : "hide");
            this._contentNode = this._container = create$1("div", className);
            this._container.setAttribute("role", "tooltip");
            this._container.setAttribute("id", "leaflet-tooltip-" + stamp(this));
        },
        _updateLayout: function() {},
        _adjustPan: function() {},
        _setPosition: function(pos) {
            var subX, subY, map = this._map, container = this._container, centerPoint = map.latLngToContainerPoint(map.getCenter()), tooltipPoint = map.layerPointToContainerPoint(pos), direction = this.options.direction, tooltipWidth = container.offsetWidth, tooltipHeight = container.offsetHeight, offset = toPoint(this.options.offset), anchor = this._getAnchor();
            if (direction === "top") {
                subX = tooltipWidth / 2;
                subY = tooltipHeight;
            } else if (direction === "bottom") {
                subX = tooltipWidth / 2;
                subY = 0;
            } else if (direction === "center") {
                subX = tooltipWidth / 2;
                subY = tooltipHeight / 2;
            } else if (direction === "right") {
                subX = 0;
                subY = tooltipHeight / 2;
            } else if (direction === "left") {
                subX = tooltipWidth;
                subY = tooltipHeight / 2;
            } else if (tooltipPoint.x < centerPoint.x) {
                direction = "right";
                subX = 0;
                subY = tooltipHeight / 2;
            } else {
                direction = "left";
                subX = tooltipWidth + (offset.x + anchor.x) * 2;
                subY = tooltipHeight / 2;
            }
            pos = pos.subtract(toPoint(subX, subY, true)).add(offset).add(anchor);
            removeClass(container, "leaflet-tooltip-right");
            removeClass(container, "leaflet-tooltip-left");
            removeClass(container, "leaflet-tooltip-top");
            removeClass(container, "leaflet-tooltip-bottom");
            addClass(container, "leaflet-tooltip-" + direction);
            setPosition(container, pos);
        },
        _updatePosition: function() {
            var pos = this._map.latLngToLayerPoint(this._latlng);
            this._setPosition(pos);
        },
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._container) setOpacity(this._container, opacity);
        },
        _animateZoom: function(e) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center);
            this._setPosition(pos);
        },
        _getAnchor: function() {
            // Where should we anchor the tooltip on the source layer?
            return toPoint(this._source && this._source._getTooltipAnchor && !this.options.sticky ? this._source._getTooltipAnchor() : [
                0,
                0
            ]);
        }
    });
    // @namespace Tooltip
    // @factory L.tooltip(options?: Tooltip options, source?: Layer)
    // Instantiates a `Tooltip` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the tooltip with a reference to the Layer to which it refers.
    // @alternative
    // @factory L.tooltip(latlng: LatLng, options?: Tooltip options)
    // Instantiates a `Tooltip` object given `latlng` where the tooltip will open and an optional `options` object that describes its appearance and location.
    var tooltip = function(options, source) {
        return new Tooltip(options, source);
    };
    // @namespace Map
    // @section Methods for Layers and Controls
    Map.include({
        // @method openTooltip(tooltip: Tooltip): this
        // Opens the specified tooltip.
        // @alternative
        // @method openTooltip(content: String|HTMLElement, latlng: LatLng, options?: Tooltip options): this
        // Creates a tooltip with the specified content and options and open it.
        openTooltip: function(tooltip, latlng, options) {
            this._initOverlay(Tooltip, tooltip, latlng, options).openOn(this);
            return this;
        },
        // @method closeTooltip(tooltip: Tooltip): this
        // Closes the tooltip given as parameter.
        closeTooltip: function(tooltip) {
            tooltip.close();
            return this;
        }
    });
    /*
   * @namespace Layer
   * @section Tooltip methods example
   *
   * All layers share a set of methods convenient for binding tooltips to it.
   *
   * ```js
   * var layer = L.Polygon(latlngs).bindTooltip('Hi There!').addTo(map);
   * layer.openTooltip();
   * layer.closeTooltip();
   * ```
   */ // @section Tooltip methods
    Layer.include({
        // @method bindTooltip(content: String|HTMLElement|Function|Tooltip, options?: Tooltip options): this
        // Binds a tooltip to the layer with the passed `content` and sets up the
        // necessary event listeners. If a `Function` is passed it will receive
        // the layer as the first argument and should return a `String` or `HTMLElement`.
        bindTooltip: function(content, options) {
            if (this._tooltip && this.isTooltipOpen()) this.unbindTooltip();
            this._tooltip = this._initOverlay(Tooltip, this._tooltip, content, options);
            this._initTooltipInteractions();
            if (this._tooltip.options.permanent && this._map && this._map.hasLayer(this)) this.openTooltip();
            return this;
        },
        // @method unbindTooltip(): this
        // Removes the tooltip previously bound with `bindTooltip`.
        unbindTooltip: function() {
            if (this._tooltip) {
                this._initTooltipInteractions(true);
                this.closeTooltip();
                this._tooltip = null;
            }
            return this;
        },
        _initTooltipInteractions: function(remove) {
            if (!remove && this._tooltipHandlersAdded) return;
            var onOff = remove ? "off" : "on", events = {
                remove: this.closeTooltip,
                move: this._moveTooltip
            };
            if (!this._tooltip.options.permanent) {
                events.mouseover = this._openTooltip;
                events.mouseout = this.closeTooltip;
                events.click = this._openTooltip;
                if (this._map) this._addFocusListeners();
                else events.add = this._addFocusListeners;
            } else events.add = this._openTooltip;
            if (this._tooltip.options.sticky) events.mousemove = this._moveTooltip;
            this[onOff](events);
            this._tooltipHandlersAdded = !remove;
        },
        // @method openTooltip(latlng?: LatLng): this
        // Opens the bound tooltip at the specified `latlng` or at the default tooltip anchor if no `latlng` is passed.
        openTooltip: function(latlng) {
            if (this._tooltip) {
                if (!(this instanceof FeatureGroup)) this._tooltip._source = this;
                if (this._tooltip._prepareOpen(latlng)) {
                    // open the tooltip on the map
                    this._tooltip.openOn(this._map);
                    if (this.getElement) this._setAriaDescribedByOnLayer(this);
                    else if (this.eachLayer) this.eachLayer(this._setAriaDescribedByOnLayer, this);
                }
            }
            return this;
        },
        // @method closeTooltip(): this
        // Closes the tooltip bound to this layer if it is open.
        closeTooltip: function() {
            if (this._tooltip) return this._tooltip.close();
        },
        // @method toggleTooltip(): this
        // Opens or closes the tooltip bound to this layer depending on its current state.
        toggleTooltip: function() {
            if (this._tooltip) this._tooltip.toggle(this);
            return this;
        },
        // @method isTooltipOpen(): boolean
        // Returns `true` if the tooltip bound to this layer is currently open.
        isTooltipOpen: function() {
            return this._tooltip.isOpen();
        },
        // @method setTooltipContent(content: String|HTMLElement|Tooltip): this
        // Sets the content of the tooltip bound to this layer.
        setTooltipContent: function(content) {
            if (this._tooltip) this._tooltip.setContent(content);
            return this;
        },
        // @method getTooltip(): Tooltip
        // Returns the tooltip bound to this layer.
        getTooltip: function() {
            return this._tooltip;
        },
        _addFocusListeners: function() {
            if (this.getElement) this._addFocusListenersOnLayer(this);
            else if (this.eachLayer) this.eachLayer(this._addFocusListenersOnLayer, this);
        },
        _addFocusListenersOnLayer: function(layer) {
            var el = typeof layer.getElement === "function" && layer.getElement();
            if (el) {
                on(el, "focus", function() {
                    this._tooltip._source = layer;
                    this.openTooltip();
                }, this);
                on(el, "blur", this.closeTooltip, this);
            }
        },
        _setAriaDescribedByOnLayer: function(layer) {
            var el = typeof layer.getElement === "function" && layer.getElement();
            if (el) el.setAttribute("aria-describedby", this._tooltip._container.id);
        },
        _openTooltip: function(e) {
            if (!this._tooltip || !this._map) return;
            // If the map is moving, we will show the tooltip after it's done.
            if (this._map.dragging && this._map.dragging.moving() && !this._openOnceFlag) {
                this._openOnceFlag = true;
                var that = this;
                this._map.once("moveend", function() {
                    that._openOnceFlag = false;
                    that._openTooltip(e);
                });
                return;
            }
            this._tooltip._source = e.layer || e.target;
            this.openTooltip(this._tooltip.options.sticky ? e.latlng : undefined);
        },
        _moveTooltip: function(e) {
            var latlng = e.latlng, containerPoint, layerPoint;
            if (this._tooltip.options.sticky && e.originalEvent) {
                containerPoint = this._map.mouseEventToContainerPoint(e.originalEvent);
                layerPoint = this._map.containerPointToLayerPoint(containerPoint);
                latlng = this._map.layerPointToLatLng(layerPoint);
            }
            this._tooltip.setLatLng(latlng);
        }
    });
    /*
   * @class DivIcon
   * @aka L.DivIcon
   * @inherits Icon
   *
   * Represents a lightweight icon for markers that uses a simple `<div>`
   * element instead of an image. Inherits from `Icon` but ignores the `iconUrl` and shadow options.
   *
   * @example
   * ```js
   * var myIcon = L.divIcon({className: 'my-div-icon'});
   * // you can set .my-div-icon styles in CSS
   *
   * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
   * ```
   *
   * By default, it has a 'leaflet-div-icon' CSS class and is styled as a little white square with a shadow.
   */ var DivIcon = Icon.extend({
        options: {
            // @section
            // @aka DivIcon options
            iconSize: [
                12,
                12
            ],
            // iconAnchor: (Point),
            // popupAnchor: (Point),
            // @option html: String|HTMLElement = ''
            // Custom HTML code to put inside the div element, empty by default. Alternatively,
            // an instance of `HTMLElement`.
            html: false,
            // @option bgPos: Point = [0, 0]
            // Optional relative position of the background, in pixels
            bgPos: null,
            className: "leaflet-div-icon"
        },
        createIcon: function(oldIcon) {
            var div = oldIcon && oldIcon.tagName === "DIV" ? oldIcon : document.createElement("div"), options = this.options;
            if (options.html instanceof Element) {
                empty(div);
                div.appendChild(options.html);
            } else div.innerHTML = options.html !== false ? options.html : "";
            if (options.bgPos) {
                var bgPos = toPoint(options.bgPos);
                div.style.backgroundPosition = -bgPos.x + "px " + -bgPos.y + "px";
            }
            this._setIconStyles(div, "icon");
            return div;
        },
        createShadow: function() {
            return null;
        }
    });
    // @factory L.divIcon(options: DivIcon options)
    // Creates a `DivIcon` instance with the given options.
    function divIcon(options) {
        return new DivIcon(options);
    }
    Icon.Default = IconDefault;
    /*
   * @class GridLayer
   * @inherits Layer
   * @aka L.GridLayer
   *
   * Generic class for handling a tiled grid of HTML elements. This is the base class for all tile layers and replaces `TileLayer.Canvas`.
   * GridLayer can be extended to create a tiled grid of HTML elements like `<canvas>`, `<img>` or `<div>`. GridLayer will handle creating and animating these DOM elements for you.
   *
   *
   * @section Synchronous usage
   * @example
   *
   * To create a custom layer, extend GridLayer and implement the `createTile()` method, which will be passed a `Point` object with the `x`, `y`, and `z` (zoom level) coordinates to draw your tile.
   *
   * ```js
   * var CanvasLayer = L.GridLayer.extend({
   *     createTile: function(coords){
   *         // create a <canvas> element for drawing
   *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
   *
   *         // setup tile width and height according to the options
   *         var size = this.getTileSize();
   *         tile.width = size.x;
   *         tile.height = size.y;
   *
   *         // get a canvas context and draw something on it using coords.x, coords.y and coords.z
   *         var ctx = tile.getContext('2d');
   *
   *         // return the tile so it can be rendered on screen
   *         return tile;
   *     }
   * });
   * ```
   *
   * @section Asynchronous usage
   * @example
   *
   * Tile creation can also be asynchronous, this is useful when using a third-party drawing library. Once the tile is finished drawing it can be passed to the `done()` callback.
   *
   * ```js
   * var CanvasLayer = L.GridLayer.extend({
   *     createTile: function(coords, done){
   *         var error;
   *
   *         // create a <canvas> element for drawing
   *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
   *
   *         // setup tile width and height according to the options
   *         var size = this.getTileSize();
   *         tile.width = size.x;
   *         tile.height = size.y;
   *
   *         // draw something asynchronously and pass the tile to the done() callback
   *         setTimeout(function() {
   *             done(error, tile);
   *         }, 1000);
   *
   *         return tile;
   *     }
   * });
   * ```
   *
   * @section
   */ var GridLayer = Layer.extend({
        // @section
        // @aka GridLayer options
        options: {
            // @option tileSize: Number|Point = 256
            // Width and height of tiles in the grid. Use a number if width and height are equal, or `L.point(width, height)` otherwise.
            tileSize: 256,
            // @option opacity: Number = 1.0
            // Opacity of the tiles. Can be used in the `createTile()` function.
            opacity: 1,
            // @option updateWhenIdle: Boolean = (depends)
            // Load new tiles only when panning ends.
            // `true` by default on mobile browsers, in order to avoid too many requests and keep smooth navigation.
            // `false` otherwise in order to display new tiles _during_ panning, since it is easy to pan outside the
            // [`keepBuffer`](#gridlayer-keepbuffer) option in desktop browsers.
            updateWhenIdle: Browser.mobile,
            // @option updateWhenZooming: Boolean = true
            // By default, a smooth zoom animation (during a [touch zoom](#map-touchzoom) or a [`flyTo()`](#map-flyto)) will update grid layers every integer zoom level. Setting this option to `false` will update the grid layer only when the smooth animation ends.
            updateWhenZooming: true,
            // @option updateInterval: Number = 200
            // Tiles will not update more than once every `updateInterval` milliseconds when panning.
            updateInterval: 200,
            // @option zIndex: Number = 1
            // The explicit zIndex of the tile layer.
            zIndex: 1,
            // @option bounds: LatLngBounds = undefined
            // If set, tiles will only be loaded inside the set `LatLngBounds`.
            bounds: null,
            // @option minZoom: Number = 0
            // The minimum zoom level down to which this layer will be displayed (inclusive).
            minZoom: 0,
            // @option maxZoom: Number = undefined
            // The maximum zoom level up to which this layer will be displayed (inclusive).
            maxZoom: undefined,
            // @option maxNativeZoom: Number = undefined
            // Maximum zoom number the tile source has available. If it is specified,
            // the tiles on all zoom levels higher than `maxNativeZoom` will be loaded
            // from `maxNativeZoom` level and auto-scaled.
            maxNativeZoom: undefined,
            // @option minNativeZoom: Number = undefined
            // Minimum zoom number the tile source has available. If it is specified,
            // the tiles on all zoom levels lower than `minNativeZoom` will be loaded
            // from `minNativeZoom` level and auto-scaled.
            minNativeZoom: undefined,
            // @option noWrap: Boolean = false
            // Whether the layer is wrapped around the antimeridian. If `true`, the
            // GridLayer will only be displayed once at low zoom levels. Has no
            // effect when the [map CRS](#map-crs) doesn't wrap around. Can be used
            // in combination with [`bounds`](#gridlayer-bounds) to prevent requesting
            // tiles outside the CRS limits.
            noWrap: false,
            // @option pane: String = 'tilePane'
            // `Map pane` where the grid layer will be added.
            pane: "tilePane",
            // @option className: String = ''
            // A custom class name to assign to the tile layer. Empty by default.
            className: "",
            // @option keepBuffer: Number = 2
            // When panning the map, keep this many rows and columns of tiles before unloading them.
            keepBuffer: 2
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        onAdd: function() {
            this._initContainer();
            this._levels = {};
            this._tiles = {};
            this._resetView(); // implicit _update() call
        },
        beforeAdd: function(map) {
            map._addZoomLimit(this);
        },
        onRemove: function(map) {
            this._removeAllTiles();
            remove(this._container);
            map._removeZoomLimit(this);
            this._container = null;
            this._tileZoom = undefined;
        },
        // @method bringToFront: this
        // Brings the tile layer to the top of all tile layers.
        bringToFront: function() {
            if (this._map) {
                toFront(this._container);
                this._setAutoZIndex(Math.max);
            }
            return this;
        },
        // @method bringToBack: this
        // Brings the tile layer to the bottom of all tile layers.
        bringToBack: function() {
            if (this._map) {
                toBack(this._container);
                this._setAutoZIndex(Math.min);
            }
            return this;
        },
        // @method getContainer: HTMLElement
        // Returns the HTML element that contains the tiles for this layer.
        getContainer: function() {
            return this._container;
        },
        // @method setOpacity(opacity: Number): this
        // Changes the [opacity](#gridlayer-opacity) of the grid layer.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            this._updateOpacity();
            return this;
        },
        // @method setZIndex(zIndex: Number): this
        // Changes the [zIndex](#gridlayer-zindex) of the grid layer.
        setZIndex: function(zIndex) {
            this.options.zIndex = zIndex;
            this._updateZIndex();
            return this;
        },
        // @method isLoading: Boolean
        // Returns `true` if any tile in the grid layer has not finished loading.
        isLoading: function() {
            return this._loading;
        },
        // @method redraw: this
        // Causes the layer to clear all the tiles and request them again.
        redraw: function() {
            if (this._map) {
                this._removeAllTiles();
                var tileZoom = this._clampZoom(this._map.getZoom());
                if (tileZoom !== this._tileZoom) {
                    this._tileZoom = tileZoom;
                    this._updateLevels();
                }
                this._update();
            }
            return this;
        },
        getEvents: function() {
            var events = {
                viewprereset: this._invalidateAll,
                viewreset: this._resetView,
                zoom: this._resetView,
                moveend: this._onMoveEnd
            };
            if (!this.options.updateWhenIdle) {
                // update tiles on move, but not more often than once per given interval
                if (!this._onMove) this._onMove = throttle(this._onMoveEnd, this.options.updateInterval, this);
                events.move = this._onMove;
            }
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @section Extension methods
        // Layers extending `GridLayer` shall reimplement the following method.
        // @method createTile(coords: Object, done?: Function): HTMLElement
        // Called only internally, must be overridden by classes extending `GridLayer`.
        // Returns the `HTMLElement` corresponding to the given `coords`. If the `done` callback
        // is specified, it must be called when the tile has finished loading and drawing.
        createTile: function() {
            return document.createElement("div");
        },
        // @section
        // @method getTileSize: Point
        // Normalizes the [tileSize option](#gridlayer-tilesize) into a point. Used by the `createTile()` method.
        getTileSize: function() {
            var s = this.options.tileSize;
            return s instanceof Point ? s : new Point(s, s);
        },
        _updateZIndex: function() {
            if (this._container && this.options.zIndex !== undefined && this.options.zIndex !== null) this._container.style.zIndex = this.options.zIndex;
        },
        _setAutoZIndex: function(compare) {
            // go through all other layers of the same pane, set zIndex to max + 1 (front) or min - 1 (back)
            var layers = this.getPane().children, edgeZIndex = -compare(-Infinity, Infinity); // -Infinity for max, Infinity for min
            for(var i = 0, len = layers.length, zIndex; i < len; i++){
                zIndex = layers[i].style.zIndex;
                if (layers[i] !== this._container && zIndex) edgeZIndex = compare(edgeZIndex, +zIndex);
            }
            if (isFinite(edgeZIndex)) {
                this.options.zIndex = edgeZIndex + compare(-1, 1);
                this._updateZIndex();
            }
        },
        _updateOpacity: function() {
            if (!this._map) return;
            // IE doesn't inherit filter opacity properly, so we're forced to set it on tiles
            if (Browser.ielt9) return;
            setOpacity(this._container, this.options.opacity);
            var now = +new Date(), nextFrame = false, willPrune = false;
            for(var key in this._tiles){
                var tile = this._tiles[key];
                if (!tile.current || !tile.loaded) continue;
                var fade = Math.min(1, (now - tile.loaded) / 200);
                setOpacity(tile.el, fade);
                if (fade < 1) nextFrame = true;
                else {
                    if (tile.active) willPrune = true;
                    else this._onOpaqueTile(tile);
                    tile.active = true;
                }
            }
            if (willPrune && !this._noPrune) this._pruneTiles();
            if (nextFrame) {
                cancelAnimFrame(this._fadeFrame);
                this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
            }
        },
        _onOpaqueTile: falseFn,
        _initContainer: function() {
            if (this._container) return;
            this._container = create$1("div", "leaflet-layer " + (this.options.className || ""));
            this._updateZIndex();
            if (this.options.opacity < 1) this._updateOpacity();
            this.getPane().appendChild(this._container);
        },
        _updateLevels: function() {
            var zoom = this._tileZoom, maxZoom = this.options.maxZoom;
            if (zoom === undefined) return undefined;
            for(var z in this._levels){
                z = Number(z);
                if (this._levels[z].el.children.length || z === zoom) {
                    this._levels[z].el.style.zIndex = maxZoom - Math.abs(zoom - z);
                    this._onUpdateLevel(z);
                } else {
                    remove(this._levels[z].el);
                    this._removeTilesAtZoom(z);
                    this._onRemoveLevel(z);
                    delete this._levels[z];
                }
            }
            var level = this._levels[zoom], map = this._map;
            if (!level) {
                level = this._levels[zoom] = {};
                level.el = create$1("div", "leaflet-tile-container leaflet-zoom-animated", this._container);
                level.el.style.zIndex = maxZoom;
                level.origin = map.project(map.unproject(map.getPixelOrigin()), zoom).round();
                level.zoom = zoom;
                this._setZoomTransform(level, map.getCenter(), map.getZoom());
                // force the browser to consider the newly added element for transition
                falseFn(level.el.offsetWidth);
                this._onCreateLevel(level);
            }
            this._level = level;
            return level;
        },
        _onUpdateLevel: falseFn,
        _onRemoveLevel: falseFn,
        _onCreateLevel: falseFn,
        _pruneTiles: function() {
            if (!this._map) return;
            var key, tile;
            var zoom = this._map.getZoom();
            if (zoom > this.options.maxZoom || zoom < this.options.minZoom) {
                this._removeAllTiles();
                return;
            }
            for(key in this._tiles){
                tile = this._tiles[key];
                tile.retain = tile.current;
            }
            for(key in this._tiles){
                tile = this._tiles[key];
                if (tile.current && !tile.active) {
                    var coords = tile.coords;
                    if (!this._retainParent(coords.x, coords.y, coords.z, coords.z - 5)) this._retainChildren(coords.x, coords.y, coords.z, coords.z + 2);
                }
            }
            for(key in this._tiles)if (!this._tiles[key].retain) this._removeTile(key);
        },
        _removeTilesAtZoom: function(zoom) {
            for(var key in this._tiles){
                if (this._tiles[key].coords.z !== zoom) continue;
                this._removeTile(key);
            }
        },
        _removeAllTiles: function() {
            for(var key in this._tiles)this._removeTile(key);
        },
        _invalidateAll: function() {
            for(var z in this._levels){
                remove(this._levels[z].el);
                this._onRemoveLevel(Number(z));
                delete this._levels[z];
            }
            this._removeAllTiles();
            this._tileZoom = undefined;
        },
        _retainParent: function(x, y, z, minZoom) {
            var x2 = Math.floor(x / 2), y2 = Math.floor(y / 2), z2 = z - 1, coords2 = new Point(+x2, +y2);
            coords2.z = +z2;
            var key = this._tileCoordsToKey(coords2), tile = this._tiles[key];
            if (tile && tile.active) {
                tile.retain = true;
                return true;
            } else if (tile && tile.loaded) tile.retain = true;
            if (z2 > minZoom) return this._retainParent(x2, y2, z2, minZoom);
            return false;
        },
        _retainChildren: function(x, y, z, maxZoom) {
            for(var i = 2 * x; i < 2 * x + 2; i++)for(var j = 2 * y; j < 2 * y + 2; j++){
                var coords = new Point(i, j);
                coords.z = z + 1;
                var key = this._tileCoordsToKey(coords), tile = this._tiles[key];
                if (tile && tile.active) {
                    tile.retain = true;
                    continue;
                } else if (tile && tile.loaded) tile.retain = true;
                if (z + 1 < maxZoom) this._retainChildren(i, j, z + 1, maxZoom);
            }
        },
        _resetView: function(e) {
            var animating = e && (e.pinch || e.flyTo);
            this._setView(this._map.getCenter(), this._map.getZoom(), animating, animating);
        },
        _animateZoom: function(e) {
            this._setView(e.center, e.zoom, true, e.noUpdate);
        },
        _clampZoom: function(zoom) {
            var options = this.options;
            if (undefined !== options.minNativeZoom && zoom < options.minNativeZoom) return options.minNativeZoom;
            if (undefined !== options.maxNativeZoom && options.maxNativeZoom < zoom) return options.maxNativeZoom;
            return zoom;
        },
        _setView: function(center, zoom, noPrune, noUpdate) {
            var tileZoom = Math.round(zoom);
            if (this.options.maxZoom !== undefined && tileZoom > this.options.maxZoom || this.options.minZoom !== undefined && tileZoom < this.options.minZoom) tileZoom = undefined;
            else tileZoom = this._clampZoom(tileZoom);
            var tileZoomChanged = this.options.updateWhenZooming && tileZoom !== this._tileZoom;
            if (!noUpdate || tileZoomChanged) {
                this._tileZoom = tileZoom;
                if (this._abortLoading) this._abortLoading();
                this._updateLevels();
                this._resetGrid();
                if (tileZoom !== undefined) this._update(center);
                if (!noPrune) this._pruneTiles();
                // Flag to prevent _updateOpacity from pruning tiles during
                // a zoom anim or a pinch gesture
                this._noPrune = !!noPrune;
            }
            this._setZoomTransforms(center, zoom);
        },
        _setZoomTransforms: function(center, zoom) {
            for(var i in this._levels)this._setZoomTransform(this._levels[i], center, zoom);
        },
        _setZoomTransform: function(level, center, zoom) {
            var scale = this._map.getZoomScale(zoom, level.zoom), translate = level.origin.multiplyBy(scale).subtract(this._map._getNewPixelOrigin(center, zoom)).round();
            if (Browser.any3d) setTransform(level.el, translate, scale);
            else setPosition(level.el, translate);
        },
        _resetGrid: function() {
            var map = this._map, crs = map.options.crs, tileSize = this._tileSize = this.getTileSize(), tileZoom = this._tileZoom;
            var bounds = this._map.getPixelWorldBounds(this._tileZoom);
            if (bounds) this._globalTileRange = this._pxBoundsToTileRange(bounds);
            this._wrapX = crs.wrapLng && !this.options.noWrap && [
                Math.floor(map.project([
                    0,
                    crs.wrapLng[0]
                ], tileZoom).x / tileSize.x),
                Math.ceil(map.project([
                    0,
                    crs.wrapLng[1]
                ], tileZoom).x / tileSize.y)
            ];
            this._wrapY = crs.wrapLat && !this.options.noWrap && [
                Math.floor(map.project([
                    crs.wrapLat[0],
                    0
                ], tileZoom).y / tileSize.x),
                Math.ceil(map.project([
                    crs.wrapLat[1],
                    0
                ], tileZoom).y / tileSize.y)
            ];
        },
        _onMoveEnd: function() {
            if (!this._map || this._map._animatingZoom) return;
            this._update();
        },
        _getTiledPixelBounds: function(center) {
            var map = this._map, mapZoom = map._animatingZoom ? Math.max(map._animateToZoom, map.getZoom()) : map.getZoom(), scale = map.getZoomScale(mapZoom, this._tileZoom), pixelCenter = map.project(center, this._tileZoom).floor(), halfSize = map.getSize().divideBy(scale * 2);
            return new Bounds(pixelCenter.subtract(halfSize), pixelCenter.add(halfSize));
        },
        // Private method to load tiles in the grid's active zoom level according to map bounds
        _update: function(center) {
            var map = this._map;
            if (!map) return;
            var zoom = this._clampZoom(map.getZoom());
            if (center === undefined) center = map.getCenter();
            if (this._tileZoom === undefined) return;
             // if out of minzoom/maxzoom
            var pixelBounds = this._getTiledPixelBounds(center), tileRange = this._pxBoundsToTileRange(pixelBounds), tileCenter = tileRange.getCenter(), queue = [], margin = this.options.keepBuffer, noPruneRange = new Bounds(tileRange.getBottomLeft().subtract([
                margin,
                -margin
            ]), tileRange.getTopRight().add([
                margin,
                -margin
            ]));
            // Sanity check: panic if the tile range contains Infinity somewhere.
            if (!(isFinite(tileRange.min.x) && isFinite(tileRange.min.y) && isFinite(tileRange.max.x) && isFinite(tileRange.max.y))) throw new Error("Attempted to load an infinite number of tiles");
            for(var key in this._tiles){
                var c = this._tiles[key].coords;
                if (c.z !== this._tileZoom || !noPruneRange.contains(new Point(c.x, c.y))) this._tiles[key].current = false;
            }
            // _update just loads more tiles. If the tile zoom level differs too much
            // from the map's, let _setView reset levels and prune old tiles.
            if (Math.abs(zoom - this._tileZoom) > 1) {
                this._setView(center, zoom);
                return;
            }
            // create a queue of coordinates to load tiles from
            for(var j = tileRange.min.y; j <= tileRange.max.y; j++)for(var i = tileRange.min.x; i <= tileRange.max.x; i++){
                var coords = new Point(i, j);
                coords.z = this._tileZoom;
                if (!this._isValidTile(coords)) continue;
                var tile = this._tiles[this._tileCoordsToKey(coords)];
                if (tile) tile.current = true;
                else queue.push(coords);
            }
            // sort tile queue to load tiles in order of their distance to center
            queue.sort(function(a, b) {
                return a.distanceTo(tileCenter) - b.distanceTo(tileCenter);
            });
            if (queue.length !== 0) {
                // if it's the first batch of tiles to load
                if (!this._loading) {
                    this._loading = true;
                    // @event loading: Event
                    // Fired when the grid layer starts loading tiles.
                    this.fire("loading");
                }
                // create DOM fragment to append tiles in one batch
                var fragment = document.createDocumentFragment();
                for(i = 0; i < queue.length; i++)this._addTile(queue[i], fragment);
                this._level.el.appendChild(fragment);
            }
        },
        _isValidTile: function(coords) {
            var crs = this._map.options.crs;
            if (!crs.infinite) {
                // don't load tile if it's out of bounds and not wrapped
                var bounds = this._globalTileRange;
                if (!crs.wrapLng && (coords.x < bounds.min.x || coords.x > bounds.max.x) || !crs.wrapLat && (coords.y < bounds.min.y || coords.y > bounds.max.y)) return false;
            }
            if (!this.options.bounds) return true;
            // don't load tile if it doesn't intersect the bounds in options
            var tileBounds = this._tileCoordsToBounds(coords);
            return toLatLngBounds(this.options.bounds).overlaps(tileBounds);
        },
        _keyToBounds: function(key) {
            return this._tileCoordsToBounds(this._keyToTileCoords(key));
        },
        _tileCoordsToNwSe: function(coords) {
            var map = this._map, tileSize = this.getTileSize(), nwPoint = coords.scaleBy(tileSize), sePoint = nwPoint.add(tileSize), nw = map.unproject(nwPoint, coords.z), se = map.unproject(sePoint, coords.z);
            return [
                nw,
                se
            ];
        },
        // converts tile coordinates to its geographical bounds
        _tileCoordsToBounds: function(coords) {
            var bp = this._tileCoordsToNwSe(coords), bounds = new LatLngBounds(bp[0], bp[1]);
            if (!this.options.noWrap) bounds = this._map.wrapLatLngBounds(bounds);
            return bounds;
        },
        // converts tile coordinates to key for the tile cache
        _tileCoordsToKey: function(coords) {
            return coords.x + ":" + coords.y + ":" + coords.z;
        },
        // converts tile cache key to coordinates
        _keyToTileCoords: function(key) {
            var k = key.split(":"), coords = new Point(+k[0], +k[1]);
            coords.z = +k[2];
            return coords;
        },
        _removeTile: function(key) {
            var tile = this._tiles[key];
            if (!tile) return;
            remove(tile.el);
            delete this._tiles[key];
            // @event tileunload: TileEvent
            // Fired when a tile is removed (e.g. when a tile goes off the screen).
            this.fire("tileunload", {
                tile: tile.el,
                coords: this._keyToTileCoords(key)
            });
        },
        _initTile: function(tile) {
            addClass(tile, "leaflet-tile");
            var tileSize = this.getTileSize();
            tile.style.width = tileSize.x + "px";
            tile.style.height = tileSize.y + "px";
            tile.onselectstart = falseFn;
            tile.onmousemove = falseFn;
            // update opacity on tiles in IE7-8 because of filter inheritance problems
            if (Browser.ielt9 && this.options.opacity < 1) setOpacity(tile, this.options.opacity);
        },
        _addTile: function(coords, container) {
            var tilePos = this._getTilePos(coords), key = this._tileCoordsToKey(coords);
            var tile = this.createTile(this._wrapCoords(coords), bind(this._tileReady, this, coords));
            this._initTile(tile);
            // if createTile is defined with a second argument ("done" callback),
            // we know that tile is async and will be ready later; otherwise
            if (this.createTile.length < 2) // mark tile as ready, but delay one frame for opacity animation to happen
            requestAnimFrame(bind(this._tileReady, this, coords, null, tile));
            setPosition(tile, tilePos);
            // save tile in cache
            this._tiles[key] = {
                el: tile,
                coords: coords,
                current: true
            };
            container.appendChild(tile);
            // @event tileloadstart: TileEvent
            // Fired when a tile is requested and starts loading.
            this.fire("tileloadstart", {
                tile: tile,
                coords: coords
            });
        },
        _tileReady: function(coords, err, tile) {
            if (err) // @event tileerror: TileErrorEvent
            // Fired when there is an error loading a tile.
            this.fire("tileerror", {
                error: err,
                tile: tile,
                coords: coords
            });
            var key = this._tileCoordsToKey(coords);
            tile = this._tiles[key];
            if (!tile) return;
            tile.loaded = +new Date();
            if (this._map._fadeAnimated) {
                setOpacity(tile.el, 0);
                cancelAnimFrame(this._fadeFrame);
                this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
            } else {
                tile.active = true;
                this._pruneTiles();
            }
            if (!err) {
                addClass(tile.el, "leaflet-tile-loaded");
                // @event tileload: TileEvent
                // Fired when a tile loads.
                this.fire("tileload", {
                    tile: tile.el,
                    coords: coords
                });
            }
            if (this._noTilesToLoad()) {
                this._loading = false;
                // @event load: Event
                // Fired when the grid layer loaded all visible tiles.
                this.fire("load");
                if (Browser.ielt9 || !this._map._fadeAnimated) requestAnimFrame(this._pruneTiles, this);
                else // Wait a bit more than 0.2 secs (the duration of the tile fade-in)
                // to trigger a pruning.
                setTimeout(bind(this._pruneTiles, this), 250);
            }
        },
        _getTilePos: function(coords) {
            return coords.scaleBy(this.getTileSize()).subtract(this._level.origin);
        },
        _wrapCoords: function(coords) {
            var newCoords = new Point(this._wrapX ? wrapNum(coords.x, this._wrapX) : coords.x, this._wrapY ? wrapNum(coords.y, this._wrapY) : coords.y);
            newCoords.z = coords.z;
            return newCoords;
        },
        _pxBoundsToTileRange: function(bounds) {
            var tileSize = this.getTileSize();
            return new Bounds(bounds.min.unscaleBy(tileSize).floor(), bounds.max.unscaleBy(tileSize).ceil().subtract([
                1,
                1
            ]));
        },
        _noTilesToLoad: function() {
            for(var key in this._tiles){
                if (!this._tiles[key].loaded) return false;
            }
            return true;
        }
    });
    // @factory L.gridLayer(options?: GridLayer options)
    // Creates a new instance of GridLayer with the supplied options.
    function gridLayer(options) {
        return new GridLayer(options);
    }
    /*
   * @class TileLayer
   * @inherits GridLayer
   * @aka L.TileLayer
   * Used to load and display tile layers on the map. Note that most tile servers require attribution, which you can set under `Layer`. Extends `GridLayer`.
   *
   * @example
   *
   * ```js
   * L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png?{foo}', {foo: 'bar', attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'}).addTo(map);
   * ```
   *
   * @section URL template
   * @example
   *
   * A string of the following form:
   *
   * ```
   * 'https://{s}.somedomain.com/blabla/{z}/{x}/{y}{r}.png'
   * ```
   *
   * `{s}` means one of the available subdomains (used sequentially to help with browser parallel requests per domain limitation; subdomain values are specified in options; `a`, `b` or `c` by default, can be omitted), `{z}` — zoom level, `{x}` and `{y}` — tile coordinates. `{r}` can be used to add "&commat;2x" to the URL to load retina tiles.
   *
   * You can use custom keys in the template, which will be [evaluated](#util-template) from TileLayer options, like this:
   *
   * ```
   * L.tileLayer('https://{s}.somedomain.com/{foo}/{z}/{x}/{y}.png', {foo: 'bar'});
   * ```
   */ var TileLayer = GridLayer.extend({
        // @section
        // @aka TileLayer options
        options: {
            // @option minZoom: Number = 0
            // The minimum zoom level down to which this layer will be displayed (inclusive).
            minZoom: 0,
            // @option maxZoom: Number = 18
            // The maximum zoom level up to which this layer will be displayed (inclusive).
            maxZoom: 18,
            // @option subdomains: String|String[] = 'abc'
            // Subdomains of the tile service. Can be passed in the form of one string (where each letter is a subdomain name) or an array of strings.
            subdomains: "abc",
            // @option errorTileUrl: String = ''
            // URL to the tile image to show in place of the tile that failed to load.
            errorTileUrl: "",
            // @option zoomOffset: Number = 0
            // The zoom number used in tile URLs will be offset with this value.
            zoomOffset: 0,
            // @option tms: Boolean = false
            // If `true`, inverses Y axis numbering for tiles (turn this on for [TMS](https://en.wikipedia.org/wiki/Tile_Map_Service) services).
            tms: false,
            // @option zoomReverse: Boolean = false
            // If set to true, the zoom number used in tile URLs will be reversed (`maxZoom - zoom` instead of `zoom`)
            zoomReverse: false,
            // @option detectRetina: Boolean = false
            // If `true` and user is on a retina display, it will request four tiles of half the specified size and a bigger zoom level in place of one to utilize the high resolution.
            detectRetina: false,
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the tiles.
            // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false,
            // @option referrerPolicy: Boolean|String = false
            // Whether the referrerPolicy attribute will be added to the tiles.
            // If a String is provided, all tiles will have their referrerPolicy attribute set to the String provided.
            // This may be needed if your map's rendering context has a strict default but your tile provider expects a valid referrer
            // (e.g. to validate an API token).
            // Refer to [HTMLImageElement.referrerPolicy](https://developer.mozilla.org/en-US/docs/Web/API/HTMLImageElement/referrerPolicy) for valid String values.
            referrerPolicy: false
        },
        initialize: function(url, options) {
            this._url = url;
            options = setOptions(this, options);
            // detecting retina displays, adjusting tileSize and zoom levels
            if (options.detectRetina && Browser.retina && options.maxZoom > 0) {
                options.tileSize = Math.floor(options.tileSize / 2);
                if (!options.zoomReverse) {
                    options.zoomOffset++;
                    options.maxZoom = Math.max(options.minZoom, options.maxZoom - 1);
                } else {
                    options.zoomOffset--;
                    options.minZoom = Math.min(options.maxZoom, options.minZoom + 1);
                }
                options.minZoom = Math.max(0, options.minZoom);
            } else if (!options.zoomReverse) // make sure maxZoom is gte minZoom
            options.maxZoom = Math.max(options.minZoom, options.maxZoom);
            else // make sure minZoom is lte maxZoom
            options.minZoom = Math.min(options.maxZoom, options.minZoom);
            if (typeof options.subdomains === "string") options.subdomains = options.subdomains.split("");
            this.on("tileunload", this._onTileRemove);
        },
        // @method setUrl(url: String, noRedraw?: Boolean): this
        // Updates the layer's URL template and redraws it (unless `noRedraw` is set to `true`).
        // If the URL does not change, the layer will not be redrawn unless
        // the noRedraw parameter is set to false.
        setUrl: function(url, noRedraw) {
            if (this._url === url && noRedraw === undefined) noRedraw = true;
            this._url = url;
            if (!noRedraw) this.redraw();
            return this;
        },
        // @method createTile(coords: Object, done?: Function): HTMLElement
        // Called only internally, overrides GridLayer's [`createTile()`](#gridlayer-createtile)
        // to return an `<img>` HTML element with the appropriate image URL given `coords`. The `done`
        // callback is called when the tile has been loaded.
        createTile: function(coords, done) {
            var tile = document.createElement("img");
            on(tile, "load", bind(this._tileOnLoad, this, done, tile));
            on(tile, "error", bind(this._tileOnError, this, done, tile));
            if (this.options.crossOrigin || this.options.crossOrigin === "") tile.crossOrigin = this.options.crossOrigin === true ? "" : this.options.crossOrigin;
            // for this new option we follow the documented behavior
            // more closely by only setting the property when string
            if (typeof this.options.referrerPolicy === "string") tile.referrerPolicy = this.options.referrerPolicy;
            // The alt attribute is set to the empty string,
            // allowing screen readers to ignore the decorative image tiles.
            // https://www.w3.org/WAI/tutorials/images/decorative/
            // https://www.w3.org/TR/html-aria/#el-img-empty-alt
            tile.alt = "";
            tile.src = this.getTileUrl(coords);
            return tile;
        },
        // @section Extension methods
        // @uninheritable
        // Layers extending `TileLayer` might reimplement the following method.
        // @method getTileUrl(coords: Object): String
        // Called only internally, returns the URL for a tile given its coordinates.
        // Classes extending `TileLayer` can override this function to provide custom tile URL naming schemes.
        getTileUrl: function(coords) {
            var data = {
                r: Browser.retina ? "@2x" : "",
                s: this._getSubdomain(coords),
                x: coords.x,
                y: coords.y,
                z: this._getZoomForUrl()
            };
            if (this._map && !this._map.options.crs.infinite) {
                var invertedY = this._globalTileRange.max.y - coords.y;
                if (this.options.tms) data["y"] = invertedY;
                data["-y"] = invertedY;
            }
            return template(this._url, extend(data, this.options));
        },
        _tileOnLoad: function(done, tile) {
            // For https://github.com/Leaflet/Leaflet/issues/3332
            if (Browser.ielt9) setTimeout(bind(done, this, null, tile), 0);
            else done(null, tile);
        },
        _tileOnError: function(done, tile, e) {
            var errorUrl = this.options.errorTileUrl;
            if (errorUrl && tile.getAttribute("src") !== errorUrl) tile.src = errorUrl;
            done(e, tile);
        },
        _onTileRemove: function(e) {
            e.tile.onload = null;
        },
        _getZoomForUrl: function() {
            var zoom = this._tileZoom, maxZoom = this.options.maxZoom, zoomReverse = this.options.zoomReverse, zoomOffset = this.options.zoomOffset;
            if (zoomReverse) zoom = maxZoom - zoom;
            return zoom + zoomOffset;
        },
        _getSubdomain: function(tilePoint) {
            var index = Math.abs(tilePoint.x + tilePoint.y) % this.options.subdomains.length;
            return this.options.subdomains[index];
        },
        // stops loading all tiles in the background layer
        _abortLoading: function() {
            var i, tile;
            for(i in this._tiles)if (this._tiles[i].coords.z !== this._tileZoom) {
                tile = this._tiles[i].el;
                tile.onload = falseFn;
                tile.onerror = falseFn;
                if (!tile.complete) {
                    tile.src = emptyImageUrl;
                    var coords = this._tiles[i].coords;
                    remove(tile);
                    delete this._tiles[i];
                    // @event tileabort: TileEvent
                    // Fired when a tile was loading but is now not wanted.
                    this.fire("tileabort", {
                        tile: tile,
                        coords: coords
                    });
                }
            }
        },
        _removeTile: function(key) {
            var tile = this._tiles[key];
            if (!tile) return;
            // Cancels any pending http requests associated with the tile
            tile.el.setAttribute("src", emptyImageUrl);
            return GridLayer.prototype._removeTile.call(this, key);
        },
        _tileReady: function(coords, err, tile) {
            if (!this._map || tile && tile.getAttribute("src") === emptyImageUrl) return;
            return GridLayer.prototype._tileReady.call(this, coords, err, tile);
        }
    });
    // @factory L.tilelayer(urlTemplate: String, options?: TileLayer options)
    // Instantiates a tile layer object given a `URL template` and optionally an options object.
    function tileLayer(url, options) {
        return new TileLayer(url, options);
    }
    /*
   * @class TileLayer.WMS
   * @inherits TileLayer
   * @aka L.TileLayer.WMS
   * Used to display [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services as tile layers on the map. Extends `TileLayer`.
   *
   * @example
   *
   * ```js
   * var nexrad = L.tileLayer.wms("http://mesonet.agron.iastate.edu/cgi-bin/wms/nexrad/n0r.cgi", {
   * 	layers: 'nexrad-n0r-900913',
   * 	format: 'image/png',
   * 	transparent: true,
   * 	attribution: "Weather data © 2012 IEM Nexrad"
   * });
   * ```
   */ var TileLayerWMS = TileLayer.extend({
        // @section
        // @aka TileLayer.WMS options
        // If any custom options not documented here are used, they will be sent to the
        // WMS server as extra parameters in each request URL. This can be useful for
        // [non-standard vendor WMS parameters](https://docs.geoserver.org/stable/en/user/services/wms/vendor.html).
        defaultWmsParams: {
            service: "WMS",
            request: "GetMap",
            // @option layers: String = ''
            // **(required)** Comma-separated list of WMS layers to show.
            layers: "",
            // @option styles: String = ''
            // Comma-separated list of WMS styles.
            styles: "",
            // @option format: String = 'image/jpeg'
            // WMS image format (use `'image/png'` for layers with transparency).
            format: "image/jpeg",
            // @option transparent: Boolean = false
            // If `true`, the WMS service will return images with transparency.
            transparent: false,
            // @option version: String = '1.1.1'
            // Version of the WMS service to use
            version: "1.1.1"
        },
        options: {
            // @option crs: CRS = null
            // Coordinate Reference System to use for the WMS requests, defaults to
            // map CRS. Don't change this if you're not sure what it means.
            crs: null,
            // @option uppercase: Boolean = false
            // If `true`, WMS request parameter keys will be uppercase.
            uppercase: false
        },
        initialize: function(url, options) {
            this._url = url;
            var wmsParams = extend({}, this.defaultWmsParams);
            // all keys that are not TileLayer options go to WMS params
            for(var i in options)if (!(i in this.options)) wmsParams[i] = options[i];
            options = setOptions(this, options);
            var realRetina = options.detectRetina && Browser.retina ? 2 : 1;
            var tileSize = this.getTileSize();
            wmsParams.width = tileSize.x * realRetina;
            wmsParams.height = tileSize.y * realRetina;
            this.wmsParams = wmsParams;
        },
        onAdd: function(map) {
            this._crs = this.options.crs || map.options.crs;
            this._wmsVersion = parseFloat(this.wmsParams.version);
            var projectionKey = this._wmsVersion >= 1.3 ? "crs" : "srs";
            this.wmsParams[projectionKey] = this._crs.code;
            TileLayer.prototype.onAdd.call(this, map);
        },
        getTileUrl: function(coords) {
            var tileBounds = this._tileCoordsToNwSe(coords), crs = this._crs, bounds = toBounds(crs.project(tileBounds[0]), crs.project(tileBounds[1])), min = bounds.min, max = bounds.max, bbox = (this._wmsVersion >= 1.3 && this._crs === EPSG4326 ? [
                min.y,
                min.x,
                max.y,
                max.x
            ] : [
                min.x,
                min.y,
                max.x,
                max.y
            ]).join(","), url = TileLayer.prototype.getTileUrl.call(this, coords);
            return url + getParamString(this.wmsParams, url, this.options.uppercase) + (this.options.uppercase ? "&BBOX=" : "&bbox=") + bbox;
        },
        // @method setParams(params: Object, noRedraw?: Boolean): this
        // Merges an object with the new parameters and re-requests tiles on the current screen (unless `noRedraw` was set to true).
        setParams: function(params, noRedraw) {
            extend(this.wmsParams, params);
            if (!noRedraw) this.redraw();
            return this;
        }
    });
    // @factory L.tileLayer.wms(baseUrl: String, options: TileLayer.WMS options)
    // Instantiates a WMS tile layer object given a base URL of the WMS service and a WMS parameters/options object.
    function tileLayerWMS(url, options) {
        return new TileLayerWMS(url, options);
    }
    TileLayer.WMS = TileLayerWMS;
    tileLayer.wms = tileLayerWMS;
    /*
   * @class Renderer
   * @inherits Layer
   * @aka L.Renderer
   *
   * Base class for vector renderer implementations (`SVG`, `Canvas`). Handles the
   * DOM container of the renderer, its bounds, and its zoom animation.
   *
   * A `Renderer` works as an implicit layer group for all `Path`s - the renderer
   * itself can be added or removed to the map. All paths use a renderer, which can
   * be implicit (the map will decide the type of renderer and use it automatically)
   * or explicit (using the [`renderer`](#path-renderer) option of the path).
   *
   * Do not use this class directly, use `SVG` and `Canvas` instead.
   *
   * @event update: Event
   * Fired when the renderer updates its bounds, center and zoom, for example when
   * its map has moved
   */ var Renderer = Layer.extend({
        // @section
        // @aka Renderer options
        options: {
            // @option padding: Number = 0.1
            // How much to extend the clip area around the map view (relative to its size)
            // e.g. 0.1 would be 10% of map view in each direction
            padding: 0.1
        },
        initialize: function(options) {
            setOptions(this, options);
            stamp(this);
            this._layers = this._layers || {};
        },
        onAdd: function() {
            if (!this._container) {
                this._initContainer(); // defined by renderer implementations
                // always keep transform-origin as 0 0
                addClass(this._container, "leaflet-zoom-animated");
            }
            this.getPane().appendChild(this._container);
            this._update();
            this.on("update", this._updatePaths, this);
        },
        onRemove: function() {
            this.off("update", this._updatePaths, this);
            this._destroyContainer();
        },
        getEvents: function() {
            var events = {
                viewreset: this._reset,
                zoom: this._onZoom,
                moveend: this._update,
                zoomend: this._onZoomEnd
            };
            if (this._zoomAnimated) events.zoomanim = this._onAnimZoom;
            return events;
        },
        _onAnimZoom: function(ev) {
            this._updateTransform(ev.center, ev.zoom);
        },
        _onZoom: function() {
            this._updateTransform(this._map.getCenter(), this._map.getZoom());
        },
        _updateTransform: function(center, zoom) {
            var scale = this._map.getZoomScale(zoom, this._zoom), viewHalf = this._map.getSize().multiplyBy(0.5 + this.options.padding), currentCenterPoint = this._map.project(this._center, zoom), topLeftOffset = viewHalf.multiplyBy(-scale).add(currentCenterPoint).subtract(this._map._getNewPixelOrigin(center, zoom));
            if (Browser.any3d) setTransform(this._container, topLeftOffset, scale);
            else setPosition(this._container, topLeftOffset);
        },
        _reset: function() {
            this._update();
            this._updateTransform(this._center, this._zoom);
            for(var id in this._layers)this._layers[id]._reset();
        },
        _onZoomEnd: function() {
            for(var id in this._layers)this._layers[id]._project();
        },
        _updatePaths: function() {
            for(var id in this._layers)this._layers[id]._update();
        },
        _update: function() {
            // Update pixel bounds of renderer container (for positioning/sizing/clipping later)
            // Subclasses are responsible of firing the 'update' event.
            var p = this.options.padding, size = this._map.getSize(), min = this._map.containerPointToLayerPoint(size.multiplyBy(-p)).round();
            this._bounds = new Bounds(min, min.add(size.multiplyBy(1 + p * 2)).round());
            this._center = this._map.getCenter();
            this._zoom = this._map.getZoom();
        }
    });
    /*
   * @class Canvas
   * @inherits Renderer
   * @aka L.Canvas
   *
   * Allows vector layers to be displayed with [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
   * Inherits `Renderer`.
   *
   * Due to [technical limitations](https://caniuse.com/canvas), Canvas is not
   * available in all web browsers, notably IE8, and overlapping geometries might
   * not display properly in some edge cases.
   *
   * @example
   *
   * Use Canvas by default for all paths in the map:
   *
   * ```js
   * var map = L.map('map', {
   * 	renderer: L.canvas()
   * });
   * ```
   *
   * Use a Canvas renderer with extra padding for specific vector geometries:
   *
   * ```js
   * var map = L.map('map');
   * var myRenderer = L.canvas({ padding: 0.5 });
   * var line = L.polyline( coordinates, { renderer: myRenderer } );
   * var circle = L.circle( center, { renderer: myRenderer } );
   * ```
   */ var Canvas = Renderer.extend({
        // @section
        // @aka Canvas options
        options: {
            // @option tolerance: Number = 0
            // How much to extend the click tolerance around a path/object on the map.
            tolerance: 0
        },
        getEvents: function() {
            var events = Renderer.prototype.getEvents.call(this);
            events.viewprereset = this._onViewPreReset;
            return events;
        },
        _onViewPreReset: function() {
            // Set a flag so that a viewprereset+moveend+viewreset only updates&redraws once
            this._postponeUpdatePaths = true;
        },
        onAdd: function() {
            Renderer.prototype.onAdd.call(this);
            // Redraw vectors since canvas is cleared upon removal,
            // in case of removing the renderer itself from the map.
            this._draw();
        },
        _initContainer: function() {
            var container = this._container = document.createElement("canvas");
            on(container, "mousemove", this._onMouseMove, this);
            on(container, "click dblclick mousedown mouseup contextmenu", this._onClick, this);
            on(container, "mouseout", this._handleMouseOut, this);
            container["_leaflet_disable_events"] = true;
            this._ctx = container.getContext("2d");
        },
        _destroyContainer: function() {
            cancelAnimFrame(this._redrawRequest);
            delete this._ctx;
            remove(this._container);
            off(this._container);
            delete this._container;
        },
        _updatePaths: function() {
            if (this._postponeUpdatePaths) return;
            var layer;
            this._redrawBounds = null;
            for(var id in this._layers){
                layer = this._layers[id];
                layer._update();
            }
            this._redraw();
        },
        _update: function() {
            if (this._map._animatingZoom && this._bounds) return;
            Renderer.prototype._update.call(this);
            var b = this._bounds, container = this._container, size = b.getSize(), m = Browser.retina ? 2 : 1;
            setPosition(container, b.min);
            // set canvas size (also clearing it); use double size on retina
            container.width = m * size.x;
            container.height = m * size.y;
            container.style.width = size.x + "px";
            container.style.height = size.y + "px";
            if (Browser.retina) this._ctx.scale(2, 2);
            // translate so we use the same path coordinates after canvas element moves
            this._ctx.translate(-b.min.x, -b.min.y);
            // Tell paths to redraw themselves
            this.fire("update");
        },
        _reset: function() {
            Renderer.prototype._reset.call(this);
            if (this._postponeUpdatePaths) {
                this._postponeUpdatePaths = false;
                this._updatePaths();
            }
        },
        _initPath: function(layer) {
            this._updateDashArray(layer);
            this._layers[stamp(layer)] = layer;
            var order = layer._order = {
                layer: layer,
                prev: this._drawLast,
                next: null
            };
            if (this._drawLast) this._drawLast.next = order;
            this._drawLast = order;
            this._drawFirst = this._drawFirst || this._drawLast;
        },
        _addPath: function(layer) {
            this._requestRedraw(layer);
        },
        _removePath: function(layer) {
            var order = layer._order;
            var next = order.next;
            var prev = order.prev;
            if (next) next.prev = prev;
            else this._drawLast = prev;
            if (prev) prev.next = next;
            else this._drawFirst = next;
            delete layer._order;
            delete this._layers[stamp(layer)];
            this._requestRedraw(layer);
        },
        _updatePath: function(layer) {
            // Redraw the union of the layer's old pixel
            // bounds and the new pixel bounds.
            this._extendRedrawBounds(layer);
            layer._project();
            layer._update();
            // The redraw will extend the redraw bounds
            // with the new pixel bounds.
            this._requestRedraw(layer);
        },
        _updateStyle: function(layer) {
            this._updateDashArray(layer);
            this._requestRedraw(layer);
        },
        _updateDashArray: function(layer) {
            if (typeof layer.options.dashArray === "string") {
                var parts = layer.options.dashArray.split(/[, ]+/), dashArray = [], dashValue, i;
                for(i = 0; i < parts.length; i++){
                    dashValue = Number(parts[i]);
                    // Ignore dash array containing invalid lengths
                    if (isNaN(dashValue)) return;
                    dashArray.push(dashValue);
                }
                layer.options._dashArray = dashArray;
            } else layer.options._dashArray = layer.options.dashArray;
        },
        _requestRedraw: function(layer) {
            if (!this._map) return;
            this._extendRedrawBounds(layer);
            this._redrawRequest = this._redrawRequest || requestAnimFrame(this._redraw, this);
        },
        _extendRedrawBounds: function(layer) {
            if (layer._pxBounds) {
                var padding = (layer.options.weight || 0) + 1;
                this._redrawBounds = this._redrawBounds || new Bounds();
                this._redrawBounds.extend(layer._pxBounds.min.subtract([
                    padding,
                    padding
                ]));
                this._redrawBounds.extend(layer._pxBounds.max.add([
                    padding,
                    padding
                ]));
            }
        },
        _redraw: function() {
            this._redrawRequest = null;
            if (this._redrawBounds) {
                this._redrawBounds.min._floor();
                this._redrawBounds.max._ceil();
            }
            this._clear(); // clear layers in redraw bounds
            this._draw(); // draw layers
            this._redrawBounds = null;
        },
        _clear: function() {
            var bounds = this._redrawBounds;
            if (bounds) {
                var size = bounds.getSize();
                this._ctx.clearRect(bounds.min.x, bounds.min.y, size.x, size.y);
            } else {
                this._ctx.save();
                this._ctx.setTransform(1, 0, 0, 1, 0, 0);
                this._ctx.clearRect(0, 0, this._container.width, this._container.height);
                this._ctx.restore();
            }
        },
        _draw: function() {
            var layer, bounds = this._redrawBounds;
            this._ctx.save();
            if (bounds) {
                var size = bounds.getSize();
                this._ctx.beginPath();
                this._ctx.rect(bounds.min.x, bounds.min.y, size.x, size.y);
                this._ctx.clip();
            }
            this._drawing = true;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (!bounds || layer._pxBounds && layer._pxBounds.intersects(bounds)) layer._updatePath();
            }
            this._drawing = false;
            this._ctx.restore(); // Restore state before clipping.
        },
        _updatePoly: function(layer, closed) {
            if (!this._drawing) return;
            var i, j, len2, p, parts = layer._parts, len = parts.length, ctx = this._ctx;
            if (!len) return;
            ctx.beginPath();
            for(i = 0; i < len; i++){
                for(j = 0, len2 = parts[i].length; j < len2; j++){
                    p = parts[i][j];
                    ctx[j ? "lineTo" : "moveTo"](p.x, p.y);
                }
                if (closed) ctx.closePath();
            }
            this._fillStroke(ctx, layer);
        // TODO optimization: 1 fill/stroke for all features with equal style instead of 1 for each feature
        },
        _updateCircle: function(layer) {
            if (!this._drawing || layer._empty()) return;
            var p = layer._point, ctx = this._ctx, r = Math.max(Math.round(layer._radius), 1), s = (Math.max(Math.round(layer._radiusY), 1) || r) / r;
            if (s !== 1) {
                ctx.save();
                ctx.scale(1, s);
            }
            ctx.beginPath();
            ctx.arc(p.x, p.y / s, r, 0, Math.PI * 2, false);
            if (s !== 1) ctx.restore();
            this._fillStroke(ctx, layer);
        },
        _fillStroke: function(ctx, layer) {
            var options = layer.options;
            if (options.fill) {
                ctx.globalAlpha = options.fillOpacity;
                ctx.fillStyle = options.fillColor || options.color;
                ctx.fill(options.fillRule || "evenodd");
            }
            if (options.stroke && options.weight !== 0) {
                if (ctx.setLineDash) ctx.setLineDash(layer.options && layer.options._dashArray || []);
                ctx.globalAlpha = options.opacity;
                ctx.lineWidth = options.weight;
                ctx.strokeStyle = options.color;
                ctx.lineCap = options.lineCap;
                ctx.lineJoin = options.lineJoin;
                ctx.stroke();
            }
        },
        // Canvas obviously doesn't have mouse events for individual drawn objects,
        // so we emulate that by calculating what's under the mouse on mousemove/click manually
        _onClick: function(e) {
            var point = this._map.mouseEventToLayerPoint(e), layer, clickedLayer;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (layer.options.interactive && layer._containsPoint(point)) {
                    if (!(e.type === "click" || e.type === "preclick") || !this._map._draggableMoved(layer)) clickedLayer = layer;
                }
            }
            this._fireEvent(clickedLayer ? [
                clickedLayer
            ] : false, e);
        },
        _onMouseMove: function(e) {
            if (!this._map || this._map.dragging.moving() || this._map._animatingZoom) return;
            var point = this._map.mouseEventToLayerPoint(e);
            this._handleMouseHover(e, point);
        },
        _handleMouseOut: function(e) {
            var layer = this._hoveredLayer;
            if (layer) {
                // if we're leaving the layer, fire mouseout
                removeClass(this._container, "leaflet-interactive");
                this._fireEvent([
                    layer
                ], e, "mouseout");
                this._hoveredLayer = null;
                this._mouseHoverThrottled = false;
            }
        },
        _handleMouseHover: function(e, point) {
            if (this._mouseHoverThrottled) return;
            var layer, candidateHoveredLayer;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (layer.options.interactive && layer._containsPoint(point)) candidateHoveredLayer = layer;
            }
            if (candidateHoveredLayer !== this._hoveredLayer) {
                this._handleMouseOut(e);
                if (candidateHoveredLayer) {
                    addClass(this._container, "leaflet-interactive"); // change cursor
                    this._fireEvent([
                        candidateHoveredLayer
                    ], e, "mouseover");
                    this._hoveredLayer = candidateHoveredLayer;
                }
            }
            this._fireEvent(this._hoveredLayer ? [
                this._hoveredLayer
            ] : false, e);
            this._mouseHoverThrottled = true;
            setTimeout(bind(function() {
                this._mouseHoverThrottled = false;
            }, this), 32);
        },
        _fireEvent: function(layers, e, type) {
            this._map._fireDOMEvent(e, type || e.type, layers);
        },
        _bringToFront: function(layer) {
            var order = layer._order;
            if (!order) return;
            var next = order.next;
            var prev = order.prev;
            if (next) next.prev = prev;
            else // Already last
            return;
            if (prev) prev.next = next;
            else if (next) // Update first entry unless this is the
            // single entry
            this._drawFirst = next;
            order.prev = this._drawLast;
            this._drawLast.next = order;
            order.next = null;
            this._drawLast = order;
            this._requestRedraw(layer);
        },
        _bringToBack: function(layer) {
            var order = layer._order;
            if (!order) return;
            var next = order.next;
            var prev = order.prev;
            if (prev) prev.next = next;
            else // Already first
            return;
            if (next) next.prev = prev;
            else if (prev) // Update last entry unless this is the
            // single entry
            this._drawLast = prev;
            order.prev = null;
            order.next = this._drawFirst;
            this._drawFirst.prev = order;
            this._drawFirst = order;
            this._requestRedraw(layer);
        }
    });
    // @factory L.canvas(options?: Renderer options)
    // Creates a Canvas renderer with the given options.
    function canvas(options) {
        return Browser.canvas ? new Canvas(options) : null;
    }
    /*
   * Thanks to Dmitry Baranovsky and his Raphael library for inspiration!
   */ var vmlCreate = function() {
        try {
            document.namespaces.add("lvml", "urn:schemas-microsoft-com:vml");
            return function(name) {
                return document.createElement("<lvml:" + name + ' class="lvml">');
            };
        } catch (e) {
        // Do not return fn from catch block so `e` can be garbage collected
        // See https://github.com/Leaflet/Leaflet/pull/7279
        }
        return function(name) {
            return document.createElement("<" + name + ' xmlns="urn:schemas-microsoft.com:vml" class="lvml">');
        };
    }();
    /*
   * @class SVG
   *
   *
   * VML was deprecated in 2012, which means VML functionality exists only for backwards compatibility
   * with old versions of Internet Explorer.
   */ // mixin to redefine some SVG methods to handle VML syntax which is similar but with some differences
    var vmlMixin = {
        _initContainer: function() {
            this._container = create$1("div", "leaflet-vml-container");
        },
        _update: function() {
            if (this._map._animatingZoom) return;
            Renderer.prototype._update.call(this);
            this.fire("update");
        },
        _initPath: function(layer) {
            var container = layer._container = vmlCreate("shape");
            addClass(container, "leaflet-vml-shape " + (this.options.className || ""));
            container.coordsize = "1 1";
            layer._path = vmlCreate("path");
            container.appendChild(layer._path);
            this._updateStyle(layer);
            this._layers[stamp(layer)] = layer;
        },
        _addPath: function(layer) {
            var container = layer._container;
            this._container.appendChild(container);
            if (layer.options.interactive) layer.addInteractiveTarget(container);
        },
        _removePath: function(layer) {
            var container = layer._container;
            remove(container);
            layer.removeInteractiveTarget(container);
            delete this._layers[stamp(layer)];
        },
        _updateStyle: function(layer) {
            var stroke = layer._stroke, fill = layer._fill, options = layer.options, container = layer._container;
            container.stroked = !!options.stroke;
            container.filled = !!options.fill;
            if (options.stroke) {
                if (!stroke) stroke = layer._stroke = vmlCreate("stroke");
                container.appendChild(stroke);
                stroke.weight = options.weight + "px";
                stroke.color = options.color;
                stroke.opacity = options.opacity;
                if (options.dashArray) stroke.dashStyle = isArray(options.dashArray) ? options.dashArray.join(" ") : options.dashArray.replace(/( *, *)/g, " ");
                else stroke.dashStyle = "";
                stroke.endcap = options.lineCap.replace("butt", "flat");
                stroke.joinstyle = options.lineJoin;
            } else if (stroke) {
                container.removeChild(stroke);
                layer._stroke = null;
            }
            if (options.fill) {
                if (!fill) fill = layer._fill = vmlCreate("fill");
                container.appendChild(fill);
                fill.color = options.fillColor || options.color;
                fill.opacity = options.fillOpacity;
            } else if (fill) {
                container.removeChild(fill);
                layer._fill = null;
            }
        },
        _updateCircle: function(layer) {
            var p = layer._point.round(), r = Math.round(layer._radius), r2 = Math.round(layer._radiusY || r);
            this._setPath(layer, layer._empty() ? "M0 0" : "AL " + p.x + "," + p.y + " " + r + "," + r2 + " 0," + 23592600);
        },
        _setPath: function(layer, path) {
            layer._path.v = path;
        },
        _bringToFront: function(layer) {
            toFront(layer._container);
        },
        _bringToBack: function(layer) {
            toBack(layer._container);
        }
    };
    var create = Browser.vml ? vmlCreate : svgCreate;
    /*
   * @class SVG
   * @inherits Renderer
   * @aka L.SVG
   *
   * Allows vector layers to be displayed with [SVG](https://developer.mozilla.org/docs/Web/SVG).
   * Inherits `Renderer`.
   *
   * Due to [technical limitations](https://caniuse.com/svg), SVG is not
   * available in all web browsers, notably Android 2.x and 3.x.
   *
   * Although SVG is not available on IE7 and IE8, these browsers support
   * [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language)
   * (a now deprecated technology), and the SVG renderer will fall back to VML in
   * this case.
   *
   * @example
   *
   * Use SVG by default for all paths in the map:
   *
   * ```js
   * var map = L.map('map', {
   * 	renderer: L.svg()
   * });
   * ```
   *
   * Use a SVG renderer with extra padding for specific vector geometries:
   *
   * ```js
   * var map = L.map('map');
   * var myRenderer = L.svg({ padding: 0.5 });
   * var line = L.polyline( coordinates, { renderer: myRenderer } );
   * var circle = L.circle( center, { renderer: myRenderer } );
   * ```
   */ var SVG = Renderer.extend({
        _initContainer: function() {
            this._container = create("svg");
            // makes it possible to click through svg root; we'll reset it back in individual paths
            this._container.setAttribute("pointer-events", "none");
            this._rootGroup = create("g");
            this._container.appendChild(this._rootGroup);
        },
        _destroyContainer: function() {
            remove(this._container);
            off(this._container);
            delete this._container;
            delete this._rootGroup;
            delete this._svgSize;
        },
        _update: function() {
            if (this._map._animatingZoom && this._bounds) return;
            Renderer.prototype._update.call(this);
            var b = this._bounds, size = b.getSize(), container = this._container;
            // set size of svg-container if changed
            if (!this._svgSize || !this._svgSize.equals(size)) {
                this._svgSize = size;
                container.setAttribute("width", size.x);
                container.setAttribute("height", size.y);
            }
            // movement: update container viewBox so that we don't have to change coordinates of individual layers
            setPosition(container, b.min);
            container.setAttribute("viewBox", [
                b.min.x,
                b.min.y,
                size.x,
                size.y
            ].join(" "));
            this.fire("update");
        },
        // methods below are called by vector layers implementations
        _initPath: function(layer) {
            var path = layer._path = create("path");
            // @namespace Path
            // @option className: String = null
            // Custom class name set on an element. Only for SVG renderer.
            if (layer.options.className) addClass(path, layer.options.className);
            if (layer.options.interactive) addClass(path, "leaflet-interactive");
            this._updateStyle(layer);
            this._layers[stamp(layer)] = layer;
        },
        _addPath: function(layer) {
            if (!this._rootGroup) this._initContainer();
            this._rootGroup.appendChild(layer._path);
            layer.addInteractiveTarget(layer._path);
        },
        _removePath: function(layer) {
            remove(layer._path);
            layer.removeInteractiveTarget(layer._path);
            delete this._layers[stamp(layer)];
        },
        _updatePath: function(layer) {
            layer._project();
            layer._update();
        },
        _updateStyle: function(layer) {
            var path = layer._path, options = layer.options;
            if (!path) return;
            if (options.stroke) {
                path.setAttribute("stroke", options.color);
                path.setAttribute("stroke-opacity", options.opacity);
                path.setAttribute("stroke-width", options.weight);
                path.setAttribute("stroke-linecap", options.lineCap);
                path.setAttribute("stroke-linejoin", options.lineJoin);
                if (options.dashArray) path.setAttribute("stroke-dasharray", options.dashArray);
                else path.removeAttribute("stroke-dasharray");
                if (options.dashOffset) path.setAttribute("stroke-dashoffset", options.dashOffset);
                else path.removeAttribute("stroke-dashoffset");
            } else path.setAttribute("stroke", "none");
            if (options.fill) {
                path.setAttribute("fill", options.fillColor || options.color);
                path.setAttribute("fill-opacity", options.fillOpacity);
                path.setAttribute("fill-rule", options.fillRule || "evenodd");
            } else path.setAttribute("fill", "none");
        },
        _updatePoly: function(layer, closed) {
            this._setPath(layer, pointsToPath(layer._parts, closed));
        },
        _updateCircle: function(layer) {
            var p = layer._point, r = Math.max(Math.round(layer._radius), 1), r2 = Math.max(Math.round(layer._radiusY), 1) || r, arc = "a" + r + "," + r2 + " 0 1,0 ";
            // drawing a circle with two half-arcs
            var d = layer._empty() ? "M0 0" : "M" + (p.x - r) + "," + p.y + arc + r * 2 + ",0 " + arc + -r * 2 + ",0 ";
            this._setPath(layer, d);
        },
        _setPath: function(layer, path) {
            layer._path.setAttribute("d", path);
        },
        // SVG does not have the concept of zIndex so we resort to changing the DOM order of elements
        _bringToFront: function(layer) {
            toFront(layer._path);
        },
        _bringToBack: function(layer) {
            toBack(layer._path);
        }
    });
    if (Browser.vml) SVG.include(vmlMixin);
    // @namespace SVG
    // @factory L.svg(options?: Renderer options)
    // Creates a SVG renderer with the given options.
    function svg(options) {
        return Browser.svg || Browser.vml ? new SVG(options) : null;
    }
    Map.include({
        // @namespace Map; @method getRenderer(layer: Path): Renderer
        // Returns the instance of `Renderer` that should be used to render the given
        // `Path`. It will ensure that the `renderer` options of the map and paths
        // are respected, and that the renderers do exist on the map.
        getRenderer: function(layer) {
            // @namespace Path; @option renderer: Renderer
            // Use this specific instance of `Renderer` for this path. Takes
            // precedence over the map's [default renderer](#map-renderer).
            var renderer = layer.options.renderer || this._getPaneRenderer(layer.options.pane) || this.options.renderer || this._renderer;
            if (!renderer) renderer = this._renderer = this._createRenderer();
            if (!this.hasLayer(renderer)) this.addLayer(renderer);
            return renderer;
        },
        _getPaneRenderer: function(name) {
            if (name === "overlayPane" || name === undefined) return false;
            var renderer = this._paneRenderers[name];
            if (renderer === undefined) {
                renderer = this._createRenderer({
                    pane: name
                });
                this._paneRenderers[name] = renderer;
            }
            return renderer;
        },
        _createRenderer: function(options) {
            // @namespace Map; @option preferCanvas: Boolean = false
            // Whether `Path`s should be rendered on a `Canvas` renderer.
            // By default, all `Path`s are rendered in a `SVG` renderer.
            return this.options.preferCanvas && canvas(options) || svg(options);
        }
    });
    /*
   * L.Rectangle extends Polygon and creates a rectangle when passed a LatLngBounds object.
   */ /*
   * @class Rectangle
   * @aka L.Rectangle
   * @inherits Polygon
   *
   * A class for drawing rectangle overlays on a map. Extends `Polygon`.
   *
   * @example
   *
   * ```js
   * // define rectangle geographical bounds
   * var bounds = [[54.559322, -5.767822], [56.1210604, -3.021240]];
   *
   * // create an orange rectangle
   * L.rectangle(bounds, {color: "#ff7800", weight: 1}).addTo(map);
   *
   * // zoom the map to the rectangle bounds
   * map.fitBounds(bounds);
   * ```
   *
   */ var Rectangle = Polygon.extend({
        initialize: function(latLngBounds, options) {
            Polygon.prototype.initialize.call(this, this._boundsToLatLngs(latLngBounds), options);
        },
        // @method setBounds(latLngBounds: LatLngBounds): this
        // Redraws the rectangle with the passed bounds.
        setBounds: function(latLngBounds) {
            return this.setLatLngs(this._boundsToLatLngs(latLngBounds));
        },
        _boundsToLatLngs: function(latLngBounds) {
            latLngBounds = toLatLngBounds(latLngBounds);
            return [
                latLngBounds.getSouthWest(),
                latLngBounds.getNorthWest(),
                latLngBounds.getNorthEast(),
                latLngBounds.getSouthEast()
            ];
        }
    });
    // @factory L.rectangle(latLngBounds: LatLngBounds, options?: Polyline options)
    function rectangle(latLngBounds, options) {
        return new Rectangle(latLngBounds, options);
    }
    SVG.create = create;
    SVG.pointsToPath = pointsToPath;
    GeoJSON.geometryToLayer = geometryToLayer;
    GeoJSON.coordsToLatLng = coordsToLatLng;
    GeoJSON.coordsToLatLngs = coordsToLatLngs;
    GeoJSON.latLngToCoords = latLngToCoords;
    GeoJSON.latLngsToCoords = latLngsToCoords;
    GeoJSON.getFeature = getFeature;
    GeoJSON.asFeature = asFeature;
    /*
   * L.Handler.BoxZoom is used to add shift-drag zoom interaction to the map
   * (zoom to a selected bounding box), enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option boxZoom: Boolean = true
        // Whether the map can be zoomed to a rectangular area specified by
        // dragging the mouse while pressing the shift key.
        boxZoom: true
    });
    var BoxZoom = Handler.extend({
        initialize: function(map) {
            this._map = map;
            this._container = map._container;
            this._pane = map._panes.overlayPane;
            this._resetStateTimeout = 0;
            map.on("unload", this._destroy, this);
        },
        addHooks: function() {
            on(this._container, "mousedown", this._onMouseDown, this);
        },
        removeHooks: function() {
            off(this._container, "mousedown", this._onMouseDown, this);
        },
        moved: function() {
            return this._moved;
        },
        _destroy: function() {
            remove(this._pane);
            delete this._pane;
        },
        _resetState: function() {
            this._resetStateTimeout = 0;
            this._moved = false;
        },
        _clearDeferredResetState: function() {
            if (this._resetStateTimeout !== 0) {
                clearTimeout(this._resetStateTimeout);
                this._resetStateTimeout = 0;
            }
        },
        _onMouseDown: function(e) {
            if (!e.shiftKey || e.which !== 1 && e.button !== 1) return false;
            // Clear the deferred resetState if it hasn't executed yet, otherwise it
            // will interrupt the interaction and orphan a box element in the container.
            this._clearDeferredResetState();
            this._resetState();
            disableTextSelection();
            disableImageDrag();
            this._startPoint = this._map.mouseEventToContainerPoint(e);
            on(document, {
                contextmenu: stop,
                mousemove: this._onMouseMove,
                mouseup: this._onMouseUp,
                keydown: this._onKeyDown
            }, this);
        },
        _onMouseMove: function(e) {
            if (!this._moved) {
                this._moved = true;
                this._box = create$1("div", "leaflet-zoom-box", this._container);
                addClass(this._container, "leaflet-crosshair");
                this._map.fire("boxzoomstart");
            }
            this._point = this._map.mouseEventToContainerPoint(e);
            var bounds = new Bounds(this._point, this._startPoint), size = bounds.getSize();
            setPosition(this._box, bounds.min);
            this._box.style.width = size.x + "px";
            this._box.style.height = size.y + "px";
        },
        _finish: function() {
            if (this._moved) {
                remove(this._box);
                removeClass(this._container, "leaflet-crosshair");
            }
            enableTextSelection();
            enableImageDrag();
            off(document, {
                contextmenu: stop,
                mousemove: this._onMouseMove,
                mouseup: this._onMouseUp,
                keydown: this._onKeyDown
            }, this);
        },
        _onMouseUp: function(e) {
            if (e.which !== 1 && e.button !== 1) return;
            this._finish();
            if (!this._moved) return;
            // Postpone to next JS tick so internal click event handling
            // still see it as "moved".
            this._clearDeferredResetState();
            this._resetStateTimeout = setTimeout(bind(this._resetState, this), 0);
            var bounds = new LatLngBounds(this._map.containerPointToLatLng(this._startPoint), this._map.containerPointToLatLng(this._point));
            this._map.fitBounds(bounds).fire("boxzoomend", {
                boxZoomBounds: bounds
            });
        },
        _onKeyDown: function(e) {
            if (e.keyCode === 27) {
                this._finish();
                this._clearDeferredResetState();
                this._resetState();
            }
        }
    });
    // @section Handlers
    // @property boxZoom: Handler
    // Box (shift-drag with mouse) zoom handler.
    Map.addInitHook("addHandler", "boxZoom", BoxZoom);
    /*
   * L.Handler.DoubleClickZoom is used to handle double-click zoom on the map, enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option doubleClickZoom: Boolean|String = true
        // Whether the map can be zoomed in by double clicking on it and
        // zoomed out by double clicking while holding shift. If passed
        // `'center'`, double-click zoom will zoom to the center of the
        //  view regardless of where the mouse was.
        doubleClickZoom: true
    });
    var DoubleClickZoom = Handler.extend({
        addHooks: function() {
            this._map.on("dblclick", this._onDoubleClick, this);
        },
        removeHooks: function() {
            this._map.off("dblclick", this._onDoubleClick, this);
        },
        _onDoubleClick: function(e) {
            var map = this._map, oldZoom = map.getZoom(), delta = map.options.zoomDelta, zoom = e.originalEvent.shiftKey ? oldZoom - delta : oldZoom + delta;
            if (map.options.doubleClickZoom === "center") map.setZoom(zoom);
            else map.setZoomAround(e.containerPoint, zoom);
        }
    });
    // @section Handlers
    //
    // Map properties include interaction handlers that allow you to control
    // interaction behavior in runtime, enabling or disabling certain features such
    // as dragging or touch zoom (see `Handler` methods). For example:
    //
    // ```js
    // map.doubleClickZoom.disable();
    // ```
    //
    // @property doubleClickZoom: Handler
    // Double click zoom handler.
    Map.addInitHook("addHandler", "doubleClickZoom", DoubleClickZoom);
    /*
   * L.Handler.MapDrag is used to make the map draggable (with panning inertia), enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option dragging: Boolean = true
        // Whether the map is draggable with mouse/touch or not.
        dragging: true,
        // @section Panning Inertia Options
        // @option inertia: Boolean = *
        // If enabled, panning of the map will have an inertia effect where
        // the map builds momentum while dragging and continues moving in
        // the same direction for some time. Feels especially nice on touch
        // devices. Enabled by default.
        inertia: true,
        // @option inertiaDeceleration: Number = 3000
        // The rate with which the inertial movement slows down, in pixels/second².
        inertiaDeceleration: 3400,
        // @option inertiaMaxSpeed: Number = Infinity
        // Max speed of the inertial movement, in pixels/second.
        inertiaMaxSpeed: Infinity,
        // @option easeLinearity: Number = 0.2
        easeLinearity: 0.2,
        // TODO refactor, move to CRS
        // @option worldCopyJump: Boolean = false
        // With this option enabled, the map tracks when you pan to another "copy"
        // of the world and seamlessly jumps to the original one so that all overlays
        // like markers and vector layers are still visible.
        worldCopyJump: false,
        // @option maxBoundsViscosity: Number = 0.0
        // If `maxBounds` is set, this option will control how solid the bounds
        // are when dragging the map around. The default value of `0.0` allows the
        // user to drag outside the bounds at normal speed, higher values will
        // slow down map dragging outside bounds, and `1.0` makes the bounds fully
        // solid, preventing the user from dragging outside the bounds.
        maxBoundsViscosity: 0.0
    });
    var Drag = Handler.extend({
        addHooks: function() {
            if (!this._draggable) {
                var map = this._map;
                this._draggable = new Draggable(map._mapPane, map._container);
                this._draggable.on({
                    dragstart: this._onDragStart,
                    drag: this._onDrag,
                    dragend: this._onDragEnd
                }, this);
                this._draggable.on("predrag", this._onPreDragLimit, this);
                if (map.options.worldCopyJump) {
                    this._draggable.on("predrag", this._onPreDragWrap, this);
                    map.on("zoomend", this._onZoomEnd, this);
                    map.whenReady(this._onZoomEnd, this);
                }
            }
            addClass(this._map._container, "leaflet-grab leaflet-touch-drag");
            this._draggable.enable();
            this._positions = [];
            this._times = [];
        },
        removeHooks: function() {
            removeClass(this._map._container, "leaflet-grab");
            removeClass(this._map._container, "leaflet-touch-drag");
            this._draggable.disable();
        },
        moved: function() {
            return this._draggable && this._draggable._moved;
        },
        moving: function() {
            return this._draggable && this._draggable._moving;
        },
        _onDragStart: function() {
            var map = this._map;
            map._stop();
            if (this._map.options.maxBounds && this._map.options.maxBoundsViscosity) {
                var bounds = toLatLngBounds(this._map.options.maxBounds);
                this._offsetLimit = toBounds(this._map.latLngToContainerPoint(bounds.getNorthWest()).multiplyBy(-1), this._map.latLngToContainerPoint(bounds.getSouthEast()).multiplyBy(-1).add(this._map.getSize()));
                this._viscosity = Math.min(1.0, Math.max(0.0, this._map.options.maxBoundsViscosity));
            } else this._offsetLimit = null;
            map.fire("movestart").fire("dragstart");
            if (map.options.inertia) {
                this._positions = [];
                this._times = [];
            }
        },
        _onDrag: function(e) {
            if (this._map.options.inertia) {
                var time = this._lastTime = +new Date(), pos = this._lastPos = this._draggable._absPos || this._draggable._newPos;
                this._positions.push(pos);
                this._times.push(time);
                this._prunePositions(time);
            }
            this._map.fire("move", e).fire("drag", e);
        },
        _prunePositions: function(time) {
            while(this._positions.length > 1 && time - this._times[0] > 50){
                this._positions.shift();
                this._times.shift();
            }
        },
        _onZoomEnd: function() {
            var pxCenter = this._map.getSize().divideBy(2), pxWorldCenter = this._map.latLngToLayerPoint([
                0,
                0
            ]);
            this._initialWorldOffset = pxWorldCenter.subtract(pxCenter).x;
            this._worldWidth = this._map.getPixelWorldBounds().getSize().x;
        },
        _viscousLimit: function(value, threshold) {
            return value - (value - threshold) * this._viscosity;
        },
        _onPreDragLimit: function() {
            if (!this._viscosity || !this._offsetLimit) return;
            var offset = this._draggable._newPos.subtract(this._draggable._startPos);
            var limit = this._offsetLimit;
            if (offset.x < limit.min.x) offset.x = this._viscousLimit(offset.x, limit.min.x);
            if (offset.y < limit.min.y) offset.y = this._viscousLimit(offset.y, limit.min.y);
            if (offset.x > limit.max.x) offset.x = this._viscousLimit(offset.x, limit.max.x);
            if (offset.y > limit.max.y) offset.y = this._viscousLimit(offset.y, limit.max.y);
            this._draggable._newPos = this._draggable._startPos.add(offset);
        },
        _onPreDragWrap: function() {
            // TODO refactor to be able to adjust map pane position after zoom
            var worldWidth = this._worldWidth, halfWidth = Math.round(worldWidth / 2), dx = this._initialWorldOffset, x = this._draggable._newPos.x, newX1 = (x - halfWidth + dx) % worldWidth + halfWidth - dx, newX2 = (x + halfWidth + dx) % worldWidth - halfWidth - dx, newX = Math.abs(newX1 + dx) < Math.abs(newX2 + dx) ? newX1 : newX2;
            this._draggable._absPos = this._draggable._newPos.clone();
            this._draggable._newPos.x = newX;
        },
        _onDragEnd: function(e) {
            var map = this._map, options = map.options, noInertia = !options.inertia || e.noInertia || this._times.length < 2;
            map.fire("dragend", e);
            if (noInertia) map.fire("moveend");
            else {
                this._prunePositions(+new Date());
                var direction = this._lastPos.subtract(this._positions[0]), duration = (this._lastTime - this._times[0]) / 1000, ease = options.easeLinearity, speedVector = direction.multiplyBy(ease / duration), speed = speedVector.distanceTo([
                    0,
                    0
                ]), limitedSpeed = Math.min(options.inertiaMaxSpeed, speed), limitedSpeedVector = speedVector.multiplyBy(limitedSpeed / speed), decelerationDuration = limitedSpeed / (options.inertiaDeceleration * ease), offset = limitedSpeedVector.multiplyBy(-decelerationDuration / 2).round();
                if (!offset.x && !offset.y) map.fire("moveend");
                else {
                    offset = map._limitOffset(offset, map.options.maxBounds);
                    requestAnimFrame(function() {
                        map.panBy(offset, {
                            duration: decelerationDuration,
                            easeLinearity: ease,
                            noMoveStart: true,
                            animate: true
                        });
                    });
                }
            }
        }
    });
    // @section Handlers
    // @property dragging: Handler
    // Map dragging handler (by both mouse and touch).
    Map.addInitHook("addHandler", "dragging", Drag);
    /*
   * L.Map.Keyboard is handling keyboard interaction with the map, enabled by default.
   */ // @namespace Map
    // @section Keyboard Navigation Options
    Map.mergeOptions({
        // @option keyboard: Boolean = true
        // Makes the map focusable and allows users to navigate the map with keyboard
        // arrows and `+`/`-` keys.
        keyboard: true,
        // @option keyboardPanDelta: Number = 80
        // Amount of pixels to pan when pressing an arrow key.
        keyboardPanDelta: 80
    });
    var Keyboard = Handler.extend({
        keyCodes: {
            left: [
                37
            ],
            right: [
                39
            ],
            down: [
                40
            ],
            up: [
                38
            ],
            zoomIn: [
                187,
                107,
                61,
                171
            ],
            zoomOut: [
                189,
                109,
                54,
                173
            ]
        },
        initialize: function(map) {
            this._map = map;
            this._setPanDelta(map.options.keyboardPanDelta);
            this._setZoomDelta(map.options.zoomDelta);
        },
        addHooks: function() {
            var container = this._map._container;
            // make the container focusable by tabbing
            if (container.tabIndex <= 0) container.tabIndex = "0";
            on(container, {
                focus: this._onFocus,
                blur: this._onBlur,
                mousedown: this._onMouseDown
            }, this);
            this._map.on({
                focus: this._addHooks,
                blur: this._removeHooks
            }, this);
        },
        removeHooks: function() {
            this._removeHooks();
            off(this._map._container, {
                focus: this._onFocus,
                blur: this._onBlur,
                mousedown: this._onMouseDown
            }, this);
            this._map.off({
                focus: this._addHooks,
                blur: this._removeHooks
            }, this);
        },
        _onMouseDown: function() {
            if (this._focused) return;
            var body = document.body, docEl = document.documentElement, top = body.scrollTop || docEl.scrollTop, left = body.scrollLeft || docEl.scrollLeft;
            this._map._container.focus();
            window.scrollTo(left, top);
        },
        _onFocus: function() {
            this._focused = true;
            this._map.fire("focus");
        },
        _onBlur: function() {
            this._focused = false;
            this._map.fire("blur");
        },
        _setPanDelta: function(panDelta) {
            var keys = this._panKeys = {}, codes = this.keyCodes, i, len;
            for(i = 0, len = codes.left.length; i < len; i++)keys[codes.left[i]] = [
                -1 * panDelta,
                0
            ];
            for(i = 0, len = codes.right.length; i < len; i++)keys[codes.right[i]] = [
                panDelta,
                0
            ];
            for(i = 0, len = codes.down.length; i < len; i++)keys[codes.down[i]] = [
                0,
                panDelta
            ];
            for(i = 0, len = codes.up.length; i < len; i++)keys[codes.up[i]] = [
                0,
                -1 * panDelta
            ];
        },
        _setZoomDelta: function(zoomDelta) {
            var keys = this._zoomKeys = {}, codes = this.keyCodes, i, len;
            for(i = 0, len = codes.zoomIn.length; i < len; i++)keys[codes.zoomIn[i]] = zoomDelta;
            for(i = 0, len = codes.zoomOut.length; i < len; i++)keys[codes.zoomOut[i]] = -zoomDelta;
        },
        _addHooks: function() {
            on(document, "keydown", this._onKeyDown, this);
        },
        _removeHooks: function() {
            off(document, "keydown", this._onKeyDown, this);
        },
        _onKeyDown: function(e) {
            if (e.altKey || e.ctrlKey || e.metaKey) return;
            var key = e.keyCode, map = this._map, offset;
            if (key in this._panKeys) {
                if (!map._panAnim || !map._panAnim._inProgress) {
                    offset = this._panKeys[key];
                    if (e.shiftKey) offset = toPoint(offset).multiplyBy(3);
                    if (map.options.maxBounds) offset = map._limitOffset(toPoint(offset), map.options.maxBounds);
                    if (map.options.worldCopyJump) {
                        var newLatLng = map.wrapLatLng(map.unproject(map.project(map.getCenter()).add(offset)));
                        map.panTo(newLatLng);
                    } else map.panBy(offset);
                }
            } else if (key in this._zoomKeys) map.setZoom(map.getZoom() + (e.shiftKey ? 3 : 1) * this._zoomKeys[key]);
            else if (key === 27 && map._popup && map._popup.options.closeOnEscapeKey) map.closePopup();
            else return;
            stop(e);
        }
    });
    // @section Handlers
    // @section Handlers
    // @property keyboard: Handler
    // Keyboard navigation handler.
    Map.addInitHook("addHandler", "keyboard", Keyboard);
    /*
   * L.Handler.ScrollWheelZoom is used by L.Map to enable mouse scroll wheel zoom on the map.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Mouse wheel options
        // @option scrollWheelZoom: Boolean|String = true
        // Whether the map can be zoomed by using the mouse wheel. If passed `'center'`,
        // it will zoom to the center of the view regardless of where the mouse was.
        scrollWheelZoom: true,
        // @option wheelDebounceTime: Number = 40
        // Limits the rate at which a wheel can fire (in milliseconds). By default
        // user can't zoom via wheel more often than once per 40 ms.
        wheelDebounceTime: 40,
        // @option wheelPxPerZoomLevel: Number = 60
        // How many scroll pixels (as reported by [L.DomEvent.getWheelDelta](#domevent-getwheeldelta))
        // mean a change of one full zoom level. Smaller values will make wheel-zooming
        // faster (and vice versa).
        wheelPxPerZoomLevel: 60
    });
    var ScrollWheelZoom = Handler.extend({
        addHooks: function() {
            on(this._map._container, "wheel", this._onWheelScroll, this);
            this._delta = 0;
        },
        removeHooks: function() {
            off(this._map._container, "wheel", this._onWheelScroll, this);
        },
        _onWheelScroll: function(e) {
            var delta = getWheelDelta(e);
            var debounce = this._map.options.wheelDebounceTime;
            this._delta += delta;
            this._lastMousePos = this._map.mouseEventToContainerPoint(e);
            if (!this._startTime) this._startTime = +new Date();
            var left = Math.max(debounce - (+new Date() - this._startTime), 0);
            clearTimeout(this._timer);
            this._timer = setTimeout(bind(this._performZoom, this), left);
            stop(e);
        },
        _performZoom: function() {
            var map = this._map, zoom = map.getZoom(), snap = this._map.options.zoomSnap || 0;
            map._stop(); // stop panning and fly animations if any
            // map the delta with a sigmoid function to -4..4 range leaning on -1..1
            var d2 = this._delta / (this._map.options.wheelPxPerZoomLevel * 4), d3 = 4 * Math.log(2 / (1 + Math.exp(-Math.abs(d2)))) / Math.LN2, d4 = snap ? Math.ceil(d3 / snap) * snap : d3, delta = map._limitZoom(zoom + (this._delta > 0 ? d4 : -d4)) - zoom;
            this._delta = 0;
            this._startTime = null;
            if (!delta) return;
            if (map.options.scrollWheelZoom === "center") map.setZoom(zoom + delta);
            else map.setZoomAround(this._lastMousePos, zoom + delta);
        }
    });
    // @section Handlers
    // @property scrollWheelZoom: Handler
    // Scroll wheel zoom handler.
    Map.addInitHook("addHandler", "scrollWheelZoom", ScrollWheelZoom);
    /*
   * L.Map.TapHold is used to simulate `contextmenu` event on long hold,
   * which otherwise is not fired by mobile Safari.
   */ var tapHoldDelay = 600;
    // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Touch interaction options
        // @option tapHold: Boolean
        // Enables simulation of `contextmenu` event, default is `true` for mobile Safari.
        tapHold: Browser.touchNative && Browser.safari && Browser.mobile,
        // @option tapTolerance: Number = 15
        // The max number of pixels a user can shift his finger during touch
        // for it to be considered a valid tap.
        tapTolerance: 15
    });
    var TapHold = Handler.extend({
        addHooks: function() {
            on(this._map._container, "touchstart", this._onDown, this);
        },
        removeHooks: function() {
            off(this._map._container, "touchstart", this._onDown, this);
        },
        _onDown: function(e) {
            clearTimeout(this._holdTimeout);
            if (e.touches.length !== 1) return;
            var first = e.touches[0];
            this._startPos = this._newPos = new Point(first.clientX, first.clientY);
            this._holdTimeout = setTimeout(bind(function() {
                this._cancel();
                if (!this._isTapValid()) return;
                // prevent simulated mouse events https://w3c.github.io/touch-events/#mouse-events
                on(document, "touchend", preventDefault);
                on(document, "touchend touchcancel", this._cancelClickPrevent);
                this._simulateEvent("contextmenu", first);
            }, this), tapHoldDelay);
            on(document, "touchend touchcancel contextmenu", this._cancel, this);
            on(document, "touchmove", this._onMove, this);
        },
        _cancelClickPrevent: function cancelClickPrevent() {
            off(document, "touchend", preventDefault);
            off(document, "touchend touchcancel", cancelClickPrevent);
        },
        _cancel: function() {
            clearTimeout(this._holdTimeout);
            off(document, "touchend touchcancel contextmenu", this._cancel, this);
            off(document, "touchmove", this._onMove, this);
        },
        _onMove: function(e) {
            var first = e.touches[0];
            this._newPos = new Point(first.clientX, first.clientY);
        },
        _isTapValid: function() {
            return this._newPos.distanceTo(this._startPos) <= this._map.options.tapTolerance;
        },
        _simulateEvent: function(type, e) {
            var simulatedEvent = new MouseEvent(type, {
                bubbles: true,
                cancelable: true,
                view: window,
                // detail: 1,
                screenX: e.screenX,
                screenY: e.screenY,
                clientX: e.clientX,
                clientY: e.clientY
            });
            simulatedEvent._simulated = true;
            e.target.dispatchEvent(simulatedEvent);
        }
    });
    // @section Handlers
    // @property tapHold: Handler
    // Long tap handler to simulate `contextmenu` event (useful in mobile Safari).
    Map.addInitHook("addHandler", "tapHold", TapHold);
    /*
   * L.Handler.TouchZoom is used by L.Map to add pinch zoom on supported mobile browsers.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Touch interaction options
        // @option touchZoom: Boolean|String = *
        // Whether the map can be zoomed by touch-dragging with two fingers. If
        // passed `'center'`, it will zoom to the center of the view regardless of
        // where the touch events (fingers) were. Enabled for touch-capable web
        // browsers.
        touchZoom: Browser.touch,
        // @option bounceAtZoomLimits: Boolean = true
        // Set it to false if you don't want the map to zoom beyond min/max zoom
        // and then bounce back when pinch-zooming.
        bounceAtZoomLimits: true
    });
    var TouchZoom = Handler.extend({
        addHooks: function() {
            addClass(this._map._container, "leaflet-touch-zoom");
            on(this._map._container, "touchstart", this._onTouchStart, this);
        },
        removeHooks: function() {
            removeClass(this._map._container, "leaflet-touch-zoom");
            off(this._map._container, "touchstart", this._onTouchStart, this);
        },
        _onTouchStart: function(e) {
            var map = this._map;
            if (!e.touches || e.touches.length !== 2 || map._animatingZoom || this._zooming) return;
            var p1 = map.mouseEventToContainerPoint(e.touches[0]), p2 = map.mouseEventToContainerPoint(e.touches[1]);
            this._centerPoint = map.getSize()._divideBy(2);
            this._startLatLng = map.containerPointToLatLng(this._centerPoint);
            if (map.options.touchZoom !== "center") this._pinchStartLatLng = map.containerPointToLatLng(p1.add(p2)._divideBy(2));
            this._startDist = p1.distanceTo(p2);
            this._startZoom = map.getZoom();
            this._moved = false;
            this._zooming = true;
            map._stop();
            on(document, "touchmove", this._onTouchMove, this);
            on(document, "touchend touchcancel", this._onTouchEnd, this);
            preventDefault(e);
        },
        _onTouchMove: function(e) {
            if (!e.touches || e.touches.length !== 2 || !this._zooming) return;
            var map = this._map, p1 = map.mouseEventToContainerPoint(e.touches[0]), p2 = map.mouseEventToContainerPoint(e.touches[1]), scale = p1.distanceTo(p2) / this._startDist;
            this._zoom = map.getScaleZoom(scale, this._startZoom);
            if (!map.options.bounceAtZoomLimits && (this._zoom < map.getMinZoom() && scale < 1 || this._zoom > map.getMaxZoom() && scale > 1)) this._zoom = map._limitZoom(this._zoom);
            if (map.options.touchZoom === "center") {
                this._center = this._startLatLng;
                if (scale === 1) return;
            } else {
                // Get delta from pinch to center, so centerLatLng is delta applied to initial pinchLatLng
                var delta = p1._add(p2)._divideBy(2)._subtract(this._centerPoint);
                if (scale === 1 && delta.x === 0 && delta.y === 0) return;
                this._center = map.unproject(map.project(this._pinchStartLatLng, this._zoom).subtract(delta), this._zoom);
            }
            if (!this._moved) {
                map._moveStart(true, false);
                this._moved = true;
            }
            cancelAnimFrame(this._animRequest);
            var moveFn = bind(map._move, map, this._center, this._zoom, {
                pinch: true,
                round: false
            }, undefined);
            this._animRequest = requestAnimFrame(moveFn, this, true);
            preventDefault(e);
        },
        _onTouchEnd: function() {
            if (!this._moved || !this._zooming) {
                this._zooming = false;
                return;
            }
            this._zooming = false;
            cancelAnimFrame(this._animRequest);
            off(document, "touchmove", this._onTouchMove, this);
            off(document, "touchend touchcancel", this._onTouchEnd, this);
            // Pinch updates GridLayers' levels only when zoomSnap is off, so zoomSnap becomes noUpdate.
            if (this._map.options.zoomAnimation) this._map._animateZoom(this._center, this._map._limitZoom(this._zoom), true, this._map.options.zoomSnap);
            else this._map._resetView(this._center, this._map._limitZoom(this._zoom));
        }
    });
    // @section Handlers
    // @property touchZoom: Handler
    // Touch zoom handler.
    Map.addInitHook("addHandler", "touchZoom", TouchZoom);
    Map.BoxZoom = BoxZoom;
    Map.DoubleClickZoom = DoubleClickZoom;
    Map.Drag = Drag;
    Map.Keyboard = Keyboard;
    Map.ScrollWheelZoom = ScrollWheelZoom;
    Map.TapHold = TapHold;
    Map.TouchZoom = TouchZoom;
    exports1.Bounds = Bounds;
    exports1.Browser = Browser;
    exports1.CRS = CRS;
    exports1.Canvas = Canvas;
    exports1.Circle = Circle;
    exports1.CircleMarker = CircleMarker;
    exports1.Class = Class;
    exports1.Control = Control;
    exports1.DivIcon = DivIcon;
    exports1.DivOverlay = DivOverlay;
    exports1.DomEvent = DomEvent;
    exports1.DomUtil = DomUtil;
    exports1.Draggable = Draggable;
    exports1.Evented = Evented;
    exports1.FeatureGroup = FeatureGroup;
    exports1.GeoJSON = GeoJSON;
    exports1.GridLayer = GridLayer;
    exports1.Handler = Handler;
    exports1.Icon = Icon;
    exports1.ImageOverlay = ImageOverlay;
    exports1.LatLng = LatLng;
    exports1.LatLngBounds = LatLngBounds;
    exports1.Layer = Layer;
    exports1.LayerGroup = LayerGroup;
    exports1.LineUtil = LineUtil;
    exports1.Map = Map;
    exports1.Marker = Marker;
    exports1.Mixin = Mixin;
    exports1.Path = Path;
    exports1.Point = Point;
    exports1.PolyUtil = PolyUtil;
    exports1.Polygon = Polygon;
    exports1.Polyline = Polyline;
    exports1.Popup = Popup;
    exports1.PosAnimation = PosAnimation;
    exports1.Projection = index;
    exports1.Rectangle = Rectangle;
    exports1.Renderer = Renderer;
    exports1.SVG = SVG;
    exports1.SVGOverlay = SVGOverlay;
    exports1.TileLayer = TileLayer;
    exports1.Tooltip = Tooltip;
    exports1.Transformation = Transformation;
    exports1.Util = Util;
    exports1.VideoOverlay = VideoOverlay;
    exports1.bind = bind;
    exports1.bounds = toBounds;
    exports1.canvas = canvas;
    exports1.circle = circle;
    exports1.circleMarker = circleMarker;
    exports1.control = control;
    exports1.divIcon = divIcon;
    exports1.extend = extend;
    exports1.featureGroup = featureGroup;
    exports1.geoJSON = geoJSON;
    exports1.geoJson = geoJson;
    exports1.gridLayer = gridLayer;
    exports1.icon = icon;
    exports1.imageOverlay = imageOverlay;
    exports1.latLng = toLatLng;
    exports1.latLngBounds = toLatLngBounds;
    exports1.layerGroup = layerGroup;
    exports1.map = createMap;
    exports1.marker = marker;
    exports1.point = toPoint;
    exports1.polygon = polygon;
    exports1.polyline = polyline;
    exports1.popup = popup;
    exports1.rectangle = rectangle;
    exports1.setOptions = setOptions;
    exports1.stamp = stamp;
    exports1.svg = svg;
    exports1.svgOverlay = svgOverlay;
    exports1.tileLayer = tileLayer;
    exports1.tooltip = tooltip;
    exports1.transformation = toTransformation;
    exports1.version = version;
    exports1.videoOverlay = videoOverlay;
    var oldL = window.L;
    exports1.noConflict = function() {
        window.L = oldL;
        return this;
    };
    // Always export us to window global (see #2364)
    window.L = exports1;
});

});

parcelRegister("bOEk0", function(module, exports) {
/*
 * Copyright Joyent, Inc. and other Node contributors.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to permit
 * persons to whom the Software is furnished to do so, subject to the
 * following conditions:
 *
 * The above copyright notice and this permission notice shall be included
 * in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
 * OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
 * NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
 * DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
 * OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
 * USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ "use strict";

var $hzMSH = parcelRequire("hzMSH");
function Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.host = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.query = null;
    this.pathname = null;
    this.path = null;
    this.href = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
/*
 * define these here so at least they only have to be
 * compiled once on the first module load.
 */ var protocolPattern = /^([a-z0-9.+-]+:)/i, portPattern = /:[0-9]*$/, // Special case for a simple path URL
simplePathPattern = /^(\/\/?(?!\/)[^?\s]*)(\?[^\s]*)?$/, /*
   * RFC 2396: characters reserved for delimiting URLs.
   * We actually just auto-escape these.
   */ delims = [
    "<",
    ">",
    '"',
    "`",
    " ",
    "\r",
    "\n",
    "	"
], // RFC 2396: characters not allowed for various reasons.
unwise = [
    "{",
    "}",
    "|",
    "\\",
    "^",
    "`"
].concat(delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
autoEscape = [
    "'"
].concat(unwise), /*
   * Characters that are never ever allowed in a hostname.
   * Note that any invalid chars are also handled, but these
   * are the ones that are *expected* to be seen, so we fast-path
   * them.
   */ nonHostChars = [
    "%",
    "/",
    "?",
    ";",
    "#"
].concat(autoEscape), hostEndingChars = [
    "/",
    "?",
    "#"
], hostnameMaxLen = 255, hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
unsafeProtocol = {
    javascript: true,
    "javascript:": true
}, // protocols that never have a hostname.
hostlessProtocol = {
    javascript: true,
    "javascript:": true
}, // protocols that always contain a // bit.
slashedProtocol = {
    http: true,
    https: true,
    ftp: true,
    gopher: true,
    file: true,
    "http:": true,
    "https:": true,
    "ftp:": true,
    "gopher:": true,
    "file:": true
};

var $hxUF9 = parcelRequire("hxUF9");
function urlParse(url, parseQueryString, slashesDenoteHost) {
    if (url && typeof url === "object" && url instanceof Url) return url;
    var u = new Url();
    u.parse(url, parseQueryString, slashesDenoteHost);
    return u;
}
Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
    if (typeof url !== "string") throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
    /*
   * Copy chrome, IE, opera backslash-handling behavior.
   * Back slashes before the query string get converted to forward slashes
   * See: https://code.google.com/p/chromium/issues/detail?id=25916
   */ var queryIndex = url.indexOf("?"), splitter = queryIndex !== -1 && queryIndex < url.indexOf("#") ? "?" : "#", uSplit = url.split(splitter), slashRegex = /\\/g;
    uSplit[0] = uSplit[0].replace(slashRegex, "/");
    url = uSplit.join(splitter);
    var rest = url;
    /*
   * trim before proceeding.
   * This is to support parse stuff like "  http://foo.com  \n"
   */ rest = rest.trim();
    if (!slashesDenoteHost && url.split("#").length === 1) {
        // Try fast path regexp
        var simplePath = simplePathPattern.exec(rest);
        if (simplePath) {
            this.path = rest;
            this.href = rest;
            this.pathname = simplePath[1];
            if (simplePath[2]) {
                this.search = simplePath[2];
                if (parseQueryString) this.query = $hxUF9.parse(this.search.substr(1));
                else this.query = this.search.substr(1);
            } else if (parseQueryString) {
                this.search = "";
                this.query = {};
            }
            return this;
        }
    }
    var proto = protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        var lowerProto = proto.toLowerCase();
        this.protocol = lowerProto;
        rest = rest.substr(proto.length);
    }
    /*
   * figure out if it's got a host
   * user@server is *always* interpreted as a hostname, and url
   * resolution will treat //foo/bar as host=foo,path=bar because that's
   * how the browser resolves relative URLs.
   */ if (slashesDenoteHost || proto || rest.match(/^\/\/[^@/]+@[^@/]+/)) {
        var slashes = rest.substr(0, 2) === "//";
        if (slashes && !(proto && hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!hostlessProtocol[proto] && (slashes || proto && !slashedProtocol[proto])) {
        /*
     * there's a hostname.
     * the first instance of /, ?, ;, or # ends the host.
     *
     * If there is an @ in the hostname, then non-host chars *are* allowed
     * to the left of the last @ sign, unless some host-ending character
     * comes *before* the @-sign.
     * URLs are obnoxious.
     *
     * ex:
     * http://a@b@c/ => user:a@b host:c
     * http://a@b?@c => user:a host:c path:/?@c
     */ /*
     * v0.12 TODO(isaacs): This is not quite how Chrome does things.
     * Review our test case against browsers more comprehensively.
     */ // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for(var i = 0; i < hostEndingChars.length; i++){
            var hec = rest.indexOf(hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        /*
     * at this point, either we have an explicit point where the
     * auth portion cannot go past, or the last @ char is the decider.
     */ var auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf("@");
        else /*
       * atSign must be in auth portion.
       * http://a@b/c@d => host:b auth:a path:/c@d
       */ atSign = rest.lastIndexOf("@", hostEnd);
        /*
     * Now we have a portion which is definitely the auth.
     * Pull that off.
     */ if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = decodeURIComponent(auth);
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(var i = 0; i < nonHostChars.length; i++){
            var hec = rest.indexOf(nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        this.host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost();
        /*
     * we've indicated that there is a hostname,
     * so even if it's empty, it has to be present.
     */ this.hostname = this.hostname || "";
        /*
     * if hostname begins with [ and ends with ]
     * assume that it's an IPv6 address.
     */ var ipv6Hostname = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
        // validate a little.
        if (!ipv6Hostname) {
            var hostparts = this.hostname.split(/\./);
            for(var i = 0, l = hostparts.length; i < l; i++){
                var part = hostparts[i];
                if (!part) continue;
                if (!part.match(hostnamePartPattern)) {
                    var newpart = "";
                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) /*
               * we replace non-ASCII char with a temporary placeholder
               * we need this to make sure size of hostname is not
               * broken by replacing non-ASCII by nothing
               */ newpart += "x";
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match(hostnamePartPattern)) {
                        var validParts = hostparts.slice(0, i);
                        var notHost = hostparts.slice(i + 1);
                        var bit = part.match(hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = "/" + notHost.join(".") + rest;
                        this.hostname = validParts.join(".");
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > hostnameMaxLen) this.hostname = "";
        else // hostnames are always lower case.
        this.hostname = this.hostname.toLowerCase();
        if (!ipv6Hostname) /*
       * IDNA Support: Returns a punycoded representation of "domain".
       * It only converts parts of the domain name that
       * have non-ASCII characters, i.e. it doesn't matter if
       * you call it with a domain that already is ASCII-only.
       */ this.hostname = $hzMSH.toASCII(this.hostname);
        var p = this.port ? ":" + this.port : "";
        var h = this.hostname || "";
        this.host = h + p;
        this.href += this.host;
        /*
     * strip [ and ] from the hostname
     * the host field still retains them, though
     */ if (ipv6Hostname) {
            this.hostname = this.hostname.substr(1, this.hostname.length - 2);
            if (rest[0] !== "/") rest = "/" + rest;
        }
    }
    /*
   * now rest is set to the post-host stuff.
   * chop off any delim chars.
   */ if (!unsafeProtocol[lowerProto]) /*
     * First, make 100% sure that any "autoEscape" chars get
     * escaped, even if encodeURIComponent doesn't think they
     * need to be.
     */ for(var i = 0, l = autoEscape.length; i < l; i++){
        var ae = autoEscape[i];
        if (rest.indexOf(ae) === -1) continue;
        var esc = encodeURIComponent(ae);
        if (esc === ae) esc = escape(ae);
        rest = rest.split(ae).join(esc);
    }
    // chop off from the tail first.
    var hash = rest.indexOf("#");
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    var qm = rest.indexOf("?");
    if (qm !== -1) {
        this.search = rest.substr(qm);
        this.query = rest.substr(qm + 1);
        if (parseQueryString) this.query = $hxUF9.parse(this.query);
        rest = rest.slice(0, qm);
    } else if (parseQueryString) {
        // no query string, but parseQueryString still requested
        this.search = "";
        this.query = {};
    }
    if (rest) this.pathname = rest;
    if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = "/";
    // to support http.request
    if (this.pathname || this.search) {
        var p = this.pathname || "";
        var s = this.search || "";
        this.path = p + s;
    }
    // finally, reconstruct the href based on what has been validated.
    this.href = this.format();
    return this;
};
// format a parsed object into a url string
function urlFormat(obj) {
    /*
   * ensure it's an object, and not a string url.
   * If it's an obj, this is a no-op.
   * this way, you can call url_format() on strings
   * to clean up potentially wonky urls.
   */ if (typeof obj === "string") obj = urlParse(obj);
    if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
    return obj.format();
}
Url.prototype.format = function() {
    var auth = this.auth || "";
    if (auth) {
        auth = encodeURIComponent(auth);
        auth = auth.replace(/%3A/i, ":");
        auth += "@";
    }
    var protocol = this.protocol || "", pathname = this.pathname || "", hash = this.hash || "", host = false, query = "";
    if (this.host) host = auth + this.host;
    else if (this.hostname) {
        host = auth + (this.hostname.indexOf(":") === -1 ? this.hostname : "[" + this.hostname + "]");
        if (this.port) host += ":" + this.port;
    }
    if (this.query && typeof this.query === "object" && Object.keys(this.query).length) query = $hxUF9.stringify(this.query, {
        arrayFormat: "repeat",
        addQueryPrefix: false
    });
    var search = this.search || query && "?" + query || "";
    if (protocol && protocol.substr(-1) !== ":") protocol += ":";
    /*
   * only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
   * unless they had them to begin with.
   */ if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
        host = "//" + (host || "");
        if (pathname && pathname.charAt(0) !== "/") pathname = "/" + pathname;
    } else if (!host) host = "";
    if (hash && hash.charAt(0) !== "#") hash = "#" + hash;
    if (search && search.charAt(0) !== "?") search = "?" + search;
    pathname = pathname.replace(/[?#]/g, function(match) {
        return encodeURIComponent(match);
    });
    search = search.replace("#", "%23");
    return protocol + host + pathname + search + hash;
};
function urlResolve(source, relative) {
    return urlParse(source, false, true).resolve(relative);
}
Url.prototype.resolve = function(relative) {
    return this.resolveObject(urlParse(relative, false, true)).format();
};
function urlResolveObject(source, relative) {
    if (!source) return relative;
    return urlParse(source, false, true).resolveObject(relative);
}
Url.prototype.resolveObject = function(relative) {
    if (typeof relative === "string") {
        var rel = new Url();
        rel.parse(relative, false, true);
        relative = rel;
    }
    var result = new Url();
    var tkeys = Object.keys(this);
    for(var tk = 0; tk < tkeys.length; tk++){
        var tkey = tkeys[tk];
        result[tkey] = this[tkey];
    }
    /*
   * hash is always overridden, no matter what.
   * even href="" will remove it.
   */ result.hash = relative.hash;
    // if the relative url is empty, then there's nothing left to do here.
    if (relative.href === "") {
        result.href = result.format();
        return result;
    }
    // hrefs like //foo/bar always cut to the protocol.
    if (relative.slashes && !relative.protocol) {
        // take everything except the protocol from relative
        var rkeys = Object.keys(relative);
        for(var rk = 0; rk < rkeys.length; rk++){
            var rkey = rkeys[rk];
            if (rkey !== "protocol") result[rkey] = relative[rkey];
        }
        // urlParse appends trailing / to urls like http://www.example.com
        if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) {
            result.pathname = "/";
            result.path = result.pathname;
        }
        result.href = result.format();
        return result;
    }
    if (relative.protocol && relative.protocol !== result.protocol) {
        /*
     * if it's a known url protocol, then changing
     * the protocol does weird things
     * first, if it's not file:, then we MUST have a host,
     * and if there was a path
     * to begin with, then we MUST have a path.
     * if it is file:, then the host is dropped,
     * because that's known to be hostless.
     * anything else is assumed to be absolute.
     */ if (!slashedProtocol[relative.protocol]) {
            var keys = Object.keys(relative);
            for(var v = 0; v < keys.length; v++){
                var k = keys[v];
                result[k] = relative[k];
            }
            result.href = result.format();
            return result;
        }
        result.protocol = relative.protocol;
        if (!relative.host && !hostlessProtocol[relative.protocol]) {
            var relPath = (relative.pathname || "").split("/");
            while(relPath.length && !(relative.host = relPath.shift()));
            if (!relative.host) relative.host = "";
            if (!relative.hostname) relative.hostname = "";
            if (relPath[0] !== "") relPath.unshift("");
            if (relPath.length < 2) relPath.unshift("");
            result.pathname = relPath.join("/");
        } else result.pathname = relative.pathname;
        result.search = relative.search;
        result.query = relative.query;
        result.host = relative.host || "";
        result.auth = relative.auth;
        result.hostname = relative.hostname || relative.host;
        result.port = relative.port;
        // to support http.request
        if (result.pathname || result.search) {
            var p = result.pathname || "";
            var s = result.search || "";
            result.path = p + s;
        }
        result.slashes = result.slashes || relative.slashes;
        result.href = result.format();
        return result;
    }
    var isSourceAbs = result.pathname && result.pathname.charAt(0) === "/", isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === "/", mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname, removeAllDots = mustEndAbs, srcPath = result.pathname && result.pathname.split("/") || [], relPath = relative.pathname && relative.pathname.split("/") || [], psychotic = result.protocol && !slashedProtocol[result.protocol];
    /*
   * if the url is a non-slashed url, then relative
   * links like ../.. should be able
   * to crawl up to the hostname, as well.  This is strange.
   * result.protocol has already been set by now.
   * Later on, put the first path part into the host field.
   */ if (psychotic) {
        result.hostname = "";
        result.port = null;
        if (result.host) {
            if (srcPath[0] === "") srcPath[0] = result.host;
            else srcPath.unshift(result.host);
        }
        result.host = "";
        if (relative.protocol) {
            relative.hostname = null;
            relative.port = null;
            if (relative.host) {
                if (relPath[0] === "") relPath[0] = relative.host;
                else relPath.unshift(relative.host);
            }
            relative.host = null;
        }
        mustEndAbs = mustEndAbs && (relPath[0] === "" || srcPath[0] === "");
    }
    if (isRelAbs) {
        // it's absolute.
        result.host = relative.host || relative.host === "" ? relative.host : result.host;
        result.hostname = relative.hostname || relative.hostname === "" ? relative.hostname : result.hostname;
        result.search = relative.search;
        result.query = relative.query;
        srcPath = relPath;
    // fall through to the dot-handling below.
    } else if (relPath.length) {
        /*
     * it's relative
     * throw away the existing file, and take the new path instead.
     */ if (!srcPath) srcPath = [];
        srcPath.pop();
        srcPath = srcPath.concat(relPath);
        result.search = relative.search;
        result.query = relative.query;
    } else if (relative.search != null) {
        /*
     * just pull out the search.
     * like href='?foo'.
     * Put this after the other two cases because it simplifies the booleans
     */ if (psychotic) {
            result.host = srcPath.shift();
            result.hostname = result.host;
            /*
       * occationaly the auth can get stuck only in host
       * this especially happens in cases like
       * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
       */ var authInHost = result.host && result.host.indexOf("@") > 0 ? result.host.split("@") : false;
            if (authInHost) {
                result.auth = authInHost.shift();
                result.hostname = authInHost.shift();
                result.host = result.hostname;
            }
        }
        result.search = relative.search;
        result.query = relative.query;
        // to support http.request
        if (result.pathname !== null || result.search !== null) result.path = (result.pathname ? result.pathname : "") + (result.search ? result.search : "");
        result.href = result.format();
        return result;
    }
    if (!srcPath.length) {
        /*
     * no path at all.  easy.
     * we've already handled the other stuff above.
     */ result.pathname = null;
        // to support http.request
        if (result.search) result.path = "/" + result.search;
        else result.path = null;
        result.href = result.format();
        return result;
    }
    /*
   * if a url ENDs in . or .., then it must get a trailing slash.
   * however, if it ends in anything else non-slashy,
   * then it must NOT get a trailing slash.
   */ var last = srcPath.slice(-1)[0];
    var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === "." || last === "..") || last === "";
    /*
   * strip single dots, resolve double dots to parent dir
   * if the path tries to go above the root, `up` ends up > 0
   */ var up = 0;
    for(var i = srcPath.length; i >= 0; i--){
        last = srcPath[i];
        if (last === ".") srcPath.splice(i, 1);
        else if (last === "..") {
            srcPath.splice(i, 1);
            up++;
        } else if (up) {
            srcPath.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (!mustEndAbs && !removeAllDots) for(; up--; up)srcPath.unshift("..");
    if (mustEndAbs && srcPath[0] !== "" && (!srcPath[0] || srcPath[0].charAt(0) !== "/")) srcPath.unshift("");
    if (hasTrailingSlash && srcPath.join("/").substr(-1) !== "/") srcPath.push("");
    var isAbsolute = srcPath[0] === "" || srcPath[0] && srcPath[0].charAt(0) === "/";
    // put the host back
    if (psychotic) {
        result.hostname = isAbsolute ? "" : srcPath.length ? srcPath.shift() : "";
        result.host = result.hostname;
        /*
     * occationaly the auth can get stuck only in host
     * this especially happens in cases like
     * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
     */ var authInHost = result.host && result.host.indexOf("@") > 0 ? result.host.split("@") : false;
        if (authInHost) {
            result.auth = authInHost.shift();
            result.hostname = authInHost.shift();
            result.host = result.hostname;
        }
    }
    mustEndAbs = mustEndAbs || result.host && srcPath.length;
    if (mustEndAbs && !isAbsolute) srcPath.unshift("");
    if (srcPath.length > 0) result.pathname = srcPath.join("/");
    else {
        result.pathname = null;
        result.path = null;
    }
    // to support request.http
    if (result.pathname !== null || result.search !== null) result.path = (result.pathname ? result.pathname : "") + (result.search ? result.search : "");
    result.auth = relative.auth || result.auth;
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
};
Url.prototype.parseHost = function() {
    var host = this.host;
    var port = portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ":") this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};
exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;
exports.Url = Url;

});
parcelRegister("hzMSH", function(module, exports) {
(function(root) {
    /** Detect free variables */ var freeExports = exports && !exports.nodeType && exports;
    var freeModule = module && !module.nodeType && module;
    var freeGlobal = typeof $parcel$global == "object" && $parcel$global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) root = freeGlobal;
    /**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */ var punycode, /** Highest positive signed 32-bit float value */ maxInt = 2147483647, /** Bootstring parameters */ base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = "-", /** Regular expressions */ regexPunycode = /^xn--/, regexNonASCII = /[^\x20-\x7E]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, /** Error messages */ errors = {
        "overflow": "Overflow: input needs wider integers to process",
        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
        "invalid-input": "Invalid input"
    }, /** Convenience shortcuts */ baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, /** Temporary variable */ key;
    /*--------------------------------------------------------------------------*/ /**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */ function error(type) {
        throw new RangeError(errors[type]);
    }
    /**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */ function map(array, fn) {
        var length = array.length;
        var result = [];
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */ function mapDomain(string, fn) {
        var parts = string.split("@");
        var result = "";
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + "@";
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, ".");
        var labels = string.split(".");
        var encoded = map(labels, fn).join(".");
        return result + encoded;
    }
    /**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */ function ucs2decode(string) {
        var output = [], counter = 0, length = string.length, value, extra;
        while(counter < length){
            value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // high surrogate, and there is a next character
                extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // unmatched surrogate; only append this code unit, in case the next
                    // code unit is the high surrogate of a surrogate pair
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */ function ucs2encode(array) {
        return map(array, function(value) {
            var output = "";
            if (value > 0xFFFF) {
                value -= 0x10000;
                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                value = 0xDC00 | value & 0x3FF;
            }
            output += stringFromCharCode(value);
            return output;
        }).join("");
    }
    /**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */ function basicToDigit(codePoint) {
        if (codePoint - 48 < 10) return codePoint - 22;
        if (codePoint - 65 < 26) return codePoint - 65;
        if (codePoint - 97 < 26) return codePoint - 97;
        return base;
    }
    /**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */ function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    }
    /**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */ function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    }
    /**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */ function decode(input) {
        // Don't use UCS-2
        var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, /** Cached calculation results */ baseMinusT;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error("not-basic");
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(index = basic > 0 ? basic + 1 : 0; index < inputLength;){
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            for(oldi = i, w = 1, k = base;; k += base){
                if (index >= inputLength) error("invalid-input");
                digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error("overflow");
                i += digit * w;
                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error("overflow");
                w *= baseMinusT;
            }
            out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error("overflow");
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output
            output.splice(i++, 0, n);
        }
        return ucs2encode(output);
    }
    /**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */ function encode(input) {
        var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], /** `inputLength` will hold the number of code points in `input`. */ inputLength, /** Cached calculation results */ handledCPCountPlusOne, baseMinusT, qMinusT;
        // Convert the input in UCS-2 to Unicode
        input = ucs2decode(input);
        // Cache the length
        inputLength = input.length;
        // Initialize the state
        n = initialN;
        delta = 0;
        bias = initialBias;
        // Handle the basic code points
        for(j = 0; j < inputLength; ++j){
            currentValue = input[j];
            if (currentValue < 0x80) output.push(stringFromCharCode(currentValue));
        }
        handledCPCount = basicLength = output.length;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string - if it is not empty - with a delimiter
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            for(m = maxInt, j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue >= n && currentValue < m) m = currentValue;
            }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow
            handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error("overflow");
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            for(j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue < n && ++delta > maxInt) error("overflow");
                if (currentValue == n) {
                    // Represent delta as a generalized variable-length integer
                    for(q = delta, k = base;; k += base){
                        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                        if (q < t) break;
                        qMinusT = q - t;
                        baseMinusT = base - t;
                        output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                        q = floor(qMinusT / baseMinusT);
                    }
                    output.push(stringFromCharCode(digitToBasic(q, 0)));
                    bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                    delta = 0;
                    ++handledCPCount;
                }
            }
            ++delta;
            ++n;
        }
        return output.join("");
    }
    /**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */ function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    }
    /**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */ function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? "xn--" + encode(string) : string;
        });
    }
    /*--------------------------------------------------------------------------*/ /** Define the public API */ punycode = {
        /**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */ "version": "1.4.1",
        /**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */ "ucs2": {
            "decode": ucs2decode,
            "encode": ucs2encode
        },
        "decode": decode,
        "encode": encode,
        "toASCII": toASCII,
        "toUnicode": toUnicode
    };
    /** Expose `punycode` */ // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) define("punycode", function() {
        return punycode;
    });
    else if (freeExports && freeModule) {
        if (module.exports == freeExports) // in Node.js, io.js, or RingoJS v0.8.0+
        freeModule.exports = punycode;
        else // in Narwhal or RingoJS v0.7.0-
        for(key in punycode)punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
    } else // in Rhino or a web browser
    root.punycode = punycode;
})(this);

});

parcelRegister("hxUF9", function(module, exports) {
"use strict";

var $68UiT = parcelRequire("68UiT");

var $eMSpG = parcelRequire("eMSpG");

var $jBJw6 = parcelRequire("jBJw6");
module.exports = {
    formats: $jBJw6,
    parse: $eMSpG,
    stringify: $68UiT
};

});
parcelRegister("68UiT", function(module, exports) {
"use strict";

var $f7bW3 = parcelRequire("f7bW3");

var $fyIa7 = parcelRequire("fyIa7");

var $jBJw6 = parcelRequire("jBJw6");
var $478f2a2e4db9aa13$var$has = Object.prototype.hasOwnProperty;
var $478f2a2e4db9aa13$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + "[]";
    },
    comma: "comma",
    indices: function indices(prefix, key) {
        return prefix + "[" + key + "]";
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $478f2a2e4db9aa13$var$isArray = Array.isArray;
var $478f2a2e4db9aa13$var$push = Array.prototype.push;
var $478f2a2e4db9aa13$var$pushToArray = function(arr, valueOrArray) {
    $478f2a2e4db9aa13$var$push.apply(arr, $478f2a2e4db9aa13$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $478f2a2e4db9aa13$var$toISO = Date.prototype.toISOString;
var $478f2a2e4db9aa13$var$defaultFormat = $jBJw6.default;
var $478f2a2e4db9aa13$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: "indices",
    charset: "utf-8",
    charsetSentinel: false,
    delimiter: "&",
    encode: true,
    encodeDotInKeys: false,
    encoder: $fyIa7.encode,
    encodeValuesOnly: false,
    format: $478f2a2e4db9aa13$var$defaultFormat,
    formatter: $jBJw6.formatters[$478f2a2e4db9aa13$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $478f2a2e4db9aa13$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $478f2a2e4db9aa13$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === "string" || typeof v === "number" || typeof v === "boolean" || typeof v === "symbol" || typeof v === "bigint";
};
var $478f2a2e4db9aa13$var$sentinel = {};
var $478f2a2e4db9aa13$var$stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
    var obj = object;
    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while((tmpSc = tmpSc.get($478f2a2e4db9aa13$var$sentinel)) !== void 0 && !findFlag){
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== "undefined") {
            if (pos === step) throw new RangeError("Cyclic object value");
            else findFlag = true; // Break while
        }
        if (typeof tmpSc.get($478f2a2e4db9aa13$var$sentinel) === "undefined") step = 0;
    }
    if (typeof filter === "function") obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === "comma" && $478f2a2e4db9aa13$var$isArray(obj)) obj = $fyIa7.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, $478f2a2e4db9aa13$var$defaults.encoder, charset, "key", format) : prefix;
        obj = "";
    }
    if ($478f2a2e4db9aa13$var$isNonNullishPrimitive(obj) || $fyIa7.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $478f2a2e4db9aa13$var$defaults.encoder, charset, "key", format);
            return [
                formatter(keyValue) + "=" + formatter(encoder(obj, $478f2a2e4db9aa13$var$defaults.encoder, charset, "value", format))
            ];
        }
        return [
            formatter(prefix) + "=" + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === "undefined") return values;
    var objKeys;
    if (generateArrayPrefix === "comma" && $478f2a2e4db9aa13$var$isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) obj = $fyIa7.maybeMap(obj, encoder);
        objKeys = [
            {
                value: obj.length > 0 ? obj.join(",") || null : void 0
            }
        ];
    } else if ($478f2a2e4db9aa13$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    var encodedPrefix = encodeDotInKeys ? prefix.replace(/\./g, "%2E") : prefix;
    var adjustedPrefix = commaRoundTrip && $478f2a2e4db9aa13$var$isArray(obj) && obj.length === 1 ? encodedPrefix + "[]" : encodedPrefix;
    if (allowEmptyArrays && $478f2a2e4db9aa13$var$isArray(obj) && obj.length === 0) return adjustedPrefix + "[]";
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === "object" && typeof key.value !== "undefined" ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var encodedKey = allowDots && encodeDotInKeys ? key.replace(/\./g, "%2E") : key;
        var keyPrefix = $478f2a2e4db9aa13$var$isArray(obj) ? typeof generateArrayPrefix === "function" ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix : adjustedPrefix + (allowDots ? "." + encodedKey : "[" + encodedKey + "]");
        sideChannel.set(object, step);
        var valueSideChannel = $f7bW3();
        valueSideChannel.set($478f2a2e4db9aa13$var$sentinel, sideChannel);
        $478f2a2e4db9aa13$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, generateArrayPrefix === "comma" && encodeValuesOnly && $478f2a2e4db9aa13$var$isArray(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
    }
    return values;
};
var $478f2a2e4db9aa13$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $478f2a2e4db9aa13$var$defaults;
    if (typeof opts.allowEmptyArrays !== "undefined" && typeof opts.allowEmptyArrays !== "boolean") throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof opts.encodeDotInKeys !== "undefined" && typeof opts.encodeDotInKeys !== "boolean") throw new TypeError("`encodeDotInKeys` option can only be `true` or `false`, when provided");
    if (opts.encoder !== null && typeof opts.encoder !== "undefined" && typeof opts.encoder !== "function") throw new TypeError("Encoder has to be a function.");
    var charset = opts.charset || $478f2a2e4db9aa13$var$defaults.charset;
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var format = $jBJw6.default;
    if (typeof opts.format !== "undefined") {
        if (!$478f2a2e4db9aa13$var$has.call($jBJw6.formatters, opts.format)) throw new TypeError("Unknown format option provided.");
        format = opts.format;
    }
    var formatter = $jBJw6.formatters[format];
    var filter = $478f2a2e4db9aa13$var$defaults.filter;
    if (typeof opts.filter === "function" || $478f2a2e4db9aa13$var$isArray(opts.filter)) filter = opts.filter;
    var arrayFormat;
    if (opts.arrayFormat in $478f2a2e4db9aa13$var$arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if ("indices" in opts) arrayFormat = opts.indices ? "indices" : "repeat";
    else arrayFormat = $478f2a2e4db9aa13$var$defaults.arrayFormat;
    if ("commaRoundTrip" in opts && typeof opts.commaRoundTrip !== "boolean") throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
    var allowDots = typeof opts.allowDots === "undefined" ? opts.encodeDotInKeys === true ? true : $478f2a2e4db9aa13$var$defaults.allowDots : !!opts.allowDots;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === "boolean" ? opts.addQueryPrefix : $478f2a2e4db9aa13$var$defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === "boolean" ? !!opts.allowEmptyArrays : $478f2a2e4db9aa13$var$defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $478f2a2e4db9aa13$var$defaults.charsetSentinel,
        commaRoundTrip: opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === "undefined" ? $478f2a2e4db9aa13$var$defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === "boolean" ? opts.encode : $478f2a2e4db9aa13$var$defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === "boolean" ? opts.encodeDotInKeys : $478f2a2e4db9aa13$var$defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === "function" ? opts.encoder : $478f2a2e4db9aa13$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === "boolean" ? opts.encodeValuesOnly : $478f2a2e4db9aa13$var$defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === "function" ? opts.serializeDate : $478f2a2e4db9aa13$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === "boolean" ? opts.skipNulls : $478f2a2e4db9aa13$var$defaults.skipNulls,
        sort: typeof opts.sort === "function" ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $478f2a2e4db9aa13$var$defaults.strictNullHandling
    };
};
module.exports = function(object, opts) {
    var obj = object;
    var options = $478f2a2e4db9aa13$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === "function") {
        filter = options.filter;
        obj = filter("", obj);
    } else if ($478f2a2e4db9aa13$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== "object" || obj === null) return "";
    var generateArrayPrefix = $478f2a2e4db9aa13$var$arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === "comma" && options.commaRoundTrip;
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    var sideChannel = $f7bW3();
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        if (options.skipNulls && obj[key] === null) continue;
        $478f2a2e4db9aa13$var$pushToArray(keys, $478f2a2e4db9aa13$var$stringify(obj[key], key, generateArrayPrefix, commaRoundTrip, options.allowEmptyArrays, options.strictNullHandling, options.skipNulls, options.encodeDotInKeys, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? "?" : "";
    if (options.charsetSentinel) {
        if (options.charset === "iso-8859-1") // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += "utf8=%26%2310003%3B&";
        else // encodeURIComponent('✓')
        prefix += "utf8=%E2%9C%93&";
    }
    return joined.length > 0 ? prefix + joined : "";
};

});
parcelRegister("f7bW3", function(module, exports) {
"use strict";

var $auUvQ = parcelRequire("auUvQ");

var $isbsx = parcelRequire("isbsx");

var $6tJ7c = parcelRequire("6tJ7c");

var $5hCNP = parcelRequire("5hCNP");
var $b010c48f9847886a$var$$WeakMap = $auUvQ("%WeakMap%", true);
var $b010c48f9847886a$var$$Map = $auUvQ("%Map%", true);
var $b010c48f9847886a$var$$weakMapGet = $isbsx("WeakMap.prototype.get", true);
var $b010c48f9847886a$var$$weakMapSet = $isbsx("WeakMap.prototype.set", true);
var $b010c48f9847886a$var$$weakMapHas = $isbsx("WeakMap.prototype.has", true);
var $b010c48f9847886a$var$$mapGet = $isbsx("Map.prototype.get", true);
var $b010c48f9847886a$var$$mapSet = $isbsx("Map.prototype.set", true);
var $b010c48f9847886a$var$$mapHas = $isbsx("Map.prototype.has", true);
/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list. By doing so, all the recently used nodes can be accessed relatively quickly.
*/ /** @type {import('.').listGetNode} */ var $b010c48f9847886a$var$listGetNode = function(list, key) {
    /** @type {typeof list | NonNullable<(typeof list)['next']>} */ var prev = list;
    /** @type {(typeof list)['next']} */ var curr;
    for(; (curr = prev.next) !== null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        // eslint-disable-next-line no-extra-parens
        curr.next = /** @type {NonNullable<typeof list.next>} */ list.next;
        list.next = curr; // eslint-disable-line no-param-reassign
        return curr;
    }
};
/** @type {import('.').listGet} */ var $b010c48f9847886a$var$listGet = function(objects, key) {
    var node = $b010c48f9847886a$var$listGetNode(objects, key);
    return node && node.value;
};
/** @type {import('.').listSet} */ var $b010c48f9847886a$var$listSet = function(objects, key, value) {
    var node = $b010c48f9847886a$var$listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = /** @type {import('.').ListNode<typeof value>} */ {
        key: key,
        next: objects.next,
        value: value
    };
};
/** @type {import('.').listHas} */ var $b010c48f9847886a$var$listHas = function(objects, key) {
    return !!$b010c48f9847886a$var$listGetNode(objects, key);
};
/** @type {import('.')} */ module.exports = function getSideChannel() {
    /** @type {WeakMap<object, unknown>} */ var $wm;
    /** @type {Map<object, unknown>} */ var $m;
    /** @type {import('.').RootNode<unknown>} */ var $o;
    /** @type {import('.').Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $5hCNP("Side channel does not contain " + $6tJ7c(key));
        },
        get: function(key) {
            if ($b010c48f9847886a$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $b010c48f9847886a$var$$weakMapGet($wm, key);
            } else if ($b010c48f9847886a$var$$Map) {
                if ($m) return $b010c48f9847886a$var$$mapGet($m, key);
            } else {
                if ($o) return $b010c48f9847886a$var$listGet($o, key);
            }
        },
        has: function(key) {
            if ($b010c48f9847886a$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $b010c48f9847886a$var$$weakMapHas($wm, key);
            } else if ($b010c48f9847886a$var$$Map) {
                if ($m) return $b010c48f9847886a$var$$mapHas($m, key);
            } else {
                if ($o) return $b010c48f9847886a$var$listHas($o, key);
            }
            return false;
        },
        set: function(key, value) {
            if ($b010c48f9847886a$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if (!$wm) $wm = new $b010c48f9847886a$var$$WeakMap();
                $b010c48f9847886a$var$$weakMapSet($wm, key, value);
            } else if ($b010c48f9847886a$var$$Map) {
                if (!$m) $m = new $b010c48f9847886a$var$$Map();
                $b010c48f9847886a$var$$mapSet($m, key, value);
            } else {
                if (!$o) // Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
                $o = {
                    key: {},
                    next: null
                };
                $b010c48f9847886a$var$listSet($o, key, value);
            }
        }
    };
    return channel;
};

});
parcelRegister("auUvQ", function(module, exports) {
"use strict";
var $7a488af73258008a$var$undefined1;

var $jc0d2 = parcelRequire("jc0d2");

var $605Sa = parcelRequire("605Sa");

var $3rnGa = parcelRequire("3rnGa");

var $bF6u1 = parcelRequire("bF6u1");

var $ggmAr = parcelRequire("ggmAr");

var $5hCNP = parcelRequire("5hCNP");

var $6PUrL = parcelRequire("6PUrL");
var $7a488af73258008a$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $7a488af73258008a$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $7a488af73258008a$var$$Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $7a488af73258008a$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($7a488af73258008a$var$$gOPD) try {
    $7a488af73258008a$var$$gOPD({}, "");
} catch (e) {
    $7a488af73258008a$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $7a488af73258008a$var$throwTypeError = function() {
    throw new $5hCNP();
};
var $7a488af73258008a$var$ThrowTypeError = $7a488af73258008a$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $7a488af73258008a$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $7a488af73258008a$var$$gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return $7a488af73258008a$var$throwTypeError;
        }
    }
}() : $7a488af73258008a$var$throwTypeError;

var $7a488af73258008a$var$hasSymbols = (parcelRequire("lFD4A"))();

var $7a488af73258008a$var$hasProto = (parcelRequire("iph8K"))();
var $7a488af73258008a$var$getProto = Object.getPrototypeOf || ($7a488af73258008a$var$hasProto ? function(x) {
    return x.__proto__;
} // eslint-disable-line no-proto
 : null);
var $7a488af73258008a$var$needsEval = {};
var $7a488af73258008a$var$TypedArray = typeof Uint8Array === "undefined" || !$7a488af73258008a$var$getProto ? undefined : $7a488af73258008a$var$getProto(Uint8Array);
var $7a488af73258008a$var$INTRINSICS = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError === "undefined" ? undefined : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined : ArrayBuffer,
    "%ArrayIteratorPrototype%": $7a488af73258008a$var$hasSymbols && $7a488af73258008a$var$getProto ? $7a488af73258008a$var$getProto([][Symbol.iterator]()) : undefined,
    "%AsyncFromSyncIteratorPrototype%": undefined,
    "%AsyncFunction%": $7a488af73258008a$var$needsEval,
    "%AsyncGenerator%": $7a488af73258008a$var$needsEval,
    "%AsyncGeneratorFunction%": $7a488af73258008a$var$needsEval,
    "%AsyncIteratorPrototype%": $7a488af73258008a$var$needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? undefined : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? undefined : BigInt,
    "%BigInt64Array%": typeof BigInt64Array === "undefined" ? undefined : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array === "undefined" ? undefined : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? undefined : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": $jc0d2,
    "%eval%": eval,
    "%EvalError%": $605Sa,
    "%Float32Array%": typeof Float32Array === "undefined" ? undefined : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? undefined : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined : FinalizationRegistry,
    "%Function%": $7a488af73258008a$var$$Function,
    "%GeneratorFunction%": $7a488af73258008a$var$needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? undefined : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? undefined : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? undefined : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": $7a488af73258008a$var$hasSymbols && $7a488af73258008a$var$getProto ? $7a488af73258008a$var$getProto($7a488af73258008a$var$getProto([][Symbol.iterator]())) : undefined,
    "%JSON%": typeof JSON === "object" ? JSON : undefined,
    "%Map%": typeof Map === "undefined" ? undefined : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !$7a488af73258008a$var$hasSymbols || !$7a488af73258008a$var$getProto ? undefined : $7a488af73258008a$var$getProto(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? undefined : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? undefined : Proxy,
    "%RangeError%": $3rnGa,
    "%ReferenceError%": $bF6u1,
    "%Reflect%": typeof Reflect === "undefined" ? undefined : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? undefined : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !$7a488af73258008a$var$hasSymbols || !$7a488af73258008a$var$getProto ? undefined : $7a488af73258008a$var$getProto(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": $7a488af73258008a$var$hasSymbols && $7a488af73258008a$var$getProto ? $7a488af73258008a$var$getProto(""[Symbol.iterator]()) : undefined,
    "%Symbol%": $7a488af73258008a$var$hasSymbols ? Symbol : undefined,
    "%SyntaxError%": $ggmAr,
    "%ThrowTypeError%": $7a488af73258008a$var$ThrowTypeError,
    "%TypedArray%": $7a488af73258008a$var$TypedArray,
    "%TypeError%": $5hCNP,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined : Uint32Array,
    "%URIError%": $6PUrL,
    "%WeakMap%": typeof WeakMap === "undefined" ? undefined : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? undefined : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? undefined : WeakSet
};
if ($7a488af73258008a$var$getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $7a488af73258008a$var$errorProto = $7a488af73258008a$var$getProto($7a488af73258008a$var$getProto(e));
    $7a488af73258008a$var$INTRINSICS["%Error.prototype%"] = $7a488af73258008a$var$errorProto;
}
var $7a488af73258008a$var$doEval = function doEval(name) {
    var value;
    if (name === "%AsyncFunction%") value = $7a488af73258008a$var$getEvalledConstructor("async function () {}");
    else if (name === "%GeneratorFunction%") value = $7a488af73258008a$var$getEvalledConstructor("function* () {}");
    else if (name === "%AsyncGeneratorFunction%") value = $7a488af73258008a$var$getEvalledConstructor("async function* () {}");
    else if (name === "%AsyncGenerator%") {
        var fn = doEval("%AsyncGeneratorFunction%");
        if (fn) value = fn.prototype;
    } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval("%AsyncGenerator%");
        if (gen && $7a488af73258008a$var$getProto) value = $7a488af73258008a$var$getProto(gen.prototype);
    }
    $7a488af73258008a$var$INTRINSICS[name] = value;
    return value;
};
var $7a488af73258008a$var$LEGACY_ALIASES = {
    __proto__: null,
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};

var $bliDA = parcelRequire("bliDA");

var $6RNCT = parcelRequire("6RNCT");
var $7a488af73258008a$var$$concat = $bliDA.call(Function.call, Array.prototype.concat);
var $7a488af73258008a$var$$spliceApply = $bliDA.call(Function.apply, Array.prototype.splice);
var $7a488af73258008a$var$$replace = $bliDA.call(Function.call, String.prototype.replace);
var $7a488af73258008a$var$$strSlice = $bliDA.call(Function.call, String.prototype.slice);
var $7a488af73258008a$var$$exec = $bliDA.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $7a488af73258008a$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $7a488af73258008a$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $7a488af73258008a$var$stringToPath = function stringToPath(string) {
    var first = $7a488af73258008a$var$$strSlice(string, 0, 1);
    var last = $7a488af73258008a$var$$strSlice(string, -1);
    if (first === "%" && last !== "%") throw new $ggmAr("invalid intrinsic syntax, expected closing `%`");
    else if (last === "%" && first !== "%") throw new $ggmAr("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    $7a488af73258008a$var$$replace(string, $7a488af73258008a$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $7a488af73258008a$var$$replace(subString, $7a488af73258008a$var$reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var $7a488af73258008a$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($6RNCT($7a488af73258008a$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $7a488af73258008a$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if ($6RNCT($7a488af73258008a$var$INTRINSICS, intrinsicName)) {
        var value = $7a488af73258008a$var$INTRINSICS[intrinsicName];
        if (value === $7a488af73258008a$var$needsEval) value = $7a488af73258008a$var$doEval(intrinsicName);
        if (typeof value === "undefined" && !allowMissing) throw new $5hCNP("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $ggmAr("intrinsic " + name + " does not exist!");
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $5hCNP("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $5hCNP('"allowMissing" argument must be a boolean');
    if ($7a488af73258008a$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $ggmAr("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var parts = $7a488af73258008a$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = $7a488af73258008a$var$getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $7a488af73258008a$var$$spliceApply(parts, $7a488af73258008a$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $7a488af73258008a$var$$strSlice(part, 0, 1);
        var last = $7a488af73258008a$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $ggmAr("property names with quotes must have matching quotes");
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if ($6RNCT($7a488af73258008a$var$INTRINSICS, intrinsicRealName)) value = $7a488af73258008a$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $5hCNP("base intrinsic for " + name + " exists, but the property is not available.");
                return void 0;
            }
            if ($7a488af73258008a$var$$gOPD && i + 1 >= parts.length) {
                var desc = $7a488af73258008a$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $6RNCT(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $7a488af73258008a$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("jc0d2", function(module, exports) {
"use strict";
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("605Sa", function(module, exports) {
"use strict";
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("3rnGa", function(module, exports) {
"use strict";
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("bF6u1", function(module, exports) {
"use strict";
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("ggmAr", function(module, exports) {
"use strict";
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("5hCNP", function(module, exports) {
"use strict";
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("6PUrL", function(module, exports) {
"use strict";
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("lFD4A", function(module, exports) {
"use strict";
var $fc6bbc62eae712e2$var$origSymbol = typeof Symbol !== "undefined" && Symbol;

var $h1Ikh = parcelRequire("h1Ikh");
module.exports = function hasNativeSymbols() {
    if (typeof $fc6bbc62eae712e2$var$origSymbol !== "function") return false;
    if (typeof Symbol !== "function") return false;
    if (typeof $fc6bbc62eae712e2$var$origSymbol("foo") !== "symbol") return false;
    if (typeof Symbol("bar") !== "symbol") return false;
    return $h1Ikh();
};

});
parcelRegister("h1Ikh", function(module, exports) {
"use strict";
/* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
    if (typeof Symbol.iterator === "symbol") return true;
    var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") return false;
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("iph8K", function(module, exports) {
"use strict";
var $d667db76df0fb5cd$var$test = {
    __proto__: null,
    foo: {}
};
var $d667db76df0fb5cd$var$$Object = Object;
/** @type {import('.')} */ module.exports = function hasProto() {
    // @ts-expect-error: TS errors on an inherited property for some reason
    return ({
        __proto__: $d667db76df0fb5cd$var$test
    }).foo === $d667db76df0fb5cd$var$test.foo && !($d667db76df0fb5cd$var$test instanceof $d667db76df0fb5cd$var$$Object);
};

});

parcelRegister("bliDA", function(module, exports) {
"use strict";

var $b1ZGj = parcelRequire("b1ZGj");
module.exports = Function.prototype.bind || $b1ZGj;

});
parcelRegister("b1ZGj", function(module, exports) {
"use strict";
/* eslint no-invalid-this: 1 */ var $807fa25e1ea5ace7$var$ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var $807fa25e1ea5ace7$var$toStr = Object.prototype.toString;
var $807fa25e1ea5ace7$var$max = Math.max;
var $807fa25e1ea5ace7$var$funcType = "[object Function]";
var $807fa25e1ea5ace7$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $807fa25e1ea5ace7$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $807fa25e1ea5ace7$var$joiny = function(arr, joiner) {
    var str = "";
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== "function" || $807fa25e1ea5ace7$var$toStr.apply(target) !== $807fa25e1ea5ace7$var$funcType) throw new TypeError($807fa25e1ea5ace7$var$ERROR_MESSAGE + target);
    var args = $807fa25e1ea5ace7$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $807fa25e1ea5ace7$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $807fa25e1ea5ace7$var$concatty(args, arguments));
    };
    var boundLength = $807fa25e1ea5ace7$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = "$" + i;
    bound = Function("binder", "return function (" + $807fa25e1ea5ace7$var$joiny(boundArgs, ",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("6RNCT", function(module, exports) {
"use strict";
var $4ffe3013813a3cbe$var$call = Function.prototype.call;
var $4ffe3013813a3cbe$var$$hasOwn = Object.prototype.hasOwnProperty;

var $bliDA = parcelRequire("bliDA");
/** @type {import('.')} */ module.exports = $bliDA.call($4ffe3013813a3cbe$var$call, $4ffe3013813a3cbe$var$$hasOwn);

});


parcelRegister("isbsx", function(module, exports) {
"use strict";

var $auUvQ = parcelRequire("auUvQ");

var $2BDQs = parcelRequire("2BDQs");
var $d6f3bb136530f427$var$$indexOf = $2BDQs($auUvQ("String.prototype.indexOf"));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $auUvQ(name, !!allowMissing);
    if (typeof intrinsic === "function" && $d6f3bb136530f427$var$$indexOf(name, ".prototype.") > -1) return $2BDQs(intrinsic);
    return intrinsic;
};

});
parcelRegister("2BDQs", function(module, exports) {
"use strict";

var $bliDA = parcelRequire("bliDA");

var $auUvQ = parcelRequire("auUvQ");

var $1D49M = parcelRequire("1D49M");

var $5hCNP = parcelRequire("5hCNP");
var $1e5df1df185c23a6$var$$apply = $auUvQ("%Function.prototype.apply%");
var $1e5df1df185c23a6$var$$call = $auUvQ("%Function.prototype.call%");
var $1e5df1df185c23a6$var$$reflectApply = $auUvQ("%Reflect.apply%", true) || $bliDA.call($1e5df1df185c23a6$var$$call, $1e5df1df185c23a6$var$$apply);

var $59F4b = parcelRequire("59F4b");
var $1e5df1df185c23a6$var$$max = $auUvQ("%Math.max%");
module.exports = function callBind(originalFunction) {
    if (typeof originalFunction !== "function") throw new $5hCNP("a function is required");
    var func = $1e5df1df185c23a6$var$$reflectApply($bliDA, $1e5df1df185c23a6$var$$call, arguments);
    return $1D49M(func, 1 + $1e5df1df185c23a6$var$$max(0, originalFunction.length - (arguments.length - 1)), true);
};
var $1e5df1df185c23a6$var$applyBind = function applyBind() {
    return $1e5df1df185c23a6$var$$reflectApply($bliDA, $1e5df1df185c23a6$var$$apply, arguments);
};
if ($59F4b) $59F4b(module.exports, "apply", {
    value: $1e5df1df185c23a6$var$applyBind
});
else module.exports.apply = $1e5df1df185c23a6$var$applyBind;

});
parcelRegister("1D49M", function(module, exports) {
"use strict";

var $auUvQ = parcelRequire("auUvQ");

var $cQt6r = parcelRequire("cQt6r");

var $12fca86dca62157a$var$hasDescriptors = (parcelRequire("idhXF"))();

var $2NTtE = parcelRequire("2NTtE");

var $5hCNP = parcelRequire("5hCNP");
var $12fca86dca62157a$var$$floor = $auUvQ("%Math.floor%");
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== "function") throw new $5hCNP("`fn` is not a function");
    if (typeof length !== "number" || length < 0 || length > 0xFFFFFFFF || $12fca86dca62157a$var$$floor(length) !== length) throw new $5hCNP("`length` must be a positive 32-bit integer");
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ("length" in fn && $2NTtE) {
        var desc = $2NTtE(fn, "length");
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($12fca86dca62157a$var$hasDescriptors) $cQt6r(/** @type {Parameters<define>[0]} */ fn, "length", length, true, true);
        else $cQt6r(/** @type {Parameters<define>[0]} */ fn, "length", length);
    }
    return fn;
};

});
parcelRegister("cQt6r", function(module, exports) {
"use strict";

var $59F4b = parcelRequire("59F4b");

var $ggmAr = parcelRequire("ggmAr");

var $5hCNP = parcelRequire("5hCNP");

var $2NTtE = parcelRequire("2NTtE");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== "object" && typeof obj !== "function") throw new $5hCNP("`obj` must be an object or a function`");
    if (typeof property !== "string" && typeof property !== "symbol") throw new $5hCNP("`property` must be a string or a symbol`");
    if (arguments.length > 3 && typeof arguments[3] !== "boolean" && arguments[3] !== null) throw new $5hCNP("`nonEnumerable`, if provided, must be a boolean or null");
    if (arguments.length > 4 && typeof arguments[4] !== "boolean" && arguments[4] !== null) throw new $5hCNP("`nonWritable`, if provided, must be a boolean or null");
    if (arguments.length > 5 && typeof arguments[5] !== "boolean" && arguments[5] !== null) throw new $5hCNP("`nonConfigurable`, if provided, must be a boolean or null");
    if (arguments.length > 6 && typeof arguments[6] !== "boolean") throw new $5hCNP("`loose`, if provided, must be a boolean");
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$2NTtE && $2NTtE(obj, property);
    if ($59F4b) $59F4b(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $ggmAr("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
};

});
parcelRegister("59F4b", function(module, exports) {
"use strict";

var $auUvQ = parcelRequire("auUvQ");
/** @type {import('.')} */ var $3c0da5f3f07ff735$var$$defineProperty = $auUvQ("%Object.defineProperty%", true) || false;
if ($3c0da5f3f07ff735$var$$defineProperty) try {
    $3c0da5f3f07ff735$var$$defineProperty({}, "a", {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $3c0da5f3f07ff735$var$$defineProperty = false;
}
module.exports = $3c0da5f3f07ff735$var$$defineProperty;

});

parcelRegister("2NTtE", function(module, exports) {
"use strict";

var $auUvQ = parcelRequire("auUvQ");
var $20ab310411dec6e2$var$$gOPD = $auUvQ("%Object.getOwnPropertyDescriptor%", true);
if ($20ab310411dec6e2$var$$gOPD) try {
    $20ab310411dec6e2$var$$gOPD([], "length");
} catch (e) {
    // IE 8 has a broken gOPD
    $20ab310411dec6e2$var$$gOPD = null;
}
module.exports = $20ab310411dec6e2$var$$gOPD;

});


parcelRegister("idhXF", function(module, exports) {
"use strict";

var $59F4b = parcelRequire("59F4b");
var $d4275fa3f61e5028$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$59F4b;
};
$d4275fa3f61e5028$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$59F4b) return null;
    try {
        return $59F4b([], "length", {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $d4275fa3f61e5028$var$hasPropertyDescriptors;

});




parcelRegister("6tJ7c", function(module, exports) {
var $4b787273e873ac0b$var$hasMap = typeof Map === "function" && Map.prototype;
var $4b787273e873ac0b$var$mapSizeDescriptor = Object.getOwnPropertyDescriptor && $4b787273e873ac0b$var$hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null;
var $4b787273e873ac0b$var$mapSize = $4b787273e873ac0b$var$hasMap && $4b787273e873ac0b$var$mapSizeDescriptor && typeof $4b787273e873ac0b$var$mapSizeDescriptor.get === "function" ? $4b787273e873ac0b$var$mapSizeDescriptor.get : null;
var $4b787273e873ac0b$var$mapForEach = $4b787273e873ac0b$var$hasMap && Map.prototype.forEach;
var $4b787273e873ac0b$var$hasSet = typeof Set === "function" && Set.prototype;
var $4b787273e873ac0b$var$setSizeDescriptor = Object.getOwnPropertyDescriptor && $4b787273e873ac0b$var$hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null;
var $4b787273e873ac0b$var$setSize = $4b787273e873ac0b$var$hasSet && $4b787273e873ac0b$var$setSizeDescriptor && typeof $4b787273e873ac0b$var$setSizeDescriptor.get === "function" ? $4b787273e873ac0b$var$setSizeDescriptor.get : null;
var $4b787273e873ac0b$var$setForEach = $4b787273e873ac0b$var$hasSet && Set.prototype.forEach;
var $4b787273e873ac0b$var$hasWeakMap = typeof WeakMap === "function" && WeakMap.prototype;
var $4b787273e873ac0b$var$weakMapHas = $4b787273e873ac0b$var$hasWeakMap ? WeakMap.prototype.has : null;
var $4b787273e873ac0b$var$hasWeakSet = typeof WeakSet === "function" && WeakSet.prototype;
var $4b787273e873ac0b$var$weakSetHas = $4b787273e873ac0b$var$hasWeakSet ? WeakSet.prototype.has : null;
var $4b787273e873ac0b$var$hasWeakRef = typeof WeakRef === "function" && WeakRef.prototype;
var $4b787273e873ac0b$var$weakRefDeref = $4b787273e873ac0b$var$hasWeakRef ? WeakRef.prototype.deref : null;
var $4b787273e873ac0b$var$booleanValueOf = Boolean.prototype.valueOf;
var $4b787273e873ac0b$var$objectToString = Object.prototype.toString;
var $4b787273e873ac0b$var$functionToString = Function.prototype.toString;
var $4b787273e873ac0b$var$$match = String.prototype.match;
var $4b787273e873ac0b$var$$slice = String.prototype.slice;
var $4b787273e873ac0b$var$$replace = String.prototype.replace;
var $4b787273e873ac0b$var$$toUpperCase = String.prototype.toUpperCase;
var $4b787273e873ac0b$var$$toLowerCase = String.prototype.toLowerCase;
var $4b787273e873ac0b$var$$test = RegExp.prototype.test;
var $4b787273e873ac0b$var$$concat = Array.prototype.concat;
var $4b787273e873ac0b$var$$join = Array.prototype.join;
var $4b787273e873ac0b$var$$arrSlice = Array.prototype.slice;
var $4b787273e873ac0b$var$$floor = Math.floor;
var $4b787273e873ac0b$var$bigIntValueOf = typeof BigInt === "function" ? BigInt.prototype.valueOf : null;
var $4b787273e873ac0b$var$gOPS = Object.getOwnPropertySymbols;
var $4b787273e873ac0b$var$symToString = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? Symbol.prototype.toString : null;
var $4b787273e873ac0b$var$hasShammedSymbols = typeof Symbol === "function" && typeof Symbol.iterator === "object";
// ie, `has-tostringtag/shams
var $4b787273e873ac0b$var$toStringTag = typeof Symbol === "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === $4b787273e873ac0b$var$hasShammedSymbols ? "object" : "symbol") ? Symbol.toStringTag : null;
var $4b787273e873ac0b$var$isEnumerable = Object.prototype.propertyIsEnumerable;
var $4b787273e873ac0b$var$gPO = (typeof Reflect === "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function $4b787273e873ac0b$var$addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $4b787273e873ac0b$var$$test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === "number") {
        var int = num < 0 ? -$4b787273e873ac0b$var$$floor(-num) : $4b787273e873ac0b$var$$floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $4b787273e873ac0b$var$$slice.call(str, intStr.length + 1);
            return $4b787273e873ac0b$var$$replace.call(intStr, sepRegex, "$&_") + "." + $4b787273e873ac0b$var$$replace.call($4b787273e873ac0b$var$$replace.call(dec, /([0-9]{3})/g, "$&_"), /_$/, "");
        }
    }
    return $4b787273e873ac0b$var$$replace.call(str, sepRegex, "$&_");
}

var $k6jEX = parcelRequire("k6jEX");
var $4b787273e873ac0b$var$inspectCustom = $k6jEX.custom;
var $4b787273e873ac0b$var$inspectSymbol = $4b787273e873ac0b$var$isSymbol($4b787273e873ac0b$var$inspectCustom) ? $4b787273e873ac0b$var$inspectCustom : null;
module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if ($4b787273e873ac0b$var$has(opts, "quoteStyle") && opts.quoteStyle !== "single" && opts.quoteStyle !== "double") throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if ($4b787273e873ac0b$var$has(opts, "maxStringLength") && (typeof opts.maxStringLength === "number" ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = $4b787273e873ac0b$var$has(opts, "customInspect") ? opts.customInspect : true;
    if (typeof customInspect !== "boolean" && customInspect !== "symbol") throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if ($4b787273e873ac0b$var$has(opts, "indent") && opts.indent !== null && opts.indent !== "	" && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if ($4b787273e873ac0b$var$has(opts, "numericSeparator") && typeof opts.numericSeparator !== "boolean") throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === "undefined") return "undefined";
    if (obj === null) return "null";
    if (typeof obj === "boolean") return obj ? "true" : "false";
    if (typeof obj === "string") return $4b787273e873ac0b$var$inspectString(obj, opts);
    if (typeof obj === "number") {
        if (obj === 0) return Infinity / obj > 0 ? "0" : "-0";
        var str = String(obj);
        return numericSeparator ? $4b787273e873ac0b$var$addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === "bigint") {
        var bigIntStr = String(obj) + "n";
        return numericSeparator ? $4b787273e873ac0b$var$addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === "undefined" ? 5 : opts.depth;
    if (typeof depth === "undefined") depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === "object") return $4b787273e873ac0b$var$isArray(obj) ? "[Array]" : "[Object]";
    var indent = $4b787273e873ac0b$var$getIndent(opts, depth);
    if (typeof seen === "undefined") seen = [];
    else if ($4b787273e873ac0b$var$indexOf(seen, obj) >= 0) return "[Circular]";
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $4b787273e873ac0b$var$$arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if ($4b787273e873ac0b$var$has(opts, "quoteStyle")) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === "function" && !$4b787273e873ac0b$var$isRegExp(obj)) {
        var name = $4b787273e873ac0b$var$nameOf(obj);
        var keys = $4b787273e873ac0b$var$arrObjKeys(obj, inspect);
        return "[Function" + (name ? ": " + name : " (anonymous)") + "]" + (keys.length > 0 ? " { " + $4b787273e873ac0b$var$$join.call(keys, ", ") + " }" : "");
    }
    if ($4b787273e873ac0b$var$isSymbol(obj)) {
        var symString = $4b787273e873ac0b$var$hasShammedSymbols ? $4b787273e873ac0b$var$$replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, "$1") : $4b787273e873ac0b$var$symToString.call(obj);
        return typeof obj === "object" && !$4b787273e873ac0b$var$hasShammedSymbols ? $4b787273e873ac0b$var$markBoxed(symString) : symString;
    }
    if ($4b787273e873ac0b$var$isElement(obj)) {
        var s = "<" + $4b787273e873ac0b$var$$toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += " " + attrs[i].name + "=" + $4b787273e873ac0b$var$wrapQuotes($4b787273e873ac0b$var$quote(attrs[i].value), "double", opts);
        s += ">";
        if (obj.childNodes && obj.childNodes.length) s += "...";
        s += "</" + $4b787273e873ac0b$var$$toLowerCase.call(String(obj.nodeName)) + ">";
        return s;
    }
    if ($4b787273e873ac0b$var$isArray(obj)) {
        if (obj.length === 0) return "[]";
        var xs = $4b787273e873ac0b$var$arrObjKeys(obj, inspect);
        if (indent && !$4b787273e873ac0b$var$singleLineValues(xs)) return "[" + $4b787273e873ac0b$var$indentedJoin(xs, indent) + "]";
        return "[ " + $4b787273e873ac0b$var$$join.call(xs, ", ") + " ]";
    }
    if ($4b787273e873ac0b$var$isError(obj)) {
        var parts = $4b787273e873ac0b$var$arrObjKeys(obj, inspect);
        if (!("cause" in Error.prototype) && "cause" in obj && !$4b787273e873ac0b$var$isEnumerable.call(obj, "cause")) return "{ [" + String(obj) + "] " + $4b787273e873ac0b$var$$join.call($4b787273e873ac0b$var$$concat.call("[cause]: " + inspect(obj.cause), parts), ", ") + " }";
        if (parts.length === 0) return "[" + String(obj) + "]";
        return "{ [" + String(obj) + "] " + $4b787273e873ac0b$var$$join.call(parts, ", ") + " }";
    }
    if (typeof obj === "object" && customInspect) {
        if ($4b787273e873ac0b$var$inspectSymbol && typeof obj[$4b787273e873ac0b$var$inspectSymbol] === "function" && $k6jEX) return $k6jEX(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== "symbol" && typeof obj.inspect === "function") return obj.inspect();
    }
    if ($4b787273e873ac0b$var$isMap(obj)) {
        var mapParts = [];
        if ($4b787273e873ac0b$var$mapForEach) $4b787273e873ac0b$var$mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + " => " + inspect(value, obj));
        });
        return $4b787273e873ac0b$var$collectionOf("Map", $4b787273e873ac0b$var$mapSize.call(obj), mapParts, indent);
    }
    if ($4b787273e873ac0b$var$isSet(obj)) {
        var setParts = [];
        if ($4b787273e873ac0b$var$setForEach) $4b787273e873ac0b$var$setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return $4b787273e873ac0b$var$collectionOf("Set", $4b787273e873ac0b$var$setSize.call(obj), setParts, indent);
    }
    if ($4b787273e873ac0b$var$isWeakMap(obj)) return $4b787273e873ac0b$var$weakCollectionOf("WeakMap");
    if ($4b787273e873ac0b$var$isWeakSet(obj)) return $4b787273e873ac0b$var$weakCollectionOf("WeakSet");
    if ($4b787273e873ac0b$var$isWeakRef(obj)) return $4b787273e873ac0b$var$weakCollectionOf("WeakRef");
    if ($4b787273e873ac0b$var$isNumber(obj)) return $4b787273e873ac0b$var$markBoxed(inspect(Number(obj)));
    if ($4b787273e873ac0b$var$isBigInt(obj)) return $4b787273e873ac0b$var$markBoxed(inspect($4b787273e873ac0b$var$bigIntValueOf.call(obj)));
    if ($4b787273e873ac0b$var$isBoolean(obj)) return $4b787273e873ac0b$var$markBoxed($4b787273e873ac0b$var$booleanValueOf.call(obj));
    if ($4b787273e873ac0b$var$isString(obj)) return $4b787273e873ac0b$var$markBoxed(inspect(String(obj)));
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */ if (typeof window !== "undefined" && obj === window) return "{ [object Window] }";
    if (obj === $parcel$global) return "{ [object globalThis] }";
    if (!$4b787273e873ac0b$var$isDate(obj) && !$4b787273e873ac0b$var$isRegExp(obj)) {
        var ys = $4b787273e873ac0b$var$arrObjKeys(obj, inspect);
        var isPlainObject = $4b787273e873ac0b$var$gPO ? $4b787273e873ac0b$var$gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? "" : "null prototype";
        var stringTag = !isPlainObject && $4b787273e873ac0b$var$toStringTag && Object(obj) === obj && $4b787273e873ac0b$var$toStringTag in obj ? $4b787273e873ac0b$var$$slice.call($4b787273e873ac0b$var$toStr(obj), 8, -1) : protoTag ? "Object" : "";
        var constructorTag = isPlainObject || typeof obj.constructor !== "function" ? "" : obj.constructor.name ? obj.constructor.name + " " : "";
        var tag = constructorTag + (stringTag || protoTag ? "[" + $4b787273e873ac0b$var$$join.call($4b787273e873ac0b$var$$concat.call([], stringTag || [], protoTag || []), ": ") + "] " : "");
        if (ys.length === 0) return tag + "{}";
        if (indent) return tag + "{" + $4b787273e873ac0b$var$indentedJoin(ys, indent) + "}";
        return tag + "{ " + $4b787273e873ac0b$var$$join.call(ys, ", ") + " }";
    }
    return String(obj);
};
function $4b787273e873ac0b$var$wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === "double" ? '"' : "'";
    return quoteChar + s + quoteChar;
}
function $4b787273e873ac0b$var$quote(s) {
    return $4b787273e873ac0b$var$$replace.call(String(s), /"/g, "&quot;");
}
function $4b787273e873ac0b$var$isArray(obj) {
    return $4b787273e873ac0b$var$toStr(obj) === "[object Array]" && (!$4b787273e873ac0b$var$toStringTag || !(typeof obj === "object" && $4b787273e873ac0b$var$toStringTag in obj));
}
function $4b787273e873ac0b$var$isDate(obj) {
    return $4b787273e873ac0b$var$toStr(obj) === "[object Date]" && (!$4b787273e873ac0b$var$toStringTag || !(typeof obj === "object" && $4b787273e873ac0b$var$toStringTag in obj));
}
function $4b787273e873ac0b$var$isRegExp(obj) {
    return $4b787273e873ac0b$var$toStr(obj) === "[object RegExp]" && (!$4b787273e873ac0b$var$toStringTag || !(typeof obj === "object" && $4b787273e873ac0b$var$toStringTag in obj));
}
function $4b787273e873ac0b$var$isError(obj) {
    return $4b787273e873ac0b$var$toStr(obj) === "[object Error]" && (!$4b787273e873ac0b$var$toStringTag || !(typeof obj === "object" && $4b787273e873ac0b$var$toStringTag in obj));
}
function $4b787273e873ac0b$var$isString(obj) {
    return $4b787273e873ac0b$var$toStr(obj) === "[object String]" && (!$4b787273e873ac0b$var$toStringTag || !(typeof obj === "object" && $4b787273e873ac0b$var$toStringTag in obj));
}
function $4b787273e873ac0b$var$isNumber(obj) {
    return $4b787273e873ac0b$var$toStr(obj) === "[object Number]" && (!$4b787273e873ac0b$var$toStringTag || !(typeof obj === "object" && $4b787273e873ac0b$var$toStringTag in obj));
}
function $4b787273e873ac0b$var$isBoolean(obj) {
    return $4b787273e873ac0b$var$toStr(obj) === "[object Boolean]" && (!$4b787273e873ac0b$var$toStringTag || !(typeof obj === "object" && $4b787273e873ac0b$var$toStringTag in obj));
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function $4b787273e873ac0b$var$isSymbol(obj) {
    if ($4b787273e873ac0b$var$hasShammedSymbols) return obj && typeof obj === "object" && obj instanceof Symbol;
    if (typeof obj === "symbol") return true;
    if (!obj || typeof obj !== "object" || !$4b787273e873ac0b$var$symToString) return false;
    try {
        $4b787273e873ac0b$var$symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function $4b787273e873ac0b$var$isBigInt(obj) {
    if (!obj || typeof obj !== "object" || !$4b787273e873ac0b$var$bigIntValueOf) return false;
    try {
        $4b787273e873ac0b$var$bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var $4b787273e873ac0b$var$hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function $4b787273e873ac0b$var$has(obj, key) {
    return $4b787273e873ac0b$var$hasOwn.call(obj, key);
}
function $4b787273e873ac0b$var$toStr(obj) {
    return $4b787273e873ac0b$var$objectToString.call(obj);
}
function $4b787273e873ac0b$var$nameOf(f) {
    if (f.name) return f.name;
    var m = $4b787273e873ac0b$var$$match.call($4b787273e873ac0b$var$functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function $4b787273e873ac0b$var$indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function $4b787273e873ac0b$var$isMap(x) {
    if (!$4b787273e873ac0b$var$mapSize || !x || typeof x !== "object") return false;
    try {
        $4b787273e873ac0b$var$mapSize.call(x);
        try {
            $4b787273e873ac0b$var$setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $4b787273e873ac0b$var$isWeakMap(x) {
    if (!$4b787273e873ac0b$var$weakMapHas || !x || typeof x !== "object") return false;
    try {
        $4b787273e873ac0b$var$weakMapHas.call(x, $4b787273e873ac0b$var$weakMapHas);
        try {
            $4b787273e873ac0b$var$weakSetHas.call(x, $4b787273e873ac0b$var$weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $4b787273e873ac0b$var$isWeakRef(x) {
    if (!$4b787273e873ac0b$var$weakRefDeref || !x || typeof x !== "object") return false;
    try {
        $4b787273e873ac0b$var$weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function $4b787273e873ac0b$var$isSet(x) {
    if (!$4b787273e873ac0b$var$setSize || !x || typeof x !== "object") return false;
    try {
        $4b787273e873ac0b$var$setSize.call(x);
        try {
            $4b787273e873ac0b$var$mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $4b787273e873ac0b$var$isWeakSet(x) {
    if (!$4b787273e873ac0b$var$weakSetHas || !x || typeof x !== "object") return false;
    try {
        $4b787273e873ac0b$var$weakSetHas.call(x, $4b787273e873ac0b$var$weakSetHas);
        try {
            $4b787273e873ac0b$var$weakMapHas.call(x, $4b787273e873ac0b$var$weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $4b787273e873ac0b$var$isElement(x) {
    if (!x || typeof x !== "object") return false;
    if (typeof HTMLElement !== "undefined" && x instanceof HTMLElement) return true;
    return typeof x.nodeName === "string" && typeof x.getAttribute === "function";
}
function $4b787273e873ac0b$var$inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = "... " + remaining + " more character" + (remaining > 1 ? "s" : "");
        return $4b787273e873ac0b$var$inspectString($4b787273e873ac0b$var$$slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $4b787273e873ac0b$var$$replace.call($4b787273e873ac0b$var$$replace.call(str, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, $4b787273e873ac0b$var$lowbyte);
    return $4b787273e873ac0b$var$wrapQuotes(s, "single", opts);
}
function $4b787273e873ac0b$var$lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: "b",
        9: "t",
        10: "n",
        12: "f",
        13: "r"
    }[n];
    if (x) return "\\" + x;
    return "\\x" + (n < 0x10 ? "0" : "") + $4b787273e873ac0b$var$$toUpperCase.call(n.toString(16));
}
function $4b787273e873ac0b$var$markBoxed(str) {
    return "Object(" + str + ")";
}
function $4b787273e873ac0b$var$weakCollectionOf(type) {
    return type + " { ? }";
}
function $4b787273e873ac0b$var$collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? $4b787273e873ac0b$var$indentedJoin(entries, indent) : $4b787273e873ac0b$var$$join.call(entries, ", ");
    return type + " (" + size + ") {" + joinedEntries + "}";
}
function $4b787273e873ac0b$var$singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if ($4b787273e873ac0b$var$indexOf(xs[i], "\n") >= 0) return false;
    }
    return true;
}
function $4b787273e873ac0b$var$getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === "	") baseIndent = "	";
    else if (typeof opts.indent === "number" && opts.indent > 0) baseIndent = $4b787273e873ac0b$var$$join.call(Array(opts.indent + 1), " ");
    else return null;
    return {
        base: baseIndent,
        prev: $4b787273e873ac0b$var$$join.call(Array(depth + 1), baseIndent)
    };
}
function $4b787273e873ac0b$var$indentedJoin(xs, indent) {
    if (xs.length === 0) return "";
    var lineJoiner = "\n" + indent.prev + indent.base;
    return lineJoiner + $4b787273e873ac0b$var$$join.call(xs, "," + lineJoiner) + "\n" + indent.prev;
}
function $4b787273e873ac0b$var$arrObjKeys(obj, inspect) {
    var isArr = $4b787273e873ac0b$var$isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = $4b787273e873ac0b$var$has(obj, i) ? inspect(obj[i], obj) : "";
    }
    var syms = typeof $4b787273e873ac0b$var$gOPS === "function" ? $4b787273e873ac0b$var$gOPS(obj) : [];
    var symMap;
    if ($4b787273e873ac0b$var$hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap["$" + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!$4b787273e873ac0b$var$has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if ($4b787273e873ac0b$var$hasShammedSymbols && symMap["$" + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($4b787273e873ac0b$var$$test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ": " + inspect(obj[key], obj));
        else xs.push(key + ": " + inspect(obj[key], obj));
    }
    if (typeof $4b787273e873ac0b$var$gOPS === "function") {
        for(var j = 0; j < syms.length; j++)if ($4b787273e873ac0b$var$isEnumerable.call(obj, syms[j])) xs.push("[" + inspect(syms[j]) + "]: " + inspect(obj[syms[j]], obj));
    }
    return xs;
}

});
parcelRegister("k6jEX", function(module, exports) {
"use strict";

});



parcelRegister("fyIa7", function(module, exports) {
"use strict";

var $jBJw6 = parcelRequire("jBJw6");
var $b53c49af39cc9676$var$has = Object.prototype.hasOwnProperty;
var $b53c49af39cc9676$var$isArray = Array.isArray;
var $b53c49af39cc9676$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array.push("%" + ((i < 16 ? "0" : "") + i.toString(16)).toUpperCase());
    return array;
}();
var $b53c49af39cc9676$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($b53c49af39cc9676$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== "undefined") compacted.push(obj[j]);
            item.obj[item.prop] = compacted;
        }
    }
};
var $b53c49af39cc9676$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== "undefined") obj[i] = source[i];
    return obj;
};
var $b53c49af39cc9676$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== "object") {
        if ($b53c49af39cc9676$var$isArray(target)) target.push(source);
        else if (target && typeof target === "object") {
            if (options && (options.plainObjects || options.allowPrototypes) || !$b53c49af39cc9676$var$has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== "object") return [
        target
    ].concat(source);
    var mergeTarget = target;
    if ($b53c49af39cc9676$var$isArray(target) && !$b53c49af39cc9676$var$isArray(source)) mergeTarget = $b53c49af39cc9676$var$arrayToObject(target, options);
    if ($b53c49af39cc9676$var$isArray(target) && $b53c49af39cc9676$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($b53c49af39cc9676$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === "object" && item && typeof item === "object") target[i] = merge(targetItem, item, options);
                else target.push(item);
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($b53c49af39cc9676$var$has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        return acc;
    }, mergeTarget);
};
var $b53c49af39cc9676$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var $b53c49af39cc9676$var$decode = function(str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, " ");
    if (charset === "iso-8859-1") // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $b53c49af39cc9676$var$limit = 1024;
/* eslint operator-linebreak: [2, "before"] */ var $b53c49af39cc9676$var$encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === "symbol") string = Symbol.prototype.toString.call(str);
    else if (typeof str !== "string") string = String(str);
    if (charset === "iso-8859-1") return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return "%26%23" + parseInt($0.slice(2), 16) + "%3B";
    });
    var out = "";
    for(var j = 0; j < string.length; j += $b53c49af39cc9676$var$limit){
        var segment = string.length >= $b53c49af39cc9676$var$limit ? string.slice(j, j + $b53c49af39cc9676$var$limit) : string;
        var arr = [];
        for(var i = 0; i < segment.length; ++i){
            var c = segment.charCodeAt(i);
            if (c === 0x2D // -
             || c === 0x2E // .
             || c === 0x5F // _
             || c === 0x7E // ~
             || c >= 0x30 && c <= 0x39 // 0-9
             || c >= 0x41 && c <= 0x5A // a-z
             || c >= 0x61 && c <= 0x7A // A-Z
             || format === $jBJw6.RFC1738 && (c === 0x28 || c === 0x29) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }
            if (c < 0x80) {
                arr[arr.length] = $b53c49af39cc9676$var$hexTable[c];
                continue;
            }
            if (c < 0x800) {
                arr[arr.length] = $b53c49af39cc9676$var$hexTable[0xC0 | c >> 6] + $b53c49af39cc9676$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = $b53c49af39cc9676$var$hexTable[0xE0 | c >> 12] + $b53c49af39cc9676$var$hexTable[0x80 | c >> 6 & 0x3F] + $b53c49af39cc9676$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            i += 1;
            c = 0x10000 + ((c & 0x3FF) << 10 | segment.charCodeAt(i) & 0x3FF);
            arr[arr.length] = $b53c49af39cc9676$var$hexTable[0xF0 | c >> 18] + $b53c49af39cc9676$var$hexTable[0x80 | c >> 12 & 0x3F] + $b53c49af39cc9676$var$hexTable[0x80 | c >> 6 & 0x3F] + $b53c49af39cc9676$var$hexTable[0x80 | c & 0x3F];
        }
        out += arr.join("");
    }
    return out;
};
var $b53c49af39cc9676$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: "o"
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === "object" && val !== null && refs.indexOf(val) === -1) {
                queue.push({
                    obj: obj,
                    prop: key
                });
                refs.push(val);
            }
        }
    }
    $b53c49af39cc9676$var$compactQueue(queue);
    return value;
};
var $b53c49af39cc9676$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === "[object RegExp]";
};
var $b53c49af39cc9676$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== "object") return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var $b53c49af39cc9676$var$combine = function combine(a, b) {
    return [].concat(a, b);
};
var $b53c49af39cc9676$var$maybeMap = function maybeMap(val, fn) {
    if ($b53c49af39cc9676$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped.push(fn(val[i]));
        return mapped;
    }
    return fn(val);
};
module.exports = {
    arrayToObject: $b53c49af39cc9676$var$arrayToObject,
    assign: $b53c49af39cc9676$var$assign,
    combine: $b53c49af39cc9676$var$combine,
    compact: $b53c49af39cc9676$var$compact,
    decode: $b53c49af39cc9676$var$decode,
    encode: $b53c49af39cc9676$var$encode,
    isBuffer: $b53c49af39cc9676$var$isBuffer,
    isRegExp: $b53c49af39cc9676$var$isRegExp,
    maybeMap: $b53c49af39cc9676$var$maybeMap,
    merge: $b53c49af39cc9676$var$merge
};

});
parcelRegister("jBJw6", function(module, exports) {
"use strict";
var $e464c7b97e69a6c3$var$replace = String.prototype.replace;
var $e464c7b97e69a6c3$var$percentTwenties = /%20/g;
var $e464c7b97e69a6c3$var$Format = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
};
module.exports = {
    "default": $e464c7b97e69a6c3$var$Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return $e464c7b97e69a6c3$var$replace.call(value, $e464c7b97e69a6c3$var$percentTwenties, "+");
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: $e464c7b97e69a6c3$var$Format.RFC1738,
    RFC3986: $e464c7b97e69a6c3$var$Format.RFC3986
};

});



parcelRegister("eMSpG", function(module, exports) {
"use strict";

var $fyIa7 = parcelRequire("fyIa7");
var $ac3fc1b6715248f1$var$has = Object.prototype.hasOwnProperty;
var $ac3fc1b6715248f1$var$isArray = Array.isArray;
var $ac3fc1b6715248f1$var$defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: $fyIa7.decode,
    delimiter: "&",
    depth: 5,
    duplicates: "combine",
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};
var $ac3fc1b6715248f1$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var $ac3fc1b6715248f1$var$parseArrayValue = function(val, options) {
    if (val && typeof val === "string" && options.comma && val.indexOf(",") > -1) return val.split(",");
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $ac3fc1b6715248f1$var$isoSentinel = "utf8=%26%2310003%3B"; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $ac3fc1b6715248f1$var$charsetSentinel = "utf8=%E2%9C%93"; // encodeURIComponent('✓')
var $ac3fc1b6715248f1$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {
        __proto__: null
    };
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, "") : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf("utf8=") === 0) {
            if (parts[i] === $ac3fc1b6715248f1$var$charsetSentinel) charset = "utf-8";
            else if (parts[i] === $ac3fc1b6715248f1$var$isoSentinel) charset = "iso-8859-1";
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf("]=");
        var pos = bracketEqualsPos === -1 ? part.indexOf("=") : bracketEqualsPos + 1;
        var key, val;
        if (pos === -1) {
            key = options.decoder(part, $ac3fc1b6715248f1$var$defaults.decoder, charset, "key");
            val = options.strictNullHandling ? null : "";
        } else {
            key = options.decoder(part.slice(0, pos), $ac3fc1b6715248f1$var$defaults.decoder, charset, "key");
            val = $fyIa7.maybeMap($ac3fc1b6715248f1$var$parseArrayValue(part.slice(pos + 1), options), function(encodedVal) {
                return options.decoder(encodedVal, $ac3fc1b6715248f1$var$defaults.decoder, charset, "value");
            });
        }
        if (val && options.interpretNumericEntities && charset === "iso-8859-1") val = $ac3fc1b6715248f1$var$interpretNumericEntities(val);
        if (part.indexOf("[]=") > -1) val = $ac3fc1b6715248f1$var$isArray(val) ? [
            val
        ] : val;
        var existing = $ac3fc1b6715248f1$var$has.call(obj, key);
        if (existing && options.duplicates === "combine") obj[key] = $fyIa7.combine(obj[key], val);
        else if (!existing || options.duplicates === "last") obj[key] = val;
    }
    return obj;
};
var $ac3fc1b6715248f1$var$parseObject = function(chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : $ac3fc1b6715248f1$var$parseArrayValue(val, options);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === "[]" && options.parseArrays) obj = options.allowEmptyArrays && leaf === "" ? [] : [].concat(leaf);
        else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === "[" && root.charAt(root.length - 1) === "]" ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, ".") : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            if (!options.parseArrays && decodedRoot === "") obj = {
                0: leaf
            };
            else if (!isNaN(index) && root !== decodedRoot && String(index) === decodedRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (decodedRoot !== "__proto__") obj[decodedRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
var $ac3fc1b6715248f1$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, "[$1]") : givenKey;
    // The regex chunks
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    // Get the parent
    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    // Stash the parent if it exists
    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && $ac3fc1b6715248f1$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys.push(parent);
    }
    // Loop through children appending to the array until we hit depth
    var i = 0;
    while(options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        if (!options.plainObjects && $ac3fc1b6715248f1$var$has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) return;
        }
        keys.push(segment[1]);
    }
    // If there's a remainder, just add whatever is left
    if (segment) keys.push("[" + key.slice(segment.index) + "]");
    return $ac3fc1b6715248f1$var$parseObject(keys, val, options, valuesParsed);
};
var $ac3fc1b6715248f1$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $ac3fc1b6715248f1$var$defaults;
    if (typeof opts.allowEmptyArrays !== "undefined" && typeof opts.allowEmptyArrays !== "boolean") throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof opts.decodeDotInKeys !== "undefined" && typeof opts.decodeDotInKeys !== "boolean") throw new TypeError("`decodeDotInKeys` option can only be `true` or `false`, when provided");
    if (opts.decoder !== null && typeof opts.decoder !== "undefined" && typeof opts.decoder !== "function") throw new TypeError("Decoder has to be a function.");
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var charset = typeof opts.charset === "undefined" ? $ac3fc1b6715248f1$var$defaults.charset : opts.charset;
    var duplicates = typeof opts.duplicates === "undefined" ? $ac3fc1b6715248f1$var$defaults.duplicates : opts.duplicates;
    if (duplicates !== "combine" && duplicates !== "first" && duplicates !== "last") throw new TypeError("The duplicates option must be either combine, first, or last");
    var allowDots = typeof opts.allowDots === "undefined" ? opts.decodeDotInKeys === true ? true : $ac3fc1b6715248f1$var$defaults.allowDots : !!opts.allowDots;
    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === "boolean" ? !!opts.allowEmptyArrays : $ac3fc1b6715248f1$var$defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === "boolean" ? opts.allowPrototypes : $ac3fc1b6715248f1$var$defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === "boolean" ? opts.allowSparse : $ac3fc1b6715248f1$var$defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === "number" ? opts.arrayLimit : $ac3fc1b6715248f1$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $ac3fc1b6715248f1$var$defaults.charsetSentinel,
        comma: typeof opts.comma === "boolean" ? opts.comma : $ac3fc1b6715248f1$var$defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === "boolean" ? opts.decodeDotInKeys : $ac3fc1b6715248f1$var$defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === "function" ? opts.decoder : $ac3fc1b6715248f1$var$defaults.decoder,
        delimiter: typeof opts.delimiter === "string" || $fyIa7.isRegExp(opts.delimiter) ? opts.delimiter : $ac3fc1b6715248f1$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === "number" || opts.depth === false ? +opts.depth : $ac3fc1b6715248f1$var$defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === "boolean" ? opts.interpretNumericEntities : $ac3fc1b6715248f1$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === "number" ? opts.parameterLimit : $ac3fc1b6715248f1$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === "boolean" ? opts.plainObjects : $ac3fc1b6715248f1$var$defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $ac3fc1b6715248f1$var$defaults.strictNullHandling
    };
};
module.exports = function(str, opts) {
    var options = $ac3fc1b6715248f1$var$normalizeParseOptions(opts);
    if (str === "" || str === null || typeof str === "undefined") return options.plainObjects ? Object.create(null) : {};
    var tempObj = typeof str === "string" ? $ac3fc1b6715248f1$var$parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $ac3fc1b6715248f1$var$parseKeys(key, tempObj[key], options, typeof str === "string");
        obj = $fyIa7.merge(obj, newObj, options);
    }
    if (options.allowSparse === true) return obj;
    return $fyIa7.compact(obj);
};

});



parcelRegister("iSVU0", function(module, exports) {
/*
 * Shared and maintained by [Nezasa](http://www.nezasa.com)
 * Published under [Apache 2.0 license](http://www.apache.org/licenses/LICENSE-2.0.html)
 * © Nezasa, 2012-2013
 *
 * ---
 *
 * Javascript library for parsing of ISO 8601 durations. Supported are durations of
 * the form P3Y6M4DT12H30M17S or PT1S or P1Y4DT1H3S etc.
 *
 * @author Nezasa AG -- https://github.com/nezasa
 * @contributor Jason "Palamedes" Ellis -- https://github.com/palamedes
 * @contributor mdartic -- https://github.com/mdartic
 * @contributor murb -- https://github.com/murb
 */ // if the module has no dependencies, the above pattern can be simplified to
(function(root, factory) {
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define([], factory);
    else if (0, module.exports) // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
    else {
        // Browser globals (root is window)
        // maintaining nezasa global
        if (!root.nezasa) root.nezasa = {};
        if (!root.nezasa.iso8601) root.nezasa.iso8601 = factory();
    }
})(module.exports, function() {
    var iso8601 = {
        Period: {}
    };
    // create sub packages
    //---- public properties
    /**
     * version of the ISO8601 version
     */ iso8601.version = "0.2";
    //---- public methods
    /**
     * Returns an array of the duration per unit. The normalized sum of all array elements
     * represents the total duration.
     *
     * - array[0]: years
     * - array[1]: months
     * - array[2]: weeks
     * - array[3]: days
     * - array[4]: hours
     * - array[5]: minutes
     * - array[6]: seconds
     *
     * @param period iso8601 period string
     * @param distributeOverflow if 'true', the unit overflows are merge into the next higher units. Defaults to 'false'.
     */ iso8601.Period.parse = function(period, distributeOverflow) {
        return parsePeriodString(period, distributeOverflow);
    };
    /**
     * Returns the total duration of the period in seconds.
     */ iso8601.Period.parseToTotalSeconds = function(period) {
        var multiplicators = [
            31104000 /* year   (360*24*60*60) */ ,
            2592000 /* month  (30*24*60*60) */ ,
            604800 /* week   (24*60*60*7) */ ,
            86400 /* day    (24*60*60) */ ,
            3600 /* hour   (60*60) */ ,
            60 /* minute (60) */ ,
            1 /* second (1) */ 
        ];
        var durationPerUnit = parsePeriodString(period);
        var durationInSeconds = 0;
        for(var i = 0; i < durationPerUnit.length; i++)durationInSeconds += durationPerUnit[i] * multiplicators[i];
        return durationInSeconds;
    };
    /**
     * Return boolean based on validity of period
     * @param period
     * @return {Boolean}
     */ iso8601.Period.isValid = function(period) {
        try {
            parsePeriodString(period);
            return true;
        } catch (e) {
            return false;
        }
    };
    /**
     * Returns a more readable string representation of the ISO8601 period.
     * @param period the ISO8601 period string
     * @param unitName the names of the time units if there is only one (such as hour or minute).
     *        Defaults to ['year', 'month', 'week', 'day', 'hour', 'minute', 'second'].
     * @param unitNamePlural thenames of the time units if there are several (such as hours or minutes).
     *        Defaults to ['years', 'months', 'weeks', 'days', 'hours', 'minutes', 'seconds'].
     * @param distributeOverflow if 'true', the unit overflows are merge into the next higher units. Defaults to 'false'.
     */ iso8601.Period.parseToString = function(period, unitNames, unitNamesPlural, distributeOverflow) {
        var result = [
            "",
            "",
            "",
            "",
            "",
            "",
            ""
        ];
        var durationPerUnit = parsePeriodString(period, distributeOverflow);
        // input validation (use english as default)
        if (!unitNames) unitNames = [
            "year",
            "month",
            "week",
            "day",
            "hour",
            "minute",
            "second"
        ];
        if (!unitNamesPlural) unitNamesPlural = [
            "years",
            "months",
            "weeks",
            "days",
            "hours",
            "minutes",
            "seconds"
        ];
        // assemble string per unit
        for(var i = 0; i < durationPerUnit.length; i++)if (durationPerUnit[i] > 0) {
            if (durationPerUnit[i] == 1) result[i] = durationPerUnit[i] + " " + unitNames[i];
            else result[i] = durationPerUnit[i] + " " + unitNamesPlural[i];
        }
        // trim because of space at very end and because of join(" ")
        // replace double spaces because of join(" ") and empty strings
        // Its actually possible to get more than 2 spaces in a row,
        //   so lets get 2+ spaces and remove them
        return result.join(" ").trim().replace(/[ ]{2,}/g, " ");
    };
    //---- private methods
    /**
     * Parses a ISO8601 period string.
     * @param period iso8601 period string
     * @param _distributeOverflow if 'true', the unit overflows are merge into the next higher units.
     */ function parsePeriodString(period, _distributeOverflow) {
        // regex splits as follows
        // grp0 omitted as it is equal to the sample
        //
        // | sample            | grp1   | grp2 | grp3 | grp4 | grp5 | grp6       | grp7 | grp8 | grp9 |
        // --------------------------------------------------------------------------------------------
        // | P1Y2M3W           | 1Y2M3W | 1Y   | 2M   | 3W   | 4D   | T12H30M17S | 12H  | 30M  | 17S  |
        // | P3Y6M4DT12H30M17S | 3Y6M4D | 3Y   | 6M   |      | 4D   | T12H30M17S | 12H  | 30M  | 17S  |
        // | P1M               | 1M     |      | 1M   |      |      |            |      |      |      |
        // | PT1M              | 3Y6M4D |      |      |      |      | T1M        |      | 1M   |      |
        // --------------------------------------------------------------------------------------------
        var distributeOverflow = _distributeOverflow ? _distributeOverflow : false;
        var valueIndexes = [
            2,
            3,
            4,
            5,
            7,
            8,
            9
        ];
        var duration = [
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        var overflowLimits = [
            0,
            12,
            4,
            7,
            24,
            60,
            60
        ];
        var struct;
        // upcase the string just in case people don't follow the letter of the law
        period = period.toUpperCase();
        // input validation
        if (!period) return duration;
        else if (typeof period !== "string") throw new Error("Invalid iso8601 period string '" + period + "'");
        // parse the string
        if (struct = /^P((\d+Y)?(\d+M)?(\d+W)?(\d+D)?)?(T(\d+H)?(\d+M)?(\d+S)?)?$/.exec(period)) // remove letters, replace by 0 if not defined
        for(var i = 0; i < valueIndexes.length; i++){
            var structIndex = valueIndexes[i];
            duration[i] = struct[structIndex] ? +struct[structIndex].replace(/[A-Za-z]+/g, "") : 0;
        }
        else throw new Error("String '" + period + "' is not a valid ISO8601 period.");
        if (distributeOverflow) {
            // note: stop at 1 to ignore overflow of years
            for(var i = duration.length - 1; i > 0; i--)if (duration[i] >= overflowLimits[i]) {
                duration[i - 1] = duration[i - 1] + Math.floor(duration[i] / overflowLimits[i]);
                duration[i] = duration[i] % overflowLimits[i];
            }
        }
        return duration;
    }
    return iso8601;
});

});

parcelRegister("6vz4b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4bd0d6c9d52320b4$export$2e2bcd8739ae039; });

var $1j4QO = parcelRequire("1j4QO");
function $4bd0d6c9d52320b4$var$_extends() {
    $4bd0d6c9d52320b4$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4bd0d6c9d52320b4$var$_extends.apply(this, arguments);
}
class $4bd0d6c9d52320b4$export$2e2bcd8739ae039 {
    constructor(options){
        this.req = null;
        this.onStart = null;
        this.onSuccess = null;
        this.onError = null;
        this.url = null;
        this.timeout = 30000;
        this.data = {};
        this.sendType = "application/json";
        this.responseType = null;
        this.method = "POST";
        this.headers = {};
        this.link = "cancel";
        if (typeof options !== "undefined") Object.entries(options).forEach(([k, v])=>{
            if (k === "onStart" || k === "onSuccess" || k === "onError" || k === "url" || k === "timeout" || k === "data" || k === "dataType" || k === "method" || k === "link" || k === "headers" || k === "sendType" || k === "responseType") this[k] = v;
        }, this);
    }
    get(newData, merge) {
        if (typeof merge === "undefined") merge = false;
        this.method = "GET";
        if (typeof newData !== "undefined") {
            if (merge) this.data = $4bd0d6c9d52320b4$var$_extends(this.data, newData);
            else this.data = newData;
        }
        this._execute();
    }
    post(newData, merge) {
        if (typeof merge === "undefined") merge = false;
        this.method = "POST";
        if (merge) this.data = $4bd0d6c9d52320b4$var$_extends(this.data, newData);
        else this.data = newData;
        this._execute();
    }
    make(newData, merge) {
        if (typeof merge === "undefined") merge = false;
        if (merge) this.data = $4bd0d6c9d52320b4$var$_extends(this.data, newData);
        else this.data = newData;
        this._execute();
    }
    _execute() {
        if (this.link === "cancel" && this.req) this.req.abort();
        // TODO handle link=chain
        if (this.onStart) this.onStart();
        this.req = null;
        this.req = (0, (/*@__PURE__*/$parcel$interopDefault($1j4QO)))(this.method, this.url).set(this.headers).type(this.sendType).timeout({
            response: this.timeout,
            deadline: this.timeout
        });
        if (this.method === "GET" || this.method === "HEAD") this.req.query(this.data);
        else this.req.send(this.data);
        if (this.responseType) this.req.responseType(this.responseType);
        // Must be here because then() triggers the actual request
        this.req.then((function(resp) {
            // SUCCESS
            //if(resp.error) 
            if (this.onSuccess) this.onSuccess(resp);
        }).bind(this)).catch((function(err) {
            // Ignore Aborted requests
            if (this.link === "cancel" && err.code === "ABORTED") return true;
            // ERROR
            if (this.onError) this.onError(err);
        }).bind(this));
    }
    cancel() {
        this.xhr.abort();
    }
}

});
parcelRegister("1j4QO", function(module, exports) {
"use strict";
/**
 * Root reference for iframes.
 */ let root;
if (typeof window !== "undefined") // Browser window
root = window;
else if (typeof self === "undefined") {
    // Other environments
    console.warn("Using browser-only version of superagent in non-browser environment");
    root = void 0;
} else // Web Worker
root = self;

var $6Ax4b = parcelRequire("6Ax4b");

var $bVHgR = parcelRequire("bVHgR");

var $hxUF9 = parcelRequire("hxUF9");

var $3T9ir = parcelRequire("3T9ir");

var $8GwVl = parcelRequire("8GwVl");
var $0f3b540fcf995d53$require$isObject = $8GwVl.isObject;
var $0f3b540fcf995d53$require$mixin = $8GwVl.mixin;
var $0f3b540fcf995d53$require$hasOwn = $8GwVl.hasOwn;

var $l4TXj = parcelRequire("l4TXj");

var $6kTtl = parcelRequire("6kTtl");
/**
 * Noop.
 */ function noop() {}
/**
 * Expose `request`.
 */ module.exports = function(method, url) {
    // callback
    if (typeof url === "function") return new exports.Request("GET", method).end(url);
    // url first
    if (arguments.length === 1) return new exports.Request("GET", method);
    return new exports.Request(method, url);
};
exports = module.exports;
const request = exports;
exports.Request = Request;
/**
 * Determine XHR.
 */ request.getXHR = ()=>{
    if (root.XMLHttpRequest) return new root.XMLHttpRequest();
    throw new Error("Browser-only version of superagent could not find XHR");
};
/**
 * Removes leading and trailing whitespace, added to support IE.
 *
 * @param {String} s
 * @return {String}
 * @api private
 */ const trim = "".trim ? (s)=>s.trim() : (s)=>s.replace(/(^\s*|\s*$)/g, "");
/**
 * Serialize the given `obj`.
 *
 * @param {Object} obj
 * @return {String}
 * @api private
 */ function serialize(object) {
    if (!$0f3b540fcf995d53$require$isObject(object)) return object;
    const pairs = [];
    for(const key in object)if ($0f3b540fcf995d53$require$hasOwn(object, key)) pushEncodedKeyValuePair(pairs, key, object[key]);
    return pairs.join("&");
}
/**
 * Helps 'serialize' with serializing arrays.
 * Mutates the pairs array.
 *
 * @param {Array} pairs
 * @param {String} key
 * @param {Mixed} val
 */ function pushEncodedKeyValuePair(pairs, key, value) {
    if (value === undefined) return;
    if (value === null) {
        pairs.push(encodeURI(key));
        return;
    }
    if (Array.isArray(value)) for (const v of value)pushEncodedKeyValuePair(pairs, key, v);
    else if ($0f3b540fcf995d53$require$isObject(value)) {
        for(const subkey in value)if ($0f3b540fcf995d53$require$hasOwn(value, subkey)) pushEncodedKeyValuePair(pairs, `${key}[${subkey}]`, value[subkey]);
    } else pairs.push(encodeURI(key) + "=" + encodeURIComponent(value));
}
/**
 * Expose serialization method.
 */ request.serializeObject = serialize;
/**
 * Parse the given x-www-form-urlencoded `str`.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */ function parseString(string_) {
    const object = {};
    const pairs = string_.split("&");
    let pair;
    let pos;
    for(let i = 0, length_ = pairs.length; i < length_; ++i){
        pair = pairs[i];
        pos = pair.indexOf("=");
        if (pos === -1) object[decodeURIComponent(pair)] = "";
        else object[decodeURIComponent(pair.slice(0, pos))] = decodeURIComponent(pair.slice(pos + 1));
    }
    return object;
}
/**
 * Expose parser.
 */ request.parseString = parseString;
/**
 * Default MIME type map.
 *
 *     superagent.types.xml = 'application/xml';
 *
 */ request.types = {
    html: "text/html",
    json: "application/json",
    xml: "text/xml",
    urlencoded: "application/x-www-form-urlencoded",
    form: "application/x-www-form-urlencoded",
    "form-data": "application/x-www-form-urlencoded"
};
/**
 * Default serialization map.
 *
 *     superagent.serialize['application/xml'] = function(obj){
 *       return 'generated xml here';
 *     };
 *
 */ request.serialize = {
    "application/x-www-form-urlencoded": $hxUF9.stringify,
    "application/json": $bVHgR
};
/**
 * Default parsers.
 *
 *     superagent.parse['application/xml'] = function(str){
 *       return { object parsed from str };
 *     };
 *
 */ request.parse = {
    "application/x-www-form-urlencoded": parseString,
    "application/json": JSON.parse
};
/**
 * Parse the given header `str` into
 * an object containing the mapped fields.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */ function parseHeader(string_) {
    const lines = string_.split(/\r?\n/);
    const fields = {};
    let index;
    let line;
    let field;
    let value;
    for(let i = 0, length_ = lines.length; i < length_; ++i){
        line = lines[i];
        index = line.indexOf(":");
        if (index === -1) continue;
        field = line.slice(0, index).toLowerCase();
        value = trim(line.slice(index + 1));
        fields[field] = value;
    }
    return fields;
}
/**
 * Check if `mime` is json or has +json structured syntax suffix.
 *
 * @param {String} mime
 * @return {Boolean}
 * @api private
 */ function isJSON(mime) {
    // should match /json or +json
    // but not /json-seq
    return /[/+]json($|[^-\w])/i.test(mime);
}
/**
 * Initialize a new `Response` with the given `xhr`.
 *
 *  - set flags (.ok, .error, etc)
 *  - parse header
 *
 * Examples:
 *
 *  Aliasing `superagent` as `request` is nice:
 *
 *      request = superagent;
 *
 *  We can use the promise-like API, or pass callbacks:
 *
 *      request.get('/').end(function(res){});
 *      request.get('/', function(res){});
 *
 *  Sending data can be chained:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' })
 *        .end(function(res){});
 *
 *  Or passed to `.send()`:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' }, function(res){});
 *
 *  Or passed to `.post()`:
 *
 *      request
 *        .post('/user', { name: 'tj' })
 *        .end(function(res){});
 *
 * Or further reduced to a single call for simple cases:
 *
 *      request
 *        .post('/user', { name: 'tj' }, function(res){});
 *
 * @param {XMLHTTPRequest} xhr
 * @param {Object} options
 * @api private
 */ function Response(request_) {
    this.req = request_;
    this.xhr = this.req.xhr;
    // responseText is accessible only if responseType is '' or 'text' and on older browsers
    this.text = this.req.method !== "HEAD" && (this.xhr.responseType === "" || this.xhr.responseType === "text") || typeof this.xhr.responseType === "undefined" ? this.xhr.responseText : null;
    this.statusText = this.req.xhr.statusText;
    let { status } = this.xhr;
    // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
    if (status === 1223) status = 204;
    this._setStatusProperties(status);
    this.headers = parseHeader(this.xhr.getAllResponseHeaders());
    this.header = this.headers;
    // getAllResponseHeaders sometimes falsely returns "" for CORS requests, but
    // getResponseHeader still works. so we get content-type even if getting
    // other headers fails.
    this.header["content-type"] = this.xhr.getResponseHeader("content-type");
    this._setHeaderProperties(this.header);
    if (this.text === null && request_._responseType) this.body = this.xhr.response;
    else this.body = this.req.method === "HEAD" ? null : this._parseBody(this.text ? this.text : this.xhr.response);
}
$0f3b540fcf995d53$require$mixin(Response.prototype, $l4TXj.prototype);
/**
 * Parse the given body `str`.
 *
 * Used for auto-parsing of bodies. Parsers
 * are defined on the `superagent.parse` object.
 *
 * @param {String} str
 * @return {Mixed}
 * @api private
 */ Response.prototype._parseBody = function(string_) {
    let parse = request.parse[this.type];
    if (this.req._parser) return this.req._parser(this, string_);
    if (!parse && isJSON(this.type)) parse = request.parse["application/json"];
    return parse && string_ && (string_.length > 0 || string_ instanceof Object) ? parse(string_) : null;
};
/**
 * Return an `Error` representative of this response.
 *
 * @return {Error}
 * @api public
 */ Response.prototype.toError = function() {
    const { req } = this;
    const { method } = req;
    const { url } = req;
    const message = `cannot ${method} ${url} (${this.status})`;
    const error = new Error(message);
    error.status = this.status;
    error.method = method;
    error.url = url;
    return error;
};
/**
 * Expose `Response`.
 */ request.Response = Response;
/**
 * Initialize a new `Request` with the given `method` and `url`.
 *
 * @param {String} method
 * @param {String} url
 * @api public
 */ function Request(method, url) {
    const self1 = this;
    this._query = this._query || [];
    this.method = method;
    this.url = url;
    this.header = {}; // preserves header name case
    this._header = {}; // coerces header names to lowercase
    this.on("end", ()=>{
        let error = null;
        let res = null;
        try {
            res = new Response(self1);
        } catch (err) {
            error = new Error("Parser is unable to parse the response");
            error.parse = true;
            error.original = err;
            // issue #675: return the raw response if the response parsing fails
            if (self1.xhr) {
                // ie9 doesn't have 'response' property
                error.rawResponse = typeof self1.xhr.responseType === "undefined" ? self1.xhr.responseText : self1.xhr.response;
                // issue #876: return the http status code if the response parsing fails
                error.status = self1.xhr.status ? self1.xhr.status : null;
                error.statusCode = error.status; // backwards-compat only
            } else {
                error.rawResponse = null;
                error.status = null;
            }
            return self1.callback(error);
        }
        self1.emit("response", res);
        let new_error;
        try {
            if (!self1._isResponseOK(res)) new_error = new Error(res.statusText || res.text || "Unsuccessful HTTP response");
        } catch (err) {
            new_error = err; // ok() callback can throw
        }
        // #1000 don't catch errors from the callback to avoid double calling it
        if (new_error) {
            new_error.original = error;
            new_error.response = res;
            new_error.status = new_error.status || res.status;
            self1.callback(new_error, res);
        } else self1.callback(null, res);
    });
}
/**
 * Mixin `Emitter` and `RequestBase`.
 */ // eslint-disable-next-line new-cap
$6Ax4b(Request.prototype);
$0f3b540fcf995d53$require$mixin(Request.prototype, $3T9ir.prototype);
/**
 * Set Content-Type to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.xml = 'application/xml';
 *
 *      request.post('/')
 *        .type('xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 *      request.post('/')
 *        .type('application/xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 * @param {String} type
 * @return {Request} for chaining
 * @api public
 */ Request.prototype.type = function(type) {
    this.set("Content-Type", request.types[type] || type);
    return this;
};
/**
 * Set Accept to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.json = 'application/json';
 *
 *      request.get('/agent')
 *        .accept('json')
 *        .end(callback);
 *
 *      request.get('/agent')
 *        .accept('application/json')
 *        .end(callback);
 *
 * @param {String} accept
 * @return {Request} for chaining
 * @api public
 */ Request.prototype.accept = function(type) {
    this.set("Accept", request.types[type] || type);
    return this;
};
/**
 * Set Authorization field value with `user` and `pass`.
 *
 * @param {String} user
 * @param {String} [pass] optional in case of using 'bearer' as type
 * @param {Object} options with 'type' property 'auto', 'basic' or 'bearer' (default 'basic')
 * @return {Request} for chaining
 * @api public
 */ Request.prototype.auth = function(user, pass, options) {
    if (arguments.length === 1) pass = "";
    if (typeof pass === "object" && pass !== null) {
        // pass is optional and can be replaced with options
        options = pass;
        pass = "";
    }
    if (!options) options = {
        type: typeof btoa === "function" ? "basic" : "auto"
    };
    const encoder = options.encoder ? options.encoder : (string)=>{
        if (typeof btoa === "function") return btoa(string);
        throw new Error("Cannot use basic auth, btoa is not a function");
    };
    return this._auth(user, pass, options, encoder);
};
/**
 * Add query-string `val`.
 *
 * Examples:
 *
 *   request.get('/shoes')
 *     .query('size=10')
 *     .query({ color: 'blue' })
 *
 * @param {Object|String} val
 * @return {Request} for chaining
 * @api public
 */ Request.prototype.query = function(value) {
    if (typeof value !== "string") value = serialize(value);
    if (value) this._query.push(value);
    return this;
};
/**
 * Queue the given `file` as an attachment to the specified `field`,
 * with optional `options` (or filename).
 *
 * ``` js
 * request.post('/upload')
 *   .attach('content', new Blob(['<a id="a"><b id="b">hey!</b></a>'], { type: "text/html"}))
 *   .end(callback);
 * ```
 *
 * @param {String} field
 * @param {Blob|File} file
 * @param {String|Object} options
 * @return {Request} for chaining
 * @api public
 */ Request.prototype.attach = function(field, file, options) {
    if (file) {
        if (this._data) throw new Error("superagent can't mix .send() and .attach()");
        this._getFormData().append(field, file, options || file.name);
    }
    return this;
};
Request.prototype._getFormData = function() {
    if (!this._formData) this._formData = new root.FormData();
    return this._formData;
};
/**
 * Invoke the callback with `err` and `res`
 * and handle arity check.
 *
 * @param {Error} err
 * @param {Response} res
 * @api private
 */ Request.prototype.callback = function(error, res) {
    if (this._shouldRetry(error, res)) return this._retry();
    const fn = this._callback;
    this.clearTimeout();
    if (error) {
        if (this._maxRetries) error.retries = this._retries - 1;
        this.emit("error", error);
    }
    fn(error, res);
};
/**
 * Invoke callback with x-domain error.
 *
 * @api private
 */ Request.prototype.crossDomainError = function() {
    const error = new Error("Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.");
    error.crossDomain = true;
    error.status = this.status;
    error.method = this.method;
    error.url = this.url;
    this.callback(error);
};
// This only warns, because the request is still likely to work
Request.prototype.agent = function() {
    console.warn("This is not supported in browser version of superagent");
    return this;
};
Request.prototype.ca = Request.prototype.agent;
Request.prototype.buffer = Request.prototype.ca;
// This throws, because it can't send/receive data as expected
Request.prototype.write = ()=>{
    throw new Error("Streaming is not supported in browser version of superagent");
};
Request.prototype.pipe = Request.prototype.write;
/**
 * Check if `obj` is a host object,
 * we don't want to serialize these :)
 *
 * @param {Object} obj host object
 * @return {Boolean} is a host object
 * @api private
 */ Request.prototype._isHost = function(object) {
    // Native objects stringify to [object File], [object Blob], [object FormData], etc.
    return object && typeof object === "object" && !Array.isArray(object) && Object.prototype.toString.call(object) !== "[object Object]";
};
/**
 * Initiate request, invoking callback `fn(res)`
 * with an instanceof `Response`.
 *
 * @param {Function} fn
 * @return {Request} for chaining
 * @api public
 */ Request.prototype.end = function(fn) {
    if (this._endCalled) console.warn("Warning: .end() was called twice. This is not supported in superagent");
    this._endCalled = true;
    // store callback
    this._callback = fn || noop;
    // querystring
    this._finalizeQueryString();
    this._end();
};
Request.prototype._setUploadTimeout = function() {
    const self1 = this;
    // upload timeout it's wokrs only if deadline timeout is off
    if (this._uploadTimeout && !this._uploadTimeoutTimer) this._uploadTimeoutTimer = setTimeout(()=>{
        self1._timeoutError("Upload timeout of ", self1._uploadTimeout, "ETIMEDOUT");
    }, this._uploadTimeout);
};
// eslint-disable-next-line complexity
Request.prototype._end = function() {
    if (this._aborted) return this.callback(new Error("The request has been aborted even before .end() was called"));
    const self1 = this;
    this.xhr = request.getXHR();
    const { xhr } = this;
    let data = this._formData || this._data;
    this._setTimeouts();
    // state change
    xhr.addEventListener("readystatechange", ()=>{
        const { readyState } = xhr;
        if (readyState >= 2 && self1._responseTimeoutTimer) clearTimeout(self1._responseTimeoutTimer);
        if (readyState !== 4) return;
        // In IE9, reads to any property (e.g. status) off of an aborted XHR will
        // result in the error "Could not complete the operation due to error c00c023f"
        let status;
        try {
            status = xhr.status;
        } catch (err) {
            status = 0;
        }
        if (!status) {
            if (self1.timedout || self1._aborted) return;
            return self1.crossDomainError();
        }
        self1.emit("end");
    });
    // progress
    const handleProgress = (direction, e)=>{
        if (e.total > 0) {
            e.percent = e.loaded / e.total * 100;
            if (e.percent === 100) clearTimeout(self1._uploadTimeoutTimer);
        }
        e.direction = direction;
        self1.emit("progress", e);
    };
    if (this.hasListeners("progress")) try {
        xhr.addEventListener("progress", handleProgress.bind(null, "download"));
        if (xhr.upload) xhr.upload.addEventListener("progress", handleProgress.bind(null, "upload"));
    } catch (err) {
    // Accessing xhr.upload fails in IE from a web worker, so just pretend it doesn't exist.
    // Reported here:
    // https://connect.microsoft.com/IE/feedback/details/837245/xmlhttprequest-upload-throws-invalid-argument-when-used-from-web-worker-context
    }
    if (xhr.upload) this._setUploadTimeout();
    // initiate request
    try {
        if (this.username && this.password) xhr.open(this.method, this.url, true, this.username, this.password);
        else xhr.open(this.method, this.url, true);
    } catch (err) {
        // see #1149
        return this.callback(err);
    }
    // CORS
    if (this._withCredentials) xhr.withCredentials = true;
    // body
    if (!this._formData && this.method !== "GET" && this.method !== "HEAD" && typeof data !== "string" && !this._isHost(data)) {
        // serialize stuff
        const contentType = this._header["content-type"];
        let serialize = this._serializer || request.serialize[contentType ? contentType.split(";")[0] : ""];
        if (!serialize && isJSON(contentType)) serialize = request.serialize["application/json"];
        if (serialize) data = serialize(data);
    }
    // set header fields
    for(const field in this.header){
        if (this.header[field] === null) continue;
        if ($0f3b540fcf995d53$require$hasOwn(this.header, field)) xhr.setRequestHeader(field, this.header[field]);
    }
    if (this._responseType) xhr.responseType = this._responseType;
    // send stuff
    this.emit("request", this);
    // IE11 xhr.send(undefined) sends 'undefined' string as POST payload (instead of nothing)
    // We need null here if data is undefined
    xhr.send(typeof data === "undefined" ? null : data);
};
request.agent = ()=>new $6kTtl();
for (const method of [
    "GET",
    "POST",
    "OPTIONS",
    "PATCH",
    "PUT",
    "DELETE"
])$6kTtl.prototype[method.toLowerCase()] = function(url, fn) {
    const request_ = new request.Request(method, url);
    this._setDefaults(request_);
    if (fn) request_.end(fn);
    return request_;
};
$6kTtl.prototype.del = $6kTtl.prototype.delete;
/**
 * GET `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */ request.get = (url, data, fn)=>{
    const request_ = request("GET", url);
    if (typeof data === "function") {
        fn = data;
        data = null;
    }
    if (data) request_.query(data);
    if (fn) request_.end(fn);
    return request_;
};
/**
 * HEAD `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */ request.head = (url, data, fn)=>{
    const request_ = request("HEAD", url);
    if (typeof data === "function") {
        fn = data;
        data = null;
    }
    if (data) request_.query(data);
    if (fn) request_.end(fn);
    return request_;
};
/**
 * OPTIONS query to `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */ request.options = (url, data, fn)=>{
    const request_ = request("OPTIONS", url);
    if (typeof data === "function") {
        fn = data;
        data = null;
    }
    if (data) request_.send(data);
    if (fn) request_.end(fn);
    return request_;
};
/**
 * DELETE `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */ function del(url, data, fn) {
    const request_ = request("DELETE", url);
    if (typeof data === "function") {
        fn = data;
        data = null;
    }
    if (data) request_.send(data);
    if (fn) request_.end(fn);
    return request_;
}
request.del = del;
request.delete = del;
/**
 * PATCH `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */ request.patch = (url, data, fn)=>{
    const request_ = request("PATCH", url);
    if (typeof data === "function") {
        fn = data;
        data = null;
    }
    if (data) request_.send(data);
    if (fn) request_.end(fn);
    return request_;
};
/**
 * POST `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */ request.post = (url, data, fn)=>{
    const request_ = request("POST", url);
    if (typeof data === "function") {
        fn = data;
        data = null;
    }
    if (data) request_.send(data);
    if (fn) request_.end(fn);
    return request_;
};
/**
 * PUT `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */ request.put = (url, data, fn)=>{
    const request_ = request("PUT", url);
    if (typeof data === "function") {
        fn = data;
        data = null;
    }
    if (data) request_.send(data);
    if (fn) request_.end(fn);
    return request_;
};

});
parcelRegister("6Ax4b", function(module, exports) {
/**
 * Expose `Emitter`.
 */ module.exports = $4cbfc13427580a5c$var$Emitter;
/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */ function $4cbfc13427580a5c$var$Emitter(obj) {
    if (obj) return $4cbfc13427580a5c$var$mixin(obj);
}
/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */ function $4cbfc13427580a5c$var$mixin(obj) {
    for(var key in $4cbfc13427580a5c$var$Emitter.prototype)obj[key] = $4cbfc13427580a5c$var$Emitter.prototype[key];
    return obj;
}
/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $4cbfc13427580a5c$var$Emitter.prototype.on = $4cbfc13427580a5c$var$Emitter.prototype.addEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    (this._callbacks["$" + event] = this._callbacks["$" + event] || []).push(fn);
    return this;
};
/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $4cbfc13427580a5c$var$Emitter.prototype.once = function(event, fn) {
    function on() {
        this.off(event, on);
        fn.apply(this, arguments);
    }
    on.fn = fn;
    this.on(event, on);
    return this;
};
/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $4cbfc13427580a5c$var$Emitter.prototype.off = $4cbfc13427580a5c$var$Emitter.prototype.removeListener = $4cbfc13427580a5c$var$Emitter.prototype.removeAllListeners = $4cbfc13427580a5c$var$Emitter.prototype.removeEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    // all
    if (0 == arguments.length) {
        this._callbacks = {};
        return this;
    }
    // specific event
    var callbacks = this._callbacks["$" + event];
    if (!callbacks) return this;
    // remove all handlers
    if (1 == arguments.length) {
        delete this._callbacks["$" + event];
        return this;
    }
    // remove specific handler
    var cb;
    for(var i = 0; i < callbacks.length; i++){
        cb = callbacks[i];
        if (cb === fn || cb.fn === fn) {
            callbacks.splice(i, 1);
            break;
        }
    }
    // Remove event specific arrays for event types that no
    // one is subscribed for to avoid memory leak.
    if (callbacks.length === 0) delete this._callbacks["$" + event];
    return this;
};
/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */ $4cbfc13427580a5c$var$Emitter.prototype.emit = function(event) {
    this._callbacks = this._callbacks || {};
    var args = new Array(arguments.length - 1), callbacks = this._callbacks["$" + event];
    for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    if (callbacks) {
        callbacks = callbacks.slice(0);
        for(var i = 0, len = callbacks.length; i < len; ++i)callbacks[i].apply(this, args);
    }
    return this;
};
/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */ $4cbfc13427580a5c$var$Emitter.prototype.listeners = function(event) {
    this._callbacks = this._callbacks || {};
    return this._callbacks["$" + event] || [];
};
/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */ $4cbfc13427580a5c$var$Emitter.prototype.hasListeners = function(event) {
    return !!this.listeners(event).length;
};

});

parcelRegister("bVHgR", function(module, exports) {
module.exports = $8af695493f68e763$var$stringify;
$8af695493f68e763$var$stringify.default = $8af695493f68e763$var$stringify;
$8af695493f68e763$var$stringify.stable = $8af695493f68e763$var$deterministicStringify;
$8af695493f68e763$var$stringify.stableStringify = $8af695493f68e763$var$deterministicStringify;
var $8af695493f68e763$var$LIMIT_REPLACE_NODE = "[...]";
var $8af695493f68e763$var$CIRCULAR_REPLACE_NODE = "[Circular]";
var $8af695493f68e763$var$arr = [];
var $8af695493f68e763$var$replacerStack = [];
function $8af695493f68e763$var$defaultOptions() {
    return {
        depthLimit: Number.MAX_SAFE_INTEGER,
        edgesLimit: Number.MAX_SAFE_INTEGER
    };
}
// Regular stringify
function $8af695493f68e763$var$stringify(obj, replacer, spacer, options) {
    if (typeof options === "undefined") options = $8af695493f68e763$var$defaultOptions();
    $8af695493f68e763$var$decirc(obj, "", 0, [], undefined, 0, options);
    var res;
    try {
        if ($8af695493f68e763$var$replacerStack.length === 0) res = JSON.stringify(obj, replacer, spacer);
        else res = JSON.stringify(obj, $8af695493f68e763$var$replaceGetterValues(replacer), spacer);
    } catch (_) {
        return JSON.stringify("[unable to serialize, circular reference is too complex to analyze]");
    } finally{
        while($8af695493f68e763$var$arr.length !== 0){
            var part = $8af695493f68e763$var$arr.pop();
            if (part.length === 4) Object.defineProperty(part[0], part[1], part[3]);
            else part[0][part[1]] = part[2];
        }
    }
    return res;
}
function $8af695493f68e763$var$setReplace(replace, val, k, parent) {
    var propertyDescriptor = Object.getOwnPropertyDescriptor(parent, k);
    if (propertyDescriptor.get !== undefined) {
        if (propertyDescriptor.configurable) {
            Object.defineProperty(parent, k, {
                value: replace
            });
            $8af695493f68e763$var$arr.push([
                parent,
                k,
                val,
                propertyDescriptor
            ]);
        } else $8af695493f68e763$var$replacerStack.push([
            val,
            k,
            replace
        ]);
    } else {
        parent[k] = replace;
        $8af695493f68e763$var$arr.push([
            parent,
            k,
            val
        ]);
    }
}
function $8af695493f68e763$var$decirc(val, k, edgeIndex, stack, parent, depth, options) {
    depth += 1;
    var i;
    if (typeof val === "object" && val !== null) {
        for(i = 0; i < stack.length; i++)if (stack[i] === val) {
            $8af695493f68e763$var$setReplace($8af695493f68e763$var$CIRCULAR_REPLACE_NODE, val, k, parent);
            return;
        }
        if (typeof options.depthLimit !== "undefined" && depth > options.depthLimit) {
            $8af695493f68e763$var$setReplace($8af695493f68e763$var$LIMIT_REPLACE_NODE, val, k, parent);
            return;
        }
        if (typeof options.edgesLimit !== "undefined" && edgeIndex + 1 > options.edgesLimit) {
            $8af695493f68e763$var$setReplace($8af695493f68e763$var$LIMIT_REPLACE_NODE, val, k, parent);
            return;
        }
        stack.push(val);
        // Optimize for Arrays. Big arrays could kill the performance otherwise!
        if (Array.isArray(val)) for(i = 0; i < val.length; i++)$8af695493f68e763$var$decirc(val[i], i, i, stack, val, depth, options);
        else {
            var keys = Object.keys(val);
            for(i = 0; i < keys.length; i++){
                var key = keys[i];
                $8af695493f68e763$var$decirc(val[key], key, i, stack, val, depth, options);
            }
        }
        stack.pop();
    }
}
// Stable-stringify
function $8af695493f68e763$var$compareFunction(a, b) {
    if (a < b) return -1;
    if (a > b) return 1;
    return 0;
}
function $8af695493f68e763$var$deterministicStringify(obj, replacer, spacer, options) {
    if (typeof options === "undefined") options = $8af695493f68e763$var$defaultOptions();
    var tmp = $8af695493f68e763$var$deterministicDecirc(obj, "", 0, [], undefined, 0, options) || obj;
    var res;
    try {
        if ($8af695493f68e763$var$replacerStack.length === 0) res = JSON.stringify(tmp, replacer, spacer);
        else res = JSON.stringify(tmp, $8af695493f68e763$var$replaceGetterValues(replacer), spacer);
    } catch (_) {
        return JSON.stringify("[unable to serialize, circular reference is too complex to analyze]");
    } finally{
        // Ensure that we restore the object as it was.
        while($8af695493f68e763$var$arr.length !== 0){
            var part = $8af695493f68e763$var$arr.pop();
            if (part.length === 4) Object.defineProperty(part[0], part[1], part[3]);
            else part[0][part[1]] = part[2];
        }
    }
    return res;
}
function $8af695493f68e763$var$deterministicDecirc(val, k, edgeIndex, stack, parent, depth, options) {
    depth += 1;
    var i;
    if (typeof val === "object" && val !== null) {
        for(i = 0; i < stack.length; i++)if (stack[i] === val) {
            $8af695493f68e763$var$setReplace($8af695493f68e763$var$CIRCULAR_REPLACE_NODE, val, k, parent);
            return;
        }
        try {
            if (typeof val.toJSON === "function") return;
        } catch (_) {
            return;
        }
        if (typeof options.depthLimit !== "undefined" && depth > options.depthLimit) {
            $8af695493f68e763$var$setReplace($8af695493f68e763$var$LIMIT_REPLACE_NODE, val, k, parent);
            return;
        }
        if (typeof options.edgesLimit !== "undefined" && edgeIndex + 1 > options.edgesLimit) {
            $8af695493f68e763$var$setReplace($8af695493f68e763$var$LIMIT_REPLACE_NODE, val, k, parent);
            return;
        }
        stack.push(val);
        // Optimize for Arrays. Big arrays could kill the performance otherwise!
        if (Array.isArray(val)) for(i = 0; i < val.length; i++)$8af695493f68e763$var$deterministicDecirc(val[i], i, i, stack, val, depth, options);
        else {
            // Create a temporary object in the required way
            var tmp = {};
            var keys = Object.keys(val).sort($8af695493f68e763$var$compareFunction);
            for(i = 0; i < keys.length; i++){
                var key = keys[i];
                $8af695493f68e763$var$deterministicDecirc(val[key], key, i, stack, val, depth, options);
                tmp[key] = val[key];
            }
            if (typeof parent !== "undefined") {
                $8af695493f68e763$var$arr.push([
                    parent,
                    k,
                    val
                ]);
                parent[k] = tmp;
            } else return tmp;
        }
        stack.pop();
    }
}
// wraps replacer function to handle values we couldn't replace
// and mark them as replaced value
function $8af695493f68e763$var$replaceGetterValues(replacer) {
    replacer = typeof replacer !== "undefined" ? replacer : function(k, v) {
        return v;
    };
    return function(key, val) {
        if ($8af695493f68e763$var$replacerStack.length > 0) for(var i = 0; i < $8af695493f68e763$var$replacerStack.length; i++){
            var part = $8af695493f68e763$var$replacerStack[i];
            if (part[1] === key && part[0] === val) {
                val = part[2];
                $8af695493f68e763$var$replacerStack.splice(i, 1);
                break;
            }
        }
        return replacer.call(this, key, val);
    };
}

});

parcelRegister("3T9ir", function(module, exports) {

var $fs15M = parcelRequire("fs15M");
"use strict";

var $k6jEX = parcelRequire("k6jEX");

var $8GwVl = parcelRequire("8GwVl");
var $2d4db83817001e3c$require$isObject = $8GwVl.isObject;
var $2d4db83817001e3c$require$hasOwn = $8GwVl.hasOwn;
/**
 * Expose `RequestBase`.
 */ module.exports = $2d4db83817001e3c$var$RequestBase;
/**
 * Initialize a new `RequestBase`.
 *
 * @api public
 */ function $2d4db83817001e3c$var$RequestBase() {}
/**
 * Clear previous timeout.
 *
 * @return {Request} for chaining
 * @api public
 */ $2d4db83817001e3c$var$RequestBase.prototype.clearTimeout = function() {
    clearTimeout(this._timer);
    clearTimeout(this._responseTimeoutTimer);
    clearTimeout(this._uploadTimeoutTimer);
    delete this._timer;
    delete this._responseTimeoutTimer;
    delete this._uploadTimeoutTimer;
    return this;
};
/**
 * Override default response body parser
 *
 * This function will be called to convert incoming data into request.body
 *
 * @param {Function}
 * @api public
 */ $2d4db83817001e3c$var$RequestBase.prototype.parse = function(fn) {
    this._parser = fn;
    return this;
};
/**
 * Set format of binary response body.
 * In browser valid formats are 'blob' and 'arraybuffer',
 * which return Blob and ArrayBuffer, respectively.
 *
 * In Node all values result in Buffer.
 *
 * Examples:
 *
 *      req.get('/')
 *        .responseType('blob')
 *        .end(callback);
 *
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */ $2d4db83817001e3c$var$RequestBase.prototype.responseType = function(value) {
    this._responseType = value;
    return this;
};
/**
 * Override default request body serializer
 *
 * This function will be called to convert data set via .send or .attach into payload to send
 *
 * @param {Function}
 * @api public
 */ $2d4db83817001e3c$var$RequestBase.prototype.serialize = function(fn) {
    this._serializer = fn;
    return this;
};
/**
 * Set timeouts.
 *
 * - response timeout is time between sending request and receiving the first byte of the response. Includes DNS and connection time.
 * - deadline is the time from start of the request to receiving response body in full. If the deadline is too short large files may not load at all on slow connections.
 * - upload is the time  since last bit of data was sent or received. This timeout works only if deadline timeout is off
 *
 * Value of 0 or false means no timeout.
 *
 * @param {Number|Object} ms or {response, deadline}
 * @return {Request} for chaining
 * @api public
 */ $2d4db83817001e3c$var$RequestBase.prototype.timeout = function(options) {
    if (!options || typeof options !== "object") {
        this._timeout = options;
        this._responseTimeout = 0;
        this._uploadTimeout = 0;
        return this;
    }
    for(const option in options)if ($2d4db83817001e3c$require$hasOwn(options, option)) switch(option){
        case "deadline":
            this._timeout = options.deadline;
            break;
        case "response":
            this._responseTimeout = options.response;
            break;
        case "upload":
            this._uploadTimeout = options.upload;
            break;
        default:
            console.warn("Unknown timeout option", option);
    }
    return this;
};
/**
 * Set number of retry attempts on error.
 *
 * Failed requests will be retried 'count' times if timeout or err.code >= 500.
 *
 * @param {Number} count
 * @param {Function} [fn]
 * @return {Request} for chaining
 * @api public
 */ $2d4db83817001e3c$var$RequestBase.prototype.retry = function(count, fn) {
    // Default to 1 if no count passed or true
    if (arguments.length === 0 || count === true) count = 1;
    if (count <= 0) count = 0;
    this._maxRetries = count;
    this._retries = 0;
    this._retryCallback = fn;
    return this;
};
//
// NOTE: we do not include ESOCKETTIMEDOUT because that is from `request` package
//       <https://github.com/sindresorhus/got/pull/537>
//
// NOTE: we do not include EADDRINFO because it was removed from libuv in 2014
//       <https://github.com/libuv/libuv/commit/02e1ebd40b807be5af46343ea873331b2ee4e9c1>
//       <https://github.com/request/request/search?q=ESOCKETTIMEDOUT&unscoped_q=ESOCKETTIMEDOUT>
//
//
// TODO: expose these as configurable defaults
//
const $2d4db83817001e3c$var$ERROR_CODES = new Set([
    "ETIMEDOUT",
    "ECONNRESET",
    "EADDRINUSE",
    "ECONNREFUSED",
    "EPIPE",
    "ENOTFOUND",
    "ENETUNREACH",
    "EAI_AGAIN"
]);
const $2d4db83817001e3c$var$STATUS_CODES = new Set([
    408,
    413,
    429,
    500,
    502,
    503,
    504,
    521,
    522,
    524
]);
// TODO: we would need to make this easily configurable before adding it in (e.g. some might want to add POST)
// const METHODS = new Set(['GET', 'PUT', 'HEAD', 'DELETE', 'OPTIONS', 'TRACE']);
/**
 * Determine if a request should be retried.
 * (Inspired by https://github.com/sindresorhus/got#retry)
 *
 * @param {Error} err an error
 * @param {Response} [res] response
 * @returns {Boolean} if segment should be retried
 */ $2d4db83817001e3c$var$RequestBase.prototype._shouldRetry = function(error, res) {
    if (!this._maxRetries || this._retries++ >= this._maxRetries) return false;
    if (this._retryCallback) try {
        const override = this._retryCallback(error, res);
        if (override === true) return true;
        if (override === false) return false;
    // undefined falls back to defaults
    } catch (err) {
        console.error(err);
    }
    // TODO: we would need to make this easily configurable before adding it in (e.g. some might want to add POST)
    /*
  if (
    this.req &&
    this.req.method &&
    !METHODS.has(this.req.method.toUpperCase())
  )
    return false;
  */ if (res && res.status && $2d4db83817001e3c$var$STATUS_CODES.has(res.status)) return true;
    if (error) {
        if (error.code && $2d4db83817001e3c$var$ERROR_CODES.has(error.code)) return true;
        // Superagent timeout
        if (error.timeout && error.code === "ECONNABORTED") return true;
        if (error.crossDomain) return true;
    }
    return false;
};
/**
 * Retry request
 *
 * @return {Request} for chaining
 * @api private
 */ $2d4db83817001e3c$var$RequestBase.prototype._retry = function() {
    this.clearTimeout();
    // node
    if (this.req) {
        this.req = null;
        this.req = this.request();
    }
    this._aborted = false;
    this.timedout = false;
    this.timedoutError = null;
    return this._end();
};
/**
 * Promise support
 *
 * @param {Function} resolve
 * @param {Function} [reject]
 * @return {Request}
 */ $2d4db83817001e3c$var$RequestBase.prototype.then = function(resolve, reject) {
    if (!this._fullfilledPromise) {
        const self = this;
        if (this._endCalled) console.warn("Warning: superagent request was sent twice, because both .end() and .then() were called. Never call .end() if you use promises");
        this._fullfilledPromise = new Promise((resolve, reject)=>{
            self.on("abort", ()=>{
                if (this._maxRetries && this._maxRetries > this._retries) return;
                if (this.timedout && this.timedoutError) {
                    reject(this.timedoutError);
                    return;
                }
                const error = new Error("Aborted");
                error.code = "ABORTED";
                error.status = this.status;
                error.method = this.method;
                error.url = this.url;
                reject(error);
            });
            self.end((error, res)=>{
                if (error) reject(error);
                else resolve(res);
            });
        });
    }
    return this._fullfilledPromise.then(resolve, reject);
};
$2d4db83817001e3c$var$RequestBase.prototype.catch = function(callback) {
    return this.then(undefined, callback);
};
/**
 * Allow for extension
 */ $2d4db83817001e3c$var$RequestBase.prototype.use = function(fn) {
    fn(this);
    return this;
};
$2d4db83817001e3c$var$RequestBase.prototype.ok = function(callback) {
    if (typeof callback !== "function") throw new Error("Callback required");
    this._okCallback = callback;
    return this;
};
$2d4db83817001e3c$var$RequestBase.prototype._isResponseOK = function(res) {
    if (!res) return false;
    if (this._okCallback) return this._okCallback(res);
    return res.status >= 200 && res.status < 300;
};
/**
 * Get request header `field`.
 * Case-insensitive.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */ $2d4db83817001e3c$var$RequestBase.prototype.get = function(field) {
    return this._header[field.toLowerCase()];
};
/**
 * Get case-insensitive header `field` value.
 * This is a deprecated internal API. Use `.get(field)` instead.
 *
 * (getHeader is no longer used internally by the superagent code base)
 *
 * @param {String} field
 * @return {String}
 * @api private
 * @deprecated
 */ $2d4db83817001e3c$var$RequestBase.prototype.getHeader = $2d4db83817001e3c$var$RequestBase.prototype.get;
/**
 * Set header `field` to `val`, or multiple fields with one object.
 * Case-insensitive.
 *
 * Examples:
 *
 *      req.get('/')
 *        .set('Accept', 'application/json')
 *        .set('X-API-Key', 'foobar')
 *        .end(callback);
 *
 *      req.get('/')
 *        .set({ Accept: 'application/json', 'X-API-Key': 'foobar' })
 *        .end(callback);
 *
 * @param {String|Object} field
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */ $2d4db83817001e3c$var$RequestBase.prototype.set = function(field, value) {
    if ($2d4db83817001e3c$require$isObject(field)) {
        for(const key in field)if ($2d4db83817001e3c$require$hasOwn(field, key)) this.set(key, field[key]);
        return this;
    }
    this._header[field.toLowerCase()] = value;
    this.header[field] = value;
    return this;
};
/**
 * Remove header `field`.
 * Case-insensitive.
 *
 * Example:
 *
 *      req.get('/')
 *        .unset('User-Agent')
 *        .end(callback);
 *
 * @param {String} field field name
 */ $2d4db83817001e3c$var$RequestBase.prototype.unset = function(field) {
    delete this._header[field.toLowerCase()];
    delete this.header[field];
    return this;
};
/**
 * Write the field `name` and `val`, or multiple fields with one object
 * for "multipart/form-data" request bodies.
 *
 * ``` js
 * request.post('/upload')
 *   .field('foo', 'bar')
 *   .end(callback);
 *
 * request.post('/upload')
 *   .field({ foo: 'bar', baz: 'qux' })
 *   .end(callback);
 * ```
 *
 * @param {String|Object} name name of field
 * @param {String|Blob|File|Buffer|fs.ReadStream} val value of field
 * @param {String} options extra options, e.g. 'blob'
 * @return {Request} for chaining
 * @api public
 */ $2d4db83817001e3c$var$RequestBase.prototype.field = function(name, value, options) {
    // name should be either a string or an object.
    if (name === null || undefined === name) throw new Error(".field(name, val) name can not be empty");
    if (this._data) throw new Error(".field() can't be used if .send() is used. Please use only .send() or only .field() & .attach()");
    if ($2d4db83817001e3c$require$isObject(name)) {
        for(const key in name)if ($2d4db83817001e3c$require$hasOwn(name, key)) this.field(key, name[key]);
        return this;
    }
    if (Array.isArray(value)) {
        for(const i in value)if ($2d4db83817001e3c$require$hasOwn(value, i)) this.field(name, value[i]);
        return this;
    }
    // val should be defined now
    if (value === null || undefined === value) throw new Error(".field(name, val) val can not be empty");
    if (typeof value === "boolean") value = String(value);
    // fix https://github.com/ladjs/superagent/issues/1680
    if (options) this._getFormData().append(name, value, options);
    else this._getFormData().append(name, value);
    return this;
};
/**
 * Abort the request, and clear potential timeout.
 *
 * @return {Request} request
 * @api public
 */ $2d4db83817001e3c$var$RequestBase.prototype.abort = function() {
    if (this._aborted) return this;
    this._aborted = true;
    if (this.xhr) this.xhr.abort(); // browser
    if (this.req) {
        // Node v13 has major differences in `abort()`
        // https://github.com/nodejs/node/blob/v12.x/lib/internal/streams/end-of-stream.js
        // https://github.com/nodejs/node/blob/v13.x/lib/internal/streams/end-of-stream.js
        // https://github.com/nodejs/node/blob/v14.x/lib/internal/streams/end-of-stream.js
        // (if you run a diff across these you will see the differences)
        //
        // References:
        // <https://github.com/nodejs/node/issues/31630>
        // <https://github.com/ladjs/superagent/pull/1084/commits/dc18679a7c5ccfc6046d882015e5126888973bc8>
        //
        // Thanks to @shadowgate15 and @niftylettuce
        if ($k6jEX.gte($fs15M.version, "v13.0.0") && $k6jEX.lt($fs15M.version, "v14.0.0")) // Note that the reason this doesn't work is because in v13 as compared to v14
        // there is no `callback = nop` set in end-of-stream.js above
        throw new Error("Superagent does not work in v13 properly with abort() due to Node.js core changes");
        this.req.abort(); // node
    }
    this.clearTimeout();
    this.emit("abort");
    return this;
};
$2d4db83817001e3c$var$RequestBase.prototype._auth = function(user, pass, options, base64Encoder) {
    switch(options.type){
        case "basic":
            this.set("Authorization", `Basic ${base64Encoder(`${user}:${pass}`)}`);
            break;
        case "auto":
            this.username = user;
            this.password = pass;
            break;
        case "bearer":
            // usage would be .auth(accessToken, { type: 'bearer' })
            this.set("Authorization", `Bearer ${user}`);
            break;
        default:
            break;
    }
    return this;
};
/**
 * Enable transmission of cookies with x-domain requests.
 *
 * Note that for this to work the origin must not be
 * using "Access-Control-Allow-Origin" with a wildcard,
 * and also must set "Access-Control-Allow-Credentials"
 * to "true".
 * @param {Boolean} [on=true] - Set 'withCredentials' state
 * @return {Request} for chaining
 * @api public
 */ $2d4db83817001e3c$var$RequestBase.prototype.withCredentials = function(on) {
    // This is browser-only functionality. Node side is no-op.
    if (on === undefined) on = true;
    this._withCredentials = on;
    return this;
};
/**
 * Set the max redirects to `n`. Does nothing in browser XHR implementation.
 *
 * @param {Number} n
 * @return {Request} for chaining
 * @api public
 */ $2d4db83817001e3c$var$RequestBase.prototype.redirects = function(n) {
    this._maxRedirects = n;
    return this;
};
/**
 * Maximum size of buffered response body, in bytes. Counts uncompressed size.
 * Default 200MB.
 *
 * @param {Number} n number of bytes
 * @return {Request} for chaining
 */ $2d4db83817001e3c$var$RequestBase.prototype.maxResponseSize = function(n) {
    if (typeof n !== "number") throw new TypeError("Invalid argument");
    this._maxResponseSize = n;
    return this;
};
/**
 * Convert to a plain javascript object (not JSON string) of scalar properties.
 * Note as this method is designed to return a useful non-this value,
 * it cannot be chained.
 *
 * @return {Object} describing method, url, and data of this request
 * @api public
 */ $2d4db83817001e3c$var$RequestBase.prototype.toJSON = function() {
    return {
        method: this.method,
        url: this.url,
        data: this._data,
        headers: this._header
    };
};
/**
 * Send `data` as the request body, defaulting the `.type()` to "json" when
 * an object is given.
 *
 * Examples:
 *
 *       // manual json
 *       request.post('/user')
 *         .type('json')
 *         .send('{"name":"tj"}')
 *         .end(callback)
 *
 *       // auto json
 *       request.post('/user')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // manual x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send('name=tj')
 *         .end(callback)
 *
 *       // auto x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // defaults to x-www-form-urlencoded
 *      request.post('/user')
 *        .send('name=tobi')
 *        .send('species=ferret')
 *        .end(callback)
 *
 * @param {String|Object} data
 * @return {Request} for chaining
 * @api public
 */ // eslint-disable-next-line complexity
$2d4db83817001e3c$var$RequestBase.prototype.send = function(data) {
    const isObject_ = $2d4db83817001e3c$require$isObject(data);
    let type = this._header["content-type"];
    if (this._formData) throw new Error(".send() can't be used if .attach() or .field() is used. Please use only .send() or only .field() & .attach()");
    if (isObject_ && !this._data) {
        if (Array.isArray(data)) this._data = [];
        else if (!this._isHost(data)) this._data = {};
    } else if (data && this._data && this._isHost(this._data)) throw new Error("Can't merge these send calls");
    // merge
    if (isObject_ && $2d4db83817001e3c$require$isObject(this._data)) for(const key in data){
        if (typeof data[key] == "bigint" && !data[key].toJSON) throw new Error("Cannot serialize BigInt value to json");
        if ($2d4db83817001e3c$require$hasOwn(data, key)) this._data[key] = data[key];
    }
    else if (typeof data === "bigint") throw new Error("Cannot send value of type BigInt");
    else if (typeof data === "string") {
        // default to x-www-form-urlencoded
        if (!type) this.type("form");
        type = this._header["content-type"];
        if (type) type = type.toLowerCase().trim();
        if (type === "application/x-www-form-urlencoded") this._data = this._data ? `${this._data}&${data}` : data;
        else this._data = (this._data || "") + data;
    } else this._data = data;
    if (!isObject_ || this._isHost(data)) return this;
    // default to json
    if (!type) this.type("json");
    return this;
};
/**
 * Sort `querystring` by the sort function
 *
 *
 * Examples:
 *
 *       // default order
 *       request.get('/user')
 *         .query('name=Nick')
 *         .query('search=Manny')
 *         .sortQuery()
 *         .end(callback)
 *
 *       // customized sort function
 *       request.get('/user')
 *         .query('name=Nick')
 *         .query('search=Manny')
 *         .sortQuery(function(a, b){
 *           return a.length - b.length;
 *         })
 *         .end(callback)
 *
 *
 * @param {Function} sort
 * @return {Request} for chaining
 * @api public
 */ $2d4db83817001e3c$var$RequestBase.prototype.sortQuery = function(sort) {
    // _sort default to true but otherwise can be a function or boolean
    this._sort = typeof sort === "undefined" ? true : sort;
    return this;
};
/**
 * Compose querystring to append to req.url
 *
 * @api private
 */ $2d4db83817001e3c$var$RequestBase.prototype._finalizeQueryString = function() {
    const query = this._query.join("&");
    if (query) this.url += (this.url.includes("?") ? "&" : "?") + query;
    this._query.length = 0; // Makes the call idempotent
    if (this._sort) {
        const index = this.url.indexOf("?");
        if (index >= 0) {
            const queryArray = this.url.slice(index + 1).split("&");
            if (typeof this._sort === "function") queryArray.sort(this._sort);
            else queryArray.sort();
            this.url = this.url.slice(0, index) + "?" + queryArray.join("&");
        }
    }
};
// For backwards compat only
$2d4db83817001e3c$var$RequestBase.prototype._appendQueryString = ()=>{
    console.warn("Unsupported");
};
/**
 * Invoke callback with timeout error.
 *
 * @api private
 */ $2d4db83817001e3c$var$RequestBase.prototype._timeoutError = function(reason, timeout, errno) {
    if (this._aborted) return;
    const error = new Error(`${reason + timeout}ms exceeded`);
    error.timeout = timeout;
    error.code = "ECONNABORTED";
    error.errno = errno;
    this.timedout = true;
    this.timedoutError = error;
    this.abort();
    this.callback(error);
};
$2d4db83817001e3c$var$RequestBase.prototype._setTimeouts = function() {
    const self = this;
    // deadline
    if (this._timeout && !this._timer) this._timer = setTimeout(()=>{
        self._timeoutError("Timeout of ", self._timeout, "ETIME");
    }, this._timeout);
    // response timeout
    if (this._responseTimeout && !this._responseTimeoutTimer) this._responseTimeoutTimer = setTimeout(()=>{
        self._timeoutError("Response timeout of ", self._responseTimeout, "ETIMEDOUT");
    }, this._responseTimeout);
};

});
parcelRegister("fs15M", function(module, exports) {
// shim for using process in browser
var $b3fa5174df769f00$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $b3fa5174df769f00$var$cachedSetTimeout;
var $b3fa5174df769f00$var$cachedClearTimeout;
function $b3fa5174df769f00$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $b3fa5174df769f00$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $b3fa5174df769f00$var$cachedSetTimeout = setTimeout;
        else $b3fa5174df769f00$var$cachedSetTimeout = $b3fa5174df769f00$var$defaultSetTimout;
    } catch (e) {
        $b3fa5174df769f00$var$cachedSetTimeout = $b3fa5174df769f00$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $b3fa5174df769f00$var$cachedClearTimeout = clearTimeout;
        else $b3fa5174df769f00$var$cachedClearTimeout = $b3fa5174df769f00$var$defaultClearTimeout;
    } catch (e) {
        $b3fa5174df769f00$var$cachedClearTimeout = $b3fa5174df769f00$var$defaultClearTimeout;
    }
})();
function $b3fa5174df769f00$var$runTimeout(fun) {
    if ($b3fa5174df769f00$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($b3fa5174df769f00$var$cachedSetTimeout === $b3fa5174df769f00$var$defaultSetTimout || !$b3fa5174df769f00$var$cachedSetTimeout) && setTimeout) {
        $b3fa5174df769f00$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $b3fa5174df769f00$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $b3fa5174df769f00$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $b3fa5174df769f00$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $b3fa5174df769f00$var$runClearTimeout(marker) {
    if ($b3fa5174df769f00$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($b3fa5174df769f00$var$cachedClearTimeout === $b3fa5174df769f00$var$defaultClearTimeout || !$b3fa5174df769f00$var$cachedClearTimeout) && clearTimeout) {
        $b3fa5174df769f00$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $b3fa5174df769f00$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $b3fa5174df769f00$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $b3fa5174df769f00$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $b3fa5174df769f00$var$queue = [];
var $b3fa5174df769f00$var$draining = false;
var $b3fa5174df769f00$var$currentQueue;
var $b3fa5174df769f00$var$queueIndex = -1;
function $b3fa5174df769f00$var$cleanUpNextTick() {
    if (!$b3fa5174df769f00$var$draining || !$b3fa5174df769f00$var$currentQueue) return;
    $b3fa5174df769f00$var$draining = false;
    if ($b3fa5174df769f00$var$currentQueue.length) $b3fa5174df769f00$var$queue = $b3fa5174df769f00$var$currentQueue.concat($b3fa5174df769f00$var$queue);
    else $b3fa5174df769f00$var$queueIndex = -1;
    if ($b3fa5174df769f00$var$queue.length) $b3fa5174df769f00$var$drainQueue();
}
function $b3fa5174df769f00$var$drainQueue() {
    if ($b3fa5174df769f00$var$draining) return;
    var timeout = $b3fa5174df769f00$var$runTimeout($b3fa5174df769f00$var$cleanUpNextTick);
    $b3fa5174df769f00$var$draining = true;
    var len = $b3fa5174df769f00$var$queue.length;
    while(len){
        $b3fa5174df769f00$var$currentQueue = $b3fa5174df769f00$var$queue;
        $b3fa5174df769f00$var$queue = [];
        while(++$b3fa5174df769f00$var$queueIndex < len)if ($b3fa5174df769f00$var$currentQueue) $b3fa5174df769f00$var$currentQueue[$b3fa5174df769f00$var$queueIndex].run();
        $b3fa5174df769f00$var$queueIndex = -1;
        len = $b3fa5174df769f00$var$queue.length;
    }
    $b3fa5174df769f00$var$currentQueue = null;
    $b3fa5174df769f00$var$draining = false;
    $b3fa5174df769f00$var$runClearTimeout(timeout);
}
$b3fa5174df769f00$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $b3fa5174df769f00$var$queue.push(new $b3fa5174df769f00$var$Item(fun, args));
    if ($b3fa5174df769f00$var$queue.length === 1 && !$b3fa5174df769f00$var$draining) $b3fa5174df769f00$var$runTimeout($b3fa5174df769f00$var$drainQueue);
};
// v8 likes predictible objects
function $b3fa5174df769f00$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$b3fa5174df769f00$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$b3fa5174df769f00$var$process.title = "browser";
$b3fa5174df769f00$var$process.browser = true;
$b3fa5174df769f00$var$process.env = {};
$b3fa5174df769f00$var$process.argv = [];
$b3fa5174df769f00$var$process.version = ""; // empty string to avoid regexp issues
$b3fa5174df769f00$var$process.versions = {};
function $b3fa5174df769f00$var$noop() {}
$b3fa5174df769f00$var$process.on = $b3fa5174df769f00$var$noop;
$b3fa5174df769f00$var$process.addListener = $b3fa5174df769f00$var$noop;
$b3fa5174df769f00$var$process.once = $b3fa5174df769f00$var$noop;
$b3fa5174df769f00$var$process.off = $b3fa5174df769f00$var$noop;
$b3fa5174df769f00$var$process.removeListener = $b3fa5174df769f00$var$noop;
$b3fa5174df769f00$var$process.removeAllListeners = $b3fa5174df769f00$var$noop;
$b3fa5174df769f00$var$process.emit = $b3fa5174df769f00$var$noop;
$b3fa5174df769f00$var$process.prependListener = $b3fa5174df769f00$var$noop;
$b3fa5174df769f00$var$process.prependOnceListener = $b3fa5174df769f00$var$noop;
$b3fa5174df769f00$var$process.listeners = function(name) {
    return [];
};
$b3fa5174df769f00$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$b3fa5174df769f00$var$process.cwd = function() {
    return "/";
};
$b3fa5174df769f00$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$b3fa5174df769f00$var$process.umask = function() {
    return 0;
};

});

parcelRegister("8GwVl", function(module, exports) {

$parcel$export(module.exports, "type", function () { return $652bc8f851300b98$export$bf9fb029d174d554; }, function (v) { return $652bc8f851300b98$export$bf9fb029d174d554 = v; });
$parcel$export(module.exports, "params", function () { return $652bc8f851300b98$export$281ad3752a540efe; }, function (v) { return $652bc8f851300b98$export$281ad3752a540efe = v; });
$parcel$export(module.exports, "parseLinks", function () { return $652bc8f851300b98$export$255722312ba7ba74; }, function (v) { return $652bc8f851300b98$export$255722312ba7ba74 = v; });
$parcel$export(module.exports, "isObject", function () { return $652bc8f851300b98$export$a6cdc56e425d0d0a; }, function (v) { return $652bc8f851300b98$export$a6cdc56e425d0d0a = v; });
$parcel$export(module.exports, "hasOwn", function () { return $652bc8f851300b98$export$b5a638e9b3fff9f3; }, function (v) { return $652bc8f851300b98$export$b5a638e9b3fff9f3 = v; });
$parcel$export(module.exports, "mixin", function () { return $652bc8f851300b98$export$e36fc9d62a853069; }, function (v) { return $652bc8f851300b98$export$e36fc9d62a853069 = v; });
/**
 * Return the mime type for the given `str`.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */ var $652bc8f851300b98$export$bf9fb029d174d554;
/**
 * Return header field parameters.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */ var $652bc8f851300b98$export$281ad3752a540efe;
/**
 * Parse Link header fields.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */ var $652bc8f851300b98$export$255722312ba7ba74;
/**
 * Strip content related fields from `header`.
 *
 * @param {Object} header
 * @return {Object} header
 * @api private
 */ var $652bc8f851300b98$export$bbc652556e2dc9ed;
/**
 * Check if `obj` is an object.
 *
 * @param {Object} object
 * @return {Boolean}
 * @api private
 */ var $652bc8f851300b98$export$a6cdc56e425d0d0a;
/**
 * Object.hasOwn fallback/polyfill.
 *
 * @type {(object: object, property: string) => boolean} object
 * @api private
 */ var $652bc8f851300b98$export$b5a638e9b3fff9f3;
var $652bc8f851300b98$export$e36fc9d62a853069;
"use strict";
$652bc8f851300b98$export$bf9fb029d174d554 = (string_)=>string_.split(/ *; */).shift();
$652bc8f851300b98$export$281ad3752a540efe = (value)=>{
    const object = {};
    for (const string_ of value.split(/ *; */)){
        const parts = string_.split(/ *= */);
        const key = parts.shift();
        const value = parts.shift();
        if (key && value) object[key] = value;
    }
    return object;
};
$652bc8f851300b98$export$255722312ba7ba74 = (value)=>{
    const object = {};
    for (const string_ of value.split(/ *, */)){
        const parts = string_.split(/ *; */);
        const url = parts[0].slice(1, -1);
        const rel = parts[1].split(/ *= */)[1].slice(1, -1);
        object[rel] = url;
    }
    return object;
};
$652bc8f851300b98$export$bbc652556e2dc9ed = (header, changesOrigin)=>{
    delete header["content-type"];
    delete header["content-length"];
    delete header["transfer-encoding"];
    delete header.host;
    // secuirty
    if (changesOrigin) {
        delete header.authorization;
        delete header.cookie;
    }
    return header;
};
$652bc8f851300b98$export$a6cdc56e425d0d0a = (object)=>{
    return object !== null && typeof object === "object";
};
$652bc8f851300b98$export$b5a638e9b3fff9f3 = Object.hasOwn || function(object, property) {
    if (object == null) throw new TypeError("Cannot convert undefined or null to object");
    return Object.prototype.hasOwnProperty.call(new Object(object), property);
};
$652bc8f851300b98$export$e36fc9d62a853069 = (target, source)=>{
    for(const key in source)if ($652bc8f851300b98$export$b5a638e9b3fff9f3(source, key)) target[key] = source[key];
};

});


parcelRegister("l4TXj", function(module, exports) {
"use strict";

var $8GwVl = parcelRequire("8GwVl");
/**
 * Expose `ResponseBase`.
 */ module.exports = $f5856050856624b0$var$ResponseBase;
/**
 * Initialize a new `ResponseBase`.
 *
 * @api public
 */ function $f5856050856624b0$var$ResponseBase() {}
/**
 * Get case-insensitive `field` value.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */ $f5856050856624b0$var$ResponseBase.prototype.get = function(field) {
    return this.header[field.toLowerCase()];
};
/**
 * Set header related properties:
 *
 *   - `.type` the content type without params
 *
 * A response of "Content-Type: text/plain; charset=utf-8"
 * will provide you with a `.type` of "text/plain".
 *
 * @param {Object} header
 * @api private
 */ $f5856050856624b0$var$ResponseBase.prototype._setHeaderProperties = function(header) {
    // TODO: moar!
    // TODO: make this a util
    // content-type
    const ct = header["content-type"] || "";
    this.type = $8GwVl.type(ct);
    // params
    const parameters = $8GwVl.params(ct);
    for(const key in parameters)if (Object.prototype.hasOwnProperty.call(parameters, key)) this[key] = parameters[key];
    this.links = {};
    // links
    try {
        if (header.link) this.links = $8GwVl.parseLinks(header.link);
    } catch (err) {
    // ignore
    }
};
/**
 * Set flags such as `.ok` based on `status`.
 *
 * For example a 2xx response will give you a `.ok` of __true__
 * whereas 5xx will be __false__ and `.error` will be __true__. The
 * `.clientError` and `.serverError` are also available to be more
 * specific, and `.statusType` is the class of error ranging from 1..5
 * sometimes useful for mapping respond colors etc.
 *
 * "sugar" properties are also defined for common cases. Currently providing:
 *
 *   - .noContent
 *   - .badRequest
 *   - .unauthorized
 *   - .notAcceptable
 *   - .notFound
 *
 * @param {Number} status
 * @api private
 */ $f5856050856624b0$var$ResponseBase.prototype._setStatusProperties = function(status) {
    const type = Math.trunc(status / 100);
    // status / class
    this.statusCode = status;
    this.status = this.statusCode;
    this.statusType = type;
    // basics
    this.info = type === 1;
    this.ok = type === 2;
    this.redirect = type === 3;
    this.clientError = type === 4;
    this.serverError = type === 5;
    this.error = type === 4 || type === 5 ? this.toError() : false;
    // sugar
    this.created = status === 201;
    this.accepted = status === 202;
    this.noContent = status === 204;
    this.badRequest = status === 400;
    this.unauthorized = status === 401;
    this.notAcceptable = status === 406;
    this.forbidden = status === 403;
    this.notFound = status === 404;
    this.unprocessableEntity = status === 422;
};

});

parcelRegister("6kTtl", function(module, exports) {
"use strict";
const $49cfa3fc86178a15$var$defaults = [
    "use",
    "on",
    "once",
    "set",
    "query",
    "type",
    "accept",
    "auth",
    "withCredentials",
    "sortQuery",
    "retry",
    "ok",
    "redirects",
    "timeout",
    "buffer",
    "serialize",
    "parse",
    "ca",
    "key",
    "pfx",
    "cert",
    "disableTLSCerts"
];
class $49cfa3fc86178a15$var$Agent {
    constructor(){
        this._defaults = [];
    }
    _setDefaults(request) {
        for (const def of this._defaults)request[def.fn](...def.args);
    }
}
for (const fn of $49cfa3fc86178a15$var$defaults)// Default setting for all requests from this agent
$49cfa3fc86178a15$var$Agent.prototype[fn] = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    this._defaults.push({
        fn: fn,
        args: args
    });
    return this;
};
module.exports = $49cfa3fc86178a15$var$Agent;

});



parcelRegister("9V98A", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $73908671e510c08a$export$2e2bcd8739ae039; });

var $6vz4b = parcelRequire("6vz4b");

var $1h1Hw = parcelRequire("1h1Hw");
var $73908671e510c08a$export$2e2bcd8739ae039 = {
    data () {
        return {
            layers: [],
            activeLayers: []
        };
    },
    mounted () {
        // Vue component has been created
        this.fetchLayerConfig();
    },
    watch: {
        layers: function() {
            // Layers list has updated (Vue works async)
            window.liveMap._handleLayerList(this.layers);
        },
        activeLayers: function(newArr, oldArr) {
            let layerAdds = newArr.filter((x)=>!oldArr.includes(x));
            let layerDeletes = oldArr.filter((x)=>!newArr.includes(x));
            console.log(layerAdds, layerDeletes, newArr);
            for (let l of layerDeletes)if (l in window.liveMap.layerManagers) window.liveMap.layerManagers[l].detachLayer();
            for (let l of layerAdds)if (l in window.liveMap.layerManagers) window.liveMap.layerManagers[l].attachLayer();
            else console.error("No LayerManager found for: " + l);
             // Save layer options to localStorage
            // FIXME HACK FOR APP
            if (!($("body").hasClass("androidapp") && oldArr.length === 0) && window.localStorage) window.localStorage.setItem("weatherusa.weatherlive.layers", JSON.stringify(newArr));
        }
    },
    methods: {
        toggleLayerOption (e) {
            var dkey = $("#" + e + "_option").val(); // jq
            if (window.liveMap.layerManagers[e].dataOptions) window.liveMap.layerManagers[e].dataOptions.mVar = dkey;
            window.liveMap.layerManagers[e].refreshLayer();
        },
        toggleLayerElement (e) {
            var dkey = $("#" + e + "_option").val(); // jq
            console.log(e, dkey);
            if (window.liveMap.layerManagers[e]) window.liveMap.layerManagers[e].setElement(dkey);
        },
        fetchLayerConfig () {
            var _self = this;
            new (0, $6vz4b.default)({
                url: "https://www.weatherusa.net/api/v1/feed/map_layers",
                timeout: 15000,
                onSuccess: function(resp) {
                    // Array copy
                    window.liveMap._layerList = (0, (/*@__PURE__*/$parcel$interopDefault($1h1Hw)))(resp.body.layers);
                    _self.layers = resp.body.layers;
                }
            }).get();
        }
    }
};

});
parcelRegister("1h1Hw", function(module, exports) {

var $h0JdM = parcelRequire("h0JdM");
/** Used to compose bitmasks for cloning. */ var $0ed8b2bf1c9ee267$var$CLONE_DEEP_FLAG = 1, $0ed8b2bf1c9ee267$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $0ed8b2bf1c9ee267$var$cloneDeep(value) {
    return $h0JdM(value, $0ed8b2bf1c9ee267$var$CLONE_DEEP_FLAG | $0ed8b2bf1c9ee267$var$CLONE_SYMBOLS_FLAG);
}
module.exports = $0ed8b2bf1c9ee267$var$cloneDeep;

});
parcelRegister("h0JdM", function(module, exports) {

var $1Yx75 = parcelRequire("1Yx75");

var $g6eUt = parcelRequire("g6eUt");

var $6p70B = parcelRequire("6p70B");

var $8Z4br = parcelRequire("8Z4br");

var $btF6q = parcelRequire("btF6q");

var $b2okp = parcelRequire("b2okp");

var $o1vzS = parcelRequire("o1vzS");

var $euBeZ = parcelRequire("euBeZ");

var $3ZRRt = parcelRequire("3ZRRt");

var $ha33u = parcelRequire("ha33u");

var $hsVGU = parcelRequire("hsVGU");

var $eHMmp = parcelRequire("eHMmp");

var $9KzYg = parcelRequire("9KzYg");

var $kyqsf = parcelRequire("kyqsf");

var $6pFcL = parcelRequire("6pFcL");

var $jsvkI = parcelRequire("jsvkI");

var $h3dfZ = parcelRequire("h3dfZ");

var $j9Qqp = parcelRequire("j9Qqp");

var $eZjDd = parcelRequire("eZjDd");

var $fK2U3 = parcelRequire("fK2U3");

var $fzwCY = parcelRequire("fzwCY");

var $dp56J = parcelRequire("dp56J");
/** Used to compose bitmasks for cloning. */ var $c62583bee4e92fe9$var$CLONE_DEEP_FLAG = 1, $c62583bee4e92fe9$var$CLONE_FLAT_FLAG = 2, $c62583bee4e92fe9$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $c62583bee4e92fe9$var$argsTag = "[object Arguments]", $c62583bee4e92fe9$var$arrayTag = "[object Array]", $c62583bee4e92fe9$var$boolTag = "[object Boolean]", $c62583bee4e92fe9$var$dateTag = "[object Date]", $c62583bee4e92fe9$var$errorTag = "[object Error]", $c62583bee4e92fe9$var$funcTag = "[object Function]", $c62583bee4e92fe9$var$genTag = "[object GeneratorFunction]", $c62583bee4e92fe9$var$mapTag = "[object Map]", $c62583bee4e92fe9$var$numberTag = "[object Number]", $c62583bee4e92fe9$var$objectTag = "[object Object]", $c62583bee4e92fe9$var$regexpTag = "[object RegExp]", $c62583bee4e92fe9$var$setTag = "[object Set]", $c62583bee4e92fe9$var$stringTag = "[object String]", $c62583bee4e92fe9$var$symbolTag = "[object Symbol]", $c62583bee4e92fe9$var$weakMapTag = "[object WeakMap]";
var $c62583bee4e92fe9$var$arrayBufferTag = "[object ArrayBuffer]", $c62583bee4e92fe9$var$dataViewTag = "[object DataView]", $c62583bee4e92fe9$var$float32Tag = "[object Float32Array]", $c62583bee4e92fe9$var$float64Tag = "[object Float64Array]", $c62583bee4e92fe9$var$int8Tag = "[object Int8Array]", $c62583bee4e92fe9$var$int16Tag = "[object Int16Array]", $c62583bee4e92fe9$var$int32Tag = "[object Int32Array]", $c62583bee4e92fe9$var$uint8Tag = "[object Uint8Array]", $c62583bee4e92fe9$var$uint8ClampedTag = "[object Uint8ClampedArray]", $c62583bee4e92fe9$var$uint16Tag = "[object Uint16Array]", $c62583bee4e92fe9$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $c62583bee4e92fe9$var$cloneableTags = {};
$c62583bee4e92fe9$var$cloneableTags[$c62583bee4e92fe9$var$argsTag] = $c62583bee4e92fe9$var$cloneableTags[$c62583bee4e92fe9$var$arrayTag] = $c62583bee4e92fe9$var$cloneableTags[$c62583bee4e92fe9$var$arrayBufferTag] = $c62583bee4e92fe9$var$cloneableTags[$c62583bee4e92fe9$var$dataViewTag] = $c62583bee4e92fe9$var$cloneableTags[$c62583bee4e92fe9$var$boolTag] = $c62583bee4e92fe9$var$cloneableTags[$c62583bee4e92fe9$var$dateTag] = $c62583bee4e92fe9$var$cloneableTags[$c62583bee4e92fe9$var$float32Tag] = $c62583bee4e92fe9$var$cloneableTags[$c62583bee4e92fe9$var$float64Tag] = $c62583bee4e92fe9$var$cloneableTags[$c62583bee4e92fe9$var$int8Tag] = $c62583bee4e92fe9$var$cloneableTags[$c62583bee4e92fe9$var$int16Tag] = $c62583bee4e92fe9$var$cloneableTags[$c62583bee4e92fe9$var$int32Tag] = $c62583bee4e92fe9$var$cloneableTags[$c62583bee4e92fe9$var$mapTag] = $c62583bee4e92fe9$var$cloneableTags[$c62583bee4e92fe9$var$numberTag] = $c62583bee4e92fe9$var$cloneableTags[$c62583bee4e92fe9$var$objectTag] = $c62583bee4e92fe9$var$cloneableTags[$c62583bee4e92fe9$var$regexpTag] = $c62583bee4e92fe9$var$cloneableTags[$c62583bee4e92fe9$var$setTag] = $c62583bee4e92fe9$var$cloneableTags[$c62583bee4e92fe9$var$stringTag] = $c62583bee4e92fe9$var$cloneableTags[$c62583bee4e92fe9$var$symbolTag] = $c62583bee4e92fe9$var$cloneableTags[$c62583bee4e92fe9$var$uint8Tag] = $c62583bee4e92fe9$var$cloneableTags[$c62583bee4e92fe9$var$uint8ClampedTag] = $c62583bee4e92fe9$var$cloneableTags[$c62583bee4e92fe9$var$uint16Tag] = $c62583bee4e92fe9$var$cloneableTags[$c62583bee4e92fe9$var$uint32Tag] = true;
$c62583bee4e92fe9$var$cloneableTags[$c62583bee4e92fe9$var$errorTag] = $c62583bee4e92fe9$var$cloneableTags[$c62583bee4e92fe9$var$funcTag] = $c62583bee4e92fe9$var$cloneableTags[$c62583bee4e92fe9$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $c62583bee4e92fe9$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $c62583bee4e92fe9$var$CLONE_DEEP_FLAG, isFlat = bitmask & $c62583bee4e92fe9$var$CLONE_FLAT_FLAG, isFull = bitmask & $c62583bee4e92fe9$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!$eZjDd(value)) return value;
    var isArr = $jsvkI(value);
    if (isArr) {
        result = $9KzYg(value);
        if (!isDeep) return $o1vzS(value, result);
    } else {
        var tag = $eHMmp(value), isFunc = tag == $c62583bee4e92fe9$var$funcTag || tag == $c62583bee4e92fe9$var$genTag;
        if ($h3dfZ(value)) return $b2okp(value, isDeep);
        if (tag == $c62583bee4e92fe9$var$objectTag || tag == $c62583bee4e92fe9$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : $6pFcL(value);
            if (!isDeep) return isFlat ? $3ZRRt(value, $btF6q(result, value)) : $euBeZ(value, $8Z4br(result, value));
        } else {
            if (!$c62583bee4e92fe9$var$cloneableTags[tag]) return object ? value : {};
            result = $kyqsf(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new $1Yx75);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ($fK2U3(value)) value.forEach(function(subValue) {
        result.add($c62583bee4e92fe9$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ($j9Qqp(value)) value.forEach(function(subValue, key) {
        result.set(key, $c62583bee4e92fe9$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? $hsVGU : $ha33u : isFlat ? $dp56J : $fzwCY;
    var props = isArr ? undefined : keysFunc(value);
    $g6eUt(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        $6p70B(result, key, $c62583bee4e92fe9$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
module.exports = $c62583bee4e92fe9$var$baseClone;

});
parcelRegister("1Yx75", function(module, exports) {

var $42l9N = parcelRequire("42l9N");

var $jIxZr = parcelRequire("jIxZr");

var $e0hU3 = parcelRequire("e0hU3");

var $b5QLc = parcelRequire("b5QLc");

var $iywad = parcelRequire("iywad");

var $k2mBg = parcelRequire("k2mBg");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $170514a0df7e2496$var$Stack(entries) {
    var data = this.__data__ = new $42l9N(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$170514a0df7e2496$var$Stack.prototype.clear = $jIxZr;
$170514a0df7e2496$var$Stack.prototype["delete"] = $e0hU3;
$170514a0df7e2496$var$Stack.prototype.get = $b5QLc;
$170514a0df7e2496$var$Stack.prototype.has = $iywad;
$170514a0df7e2496$var$Stack.prototype.set = $k2mBg;
module.exports = $170514a0df7e2496$var$Stack;

});
parcelRegister("42l9N", function(module, exports) {

var $b8Z2z = parcelRequire("b8Z2z");

var $fTqyL = parcelRequire("fTqyL");

var $8Lrm8 = parcelRequire("8Lrm8");

var $48BzL = parcelRequire("48BzL");

var $j0knp = parcelRequire("j0knp");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $2f07c2a9396bd484$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$2f07c2a9396bd484$var$ListCache.prototype.clear = $b8Z2z;
$2f07c2a9396bd484$var$ListCache.prototype["delete"] = $fTqyL;
$2f07c2a9396bd484$var$ListCache.prototype.get = $8Lrm8;
$2f07c2a9396bd484$var$ListCache.prototype.has = $48BzL;
$2f07c2a9396bd484$var$ListCache.prototype.set = $j0knp;
module.exports = $2f07c2a9396bd484$var$ListCache;

});
parcelRegister("b8Z2z", function(module, exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $81cfca68c0463a54$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = $81cfca68c0463a54$var$listCacheClear;

});

parcelRegister("fTqyL", function(module, exports) {

var $34zTp = parcelRequire("34zTp");
/** Used for built-in method references. */ var $b9209841de2e608b$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $b9209841de2e608b$var$splice = $b9209841de2e608b$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $b9209841de2e608b$var$listCacheDelete(key) {
    var data = this.__data__, index = $34zTp(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $b9209841de2e608b$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = $b9209841de2e608b$var$listCacheDelete;

});
parcelRegister("34zTp", function(module, exports) {

var $lTxG5 = parcelRequire("lTxG5");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $23cd965e378f4513$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($lTxG5(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = $23cd965e378f4513$var$assocIndexOf;

});
parcelRegister("lTxG5", function(module, exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $ff08dbbb6b9cf534$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = $ff08dbbb6b9cf534$var$eq;

});



parcelRegister("8Lrm8", function(module, exports) {

var $34zTp = parcelRequire("34zTp");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $6617eed4d866b593$var$listCacheGet(key) {
    var data = this.__data__, index = $34zTp(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = $6617eed4d866b593$var$listCacheGet;

});

parcelRegister("48BzL", function(module, exports) {

var $34zTp = parcelRequire("34zTp");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $30350e93ce5fb277$var$listCacheHas(key) {
    return $34zTp(this.__data__, key) > -1;
}
module.exports = $30350e93ce5fb277$var$listCacheHas;

});

parcelRegister("j0knp", function(module, exports) {

var $34zTp = parcelRequire("34zTp");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $dd5dd2c34391cee2$var$listCacheSet(key, value) {
    var data = this.__data__, index = $34zTp(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = $dd5dd2c34391cee2$var$listCacheSet;

});


parcelRegister("jIxZr", function(module, exports) {

var $42l9N = parcelRequire("42l9N");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $e5ac7e17afad69d3$var$stackClear() {
    this.__data__ = new $42l9N;
    this.size = 0;
}
module.exports = $e5ac7e17afad69d3$var$stackClear;

});

parcelRegister("e0hU3", function(module, exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $a31ef3f0c9a6b3a0$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
module.exports = $a31ef3f0c9a6b3a0$var$stackDelete;

});

parcelRegister("b5QLc", function(module, exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $81391672ad198f27$var$stackGet(key) {
    return this.__data__.get(key);
}
module.exports = $81391672ad198f27$var$stackGet;

});

parcelRegister("iywad", function(module, exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $d8245a0b8f175570$var$stackHas(key) {
    return this.__data__.has(key);
}
module.exports = $d8245a0b8f175570$var$stackHas;

});

parcelRegister("k2mBg", function(module, exports) {

var $42l9N = parcelRequire("42l9N");

var $hfh24 = parcelRequire("hfh24");

var $1TGg0 = parcelRequire("1TGg0");
/** Used as the size to enable large array optimizations. */ var $e965866c8a7ecbe9$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $e965866c8a7ecbe9$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $42l9N) {
        var pairs = data.__data__;
        if (!$hfh24 || pairs.length < $e965866c8a7ecbe9$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $1TGg0(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = $e965866c8a7ecbe9$var$stackSet;

});
parcelRegister("hfh24", function(module, exports) {

var $eYreK = parcelRequire("eYreK");

var $kWy0a = parcelRequire("kWy0a");
/* Built-in method references that are verified to be native. */ var $c8e10caa994d0969$var$Map = $eYreK($kWy0a, "Map");
module.exports = $c8e10caa994d0969$var$Map;

});
parcelRegister("eYreK", function(module, exports) {

var $3vt6X = parcelRequire("3vt6X");

var $eyraa = parcelRequire("eyraa");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $ae6bcbf073ab58e5$var$getNative(object, key) {
    var value = $eyraa(object, key);
    return $3vt6X(value) ? value : undefined;
}
module.exports = $ae6bcbf073ab58e5$var$getNative;

});
parcelRegister("3vt6X", function(module, exports) {

var $cSztt = parcelRequire("cSztt");

var $jaq6B = parcelRequire("jaq6B");

var $eZjDd = parcelRequire("eZjDd");

var $fQae2 = parcelRequire("fQae2");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $28dad9361a37098b$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $28dad9361a37098b$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $28dad9361a37098b$var$funcProto = Function.prototype, $28dad9361a37098b$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $28dad9361a37098b$var$funcToString = $28dad9361a37098b$var$funcProto.toString;
/** Used to check objects for own properties. */ var $28dad9361a37098b$var$hasOwnProperty = $28dad9361a37098b$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $28dad9361a37098b$var$reIsNative = RegExp("^" + $28dad9361a37098b$var$funcToString.call($28dad9361a37098b$var$hasOwnProperty).replace($28dad9361a37098b$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $28dad9361a37098b$var$baseIsNative(value) {
    if (!$eZjDd(value) || $jaq6B(value)) return false;
    var pattern = $cSztt(value) ? $28dad9361a37098b$var$reIsNative : $28dad9361a37098b$var$reIsHostCtor;
    return pattern.test($fQae2(value));
}
module.exports = $28dad9361a37098b$var$baseIsNative;

});
parcelRegister("cSztt", function(module, exports) {

var $ch48J = parcelRequire("ch48J");

var $eZjDd = parcelRequire("eZjDd");
/** `Object#toString` result references. */ var $96060ba810b3113f$var$asyncTag = "[object AsyncFunction]", $96060ba810b3113f$var$funcTag = "[object Function]", $96060ba810b3113f$var$genTag = "[object GeneratorFunction]", $96060ba810b3113f$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $96060ba810b3113f$var$isFunction(value) {
    if (!$eZjDd(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $ch48J(value);
    return tag == $96060ba810b3113f$var$funcTag || tag == $96060ba810b3113f$var$genTag || tag == $96060ba810b3113f$var$asyncTag || tag == $96060ba810b3113f$var$proxyTag;
}
module.exports = $96060ba810b3113f$var$isFunction;

});
parcelRegister("ch48J", function(module, exports) {

var $bZ0Fd = parcelRequire("bZ0Fd");

var $7JLUm = parcelRequire("7JLUm");

var $1A4zQ = parcelRequire("1A4zQ");
/** `Object#toString` result references. */ var $8efa48ad386a554e$var$nullTag = "[object Null]", $8efa48ad386a554e$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $8efa48ad386a554e$var$symToStringTag = $bZ0Fd ? $bZ0Fd.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $8efa48ad386a554e$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $8efa48ad386a554e$var$undefinedTag : $8efa48ad386a554e$var$nullTag;
    return $8efa48ad386a554e$var$symToStringTag && $8efa48ad386a554e$var$symToStringTag in Object(value) ? $7JLUm(value) : $1A4zQ(value);
}
module.exports = $8efa48ad386a554e$var$baseGetTag;

});
parcelRegister("bZ0Fd", function(module, exports) {

var $kWy0a = parcelRequire("kWy0a");
/** Built-in value references. */ var $8b95e8000aed0d2e$var$Symbol = $kWy0a.Symbol;
module.exports = $8b95e8000aed0d2e$var$Symbol;

});
parcelRegister("kWy0a", function(module, exports) {

var $2piOc = parcelRequire("2piOc");
/** Detect free variable `self`. */ var $f3f3996f958d35ec$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $f3f3996f958d35ec$var$root = $2piOc || $f3f3996f958d35ec$var$freeSelf || Function("return this")();
module.exports = $f3f3996f958d35ec$var$root;

});
parcelRegister("2piOc", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $1c0c8198ec204b0c$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $1c0c8198ec204b0c$var$freeGlobal;

});



parcelRegister("7JLUm", function(module, exports) {

var $bZ0Fd = parcelRequire("bZ0Fd");
/** Used for built-in method references. */ var $5a21e5ec6fbbf4e4$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $5a21e5ec6fbbf4e4$var$hasOwnProperty = $5a21e5ec6fbbf4e4$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $5a21e5ec6fbbf4e4$var$nativeObjectToString = $5a21e5ec6fbbf4e4$var$objectProto.toString;
/** Built-in value references. */ var $5a21e5ec6fbbf4e4$var$symToStringTag = $bZ0Fd ? $bZ0Fd.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $5a21e5ec6fbbf4e4$var$getRawTag(value) {
    var isOwn = $5a21e5ec6fbbf4e4$var$hasOwnProperty.call(value, $5a21e5ec6fbbf4e4$var$symToStringTag), tag = value[$5a21e5ec6fbbf4e4$var$symToStringTag];
    try {
        value[$5a21e5ec6fbbf4e4$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $5a21e5ec6fbbf4e4$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$5a21e5ec6fbbf4e4$var$symToStringTag] = tag;
        else delete value[$5a21e5ec6fbbf4e4$var$symToStringTag];
    }
    return result;
}
module.exports = $5a21e5ec6fbbf4e4$var$getRawTag;

});

parcelRegister("1A4zQ", function(module, exports) {
/** Used for built-in method references. */ var $126cb42e0fecfdb5$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $126cb42e0fecfdb5$var$nativeObjectToString = $126cb42e0fecfdb5$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $126cb42e0fecfdb5$var$objectToString(value) {
    return $126cb42e0fecfdb5$var$nativeObjectToString.call(value);
}
module.exports = $126cb42e0fecfdb5$var$objectToString;

});


parcelRegister("eZjDd", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $ae95fd99bea76964$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
module.exports = $ae95fd99bea76964$var$isObject;

});


parcelRegister("jaq6B", function(module, exports) {

var $jO88h = parcelRequire("jO88h");
/** Used to detect methods masquerading as native. */ var $df433380b0922afe$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($jO88h && $jO88h.keys && $jO88h.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $df433380b0922afe$var$isMasked(func) {
    return !!$df433380b0922afe$var$maskSrcKey && $df433380b0922afe$var$maskSrcKey in func;
}
module.exports = $df433380b0922afe$var$isMasked;

});
parcelRegister("jO88h", function(module, exports) {

var $kWy0a = parcelRequire("kWy0a");
/** Used to detect overreaching core-js shims. */ var $e6b8fec39bbd16ae$var$coreJsData = $kWy0a["__core-js_shared__"];
module.exports = $e6b8fec39bbd16ae$var$coreJsData;

});


parcelRegister("fQae2", function(module, exports) {
/** Used for built-in method references. */ var $b883a4e522466c1e$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $b883a4e522466c1e$var$funcToString = $b883a4e522466c1e$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $b883a4e522466c1e$var$toSource(func) {
    if (func != null) {
        try {
            return $b883a4e522466c1e$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
module.exports = $b883a4e522466c1e$var$toSource;

});


parcelRegister("eyraa", function(module, exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $a9894fae1f653bfc$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = $a9894fae1f653bfc$var$getValue;

});



parcelRegister("1TGg0", function(module, exports) {

var $2ht7T = parcelRequire("2ht7T");

var $7fVAi = parcelRequire("7fVAi");

var $2rhlt = parcelRequire("2rhlt");

var $1mkbu = parcelRequire("1mkbu");

var $jo0nn = parcelRequire("jo0nn");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $161bb4dda17fc4d3$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$161bb4dda17fc4d3$var$MapCache.prototype.clear = $2ht7T;
$161bb4dda17fc4d3$var$MapCache.prototype["delete"] = $7fVAi;
$161bb4dda17fc4d3$var$MapCache.prototype.get = $2rhlt;
$161bb4dda17fc4d3$var$MapCache.prototype.has = $1mkbu;
$161bb4dda17fc4d3$var$MapCache.prototype.set = $jo0nn;
module.exports = $161bb4dda17fc4d3$var$MapCache;

});
parcelRegister("2ht7T", function(module, exports) {

var $gOpNW = parcelRequire("gOpNW");

var $42l9N = parcelRequire("42l9N");

var $hfh24 = parcelRequire("hfh24");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $1a93c32f5ad0125a$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new $gOpNW,
        "map": new ($hfh24 || $42l9N),
        "string": new $gOpNW
    };
}
module.exports = $1a93c32f5ad0125a$var$mapCacheClear;

});
parcelRegister("gOpNW", function(module, exports) {

var $eTF4J = parcelRequire("eTF4J");

var $9yWzt = parcelRequire("9yWzt");

var $vWN72 = parcelRequire("vWN72");

var $7agcw = parcelRequire("7agcw");

var $cjQie = parcelRequire("cjQie");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $c3d55511f790ce33$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$c3d55511f790ce33$var$Hash.prototype.clear = $eTF4J;
$c3d55511f790ce33$var$Hash.prototype["delete"] = $9yWzt;
$c3d55511f790ce33$var$Hash.prototype.get = $vWN72;
$c3d55511f790ce33$var$Hash.prototype.has = $7agcw;
$c3d55511f790ce33$var$Hash.prototype.set = $cjQie;
module.exports = $c3d55511f790ce33$var$Hash;

});
parcelRegister("eTF4J", function(module, exports) {

var $gfreF = parcelRequire("gfreF");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $ad861075aaef60b2$var$hashClear() {
    this.__data__ = $gfreF ? $gfreF(null) : {};
    this.size = 0;
}
module.exports = $ad861075aaef60b2$var$hashClear;

});
parcelRegister("gfreF", function(module, exports) {

var $eYreK = parcelRequire("eYreK");
/* Built-in method references that are verified to be native. */ var $bd432c7e9e61eaf4$var$nativeCreate = $eYreK(Object, "create");
module.exports = $bd432c7e9e61eaf4$var$nativeCreate;

});


parcelRegister("9yWzt", function(module, exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $6f64b90683b98f2f$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $6f64b90683b98f2f$var$hashDelete;

});

parcelRegister("vWN72", function(module, exports) {

var $gfreF = parcelRequire("gfreF");
/** Used to stand-in for `undefined` hash values. */ var $0600800f588d0ff4$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $0600800f588d0ff4$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0600800f588d0ff4$var$hasOwnProperty = $0600800f588d0ff4$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $0600800f588d0ff4$var$hashGet(key) {
    var data = this.__data__;
    if ($gfreF) {
        var result = data[key];
        return result === $0600800f588d0ff4$var$HASH_UNDEFINED ? undefined : result;
    }
    return $0600800f588d0ff4$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = $0600800f588d0ff4$var$hashGet;

});

parcelRegister("7agcw", function(module, exports) {

var $gfreF = parcelRequire("gfreF");
/** Used for built-in method references. */ var $537608c1f4bc9d37$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $537608c1f4bc9d37$var$hasOwnProperty = $537608c1f4bc9d37$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $537608c1f4bc9d37$var$hashHas(key) {
    var data = this.__data__;
    return $gfreF ? data[key] !== undefined : $537608c1f4bc9d37$var$hasOwnProperty.call(data, key);
}
module.exports = $537608c1f4bc9d37$var$hashHas;

});

parcelRegister("cjQie", function(module, exports) {

var $gfreF = parcelRequire("gfreF");
/** Used to stand-in for `undefined` hash values. */ var $8f7fd2ad497f8f18$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $8f7fd2ad497f8f18$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $gfreF && value === undefined ? $8f7fd2ad497f8f18$var$HASH_UNDEFINED : value;
    return this;
}
module.exports = $8f7fd2ad497f8f18$var$hashSet;

});



parcelRegister("7fVAi", function(module, exports) {

var $bbR3R = parcelRequire("bbR3R");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $54869a304fa725d9$var$mapCacheDelete(key) {
    var result = $bbR3R(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $54869a304fa725d9$var$mapCacheDelete;

});
parcelRegister("bbR3R", function(module, exports) {

var $1CYmP = parcelRequire("1CYmP");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $8259e1a8b86f3ba3$var$getMapData(map, key) {
    var data = map.__data__;
    return $1CYmP(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
module.exports = $8259e1a8b86f3ba3$var$getMapData;

});
parcelRegister("1CYmP", function(module, exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $12f82ab91f12ebef$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
module.exports = $12f82ab91f12ebef$var$isKeyable;

});



parcelRegister("2rhlt", function(module, exports) {

var $bbR3R = parcelRequire("bbR3R");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $1c6b8ecb915c4f7e$var$mapCacheGet(key) {
    return $bbR3R(this, key).get(key);
}
module.exports = $1c6b8ecb915c4f7e$var$mapCacheGet;

});

parcelRegister("1mkbu", function(module, exports) {

var $bbR3R = parcelRequire("bbR3R");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $0fd780b95b1215e7$var$mapCacheHas(key) {
    return $bbR3R(this, key).has(key);
}
module.exports = $0fd780b95b1215e7$var$mapCacheHas;

});

parcelRegister("jo0nn", function(module, exports) {

var $bbR3R = parcelRequire("bbR3R");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $e1d08ce358c52953$var$mapCacheSet(key, value) {
    var data = $bbR3R(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = $e1d08ce358c52953$var$mapCacheSet;

});




parcelRegister("g6eUt", function(module, exports) {
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $bb88c5aec02031da$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
module.exports = $bb88c5aec02031da$var$arrayEach;

});

parcelRegister("6p70B", function(module, exports) {

var $iGecC = parcelRequire("iGecC");

var $lTxG5 = parcelRequire("lTxG5");
/** Used for built-in method references. */ var $4a9a83aad63fbb8a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $4a9a83aad63fbb8a$var$hasOwnProperty = $4a9a83aad63fbb8a$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $4a9a83aad63fbb8a$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($4a9a83aad63fbb8a$var$hasOwnProperty.call(object, key) && $lTxG5(objValue, value)) || value === undefined && !(key in object)) $iGecC(object, key, value);
}
module.exports = $4a9a83aad63fbb8a$var$assignValue;

});
parcelRegister("iGecC", function(module, exports) {

var $a4YUs = parcelRequire("a4YUs");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $d9972a91a3e83199$var$baseAssignValue(object, key, value) {
    if (key == "__proto__" && $a4YUs) $a4YUs(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
module.exports = $d9972a91a3e83199$var$baseAssignValue;

});
parcelRegister("a4YUs", function(module, exports) {

var $eYreK = parcelRequire("eYreK");
var $7569867e54c0da69$var$defineProperty = function() {
    try {
        var func = $eYreK(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
module.exports = $7569867e54c0da69$var$defineProperty;

});



parcelRegister("8Z4br", function(module, exports) {

var $cIFys = parcelRequire("cIFys");

var $fzwCY = parcelRequire("fzwCY");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $68a744010facbe6d$var$baseAssign(object, source) {
    return object && $cIFys(source, $fzwCY(source), object);
}
module.exports = $68a744010facbe6d$var$baseAssign;

});
parcelRegister("cIFys", function(module, exports) {

var $6p70B = parcelRequire("6p70B");

var $iGecC = parcelRequire("iGecC");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $9429d4054ecefbda$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) $iGecC(object, key, newValue);
        else $6p70B(object, key, newValue);
    }
    return object;
}
module.exports = $9429d4054ecefbda$var$copyObject;

});

parcelRegister("fzwCY", function(module, exports) {

var $dDy16 = parcelRequire("dDy16");

var $kBssm = parcelRequire("kBssm");

var $g6J9C = parcelRequire("g6J9C");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $b5636f1189dc2c78$var$keys(object) {
    return $g6J9C(object) ? $dDy16(object) : $kBssm(object);
}
module.exports = $b5636f1189dc2c78$var$keys;

});
parcelRegister("dDy16", function(module, exports) {

var $fBwoo = parcelRequire("fBwoo");

var $3my3n = parcelRequire("3my3n");

var $jsvkI = parcelRequire("jsvkI");

var $h3dfZ = parcelRequire("h3dfZ");

var $TFgQG = parcelRequire("TFgQG");

var $5zose = parcelRequire("5zose");
/** Used for built-in method references. */ var $9ed94de46ad11938$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $9ed94de46ad11938$var$hasOwnProperty = $9ed94de46ad11938$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $9ed94de46ad11938$var$arrayLikeKeys(value, inherited) {
    var isArr = $jsvkI(value), isArg = !isArr && $3my3n(value), isBuff = !isArr && !isArg && $h3dfZ(value), isType = !isArr && !isArg && !isBuff && $5zose(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $fBwoo(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $9ed94de46ad11938$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    $TFgQG(key, length)))) result.push(key);
    return result;
}
module.exports = $9ed94de46ad11938$var$arrayLikeKeys;

});
parcelRegister("fBwoo", function(module, exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $b5c37031c12286d1$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = $b5c37031c12286d1$var$baseTimes;

});

parcelRegister("3my3n", function(module, exports) {

var $3VkIz = parcelRequire("3VkIz");

var $bCo5h = parcelRequire("bCo5h");
/** Used for built-in method references. */ var $272dd778d8400e20$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $272dd778d8400e20$var$hasOwnProperty = $272dd778d8400e20$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $272dd778d8400e20$var$propertyIsEnumerable = $272dd778d8400e20$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $272dd778d8400e20$var$isArguments = $3VkIz(function() {
    return arguments;
}()) ? $3VkIz : function(value) {
    return $bCo5h(value) && $272dd778d8400e20$var$hasOwnProperty.call(value, "callee") && !$272dd778d8400e20$var$propertyIsEnumerable.call(value, "callee");
};
module.exports = $272dd778d8400e20$var$isArguments;

});
parcelRegister("3VkIz", function(module, exports) {

var $ch48J = parcelRequire("ch48J");

var $bCo5h = parcelRequire("bCo5h");
/** `Object#toString` result references. */ var $2db6c4209eafeb9f$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $2db6c4209eafeb9f$var$baseIsArguments(value) {
    return $bCo5h(value) && $ch48J(value) == $2db6c4209eafeb9f$var$argsTag;
}
module.exports = $2db6c4209eafeb9f$var$baseIsArguments;

});
parcelRegister("bCo5h", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $8755ecf3096d5895$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
module.exports = $8755ecf3096d5895$var$isObjectLike;

});



parcelRegister("jsvkI", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $e2a8eff43ee9167f$var$isArray = Array.isArray;
module.exports = $e2a8eff43ee9167f$var$isArray;

});

parcelRegister("h3dfZ", function(module, exports) {

var $kWy0a = parcelRequire("kWy0a");

var $96PKv = parcelRequire("96PKv");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $kWy0a.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $96PKv;
module.exports = isBuffer;

});
parcelRegister("96PKv", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $6a1cd0de80108491$var$stubFalse() {
    return false;
}
module.exports = $6a1cd0de80108491$var$stubFalse;

});


parcelRegister("TFgQG", function(module, exports) {
/** Used as references for various `Number` constants. */ var $0a7526ae6491a34b$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $0a7526ae6491a34b$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $0a7526ae6491a34b$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $0a7526ae6491a34b$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $0a7526ae6491a34b$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = $0a7526ae6491a34b$var$isIndex;

});

parcelRegister("5zose", function(module, exports) {

var $WkXBe = parcelRequire("WkXBe");

var $bBLW9 = parcelRequire("bBLW9");

var $RPBNs = parcelRequire("RPBNs");
/* Node.js helper references. */ var $40e330c7c57f10fa$var$nodeIsTypedArray = $RPBNs && $RPBNs.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $40e330c7c57f10fa$var$isTypedArray = $40e330c7c57f10fa$var$nodeIsTypedArray ? $bBLW9($40e330c7c57f10fa$var$nodeIsTypedArray) : $WkXBe;
module.exports = $40e330c7c57f10fa$var$isTypedArray;

});
parcelRegister("WkXBe", function(module, exports) {

var $ch48J = parcelRequire("ch48J");

var $9zZUo = parcelRequire("9zZUo");

var $bCo5h = parcelRequire("bCo5h");
/** `Object#toString` result references. */ var $0af5ad2b93aff5d6$var$argsTag = "[object Arguments]", $0af5ad2b93aff5d6$var$arrayTag = "[object Array]", $0af5ad2b93aff5d6$var$boolTag = "[object Boolean]", $0af5ad2b93aff5d6$var$dateTag = "[object Date]", $0af5ad2b93aff5d6$var$errorTag = "[object Error]", $0af5ad2b93aff5d6$var$funcTag = "[object Function]", $0af5ad2b93aff5d6$var$mapTag = "[object Map]", $0af5ad2b93aff5d6$var$numberTag = "[object Number]", $0af5ad2b93aff5d6$var$objectTag = "[object Object]", $0af5ad2b93aff5d6$var$regexpTag = "[object RegExp]", $0af5ad2b93aff5d6$var$setTag = "[object Set]", $0af5ad2b93aff5d6$var$stringTag = "[object String]", $0af5ad2b93aff5d6$var$weakMapTag = "[object WeakMap]";
var $0af5ad2b93aff5d6$var$arrayBufferTag = "[object ArrayBuffer]", $0af5ad2b93aff5d6$var$dataViewTag = "[object DataView]", $0af5ad2b93aff5d6$var$float32Tag = "[object Float32Array]", $0af5ad2b93aff5d6$var$float64Tag = "[object Float64Array]", $0af5ad2b93aff5d6$var$int8Tag = "[object Int8Array]", $0af5ad2b93aff5d6$var$int16Tag = "[object Int16Array]", $0af5ad2b93aff5d6$var$int32Tag = "[object Int32Array]", $0af5ad2b93aff5d6$var$uint8Tag = "[object Uint8Array]", $0af5ad2b93aff5d6$var$uint8ClampedTag = "[object Uint8ClampedArray]", $0af5ad2b93aff5d6$var$uint16Tag = "[object Uint16Array]", $0af5ad2b93aff5d6$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $0af5ad2b93aff5d6$var$typedArrayTags = {};
$0af5ad2b93aff5d6$var$typedArrayTags[$0af5ad2b93aff5d6$var$float32Tag] = $0af5ad2b93aff5d6$var$typedArrayTags[$0af5ad2b93aff5d6$var$float64Tag] = $0af5ad2b93aff5d6$var$typedArrayTags[$0af5ad2b93aff5d6$var$int8Tag] = $0af5ad2b93aff5d6$var$typedArrayTags[$0af5ad2b93aff5d6$var$int16Tag] = $0af5ad2b93aff5d6$var$typedArrayTags[$0af5ad2b93aff5d6$var$int32Tag] = $0af5ad2b93aff5d6$var$typedArrayTags[$0af5ad2b93aff5d6$var$uint8Tag] = $0af5ad2b93aff5d6$var$typedArrayTags[$0af5ad2b93aff5d6$var$uint8ClampedTag] = $0af5ad2b93aff5d6$var$typedArrayTags[$0af5ad2b93aff5d6$var$uint16Tag] = $0af5ad2b93aff5d6$var$typedArrayTags[$0af5ad2b93aff5d6$var$uint32Tag] = true;
$0af5ad2b93aff5d6$var$typedArrayTags[$0af5ad2b93aff5d6$var$argsTag] = $0af5ad2b93aff5d6$var$typedArrayTags[$0af5ad2b93aff5d6$var$arrayTag] = $0af5ad2b93aff5d6$var$typedArrayTags[$0af5ad2b93aff5d6$var$arrayBufferTag] = $0af5ad2b93aff5d6$var$typedArrayTags[$0af5ad2b93aff5d6$var$boolTag] = $0af5ad2b93aff5d6$var$typedArrayTags[$0af5ad2b93aff5d6$var$dataViewTag] = $0af5ad2b93aff5d6$var$typedArrayTags[$0af5ad2b93aff5d6$var$dateTag] = $0af5ad2b93aff5d6$var$typedArrayTags[$0af5ad2b93aff5d6$var$errorTag] = $0af5ad2b93aff5d6$var$typedArrayTags[$0af5ad2b93aff5d6$var$funcTag] = $0af5ad2b93aff5d6$var$typedArrayTags[$0af5ad2b93aff5d6$var$mapTag] = $0af5ad2b93aff5d6$var$typedArrayTags[$0af5ad2b93aff5d6$var$numberTag] = $0af5ad2b93aff5d6$var$typedArrayTags[$0af5ad2b93aff5d6$var$objectTag] = $0af5ad2b93aff5d6$var$typedArrayTags[$0af5ad2b93aff5d6$var$regexpTag] = $0af5ad2b93aff5d6$var$typedArrayTags[$0af5ad2b93aff5d6$var$setTag] = $0af5ad2b93aff5d6$var$typedArrayTags[$0af5ad2b93aff5d6$var$stringTag] = $0af5ad2b93aff5d6$var$typedArrayTags[$0af5ad2b93aff5d6$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $0af5ad2b93aff5d6$var$baseIsTypedArray(value) {
    return $bCo5h(value) && $9zZUo(value.length) && !!$0af5ad2b93aff5d6$var$typedArrayTags[$ch48J(value)];
}
module.exports = $0af5ad2b93aff5d6$var$baseIsTypedArray;

});
parcelRegister("9zZUo", function(module, exports) {
/** Used as references for various `Number` constants. */ var $6f9767b11f030c73$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $6f9767b11f030c73$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $6f9767b11f030c73$var$MAX_SAFE_INTEGER;
}
module.exports = $6f9767b11f030c73$var$isLength;

});


parcelRegister("bBLW9", function(module, exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $873855aa22662442$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = $873855aa22662442$var$baseUnary;

});

parcelRegister("RPBNs", function(module, exports) {

var $2piOc = parcelRequire("2piOc");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $2piOc.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
module.exports = nodeUtil;

});



parcelRegister("kBssm", function(module, exports) {

var $1BM1e = parcelRequire("1BM1e");

var $10D7w = parcelRequire("10D7w");
/** Used for built-in method references. */ var $effd562d943658a2$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $effd562d943658a2$var$hasOwnProperty = $effd562d943658a2$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $effd562d943658a2$var$baseKeys(object) {
    if (!$1BM1e(object)) return $10D7w(object);
    var result = [];
    for(var key in Object(object))if ($effd562d943658a2$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
module.exports = $effd562d943658a2$var$baseKeys;

});
parcelRegister("1BM1e", function(module, exports) {
/** Used for built-in method references. */ var $12be7eb01689dd68$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $12be7eb01689dd68$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $12be7eb01689dd68$var$objectProto;
    return value === proto;
}
module.exports = $12be7eb01689dd68$var$isPrototype;

});

parcelRegister("10D7w", function(module, exports) {

var $1j9me = parcelRequire("1j9me");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $0bc423092a8115ae$var$nativeKeys = $1j9me(Object.keys, Object);
module.exports = $0bc423092a8115ae$var$nativeKeys;

});
parcelRegister("1j9me", function(module, exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $0f3ed2ffdab3e2d4$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = $0f3ed2ffdab3e2d4$var$overArg;

});



parcelRegister("g6J9C", function(module, exports) {

var $cSztt = parcelRequire("cSztt");

var $9zZUo = parcelRequire("9zZUo");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $bba03b924e3fb1e4$var$isArrayLike(value) {
    return value != null && $9zZUo(value.length) && !$cSztt(value);
}
module.exports = $bba03b924e3fb1e4$var$isArrayLike;

});



parcelRegister("btF6q", function(module, exports) {

var $cIFys = parcelRequire("cIFys");

var $dp56J = parcelRequire("dp56J");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $85b24945e4c8c880$var$baseAssignIn(object, source) {
    return object && $cIFys(source, $dp56J(source), object);
}
module.exports = $85b24945e4c8c880$var$baseAssignIn;

});
parcelRegister("dp56J", function(module, exports) {

var $dDy16 = parcelRequire("dDy16");

var $h7sb5 = parcelRequire("h7sb5");

var $g6J9C = parcelRequire("g6J9C");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $9c219270ed5c2e87$var$keysIn(object) {
    return $g6J9C(object) ? $dDy16(object, true) : $h7sb5(object);
}
module.exports = $9c219270ed5c2e87$var$keysIn;

});
parcelRegister("h7sb5", function(module, exports) {

var $eZjDd = parcelRequire("eZjDd");

var $1BM1e = parcelRequire("1BM1e");

var $1fu6Z = parcelRequire("1fu6Z");
/** Used for built-in method references. */ var $c768f2a7b56e3086$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c768f2a7b56e3086$var$hasOwnProperty = $c768f2a7b56e3086$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $c768f2a7b56e3086$var$baseKeysIn(object) {
    if (!$eZjDd(object)) return $1fu6Z(object);
    var isProto = $1BM1e(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !$c768f2a7b56e3086$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
module.exports = $c768f2a7b56e3086$var$baseKeysIn;

});
parcelRegister("1fu6Z", function(module, exports) {
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $0e8e8cb290518f98$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
module.exports = $0e8e8cb290518f98$var$nativeKeysIn;

});




parcelRegister("b2okp", function(module, exports) {

var $kWy0a = parcelRequire("kWy0a");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $kWy0a.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

});

parcelRegister("o1vzS", function(module, exports) {
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $04836986ba6ecdcb$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
module.exports = $04836986ba6ecdcb$var$copyArray;

});

parcelRegister("euBeZ", function(module, exports) {

var $cIFys = parcelRequire("cIFys");

var $26R83 = parcelRequire("26R83");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $a8d0c144a071d97c$var$copySymbols(source, object) {
    return $cIFys(source, $26R83(source), object);
}
module.exports = $a8d0c144a071d97c$var$copySymbols;

});
parcelRegister("26R83", function(module, exports) {

var $vs5dq = parcelRequire("vs5dq");

var $3oZtm = parcelRequire("3oZtm");
/** Used for built-in method references. */ var $18955a9aa12daa8d$var$objectProto = Object.prototype;
/** Built-in value references. */ var $18955a9aa12daa8d$var$propertyIsEnumerable = $18955a9aa12daa8d$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $18955a9aa12daa8d$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $18955a9aa12daa8d$var$getSymbols = !$18955a9aa12daa8d$var$nativeGetSymbols ? $3oZtm : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $vs5dq($18955a9aa12daa8d$var$nativeGetSymbols(object), function(symbol) {
        return $18955a9aa12daa8d$var$propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = $18955a9aa12daa8d$var$getSymbols;

});
parcelRegister("vs5dq", function(module, exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $05e8ae167e936677$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = $05e8ae167e936677$var$arrayFilter;

});

parcelRegister("3oZtm", function(module, exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $27a34c23f38f2402$var$stubArray() {
    return [];
}
module.exports = $27a34c23f38f2402$var$stubArray;

});



parcelRegister("3ZRRt", function(module, exports) {

var $cIFys = parcelRequire("cIFys");

var $iFCv1 = parcelRequire("iFCv1");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $2e90d964725bd940$var$copySymbolsIn(source, object) {
    return $cIFys(source, $iFCv1(source), object);
}
module.exports = $2e90d964725bd940$var$copySymbolsIn;

});
parcelRegister("iFCv1", function(module, exports) {

var $6WjzU = parcelRequire("6WjzU");

var $2XgYJ = parcelRequire("2XgYJ");

var $26R83 = parcelRequire("26R83");

var $3oZtm = parcelRequire("3oZtm");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $d979eb7c8bd4efbe$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $d979eb7c8bd4efbe$var$getSymbolsIn = !$d979eb7c8bd4efbe$var$nativeGetSymbols ? $3oZtm : function(object) {
    var result = [];
    while(object){
        $6WjzU(result, $26R83(object));
        object = $2XgYJ(object);
    }
    return result;
};
module.exports = $d979eb7c8bd4efbe$var$getSymbolsIn;

});
parcelRegister("6WjzU", function(module, exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $50d758aba8751d3e$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = $50d758aba8751d3e$var$arrayPush;

});

parcelRegister("2XgYJ", function(module, exports) {

var $1j9me = parcelRequire("1j9me");
/** Built-in value references. */ var $226e4311a08add6a$var$getPrototype = $1j9me(Object.getPrototypeOf, Object);
module.exports = $226e4311a08add6a$var$getPrototype;

});



parcelRegister("ha33u", function(module, exports) {

var $25V4C = parcelRequire("25V4C");

var $26R83 = parcelRequire("26R83");

var $fzwCY = parcelRequire("fzwCY");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $c7e5bd92e5e2adf9$var$getAllKeys(object) {
    return $25V4C(object, $fzwCY, $26R83);
}
module.exports = $c7e5bd92e5e2adf9$var$getAllKeys;

});
parcelRegister("25V4C", function(module, exports) {

var $6WjzU = parcelRequire("6WjzU");

var $jsvkI = parcelRequire("jsvkI");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $186851fc2ab1b160$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $jsvkI(object) ? result : $6WjzU(result, symbolsFunc(object));
}
module.exports = $186851fc2ab1b160$var$baseGetAllKeys;

});


parcelRegister("hsVGU", function(module, exports) {

var $25V4C = parcelRequire("25V4C");

var $iFCv1 = parcelRequire("iFCv1");

var $dp56J = parcelRequire("dp56J");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $cb71cd6b51a8f1c3$var$getAllKeysIn(object) {
    return $25V4C(object, $dp56J, $iFCv1);
}
module.exports = $cb71cd6b51a8f1c3$var$getAllKeysIn;

});

parcelRegister("eHMmp", function(module, exports) {

var $aE6yq = parcelRequire("aE6yq");

var $hfh24 = parcelRequire("hfh24");

var $9f4gn = parcelRequire("9f4gn");

var $i3Ee5 = parcelRequire("i3Ee5");

var $5iGvD = parcelRequire("5iGvD");

var $ch48J = parcelRequire("ch48J");

var $fQae2 = parcelRequire("fQae2");
/** `Object#toString` result references. */ var $ab4a983b16b10b88$var$mapTag = "[object Map]", $ab4a983b16b10b88$var$objectTag = "[object Object]", $ab4a983b16b10b88$var$promiseTag = "[object Promise]", $ab4a983b16b10b88$var$setTag = "[object Set]", $ab4a983b16b10b88$var$weakMapTag = "[object WeakMap]";
var $ab4a983b16b10b88$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $ab4a983b16b10b88$var$dataViewCtorString = $fQae2($aE6yq), $ab4a983b16b10b88$var$mapCtorString = $fQae2($hfh24), $ab4a983b16b10b88$var$promiseCtorString = $fQae2($9f4gn), $ab4a983b16b10b88$var$setCtorString = $fQae2($i3Ee5), $ab4a983b16b10b88$var$weakMapCtorString = $fQae2($5iGvD);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $ab4a983b16b10b88$var$getTag = $ch48J;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($aE6yq && $ab4a983b16b10b88$var$getTag(new $aE6yq(new ArrayBuffer(1))) != $ab4a983b16b10b88$var$dataViewTag || $hfh24 && $ab4a983b16b10b88$var$getTag(new $hfh24) != $ab4a983b16b10b88$var$mapTag || $9f4gn && $ab4a983b16b10b88$var$getTag($9f4gn.resolve()) != $ab4a983b16b10b88$var$promiseTag || $i3Ee5 && $ab4a983b16b10b88$var$getTag(new $i3Ee5) != $ab4a983b16b10b88$var$setTag || $5iGvD && $ab4a983b16b10b88$var$getTag(new $5iGvD) != $ab4a983b16b10b88$var$weakMapTag) $ab4a983b16b10b88$var$getTag = function(value) {
    var result = $ch48J(value), Ctor = result == $ab4a983b16b10b88$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $fQae2(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $ab4a983b16b10b88$var$dataViewCtorString:
            return $ab4a983b16b10b88$var$dataViewTag;
        case $ab4a983b16b10b88$var$mapCtorString:
            return $ab4a983b16b10b88$var$mapTag;
        case $ab4a983b16b10b88$var$promiseCtorString:
            return $ab4a983b16b10b88$var$promiseTag;
        case $ab4a983b16b10b88$var$setCtorString:
            return $ab4a983b16b10b88$var$setTag;
        case $ab4a983b16b10b88$var$weakMapCtorString:
            return $ab4a983b16b10b88$var$weakMapTag;
    }
    return result;
};
module.exports = $ab4a983b16b10b88$var$getTag;

});
parcelRegister("aE6yq", function(module, exports) {

var $eYreK = parcelRequire("eYreK");

var $kWy0a = parcelRequire("kWy0a");
/* Built-in method references that are verified to be native. */ var $7c02b9584f756963$var$DataView = $eYreK($kWy0a, "DataView");
module.exports = $7c02b9584f756963$var$DataView;

});

parcelRegister("9f4gn", function(module, exports) {

var $eYreK = parcelRequire("eYreK");

var $kWy0a = parcelRequire("kWy0a");
/* Built-in method references that are verified to be native. */ var $6ba8d25aa37272ab$var$Promise = $eYreK($kWy0a, "Promise");
module.exports = $6ba8d25aa37272ab$var$Promise;

});

parcelRegister("i3Ee5", function(module, exports) {

var $eYreK = parcelRequire("eYreK");

var $kWy0a = parcelRequire("kWy0a");
/* Built-in method references that are verified to be native. */ var $d257b5e5a4e17c11$var$Set = $eYreK($kWy0a, "Set");
module.exports = $d257b5e5a4e17c11$var$Set;

});

parcelRegister("5iGvD", function(module, exports) {

var $eYreK = parcelRequire("eYreK");

var $kWy0a = parcelRequire("kWy0a");
/* Built-in method references that are verified to be native. */ var $3dbf9ba2df85da9a$var$WeakMap = $eYreK($kWy0a, "WeakMap");
module.exports = $3dbf9ba2df85da9a$var$WeakMap;

});


parcelRegister("9KzYg", function(module, exports) {
/** Used for built-in method references. */ var $71945004cf9faf6d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $71945004cf9faf6d$var$hasOwnProperty = $71945004cf9faf6d$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $71945004cf9faf6d$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == "string" && $71945004cf9faf6d$var$hasOwnProperty.call(array, "index")) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
module.exports = $71945004cf9faf6d$var$initCloneArray;

});

parcelRegister("kyqsf", function(module, exports) {

var $fCs5W = parcelRequire("fCs5W");

var $aE1uu = parcelRequire("aE1uu");

var $j6Sld = parcelRequire("j6Sld");

var $heaVI = parcelRequire("heaVI");

var $fdo0J = parcelRequire("fdo0J");
/** `Object#toString` result references. */ var $ef6b80f97c8911a1$var$boolTag = "[object Boolean]", $ef6b80f97c8911a1$var$dateTag = "[object Date]", $ef6b80f97c8911a1$var$mapTag = "[object Map]", $ef6b80f97c8911a1$var$numberTag = "[object Number]", $ef6b80f97c8911a1$var$regexpTag = "[object RegExp]", $ef6b80f97c8911a1$var$setTag = "[object Set]", $ef6b80f97c8911a1$var$stringTag = "[object String]", $ef6b80f97c8911a1$var$symbolTag = "[object Symbol]";
var $ef6b80f97c8911a1$var$arrayBufferTag = "[object ArrayBuffer]", $ef6b80f97c8911a1$var$dataViewTag = "[object DataView]", $ef6b80f97c8911a1$var$float32Tag = "[object Float32Array]", $ef6b80f97c8911a1$var$float64Tag = "[object Float64Array]", $ef6b80f97c8911a1$var$int8Tag = "[object Int8Array]", $ef6b80f97c8911a1$var$int16Tag = "[object Int16Array]", $ef6b80f97c8911a1$var$int32Tag = "[object Int32Array]", $ef6b80f97c8911a1$var$uint8Tag = "[object Uint8Array]", $ef6b80f97c8911a1$var$uint8ClampedTag = "[object Uint8ClampedArray]", $ef6b80f97c8911a1$var$uint16Tag = "[object Uint16Array]", $ef6b80f97c8911a1$var$uint32Tag = "[object Uint32Array]";
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $ef6b80f97c8911a1$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $ef6b80f97c8911a1$var$arrayBufferTag:
            return $fCs5W(object);
        case $ef6b80f97c8911a1$var$boolTag:
        case $ef6b80f97c8911a1$var$dateTag:
            return new Ctor(+object);
        case $ef6b80f97c8911a1$var$dataViewTag:
            return $aE1uu(object, isDeep);
        case $ef6b80f97c8911a1$var$float32Tag:
        case $ef6b80f97c8911a1$var$float64Tag:
        case $ef6b80f97c8911a1$var$int8Tag:
        case $ef6b80f97c8911a1$var$int16Tag:
        case $ef6b80f97c8911a1$var$int32Tag:
        case $ef6b80f97c8911a1$var$uint8Tag:
        case $ef6b80f97c8911a1$var$uint8ClampedTag:
        case $ef6b80f97c8911a1$var$uint16Tag:
        case $ef6b80f97c8911a1$var$uint32Tag:
            return $fdo0J(object, isDeep);
        case $ef6b80f97c8911a1$var$mapTag:
            return new Ctor;
        case $ef6b80f97c8911a1$var$numberTag:
        case $ef6b80f97c8911a1$var$stringTag:
            return new Ctor(object);
        case $ef6b80f97c8911a1$var$regexpTag:
            return $j6Sld(object);
        case $ef6b80f97c8911a1$var$setTag:
            return new Ctor;
        case $ef6b80f97c8911a1$var$symbolTag:
            return $heaVI(object);
    }
}
module.exports = $ef6b80f97c8911a1$var$initCloneByTag;

});
parcelRegister("fCs5W", function(module, exports) {

var $fSkny = parcelRequire("fSkny");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $b5f032b004a935d2$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new $fSkny(result).set(new $fSkny(arrayBuffer));
    return result;
}
module.exports = $b5f032b004a935d2$var$cloneArrayBuffer;

});
parcelRegister("fSkny", function(module, exports) {

var $kWy0a = parcelRequire("kWy0a");
/** Built-in value references. */ var $b8ebb4f997e69288$var$Uint8Array = $kWy0a.Uint8Array;
module.exports = $b8ebb4f997e69288$var$Uint8Array;

});


parcelRegister("aE1uu", function(module, exports) {

var $fCs5W = parcelRequire("fCs5W");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $7bfecbd3554eab2b$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? $fCs5W(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
module.exports = $7bfecbd3554eab2b$var$cloneDataView;

});

parcelRegister("j6Sld", function(module, exports) {
/** Used to match `RegExp` flags from their coerced string values. */ var $de98badd3e4d1087$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $de98badd3e4d1087$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $de98badd3e4d1087$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
module.exports = $de98badd3e4d1087$var$cloneRegExp;

});

parcelRegister("heaVI", function(module, exports) {

var $bZ0Fd = parcelRequire("bZ0Fd");
/** Used to convert symbols to primitives and strings. */ var $c8ac38ec2a006675$var$symbolProto = $bZ0Fd ? $bZ0Fd.prototype : undefined, $c8ac38ec2a006675$var$symbolValueOf = $c8ac38ec2a006675$var$symbolProto ? $c8ac38ec2a006675$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $c8ac38ec2a006675$var$cloneSymbol(symbol) {
    return $c8ac38ec2a006675$var$symbolValueOf ? Object($c8ac38ec2a006675$var$symbolValueOf.call(symbol)) : {};
}
module.exports = $c8ac38ec2a006675$var$cloneSymbol;

});

parcelRegister("fdo0J", function(module, exports) {

var $fCs5W = parcelRequire("fCs5W");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $b13ab1f41867721b$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? $fCs5W(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
module.exports = $b13ab1f41867721b$var$cloneTypedArray;

});


parcelRegister("6pFcL", function(module, exports) {

var $iubzY = parcelRequire("iubzY");

var $2XgYJ = parcelRequire("2XgYJ");

var $1BM1e = parcelRequire("1BM1e");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $4ab50a4f9e2bea69$var$initCloneObject(object) {
    return typeof object.constructor == "function" && !$1BM1e(object) ? $iubzY($2XgYJ(object)) : {};
}
module.exports = $4ab50a4f9e2bea69$var$initCloneObject;

});
parcelRegister("iubzY", function(module, exports) {

var $eZjDd = parcelRequire("eZjDd");
/** Built-in value references. */ var $d75402b4e095ad80$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $d75402b4e095ad80$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!$eZjDd(proto)) return {};
        if ($d75402b4e095ad80$var$objectCreate) return $d75402b4e095ad80$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
module.exports = $d75402b4e095ad80$var$baseCreate;

});


parcelRegister("j9Qqp", function(module, exports) {

var $6FTYv = parcelRequire("6FTYv");

var $bBLW9 = parcelRequire("bBLW9");

var $RPBNs = parcelRequire("RPBNs");
/* Node.js helper references. */ var $df278618c5d9c3c7$var$nodeIsMap = $RPBNs && $RPBNs.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $df278618c5d9c3c7$var$isMap = $df278618c5d9c3c7$var$nodeIsMap ? $bBLW9($df278618c5d9c3c7$var$nodeIsMap) : $6FTYv;
module.exports = $df278618c5d9c3c7$var$isMap;

});
parcelRegister("6FTYv", function(module, exports) {

var $eHMmp = parcelRequire("eHMmp");

var $bCo5h = parcelRequire("bCo5h");
/** `Object#toString` result references. */ var $4dc1fde189b8f08e$var$mapTag = "[object Map]";
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $4dc1fde189b8f08e$var$baseIsMap(value) {
    return $bCo5h(value) && $eHMmp(value) == $4dc1fde189b8f08e$var$mapTag;
}
module.exports = $4dc1fde189b8f08e$var$baseIsMap;

});


parcelRegister("fK2U3", function(module, exports) {

var $hEtEy = parcelRequire("hEtEy");

var $bBLW9 = parcelRequire("bBLW9");

var $RPBNs = parcelRequire("RPBNs");
/* Node.js helper references. */ var $b75d6766ad52b312$var$nodeIsSet = $RPBNs && $RPBNs.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $b75d6766ad52b312$var$isSet = $b75d6766ad52b312$var$nodeIsSet ? $bBLW9($b75d6766ad52b312$var$nodeIsSet) : $hEtEy;
module.exports = $b75d6766ad52b312$var$isSet;

});
parcelRegister("hEtEy", function(module, exports) {

var $eHMmp = parcelRequire("eHMmp");

var $bCo5h = parcelRequire("bCo5h");
/** `Object#toString` result references. */ var $cd9d2c8ec46e5b53$var$setTag = "[object Set]";
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $cd9d2c8ec46e5b53$var$baseIsSet(value) {
    return $bCo5h(value) && $eHMmp(value) == $cd9d2c8ec46e5b53$var$setTag;
}
module.exports = $cd9d2c8ec46e5b53$var$baseIsSet;

});





parcelRegister("lA4pq", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $fb60614b5f71d32e$export$b3890eb0ae9dca99; });
parcelRequire("gMau8");
var $lY371 = parcelRequire("lY371");
var $16Sl1 = parcelRequire("16Sl1");
var $aFJJk = parcelRequire("aFJJk");
const $fb60614b5f71d32e$var$_hoisted_1 = {
    id: "vue_MapSidebar"
};
const $fb60614b5f71d32e$var$_hoisted_2 = {
    class: "map_control_header bg-blue"
};
const $fb60614b5f71d32e$var$_hoisted_3 = {
    class: "map_control_body",
    style: {
        "display": "block"
    }
};
const $fb60614b5f71d32e$var$_hoisted_4 = {
    class: "custom-control custom-checkbox"
};
const $fb60614b5f71d32e$var$_hoisted_5 = [
    "id",
    "value"
];
const $fb60614b5f71d32e$var$_hoisted_6 = [
    "for",
    "innerHTML"
];
const $fb60614b5f71d32e$var$_hoisted_7 = {
    key: 0,
    class: "map_control_options"
};
const $fb60614b5f71d32e$var$_hoisted_8 = [
    "id",
    "onChange"
];
const $fb60614b5f71d32e$var$_hoisted_9 = [
    "value",
    "selected"
];
const $fb60614b5f71d32e$var$_hoisted_10 = {
    key: 1,
    class: "map_control_options"
};
const $fb60614b5f71d32e$var$_hoisted_11 = [
    "id",
    "onChange"
];
const $fb60614b5f71d32e$var$_hoisted_12 = [
    "value",
    "selected"
];
const $fb60614b5f71d32e$var$_hoisted_13 = {
    key: 2,
    class: "map_control_options"
};
const $fb60614b5f71d32e$var$_hoisted_14 = [
    "value"
];
const $fb60614b5f71d32e$var$_hoisted_15 = [
    "name",
    "id",
    "value"
];
const $fb60614b5f71d32e$var$_hoisted_16 = [
    "for"
];
function $fb60614b5f71d32e$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $lY371.openBlock)(), (0, $lY371.createElementBlock)("div", $fb60614b5f71d32e$var$_hoisted_1, [
        ((0, $lY371.openBlock)(true), (0, $lY371.createElementBlock)((0, $lY371.Fragment), null, (0, $lY371.renderList)($data.layers, (section)=>{
            return (0, $lY371.openBlock)(), (0, $lY371.createElementBlock)("div", {
                class: "map_control_section",
                key: section.cid
            }, [
                (0, $lY371.createElementVNode)("div", $fb60614b5f71d32e$var$_hoisted_2, (0, $16Sl1.toDisplayString)(section.name), 1),
                (0, $lY371.createElementVNode)("div", $fb60614b5f71d32e$var$_hoisted_3, [
                    ((0, $lY371.openBlock)(true), (0, $lY371.createElementBlock)((0, $lY371.Fragment), null, (0, $lY371.renderList)(section.layers, (layer)=>{
                        return (0, $lY371.openBlock)(), (0, $lY371.createElementBlock)("div", {
                            class: "form-group",
                            key: layer.layerId
                        }, [
                            (0, $lY371.createElementVNode)("div", $fb60614b5f71d32e$var$_hoisted_4, [
                                (0, $lY371.withDirectives)((0, $lY371.createElementVNode)("input", {
                                    type: "checkbox",
                                    class: "custom-control-input",
                                    id: "toggle_" + layer.layerId,
                                    value: layer.layerId,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$data.activeLayers = $event)
                                }, null, 8, $fb60614b5f71d32e$var$_hoisted_5), [
                                    [
                                        (0, $aFJJk.vModelCheckbox),
                                        $data.activeLayers
                                    ]
                                ]),
                                (0, $lY371.createElementVNode)("label", {
                                    class: "custom-control-label",
                                    for: "toggle_" + layer.layerId,
                                    innerHTML: layer.name
                                }, null, 8, $fb60614b5f71d32e$var$_hoisted_6)
                            ]),
                            layer.options && (!layer.options.selectType || layer.options.selectType == "dropdown") && layer.options.filters && layer.options.filters.length > 0 ? ((0, $lY371.openBlock)(), (0, $lY371.createElementBlock)("div", $fb60614b5f71d32e$var$_hoisted_7, [
                                (0, $lY371.createElementVNode)("select", {
                                    class: "form-control",
                                    id: layer.layerId + "_option",
                                    onChange: ($event)=>$options.toggleLayerOption(layer.layerId)
                                }, [
                                    ((0, $lY371.openBlock)(true), (0, $lY371.createElementBlock)((0, $lY371.Fragment), null, (0, $lY371.renderList)(layer.options.filters, (entry)=>{
                                        return (0, $lY371.openBlock)(), (0, $lY371.createElementBlock)("option", {
                                            key: entry.value,
                                            value: entry.value,
                                            selected: !!entry.default
                                        }, (0, $16Sl1.toDisplayString)(entry.name), 9, $fb60614b5f71d32e$var$_hoisted_9);
                                    }), 128))
                                ], 40, $fb60614b5f71d32e$var$_hoisted_8)
                            ])) : (0, $lY371.createCommentVNode)("", true),
                            layer.sublayers ? ((0, $lY371.openBlock)(), (0, $lY371.createElementBlock)("div", $fb60614b5f71d32e$var$_hoisted_10, [
                                (0, $lY371.createElementVNode)("select", {
                                    class: "form-control",
                                    id: layer.layerId + "_option",
                                    onChange: ($event)=>$options.toggleLayerElement(layer.layerId)
                                }, [
                                    ((0, $lY371.openBlock)(true), (0, $lY371.createElementBlock)((0, $lY371.Fragment), null, (0, $lY371.renderList)(layer.sublayers, (entry)=>{
                                        return (0, $lY371.openBlock)(), (0, $lY371.createElementBlock)("option", {
                                            key: entry.layerId,
                                            value: entry.layerId,
                                            selected: !!entry.default
                                        }, (0, $16Sl1.toDisplayString)(entry.name), 9, $fb60614b5f71d32e$var$_hoisted_12);
                                    }), 128))
                                ], 40, $fb60614b5f71d32e$var$_hoisted_11)
                            ])) : (0, $lY371.createCommentVNode)("", true),
                            layer.options && layer.options.selectType == "radio" && layer.options.filters && layer.options.filters.length > 0 ? ((0, $lY371.openBlock)(), (0, $lY371.createElementBlock)("div", $fb60614b5f71d32e$var$_hoisted_13, [
                                ((0, $lY371.openBlock)(true), (0, $lY371.createElementBlock)((0, $lY371.Fragment), null, (0, $lY371.renderList)(layer.options, (entry)=>{
                                    return (0, $lY371.openBlock)(), (0, $lY371.createElementBlock)("div", {
                                        class: "custom-control custom-radio",
                                        key: entry.value,
                                        value: entry.value
                                    }, [
                                        (0, $lY371.createElementVNode)("input", {
                                            type: "radio",
                                            class: "custom-control-input",
                                            name: layer.layerId,
                                            id: "toggle_" + entry.layerId,
                                            value: entry.layerId
                                        }, null, 8, $fb60614b5f71d32e$var$_hoisted_15),
                                        (0, $lY371.createElementVNode)("label", {
                                            class: "custom-control-label",
                                            for: "toggle_" + entry.layerId
                                        }, (0, $16Sl1.toDisplayString)(entry.name), 9, $fb60614b5f71d32e$var$_hoisted_16)
                                    ], 8, $fb60614b5f71d32e$var$_hoisted_14);
                                }), 128))
                            ])) : (0, $lY371.createCommentVNode)("", true)
                        ]);
                    }), 128))
                ])
            ]);
        }), 128))
    ]);
}

});
parcelRegister("gMau8", function(module, exports) {
$parcel$export(module.exports, "createApp", function () { return (parcelRequire("aFJJk")).createApp; });
$parcel$export(module.exports, "vModelCheckbox", function () { return (parcelRequire("aFJJk")).vModelCheckbox; });
$parcel$export(module.exports, "createCommentVNode", function () { return (parcelRequire("lY371")).createCommentVNode; });
$parcel$export(module.exports, "createElementBlock", function () { return (parcelRequire("lY371")).createElementBlock; });
$parcel$export(module.exports, "createElementVNode", function () { return (parcelRequire("lY371")).createElementVNode; });
$parcel$export(module.exports, "Fragment", function () { return (parcelRequire("lY371")).Fragment; });
$parcel$export(module.exports, "initCustomFormatter", function () { return (parcelRequire("lY371")).initCustomFormatter; });
$parcel$export(module.exports, "openBlock", function () { return (parcelRequire("lY371")).openBlock; });
$parcel$export(module.exports, "renderList", function () { return (parcelRequire("lY371")).renderList; });
$parcel$export(module.exports, "withDirectives", function () { return (parcelRequire("lY371")).withDirectives; });
$parcel$export(module.exports, "toDisplayString", function () { return (parcelRequire("16Sl1")).toDisplayString; });
/**
* vue v3.4.25
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ parcelRequire("aFJJk");
var $lY371 = parcelRequire("lY371");parcelRequire("16Sl1");
function $c36943277447c002$var$initDev() {
    (0, $lY371.initCustomFormatter)();
}
const $c36943277447c002$export$ef7acd7185315e22 = ()=>{};

});
parcelRegister("aFJJk", function(module, exports) {
$parcel$export(module.exports, "BaseTransition", function () { return (parcelRequire("lY371")).BaseTransition; });
$parcel$export(module.exports, "BaseTransitionPropsValidators", function () { return (parcelRequire("lY371")).BaseTransitionPropsValidators; });
$parcel$export(module.exports, "callWithAsyncErrorHandling", function () { return (parcelRequire("lY371")).callWithAsyncErrorHandling; });
$parcel$export(module.exports, "camelize", function () { return (parcelRequire("16Sl1")).camelize; });
$parcel$export(module.exports, "createCommentVNode", function () { return (parcelRequire("lY371")).createCommentVNode; });
$parcel$export(module.exports, "createElementBlock", function () { return (parcelRequire("lY371")).createElementBlock; });
$parcel$export(module.exports, "createElementVNode", function () { return (parcelRequire("lY371")).createElementVNode; });
$parcel$export(module.exports, "createHydrationRenderer", function () { return (parcelRequire("lY371")).createHydrationRenderer; });
$parcel$export(module.exports, "createRenderer", function () { return (parcelRequire("lY371")).createRenderer; });
$parcel$export(module.exports, "createVNode", function () { return (parcelRequire("lY371")).createVNode; });
$parcel$export(module.exports, "defineComponent", function () { return (parcelRequire("lY371")).defineComponent; });
$parcel$export(module.exports, "Fragment", function () { return (parcelRequire("lY371")).Fragment; });
$parcel$export(module.exports, "getCurrentInstance", function () { return (parcelRequire("lY371")).getCurrentInstance; });
$parcel$export(module.exports, "getTransitionRawChildren", function () { return (parcelRequire("lY371")).getTransitionRawChildren; });
$parcel$export(module.exports, "h", function () { return (parcelRequire("lY371")).h; });
$parcel$export(module.exports, "initCustomFormatter", function () { return (parcelRequire("lY371")).initCustomFormatter; });
$parcel$export(module.exports, "isRuntimeOnly", function () { return (parcelRequire("lY371")).isRuntimeOnly; });
$parcel$export(module.exports, "nextTick", function () { return (parcelRequire("lY371")).nextTick; });
$parcel$export(module.exports, "onMounted", function () { return (parcelRequire("lY371")).onMounted; });
$parcel$export(module.exports, "onUnmounted", function () { return (parcelRequire("lY371")).onUnmounted; });
$parcel$export(module.exports, "onUpdated", function () { return (parcelRequire("lY371")).onUpdated; });
$parcel$export(module.exports, "openBlock", function () { return (parcelRequire("lY371")).openBlock; });
$parcel$export(module.exports, "renderList", function () { return (parcelRequire("lY371")).renderList; });
$parcel$export(module.exports, "resolveTransitionHooks", function () { return (parcelRequire("lY371")).resolveTransitionHooks; });
$parcel$export(module.exports, "setTransitionHooks", function () { return (parcelRequire("lY371")).setTransitionHooks; });
$parcel$export(module.exports, "Static", function () { return (parcelRequire("lY371")).Static; });
$parcel$export(module.exports, "toRaw", function () { return (parcelRequire("99kuS")).toRaw; });
$parcel$export(module.exports, "useTransitionState", function () { return (parcelRequire("lY371")).useTransitionState; });
$parcel$export(module.exports, "warn", function () { return (parcelRequire("lY371")).warn; });
$parcel$export(module.exports, "watchPostEffect", function () { return (parcelRequire("lY371")).watchPostEffect; });
$parcel$export(module.exports, "withDirectives", function () { return (parcelRequire("lY371")).withDirectives; });
$parcel$export(module.exports, "toDisplayString", function () { return (parcelRequire("16Sl1")).toDisplayString; });

$parcel$export(module.exports, "vModelCheckbox", function () { return $7c5134c8d276549e$export$8847c2e532b35714; });
$parcel$export(module.exports, "createApp", function () { return $7c5134c8d276549e$export$4e373c34abfa8c68; });
/**
* @vue/runtime-dom v3.4.25
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $lY371 = parcelRequire("lY371");
var $16Sl1 = parcelRequire("16Sl1");
var $99kuS = parcelRequire("99kuS");parcelRequire("16Sl1");

var $16Sl1 = parcelRequire("16Sl1");
const $7c5134c8d276549e$var$svgNS = "http://www.w3.org/2000/svg";
const $7c5134c8d276549e$var$mathmlNS = "http://www.w3.org/1998/Math/MathML";
const $7c5134c8d276549e$var$doc = typeof document !== "undefined" ? document : null;
const $7c5134c8d276549e$var$templateContainer = $7c5134c8d276549e$var$doc && /* @__PURE__ */ $7c5134c8d276549e$var$doc.createElement("template");
const $7c5134c8d276549e$var$nodeOps = {
    insert: (child, parent, anchor)=>{
        parent.insertBefore(child, anchor || null);
    },
    remove: (child)=>{
        const parent = child.parentNode;
        if (parent) parent.removeChild(child);
    },
    createElement: (tag, namespace, is, props)=>{
        const el = namespace === "svg" ? $7c5134c8d276549e$var$doc.createElementNS($7c5134c8d276549e$var$svgNS, tag) : namespace === "mathml" ? $7c5134c8d276549e$var$doc.createElementNS($7c5134c8d276549e$var$mathmlNS, tag) : $7c5134c8d276549e$var$doc.createElement(tag, is ? {
            is: is
        } : void 0);
        if (tag === "select" && props && props.multiple != null) el.setAttribute("multiple", props.multiple);
        return el;
    },
    createText: (text)=>$7c5134c8d276549e$var$doc.createTextNode(text),
    createComment: (text)=>$7c5134c8d276549e$var$doc.createComment(text),
    setText: (node, text)=>{
        node.nodeValue = text;
    },
    setElementText: (el, text)=>{
        el.textContent = text;
    },
    parentNode: (node)=>node.parentNode,
    nextSibling: (node)=>node.nextSibling,
    querySelector: (selector)=>$7c5134c8d276549e$var$doc.querySelector(selector),
    setScopeId (el, id) {
        el.setAttribute(id, "");
    },
    // __UNSAFE__
    // Reason: innerHTML.
    // Static content here can only come from compiled templates.
    // As long as the user only uses trusted templates, this is safe.
    insertStaticContent (content, parent, anchor, namespace, start, end) {
        const before = anchor ? anchor.previousSibling : parent.lastChild;
        if (start && (start === end || start.nextSibling)) while(true){
            parent.insertBefore(start.cloneNode(true), anchor);
            if (start === end || !(start = start.nextSibling)) break;
        }
        else {
            $7c5134c8d276549e$var$templateContainer.innerHTML = namespace === "svg" ? `<svg>${content}</svg>` : namespace === "mathml" ? `<math>${content}</math>` : content;
            const template = $7c5134c8d276549e$var$templateContainer.content;
            if (namespace === "svg" || namespace === "mathml") {
                const wrapper = template.firstChild;
                while(wrapper.firstChild)template.appendChild(wrapper.firstChild);
                template.removeChild(wrapper);
            }
            parent.insertBefore(template, anchor);
        }
        return [
            // first
            before ? before.nextSibling : parent.firstChild,
            // last
            anchor ? anchor.previousSibling : parent.lastChild
        ];
    }
};
const $7c5134c8d276549e$var$TRANSITION = "transition";
const $7c5134c8d276549e$var$ANIMATION = "animation";
const $7c5134c8d276549e$var$vtcKey = Symbol("_vtc");
const $7c5134c8d276549e$export$be58926105124dd4 = (props, { slots: slots })=>(0, $lY371.h)((0, $lY371.BaseTransition), $7c5134c8d276549e$var$resolveTransitionProps(props), slots);
$7c5134c8d276549e$export$be58926105124dd4.displayName = "Transition";
const $7c5134c8d276549e$var$DOMTransitionPropsValidators = {
    name: String,
    type: String,
    css: {
        type: Boolean,
        default: true
    },
    duration: [
        String,
        Number,
        Object
    ],
    enterFromClass: String,
    enterActiveClass: String,
    enterToClass: String,
    appearFromClass: String,
    appearActiveClass: String,
    appearToClass: String,
    leaveFromClass: String,
    leaveActiveClass: String,
    leaveToClass: String
};
const $7c5134c8d276549e$var$TransitionPropsValidators = $7c5134c8d276549e$export$be58926105124dd4.props = /* @__PURE__ */ (0, $16Sl1.extend)({}, (0, $lY371.BaseTransitionPropsValidators), $7c5134c8d276549e$var$DOMTransitionPropsValidators);
const $7c5134c8d276549e$var$callHook = (hook, args = [])=>{
    if ((0, $16Sl1.isArray)(hook)) hook.forEach((h2)=>h2(...args));
    else if (hook) hook(...args);
};
const $7c5134c8d276549e$var$hasExplicitCallback = (hook)=>{
    return hook ? (0, $16Sl1.isArray)(hook) ? hook.some((h2)=>h2.length > 1) : hook.length > 1 : false;
};
function $7c5134c8d276549e$var$resolveTransitionProps(rawProps) {
    const baseProps = {};
    for(const key in rawProps)if (!(key in $7c5134c8d276549e$var$DOMTransitionPropsValidators)) baseProps[key] = rawProps[key];
    if (rawProps.css === false) return baseProps;
    const { name: name = "v", type: type, duration: duration, enterFromClass: enterFromClass = `${name}-enter-from`, enterActiveClass: enterActiveClass = `${name}-enter-active`, enterToClass: enterToClass = `${name}-enter-to`, appearFromClass: appearFromClass = enterFromClass, appearActiveClass: appearActiveClass = enterActiveClass, appearToClass: appearToClass = enterToClass, leaveFromClass: leaveFromClass = `${name}-leave-from`, leaveActiveClass: leaveActiveClass = `${name}-leave-active`, leaveToClass: leaveToClass = `${name}-leave-to` } = rawProps;
    const durations = $7c5134c8d276549e$var$normalizeDuration(duration);
    const enterDuration = durations && durations[0];
    const leaveDuration = durations && durations[1];
    const { onBeforeEnter: onBeforeEnter, onEnter: onEnter, onEnterCancelled: onEnterCancelled, onLeave: onLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear = onBeforeEnter, onAppear: onAppear = onEnter, onAppearCancelled: onAppearCancelled = onEnterCancelled } = baseProps;
    const finishEnter = (el, isAppear, done)=>{
        $7c5134c8d276549e$var$removeTransitionClass(el, isAppear ? appearToClass : enterToClass);
        $7c5134c8d276549e$var$removeTransitionClass(el, isAppear ? appearActiveClass : enterActiveClass);
        done && done();
    };
    const finishLeave = (el, done)=>{
        el._isLeaving = false;
        $7c5134c8d276549e$var$removeTransitionClass(el, leaveFromClass);
        $7c5134c8d276549e$var$removeTransitionClass(el, leaveToClass);
        $7c5134c8d276549e$var$removeTransitionClass(el, leaveActiveClass);
        done && done();
    };
    const makeEnterHook = (isAppear)=>{
        return (el, done)=>{
            const hook = isAppear ? onAppear : onEnter;
            const resolve = ()=>finishEnter(el, isAppear, done);
            $7c5134c8d276549e$var$callHook(hook, [
                el,
                resolve
            ]);
            $7c5134c8d276549e$var$nextFrame(()=>{
                $7c5134c8d276549e$var$removeTransitionClass(el, isAppear ? appearFromClass : enterFromClass);
                $7c5134c8d276549e$var$addTransitionClass(el, isAppear ? appearToClass : enterToClass);
                if (!$7c5134c8d276549e$var$hasExplicitCallback(hook)) $7c5134c8d276549e$var$whenTransitionEnds(el, type, enterDuration, resolve);
            });
        };
    };
    return (0, $16Sl1.extend)(baseProps, {
        onBeforeEnter (el) {
            $7c5134c8d276549e$var$callHook(onBeforeEnter, [
                el
            ]);
            $7c5134c8d276549e$var$addTransitionClass(el, enterFromClass);
            $7c5134c8d276549e$var$addTransitionClass(el, enterActiveClass);
        },
        onBeforeAppear (el) {
            $7c5134c8d276549e$var$callHook(onBeforeAppear, [
                el
            ]);
            $7c5134c8d276549e$var$addTransitionClass(el, appearFromClass);
            $7c5134c8d276549e$var$addTransitionClass(el, appearActiveClass);
        },
        onEnter: makeEnterHook(false),
        onAppear: makeEnterHook(true),
        onLeave (el, done) {
            el._isLeaving = true;
            const resolve = ()=>finishLeave(el, done);
            $7c5134c8d276549e$var$addTransitionClass(el, leaveFromClass);
            $7c5134c8d276549e$var$addTransitionClass(el, leaveActiveClass);
            $7c5134c8d276549e$var$forceReflow();
            $7c5134c8d276549e$var$nextFrame(()=>{
                if (!el._isLeaving) return;
                $7c5134c8d276549e$var$removeTransitionClass(el, leaveFromClass);
                $7c5134c8d276549e$var$addTransitionClass(el, leaveToClass);
                if (!$7c5134c8d276549e$var$hasExplicitCallback(onLeave)) $7c5134c8d276549e$var$whenTransitionEnds(el, type, leaveDuration, resolve);
            });
            $7c5134c8d276549e$var$callHook(onLeave, [
                el,
                resolve
            ]);
        },
        onEnterCancelled (el) {
            finishEnter(el, false);
            $7c5134c8d276549e$var$callHook(onEnterCancelled, [
                el
            ]);
        },
        onAppearCancelled (el) {
            finishEnter(el, true);
            $7c5134c8d276549e$var$callHook(onAppearCancelled, [
                el
            ]);
        },
        onLeaveCancelled (el) {
            finishLeave(el);
            $7c5134c8d276549e$var$callHook(onLeaveCancelled, [
                el
            ]);
        }
    });
}
function $7c5134c8d276549e$var$normalizeDuration(duration) {
    if (duration == null) return null;
    else if ((0, $16Sl1.isObject)(duration)) return [
        $7c5134c8d276549e$var$NumberOf(duration.enter),
        $7c5134c8d276549e$var$NumberOf(duration.leave)
    ];
    else {
        const n = $7c5134c8d276549e$var$NumberOf(duration);
        return [
            n,
            n
        ];
    }
}
function $7c5134c8d276549e$var$NumberOf(val) {
    const res = (0, $16Sl1.toNumber)(val);
    return res;
}
function $7c5134c8d276549e$var$addTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.add(c));
    (el[$7c5134c8d276549e$var$vtcKey] || (el[$7c5134c8d276549e$var$vtcKey] = /* @__PURE__ */ new Set())).add(cls);
}
function $7c5134c8d276549e$var$removeTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.remove(c));
    const _vtc = el[$7c5134c8d276549e$var$vtcKey];
    if (_vtc) {
        _vtc.delete(cls);
        if (!_vtc.size) el[$7c5134c8d276549e$var$vtcKey] = void 0;
    }
}
function $7c5134c8d276549e$var$nextFrame(cb) {
    requestAnimationFrame(()=>{
        requestAnimationFrame(cb);
    });
}
let $7c5134c8d276549e$var$endId = 0;
function $7c5134c8d276549e$var$whenTransitionEnds(el, expectedType, explicitTimeout, resolve) {
    const id = el._endId = ++$7c5134c8d276549e$var$endId;
    const resolveIfNotStale = ()=>{
        if (id === el._endId) resolve();
    };
    if (explicitTimeout) return setTimeout(resolveIfNotStale, explicitTimeout);
    const { type: type, timeout: timeout, propCount: propCount } = $7c5134c8d276549e$var$getTransitionInfo(el, expectedType);
    if (!type) return resolve();
    const endEvent = type + "end";
    let ended = 0;
    const end = ()=>{
        el.removeEventListener(endEvent, onEnd);
        resolveIfNotStale();
    };
    const onEnd = (e)=>{
        if (e.target === el && ++ended >= propCount) end();
    };
    setTimeout(()=>{
        if (ended < propCount) end();
    }, timeout + 1);
    el.addEventListener(endEvent, onEnd);
}
function $7c5134c8d276549e$var$getTransitionInfo(el, expectedType) {
    const styles = window.getComputedStyle(el);
    const getStyleProperties = (key)=>(styles[key] || "").split(", ");
    const transitionDelays = getStyleProperties(`${$7c5134c8d276549e$var$TRANSITION}Delay`);
    const transitionDurations = getStyleProperties(`${$7c5134c8d276549e$var$TRANSITION}Duration`);
    const transitionTimeout = $7c5134c8d276549e$var$getTimeout(transitionDelays, transitionDurations);
    const animationDelays = getStyleProperties(`${$7c5134c8d276549e$var$ANIMATION}Delay`);
    const animationDurations = getStyleProperties(`${$7c5134c8d276549e$var$ANIMATION}Duration`);
    const animationTimeout = $7c5134c8d276549e$var$getTimeout(animationDelays, animationDurations);
    let type = null;
    let timeout = 0;
    let propCount = 0;
    if (expectedType === $7c5134c8d276549e$var$TRANSITION) {
        if (transitionTimeout > 0) {
            type = $7c5134c8d276549e$var$TRANSITION;
            timeout = transitionTimeout;
            propCount = transitionDurations.length;
        }
    } else if (expectedType === $7c5134c8d276549e$var$ANIMATION) {
        if (animationTimeout > 0) {
            type = $7c5134c8d276549e$var$ANIMATION;
            timeout = animationTimeout;
            propCount = animationDurations.length;
        }
    } else {
        timeout = Math.max(transitionTimeout, animationTimeout);
        type = timeout > 0 ? transitionTimeout > animationTimeout ? $7c5134c8d276549e$var$TRANSITION : $7c5134c8d276549e$var$ANIMATION : null;
        propCount = type ? type === $7c5134c8d276549e$var$TRANSITION ? transitionDurations.length : animationDurations.length : 0;
    }
    const hasTransform = type === $7c5134c8d276549e$var$TRANSITION && /\b(transform|all)(,|$)/.test(getStyleProperties(`${$7c5134c8d276549e$var$TRANSITION}Property`).toString());
    return {
        type: type,
        timeout: timeout,
        propCount: propCount,
        hasTransform: hasTransform
    };
}
function $7c5134c8d276549e$var$getTimeout(delays, durations) {
    while(delays.length < durations.length)delays = delays.concat(delays);
    return Math.max(...durations.map((d, i)=>$7c5134c8d276549e$var$toMs(d) + $7c5134c8d276549e$var$toMs(delays[i])));
}
function $7c5134c8d276549e$var$toMs(s) {
    if (s === "auto") return 0;
    return Number(s.slice(0, -1).replace(",", ".")) * 1e3;
}
function $7c5134c8d276549e$var$forceReflow() {
    return document.body.offsetHeight;
}
function $7c5134c8d276549e$var$patchClass(el, value, isSVG) {
    const transitionClasses = el[$7c5134c8d276549e$var$vtcKey];
    if (transitionClasses) value = (value ? [
        value,
        ...transitionClasses
    ] : [
        ...transitionClasses
    ]).join(" ");
    if (value == null) el.removeAttribute("class");
    else if (isSVG) el.setAttribute("class", value);
    else el.className = value;
}
const $7c5134c8d276549e$var$vShowOriginalDisplay = Symbol("_vod");
const $7c5134c8d276549e$var$vShowHidden = Symbol("_vsh");
const $7c5134c8d276549e$export$5cb4fcdc6937d7e1 = {
    beforeMount (el, { value: value }, { transition: transition }) {
        el[$7c5134c8d276549e$var$vShowOriginalDisplay] = el.style.display === "none" ? "" : el.style.display;
        if (transition && value) transition.beforeEnter(el);
        else $7c5134c8d276549e$var$setDisplay(el, value);
    },
    mounted (el, { value: value }, { transition: transition }) {
        if (transition && value) transition.enter(el);
    },
    updated (el, { value: value, oldValue: oldValue }, { transition: transition }) {
        if (!value === !oldValue) return;
        if (transition) {
            if (value) {
                transition.beforeEnter(el);
                $7c5134c8d276549e$var$setDisplay(el, true);
                transition.enter(el);
            } else transition.leave(el, ()=>{
                $7c5134c8d276549e$var$setDisplay(el, false);
            });
        } else $7c5134c8d276549e$var$setDisplay(el, value);
    },
    beforeUnmount (el, { value: value }) {
        $7c5134c8d276549e$var$setDisplay(el, value);
    }
};
function $7c5134c8d276549e$var$setDisplay(el, value) {
    el.style.display = value ? el[$7c5134c8d276549e$var$vShowOriginalDisplay] : "none";
    el[$7c5134c8d276549e$var$vShowHidden] = !value;
}
function $7c5134c8d276549e$var$initVShowForSSR() {
    $7c5134c8d276549e$export$5cb4fcdc6937d7e1.getSSRProps = ({ value: value })=>{
        if (!value) return {
            style: {
                display: "none"
            }
        };
    };
}
const $7c5134c8d276549e$var$CSS_VAR_TEXT = Symbol("");
function $7c5134c8d276549e$export$ef28b76f07940108(getter) {
    const instance = (0, $lY371.getCurrentInstance)();
    if (!instance) return;
    const updateTeleports = instance.ut = (vars = getter(instance.proxy))=>{
        Array.from(document.querySelectorAll(`[data-v-owner="${instance.uid}"]`)).forEach((node)=>$7c5134c8d276549e$var$setVarsOnNode(node, vars));
    };
    const setVars = ()=>{
        const vars = getter(instance.proxy);
        $7c5134c8d276549e$var$setVarsOnVNode(instance.subTree, vars);
        updateTeleports(vars);
    };
    (0, $lY371.onMounted)(()=>{
        (0, $lY371.watchPostEffect)(setVars);
        const ob = new MutationObserver(setVars);
        ob.observe(instance.subTree.el.parentNode, {
            childList: true
        });
        (0, $lY371.onUnmounted)(()=>ob.disconnect());
    });
}
function $7c5134c8d276549e$var$setVarsOnVNode(vnode, vars) {
    if (vnode.shapeFlag & 128) {
        const suspense = vnode.suspense;
        vnode = suspense.activeBranch;
        if (suspense.pendingBranch && !suspense.isHydrating) suspense.effects.push(()=>{
            $7c5134c8d276549e$var$setVarsOnVNode(suspense.activeBranch, vars);
        });
    }
    while(vnode.component)vnode = vnode.component.subTree;
    if (vnode.shapeFlag & 1 && vnode.el) $7c5134c8d276549e$var$setVarsOnNode(vnode.el, vars);
    else if (vnode.type === (0, $lY371.Fragment)) vnode.children.forEach((c)=>$7c5134c8d276549e$var$setVarsOnVNode(c, vars));
    else if (vnode.type === (0, $lY371.Static)) {
        let { el: el, anchor: anchor } = vnode;
        while(el){
            $7c5134c8d276549e$var$setVarsOnNode(el, vars);
            if (el === anchor) break;
            el = el.nextSibling;
        }
    }
}
function $7c5134c8d276549e$var$setVarsOnNode(el, vars) {
    if (el.nodeType === 1) {
        const style = el.style;
        let cssText = "";
        for(const key in vars){
            style.setProperty(`--${key}`, vars[key]);
            cssText += `--${key}: ${vars[key]};`;
        }
        style[$7c5134c8d276549e$var$CSS_VAR_TEXT] = cssText;
    }
}
const $7c5134c8d276549e$var$displayRE = /(^|;)\s*display\s*:/;
function $7c5134c8d276549e$var$patchStyle(el, prev, next) {
    const style = el.style;
    const isCssString = (0, $16Sl1.isString)(next);
    let hasControlledDisplay = false;
    if (next && !isCssString) {
        if (prev) {
            if (!(0, $16Sl1.isString)(prev)) {
                for(const key in prev)if (next[key] == null) $7c5134c8d276549e$var$setStyle(style, key, "");
            } else for (const prevStyle of prev.split(";")){
                const key = prevStyle.slice(0, prevStyle.indexOf(":")).trim();
                if (next[key] == null) $7c5134c8d276549e$var$setStyle(style, key, "");
            }
        }
        for(const key in next){
            if (key === "display") hasControlledDisplay = true;
            $7c5134c8d276549e$var$setStyle(style, key, next[key]);
        }
    } else {
        if (isCssString) {
            if (prev !== next) {
                const cssVarText = style[$7c5134c8d276549e$var$CSS_VAR_TEXT];
                if (cssVarText) next += ";" + cssVarText;
                style.cssText = next;
                hasControlledDisplay = $7c5134c8d276549e$var$displayRE.test(next);
            }
        } else if (prev) el.removeAttribute("style");
    }
    if ($7c5134c8d276549e$var$vShowOriginalDisplay in el) {
        el[$7c5134c8d276549e$var$vShowOriginalDisplay] = hasControlledDisplay ? style.display : "";
        if (el[$7c5134c8d276549e$var$vShowHidden]) style.display = "none";
    }
}
const $7c5134c8d276549e$var$semicolonRE = /[^\\];\s*$/;
const $7c5134c8d276549e$var$importantRE = /\s*!important$/;
function $7c5134c8d276549e$var$setStyle(style, name, val) {
    if ((0, $16Sl1.isArray)(val)) val.forEach((v)=>$7c5134c8d276549e$var$setStyle(style, name, v));
    else {
        if (val == null) val = "";
        if (name.startsWith("--")) style.setProperty(name, val);
        else {
            const prefixed = $7c5134c8d276549e$var$autoPrefix(style, name);
            if ($7c5134c8d276549e$var$importantRE.test(val)) style.setProperty((0, $16Sl1.hyphenate)(prefixed), val.replace($7c5134c8d276549e$var$importantRE, ""), "important");
            else style[prefixed] = val;
        }
    }
}
const $7c5134c8d276549e$var$prefixes = [
    "Webkit",
    "Moz",
    "ms"
];
const $7c5134c8d276549e$var$prefixCache = {};
function $7c5134c8d276549e$var$autoPrefix(style, rawName) {
    const cached = $7c5134c8d276549e$var$prefixCache[rawName];
    if (cached) return cached;
    let name = (0, $16Sl1.camelize)(rawName);
    if (name !== "filter" && name in style) return $7c5134c8d276549e$var$prefixCache[rawName] = name;
    name = (0, $16Sl1.capitalize)(name);
    for(let i = 0; i < $7c5134c8d276549e$var$prefixes.length; i++){
        const prefixed = $7c5134c8d276549e$var$prefixes[i] + name;
        if (prefixed in style) return $7c5134c8d276549e$var$prefixCache[rawName] = prefixed;
    }
    return rawName;
}
const $7c5134c8d276549e$var$xlinkNS = "http://www.w3.org/1999/xlink";
function $7c5134c8d276549e$var$patchAttr(el, key, value, isSVG, instance) {
    if (isSVG && key.startsWith("xlink:")) {
        if (value == null) el.removeAttributeNS($7c5134c8d276549e$var$xlinkNS, key.slice(6, key.length));
        else el.setAttributeNS($7c5134c8d276549e$var$xlinkNS, key, value);
    } else {
        const isBoolean = (0, $16Sl1.isSpecialBooleanAttr)(key);
        if (value == null || isBoolean && !(0, $16Sl1.includeBooleanAttr)(value)) el.removeAttribute(key);
        else el.setAttribute(key, isBoolean ? "" : value);
    }
}
function $7c5134c8d276549e$var$patchDOMProp(el, key, value, prevChildren, parentComponent, parentSuspense, unmountChildren) {
    if (key === "innerHTML" || key === "textContent") {
        if (prevChildren) unmountChildren(prevChildren, parentComponent, parentSuspense);
        el[key] = value == null ? "" : value;
        return;
    }
    const tag = el.tagName;
    if (key === "value" && tag !== "PROGRESS" && // custom elements may use _value internally
    !tag.includes("-")) {
        const oldValue = tag === "OPTION" ? el.getAttribute("value") || "" : el.value;
        const newValue = value == null ? "" : value;
        if (oldValue !== newValue || !("_value" in el)) el.value = newValue;
        if (value == null) el.removeAttribute(key);
        el._value = value;
        return;
    }
    let needRemove = false;
    if (value === "" || value == null) {
        const type = typeof el[key];
        if (type === "boolean") value = (0, $16Sl1.includeBooleanAttr)(value);
        else if (value == null && type === "string") {
            value = "";
            needRemove = true;
        } else if (type === "number") {
            value = 0;
            needRemove = true;
        }
    }
    try {
        el[key] = value;
    } catch (e) {}
    needRemove && el.removeAttribute(key);
}
function $7c5134c8d276549e$var$addEventListener(el, event, handler, options) {
    el.addEventListener(event, handler, options);
}
function $7c5134c8d276549e$var$removeEventListener(el, event, handler, options) {
    el.removeEventListener(event, handler, options);
}
const $7c5134c8d276549e$var$veiKey = Symbol("_vei");
function $7c5134c8d276549e$var$patchEvent(el, rawName, prevValue, nextValue, instance = null) {
    const invokers = el[$7c5134c8d276549e$var$veiKey] || (el[$7c5134c8d276549e$var$veiKey] = {});
    const existingInvoker = invokers[rawName];
    if (nextValue && existingInvoker) existingInvoker.value = nextValue;
    else {
        const [name, options] = $7c5134c8d276549e$var$parseName(rawName);
        if (nextValue) {
            const invoker = invokers[rawName] = $7c5134c8d276549e$var$createInvoker(nextValue, instance);
            $7c5134c8d276549e$var$addEventListener(el, name, invoker, options);
        } else if (existingInvoker) {
            $7c5134c8d276549e$var$removeEventListener(el, name, existingInvoker, options);
            invokers[rawName] = void 0;
        }
    }
}
const $7c5134c8d276549e$var$optionsModifierRE = /(?:Once|Passive|Capture)$/;
function $7c5134c8d276549e$var$parseName(name) {
    let options;
    if ($7c5134c8d276549e$var$optionsModifierRE.test(name)) {
        options = {};
        let m;
        while(m = name.match($7c5134c8d276549e$var$optionsModifierRE)){
            name = name.slice(0, name.length - m[0].length);
            options[m[0].toLowerCase()] = true;
        }
    }
    const event = name[2] === ":" ? name.slice(3) : (0, $16Sl1.hyphenate)(name.slice(2));
    return [
        event,
        options
    ];
}
let $7c5134c8d276549e$var$cachedNow = 0;
const $7c5134c8d276549e$var$p = /* @__PURE__ */ Promise.resolve();
const $7c5134c8d276549e$var$getNow = ()=>$7c5134c8d276549e$var$cachedNow || ($7c5134c8d276549e$var$p.then(()=>$7c5134c8d276549e$var$cachedNow = 0), $7c5134c8d276549e$var$cachedNow = Date.now());
function $7c5134c8d276549e$var$createInvoker(initialValue, instance) {
    const invoker = (e)=>{
        if (!e._vts) e._vts = Date.now();
        else if (e._vts <= invoker.attached) return;
        (0, $lY371.callWithAsyncErrorHandling)($7c5134c8d276549e$var$patchStopImmediatePropagation(e, invoker.value), instance, 5, [
            e
        ]);
    };
    invoker.value = initialValue;
    invoker.attached = $7c5134c8d276549e$var$getNow();
    return invoker;
}
function $7c5134c8d276549e$var$sanitizeEventValue(value, propName) {
    if ((0, $16Sl1.isFunction)(value) || (0, $16Sl1.isArray)(value)) return value;
    (0, $lY371.warn)(`Wrong type passed as event handler to ${propName} - did you forget @ or : in front of your prop?
Expected function or array of functions, received type ${typeof value}.`);
    return 0, $16Sl1.NOOP;
}
function $7c5134c8d276549e$var$patchStopImmediatePropagation(e, value) {
    if ((0, $16Sl1.isArray)(value)) {
        const originalStop = e.stopImmediatePropagation;
        e.stopImmediatePropagation = ()=>{
            originalStop.call(e);
            e._stopped = true;
        };
        return value.map((fn)=>(e2)=>!e2._stopped && fn && fn(e2));
    } else return value;
}
const $7c5134c8d276549e$var$isNativeOn = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // lowercase letter
    key.charCodeAt(2) > 96 && key.charCodeAt(2) < 123;
const $7c5134c8d276549e$var$patchProp = (el, key, prevValue, nextValue, namespace, prevChildren, parentComponent, parentSuspense, unmountChildren)=>{
    const isSVG = namespace === "svg";
    if (key === "class") $7c5134c8d276549e$var$patchClass(el, nextValue, isSVG);
    else if (key === "style") $7c5134c8d276549e$var$patchStyle(el, prevValue, nextValue);
    else if ((0, $16Sl1.isOn)(key)) {
        if (!(0, $16Sl1.isModelListener)(key)) $7c5134c8d276549e$var$patchEvent(el, key, prevValue, nextValue, parentComponent);
    } else if (key[0] === "." ? (key = key.slice(1), true) : key[0] === "^" ? (key = key.slice(1), false) : $7c5134c8d276549e$var$shouldSetAsProp(el, key, nextValue, isSVG)) $7c5134c8d276549e$var$patchDOMProp(el, key, nextValue, prevChildren, parentComponent, parentSuspense, unmountChildren);
    else {
        if (key === "true-value") el._trueValue = nextValue;
        else if (key === "false-value") el._falseValue = nextValue;
        $7c5134c8d276549e$var$patchAttr(el, key, nextValue, isSVG);
    }
};
function $7c5134c8d276549e$var$shouldSetAsProp(el, key, value, isSVG) {
    if (isSVG) {
        if (key === "innerHTML" || key === "textContent") return true;
        if (key in el && $7c5134c8d276549e$var$isNativeOn(key) && (0, $16Sl1.isFunction)(value)) return true;
        return false;
    }
    if (key === "spellcheck" || key === "draggable" || key === "translate") return false;
    if (key === "form") return false;
    if (key === "list" && el.tagName === "INPUT") return false;
    if (key === "type" && el.tagName === "TEXTAREA") return false;
    if (key === "width" || key === "height") {
        const tag = el.tagName;
        if (tag === "IMG" || tag === "VIDEO" || tag === "CANVAS" || tag === "SOURCE") return false;
    }
    if ($7c5134c8d276549e$var$isNativeOn(key) && (0, $16Sl1.isString)(value)) return false;
    return key in el;
}
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $7c5134c8d276549e$export$a00e2346eabbdbef(options, hydrate2) {
    const Comp = (0, $lY371.defineComponent)(options);
    class VueCustomElement extends $7c5134c8d276549e$export$b337c1a55163dbe3 {
        constructor(initialProps){
            super(Comp, initialProps, hydrate2);
        }
    }
    VueCustomElement.def = Comp;
    return VueCustomElement;
}
/*! #__NO_SIDE_EFFECTS__ */ const $7c5134c8d276549e$export$6debb2e68f212638 = /* @__NO_SIDE_EFFECTS__ */ (options)=>{
    return /* @__PURE__ */ $7c5134c8d276549e$export$a00e2346eabbdbef(options, $7c5134c8d276549e$export$fa8d919ba61d84db);
};
const $7c5134c8d276549e$var$BaseClass = typeof HTMLElement !== "undefined" ? HTMLElement : class {
};
class $7c5134c8d276549e$export$b337c1a55163dbe3 extends $7c5134c8d276549e$var$BaseClass {
    constructor(_def, _props = {}, hydrate2){
        super();
        this._def = _def;
        this._props = _props;
        /**
     * @internal
     */ this._instance = null;
        this._connected = false;
        this._resolved = false;
        this._numberProps = null;
        this._ob = null;
        if (this.shadowRoot && hydrate2) hydrate2(this._createVNode(), this.shadowRoot);
        else {
            this.attachShadow({
                mode: "open"
            });
            if (!this._def.__asyncLoader) this._resolveProps(this._def);
        }
    }
    connectedCallback() {
        this._connected = true;
        if (!this._instance) {
            if (this._resolved) this._update();
            else this._resolveDef();
        }
    }
    disconnectedCallback() {
        this._connected = false;
        if (this._ob) {
            this._ob.disconnect();
            this._ob = null;
        }
        (0, $lY371.nextTick)(()=>{
            if (!this._connected) {
                $7c5134c8d276549e$export$b3890eb0ae9dca99(null, this.shadowRoot);
                this._instance = null;
            }
        });
    }
    /**
   * resolve inner component definition (handle possible async component)
   */ _resolveDef() {
        this._resolved = true;
        for(let i = 0; i < this.attributes.length; i++)this._setAttr(this.attributes[i].name);
        this._ob = new MutationObserver((mutations)=>{
            for (const m of mutations)this._setAttr(m.attributeName);
        });
        this._ob.observe(this, {
            attributes: true
        });
        const resolve = (def, isAsync = false)=>{
            const { props: props, styles: styles } = def;
            let numberProps;
            if (props && !(0, $16Sl1.isArray)(props)) for(const key in props){
                const opt = props[key];
                if (opt === Number || opt && opt.type === Number) {
                    if (key in this._props) this._props[key] = (0, $16Sl1.toNumber)(this._props[key]);
                    (numberProps || (numberProps = /* @__PURE__ */ Object.create(null)))[(0, $16Sl1.camelize)(key)] = true;
                }
            }
            this._numberProps = numberProps;
            if (isAsync) this._resolveProps(def);
            this._applyStyles(styles);
            this._update();
        };
        const asyncDef = this._def.__asyncLoader;
        if (asyncDef) asyncDef().then((def)=>resolve(def, true));
        else resolve(this._def);
    }
    _resolveProps(def) {
        const { props: props } = def;
        const declaredPropKeys = (0, $16Sl1.isArray)(props) ? props : Object.keys(props || {});
        for (const key of Object.keys(this))if (key[0] !== "_" && declaredPropKeys.includes(key)) this._setProp(key, this[key], true, false);
        for (const key of declaredPropKeys.map((0, $16Sl1.camelize)))Object.defineProperty(this, key, {
            get () {
                return this._getProp(key);
            },
            set (val) {
                this._setProp(key, val);
            }
        });
    }
    _setAttr(key) {
        let value = this.hasAttribute(key) ? this.getAttribute(key) : void 0;
        const camelKey = (0, $16Sl1.camelize)(key);
        if (this._numberProps && this._numberProps[camelKey]) value = (0, $16Sl1.toNumber)(value);
        this._setProp(camelKey, value, false);
    }
    /**
   * @internal
   */ _getProp(key) {
        return this._props[key];
    }
    /**
   * @internal
   */ _setProp(key, val, shouldReflect = true, shouldUpdate = true) {
        if (val !== this._props[key]) {
            this._props[key] = val;
            if (shouldUpdate && this._instance) this._update();
            if (shouldReflect) {
                if (val === true) this.setAttribute((0, $16Sl1.hyphenate)(key), "");
                else if (typeof val === "string" || typeof val === "number") this.setAttribute((0, $16Sl1.hyphenate)(key), val + "");
                else if (!val) this.removeAttribute((0, $16Sl1.hyphenate)(key));
            }
        }
    }
    _update() {
        $7c5134c8d276549e$export$b3890eb0ae9dca99(this._createVNode(), this.shadowRoot);
    }
    _createVNode() {
        const vnode = (0, $lY371.createVNode)(this._def, (0, $16Sl1.extend)({}, this._props));
        if (!this._instance) vnode.ce = (instance)=>{
            this._instance = instance;
            instance.isCE = true;
            var newStyles, s;
            const dispatch = (event, args)=>{
                this.dispatchEvent(new CustomEvent(event, {
                    detail: args
                }));
            };
            instance.emit = (event, ...args)=>{
                dispatch(event, args);
                if ((0, $16Sl1.hyphenate)(event) !== event) dispatch((0, $16Sl1.hyphenate)(event), args);
            };
            let parent = this;
            while(parent = parent && (parent.parentNode || parent.host))if (parent instanceof $7c5134c8d276549e$export$b337c1a55163dbe3) {
                instance.parent = parent._instance;
                instance.provides = parent._instance.provides;
                break;
            }
        };
        return vnode;
    }
    _applyStyles(styles) {
        if (styles) styles.forEach((css)=>{
            const s = document.createElement("style");
            s.textContent = css;
            this.shadowRoot.appendChild(s);
        });
    }
}
function $7c5134c8d276549e$export$9300d5b90d56e3d1(name = "$style") {
    {
        const instance = (0, $lY371.getCurrentInstance)();
        if (!instance) return 0, $16Sl1.EMPTY_OBJ;
        const modules = instance.type.__cssModules;
        if (!modules) return 0, $16Sl1.EMPTY_OBJ;
        const mod = modules[name];
        if (!mod) return 0, $16Sl1.EMPTY_OBJ;
        return mod;
    }
}
const $7c5134c8d276549e$var$positionMap = /* @__PURE__ */ new WeakMap();
const $7c5134c8d276549e$var$newPositionMap = /* @__PURE__ */ new WeakMap();
const $7c5134c8d276549e$var$moveCbKey = Symbol("_moveCb");
const $7c5134c8d276549e$var$enterCbKey = Symbol("_enterCb");
const $7c5134c8d276549e$var$TransitionGroupImpl = {
    name: "TransitionGroup",
    props: /* @__PURE__ */ (0, $16Sl1.extend)({}, $7c5134c8d276549e$var$TransitionPropsValidators, {
        tag: String,
        moveClass: String
    }),
    setup (props, { slots: slots }) {
        const instance = (0, $lY371.getCurrentInstance)();
        const state = (0, $lY371.useTransitionState)();
        let prevChildren;
        let children;
        (0, $lY371.onUpdated)(()=>{
            if (!prevChildren.length) return;
            const moveClass = props.moveClass || `${props.name || "v"}-move`;
            if (!$7c5134c8d276549e$var$hasCSSTransform(prevChildren[0].el, instance.vnode.el, moveClass)) return;
            prevChildren.forEach($7c5134c8d276549e$var$callPendingCbs);
            prevChildren.forEach($7c5134c8d276549e$var$recordPosition);
            const movedChildren = prevChildren.filter($7c5134c8d276549e$var$applyTranslation);
            $7c5134c8d276549e$var$forceReflow();
            movedChildren.forEach((c)=>{
                const el = c.el;
                const style = el.style;
                $7c5134c8d276549e$var$addTransitionClass(el, moveClass);
                style.transform = style.webkitTransform = style.transitionDuration = "";
                const cb = el[$7c5134c8d276549e$var$moveCbKey] = (e)=>{
                    if (e && e.target !== el) return;
                    if (!e || /transform$/.test(e.propertyName)) {
                        el.removeEventListener("transitionend", cb);
                        el[$7c5134c8d276549e$var$moveCbKey] = null;
                        $7c5134c8d276549e$var$removeTransitionClass(el, moveClass);
                    }
                };
                el.addEventListener("transitionend", cb);
            });
        });
        return ()=>{
            const rawProps = (0, $99kuS.toRaw)(props);
            const cssTransitionProps = $7c5134c8d276549e$var$resolveTransitionProps(rawProps);
            let tag = rawProps.tag || (0, $lY371.Fragment);
            prevChildren = [];
            if (children) for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.el && child.el instanceof Element) {
                    prevChildren.push(child);
                    (0, $lY371.setTransitionHooks)(child, (0, $lY371.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
                    $7c5134c8d276549e$var$positionMap.set(child, child.el.getBoundingClientRect());
                }
            }
            children = slots.default ? (0, $lY371.getTransitionRawChildren)(slots.default()) : [];
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.key != null) (0, $lY371.setTransitionHooks)(child, (0, $lY371.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
            }
            return (0, $lY371.createVNode)(tag, null, children);
        };
    }
};
const $7c5134c8d276549e$var$removeMode = (props)=>delete props.mode;
/* @__PURE__ */ $7c5134c8d276549e$var$removeMode($7c5134c8d276549e$var$TransitionGroupImpl.props);
const $7c5134c8d276549e$export$19ffa8f511f7bc2e = $7c5134c8d276549e$var$TransitionGroupImpl;
function $7c5134c8d276549e$var$callPendingCbs(c) {
    const el = c.el;
    if (el[$7c5134c8d276549e$var$moveCbKey]) el[$7c5134c8d276549e$var$moveCbKey]();
    if (el[$7c5134c8d276549e$var$enterCbKey]) el[$7c5134c8d276549e$var$enterCbKey]();
}
function $7c5134c8d276549e$var$recordPosition(c) {
    $7c5134c8d276549e$var$newPositionMap.set(c, c.el.getBoundingClientRect());
}
function $7c5134c8d276549e$var$applyTranslation(c) {
    const oldPos = $7c5134c8d276549e$var$positionMap.get(c);
    const newPos = $7c5134c8d276549e$var$newPositionMap.get(c);
    const dx = oldPos.left - newPos.left;
    const dy = oldPos.top - newPos.top;
    if (dx || dy) {
        const s = c.el.style;
        s.transform = s.webkitTransform = `translate(${dx}px,${dy}px)`;
        s.transitionDuration = "0s";
        return c;
    }
}
function $7c5134c8d276549e$var$hasCSSTransform(el, root, moveClass) {
    const clone = el.cloneNode();
    const _vtc = el[$7c5134c8d276549e$var$vtcKey];
    if (_vtc) _vtc.forEach((cls)=>{
        cls.split(/\s+/).forEach((c)=>c && clone.classList.remove(c));
    });
    moveClass.split(/\s+/).forEach((c)=>c && clone.classList.add(c));
    clone.style.display = "none";
    const container = root.nodeType === 1 ? root : root.parentNode;
    container.appendChild(clone);
    const { hasTransform: hasTransform } = $7c5134c8d276549e$var$getTransitionInfo(clone);
    container.removeChild(clone);
    return hasTransform;
}
const $7c5134c8d276549e$var$getModelAssigner = (vnode)=>{
    const fn = vnode.props["onUpdate:modelValue"] || false;
    return (0, $16Sl1.isArray)(fn) ? (value)=>(0, $16Sl1.invokeArrayFns)(fn, value) : fn;
};
function $7c5134c8d276549e$var$onCompositionStart(e) {
    e.target.composing = true;
}
function $7c5134c8d276549e$var$onCompositionEnd(e) {
    const target = e.target;
    if (target.composing) {
        target.composing = false;
        target.dispatchEvent(new Event("input"));
    }
}
const $7c5134c8d276549e$var$assignKey = Symbol("_assign");
const $7c5134c8d276549e$export$f1f88689f5728478 = {
    created (el, { modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el[$7c5134c8d276549e$var$assignKey] = $7c5134c8d276549e$var$getModelAssigner(vnode);
        const castToNumber = number || vnode.props && vnode.props.type === "number";
        $7c5134c8d276549e$var$addEventListener(el, lazy ? "change" : "input", (e)=>{
            if (e.target.composing) return;
            let domValue = el.value;
            if (trim) domValue = domValue.trim();
            if (castToNumber) domValue = (0, $16Sl1.looseToNumber)(domValue);
            el[$7c5134c8d276549e$var$assignKey](domValue);
        });
        if (trim) $7c5134c8d276549e$var$addEventListener(el, "change", ()=>{
            el.value = el.value.trim();
        });
        if (!lazy) {
            $7c5134c8d276549e$var$addEventListener(el, "compositionstart", $7c5134c8d276549e$var$onCompositionStart);
            $7c5134c8d276549e$var$addEventListener(el, "compositionend", $7c5134c8d276549e$var$onCompositionEnd);
            $7c5134c8d276549e$var$addEventListener(el, "change", $7c5134c8d276549e$var$onCompositionEnd);
        }
    },
    // set value on mounted so it's after min/max for type="range"
    mounted (el, { value: value }) {
        el.value = value == null ? "" : value;
    },
    beforeUpdate (el, { value: value, modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el[$7c5134c8d276549e$var$assignKey] = $7c5134c8d276549e$var$getModelAssigner(vnode);
        if (el.composing) return;
        const elValue = (number || el.type === "number") && !/^0\d/.test(el.value) ? (0, $16Sl1.looseToNumber)(el.value) : el.value;
        const newValue = value == null ? "" : value;
        if (elValue === newValue) return;
        if (document.activeElement === el && el.type !== "range") {
            if (lazy) return;
            if (trim && el.value.trim() === newValue) return;
        }
        el.value = newValue;
    }
};
const $7c5134c8d276549e$export$8847c2e532b35714 = {
    // #4096 array checkboxes need to be deep traversed
    deep: true,
    created (el, _, vnode) {
        el[$7c5134c8d276549e$var$assignKey] = $7c5134c8d276549e$var$getModelAssigner(vnode);
        $7c5134c8d276549e$var$addEventListener(el, "change", ()=>{
            const modelValue = el._modelValue;
            const elementValue = $7c5134c8d276549e$var$getValue(el);
            const checked = el.checked;
            const assign = el[$7c5134c8d276549e$var$assignKey];
            if ((0, $16Sl1.isArray)(modelValue)) {
                const index = (0, $16Sl1.looseIndexOf)(modelValue, elementValue);
                const found = index !== -1;
                if (checked && !found) assign(modelValue.concat(elementValue));
                else if (!checked && found) {
                    const filtered = [
                        ...modelValue
                    ];
                    filtered.splice(index, 1);
                    assign(filtered);
                }
            } else if ((0, $16Sl1.isSet)(modelValue)) {
                const cloned = new Set(modelValue);
                if (checked) cloned.add(elementValue);
                else cloned.delete(elementValue);
                assign(cloned);
            } else assign($7c5134c8d276549e$var$getCheckboxValue(el, checked));
        });
    },
    // set initial checked on mount to wait for true-value/false-value
    mounted: $7c5134c8d276549e$var$setChecked,
    beforeUpdate (el, binding, vnode) {
        el[$7c5134c8d276549e$var$assignKey] = $7c5134c8d276549e$var$getModelAssigner(vnode);
        $7c5134c8d276549e$var$setChecked(el, binding, vnode);
    }
};
function $7c5134c8d276549e$var$setChecked(el, { value: value, oldValue: oldValue }, vnode) {
    el._modelValue = value;
    if ((0, $16Sl1.isArray)(value)) el.checked = (0, $16Sl1.looseIndexOf)(value, vnode.props.value) > -1;
    else if ((0, $16Sl1.isSet)(value)) el.checked = value.has(vnode.props.value);
    else if (value !== oldValue) el.checked = (0, $16Sl1.looseEqual)(value, $7c5134c8d276549e$var$getCheckboxValue(el, true));
}
const $7c5134c8d276549e$export$b4356c59b38b7aa9 = {
    created (el, { value: value }, vnode) {
        el.checked = (0, $16Sl1.looseEqual)(value, vnode.props.value);
        el[$7c5134c8d276549e$var$assignKey] = $7c5134c8d276549e$var$getModelAssigner(vnode);
        $7c5134c8d276549e$var$addEventListener(el, "change", ()=>{
            el[$7c5134c8d276549e$var$assignKey]($7c5134c8d276549e$var$getValue(el));
        });
    },
    beforeUpdate (el, { value: value, oldValue: oldValue }, vnode) {
        el[$7c5134c8d276549e$var$assignKey] = $7c5134c8d276549e$var$getModelAssigner(vnode);
        if (value !== oldValue) el.checked = (0, $16Sl1.looseEqual)(value, vnode.props.value);
    }
};
const $7c5134c8d276549e$export$87d227567b51ca39 = {
    // <select multiple> value need to be deep traversed
    deep: true,
    created (el, { value: value, modifiers: { number: number } }, vnode) {
        const isSetModel = (0, $16Sl1.isSet)(value);
        $7c5134c8d276549e$var$addEventListener(el, "change", ()=>{
            const selectedVal = Array.prototype.filter.call(el.options, (o)=>o.selected).map((o)=>number ? (0, $16Sl1.looseToNumber)($7c5134c8d276549e$var$getValue(o)) : $7c5134c8d276549e$var$getValue(o));
            el[$7c5134c8d276549e$var$assignKey](el.multiple ? isSetModel ? new Set(selectedVal) : selectedVal : selectedVal[0]);
            el._assigning = true;
            (0, $lY371.nextTick)(()=>{
                el._assigning = false;
            });
        });
        el[$7c5134c8d276549e$var$assignKey] = $7c5134c8d276549e$var$getModelAssigner(vnode);
    },
    // set value in mounted & updated because <select> relies on its children
    // <option>s.
    mounted (el, { value: value, modifiers: { number: number } }) {
        $7c5134c8d276549e$var$setSelected(el, value);
    },
    beforeUpdate (el, _binding, vnode) {
        el[$7c5134c8d276549e$var$assignKey] = $7c5134c8d276549e$var$getModelAssigner(vnode);
    },
    updated (el, { value: value, modifiers: { number: number } }) {
        if (!el._assigning) $7c5134c8d276549e$var$setSelected(el, value);
    }
};
function $7c5134c8d276549e$var$setSelected(el, value, number) {
    const isMultiple = el.multiple;
    const isArrayValue = (0, $16Sl1.isArray)(value);
    if (isMultiple && !isArrayValue && !(0, $16Sl1.isSet)(value)) return;
    for(let i = 0, l = el.options.length; i < l; i++){
        const option = el.options[i];
        const optionValue = $7c5134c8d276549e$var$getValue(option);
        if (isMultiple) {
            if (isArrayValue) {
                const optionType = typeof optionValue;
                if (optionType === "string" || optionType === "number") option.selected = value.some((v)=>String(v) === String(optionValue));
                else option.selected = (0, $16Sl1.looseIndexOf)(value, optionValue) > -1;
            } else option.selected = value.has(optionValue);
        } else if ((0, $16Sl1.looseEqual)($7c5134c8d276549e$var$getValue(option), value)) {
            if (el.selectedIndex !== i) el.selectedIndex = i;
            return;
        }
    }
    if (!isMultiple && el.selectedIndex !== -1) el.selectedIndex = -1;
}
function $7c5134c8d276549e$var$getValue(el) {
    return "_value" in el ? el._value : el.value;
}
function $7c5134c8d276549e$var$getCheckboxValue(el, checked) {
    const key = checked ? "_trueValue" : "_falseValue";
    return key in el ? el[key] : checked;
}
const $7c5134c8d276549e$export$5ad5c0e01ff62c5 = {
    created (el, binding, vnode) {
        $7c5134c8d276549e$var$callModelHook(el, binding, vnode, null, "created");
    },
    mounted (el, binding, vnode) {
        $7c5134c8d276549e$var$callModelHook(el, binding, vnode, null, "mounted");
    },
    beforeUpdate (el, binding, vnode, prevVNode) {
        $7c5134c8d276549e$var$callModelHook(el, binding, vnode, prevVNode, "beforeUpdate");
    },
    updated (el, binding, vnode, prevVNode) {
        $7c5134c8d276549e$var$callModelHook(el, binding, vnode, prevVNode, "updated");
    }
};
function $7c5134c8d276549e$var$resolveDynamicModel(tagName, type) {
    switch(tagName){
        case "SELECT":
            return $7c5134c8d276549e$export$87d227567b51ca39;
        case "TEXTAREA":
            return $7c5134c8d276549e$export$f1f88689f5728478;
        default:
            switch(type){
                case "checkbox":
                    return $7c5134c8d276549e$export$8847c2e532b35714;
                case "radio":
                    return $7c5134c8d276549e$export$b4356c59b38b7aa9;
                default:
                    return $7c5134c8d276549e$export$f1f88689f5728478;
            }
    }
}
function $7c5134c8d276549e$var$callModelHook(el, binding, vnode, prevVNode, hook) {
    const modelToUse = $7c5134c8d276549e$var$resolveDynamicModel(el.tagName, vnode.props && vnode.props.type);
    const fn = modelToUse[hook];
    fn && fn(el, binding, vnode, prevVNode);
}
function $7c5134c8d276549e$var$initVModelForSSR() {
    $7c5134c8d276549e$export$f1f88689f5728478.getSSRProps = ({ value: value })=>({
            value: value
        });
    $7c5134c8d276549e$export$b4356c59b38b7aa9.getSSRProps = ({ value: value }, vnode)=>{
        if (vnode.props && (0, $16Sl1.looseEqual)(vnode.props.value, value)) return {
            checked: true
        };
    };
    $7c5134c8d276549e$export$8847c2e532b35714.getSSRProps = ({ value: value }, vnode)=>{
        if ((0, $16Sl1.isArray)(value)) {
            if (vnode.props && (0, $16Sl1.looseIndexOf)(value, vnode.props.value) > -1) return {
                checked: true
            };
        } else if ((0, $16Sl1.isSet)(value)) {
            if (vnode.props && value.has(vnode.props.value)) return {
                checked: true
            };
        } else if (value) return {
            checked: true
        };
    };
    $7c5134c8d276549e$export$5ad5c0e01ff62c5.getSSRProps = (binding, vnode)=>{
        if (typeof vnode.type !== "string") return;
        const modelToUse = $7c5134c8d276549e$var$resolveDynamicModel(// resolveDynamicModel expects an uppercase tag name, but vnode.type is lowercase
        vnode.type.toUpperCase(), vnode.props && vnode.props.type);
        if (modelToUse.getSSRProps) return modelToUse.getSSRProps(binding, vnode);
    };
}
const $7c5134c8d276549e$var$systemModifiers = [
    "ctrl",
    "shift",
    "alt",
    "meta"
];
const $7c5134c8d276549e$var$modifierGuards = {
    stop: (e)=>e.stopPropagation(),
    prevent: (e)=>e.preventDefault(),
    self: (e)=>e.target !== e.currentTarget,
    ctrl: (e)=>!e.ctrlKey,
    shift: (e)=>!e.shiftKey,
    alt: (e)=>!e.altKey,
    meta: (e)=>!e.metaKey,
    left: (e)=>"button" in e && e.button !== 0,
    middle: (e)=>"button" in e && e.button !== 1,
    right: (e)=>"button" in e && e.button !== 2,
    exact: (e, modifiers)=>$7c5134c8d276549e$var$systemModifiers.some((m)=>e[`${m}Key`] && !modifiers.includes(m))
};
const $7c5134c8d276549e$export$26bd3b8e29e6f273 = (fn, modifiers)=>{
    const cache = fn._withMods || (fn._withMods = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event, ...args)=>{
        for(let i = 0; i < modifiers.length; i++){
            const guard = $7c5134c8d276549e$var$modifierGuards[modifiers[i]];
            if (guard && guard(event, modifiers)) return;
        }
        return fn(event, ...args);
    });
};
const $7c5134c8d276549e$var$keyNames = {
    esc: "escape",
    space: " ",
    up: "arrow-up",
    left: "arrow-left",
    right: "arrow-right",
    down: "arrow-down",
    delete: "backspace"
};
const $7c5134c8d276549e$export$f691a8759658f782 = (fn, modifiers)=>{
    const cache = fn._withKeys || (fn._withKeys = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event)=>{
        if (!("key" in event)) return;
        const eventKey = (0, $16Sl1.hyphenate)(event.key);
        if (modifiers.some((k)=>k === eventKey || $7c5134c8d276549e$var$keyNames[k] === eventKey)) return fn(event);
    });
};
const $7c5134c8d276549e$var$rendererOptions = /* @__PURE__ */ (0, $16Sl1.extend)({
    patchProp: $7c5134c8d276549e$var$patchProp
}, $7c5134c8d276549e$var$nodeOps);
let $7c5134c8d276549e$var$renderer;
let $7c5134c8d276549e$var$enabledHydration = false;
function $7c5134c8d276549e$var$ensureRenderer() {
    return $7c5134c8d276549e$var$renderer || ($7c5134c8d276549e$var$renderer = (0, $lY371.createRenderer)($7c5134c8d276549e$var$rendererOptions));
}
function $7c5134c8d276549e$var$ensureHydrationRenderer() {
    $7c5134c8d276549e$var$renderer = $7c5134c8d276549e$var$enabledHydration ? $7c5134c8d276549e$var$renderer : (0, $lY371.createHydrationRenderer)($7c5134c8d276549e$var$rendererOptions);
    $7c5134c8d276549e$var$enabledHydration = true;
    return $7c5134c8d276549e$var$renderer;
}
const $7c5134c8d276549e$export$b3890eb0ae9dca99 = (...args)=>{
    $7c5134c8d276549e$var$ensureRenderer().render(...args);
};
const $7c5134c8d276549e$export$fa8d919ba61d84db = (...args)=>{
    $7c5134c8d276549e$var$ensureHydrationRenderer().hydrate(...args);
};
const $7c5134c8d276549e$export$4e373c34abfa8c68 = (...args)=>{
    const app = $7c5134c8d276549e$var$ensureRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $7c5134c8d276549e$var$normalizeContainer(containerOrSelector);
        if (!container) return;
        const component = app._component;
        if (!(0, $16Sl1.isFunction)(component) && !component.render && !component.template) component.template = container.innerHTML;
        container.innerHTML = "";
        const proxy = mount(container, false, $7c5134c8d276549e$var$resolveRootNamespace(container));
        if (container instanceof Element) {
            container.removeAttribute("v-cloak");
            container.setAttribute("data-v-app", "");
        }
        return proxy;
    };
    return app;
};
const $7c5134c8d276549e$export$35800275c0037383 = (...args)=>{
    const app = $7c5134c8d276549e$var$ensureHydrationRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $7c5134c8d276549e$var$normalizeContainer(containerOrSelector);
        if (container) return mount(container, true, $7c5134c8d276549e$var$resolveRootNamespace(container));
    };
    return app;
};
function $7c5134c8d276549e$var$resolveRootNamespace(container) {
    if (container instanceof SVGElement) return "svg";
    if (typeof MathMLElement === "function" && container instanceof MathMLElement) return "mathml";
}
function $7c5134c8d276549e$var$injectNativeTagCheck(app) {
    Object.defineProperty(app.config, "isNativeTag", {
        value: (tag)=>(0, $16Sl1.isHTMLTag)(tag) || (0, $16Sl1.isSVGTag)(tag) || (0, $16Sl1.isMathMLTag)(tag),
        writable: false
    });
}
function $7c5134c8d276549e$var$injectCompilerOptionsCheck(app) {
    if ((0, $lY371.isRuntimeOnly)()) {
        const isCustomElement = app.config.isCustomElement;
        Object.defineProperty(app.config, "isCustomElement", {
            get () {
                return isCustomElement;
            },
            set () {
                (0, $lY371.warn)(`The \`isCustomElement\` config option is deprecated. Use \`compilerOptions.isCustomElement\` instead.`);
            }
        });
        const compilerOptions = app.config.compilerOptions;
        const msg = `The \`compilerOptions\` config option is only respected when using a build of Vue.js that includes the runtime compiler (aka "full build"). Since you are using the runtime-only build, \`compilerOptions\` must be passed to \`@vue/compiler-dom\` in the build setup instead.
- For vue-loader: pass it via vue-loader's \`compilerOptions\` loader option.
- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader
- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite-plugin-vue/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-sfc`;
        Object.defineProperty(app.config, "compilerOptions", {
            get () {
                (0, $lY371.warn)(msg);
                return compilerOptions;
            },
            set () {
                (0, $lY371.warn)(msg);
            }
        });
    }
}
function $7c5134c8d276549e$var$normalizeContainer(container) {
    if ((0, $16Sl1.isString)(container)) {
        const res = document.querySelector(container);
        return res;
    }
    return container;
}
let $7c5134c8d276549e$var$ssrDirectiveInitialized = false;
const $7c5134c8d276549e$export$800b28255aa678d9 = ()=>{
    if (!$7c5134c8d276549e$var$ssrDirectiveInitialized) {
        $7c5134c8d276549e$var$ssrDirectiveInitialized = true;
        $7c5134c8d276549e$var$initVModelForSSR();
        $7c5134c8d276549e$var$initVShowForSSR();
    }
};

});
parcelRegister("lY371", function(module, exports) {

$parcel$export(module.exports, "callWithAsyncErrorHandling", function () { return $ffe19d932e7e7bce$export$dae85862a8d94378; });
$parcel$export(module.exports, "nextTick", function () { return $ffe19d932e7e7bce$export$bdd553fddd433dcb; });
$parcel$export(module.exports, "Fragment", function () { return $ffe19d932e7e7bce$export$ffb0004e005737fa; });
$parcel$export(module.exports, "Static", function () { return $ffe19d932e7e7bce$export$c1b9a1d3af45b7b6; });
$parcel$export(module.exports, "createVNode", function () { return $ffe19d932e7e7bce$export$bf5c4cf060303d58; });
$parcel$export(module.exports, "openBlock", function () { return $ffe19d932e7e7bce$export$e7eaa45e502fe5cc; });
$parcel$export(module.exports, "watchPostEffect", function () { return $ffe19d932e7e7bce$export$b7f27ea67102d543; });
$parcel$export(module.exports, "withDirectives", function () { return $ffe19d932e7e7bce$export$49729353e7c1e6c5; });
$parcel$export(module.exports, "useTransitionState", function () { return $ffe19d932e7e7bce$export$d2a0a1bc267c90f6; });
$parcel$export(module.exports, "onMounted", function () { return $ffe19d932e7e7bce$export$6d1641039221b5cb; });
$parcel$export(module.exports, "BaseTransitionPropsValidators", function () { return $ffe19d932e7e7bce$export$b876c99684f8cf3b; });
$parcel$export(module.exports, "getCurrentInstance", function () { return $ffe19d932e7e7bce$export$f13e630aa3915748; });
$parcel$export(module.exports, "getTransitionRawChildren", function () { return $ffe19d932e7e7bce$export$a67f9b1229c7c97a; });
$parcel$export(module.exports, "resolveTransitionHooks", function () { return $ffe19d932e7e7bce$export$76ac1779589cd824; });
$parcel$export(module.exports, "setTransitionHooks", function () { return $ffe19d932e7e7bce$export$7770a22486565649; });
$parcel$export(module.exports, "BaseTransition", function () { return $ffe19d932e7e7bce$export$abd95b5f5e8a8837; });
$parcel$export(module.exports, "defineComponent", function () { return $ffe19d932e7e7bce$export$afa64b67e5a01c3b; });
$parcel$export(module.exports, "onUpdated", function () { return $ffe19d932e7e7bce$export$5876c47052fb88b1; });
$parcel$export(module.exports, "onUnmounted", function () { return $ffe19d932e7e7bce$export$13348a43ccacfe58; });
$parcel$export(module.exports, "renderList", function () { return $ffe19d932e7e7bce$export$4bf387f59bfc6d67; });
$parcel$export(module.exports, "createRenderer", function () { return $ffe19d932e7e7bce$export$53ae2f996c64e9a; });
$parcel$export(module.exports, "createHydrationRenderer", function () { return $ffe19d932e7e7bce$export$200524cf0d997ff0; });
$parcel$export(module.exports, "createElementBlock", function () { return $ffe19d932e7e7bce$export$167055419fc69ec1; });
$parcel$export(module.exports, "createElementVNode", function () { return $ffe19d932e7e7bce$export$42098e0eaa15c48e; });
$parcel$export(module.exports, "createCommentVNode", function () { return $ffe19d932e7e7bce$export$49553837c7236d3c; });
$parcel$export(module.exports, "isRuntimeOnly", function () { return $ffe19d932e7e7bce$export$c93a9c496c5211fa; });
$parcel$export(module.exports, "h", function () { return $ffe19d932e7e7bce$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "initCustomFormatter", function () { return $ffe19d932e7e7bce$export$aed4979be6a60047; });
$parcel$export(module.exports, "warn", function () { return $ffe19d932e7e7bce$export$c106dd0671a0fc2d; });
$parcel$export(module.exports, "toRaw", function () { return (parcelRequire("99kuS")).toRaw; });
$parcel$export(module.exports, "camelize", function () { return (parcelRequire("16Sl1")).camelize; });
/**
* @vue/runtime-core v3.4.25
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $99kuS = parcelRequire("99kuS");

var $16Sl1 = parcelRequire("16Sl1");
const $ffe19d932e7e7bce$var$stack = [];
function $ffe19d932e7e7bce$var$pushWarningContext(vnode) {
    $ffe19d932e7e7bce$var$stack.push(vnode);
}
function $ffe19d932e7e7bce$var$popWarningContext() {
    $ffe19d932e7e7bce$var$stack.pop();
}
function $ffe19d932e7e7bce$var$warn$1(msg, ...args) {
    (0, $99kuS.pauseTracking)();
    const instance = $ffe19d932e7e7bce$var$stack.length ? $ffe19d932e7e7bce$var$stack[$ffe19d932e7e7bce$var$stack.length - 1].component : null;
    const appWarnHandler = instance && instance.appContext.config.warnHandler;
    const trace = $ffe19d932e7e7bce$var$getComponentTrace();
    if (appWarnHandler) $ffe19d932e7e7bce$export$b22fcaf88446e9bf(appWarnHandler, instance, 11, [
        msg + args.map((a)=>{
            var _a, _b;
            return (_b = (_a = a.toString) == null ? void 0 : _a.call(a)) != null ? _b : JSON.stringify(a);
        }).join(""),
        instance && instance.proxy,
        trace.map(({ vnode: vnode })=>`at <${$ffe19d932e7e7bce$var$formatComponentName(instance, vnode.type)}>`).join("\n"),
        trace
    ]);
    else {
        const warnArgs = [
            `[Vue warn]: ${msg}`,
            ...args
        ];
        if (trace.length && // avoid spamming console during tests
        true) warnArgs.push(`
`, ...$ffe19d932e7e7bce$var$formatTrace(trace));
        console.warn(...warnArgs);
    }
    (0, $99kuS.resetTracking)();
}
function $ffe19d932e7e7bce$var$getComponentTrace() {
    let currentVNode = $ffe19d932e7e7bce$var$stack[$ffe19d932e7e7bce$var$stack.length - 1];
    if (!currentVNode) return [];
    const normalizedStack = [];
    while(currentVNode){
        const last = normalizedStack[0];
        if (last && last.vnode === currentVNode) last.recurseCount++;
        else normalizedStack.push({
            vnode: currentVNode,
            recurseCount: 0
        });
        const parentInstance = currentVNode.component && currentVNode.component.parent;
        currentVNode = parentInstance && parentInstance.vnode;
    }
    return normalizedStack;
}
function $ffe19d932e7e7bce$var$formatTrace(trace) {
    const logs = [];
    trace.forEach((entry, i)=>{
        logs.push(...i === 0 ? [] : [
            `
`
        ], ...$ffe19d932e7e7bce$var$formatTraceEntry(entry));
    });
    return logs;
}
function $ffe19d932e7e7bce$var$formatTraceEntry({ vnode: vnode, recurseCount: recurseCount }) {
    const postfix = recurseCount > 0 ? `... (${recurseCount} recursive calls)` : ``;
    const isRoot = vnode.component ? vnode.component.parent == null : false;
    const open = ` at <${$ffe19d932e7e7bce$var$formatComponentName(vnode.component, vnode.type, isRoot)}`;
    const close = `>` + postfix;
    return vnode.props ? [
        open,
        ...$ffe19d932e7e7bce$var$formatProps(vnode.props),
        close
    ] : [
        open + close
    ];
}
function $ffe19d932e7e7bce$var$formatProps(props) {
    const res = [];
    const keys = Object.keys(props);
    keys.slice(0, 3).forEach((key)=>{
        res.push(...$ffe19d932e7e7bce$var$formatProp(key, props[key]));
    });
    if (keys.length > 3) res.push(` ...`);
    return res;
}
function $ffe19d932e7e7bce$var$formatProp(key, value, raw) {
    if ((0, $16Sl1.isString)(value)) {
        value = JSON.stringify(value);
        return raw ? value : [
            `${key}=${value}`
        ];
    } else if (typeof value === "number" || typeof value === "boolean" || value == null) return raw ? value : [
        `${key}=${value}`
    ];
    else if ((0, $99kuS.isRef)(value)) {
        value = $ffe19d932e7e7bce$var$formatProp(key, (0, $99kuS.toRaw)(value.value), true);
        return raw ? value : [
            `${key}=Ref<`,
            value,
            `>`
        ];
    } else if ((0, $16Sl1.isFunction)(value)) return [
        `${key}=fn${value.name ? `<${value.name}>` : ``}`
    ];
    else {
        value = (0, $99kuS.toRaw)(value);
        return raw ? value : [
            `${key}=`,
            value
        ];
    }
}
function $ffe19d932e7e7bce$export$dfbcecb440255e4a(val, type) {
    return;
}
const $ffe19d932e7e7bce$export$10e8e1cf990558d7 = {
    "SETUP_FUNCTION": 0,
    "0": "SETUP_FUNCTION",
    "RENDER_FUNCTION": 1,
    "1": "RENDER_FUNCTION",
    "WATCH_GETTER": 2,
    "2": "WATCH_GETTER",
    "WATCH_CALLBACK": 3,
    "3": "WATCH_CALLBACK",
    "WATCH_CLEANUP": 4,
    "4": "WATCH_CLEANUP",
    "NATIVE_EVENT_HANDLER": 5,
    "5": "NATIVE_EVENT_HANDLER",
    "COMPONENT_EVENT_HANDLER": 6,
    "6": "COMPONENT_EVENT_HANDLER",
    "VNODE_HOOK": 7,
    "7": "VNODE_HOOK",
    "DIRECTIVE_HOOK": 8,
    "8": "DIRECTIVE_HOOK",
    "TRANSITION_HOOK": 9,
    "9": "TRANSITION_HOOK",
    "APP_ERROR_HANDLER": 10,
    "10": "APP_ERROR_HANDLER",
    "APP_WARN_HANDLER": 11,
    "11": "APP_WARN_HANDLER",
    "FUNCTION_REF": 12,
    "12": "FUNCTION_REF",
    "ASYNC_COMPONENT_LOADER": 13,
    "13": "ASYNC_COMPONENT_LOADER",
    "SCHEDULER": 14,
    "14": "SCHEDULER"
};
const $ffe19d932e7e7bce$var$ErrorTypeStrings$1 = {
    ["sp"]: "serverPrefetch hook",
    ["bc"]: "beforeCreate hook",
    ["c"]: "created hook",
    ["bm"]: "beforeMount hook",
    ["m"]: "mounted hook",
    ["bu"]: "beforeUpdate hook",
    ["u"]: "updated",
    ["bum"]: "beforeUnmount hook",
    ["um"]: "unmounted hook",
    ["a"]: "activated hook",
    ["da"]: "deactivated hook",
    ["ec"]: "errorCaptured hook",
    ["rtc"]: "renderTracked hook",
    ["rtg"]: "renderTriggered hook",
    [0]: "setup function",
    [1]: "render function",
    [2]: "watcher getter",
    [3]: "watcher callback",
    [4]: "watcher cleanup function",
    [5]: "native event handler",
    [6]: "component event handler",
    [7]: "vnode hook",
    [8]: "directive hook",
    [9]: "transition hook",
    [10]: "app errorHandler",
    [11]: "app warnHandler",
    [12]: "ref function",
    [13]: "async component loader",
    [14]: "scheduler flush. This is likely a Vue internals bug. Please open an issue at https://github.com/vuejs/core ."
};
function $ffe19d932e7e7bce$export$b22fcaf88446e9bf(fn, instance, type, args) {
    try {
        return args ? fn(...args) : fn();
    } catch (err) {
        $ffe19d932e7e7bce$export$d3da1ecaf1206c58(err, instance, type);
    }
}
function $ffe19d932e7e7bce$export$dae85862a8d94378(fn, instance, type, args) {
    if ((0, $16Sl1.isFunction)(fn)) {
        const res = $ffe19d932e7e7bce$export$b22fcaf88446e9bf(fn, instance, type, args);
        if (res && (0, $16Sl1.isPromise)(res)) res.catch((err)=>{
            $ffe19d932e7e7bce$export$d3da1ecaf1206c58(err, instance, type);
        });
        return res;
    }
    if ((0, $16Sl1.isArray)(fn)) {
        const values = [];
        for(let i = 0; i < fn.length; i++)values.push($ffe19d932e7e7bce$export$dae85862a8d94378(fn[i], instance, type, args));
        return values;
    }
}
function $ffe19d932e7e7bce$export$d3da1ecaf1206c58(err, instance, type, throwInDev = true) {
    const contextVNode = instance ? instance.vnode : null;
    if (instance) {
        let cur = instance.parent;
        const exposedInstance = instance.proxy;
        const errorInfo = `https://vuejs.org/error-reference/#runtime-${type}`;
        while(cur){
            const errorCapturedHooks = cur.ec;
            if (errorCapturedHooks) for(let i = 0; i < errorCapturedHooks.length; i++){
                if (errorCapturedHooks[i](err, exposedInstance, errorInfo) === false) return;
            }
            cur = cur.parent;
        }
        const appErrorHandler = instance.appContext.config.errorHandler;
        if (appErrorHandler) {
            (0, $99kuS.pauseTracking)();
            $ffe19d932e7e7bce$export$b22fcaf88446e9bf(appErrorHandler, null, 10, [
                err,
                exposedInstance,
                errorInfo
            ]);
            (0, $99kuS.resetTracking)();
            return;
        }
    }
    $ffe19d932e7e7bce$var$logError(err, type, contextVNode, throwInDev);
}
function $ffe19d932e7e7bce$var$logError(err, type, contextVNode, throwInDev = true) {
    console.error(err);
}
let $ffe19d932e7e7bce$var$isFlushing = false;
let $ffe19d932e7e7bce$var$isFlushPending = false;
const $ffe19d932e7e7bce$var$queue = [];
let $ffe19d932e7e7bce$var$flushIndex = 0;
const $ffe19d932e7e7bce$var$pendingPostFlushCbs = [];
let $ffe19d932e7e7bce$var$activePostFlushCbs = null;
let $ffe19d932e7e7bce$var$postFlushIndex = 0;
const $ffe19d932e7e7bce$var$resolvedPromise = /* @__PURE__ */ Promise.resolve();
let $ffe19d932e7e7bce$var$currentFlushPromise = null;
const $ffe19d932e7e7bce$var$RECURSION_LIMIT = 100;
function $ffe19d932e7e7bce$export$bdd553fddd433dcb(fn) {
    const p = $ffe19d932e7e7bce$var$currentFlushPromise || $ffe19d932e7e7bce$var$resolvedPromise;
    return fn ? p.then(this ? fn.bind(this) : fn) : p;
}
function $ffe19d932e7e7bce$var$findInsertionIndex(id) {
    let start = $ffe19d932e7e7bce$var$flushIndex + 1;
    let end = $ffe19d932e7e7bce$var$queue.length;
    while(start < end){
        const middle = start + end >>> 1;
        const middleJob = $ffe19d932e7e7bce$var$queue[middle];
        const middleJobId = $ffe19d932e7e7bce$var$getId(middleJob);
        if (middleJobId < id || middleJobId === id && middleJob.pre) start = middle + 1;
        else end = middle;
    }
    return start;
}
function $ffe19d932e7e7bce$var$queueJob(job) {
    if (!$ffe19d932e7e7bce$var$queue.length || !$ffe19d932e7e7bce$var$queue.includes(job, $ffe19d932e7e7bce$var$isFlushing && job.allowRecurse ? $ffe19d932e7e7bce$var$flushIndex + 1 : $ffe19d932e7e7bce$var$flushIndex)) {
        if (job.id == null) $ffe19d932e7e7bce$var$queue.push(job);
        else $ffe19d932e7e7bce$var$queue.splice($ffe19d932e7e7bce$var$findInsertionIndex(job.id), 0, job);
        $ffe19d932e7e7bce$var$queueFlush();
    }
}
function $ffe19d932e7e7bce$var$queueFlush() {
    if (!$ffe19d932e7e7bce$var$isFlushing && !$ffe19d932e7e7bce$var$isFlushPending) {
        $ffe19d932e7e7bce$var$isFlushPending = true;
        $ffe19d932e7e7bce$var$currentFlushPromise = $ffe19d932e7e7bce$var$resolvedPromise.then($ffe19d932e7e7bce$var$flushJobs);
    }
}
function $ffe19d932e7e7bce$var$invalidateJob(job) {
    const i = $ffe19d932e7e7bce$var$queue.indexOf(job);
    if (i > $ffe19d932e7e7bce$var$flushIndex) $ffe19d932e7e7bce$var$queue.splice(i, 1);
}
function $ffe19d932e7e7bce$export$59536a0199721cab(cb) {
    if (!(0, $16Sl1.isArray)(cb)) {
        if (!$ffe19d932e7e7bce$var$activePostFlushCbs || !$ffe19d932e7e7bce$var$activePostFlushCbs.includes(cb, cb.allowRecurse ? $ffe19d932e7e7bce$var$postFlushIndex + 1 : $ffe19d932e7e7bce$var$postFlushIndex)) $ffe19d932e7e7bce$var$pendingPostFlushCbs.push(cb);
    } else $ffe19d932e7e7bce$var$pendingPostFlushCbs.push(...cb);
    $ffe19d932e7e7bce$var$queueFlush();
}
function $ffe19d932e7e7bce$var$flushPreFlushCbs(instance, seen, i = $ffe19d932e7e7bce$var$isFlushing ? $ffe19d932e7e7bce$var$flushIndex + 1 : 0) {
    for(; i < $ffe19d932e7e7bce$var$queue.length; i++){
        const cb = $ffe19d932e7e7bce$var$queue[i];
        if (cb && cb.pre) {
            if (instance && cb.id !== instance.uid) continue;
            $ffe19d932e7e7bce$var$queue.splice(i, 1);
            i--;
            cb();
        }
    }
}
function $ffe19d932e7e7bce$var$flushPostFlushCbs(seen) {
    if ($ffe19d932e7e7bce$var$pendingPostFlushCbs.length) {
        const deduped = [
            ...new Set($ffe19d932e7e7bce$var$pendingPostFlushCbs)
        ].sort((a, b)=>$ffe19d932e7e7bce$var$getId(a) - $ffe19d932e7e7bce$var$getId(b));
        $ffe19d932e7e7bce$var$pendingPostFlushCbs.length = 0;
        if ($ffe19d932e7e7bce$var$activePostFlushCbs) {
            $ffe19d932e7e7bce$var$activePostFlushCbs.push(...deduped);
            return;
        }
        $ffe19d932e7e7bce$var$activePostFlushCbs = deduped;
        for($ffe19d932e7e7bce$var$postFlushIndex = 0; $ffe19d932e7e7bce$var$postFlushIndex < $ffe19d932e7e7bce$var$activePostFlushCbs.length; $ffe19d932e7e7bce$var$postFlushIndex++)$ffe19d932e7e7bce$var$activePostFlushCbs[$ffe19d932e7e7bce$var$postFlushIndex]();
        $ffe19d932e7e7bce$var$activePostFlushCbs = null;
        $ffe19d932e7e7bce$var$postFlushIndex = 0;
    }
}
const $ffe19d932e7e7bce$var$getId = (job)=>job.id == null ? Infinity : job.id;
const $ffe19d932e7e7bce$var$comparator = (a, b)=>{
    const diff = $ffe19d932e7e7bce$var$getId(a) - $ffe19d932e7e7bce$var$getId(b);
    if (diff === 0) {
        if (a.pre && !b.pre) return -1;
        if (b.pre && !a.pre) return 1;
    }
    return diff;
};
function $ffe19d932e7e7bce$var$flushJobs(seen) {
    $ffe19d932e7e7bce$var$isFlushPending = false;
    $ffe19d932e7e7bce$var$isFlushing = true;
    $ffe19d932e7e7bce$var$queue.sort($ffe19d932e7e7bce$var$comparator);
    const check = (0, $16Sl1.NOOP);
    try {
        for($ffe19d932e7e7bce$var$flushIndex = 0; $ffe19d932e7e7bce$var$flushIndex < $ffe19d932e7e7bce$var$queue.length; $ffe19d932e7e7bce$var$flushIndex++){
            const job = $ffe19d932e7e7bce$var$queue[$ffe19d932e7e7bce$var$flushIndex];
            if (job && job.active !== false) $ffe19d932e7e7bce$export$b22fcaf88446e9bf(job, null, 14);
        }
    } finally{
        $ffe19d932e7e7bce$var$flushIndex = 0;
        $ffe19d932e7e7bce$var$queue.length = 0;
        $ffe19d932e7e7bce$var$flushPostFlushCbs(seen);
        $ffe19d932e7e7bce$var$isFlushing = false;
        $ffe19d932e7e7bce$var$currentFlushPromise = null;
        if ($ffe19d932e7e7bce$var$queue.length || $ffe19d932e7e7bce$var$pendingPostFlushCbs.length) $ffe19d932e7e7bce$var$flushJobs(seen);
    }
}
function $ffe19d932e7e7bce$var$checkRecursiveUpdates(seen, fn) {
    if (!seen.has(fn)) seen.set(fn, 1);
    else {
        const count = seen.get(fn);
        if (count > $ffe19d932e7e7bce$var$RECURSION_LIMIT) {
            const instance = fn.ownerInstance;
            const componentName = instance && $ffe19d932e7e7bce$var$getComponentName(instance.type);
            $ffe19d932e7e7bce$export$d3da1ecaf1206c58(`Maximum recursive updates exceeded${componentName ? ` in component <${componentName}>` : ``}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`, null, 10);
            return true;
        } else seen.set(fn, count + 1);
    }
}
let $ffe19d932e7e7bce$var$isHmrUpdating = false;
const $ffe19d932e7e7bce$var$hmrDirtyComponents = /* @__PURE__ */ new Set();
const $ffe19d932e7e7bce$var$map = /* @__PURE__ */ new Map();
function $ffe19d932e7e7bce$var$registerHMR(instance) {
    const id = instance.type.__hmrId;
    let record = $ffe19d932e7e7bce$var$map.get(id);
    if (!record) {
        $ffe19d932e7e7bce$var$createRecord(id, instance.type);
        record = $ffe19d932e7e7bce$var$map.get(id);
    }
    record.instances.add(instance);
}
function $ffe19d932e7e7bce$var$unregisterHMR(instance) {
    $ffe19d932e7e7bce$var$map.get(instance.type.__hmrId).instances.delete(instance);
}
function $ffe19d932e7e7bce$var$createRecord(id, initialDef) {
    if ($ffe19d932e7e7bce$var$map.has(id)) return false;
    $ffe19d932e7e7bce$var$map.set(id, {
        initialDef: $ffe19d932e7e7bce$var$normalizeClassComponent(initialDef),
        instances: /* @__PURE__ */ new Set()
    });
    return true;
}
function $ffe19d932e7e7bce$var$normalizeClassComponent(component) {
    return $ffe19d932e7e7bce$var$isClassComponent(component) ? component.__vccOpts : component;
}
function $ffe19d932e7e7bce$var$rerender(id, newRender) {
    const record = $ffe19d932e7e7bce$var$map.get(id);
    if (!record) return;
    record.initialDef.render = newRender;
    [
        ...record.instances
    ].forEach((instance)=>{
        if (newRender) {
            instance.render = newRender;
            $ffe19d932e7e7bce$var$normalizeClassComponent(instance.type).render = newRender;
        }
        instance.renderCache = [];
        $ffe19d932e7e7bce$var$isHmrUpdating = true;
        instance.effect.dirty = true;
        instance.update();
        $ffe19d932e7e7bce$var$isHmrUpdating = false;
    });
}
function $ffe19d932e7e7bce$var$reload(id, newComp) {
    const record = $ffe19d932e7e7bce$var$map.get(id);
    if (!record) return;
    newComp = $ffe19d932e7e7bce$var$normalizeClassComponent(newComp);
    $ffe19d932e7e7bce$var$updateComponentDef(record.initialDef, newComp);
    const instances = [
        ...record.instances
    ];
    for (const instance of instances){
        const oldComp = $ffe19d932e7e7bce$var$normalizeClassComponent(instance.type);
        if (!$ffe19d932e7e7bce$var$hmrDirtyComponents.has(oldComp)) {
            if (oldComp !== record.initialDef) $ffe19d932e7e7bce$var$updateComponentDef(oldComp, newComp);
            $ffe19d932e7e7bce$var$hmrDirtyComponents.add(oldComp);
        }
        instance.appContext.propsCache.delete(instance.type);
        instance.appContext.emitsCache.delete(instance.type);
        instance.appContext.optionsCache.delete(instance.type);
        if (instance.ceReload) {
            $ffe19d932e7e7bce$var$hmrDirtyComponents.add(oldComp);
            instance.ceReload(newComp.styles);
            $ffe19d932e7e7bce$var$hmrDirtyComponents.delete(oldComp);
        } else if (instance.parent) {
            instance.parent.effect.dirty = true;
            $ffe19d932e7e7bce$var$queueJob(instance.parent.update);
        } else if (instance.appContext.reload) instance.appContext.reload();
        else if (typeof window !== "undefined") window.location.reload();
        else console.warn("[HMR] Root or manually mounted instance modified. Full reload required.");
    }
    $ffe19d932e7e7bce$export$59536a0199721cab(()=>{
        for (const instance of instances)$ffe19d932e7e7bce$var$hmrDirtyComponents.delete($ffe19d932e7e7bce$var$normalizeClassComponent(instance.type));
    });
}
function $ffe19d932e7e7bce$var$updateComponentDef(oldComp, newComp) {
    (0, $16Sl1.extend)(oldComp, newComp);
    for(const key in oldComp)if (key !== "__file" && !(key in newComp)) delete oldComp[key];
}
function $ffe19d932e7e7bce$var$tryWrap(fn) {
    return (id, arg)=>{
        try {
            return fn(id, arg);
        } catch (e) {
            console.error(e);
            console.warn(`[HMR] Something went wrong during Vue component hot-reload. Full reload required.`);
        }
    };
}
let $ffe19d932e7e7bce$var$devtools$1;
let $ffe19d932e7e7bce$var$buffer = [];
let $ffe19d932e7e7bce$var$devtoolsNotInstalled = false;
function $ffe19d932e7e7bce$var$emit$1(event, ...args) {
    if ($ffe19d932e7e7bce$var$devtools$1) $ffe19d932e7e7bce$var$devtools$1.emit(event, ...args);
    else if (!$ffe19d932e7e7bce$var$devtoolsNotInstalled) $ffe19d932e7e7bce$var$buffer.push({
        event: event,
        args: args
    });
}
function $ffe19d932e7e7bce$var$setDevtoolsHook$1(hook, target) {
    var _a, _b;
    $ffe19d932e7e7bce$var$devtools$1 = hook;
    if ($ffe19d932e7e7bce$var$devtools$1) {
        $ffe19d932e7e7bce$var$devtools$1.enabled = true;
        $ffe19d932e7e7bce$var$buffer.forEach(({ event: event, args: args })=>$ffe19d932e7e7bce$var$devtools$1.emit(event, ...args));
        $ffe19d932e7e7bce$var$buffer = [];
    } else if (// handle late devtools injection - only do this if we are in an actual
    // browser environment to avoid the timer handle stalling test runner exit
    // (#4815)
    typeof window !== "undefined" && // some envs mock window but not fully
    window.HTMLElement && // also exclude jsdom
    !((_b = (_a = window.navigator) == null ? void 0 : _a.userAgent) == null ? void 0 : _b.includes("jsdom"))) {
        const replay = target.__VUE_DEVTOOLS_HOOK_REPLAY__ = target.__VUE_DEVTOOLS_HOOK_REPLAY__ || [];
        replay.push((newHook)=>{
            $ffe19d932e7e7bce$var$setDevtoolsHook$1(newHook, target);
        });
        setTimeout(()=>{
            if (!$ffe19d932e7e7bce$var$devtools$1) {
                target.__VUE_DEVTOOLS_HOOK_REPLAY__ = null;
                $ffe19d932e7e7bce$var$devtoolsNotInstalled = true;
                $ffe19d932e7e7bce$var$buffer = [];
            }
        }, 3e3);
    } else {
        $ffe19d932e7e7bce$var$devtoolsNotInstalled = true;
        $ffe19d932e7e7bce$var$buffer = [];
    }
}
function $ffe19d932e7e7bce$var$devtoolsInitApp(app, version) {
    $ffe19d932e7e7bce$var$emit$1("app:init" /* APP_INIT */ , app, version, {
        Fragment: $ffe19d932e7e7bce$export$ffb0004e005737fa,
        Text: $ffe19d932e7e7bce$export$5f1af8db9871e1d6,
        Comment: $ffe19d932e7e7bce$export$4d299b491347818a,
        Static: $ffe19d932e7e7bce$export$c1b9a1d3af45b7b6
    });
}
function $ffe19d932e7e7bce$var$devtoolsUnmountApp(app) {
    $ffe19d932e7e7bce$var$emit$1("app:unmount" /* APP_UNMOUNT */ , app);
}
const $ffe19d932e7e7bce$var$devtoolsComponentAdded = /* @__PURE__ */ $ffe19d932e7e7bce$var$createDevtoolsComponentHook("component:added" /* COMPONENT_ADDED */ );
const $ffe19d932e7e7bce$var$devtoolsComponentUpdated = /* @__PURE__ */ $ffe19d932e7e7bce$var$createDevtoolsComponentHook("component:updated" /* COMPONENT_UPDATED */ );
const $ffe19d932e7e7bce$var$_devtoolsComponentRemoved = /* @__PURE__ */ $ffe19d932e7e7bce$var$createDevtoolsComponentHook("component:removed" /* COMPONENT_REMOVED */ );
const $ffe19d932e7e7bce$var$devtoolsComponentRemoved = (component)=>{
    if ($ffe19d932e7e7bce$var$devtools$1 && typeof $ffe19d932e7e7bce$var$devtools$1.cleanupBuffer === "function" && // remove the component if it wasn't buffered
    !$ffe19d932e7e7bce$var$devtools$1.cleanupBuffer(component)) $ffe19d932e7e7bce$var$_devtoolsComponentRemoved(component);
};
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $ffe19d932e7e7bce$var$createDevtoolsComponentHook(hook) {
    return (component)=>{
        $ffe19d932e7e7bce$var$emit$1(hook, component.appContext.app, component.uid, component.parent ? component.parent.uid : void 0, component);
    };
}
const $ffe19d932e7e7bce$var$devtoolsPerfStart = /* @__PURE__ */ $ffe19d932e7e7bce$var$createDevtoolsPerformanceHook("perf:start" /* PERFORMANCE_START */ );
const $ffe19d932e7e7bce$var$devtoolsPerfEnd = /* @__PURE__ */ $ffe19d932e7e7bce$var$createDevtoolsPerformanceHook("perf:end" /* PERFORMANCE_END */ );
function $ffe19d932e7e7bce$var$createDevtoolsPerformanceHook(hook) {
    return (component, type, time)=>{
        $ffe19d932e7e7bce$var$emit$1(hook, component.appContext.app, component.uid, component, type, time);
    };
}
function $ffe19d932e7e7bce$var$devtoolsComponentEmit(component, event, params) {
    $ffe19d932e7e7bce$var$emit$1("component:emit" /* COMPONENT_EMIT */ , component.appContext.app, component, event, params);
}
function $ffe19d932e7e7bce$var$emit(instance, event, ...rawArgs) {
    if (instance.isUnmounted) return;
    const props = instance.vnode.props || (0, $16Sl1.EMPTY_OBJ);
    let args = rawArgs;
    const isModelListener = event.startsWith("update:");
    const modelArg = isModelListener && event.slice(7);
    if (modelArg && modelArg in props) {
        const modifiersKey = `${modelArg === "modelValue" ? "model" : modelArg}Modifiers`;
        const { number: number, trim: trim } = props[modifiersKey] || (0, $16Sl1.EMPTY_OBJ);
        if (trim) args = rawArgs.map((a)=>(0, $16Sl1.isString)(a) ? a.trim() : a);
        if (number) args = rawArgs.map((0, $16Sl1.looseToNumber));
    }
    if (__VUE_PROD_DEVTOOLS__) $ffe19d932e7e7bce$var$devtoolsComponentEmit(instance, event, args);
    let handlerName;
    let handler = props[handlerName = (0, $16Sl1.toHandlerKey)(event)] || // also try camelCase event handler (#2249)
    props[handlerName = (0, $16Sl1.toHandlerKey)((0, $16Sl1.camelize)(event))];
    if (!handler && isModelListener) handler = props[handlerName = (0, $16Sl1.toHandlerKey)((0, $16Sl1.hyphenate)(event))];
    if (handler) $ffe19d932e7e7bce$export$dae85862a8d94378(handler, instance, 6, args);
    const onceHandler = props[handlerName + `Once`];
    if (onceHandler) {
        if (!instance.emitted) instance.emitted = {};
        else if (instance.emitted[handlerName]) return;
        instance.emitted[handlerName] = true;
        $ffe19d932e7e7bce$export$dae85862a8d94378(onceHandler, instance, 6, args);
    }
}
function $ffe19d932e7e7bce$var$normalizeEmitsOptions(comp, appContext, asMixin = false) {
    const cache = appContext.emitsCache;
    const cached = cache.get(comp);
    if (cached !== void 0) return cached;
    const raw = comp.emits;
    let normalized = {};
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $16Sl1.isFunction)(comp)) {
        const extendEmits = (raw2)=>{
            const normalizedFromExtend = $ffe19d932e7e7bce$var$normalizeEmitsOptions(raw2, appContext, true);
            if (normalizedFromExtend) {
                hasExtends = true;
                (0, $16Sl1.extend)(normalized, normalizedFromExtend);
            }
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendEmits);
        if (comp.extends) extendEmits(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendEmits);
    }
    if (!raw && !hasExtends) {
        if ((0, $16Sl1.isObject)(comp)) cache.set(comp, null);
        return null;
    }
    if ((0, $16Sl1.isArray)(raw)) raw.forEach((key)=>normalized[key] = null);
    else (0, $16Sl1.extend)(normalized, raw);
    if ((0, $16Sl1.isObject)(comp)) cache.set(comp, normalized);
    return normalized;
}
function $ffe19d932e7e7bce$var$isEmitListener(options, key) {
    if (!options || !(0, $16Sl1.isOn)(key)) return false;
    key = key.slice(2).replace(/Once$/, "");
    return (0, $16Sl1.hasOwn)(options, key[0].toLowerCase() + key.slice(1)) || (0, $16Sl1.hasOwn)(options, (0, $16Sl1.hyphenate)(key)) || (0, $16Sl1.hasOwn)(options, key);
}
let $ffe19d932e7e7bce$var$currentRenderingInstance = null;
let $ffe19d932e7e7bce$var$currentScopeId = null;
function $ffe19d932e7e7bce$var$setCurrentRenderingInstance(instance) {
    const prev = $ffe19d932e7e7bce$var$currentRenderingInstance;
    $ffe19d932e7e7bce$var$currentRenderingInstance = instance;
    $ffe19d932e7e7bce$var$currentScopeId = instance && instance.type.__scopeId || null;
    return prev;
}
function $ffe19d932e7e7bce$export$ac020265ca2cc4cd(id) {
    $ffe19d932e7e7bce$var$currentScopeId = id;
}
function $ffe19d932e7e7bce$export$f2dc6805dc11834e() {
    $ffe19d932e7e7bce$var$currentScopeId = null;
}
const $ffe19d932e7e7bce$export$15ba313e13f3dd04 = (_id)=>$ffe19d932e7e7bce$export$694b237e827a3d23;
function $ffe19d932e7e7bce$export$694b237e827a3d23(fn, ctx = $ffe19d932e7e7bce$var$currentRenderingInstance, isNonScopedSlot) {
    if (!ctx) return fn;
    if (fn._n) return fn;
    const renderFnWithContext = (...args)=>{
        if (renderFnWithContext._d) $ffe19d932e7e7bce$export$c20bee82f26f1e27(-1);
        const prevInstance = $ffe19d932e7e7bce$var$setCurrentRenderingInstance(ctx);
        let res;
        try {
            res = fn(...args);
        } finally{
            $ffe19d932e7e7bce$var$setCurrentRenderingInstance(prevInstance);
            if (renderFnWithContext._d) $ffe19d932e7e7bce$export$c20bee82f26f1e27(1);
        }
        if (__VUE_PROD_DEVTOOLS__) $ffe19d932e7e7bce$var$devtoolsComponentUpdated(ctx);
        return res;
    };
    renderFnWithContext._n = true;
    renderFnWithContext._c = true;
    renderFnWithContext._d = true;
    return renderFnWithContext;
}
let $ffe19d932e7e7bce$var$accessedAttrs = false;
function $ffe19d932e7e7bce$var$markAttrsAccessed() {
    $ffe19d932e7e7bce$var$accessedAttrs = true;
}
function $ffe19d932e7e7bce$var$renderComponentRoot(instance) {
    const { type: Component, vnode: vnode, proxy: proxy, withProxy: withProxy, propsOptions: [propsOptions], slots: slots, attrs: attrs, emit: emit, render: render, renderCache: renderCache, props: props, data: data, setupState: setupState, ctx: ctx, inheritAttrs: inheritAttrs } = instance;
    const prev = $ffe19d932e7e7bce$var$setCurrentRenderingInstance(instance);
    let result;
    let fallthroughAttrs;
    try {
        if (vnode.shapeFlag & 4) {
            const proxyToUse = withProxy || proxy;
            const thisProxy = proxyToUse;
            result = $ffe19d932e7e7bce$var$normalizeVNode(render.call(thisProxy, proxyToUse, renderCache, props, setupState, data, ctx));
            fallthroughAttrs = attrs;
        } else {
            const render2 = Component;
            result = $ffe19d932e7e7bce$var$normalizeVNode(render2.length > 1 ? render2(props, {
                attrs: attrs,
                slots: slots,
                emit: emit
            }) : render2(props, null));
            fallthroughAttrs = Component.props ? attrs : $ffe19d932e7e7bce$var$getFunctionalFallthrough(attrs);
        }
    } catch (err) {
        $ffe19d932e7e7bce$var$blockStack.length = 0;
        $ffe19d932e7e7bce$export$d3da1ecaf1206c58(err, instance, 1);
        result = $ffe19d932e7e7bce$export$bf5c4cf060303d58($ffe19d932e7e7bce$export$4d299b491347818a);
    }
    let root = result;
    let setRoot = void 0;
    if (fallthroughAttrs && inheritAttrs !== false) {
        const keys = Object.keys(fallthroughAttrs);
        const { shapeFlag: shapeFlag } = root;
        if (keys.length) {
            if (shapeFlag & 7) {
                if (propsOptions && keys.some((0, $16Sl1.isModelListener))) fallthroughAttrs = $ffe19d932e7e7bce$var$filterModelListeners(fallthroughAttrs, propsOptions);
                root = $ffe19d932e7e7bce$export$ee4f9e12c0a92a1a(root, fallthroughAttrs);
            }
        }
    }
    if (vnode.dirs) {
        root = $ffe19d932e7e7bce$export$ee4f9e12c0a92a1a(root);
        root.dirs = root.dirs ? root.dirs.concat(vnode.dirs) : vnode.dirs;
    }
    if (vnode.transition) root.transition = vnode.transition;
    result = root;
    $ffe19d932e7e7bce$var$setCurrentRenderingInstance(prev);
    return result;
}
const $ffe19d932e7e7bce$var$getChildRoot = (vnode)=>{
    const rawChildren = vnode.children;
    const dynamicChildren = vnode.dynamicChildren;
    const childRoot = $ffe19d932e7e7bce$var$filterSingleRoot(rawChildren, false);
    if (!childRoot) return [
        vnode,
        void 0
    ];
    const index = rawChildren.indexOf(childRoot);
    const dynamicIndex = dynamicChildren ? dynamicChildren.indexOf(childRoot) : -1;
    const setRoot = (updatedRoot)=>{
        rawChildren[index] = updatedRoot;
        if (dynamicChildren) {
            if (dynamicIndex > -1) dynamicChildren[dynamicIndex] = updatedRoot;
            else if (updatedRoot.patchFlag > 0) vnode.dynamicChildren = [
                ...dynamicChildren,
                updatedRoot
            ];
        }
    };
    return [
        $ffe19d932e7e7bce$var$normalizeVNode(childRoot),
        setRoot
    ];
};
function $ffe19d932e7e7bce$var$filterSingleRoot(children, recurse = true) {
    let singleRoot;
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        if ($ffe19d932e7e7bce$export$3868d13f8734ae81(child)) {
            if (child.type !== $ffe19d932e7e7bce$export$4d299b491347818a || child.children === "v-if") {
                if (singleRoot) return;
                else singleRoot = child;
            }
        } else return;
    }
    return singleRoot;
}
const $ffe19d932e7e7bce$var$getFunctionalFallthrough = (attrs)=>{
    let res;
    for(const key in attrs)if (key === "class" || key === "style" || (0, $16Sl1.isOn)(key)) (res || (res = {}))[key] = attrs[key];
    return res;
};
const $ffe19d932e7e7bce$var$filterModelListeners = (attrs, props)=>{
    const res = {};
    for(const key in attrs)if (!(0, $16Sl1.isModelListener)(key) || !(key.slice(9) in props)) res[key] = attrs[key];
    return res;
};
const $ffe19d932e7e7bce$var$isElementRoot = (vnode)=>{
    return vnode.shapeFlag & 7 || vnode.type === $ffe19d932e7e7bce$export$4d299b491347818a;
};
function $ffe19d932e7e7bce$var$shouldUpdateComponent(prevVNode, nextVNode, optimized) {
    const { props: prevProps, children: prevChildren, component: component } = prevVNode;
    const { props: nextProps, children: nextChildren, patchFlag: patchFlag } = nextVNode;
    const emits = component.emitsOptions;
    if (nextVNode.dirs || nextVNode.transition) return true;
    if (optimized && patchFlag >= 0) {
        if (patchFlag & 1024) return true;
        if (patchFlag & 16) {
            if (!prevProps) return !!nextProps;
            return $ffe19d932e7e7bce$var$hasPropsChanged(prevProps, nextProps, emits);
        } else if (patchFlag & 8) {
            const dynamicProps = nextVNode.dynamicProps;
            for(let i = 0; i < dynamicProps.length; i++){
                const key = dynamicProps[i];
                if (nextProps[key] !== prevProps[key] && !$ffe19d932e7e7bce$var$isEmitListener(emits, key)) return true;
            }
        }
    } else {
        if (prevChildren || nextChildren) {
            if (!nextChildren || !nextChildren.$stable) return true;
        }
        if (prevProps === nextProps) return false;
        if (!prevProps) return !!nextProps;
        if (!nextProps) return true;
        return $ffe19d932e7e7bce$var$hasPropsChanged(prevProps, nextProps, emits);
    }
    return false;
}
function $ffe19d932e7e7bce$var$hasPropsChanged(prevProps, nextProps, emitsOptions) {
    const nextKeys = Object.keys(nextProps);
    if (nextKeys.length !== Object.keys(prevProps).length) return true;
    for(let i = 0; i < nextKeys.length; i++){
        const key = nextKeys[i];
        if (nextProps[key] !== prevProps[key] && !$ffe19d932e7e7bce$var$isEmitListener(emitsOptions, key)) return true;
    }
    return false;
}
function $ffe19d932e7e7bce$var$updateHOCHostEl({ vnode: vnode, parent: parent }, el) {
    while(parent){
        const root = parent.subTree;
        if (root.suspense && root.suspense.activeBranch === vnode) root.el = vnode.el;
        if (root === vnode) {
            (vnode = parent.vnode).el = el;
            parent = parent.parent;
        } else break;
    }
}
const $ffe19d932e7e7bce$var$COMPONENTS = "components";
const $ffe19d932e7e7bce$var$DIRECTIVES = "directives";
function $ffe19d932e7e7bce$export$681d65eec9d1d1e8(name, maybeSelfReference) {
    return $ffe19d932e7e7bce$var$resolveAsset($ffe19d932e7e7bce$var$COMPONENTS, name, true, maybeSelfReference) || name;
}
const $ffe19d932e7e7bce$var$NULL_DYNAMIC_COMPONENT = Symbol.for("v-ndc");
function $ffe19d932e7e7bce$export$b44c564a05ca975(component) {
    if ((0, $16Sl1.isString)(component)) return $ffe19d932e7e7bce$var$resolveAsset($ffe19d932e7e7bce$var$COMPONENTS, component, false) || component;
    else return component || $ffe19d932e7e7bce$var$NULL_DYNAMIC_COMPONENT;
}
function $ffe19d932e7e7bce$export$a1989e995cd481be(name) {
    return $ffe19d932e7e7bce$var$resolveAsset($ffe19d932e7e7bce$var$DIRECTIVES, name);
}
function $ffe19d932e7e7bce$var$resolveAsset(type, name, warnMissing = true, maybeSelfReference = false) {
    const instance = $ffe19d932e7e7bce$var$currentRenderingInstance || $ffe19d932e7e7bce$var$currentInstance;
    if (instance) {
        const Component = instance.type;
        if (type === $ffe19d932e7e7bce$var$COMPONENTS) {
            const selfName = $ffe19d932e7e7bce$var$getComponentName(Component, false);
            if (selfName && (selfName === name || selfName === (0, $16Sl1.camelize)(name) || selfName === (0, $16Sl1.capitalize)((0, $16Sl1.camelize)(name)))) return Component;
        }
        const res = // local registration
        // check instance[type] first which is resolved for options API
        $ffe19d932e7e7bce$var$resolve(instance[type] || Component[type], name) || // global registration
        $ffe19d932e7e7bce$var$resolve(instance.appContext[type], name);
        if (!res && maybeSelfReference) return Component;
        return res;
    }
}
function $ffe19d932e7e7bce$var$resolve(registry, name) {
    return registry && (registry[name] || registry[(0, $16Sl1.camelize)(name)] || registry[(0, $16Sl1.capitalize)((0, $16Sl1.camelize)(name))]);
}
const $ffe19d932e7e7bce$var$isSuspense = (type)=>type.__isSuspense;
let $ffe19d932e7e7bce$var$suspenseId = 0;
const $ffe19d932e7e7bce$var$SuspenseImpl = {
    name: "Suspense",
    // In order to make Suspense tree-shakable, we need to avoid importing it
    // directly in the renderer. The renderer checks for the __isSuspense flag
    // on a vnode's type and calls the `process` method, passing in renderer
    // internals.
    __isSuspense: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
        if (n1 == null) $ffe19d932e7e7bce$var$mountSuspense(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals);
        else {
            if (parentSuspense && parentSuspense.deps > 0 && !n1.suspense.isInFallback) {
                n2.suspense = n1.suspense;
                n2.suspense.vnode = n2;
                n2.el = n1.el;
                return;
            }
            $ffe19d932e7e7bce$var$patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, rendererInternals);
        }
    },
    hydrate: $ffe19d932e7e7bce$var$hydrateSuspense,
    create: $ffe19d932e7e7bce$var$createSuspenseBoundary,
    normalize: $ffe19d932e7e7bce$var$normalizeSuspenseChildren
};
const $ffe19d932e7e7bce$export$74bf444e3cd11ea5 = $ffe19d932e7e7bce$var$SuspenseImpl;
function $ffe19d932e7e7bce$var$triggerEvent(vnode, name) {
    const eventListener = vnode.props && vnode.props[name];
    if ((0, $16Sl1.isFunction)(eventListener)) eventListener();
}
function $ffe19d932e7e7bce$var$mountSuspense(vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
    const { p: patch, o: { createElement: createElement } } = rendererInternals;
    const hiddenContainer = createElement("div");
    const suspense = vnode.suspense = $ffe19d932e7e7bce$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals);
    patch(null, suspense.pendingBranch = vnode.ssContent, hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds);
    if (suspense.deps > 0) {
        $ffe19d932e7e7bce$var$triggerEvent(vnode, "onPending");
        $ffe19d932e7e7bce$var$triggerEvent(vnode, "onFallback");
        patch(null, vnode.ssFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
        namespace, slotScopeIds);
        $ffe19d932e7e7bce$var$setActiveBranch(suspense, vnode.ssFallback);
    } else suspense.resolve(false, true);
}
function $ffe19d932e7e7bce$var$patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, { p: patch, um: unmount, o: { createElement: createElement } }) {
    const suspense = n2.suspense = n1.suspense;
    suspense.vnode = n2;
    n2.el = n1.el;
    const newBranch = n2.ssContent;
    const newFallback = n2.ssFallback;
    const { activeBranch: activeBranch, pendingBranch: pendingBranch, isInFallback: isInFallback, isHydrating: isHydrating } = suspense;
    if (pendingBranch) {
        suspense.pendingBranch = newBranch;
        if ($ffe19d932e7e7bce$var$isSameVNodeType(newBranch, pendingBranch)) {
            patch(pendingBranch, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
            if (suspense.deps <= 0) suspense.resolve();
            else if (isInFallback) {
                if (!isHydrating) {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    $ffe19d932e7e7bce$var$setActiveBranch(suspense, newFallback);
                }
            }
        } else {
            suspense.pendingId = $ffe19d932e7e7bce$var$suspenseId++;
            if (isHydrating) {
                suspense.isHydrating = false;
                suspense.activeBranch = pendingBranch;
            } else unmount(pendingBranch, parentComponent, suspense);
            suspense.deps = 0;
            suspense.effects.length = 0;
            suspense.hiddenContainer = createElement("div");
            if (isInFallback) {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
                else {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    $ffe19d932e7e7bce$var$setActiveBranch(suspense, newFallback);
                }
            } else if (activeBranch && $ffe19d932e7e7bce$var$isSameVNodeType(newBranch, activeBranch)) {
                patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
                suspense.resolve(true);
            } else {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
            }
        }
    } else if (activeBranch && $ffe19d932e7e7bce$var$isSameVNodeType(newBranch, activeBranch)) {
        patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
        $ffe19d932e7e7bce$var$setActiveBranch(suspense, newBranch);
    } else {
        $ffe19d932e7e7bce$var$triggerEvent(n2, "onPending");
        suspense.pendingBranch = newBranch;
        if (newBranch.shapeFlag & 512) suspense.pendingId = newBranch.component.suspenseId;
        else suspense.pendingId = $ffe19d932e7e7bce$var$suspenseId++;
        patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
        if (suspense.deps <= 0) suspense.resolve();
        else {
            const { timeout: timeout, pendingId: pendingId } = suspense;
            if (timeout > 0) setTimeout(()=>{
                if (suspense.pendingId === pendingId) suspense.fallback(newFallback);
            }, timeout);
            else if (timeout === 0) suspense.fallback(newFallback);
        }
    }
}
let $ffe19d932e7e7bce$var$hasWarned = false;
function $ffe19d932e7e7bce$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals, isHydrating = false) {
    const { p: patch, m: move, um: unmount, n: next, o: { parentNode: parentNode, remove: remove } } = rendererInternals;
    let parentSuspenseId;
    const isSuspensible = $ffe19d932e7e7bce$var$isVNodeSuspensible(vnode);
    if (isSuspensible) {
        if (parentSuspense == null ? void 0 : parentSuspense.pendingBranch) {
            parentSuspenseId = parentSuspense.pendingId;
            parentSuspense.deps++;
        }
    }
    const timeout = vnode.props ? (0, $16Sl1.toNumber)(vnode.props.timeout) : void 0;
    const initialAnchor = anchor;
    const suspense = {
        vnode: vnode,
        parent: parentSuspense,
        parentComponent: parentComponent,
        namespace: namespace,
        container: container,
        hiddenContainer: hiddenContainer,
        deps: 0,
        pendingId: $ffe19d932e7e7bce$var$suspenseId++,
        timeout: typeof timeout === "number" ? timeout : -1,
        activeBranch: null,
        pendingBranch: null,
        isInFallback: !isHydrating,
        isHydrating: isHydrating,
        isUnmounted: false,
        effects: [],
        resolve (resume = false, sync = false) {
            const { vnode: vnode2, activeBranch: activeBranch, pendingBranch: pendingBranch, pendingId: pendingId, effects: effects, parentComponent: parentComponent2, container: container2 } = suspense;
            let delayEnter = false;
            if (suspense.isHydrating) suspense.isHydrating = false;
            else if (!resume) {
                delayEnter = activeBranch && pendingBranch.transition && pendingBranch.transition.mode === "out-in";
                if (delayEnter) activeBranch.transition.afterLeave = ()=>{
                    if (pendingId === suspense.pendingId) {
                        move(pendingBranch, container2, anchor === initialAnchor ? next(activeBranch) : anchor, 0);
                        $ffe19d932e7e7bce$export$59536a0199721cab(effects);
                    }
                };
                if (activeBranch) {
                    if (parentNode(activeBranch.el) !== suspense.hiddenContainer) anchor = next(activeBranch);
                    unmount(activeBranch, parentComponent2, suspense, true);
                }
                if (!delayEnter) move(pendingBranch, container2, anchor, 0);
            }
            $ffe19d932e7e7bce$var$setActiveBranch(suspense, pendingBranch);
            suspense.pendingBranch = null;
            suspense.isInFallback = false;
            let parent = suspense.parent;
            let hasUnresolvedAncestor = false;
            while(parent){
                if (parent.pendingBranch) {
                    parent.effects.push(...effects);
                    hasUnresolvedAncestor = true;
                    break;
                }
                parent = parent.parent;
            }
            if (!hasUnresolvedAncestor && !delayEnter) $ffe19d932e7e7bce$export$59536a0199721cab(effects);
            suspense.effects = [];
            if (isSuspensible) {
                if (parentSuspense && parentSuspense.pendingBranch && parentSuspenseId === parentSuspense.pendingId) {
                    parentSuspense.deps--;
                    if (parentSuspense.deps === 0 && !sync) parentSuspense.resolve();
                }
            }
            $ffe19d932e7e7bce$var$triggerEvent(vnode2, "onResolve");
        },
        fallback (fallbackVNode) {
            if (!suspense.pendingBranch) return;
            const { vnode: vnode2, activeBranch: activeBranch, parentComponent: parentComponent2, container: container2, namespace: namespace2 } = suspense;
            $ffe19d932e7e7bce$var$triggerEvent(vnode2, "onFallback");
            const anchor2 = next(activeBranch);
            const mountFallback = ()=>{
                if (!suspense.isInFallback) return;
                patch(null, fallbackVNode, container2, anchor2, parentComponent2, null, // fallback tree will not have suspense context
                namespace2, slotScopeIds, optimized);
                $ffe19d932e7e7bce$var$setActiveBranch(suspense, fallbackVNode);
            };
            const delayEnter = fallbackVNode.transition && fallbackVNode.transition.mode === "out-in";
            if (delayEnter) activeBranch.transition.afterLeave = mountFallback;
            suspense.isInFallback = true;
            unmount(activeBranch, parentComponent2, null, // no suspense so unmount hooks fire now
            true);
            if (!delayEnter) mountFallback();
        },
        move (container2, anchor2, type) {
            suspense.activeBranch && move(suspense.activeBranch, container2, anchor2, type);
            suspense.container = container2;
        },
        next () {
            return suspense.activeBranch && next(suspense.activeBranch);
        },
        registerDep (instance, setupRenderEffect) {
            const isInPendingSuspense = !!suspense.pendingBranch;
            if (isInPendingSuspense) suspense.deps++;
            const hydratedEl = instance.vnode.el;
            instance.asyncDep.catch((err)=>{
                $ffe19d932e7e7bce$export$d3da1ecaf1206c58(err, instance, 0);
            }).then((asyncSetupResult)=>{
                if (instance.isUnmounted || suspense.isUnmounted || suspense.pendingId !== instance.suspenseId) return;
                instance.asyncResolved = true;
                const { vnode: vnode2 } = instance;
                $ffe19d932e7e7bce$var$handleSetupResult(instance, asyncSetupResult, false);
                if (hydratedEl) vnode2.el = hydratedEl;
                const placeholder = !hydratedEl && instance.subTree.el;
                setupRenderEffect(instance, vnode2, // component may have been moved before resolve.
                // if this is not a hydration, instance.subTree will be the comment
                // placeholder.
                parentNode(hydratedEl || instance.subTree.el), // anchor will not be used if this is hydration, so only need to
                // consider the comment placeholder case.
                hydratedEl ? null : next(instance.subTree), suspense, namespace, optimized);
                if (placeholder) remove(placeholder);
                $ffe19d932e7e7bce$var$updateHOCHostEl(instance, vnode2.el);
                if (isInPendingSuspense && --suspense.deps === 0) suspense.resolve();
            });
        },
        unmount (parentSuspense2, doRemove) {
            suspense.isUnmounted = true;
            if (suspense.activeBranch) unmount(suspense.activeBranch, parentComponent, parentSuspense2, doRemove);
            if (suspense.pendingBranch) unmount(suspense.pendingBranch, parentComponent, parentSuspense2, doRemove);
        }
    };
    return suspense;
}
function $ffe19d932e7e7bce$var$hydrateSuspense(node, vnode, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals, hydrateNode) {
    const suspense = vnode.suspense = $ffe19d932e7e7bce$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, node.parentNode, // eslint-disable-next-line no-restricted-globals
    document.createElement("div"), null, namespace, slotScopeIds, optimized, rendererInternals, true);
    const result = hydrateNode(node, suspense.pendingBranch = vnode.ssContent, parentComponent, suspense, slotScopeIds, optimized);
    if (suspense.deps === 0) suspense.resolve(false, true);
    return result;
}
function $ffe19d932e7e7bce$var$normalizeSuspenseChildren(vnode) {
    const { shapeFlag: shapeFlag, children: children } = vnode;
    const isSlotChildren = shapeFlag & 32;
    vnode.ssContent = $ffe19d932e7e7bce$var$normalizeSuspenseSlot(isSlotChildren ? children.default : children);
    vnode.ssFallback = isSlotChildren ? $ffe19d932e7e7bce$var$normalizeSuspenseSlot(children.fallback) : $ffe19d932e7e7bce$export$bf5c4cf060303d58($ffe19d932e7e7bce$export$4d299b491347818a);
}
function $ffe19d932e7e7bce$var$normalizeSuspenseSlot(s) {
    let block;
    if ((0, $16Sl1.isFunction)(s)) {
        const trackBlock = $ffe19d932e7e7bce$var$isBlockTreeEnabled && s._c;
        if (trackBlock) {
            s._d = false;
            $ffe19d932e7e7bce$export$e7eaa45e502fe5cc();
        }
        s = s();
        if (trackBlock) {
            s._d = true;
            block = $ffe19d932e7e7bce$var$currentBlock;
            $ffe19d932e7e7bce$var$closeBlock();
        }
    }
    if ((0, $16Sl1.isArray)(s)) {
        const singleChild = $ffe19d932e7e7bce$var$filterSingleRoot(s);
        s = singleChild;
    }
    s = $ffe19d932e7e7bce$var$normalizeVNode(s);
    if (block && !s.dynamicChildren) s.dynamicChildren = block.filter((c)=>c !== s);
    return s;
}
function $ffe19d932e7e7bce$var$queueEffectWithSuspense(fn, suspense) {
    if (suspense && suspense.pendingBranch) {
        if ((0, $16Sl1.isArray)(fn)) suspense.effects.push(...fn);
        else suspense.effects.push(fn);
    } else $ffe19d932e7e7bce$export$59536a0199721cab(fn);
}
function $ffe19d932e7e7bce$var$setActiveBranch(suspense, branch) {
    suspense.activeBranch = branch;
    const { vnode: vnode, parentComponent: parentComponent } = suspense;
    let el = branch.el;
    while(!el && branch.component){
        branch = branch.component.subTree;
        el = branch.el;
    }
    vnode.el = el;
    if (parentComponent && parentComponent.subTree === vnode) {
        parentComponent.vnode.el = el;
        $ffe19d932e7e7bce$var$updateHOCHostEl(parentComponent, el);
    }
}
function $ffe19d932e7e7bce$var$isVNodeSuspensible(vnode) {
    var _a;
    return ((_a = vnode.props) == null ? void 0 : _a.suspensible) != null && vnode.props.suspensible !== false;
}
const $ffe19d932e7e7bce$export$f2549a27e18acf2d = Symbol.for("v-scx");
const $ffe19d932e7e7bce$export$6b1c54dc4befcda = ()=>{
    {
        const ctx = $ffe19d932e7e7bce$export$a976684a0efeb93f($ffe19d932e7e7bce$export$f2549a27e18acf2d);
        ctx;
        return ctx;
    }
};
function $ffe19d932e7e7bce$export$ede35fc0e5500309(effect, options) {
    return $ffe19d932e7e7bce$var$doWatch(effect, null, options);
}
function $ffe19d932e7e7bce$export$b7f27ea67102d543(effect, options) {
    return $ffe19d932e7e7bce$var$doWatch(effect, null, {
        flush: "post"
    });
}
function $ffe19d932e7e7bce$export$2035654f31b0e555(effect, options) {
    return $ffe19d932e7e7bce$var$doWatch(effect, null, {
        flush: "sync"
    });
}
const $ffe19d932e7e7bce$var$INITIAL_WATCHER_VALUE = {};
function $ffe19d932e7e7bce$export$3db5d71bdb2d5499(source, cb, options) {
    return $ffe19d932e7e7bce$var$doWatch(source, cb, options);
}
function $ffe19d932e7e7bce$var$doWatch(source, cb, { immediate: immediate, deep: deep, flush: flush, once: once, onTrack: onTrack, onTrigger: onTrigger } = (0, $16Sl1.EMPTY_OBJ)) {
    if (cb && once) {
        const _cb = cb;
        cb = (...args)=>{
            _cb(...args);
            unwatch();
        };
    }
    const warnInvalidSource = (s)=>{
        $ffe19d932e7e7bce$var$warn$1(`Invalid watch source: `, s, `A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.`);
    };
    const instance = $ffe19d932e7e7bce$var$currentInstance;
    const reactiveGetter = (source2)=>deep === true ? source2 : // for deep: false, only traverse root-level properties
        $ffe19d932e7e7bce$var$traverse(source2, deep === false ? 1 : void 0);
    let getter;
    let forceTrigger = false;
    let isMultiSource = false;
    if ((0, $99kuS.isRef)(source)) {
        getter = ()=>source.value;
        forceTrigger = (0, $99kuS.isShallow)(source);
    } else if ((0, $99kuS.isReactive)(source)) {
        getter = ()=>reactiveGetter(source);
        forceTrigger = true;
    } else if ((0, $16Sl1.isArray)(source)) {
        isMultiSource = true;
        forceTrigger = source.some((s)=>(0, $99kuS.isReactive)(s) || (0, $99kuS.isShallow)(s));
        getter = ()=>source.map((s)=>{
                if ((0, $99kuS.isRef)(s)) return s.value;
                else if ((0, $99kuS.isReactive)(s)) return reactiveGetter(s);
                else if ((0, $16Sl1.isFunction)(s)) return $ffe19d932e7e7bce$export$b22fcaf88446e9bf(s, instance, 2);
            });
    } else if ((0, $16Sl1.isFunction)(source)) {
        if (cb) getter = ()=>$ffe19d932e7e7bce$export$b22fcaf88446e9bf(source, instance, 2);
        else getter = ()=>{
            if (cleanup) cleanup();
            return $ffe19d932e7e7bce$export$dae85862a8d94378(source, instance, 3, [
                onCleanup
            ]);
        };
    } else getter = (0, $16Sl1.NOOP);
    if (cb && deep) {
        const baseGetter = getter;
        getter = ()=>$ffe19d932e7e7bce$var$traverse(baseGetter());
    }
    let cleanup;
    let onCleanup = (fn)=>{
        cleanup = effect.onStop = ()=>{
            $ffe19d932e7e7bce$export$b22fcaf88446e9bf(fn, instance, 4);
            cleanup = effect.onStop = void 0;
        };
    };
    let ssrCleanup;
    if ($ffe19d932e7e7bce$var$isInSSRComponentSetup) {
        onCleanup = (0, $16Sl1.NOOP);
        if (!cb) getter();
        else if (immediate) $ffe19d932e7e7bce$export$dae85862a8d94378(cb, instance, 3, [
            getter(),
            isMultiSource ? [] : void 0,
            onCleanup
        ]);
        if (flush === "sync") {
            const ctx = $ffe19d932e7e7bce$export$6b1c54dc4befcda();
            ssrCleanup = ctx.__watcherHandles || (ctx.__watcherHandles = []);
        } else return 0, $16Sl1.NOOP;
    }
    let oldValue = isMultiSource ? new Array(source.length).fill($ffe19d932e7e7bce$var$INITIAL_WATCHER_VALUE) : $ffe19d932e7e7bce$var$INITIAL_WATCHER_VALUE;
    const job = ()=>{
        if (!effect.active || !effect.dirty) return;
        if (cb) {
            const newValue = effect.run();
            if (deep || forceTrigger || (isMultiSource ? newValue.some((v1, i)=>(0, $16Sl1.hasChanged)(v1, oldValue[i])) : (0, $16Sl1.hasChanged)(newValue, oldValue)) || false) {
                if (cleanup) cleanup();
                $ffe19d932e7e7bce$export$dae85862a8d94378(cb, instance, 3, [
                    newValue,
                    // pass undefined as the old value when it's changed for the first time
                    oldValue === $ffe19d932e7e7bce$var$INITIAL_WATCHER_VALUE ? void 0 : isMultiSource && oldValue[0] === $ffe19d932e7e7bce$var$INITIAL_WATCHER_VALUE ? [] : oldValue,
                    onCleanup
                ]);
                oldValue = newValue;
            }
        } else effect.run();
    };
    job.allowRecurse = !!cb;
    let scheduler;
    if (flush === "sync") scheduler = job;
    else if (flush === "post") scheduler = ()=>$ffe19d932e7e7bce$var$queuePostRenderEffect(job, instance && instance.suspense);
    else {
        job.pre = true;
        if (instance) job.id = instance.uid;
        scheduler = ()=>$ffe19d932e7e7bce$var$queueJob(job);
    }
    const effect = new (0, $99kuS.ReactiveEffect)(getter, (0, $16Sl1.NOOP), scheduler);
    const scope = (0, $99kuS.getCurrentScope)();
    const unwatch = ()=>{
        effect.stop();
        if (scope) (0, $16Sl1.remove)(scope.effects, effect);
    };
    if (cb) {
        if (immediate) job();
        else oldValue = effect.run();
    } else if (flush === "post") $ffe19d932e7e7bce$var$queuePostRenderEffect(effect.run.bind(effect), instance && instance.suspense);
    else effect.run();
    if (ssrCleanup) ssrCleanup.push(unwatch);
    return unwatch;
}
function $ffe19d932e7e7bce$var$instanceWatch(source, value, options) {
    const publicThis = this.proxy;
    const getter = (0, $16Sl1.isString)(source) ? source.includes(".") ? $ffe19d932e7e7bce$var$createPathGetter(publicThis, source) : ()=>publicThis[source] : source.bind(publicThis, publicThis);
    let cb;
    if ((0, $16Sl1.isFunction)(value)) cb = value;
    else {
        cb = value.handler;
        options = value;
    }
    const reset = $ffe19d932e7e7bce$var$setCurrentInstance(this);
    const res = $ffe19d932e7e7bce$var$doWatch(getter, cb.bind(publicThis), options);
    reset();
    return res;
}
function $ffe19d932e7e7bce$var$createPathGetter(ctx, path) {
    const segments = path.split(".");
    return ()=>{
        let cur = ctx;
        for(let i = 0; i < segments.length && cur; i++)cur = cur[segments[i]];
        return cur;
    };
}
function $ffe19d932e7e7bce$var$traverse(value, depth, currentDepth = 0, seen) {
    if (!(0, $16Sl1.isObject)(value) || value["__v_skip"]) return value;
    if (depth && depth > 0) {
        if (currentDepth >= depth) return value;
        currentDepth++;
    }
    seen = seen || /* @__PURE__ */ new Set();
    if (seen.has(value)) return value;
    seen.add(value);
    if ((0, $99kuS.isRef)(value)) $ffe19d932e7e7bce$var$traverse(value.value, depth, currentDepth, seen);
    else if ((0, $16Sl1.isArray)(value)) for(let i = 0; i < value.length; i++)$ffe19d932e7e7bce$var$traverse(value[i], depth, currentDepth, seen);
    else if ((0, $16Sl1.isSet)(value) || (0, $16Sl1.isMap)(value)) value.forEach((v1)=>{
        $ffe19d932e7e7bce$var$traverse(v1, depth, currentDepth, seen);
    });
    else if ((0, $16Sl1.isPlainObject)(value)) for(const key in value)$ffe19d932e7e7bce$var$traverse(value[key], depth, currentDepth, seen);
    return value;
}
function $ffe19d932e7e7bce$var$validateDirectiveName(name) {
    if ((0, $16Sl1.isBuiltInDirective)(name)) $ffe19d932e7e7bce$var$warn$1("Do not use built-in directive ids as custom directive id: " + name);
}
function $ffe19d932e7e7bce$export$49729353e7c1e6c5(vnode, directives) {
    if ($ffe19d932e7e7bce$var$currentRenderingInstance === null) return vnode;
    const instance = $ffe19d932e7e7bce$var$getExposeProxy($ffe19d932e7e7bce$var$currentRenderingInstance) || $ffe19d932e7e7bce$var$currentRenderingInstance.proxy;
    const bindings = vnode.dirs || (vnode.dirs = []);
    for(let i = 0; i < directives.length; i++){
        let [dir, value, arg, modifiers = (0, $16Sl1.EMPTY_OBJ)] = directives[i];
        if (dir) {
            if ((0, $16Sl1.isFunction)(dir)) dir = {
                mounted: dir,
                updated: dir
            };
            if (dir.deep) $ffe19d932e7e7bce$var$traverse(value);
            bindings.push({
                dir: dir,
                instance: instance,
                value: value,
                oldValue: void 0,
                arg: arg,
                modifiers: modifiers
            });
        }
    }
    return vnode;
}
function $ffe19d932e7e7bce$var$invokeDirectiveHook(vnode, prevVNode, instance, name) {
    const bindings = vnode.dirs;
    const oldBindings = prevVNode && prevVNode.dirs;
    for(let i = 0; i < bindings.length; i++){
        const binding = bindings[i];
        if (oldBindings) binding.oldValue = oldBindings[i].value;
        let hook = binding.dir[name];
        if (hook) {
            (0, $99kuS.pauseTracking)();
            $ffe19d932e7e7bce$export$dae85862a8d94378(hook, instance, 8, [
                vnode.el,
                binding,
                vnode,
                prevVNode
            ]);
            (0, $99kuS.resetTracking)();
        }
    }
}
const $ffe19d932e7e7bce$var$leaveCbKey = Symbol("_leaveCb");
const $ffe19d932e7e7bce$var$enterCbKey = Symbol("_enterCb");
function $ffe19d932e7e7bce$export$d2a0a1bc267c90f6() {
    const state = {
        isMounted: false,
        isLeaving: false,
        isUnmounting: false,
        leavingVNodes: /* @__PURE__ */ new Map()
    };
    $ffe19d932e7e7bce$export$6d1641039221b5cb(()=>{
        state.isMounted = true;
    });
    $ffe19d932e7e7bce$export$40c420df62d2614(()=>{
        state.isUnmounting = true;
    });
    return state;
}
const $ffe19d932e7e7bce$var$TransitionHookValidator = [
    Function,
    Array
];
const $ffe19d932e7e7bce$export$b876c99684f8cf3b = {
    mode: String,
    appear: Boolean,
    persisted: Boolean,
    // enter
    onBeforeEnter: $ffe19d932e7e7bce$var$TransitionHookValidator,
    onEnter: $ffe19d932e7e7bce$var$TransitionHookValidator,
    onAfterEnter: $ffe19d932e7e7bce$var$TransitionHookValidator,
    onEnterCancelled: $ffe19d932e7e7bce$var$TransitionHookValidator,
    // leave
    onBeforeLeave: $ffe19d932e7e7bce$var$TransitionHookValidator,
    onLeave: $ffe19d932e7e7bce$var$TransitionHookValidator,
    onAfterLeave: $ffe19d932e7e7bce$var$TransitionHookValidator,
    onLeaveCancelled: $ffe19d932e7e7bce$var$TransitionHookValidator,
    // appear
    onBeforeAppear: $ffe19d932e7e7bce$var$TransitionHookValidator,
    onAppear: $ffe19d932e7e7bce$var$TransitionHookValidator,
    onAfterAppear: $ffe19d932e7e7bce$var$TransitionHookValidator,
    onAppearCancelled: $ffe19d932e7e7bce$var$TransitionHookValidator
};
const $ffe19d932e7e7bce$var$BaseTransitionImpl = {
    name: `BaseTransition`,
    props: $ffe19d932e7e7bce$export$b876c99684f8cf3b,
    setup (props, { slots: slots }) {
        const instance = $ffe19d932e7e7bce$export$f13e630aa3915748();
        const state = $ffe19d932e7e7bce$export$d2a0a1bc267c90f6();
        return ()=>{
            const children = slots.default && $ffe19d932e7e7bce$export$a67f9b1229c7c97a(slots.default(), true);
            if (!children || !children.length) return;
            let child = children[0];
            if (children.length > 1) {
                let hasFound = false;
                for (const c of children)if (c.type !== $ffe19d932e7e7bce$export$4d299b491347818a) {
                    child = c;
                    hasFound = true;
                    break;
                }
            }
            const rawProps = (0, $99kuS.toRaw)(props);
            const { mode: mode } = rawProps;
            if (state.isLeaving) return $ffe19d932e7e7bce$var$emptyPlaceholder(child);
            const innerChild = $ffe19d932e7e7bce$var$getKeepAliveChild(child);
            if (!innerChild) return $ffe19d932e7e7bce$var$emptyPlaceholder(child);
            const enterHooks = $ffe19d932e7e7bce$export$76ac1779589cd824(innerChild, rawProps, state, instance);
            $ffe19d932e7e7bce$export$7770a22486565649(innerChild, enterHooks);
            const oldChild = instance.subTree;
            const oldInnerChild = oldChild && $ffe19d932e7e7bce$var$getKeepAliveChild(oldChild);
            if (oldInnerChild && oldInnerChild.type !== $ffe19d932e7e7bce$export$4d299b491347818a && !$ffe19d932e7e7bce$var$isSameVNodeType(innerChild, oldInnerChild)) {
                const leavingHooks = $ffe19d932e7e7bce$export$76ac1779589cd824(oldInnerChild, rawProps, state, instance);
                $ffe19d932e7e7bce$export$7770a22486565649(oldInnerChild, leavingHooks);
                if (mode === "out-in") {
                    state.isLeaving = true;
                    leavingHooks.afterLeave = ()=>{
                        state.isLeaving = false;
                        if (instance.update.active !== false) {
                            instance.effect.dirty = true;
                            instance.update();
                        }
                    };
                    return $ffe19d932e7e7bce$var$emptyPlaceholder(child);
                } else if (mode === "in-out" && innerChild.type !== $ffe19d932e7e7bce$export$4d299b491347818a) leavingHooks.delayLeave = (el, earlyRemove, delayedLeave)=>{
                    const leavingVNodesCache = $ffe19d932e7e7bce$var$getLeavingNodesForType(state, oldInnerChild);
                    leavingVNodesCache[String(oldInnerChild.key)] = oldInnerChild;
                    el[$ffe19d932e7e7bce$var$leaveCbKey] = ()=>{
                        earlyRemove();
                        el[$ffe19d932e7e7bce$var$leaveCbKey] = void 0;
                        delete enterHooks.delayedLeave;
                    };
                    enterHooks.delayedLeave = delayedLeave;
                };
            }
            return child;
        };
    }
};
const $ffe19d932e7e7bce$export$abd95b5f5e8a8837 = $ffe19d932e7e7bce$var$BaseTransitionImpl;
function $ffe19d932e7e7bce$var$getLeavingNodesForType(state, vnode) {
    const { leavingVNodes: leavingVNodes } = state;
    let leavingVNodesCache = leavingVNodes.get(vnode.type);
    if (!leavingVNodesCache) {
        leavingVNodesCache = /* @__PURE__ */ Object.create(null);
        leavingVNodes.set(vnode.type, leavingVNodesCache);
    }
    return leavingVNodesCache;
}
function $ffe19d932e7e7bce$export$76ac1779589cd824(vnode, props, state, instance) {
    const { appear: appear, mode: mode, persisted: persisted = false, onBeforeEnter: onBeforeEnter, onEnter: onEnter, onAfterEnter: onAfterEnter, onEnterCancelled: onEnterCancelled, onBeforeLeave: onBeforeLeave, onLeave: onLeave, onAfterLeave: onAfterLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear, onAppear: onAppear, onAfterAppear: onAfterAppear, onAppearCancelled: onAppearCancelled } = props;
    const key = String(vnode.key);
    const leavingVNodesCache = $ffe19d932e7e7bce$var$getLeavingNodesForType(state, vnode);
    const callHook = (hook, args)=>{
        hook && $ffe19d932e7e7bce$export$dae85862a8d94378(hook, instance, 9, args);
    };
    const callAsyncHook = (hook, args)=>{
        const done = args[1];
        callHook(hook, args);
        if ((0, $16Sl1.isArray)(hook)) {
            if (hook.every((hook2)=>hook2.length <= 1)) done();
        } else if (hook.length <= 1) done();
    };
    const hooks = {
        mode: mode,
        persisted: persisted,
        beforeEnter (el) {
            let hook = onBeforeEnter;
            if (!state.isMounted) {
                if (appear) hook = onBeforeAppear || onBeforeEnter;
                else return;
            }
            if (el[$ffe19d932e7e7bce$var$leaveCbKey]) el[$ffe19d932e7e7bce$var$leaveCbKey](true);
            const leavingVNode = leavingVNodesCache[key];
            if (leavingVNode && $ffe19d932e7e7bce$var$isSameVNodeType(vnode, leavingVNode) && leavingVNode.el[$ffe19d932e7e7bce$var$leaveCbKey]) leavingVNode.el[$ffe19d932e7e7bce$var$leaveCbKey]();
            callHook(hook, [
                el
            ]);
        },
        enter (el) {
            let hook = onEnter;
            let afterHook = onAfterEnter;
            let cancelHook = onEnterCancelled;
            if (!state.isMounted) {
                if (appear) {
                    hook = onAppear || onEnter;
                    afterHook = onAfterAppear || onAfterEnter;
                    cancelHook = onAppearCancelled || onEnterCancelled;
                } else return;
            }
            let called = false;
            const done = el[$ffe19d932e7e7bce$var$enterCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                if (cancelled) callHook(cancelHook, [
                    el
                ]);
                else callHook(afterHook, [
                    el
                ]);
                if (hooks.delayedLeave) hooks.delayedLeave();
                el[$ffe19d932e7e7bce$var$enterCbKey] = void 0;
            };
            if (hook) callAsyncHook(hook, [
                el,
                done
            ]);
            else done();
        },
        leave (el, remove) {
            const key2 = String(vnode.key);
            if (el[$ffe19d932e7e7bce$var$enterCbKey]) el[$ffe19d932e7e7bce$var$enterCbKey](true);
            if (state.isUnmounting) return remove();
            callHook(onBeforeLeave, [
                el
            ]);
            let called = false;
            const done = el[$ffe19d932e7e7bce$var$leaveCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                remove();
                if (cancelled) callHook(onLeaveCancelled, [
                    el
                ]);
                else callHook(onAfterLeave, [
                    el
                ]);
                el[$ffe19d932e7e7bce$var$leaveCbKey] = void 0;
                if (leavingVNodesCache[key2] === vnode) delete leavingVNodesCache[key2];
            };
            leavingVNodesCache[key2] = vnode;
            if (onLeave) callAsyncHook(onLeave, [
                el,
                done
            ]);
            else done();
        },
        clone (vnode2) {
            return $ffe19d932e7e7bce$export$76ac1779589cd824(vnode2, props, state, instance);
        }
    };
    return hooks;
}
function $ffe19d932e7e7bce$var$emptyPlaceholder(vnode) {
    if ($ffe19d932e7e7bce$var$isKeepAlive(vnode)) {
        vnode = $ffe19d932e7e7bce$export$ee4f9e12c0a92a1a(vnode);
        vnode.children = null;
        return vnode;
    }
}
function $ffe19d932e7e7bce$var$getKeepAliveChild(vnode) {
    if (!$ffe19d932e7e7bce$var$isKeepAlive(vnode)) return vnode;
    const { shapeFlag: shapeFlag, children: children } = vnode;
    if (children) {
        if (shapeFlag & 16) return children[0];
        if (shapeFlag & 32 && (0, $16Sl1.isFunction)(children.default)) return children.default();
    }
}
function $ffe19d932e7e7bce$export$7770a22486565649(vnode, hooks) {
    if (vnode.shapeFlag & 6 && vnode.component) $ffe19d932e7e7bce$export$7770a22486565649(vnode.component.subTree, hooks);
    else if (vnode.shapeFlag & 128) {
        vnode.ssContent.transition = hooks.clone(vnode.ssContent);
        vnode.ssFallback.transition = hooks.clone(vnode.ssFallback);
    } else vnode.transition = hooks;
}
function $ffe19d932e7e7bce$export$a67f9b1229c7c97a(children, keepComment = false, parentKey) {
    let ret = [];
    let keyedFragmentCount = 0;
    for(let i = 0; i < children.length; i++){
        let child = children[i];
        const key = parentKey == null ? child.key : String(parentKey) + String(child.key != null ? child.key : i);
        if (child.type === $ffe19d932e7e7bce$export$ffb0004e005737fa) {
            if (child.patchFlag & 128) keyedFragmentCount++;
            ret = ret.concat($ffe19d932e7e7bce$export$a67f9b1229c7c97a(child.children, keepComment, key));
        } else if (keepComment || child.type !== $ffe19d932e7e7bce$export$4d299b491347818a) ret.push(key != null ? $ffe19d932e7e7bce$export$ee4f9e12c0a92a1a(child, {
            key: key
        }) : child);
    }
    if (keyedFragmentCount > 1) for(let i = 0; i < ret.length; i++)ret[i].patchFlag = -2;
    return ret;
}
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $ffe19d932e7e7bce$export$afa64b67e5a01c3b(options, extraOptions) {
    return (0, $16Sl1.isFunction)(options) ? // #8326: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    /* @__PURE__ */ (()=>(0, $16Sl1.extend)({
            name: options.name
        }, extraOptions, {
            setup: options
        }))() : options;
}
const $ffe19d932e7e7bce$var$isAsyncWrapper = (i)=>!!i.type.__asyncLoader;
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $ffe19d932e7e7bce$export$d75d499b4c16cf21(source) {
    if ((0, $16Sl1.isFunction)(source)) source = {
        loader: source
    };
    const { loader: loader, loadingComponent: loadingComponent, errorComponent: errorComponent, delay: delay = 200, timeout: timeout, suspensible: // undefined = never times out
    suspensible = true, onError: userOnError } = source;
    let pendingRequest = null;
    let resolvedComp;
    let retries = 0;
    const retry = ()=>{
        retries++;
        pendingRequest = null;
        return load();
    };
    const load = ()=>{
        let thisRequest;
        return pendingRequest || (thisRequest = pendingRequest = loader().catch((err)=>{
            err = err instanceof Error ? err : new Error(String(err));
            if (userOnError) return new Promise((resolve, reject)=>{
                const userRetry = ()=>resolve(retry());
                const userFail = ()=>reject(err);
                userOnError(err, userRetry, userFail, retries + 1);
            });
            else throw err;
        }).then((comp)=>{
            if (thisRequest !== pendingRequest && pendingRequest) return pendingRequest;
            if (comp && (comp.__esModule || comp[Symbol.toStringTag] === "Module")) comp = comp.default;
            resolvedComp = comp;
            return comp;
        }));
    };
    return $ffe19d932e7e7bce$export$afa64b67e5a01c3b({
        name: "AsyncComponentWrapper",
        __asyncLoader: load,
        get __asyncResolved () {
            return resolvedComp;
        },
        setup () {
            const instance = $ffe19d932e7e7bce$var$currentInstance;
            if (resolvedComp) return ()=>$ffe19d932e7e7bce$var$createInnerComp(resolvedComp, instance);
            const onError = (err)=>{
                pendingRequest = null;
                $ffe19d932e7e7bce$export$d3da1ecaf1206c58(err, instance, 13, !errorComponent);
            };
            if (suspensible && instance.suspense || $ffe19d932e7e7bce$var$isInSSRComponentSetup) return load().then((comp)=>{
                return ()=>$ffe19d932e7e7bce$var$createInnerComp(comp, instance);
            }).catch((err)=>{
                onError(err);
                return ()=>errorComponent ? $ffe19d932e7e7bce$export$bf5c4cf060303d58(errorComponent, {
                        error: err
                    }) : null;
            });
            const loaded = (0, $99kuS.ref)(false);
            const error = (0, $99kuS.ref)();
            const delayed = (0, $99kuS.ref)(!!delay);
            if (delay) setTimeout(()=>{
                delayed.value = false;
            }, delay);
            if (timeout != null) setTimeout(()=>{
                if (!loaded.value && !error.value) {
                    const err = new Error(`Async component timed out after ${timeout}ms.`);
                    onError(err);
                    error.value = err;
                }
            }, timeout);
            load().then(()=>{
                loaded.value = true;
                if (instance.parent && $ffe19d932e7e7bce$var$isKeepAlive(instance.parent.vnode)) {
                    instance.parent.effect.dirty = true;
                    $ffe19d932e7e7bce$var$queueJob(instance.parent.update);
                }
            }).catch((err)=>{
                onError(err);
                error.value = err;
            });
            return ()=>{
                if (loaded.value && resolvedComp) return $ffe19d932e7e7bce$var$createInnerComp(resolvedComp, instance);
                else if (error.value && errorComponent) return $ffe19d932e7e7bce$export$bf5c4cf060303d58(errorComponent, {
                    error: error.value
                });
                else if (loadingComponent && !delayed.value) return $ffe19d932e7e7bce$export$bf5c4cf060303d58(loadingComponent);
            };
        }
    });
}
function $ffe19d932e7e7bce$var$createInnerComp(comp, parent) {
    const { ref: ref2, props: props, children: children, ce: ce } = parent.vnode;
    const vnode = $ffe19d932e7e7bce$export$bf5c4cf060303d58(comp, props, children);
    vnode.ref = ref2;
    vnode.ce = ce;
    delete parent.vnode.ce;
    return vnode;
}
const $ffe19d932e7e7bce$var$isKeepAlive = (vnode)=>vnode.type.__isKeepAlive;
const $ffe19d932e7e7bce$var$KeepAliveImpl = {
    name: `KeepAlive`,
    // Marker for special handling inside the renderer. We are not using a ===
    // check directly on KeepAlive in the renderer, because importing it directly
    // would prevent it from being tree-shaken.
    __isKeepAlive: true,
    props: {
        include: [
            String,
            RegExp,
            Array
        ],
        exclude: [
            String,
            RegExp,
            Array
        ],
        max: [
            String,
            Number
        ]
    },
    setup (props, { slots: slots }) {
        const instance = $ffe19d932e7e7bce$export$f13e630aa3915748();
        const sharedContext = instance.ctx;
        if (!sharedContext.renderer) return ()=>{
            const children = slots.default && slots.default();
            return children && children.length === 1 ? children[0] : children;
        };
        const cache = /* @__PURE__ */ new Map();
        const keys = /* @__PURE__ */ new Set();
        let current = null;
        if (__VUE_PROD_DEVTOOLS__) instance.__v_cache = cache;
        const parentSuspense = instance.suspense;
        const { renderer: { p: patch, m: move, um: _unmount, o: { createElement: createElement } } } = sharedContext;
        const storageContainer = createElement("div");
        sharedContext.activate = (vnode, container, anchor, namespace, optimized)=>{
            const instance2 = vnode.component;
            move(vnode, container, anchor, 0, parentSuspense);
            patch(instance2.vnode, vnode, container, anchor, instance2, parentSuspense, namespace, vnode.slotScopeIds, optimized);
            $ffe19d932e7e7bce$var$queuePostRenderEffect(()=>{
                instance2.isDeactivated = false;
                if (instance2.a) (0, $16Sl1.invokeArrayFns)(instance2.a);
                const vnodeHook = vnode.props && vnode.props.onVnodeMounted;
                if (vnodeHook) $ffe19d932e7e7bce$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $ffe19d932e7e7bce$var$devtoolsComponentAdded(instance2);
        };
        sharedContext.deactivate = (vnode)=>{
            const instance2 = vnode.component;
            move(vnode, storageContainer, null, 1, parentSuspense);
            $ffe19d932e7e7bce$var$queuePostRenderEffect(()=>{
                if (instance2.da) (0, $16Sl1.invokeArrayFns)(instance2.da);
                const vnodeHook = vnode.props && vnode.props.onVnodeUnmounted;
                if (vnodeHook) $ffe19d932e7e7bce$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
                instance2.isDeactivated = true;
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $ffe19d932e7e7bce$var$devtoolsComponentAdded(instance2);
        };
        function unmount(vnode) {
            $ffe19d932e7e7bce$var$resetShapeFlag(vnode);
            _unmount(vnode, instance, parentSuspense, true);
        }
        function pruneCache(filter) {
            cache.forEach((vnode, key)=>{
                const name = $ffe19d932e7e7bce$var$getComponentName(vnode.type);
                if (name && (!filter || !filter(name))) pruneCacheEntry(key);
            });
        }
        function pruneCacheEntry(key) {
            const cached = cache.get(key);
            if (!current || !$ffe19d932e7e7bce$var$isSameVNodeType(cached, current)) unmount(cached);
            else if (current) $ffe19d932e7e7bce$var$resetShapeFlag(current);
            cache.delete(key);
            keys.delete(key);
        }
        $ffe19d932e7e7bce$export$3db5d71bdb2d5499(()=>[
                props.include,
                props.exclude
            ], ([include, exclude])=>{
            include && pruneCache((name)=>$ffe19d932e7e7bce$var$matches(include, name));
            exclude && pruneCache((name)=>!$ffe19d932e7e7bce$var$matches(exclude, name));
        }, // prune post-render after `current` has been updated
        {
            flush: "post",
            deep: true
        });
        let pendingCacheKey = null;
        const cacheSubtree = ()=>{
            if (pendingCacheKey != null) cache.set(pendingCacheKey, $ffe19d932e7e7bce$var$getInnerChild(instance.subTree));
        };
        $ffe19d932e7e7bce$export$6d1641039221b5cb(cacheSubtree);
        $ffe19d932e7e7bce$export$5876c47052fb88b1(cacheSubtree);
        $ffe19d932e7e7bce$export$40c420df62d2614(()=>{
            cache.forEach((cached)=>{
                const { subTree: subTree, suspense: suspense } = instance;
                const vnode = $ffe19d932e7e7bce$var$getInnerChild(subTree);
                if (cached.type === vnode.type && cached.key === vnode.key) {
                    $ffe19d932e7e7bce$var$resetShapeFlag(vnode);
                    const da = vnode.component.da;
                    da && $ffe19d932e7e7bce$var$queuePostRenderEffect(da, suspense);
                    return;
                }
                unmount(cached);
            });
        });
        return ()=>{
            pendingCacheKey = null;
            if (!slots.default) return current = null;
            const children = slots.default();
            const rawVNode = children[0];
            if (children.length > 1) {
                current = null;
                return children;
            } else if (!$ffe19d932e7e7bce$export$3868d13f8734ae81(rawVNode) || !(rawVNode.shapeFlag & 4) && !(rawVNode.shapeFlag & 128)) {
                current = null;
                return rawVNode;
            }
            let vnode = $ffe19d932e7e7bce$var$getInnerChild(rawVNode);
            const comp = vnode.type;
            const name = $ffe19d932e7e7bce$var$getComponentName($ffe19d932e7e7bce$var$isAsyncWrapper(vnode) ? vnode.type.__asyncResolved || {} : comp);
            const { include: include, exclude: exclude, max: max } = props;
            if (include && (!name || !$ffe19d932e7e7bce$var$matches(include, name)) || exclude && name && $ffe19d932e7e7bce$var$matches(exclude, name)) {
                current = vnode;
                return rawVNode;
            }
            const key = vnode.key == null ? comp : vnode.key;
            const cachedVNode = cache.get(key);
            if (vnode.el) {
                vnode = $ffe19d932e7e7bce$export$ee4f9e12c0a92a1a(vnode);
                if (rawVNode.shapeFlag & 128) rawVNode.ssContent = vnode;
            }
            pendingCacheKey = key;
            if (cachedVNode) {
                vnode.el = cachedVNode.el;
                vnode.component = cachedVNode.component;
                if (vnode.transition) $ffe19d932e7e7bce$export$7770a22486565649(vnode, vnode.transition);
                vnode.shapeFlag |= 512;
                keys.delete(key);
                keys.add(key);
            } else {
                keys.add(key);
                if (max && keys.size > parseInt(max, 10)) pruneCacheEntry(keys.values().next().value);
            }
            vnode.shapeFlag |= 256;
            current = vnode;
            return $ffe19d932e7e7bce$var$isSuspense(rawVNode.type) ? rawVNode : vnode;
        };
    }
};
const $ffe19d932e7e7bce$export$70eb8a58709972df = $ffe19d932e7e7bce$var$KeepAliveImpl;
function $ffe19d932e7e7bce$var$matches(pattern, name) {
    if ((0, $16Sl1.isArray)(pattern)) return pattern.some((p)=>$ffe19d932e7e7bce$var$matches(p, name));
    else if ((0, $16Sl1.isString)(pattern)) return pattern.split(",").includes(name);
    else if ((0, $16Sl1.isRegExp)(pattern)) return pattern.test(name);
    return false;
}
function $ffe19d932e7e7bce$export$ba52d824b95a2154(hook, target) {
    $ffe19d932e7e7bce$var$registerKeepAliveHook(hook, "a", target);
}
function $ffe19d932e7e7bce$export$bf1440eeaf5fa709(hook, target) {
    $ffe19d932e7e7bce$var$registerKeepAliveHook(hook, "da", target);
}
function $ffe19d932e7e7bce$var$registerKeepAliveHook(hook, type, target = $ffe19d932e7e7bce$var$currentInstance) {
    const wrappedHook = hook.__wdc || (hook.__wdc = ()=>{
        let current = target;
        while(current){
            if (current.isDeactivated) return;
            current = current.parent;
        }
        return hook();
    });
    $ffe19d932e7e7bce$var$injectHook(type, wrappedHook, target);
    if (target) {
        let current = target.parent;
        while(current && current.parent){
            if ($ffe19d932e7e7bce$var$isKeepAlive(current.parent.vnode)) $ffe19d932e7e7bce$var$injectToKeepAliveRoot(wrappedHook, type, target, current);
            current = current.parent;
        }
    }
}
function $ffe19d932e7e7bce$var$injectToKeepAliveRoot(hook, type, target, keepAliveRoot) {
    const injected = $ffe19d932e7e7bce$var$injectHook(type, hook, keepAliveRoot, true);
    $ffe19d932e7e7bce$export$13348a43ccacfe58(()=>{
        (0, $16Sl1.remove)(keepAliveRoot[type], injected);
    }, target);
}
function $ffe19d932e7e7bce$var$resetShapeFlag(vnode) {
    vnode.shapeFlag &= -257;
    vnode.shapeFlag &= -513;
}
function $ffe19d932e7e7bce$var$getInnerChild(vnode) {
    return vnode.shapeFlag & 128 ? vnode.ssContent : vnode;
}
function $ffe19d932e7e7bce$var$injectHook(type, hook, target = $ffe19d932e7e7bce$var$currentInstance, prepend = false) {
    if (target) {
        const hooks = target[type] || (target[type] = []);
        const wrappedHook = hook.__weh || (hook.__weh = (...args)=>{
            if (target.isUnmounted) return;
            (0, $99kuS.pauseTracking)();
            const reset = $ffe19d932e7e7bce$var$setCurrentInstance(target);
            const res = $ffe19d932e7e7bce$export$dae85862a8d94378(hook, target, type, args);
            reset();
            (0, $99kuS.resetTracking)();
            return res;
        });
        if (prepend) hooks.unshift(wrappedHook);
        else hooks.push(wrappedHook);
        return wrappedHook;
    }
}
const $ffe19d932e7e7bce$var$createHook = (lifecycle)=>(hook, target = $ffe19d932e7e7bce$var$currentInstance)=>// post-create lifecycle registrations are noops during SSR (except for serverPrefetch)
        (!$ffe19d932e7e7bce$var$isInSSRComponentSetup || lifecycle === "sp") && $ffe19d932e7e7bce$var$injectHook(lifecycle, (...args)=>hook(...args), target);
const $ffe19d932e7e7bce$export$23b7aeb0d671f804 = $ffe19d932e7e7bce$var$createHook("bm");
const $ffe19d932e7e7bce$export$6d1641039221b5cb = $ffe19d932e7e7bce$var$createHook("m");
const $ffe19d932e7e7bce$export$ab91988a13872e4c = $ffe19d932e7e7bce$var$createHook("bu");
const $ffe19d932e7e7bce$export$5876c47052fb88b1 = $ffe19d932e7e7bce$var$createHook("u");
const $ffe19d932e7e7bce$export$40c420df62d2614 = $ffe19d932e7e7bce$var$createHook("bum");
const $ffe19d932e7e7bce$export$13348a43ccacfe58 = $ffe19d932e7e7bce$var$createHook("um");
const $ffe19d932e7e7bce$export$ebf0c601f267bceb = $ffe19d932e7e7bce$var$createHook("sp");
const $ffe19d932e7e7bce$export$898295a813d662eb = $ffe19d932e7e7bce$var$createHook("rtg");
const $ffe19d932e7e7bce$export$2b41f4235363e921 = $ffe19d932e7e7bce$var$createHook("rtc");
function $ffe19d932e7e7bce$export$6a3a15856e50ad19(hook, target = $ffe19d932e7e7bce$var$currentInstance) {
    $ffe19d932e7e7bce$var$injectHook("ec", hook, target);
}
function $ffe19d932e7e7bce$export$4bf387f59bfc6d67(source, renderItem, cache, index) {
    let ret;
    const cached = cache && cache[index];
    if ((0, $16Sl1.isArray)(source) || (0, $16Sl1.isString)(source)) {
        ret = new Array(source.length);
        for(let i = 0, l = source.length; i < l; i++)ret[i] = renderItem(source[i], i, void 0, cached && cached[i]);
    } else if (typeof source === "number") {
        ret = new Array(source);
        for(let i = 0; i < source; i++)ret[i] = renderItem(i + 1, i, void 0, cached && cached[i]);
    } else if ((0, $16Sl1.isObject)(source)) {
        if (source[Symbol.iterator]) ret = Array.from(source, (item, i)=>renderItem(item, i, void 0, cached && cached[i]));
        else {
            const keys = Object.keys(source);
            ret = new Array(keys.length);
            for(let i = 0, l = keys.length; i < l; i++){
                const key = keys[i];
                ret[i] = renderItem(source[key], key, i, cached && cached[i]);
            }
        }
    } else ret = [];
    if (cache) cache[index] = ret;
    return ret;
}
function $ffe19d932e7e7bce$export$85738f8fcd0a5430(slots, dynamicSlots) {
    for(let i = 0; i < dynamicSlots.length; i++){
        const slot = dynamicSlots[i];
        if ((0, $16Sl1.isArray)(slot)) for(let j = 0; j < slot.length; j++)slots[slot[j].name] = slot[j].fn;
        else if (slot) slots[slot.name] = slot.key ? (...args)=>{
            const res = slot.fn(...args);
            if (res) res.key = slot.key;
            return res;
        } : slot.fn;
    }
    return slots;
}
function $ffe19d932e7e7bce$export$4abee4c34694ada1(slots, name, props = {}, fallback, noSlotted) {
    if ($ffe19d932e7e7bce$var$currentRenderingInstance.isCE || $ffe19d932e7e7bce$var$currentRenderingInstance.parent && $ffe19d932e7e7bce$var$isAsyncWrapper($ffe19d932e7e7bce$var$currentRenderingInstance.parent) && $ffe19d932e7e7bce$var$currentRenderingInstance.parent.isCE) {
        if (name !== "default") props.name = name;
        return $ffe19d932e7e7bce$export$bf5c4cf060303d58("slot", props, fallback && fallback());
    }
    let slot = slots[name];
    if (slot && slot._c) slot._d = false;
    $ffe19d932e7e7bce$export$e7eaa45e502fe5cc();
    const validSlotContent = slot && $ffe19d932e7e7bce$var$ensureValidVNode(slot(props));
    const rendered = $ffe19d932e7e7bce$export$9f2dfe8048dfb22b($ffe19d932e7e7bce$export$ffb0004e005737fa, {
        key: props.key || // slot content array of a dynamic conditional slot may have a branch
        // key attached in the `createSlots` helper, respect that
        validSlotContent && validSlotContent.key || `_${name}`
    }, validSlotContent || (fallback ? fallback() : []), validSlotContent && slots._ === 1 ? 64 : -2);
    if (!noSlotted && rendered.scopeId) rendered.slotScopeIds = [
        rendered.scopeId + "-s"
    ];
    if (slot && slot._c) slot._d = true;
    return rendered;
}
function $ffe19d932e7e7bce$var$ensureValidVNode(vnodes) {
    return vnodes.some((child)=>{
        if (!$ffe19d932e7e7bce$export$3868d13f8734ae81(child)) return true;
        if (child.type === $ffe19d932e7e7bce$export$4d299b491347818a) return false;
        if (child.type === $ffe19d932e7e7bce$export$ffb0004e005737fa && !$ffe19d932e7e7bce$var$ensureValidVNode(child.children)) return false;
        return true;
    }) ? vnodes : null;
}
function $ffe19d932e7e7bce$export$2fb94ff667a6a1a(obj, preserveCaseIfNecessary) {
    const ret = {};
    for(const key in obj)ret[preserveCaseIfNecessary && /[A-Z]/.test(key) ? `on:${key}` : (0, $16Sl1.toHandlerKey)(key)] = obj[key];
    return ret;
}
const $ffe19d932e7e7bce$var$getPublicInstance = (i)=>{
    if (!i) return null;
    if ($ffe19d932e7e7bce$var$isStatefulComponent(i)) return $ffe19d932e7e7bce$var$getExposeProxy(i) || i.proxy;
    return $ffe19d932e7e7bce$var$getPublicInstance(i.parent);
};
const $ffe19d932e7e7bce$var$publicPropertiesMap = // Move PURE marker to new line to workaround compiler discarding it
// due to type annotation
/* @__PURE__ */ (0, $16Sl1.extend)(/* @__PURE__ */ Object.create(null), {
    $: (i)=>i,
    $el: (i)=>i.vnode.el,
    $data: (i)=>i.data,
    $props: (i)=>(0, i.props),
    $attrs: (i)=>(0, i.attrs),
    $slots: (i)=>(0, i.slots),
    $refs: (i)=>(0, i.refs),
    $parent: (i)=>$ffe19d932e7e7bce$var$getPublicInstance(i.parent),
    $root: (i)=>$ffe19d932e7e7bce$var$getPublicInstance(i.root),
    $emit: (i)=>i.emit,
    $options: (i)=>__VUE_OPTIONS_API__ ? $ffe19d932e7e7bce$var$resolveMergedOptions(i) : i.type,
    $forceUpdate: (i)=>i.f || (i.f = ()=>{
            i.effect.dirty = true;
            $ffe19d932e7e7bce$var$queueJob(i.update);
        }),
    $nextTick: (i)=>i.n || (i.n = $ffe19d932e7e7bce$export$bdd553fddd433dcb.bind(i.proxy)),
    $watch: (i)=>__VUE_OPTIONS_API__ ? $ffe19d932e7e7bce$var$instanceWatch.bind(i) : (0, $16Sl1.NOOP)
});
const $ffe19d932e7e7bce$var$isReservedPrefix = (key)=>key === "_" || key === "$";
const $ffe19d932e7e7bce$var$hasSetupBinding = (state, key)=>state !== (0, $16Sl1.EMPTY_OBJ) && !state.__isScriptSetup && (0, $16Sl1.hasOwn)(state, key);
const $ffe19d932e7e7bce$var$PublicInstanceProxyHandlers = {
    get ({ _: instance }, key) {
        if (key === "__v_skip") return true;
        const { ctx: ctx, setupState: setupState, data: data, props: props, accessCache: accessCache, type: type, appContext: appContext } = instance;
        let normalizedProps;
        if (key[0] !== "$") {
            const n = accessCache[key];
            if (n !== void 0) switch(n){
                case 1 /* SETUP */ :
                    return setupState[key];
                case 2 /* DATA */ :
                    return data[key];
                case 4 /* CONTEXT */ :
                    return ctx[key];
                case 3 /* PROPS */ :
                    return props[key];
            }
            else if ($ffe19d932e7e7bce$var$hasSetupBinding(setupState, key)) {
                accessCache[key] = 1 /* SETUP */ ;
                return setupState[key];
            } else if (data !== (0, $16Sl1.EMPTY_OBJ) && (0, $16Sl1.hasOwn)(data, key)) {
                accessCache[key] = 2 /* DATA */ ;
                return data[key];
            } else if (// only cache other properties when instance has declared (thus stable)
            // props
            (normalizedProps = instance.propsOptions[0]) && (0, $16Sl1.hasOwn)(normalizedProps, key)) {
                accessCache[key] = 3 /* PROPS */ ;
                return props[key];
            } else if (ctx !== (0, $16Sl1.EMPTY_OBJ) && (0, $16Sl1.hasOwn)(ctx, key)) {
                accessCache[key] = 4 /* CONTEXT */ ;
                return ctx[key];
            } else if (!__VUE_OPTIONS_API__ || $ffe19d932e7e7bce$var$shouldCacheAccess) accessCache[key] = 0 /* OTHER */ ;
        }
        const publicGetter = $ffe19d932e7e7bce$var$publicPropertiesMap[key];
        let cssModule, globalProperties;
        if (publicGetter) {
            if (key === "$attrs") (0, $99kuS.track)(instance.attrs, "get", "");
            return publicGetter(instance);
        } else if (// css module (injected by vue-loader)
        (cssModule = type.__cssModules) && (cssModule = cssModule[key])) return cssModule;
        else if (ctx !== (0, $16Sl1.EMPTY_OBJ) && (0, $16Sl1.hasOwn)(ctx, key)) {
            accessCache[key] = 4 /* CONTEXT */ ;
            return ctx[key];
        } else if (// global properties
        globalProperties = appContext.config.globalProperties, (0, $16Sl1.hasOwn)(globalProperties, key)) return globalProperties[key];
    },
    set ({ _: instance }, key, value) {
        const { data: data, setupState: setupState, ctx: ctx } = instance;
        if ($ffe19d932e7e7bce$var$hasSetupBinding(setupState, key)) {
            setupState[key] = value;
            return true;
        } else {
            if (data !== (0, $16Sl1.EMPTY_OBJ) && (0, $16Sl1.hasOwn)(data, key)) {
                data[key] = value;
                return true;
            } else if ((0, $16Sl1.hasOwn)(instance.props, key)) return false;
        }
        if (key[0] === "$" && key.slice(1) in instance) return false;
        else ctx[key] = value;
        return true;
    },
    has ({ _: { data: data, setupState: setupState, accessCache: accessCache, ctx: ctx, appContext: appContext, propsOptions: propsOptions } }, key) {
        let normalizedProps;
        return !!accessCache[key] || data !== (0, $16Sl1.EMPTY_OBJ) && (0, $16Sl1.hasOwn)(data, key) || $ffe19d932e7e7bce$var$hasSetupBinding(setupState, key) || (normalizedProps = propsOptions[0]) && (0, $16Sl1.hasOwn)(normalizedProps, key) || (0, $16Sl1.hasOwn)(ctx, key) || (0, $16Sl1.hasOwn)($ffe19d932e7e7bce$var$publicPropertiesMap, key) || (0, $16Sl1.hasOwn)(appContext.config.globalProperties, key);
    },
    defineProperty (target, key, descriptor) {
        if (descriptor.get != null) target._.accessCache[key] = 0;
        else if ((0, $16Sl1.hasOwn)(descriptor, "value")) this.set(target, key, descriptor.value, null);
        return Reflect.defineProperty(target, key, descriptor);
    }
};
var $ffe19d932e7e7bce$var$target;
const $ffe19d932e7e7bce$var$RuntimeCompiledPublicInstanceProxyHandlers = /* @__PURE__ */ (0, $16Sl1.extend)({}, $ffe19d932e7e7bce$var$PublicInstanceProxyHandlers, {
    get (target, key) {
        if (key === Symbol.unscopables) return;
        return $ffe19d932e7e7bce$var$PublicInstanceProxyHandlers.get(target, key, target);
    },
    has (_, key) {
        const has = key[0] !== "_" && !(0, $16Sl1.isGloballyAllowed)(key);
        return has;
    }
});
function $ffe19d932e7e7bce$var$createDevRenderContext(instance) {
    const target = {};
    Object.defineProperty(target, `_`, {
        configurable: true,
        enumerable: false,
        get: ()=>instance
    });
    Object.keys($ffe19d932e7e7bce$var$publicPropertiesMap).forEach((key)=>{
        Object.defineProperty(target, key, {
            configurable: true,
            enumerable: false,
            get: ()=>$ffe19d932e7e7bce$var$publicPropertiesMap[key](instance),
            // intercepted by the proxy so no need for implementation,
            // but needed to prevent set errors
            set: (0, $16Sl1.NOOP)
        });
    });
    return target;
}
function $ffe19d932e7e7bce$var$exposePropsOnRenderContext(instance) {
    const { ctx: ctx, propsOptions: [propsOptions] } = instance;
    if (propsOptions) Object.keys(propsOptions).forEach((key)=>{
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>instance.props[key],
            set: (0, $16Sl1.NOOP)
        });
    });
}
function $ffe19d932e7e7bce$var$exposeSetupStateOnRenderContext(instance) {
    const { ctx: ctx, setupState: setupState } = instance;
    Object.keys((0, $99kuS.toRaw)(setupState)).forEach((key)=>{
        if (!setupState.__isScriptSetup) {
            if ($ffe19d932e7e7bce$var$isReservedPrefix(key[0])) {
                $ffe19d932e7e7bce$var$warn$1(`setup() return property ${JSON.stringify(key)} should not start with "$" or "_" which are reserved prefixes for Vue internals.`);
                return;
            }
            Object.defineProperty(ctx, key, {
                enumerable: true,
                configurable: true,
                get: ()=>setupState[key],
                set: (0, $16Sl1.NOOP)
            });
        }
    });
}
const $ffe19d932e7e7bce$var$warnRuntimeUsage = (method)=>$ffe19d932e7e7bce$var$warn$1(`${method}() is a compiler-hint helper that is only usable inside <script setup> of a single file component. Its arguments should be compiled away and passing it at runtime has no effect.`);
function $ffe19d932e7e7bce$export$80b33eababae110e() {
    return null;
}
function $ffe19d932e7e7bce$export$51ecece22fc17ddc() {
    return null;
}
function $ffe19d932e7e7bce$export$da25b65ca24b518a(exposed) {}
function $ffe19d932e7e7bce$export$77e79129327f3d0d(options) {}
function $ffe19d932e7e7bce$export$1b3acd4bb805b712() {
    return null;
}
function $ffe19d932e7e7bce$export$acd55aa037e791bb() {}
function $ffe19d932e7e7bce$export$4df9c0969a9e0160(props, defaults) {
    return null;
}
function $ffe19d932e7e7bce$export$9203a8e84125433c() {
    return $ffe19d932e7e7bce$var$getContext().slots;
}
function $ffe19d932e7e7bce$export$75e29435042cd2ea() {
    return $ffe19d932e7e7bce$var$getContext().attrs;
}
function $ffe19d932e7e7bce$var$getContext() {
    const i = $ffe19d932e7e7bce$export$f13e630aa3915748();
    return i.setupContext || (i.setupContext = $ffe19d932e7e7bce$var$createSetupContext(i));
}
function $ffe19d932e7e7bce$var$normalizePropsOrEmits(props) {
    return (0, $16Sl1.isArray)(props) ? props.reduce((normalized, p)=>(normalized[p] = null, normalized), {}) : props;
}
function $ffe19d932e7e7bce$export$ec60f47d4a8a2e7f(raw, defaults) {
    const props = $ffe19d932e7e7bce$var$normalizePropsOrEmits(raw);
    for(const key in defaults){
        if (key.startsWith("__skip")) continue;
        let opt = props[key];
        if (opt) {
            if ((0, $16Sl1.isArray)(opt) || (0, $16Sl1.isFunction)(opt)) opt = props[key] = {
                type: opt,
                default: defaults[key]
            };
            else opt.default = defaults[key];
        } else if (opt === null) opt = props[key] = {
            default: defaults[key]
        };
        if (opt && defaults[`__skip_${key}`]) opt.skipFactory = true;
    }
    return props;
}
function $ffe19d932e7e7bce$export$ad4f724f587e6828(a, b) {
    if (!a || !b) return a || b;
    if ((0, $16Sl1.isArray)(a) && (0, $16Sl1.isArray)(b)) return a.concat(b);
    return (0, $16Sl1.extend)({}, $ffe19d932e7e7bce$var$normalizePropsOrEmits(a), $ffe19d932e7e7bce$var$normalizePropsOrEmits(b));
}
function $ffe19d932e7e7bce$export$7c343e855c563faa(props, excludedKeys) {
    const ret = {};
    for(const key in props)if (!excludedKeys.includes(key)) Object.defineProperty(ret, key, {
        enumerable: true,
        get: ()=>props[key]
    });
    return ret;
}
function $ffe19d932e7e7bce$export$d6d6f7369f1fb104(getAwaitable) {
    const ctx = $ffe19d932e7e7bce$export$f13e630aa3915748();
    let awaitable = getAwaitable();
    $ffe19d932e7e7bce$var$unsetCurrentInstance();
    if ((0, $16Sl1.isPromise)(awaitable)) awaitable = awaitable.catch((e)=>{
        $ffe19d932e7e7bce$var$setCurrentInstance(ctx);
        throw e;
    });
    return [
        awaitable,
        ()=>$ffe19d932e7e7bce$var$setCurrentInstance(ctx)
    ];
}
function $ffe19d932e7e7bce$var$createDuplicateChecker() {
    const cache = /* @__PURE__ */ Object.create(null);
    return (type, key)=>{
        if (cache[key]) $ffe19d932e7e7bce$var$warn$1(`${type} property "${key}" is already defined in ${cache[key]}.`);
        else cache[key] = type;
    };
}
let $ffe19d932e7e7bce$var$shouldCacheAccess = true;
function $ffe19d932e7e7bce$var$applyOptions(instance) {
    const options = $ffe19d932e7e7bce$var$resolveMergedOptions(instance);
    const publicThis = instance.proxy;
    const ctx = instance.ctx;
    $ffe19d932e7e7bce$var$shouldCacheAccess = false;
    if (options.beforeCreate) $ffe19d932e7e7bce$var$callHook(options.beforeCreate, instance, "bc");
    const { // state
    data: dataOptions, computed: computedOptions, methods: methods, watch: watchOptions, provide: provideOptions, inject: injectOptions, created: // lifecycle
    created, beforeMount: beforeMount, mounted: mounted, beforeUpdate: beforeUpdate, updated: updated, activated: activated, deactivated: deactivated, beforeDestroy: beforeDestroy, beforeUnmount: beforeUnmount, destroyed: destroyed, unmounted: unmounted, render: render, renderTracked: renderTracked, renderTriggered: renderTriggered, errorCaptured: errorCaptured, serverPrefetch: serverPrefetch, expose: // public API
    expose, inheritAttrs: inheritAttrs, components: // assets
    components, directives: directives, filters: filters } = options;
    const checkDuplicateProperties = null;
    if (injectOptions) $ffe19d932e7e7bce$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties);
    if (methods) for(const key in methods){
        const methodHandler = methods[key];
        if ((0, $16Sl1.isFunction)(methodHandler)) ctx[key] = methodHandler.bind(publicThis);
    }
    if (dataOptions) {
        const data = dataOptions.call(publicThis, publicThis);
        if (!(0, $16Sl1.isObject)(data)) ;
        else instance.data = (0, $99kuS.reactive)(data);
    }
    $ffe19d932e7e7bce$var$shouldCacheAccess = true;
    if (computedOptions) for(const key in computedOptions){
        const opt = computedOptions[key];
        const get = (0, $16Sl1.isFunction)(opt) ? opt.bind(publicThis, publicThis) : (0, $16Sl1.isFunction)(opt.get) ? opt.get.bind(publicThis, publicThis) : (0, $16Sl1.NOOP);
        const set = !(0, $16Sl1.isFunction)(opt) && (0, $16Sl1.isFunction)(opt.set) ? opt.set.bind(publicThis) : (0, $16Sl1.NOOP);
        const c = $ffe19d932e7e7bce$export$2983e091f1a1e8e2({
            get: get,
            set: set
        });
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>c.value,
            set: (v1)=>c.value = v1
        });
    }
    if (watchOptions) for(const key in watchOptions)$ffe19d932e7e7bce$var$createWatcher(watchOptions[key], ctx, publicThis, key);
    if (provideOptions) {
        const provides = (0, $16Sl1.isFunction)(provideOptions) ? provideOptions.call(publicThis) : provideOptions;
        Reflect.ownKeys(provides).forEach((key)=>{
            $ffe19d932e7e7bce$export$abe1e183e22e10ad(key, provides[key]);
        });
    }
    if (created) $ffe19d932e7e7bce$var$callHook(created, instance, "c");
    function registerLifecycleHook(register, hook) {
        if ((0, $16Sl1.isArray)(hook)) hook.forEach((_hook)=>register(_hook.bind(publicThis)));
        else if (hook) register(hook.bind(publicThis));
    }
    registerLifecycleHook($ffe19d932e7e7bce$export$23b7aeb0d671f804, beforeMount);
    registerLifecycleHook($ffe19d932e7e7bce$export$6d1641039221b5cb, mounted);
    registerLifecycleHook($ffe19d932e7e7bce$export$ab91988a13872e4c, beforeUpdate);
    registerLifecycleHook($ffe19d932e7e7bce$export$5876c47052fb88b1, updated);
    registerLifecycleHook($ffe19d932e7e7bce$export$ba52d824b95a2154, activated);
    registerLifecycleHook($ffe19d932e7e7bce$export$bf1440eeaf5fa709, deactivated);
    registerLifecycleHook($ffe19d932e7e7bce$export$6a3a15856e50ad19, errorCaptured);
    registerLifecycleHook($ffe19d932e7e7bce$export$2b41f4235363e921, renderTracked);
    registerLifecycleHook($ffe19d932e7e7bce$export$898295a813d662eb, renderTriggered);
    registerLifecycleHook($ffe19d932e7e7bce$export$40c420df62d2614, beforeUnmount);
    registerLifecycleHook($ffe19d932e7e7bce$export$13348a43ccacfe58, unmounted);
    registerLifecycleHook($ffe19d932e7e7bce$export$ebf0c601f267bceb, serverPrefetch);
    if ((0, $16Sl1.isArray)(expose)) {
        if (expose.length) {
            const exposed = instance.exposed || (instance.exposed = {});
            expose.forEach((key)=>{
                Object.defineProperty(exposed, key, {
                    get: ()=>publicThis[key],
                    set: (val)=>publicThis[key] = val
                });
            });
        } else if (!instance.exposed) instance.exposed = {};
    }
    if (render && instance.render === (0, $16Sl1.NOOP)) instance.render = render;
    if (inheritAttrs != null) instance.inheritAttrs = inheritAttrs;
    if (components) instance.components = components;
    if (directives) instance.directives = directives;
}
function $ffe19d932e7e7bce$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties = (0, $16Sl1.NOOP)) {
    if ((0, $16Sl1.isArray)(injectOptions)) injectOptions = $ffe19d932e7e7bce$var$normalizeInject(injectOptions);
    for(const key in injectOptions){
        const opt = injectOptions[key];
        let injected;
        if ((0, $16Sl1.isObject)(opt)) {
            if ("default" in opt) injected = $ffe19d932e7e7bce$export$a976684a0efeb93f(opt.from || key, opt.default, true);
            else injected = $ffe19d932e7e7bce$export$a976684a0efeb93f(opt.from || key);
        } else injected = $ffe19d932e7e7bce$export$a976684a0efeb93f(opt);
        if ((0, $99kuS.isRef)(injected)) Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>injected.value,
            set: (v1)=>injected.value = v1
        });
        else ctx[key] = injected;
    }
}
function $ffe19d932e7e7bce$var$callHook(hook, instance, type) {
    $ffe19d932e7e7bce$export$dae85862a8d94378((0, $16Sl1.isArray)(hook) ? hook.map((h)=>h.bind(instance.proxy)) : hook.bind(instance.proxy), instance, type);
}
function $ffe19d932e7e7bce$var$createWatcher(raw, ctx, publicThis, key) {
    const getter = key.includes(".") ? $ffe19d932e7e7bce$var$createPathGetter(publicThis, key) : ()=>publicThis[key];
    if ((0, $16Sl1.isString)(raw)) {
        const handler = ctx[raw];
        if ((0, $16Sl1.isFunction)(handler)) $ffe19d932e7e7bce$export$3db5d71bdb2d5499(getter, handler);
    } else if ((0, $16Sl1.isFunction)(raw)) $ffe19d932e7e7bce$export$3db5d71bdb2d5499(getter, raw.bind(publicThis));
    else if ((0, $16Sl1.isObject)(raw)) {
        if ((0, $16Sl1.isArray)(raw)) raw.forEach((r)=>$ffe19d932e7e7bce$var$createWatcher(r, ctx, publicThis, key));
        else {
            const handler = (0, $16Sl1.isFunction)(raw.handler) ? raw.handler.bind(publicThis) : ctx[raw.handler];
            if ((0, $16Sl1.isFunction)(handler)) $ffe19d932e7e7bce$export$3db5d71bdb2d5499(getter, handler, raw);
        }
    } else ;
}
function $ffe19d932e7e7bce$var$resolveMergedOptions(instance) {
    const base = instance.type;
    const { mixins: mixins, extends: extendsOptions } = base;
    const { mixins: globalMixins, optionsCache: cache, config: { optionMergeStrategies: optionMergeStrategies } } = instance.appContext;
    const cached = cache.get(base);
    let resolved;
    if (cached) resolved = cached;
    else if (!globalMixins.length && !mixins && !extendsOptions) resolved = base;
    else {
        resolved = {};
        if (globalMixins.length) globalMixins.forEach((m)=>$ffe19d932e7e7bce$var$mergeOptions(resolved, m, optionMergeStrategies, true));
        $ffe19d932e7e7bce$var$mergeOptions(resolved, base, optionMergeStrategies);
    }
    if ((0, $16Sl1.isObject)(base)) cache.set(base, resolved);
    return resolved;
}
function $ffe19d932e7e7bce$var$mergeOptions(to, from, strats, asMixin = false) {
    const { mixins: mixins, extends: extendsOptions } = from;
    if (extendsOptions) $ffe19d932e7e7bce$var$mergeOptions(to, extendsOptions, strats, true);
    if (mixins) mixins.forEach((m)=>$ffe19d932e7e7bce$var$mergeOptions(to, m, strats, true));
    for(const key in from){
        if (asMixin && key === "expose") ;
        else {
            const strat = $ffe19d932e7e7bce$var$internalOptionMergeStrats[key] || strats && strats[key];
            to[key] = strat ? strat(to[key], from[key]) : from[key];
        }
    }
    return to;
}
const $ffe19d932e7e7bce$var$internalOptionMergeStrats = {
    data: $ffe19d932e7e7bce$var$mergeDataFn,
    props: $ffe19d932e7e7bce$var$mergeEmitsOrPropsOptions,
    emits: $ffe19d932e7e7bce$var$mergeEmitsOrPropsOptions,
    // objects
    methods: $ffe19d932e7e7bce$var$mergeObjectOptions,
    computed: $ffe19d932e7e7bce$var$mergeObjectOptions,
    // lifecycle
    beforeCreate: $ffe19d932e7e7bce$var$mergeAsArray,
    created: $ffe19d932e7e7bce$var$mergeAsArray,
    beforeMount: $ffe19d932e7e7bce$var$mergeAsArray,
    mounted: $ffe19d932e7e7bce$var$mergeAsArray,
    beforeUpdate: $ffe19d932e7e7bce$var$mergeAsArray,
    updated: $ffe19d932e7e7bce$var$mergeAsArray,
    beforeDestroy: $ffe19d932e7e7bce$var$mergeAsArray,
    beforeUnmount: $ffe19d932e7e7bce$var$mergeAsArray,
    destroyed: $ffe19d932e7e7bce$var$mergeAsArray,
    unmounted: $ffe19d932e7e7bce$var$mergeAsArray,
    activated: $ffe19d932e7e7bce$var$mergeAsArray,
    deactivated: $ffe19d932e7e7bce$var$mergeAsArray,
    errorCaptured: $ffe19d932e7e7bce$var$mergeAsArray,
    serverPrefetch: $ffe19d932e7e7bce$var$mergeAsArray,
    // assets
    components: $ffe19d932e7e7bce$var$mergeObjectOptions,
    directives: $ffe19d932e7e7bce$var$mergeObjectOptions,
    // watch
    watch: $ffe19d932e7e7bce$var$mergeWatchOptions,
    // provide / inject
    provide: $ffe19d932e7e7bce$var$mergeDataFn,
    inject: $ffe19d932e7e7bce$var$mergeInject
};
function $ffe19d932e7e7bce$var$mergeDataFn(to, from) {
    if (!from) return to;
    if (!to) return from;
    return function mergedDataFn() {
        return (0, $16Sl1.extend)((0, $16Sl1.isFunction)(to) ? to.call(this, this) : to, (0, $16Sl1.isFunction)(from) ? from.call(this, this) : from);
    };
}
function $ffe19d932e7e7bce$var$mergeInject(to, from) {
    return $ffe19d932e7e7bce$var$mergeObjectOptions($ffe19d932e7e7bce$var$normalizeInject(to), $ffe19d932e7e7bce$var$normalizeInject(from));
}
function $ffe19d932e7e7bce$var$normalizeInject(raw) {
    if ((0, $16Sl1.isArray)(raw)) {
        const res = {};
        for(let i = 0; i < raw.length; i++)res[raw[i]] = raw[i];
        return res;
    }
    return raw;
}
function $ffe19d932e7e7bce$var$mergeAsArray(to, from) {
    return to ? [
        ...new Set([].concat(to, from))
    ] : from;
}
function $ffe19d932e7e7bce$var$mergeObjectOptions(to, from) {
    return to ? (0, $16Sl1.extend)(/* @__PURE__ */ Object.create(null), to, from) : from;
}
function $ffe19d932e7e7bce$var$mergeEmitsOrPropsOptions(to, from) {
    if (to) {
        if ((0, $16Sl1.isArray)(to) && (0, $16Sl1.isArray)(from)) return [
            .../* @__PURE__ */ new Set([
                ...to,
                ...from
            ])
        ];
        return (0, $16Sl1.extend)(/* @__PURE__ */ Object.create(null), $ffe19d932e7e7bce$var$normalizePropsOrEmits(to), $ffe19d932e7e7bce$var$normalizePropsOrEmits(from != null ? from : {}));
    } else return from;
}
function $ffe19d932e7e7bce$var$mergeWatchOptions(to, from) {
    if (!to) return from;
    if (!from) return to;
    const merged = (0, $16Sl1.extend)(/* @__PURE__ */ Object.create(null), to);
    for(const key in from)merged[key] = $ffe19d932e7e7bce$var$mergeAsArray(to[key], from[key]);
    return merged;
}
function $ffe19d932e7e7bce$var$createAppContext() {
    return {
        app: null,
        config: {
            isNativeTag: (0, $16Sl1.NO),
            performance: false,
            globalProperties: {},
            optionMergeStrategies: {},
            errorHandler: void 0,
            warnHandler: void 0,
            compilerOptions: {}
        },
        mixins: [],
        components: {},
        directives: {},
        provides: /* @__PURE__ */ Object.create(null),
        optionsCache: /* @__PURE__ */ new WeakMap(),
        propsCache: /* @__PURE__ */ new WeakMap(),
        emitsCache: /* @__PURE__ */ new WeakMap()
    };
}
let $ffe19d932e7e7bce$var$uid$1 = 0;
function $ffe19d932e7e7bce$var$createAppAPI(render, hydrate) {
    return function createApp(rootComponent, rootProps = null) {
        if (!(0, $16Sl1.isFunction)(rootComponent)) rootComponent = (0, $16Sl1.extend)({}, rootComponent);
        if (rootProps != null && !(0, $16Sl1.isObject)(rootProps)) rootProps = null;
        const context = $ffe19d932e7e7bce$var$createAppContext();
        const installedPlugins = /* @__PURE__ */ new WeakSet();
        let isMounted = false;
        const app = context.app = {
            _uid: $ffe19d932e7e7bce$var$uid$1++,
            _component: rootComponent,
            _props: rootProps,
            _container: null,
            _context: context,
            _instance: null,
            version: $ffe19d932e7e7bce$export$83d89fbfd8236492,
            get config () {
                return context.config;
            },
            set config (v){},
            use (plugin, ...options) {
                if (installedPlugins.has(plugin)) ;
                else if (plugin && (0, $16Sl1.isFunction)(plugin.install)) {
                    installedPlugins.add(plugin);
                    plugin.install(app, ...options);
                } else if ((0, $16Sl1.isFunction)(plugin)) {
                    installedPlugins.add(plugin);
                    plugin(app, ...options);
                }
                return app;
            },
            mixin (mixin) {
                if (__VUE_OPTIONS_API__) {
                    if (!context.mixins.includes(mixin)) context.mixins.push(mixin);
                }
                return app;
            },
            component (name, component) {
                if (!component) return context.components[name];
                context.components[name] = component;
                return app;
            },
            directive (name, directive) {
                if (!directive) return context.directives[name];
                context.directives[name] = directive;
                return app;
            },
            mount (rootContainer, isHydrate, namespace) {
                if (!isMounted) {
                    const vnode = $ffe19d932e7e7bce$export$bf5c4cf060303d58(rootComponent, rootProps);
                    vnode.appContext = context;
                    if (namespace === true) namespace = "svg";
                    else if (namespace === false) namespace = void 0;
                    if (isHydrate && hydrate) hydrate(vnode, rootContainer);
                    else render(vnode, rootContainer, namespace);
                    isMounted = true;
                    app._container = rootContainer;
                    rootContainer.__vue_app__ = app;
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = vnode.component;
                        $ffe19d932e7e7bce$var$devtoolsInitApp(app, $ffe19d932e7e7bce$export$83d89fbfd8236492);
                    }
                    return $ffe19d932e7e7bce$var$getExposeProxy(vnode.component) || vnode.component.proxy;
                }
            },
            unmount () {
                if (isMounted) {
                    render(null, app._container);
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = null;
                        $ffe19d932e7e7bce$var$devtoolsUnmountApp(app);
                    }
                    delete app._container.__vue_app__;
                }
            },
            provide (key, value) {
                context.provides[key] = value;
                return app;
            },
            runWithContext (fn) {
                const lastApp = $ffe19d932e7e7bce$var$currentApp;
                $ffe19d932e7e7bce$var$currentApp = app;
                try {
                    return fn();
                } finally{
                    $ffe19d932e7e7bce$var$currentApp = lastApp;
                }
            }
        };
        return app;
    };
}
let $ffe19d932e7e7bce$var$currentApp = null;
function $ffe19d932e7e7bce$export$abe1e183e22e10ad(key, value) {
    if (!$ffe19d932e7e7bce$var$currentInstance) ;
    else {
        let provides = $ffe19d932e7e7bce$var$currentInstance.provides;
        const parentProvides = $ffe19d932e7e7bce$var$currentInstance.parent && $ffe19d932e7e7bce$var$currentInstance.parent.provides;
        if (parentProvides === provides) provides = $ffe19d932e7e7bce$var$currentInstance.provides = Object.create(parentProvides);
        provides[key] = value;
    }
}
function $ffe19d932e7e7bce$export$a976684a0efeb93f(key, defaultValue, treatDefaultAsFactory = false) {
    const instance = $ffe19d932e7e7bce$var$currentInstance || $ffe19d932e7e7bce$var$currentRenderingInstance;
    if (instance || $ffe19d932e7e7bce$var$currentApp) {
        const provides = instance ? instance.parent == null ? instance.vnode.appContext && instance.vnode.appContext.provides : instance.parent.provides : $ffe19d932e7e7bce$var$currentApp._context.provides;
        if (provides && key in provides) return provides[key];
        else if (arguments.length > 1) return treatDefaultAsFactory && (0, $16Sl1.isFunction)(defaultValue) ? defaultValue.call(instance && instance.proxy) : defaultValue;
    }
}
function $ffe19d932e7e7bce$export$caf6761f24fc571a() {
    return !!($ffe19d932e7e7bce$var$currentInstance || $ffe19d932e7e7bce$var$currentRenderingInstance || $ffe19d932e7e7bce$var$currentApp);
}
const $ffe19d932e7e7bce$var$internalObjectProto = {};
const $ffe19d932e7e7bce$var$createInternalObject = ()=>Object.create($ffe19d932e7e7bce$var$internalObjectProto);
const $ffe19d932e7e7bce$var$isInternalObject = (obj)=>Object.getPrototypeOf(obj) === $ffe19d932e7e7bce$var$internalObjectProto;
function $ffe19d932e7e7bce$var$initProps(instance, rawProps, isStateful, isSSR = false) {
    const props = {};
    const attrs = $ffe19d932e7e7bce$var$createInternalObject();
    instance.propsDefaults = /* @__PURE__ */ Object.create(null);
    $ffe19d932e7e7bce$var$setFullProps(instance, rawProps, props, attrs);
    for(const key in instance.propsOptions[0])if (!(key in props)) props[key] = void 0;
    if (isStateful) instance.props = isSSR ? props : (0, $99kuS.shallowReactive)(props);
    else if (!instance.type.props) instance.props = attrs;
    else instance.props = props;
    instance.attrs = attrs;
}
function $ffe19d932e7e7bce$var$isInHmrContext(instance) {
    while(instance){
        if (instance.type.__hmrId) return true;
        instance = instance.parent;
    }
}
function $ffe19d932e7e7bce$var$updateProps(instance, rawProps, rawPrevProps, optimized) {
    const { props: props, attrs: attrs, vnode: { patchFlag: patchFlag } } = instance;
    const rawCurrentProps = (0, $99kuS.toRaw)(props);
    const [options] = instance.propsOptions;
    let hasAttrsChanged = false;
    if (// always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    (optimized || patchFlag > 0) && !(patchFlag & 16)) {
        if (patchFlag & 8) {
            const propsToUpdate = instance.vnode.dynamicProps;
            for(let i = 0; i < propsToUpdate.length; i++){
                let key = propsToUpdate[i];
                if ($ffe19d932e7e7bce$var$isEmitListener(instance.emitsOptions, key)) continue;
                const value = rawProps[key];
                if (options) {
                    if ((0, $16Sl1.hasOwn)(attrs, key)) {
                        if (value !== attrs[key]) {
                            attrs[key] = value;
                            hasAttrsChanged = true;
                        }
                    } else {
                        const camelizedKey = (0, $16Sl1.camelize)(key);
                        props[camelizedKey] = $ffe19d932e7e7bce$var$resolvePropValue(options, rawCurrentProps, camelizedKey, value, instance, false);
                    }
                } else if (value !== attrs[key]) {
                    attrs[key] = value;
                    hasAttrsChanged = true;
                }
            }
        }
    } else {
        if ($ffe19d932e7e7bce$var$setFullProps(instance, rawProps, props, attrs)) hasAttrsChanged = true;
        let kebabKey;
        for(const key in rawCurrentProps)if (!rawProps || // for camelCase
        !(0, $16Sl1.hasOwn)(rawProps, key) && // it's possible the original props was passed in as kebab-case
        // and converted to camelCase (#955)
        ((kebabKey = (0, $16Sl1.hyphenate)(key)) === key || !(0, $16Sl1.hasOwn)(rawProps, kebabKey))) {
            if (options) {
                if (rawPrevProps && // for camelCase
                (rawPrevProps[key] !== void 0 || // for kebab-case
                rawPrevProps[kebabKey] !== void 0)) props[key] = $ffe19d932e7e7bce$var$resolvePropValue(options, rawCurrentProps, key, void 0, instance, true);
            } else delete props[key];
        }
        if (attrs !== rawCurrentProps) {
            for(const key in attrs)if (!rawProps || !(0, $16Sl1.hasOwn)(rawProps, key) && true) {
                delete attrs[key];
                hasAttrsChanged = true;
            }
        }
    }
    if (hasAttrsChanged) (0, $99kuS.trigger)(instance.attrs, "set", "");
}
function $ffe19d932e7e7bce$var$setFullProps(instance, rawProps, props, attrs) {
    const [options, needCastKeys] = instance.propsOptions;
    let hasAttrsChanged = false;
    let rawCastValues;
    if (rawProps) for(let key in rawProps){
        if ((0, $16Sl1.isReservedProp)(key)) continue;
        const value = rawProps[key];
        let camelKey;
        if (options && (0, $16Sl1.hasOwn)(options, camelKey = (0, $16Sl1.camelize)(key))) {
            if (!needCastKeys || !needCastKeys.includes(camelKey)) props[camelKey] = value;
            else (rawCastValues || (rawCastValues = {}))[camelKey] = value;
        } else if (!$ffe19d932e7e7bce$var$isEmitListener(instance.emitsOptions, key)) {
            if (!(key in attrs) || value !== attrs[key]) {
                attrs[key] = value;
                hasAttrsChanged = true;
            }
        }
    }
    if (needCastKeys) {
        const rawCurrentProps = (0, $99kuS.toRaw)(props);
        const castValues = rawCastValues || (0, $16Sl1.EMPTY_OBJ);
        for(let i = 0; i < needCastKeys.length; i++){
            const key = needCastKeys[i];
            props[key] = $ffe19d932e7e7bce$var$resolvePropValue(options, rawCurrentProps, key, castValues[key], instance, !(0, $16Sl1.hasOwn)(castValues, key));
        }
    }
    return hasAttrsChanged;
}
function $ffe19d932e7e7bce$var$resolvePropValue(options, props, key, value, instance, isAbsent) {
    const opt = options[key];
    if (opt != null) {
        const hasDefault = (0, $16Sl1.hasOwn)(opt, "default");
        if (hasDefault && value === void 0) {
            const defaultValue = opt.default;
            if (opt.type !== Function && !opt.skipFactory && (0, $16Sl1.isFunction)(defaultValue)) {
                const { propsDefaults: propsDefaults } = instance;
                if (key in propsDefaults) value = propsDefaults[key];
                else {
                    const reset = $ffe19d932e7e7bce$var$setCurrentInstance(instance);
                    value = propsDefaults[key] = defaultValue.call(null, props);
                    reset();
                }
            } else value = defaultValue;
        }
        if (opt[0 /* shouldCast */ ]) {
            if (isAbsent && !hasDefault) value = false;
            else if (opt[1 /* shouldCastTrue */ ] && (value === "" || value === (0, $16Sl1.hyphenate)(key))) value = true;
        }
    }
    return value;
}
function $ffe19d932e7e7bce$var$normalizePropsOptions(comp, appContext, asMixin = false) {
    const cache = appContext.propsCache;
    const cached = cache.get(comp);
    if (cached) return cached;
    const raw = comp.props;
    const normalized = {};
    const needCastKeys = [];
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $16Sl1.isFunction)(comp)) {
        const extendProps = (raw2)=>{
            hasExtends = true;
            const [props, keys] = $ffe19d932e7e7bce$var$normalizePropsOptions(raw2, appContext, true);
            (0, $16Sl1.extend)(normalized, props);
            if (keys) needCastKeys.push(...keys);
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendProps);
        if (comp.extends) extendProps(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendProps);
    }
    if (!raw && !hasExtends) {
        if ((0, $16Sl1.isObject)(comp)) cache.set(comp, (0, $16Sl1.EMPTY_ARR));
        return 0, $16Sl1.EMPTY_ARR;
    }
    if ((0, $16Sl1.isArray)(raw)) for(let i = 0; i < raw.length; i++){
        const normalizedKey = (0, $16Sl1.camelize)(raw[i]);
        if ($ffe19d932e7e7bce$var$validatePropName(normalizedKey)) normalized[normalizedKey] = (0, $16Sl1.EMPTY_OBJ);
    }
    else if (raw) for(const key in raw){
        const normalizedKey = (0, $16Sl1.camelize)(key);
        if ($ffe19d932e7e7bce$var$validatePropName(normalizedKey)) {
            const opt = raw[key];
            const prop = normalized[normalizedKey] = (0, $16Sl1.isArray)(opt) || (0, $16Sl1.isFunction)(opt) ? {
                type: opt
            } : (0, $16Sl1.extend)({}, opt);
            if (prop) {
                const booleanIndex = $ffe19d932e7e7bce$var$getTypeIndex(Boolean, prop.type);
                const stringIndex = $ffe19d932e7e7bce$var$getTypeIndex(String, prop.type);
                prop[0 /* shouldCast */ ] = booleanIndex > -1;
                prop[1 /* shouldCastTrue */ ] = stringIndex < 0 || booleanIndex < stringIndex;
                if (booleanIndex > -1 || (0, $16Sl1.hasOwn)(prop, "default")) needCastKeys.push(normalizedKey);
            }
        }
    }
    const res = [
        normalized,
        needCastKeys
    ];
    if ((0, $16Sl1.isObject)(comp)) cache.set(comp, res);
    return res;
}
function $ffe19d932e7e7bce$var$validatePropName(key) {
    if (key[0] !== "$" && !(0, $16Sl1.isReservedProp)(key)) return true;
    return false;
}
function $ffe19d932e7e7bce$var$getType(ctor) {
    if (ctor === null) return "null";
    if (typeof ctor === "function") return ctor.name || "";
    else if (typeof ctor === "object") {
        const name = ctor.constructor && ctor.constructor.name;
        return name || "";
    }
    return "";
}
function $ffe19d932e7e7bce$var$isSameType(a, b) {
    return $ffe19d932e7e7bce$var$getType(a) === $ffe19d932e7e7bce$var$getType(b);
}
function $ffe19d932e7e7bce$var$getTypeIndex(type, expectedTypes) {
    if ((0, $16Sl1.isArray)(expectedTypes)) return expectedTypes.findIndex((t)=>$ffe19d932e7e7bce$var$isSameType(t, type));
    else if ((0, $16Sl1.isFunction)(expectedTypes)) return $ffe19d932e7e7bce$var$isSameType(expectedTypes, type) ? 0 : -1;
    return -1;
}
function $ffe19d932e7e7bce$var$validateProps(rawProps, props, instance) {
    const resolvedValues = (0, $99kuS.toRaw)(props);
    const options = instance.propsOptions[0];
    for(const key in options){
        let opt = options[key];
        if (opt == null) continue;
        $ffe19d932e7e7bce$var$validateProp(key, resolvedValues[key], opt, resolvedValues, !(0, $16Sl1.hasOwn)(rawProps, key) && !(0, $16Sl1.hasOwn)(rawProps, (0, $16Sl1.hyphenate)(key)));
    }
}
function $ffe19d932e7e7bce$var$validateProp(name, value, prop, props, isAbsent) {
    const { type: type, required: required, validator: validator, skipCheck: skipCheck } = prop;
    if (required && isAbsent) {
        $ffe19d932e7e7bce$var$warn$1('Missing required prop: "' + name + '"');
        return;
    }
    if (value == null && !required) return;
    if (type != null && type !== true && !skipCheck) {
        let isValid = false;
        const types = (0, $16Sl1.isArray)(type) ? type : [
            type
        ];
        const expectedTypes = [];
        for(let i = 0; i < types.length && !isValid; i++){
            const { valid: valid, expectedType: expectedType } = $ffe19d932e7e7bce$var$assertType(value, types[i]);
            expectedTypes.push(expectedType || "");
            isValid = valid;
        }
        if (!isValid) {
            $ffe19d932e7e7bce$var$warn$1($ffe19d932e7e7bce$var$getInvalidTypeMessage(name, value, expectedTypes));
            return;
        }
    }
    if (validator && !validator(value, props)) $ffe19d932e7e7bce$var$warn$1('Invalid prop: custom validator check failed for prop "' + name + '".');
}
const $ffe19d932e7e7bce$var$isSimpleType = /* @__PURE__ */ (0, $16Sl1.makeMap)("String,Number,Boolean,Function,Symbol,BigInt");
function $ffe19d932e7e7bce$var$assertType(value, type) {
    let valid;
    const expectedType = $ffe19d932e7e7bce$var$getType(type);
    if ($ffe19d932e7e7bce$var$isSimpleType(expectedType)) {
        const t = typeof value;
        valid = t === expectedType.toLowerCase();
        if (!valid && t === "object") valid = value instanceof type;
    } else if (expectedType === "Object") valid = (0, $16Sl1.isObject)(value);
    else if (expectedType === "Array") valid = (0, $16Sl1.isArray)(value);
    else if (expectedType === "null") valid = value === null;
    else valid = value instanceof type;
    return {
        valid: valid,
        expectedType: expectedType
    };
}
function $ffe19d932e7e7bce$var$getInvalidTypeMessage(name, value, expectedTypes) {
    if (expectedTypes.length === 0) return `Prop type [] for prop "${name}" won't match anything. Did you mean to use type Array instead?`;
    let message = `Invalid prop: type check failed for prop "${name}". Expected ${expectedTypes.map((0, $16Sl1.capitalize)).join(" | ")}`;
    const expectedType = expectedTypes[0];
    const receivedType = (0, $16Sl1.toRawType)(value);
    const expectedValue = $ffe19d932e7e7bce$var$styleValue(value, expectedType);
    const receivedValue = $ffe19d932e7e7bce$var$styleValue(value, receivedType);
    if (expectedTypes.length === 1 && $ffe19d932e7e7bce$var$isExplicable(expectedType) && !$ffe19d932e7e7bce$var$isBoolean(expectedType, receivedType)) message += ` with value ${expectedValue}`;
    message += `, got ${receivedType} `;
    if ($ffe19d932e7e7bce$var$isExplicable(receivedType)) message += `with value ${receivedValue}.`;
    return message;
}
function $ffe19d932e7e7bce$var$styleValue(value, type) {
    if (type === "String") return `"${value}"`;
    else if (type === "Number") return `${Number(value)}`;
    else return `${value}`;
}
function $ffe19d932e7e7bce$var$isExplicable(type) {
    const explicitTypes = [
        "string",
        "number",
        "boolean"
    ];
    return explicitTypes.some((elem)=>type.toLowerCase() === elem);
}
function $ffe19d932e7e7bce$var$isBoolean(...args) {
    return args.some((elem)=>elem.toLowerCase() === "boolean");
}
const $ffe19d932e7e7bce$var$isInternalKey = (key)=>key[0] === "_" || key === "$stable";
const $ffe19d932e7e7bce$var$normalizeSlotValue = (value)=>(0, $16Sl1.isArray)(value) ? value.map($ffe19d932e7e7bce$var$normalizeVNode) : [
        $ffe19d932e7e7bce$var$normalizeVNode(value)
    ];
const $ffe19d932e7e7bce$var$normalizeSlot = (key, rawSlot, ctx)=>{
    if (rawSlot._n) return rawSlot;
    const normalized = $ffe19d932e7e7bce$export$694b237e827a3d23((...args)=>{
        return $ffe19d932e7e7bce$var$normalizeSlotValue(rawSlot(...args));
    }, ctx);
    normalized._c = false;
    return normalized;
};
const $ffe19d932e7e7bce$var$normalizeObjectSlots = (rawSlots, slots, instance)=>{
    const ctx = rawSlots._ctx;
    for(const key in rawSlots){
        if ($ffe19d932e7e7bce$var$isInternalKey(key)) continue;
        const value = rawSlots[key];
        if ((0, $16Sl1.isFunction)(value)) slots[key] = $ffe19d932e7e7bce$var$normalizeSlot(key, value, ctx);
        else if (value != null) {
            const normalized = $ffe19d932e7e7bce$var$normalizeSlotValue(value);
            slots[key] = ()=>normalized;
        }
    }
};
const $ffe19d932e7e7bce$var$normalizeVNodeSlots = (instance, children)=>{
    const normalized = $ffe19d932e7e7bce$var$normalizeSlotValue(children);
    instance.slots.default = ()=>normalized;
};
const $ffe19d932e7e7bce$var$initSlots = (instance, children)=>{
    const slots = instance.slots = $ffe19d932e7e7bce$var$createInternalObject();
    if (instance.vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            (0, $16Sl1.extend)(slots, children);
            (0, $16Sl1.def)(slots, "_", type);
        } else $ffe19d932e7e7bce$var$normalizeObjectSlots(children, slots);
    } else if (children) $ffe19d932e7e7bce$var$normalizeVNodeSlots(instance, children);
};
const $ffe19d932e7e7bce$var$updateSlots = (instance, children, optimized)=>{
    const { vnode: vnode, slots: slots } = instance;
    let needDeletionCheck = true;
    let deletionComparisonTarget = (0, $16Sl1.EMPTY_OBJ);
    if (vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            if (optimized && type === 1) needDeletionCheck = false;
            else {
                (0, $16Sl1.extend)(slots, children);
                if (!optimized && type === 1) delete slots._;
            }
        } else {
            needDeletionCheck = !children.$stable;
            $ffe19d932e7e7bce$var$normalizeObjectSlots(children, slots);
        }
        deletionComparisonTarget = children;
    } else if (children) {
        $ffe19d932e7e7bce$var$normalizeVNodeSlots(instance, children);
        deletionComparisonTarget = {
            default: 1
        };
    }
    if (needDeletionCheck) {
        for(const key in slots)if (!$ffe19d932e7e7bce$var$isInternalKey(key) && deletionComparisonTarget[key] == null) delete slots[key];
    }
};
function $ffe19d932e7e7bce$var$setRef(rawRef, oldRawRef, parentSuspense, vnode, isUnmount = false) {
    if ((0, $16Sl1.isArray)(rawRef)) {
        rawRef.forEach((r, i)=>$ffe19d932e7e7bce$var$setRef(r, oldRawRef && ((0, $16Sl1.isArray)(oldRawRef) ? oldRawRef[i] : oldRawRef), parentSuspense, vnode, isUnmount));
        return;
    }
    if ($ffe19d932e7e7bce$var$isAsyncWrapper(vnode) && !isUnmount) return;
    const refValue = vnode.shapeFlag & 4 ? $ffe19d932e7e7bce$var$getExposeProxy(vnode.component) || vnode.component.proxy : vnode.el;
    const value = isUnmount ? null : refValue;
    const { i: owner, r: ref } = rawRef;
    const oldRef = oldRawRef && oldRawRef.r;
    const refs = owner.refs === (0, $16Sl1.EMPTY_OBJ) ? owner.refs = {} : owner.refs;
    const setupState = owner.setupState;
    if (oldRef != null && oldRef !== ref) {
        if ((0, $16Sl1.isString)(oldRef)) {
            refs[oldRef] = null;
            if ((0, $16Sl1.hasOwn)(setupState, oldRef)) setupState[oldRef] = null;
        } else if ((0, $99kuS.isRef)(oldRef)) oldRef.value = null;
    }
    if ((0, $16Sl1.isFunction)(ref)) $ffe19d932e7e7bce$export$b22fcaf88446e9bf(ref, owner, 12, [
        value,
        refs
    ]);
    else {
        const _isString = (0, $16Sl1.isString)(ref);
        const _isRef = (0, $99kuS.isRef)(ref);
        if (_isString || _isRef) {
            const doSet = ()=>{
                if (rawRef.f) {
                    const existing = _isString ? (0, $16Sl1.hasOwn)(setupState, ref) ? setupState[ref] : refs[ref] : ref.value;
                    if (isUnmount) (0, $16Sl1.isArray)(existing) && (0, $16Sl1.remove)(existing, refValue);
                    else {
                        if (!(0, $16Sl1.isArray)(existing)) {
                            if (_isString) {
                                refs[ref] = [
                                    refValue
                                ];
                                if ((0, $16Sl1.hasOwn)(setupState, ref)) setupState[ref] = refs[ref];
                            } else {
                                ref.value = [
                                    refValue
                                ];
                                if (rawRef.k) refs[rawRef.k] = ref.value;
                            }
                        } else if (!existing.includes(refValue)) existing.push(refValue);
                    }
                } else if (_isString) {
                    refs[ref] = value;
                    if ((0, $16Sl1.hasOwn)(setupState, ref)) setupState[ref] = value;
                } else if (_isRef) {
                    ref.value = value;
                    if (rawRef.k) refs[rawRef.k] = value;
                }
            };
            if (value) {
                doSet.id = -1;
                $ffe19d932e7e7bce$var$queuePostRenderEffect(doSet, parentSuspense);
            } else doSet();
        }
    }
}
let $ffe19d932e7e7bce$var$hasMismatch = false;
const $ffe19d932e7e7bce$var$isSVGContainer = (container)=>container.namespaceURI.includes("svg") && container.tagName !== "foreignObject";
const $ffe19d932e7e7bce$var$isMathMLContainer = (container)=>container.namespaceURI.includes("MathML");
const $ffe19d932e7e7bce$var$getContainerType = (container)=>{
    if ($ffe19d932e7e7bce$var$isSVGContainer(container)) return "svg";
    if ($ffe19d932e7e7bce$var$isMathMLContainer(container)) return "mathml";
    return void 0;
};
const $ffe19d932e7e7bce$var$isComment = (node)=>node.nodeType === 8 /* COMMENT */ ;
function $ffe19d932e7e7bce$var$createHydrationFunctions(rendererInternals) {
    const { mt: mountComponent, p: patch, o: { patchProp: patchProp, createText: createText, nextSibling: nextSibling, parentNode: parentNode, remove: remove, insert: insert, createComment: createComment } } = rendererInternals;
    const hydrate = (vnode, container)=>{
        if (!container.hasChildNodes()) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $ffe19d932e7e7bce$var$warn$1(`Attempting to hydrate existing markup but container is empty. Performing full mount instead.`);
            patch(null, vnode, container);
            $ffe19d932e7e7bce$var$flushPostFlushCbs();
            container._vnode = vnode;
            return;
        }
        $ffe19d932e7e7bce$var$hasMismatch = false;
        hydrateNode(container.firstChild, vnode, null, null, null);
        $ffe19d932e7e7bce$var$flushPostFlushCbs();
        container._vnode = vnode;
        if ($ffe19d932e7e7bce$var$hasMismatch && true) console.error(`Hydration completed but contains mismatches.`);
    };
    const hydrateNode = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized = false)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const isFragmentStart = $ffe19d932e7e7bce$var$isComment(node) && node.data === "[";
        const onMismatch = ()=>handleMismatch(node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragmentStart);
        const { type: type, ref: ref, shapeFlag: shapeFlag, patchFlag: patchFlag } = vnode;
        let domType = node.nodeType;
        vnode.el = node;
        if (__VUE_PROD_DEVTOOLS__) {
            if (!("__vnode" in node)) Object.defineProperty(node, "__vnode", {
                value: vnode,
                enumerable: false
            });
            if (!("__vueParentComponent" in node)) Object.defineProperty(node, "__vueParentComponent", {
                value: parentComponent,
                enumerable: false
            });
        }
        if (patchFlag === -2) {
            optimized = false;
            vnode.dynamicChildren = null;
        }
        let nextNode = null;
        switch(type){
            case $ffe19d932e7e7bce$export$5f1af8db9871e1d6:
                if (domType !== 3 /* TEXT */ ) {
                    if (vnode.children === "") {
                        insert(vnode.el = createText(""), parentNode(node), node);
                        nextNode = node;
                    } else nextNode = onMismatch();
                } else {
                    if (node.data !== vnode.children) {
                        $ffe19d932e7e7bce$var$hasMismatch = true;
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $ffe19d932e7e7bce$var$warn$1(`Hydration text mismatch in`, node.parentNode, `
  - rendered on server: ${JSON.stringify(node.data)}
  - expected on client: ${JSON.stringify(vnode.children)}`);
                        node.data = vnode.children;
                    }
                    nextNode = nextSibling(node);
                }
                break;
            case $ffe19d932e7e7bce$export$4d299b491347818a:
                if (isTemplateNode(node)) {
                    nextNode = nextSibling(node);
                    replaceNode(vnode.el = node.content.firstChild, node, parentComponent);
                } else if (domType !== 8 /* COMMENT */  || isFragmentStart) nextNode = onMismatch();
                else nextNode = nextSibling(node);
                break;
            case $ffe19d932e7e7bce$export$c1b9a1d3af45b7b6:
                if (isFragmentStart) {
                    node = nextSibling(node);
                    domType = node.nodeType;
                }
                if (domType === 1 /* ELEMENT */  || domType === 3 /* TEXT */ ) {
                    nextNode = node;
                    const needToAdoptContent = !vnode.children.length;
                    for(let i = 0; i < vnode.staticCount; i++){
                        if (needToAdoptContent) vnode.children += nextNode.nodeType === 1 /* ELEMENT */  ? nextNode.outerHTML : nextNode.data;
                        if (i === vnode.staticCount - 1) vnode.anchor = nextNode;
                        nextNode = nextSibling(nextNode);
                    }
                    return isFragmentStart ? nextSibling(nextNode) : nextNode;
                } else onMismatch();
                break;
            case $ffe19d932e7e7bce$export$ffb0004e005737fa:
                if (!isFragmentStart) nextNode = onMismatch();
                else nextNode = hydrateFragment(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) {
                    if ((domType !== 1 /* ELEMENT */  || vnode.type.toLowerCase() !== node.tagName.toLowerCase()) && !isTemplateNode(node)) nextNode = onMismatch();
                    else nextNode = hydrateElement(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                } else if (shapeFlag & 6) {
                    vnode.slotScopeIds = slotScopeIds;
                    const container = parentNode(node);
                    if (isFragmentStart) nextNode = locateClosingAnchor(node);
                    else if ($ffe19d932e7e7bce$var$isComment(node) && node.data === "teleport start") nextNode = locateClosingAnchor(node, node.data, "teleport end");
                    else nextNode = nextSibling(node);
                    mountComponent(vnode, container, null, parentComponent, parentSuspense, $ffe19d932e7e7bce$var$getContainerType(container), optimized);
                    if ($ffe19d932e7e7bce$var$isAsyncWrapper(vnode)) {
                        let subTree;
                        if (isFragmentStart) {
                            subTree = $ffe19d932e7e7bce$export$bf5c4cf060303d58($ffe19d932e7e7bce$export$ffb0004e005737fa);
                            subTree.anchor = nextNode ? nextNode.previousSibling : container.lastChild;
                        } else subTree = node.nodeType === 3 ? $ffe19d932e7e7bce$export$22f9b5ffd89dac9("") : $ffe19d932e7e7bce$export$bf5c4cf060303d58("div");
                        subTree.el = node;
                        vnode.component.subTree = subTree;
                    }
                } else if (shapeFlag & 64) {
                    if (domType !== 8 /* COMMENT */ ) nextNode = onMismatch();
                    else nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, rendererInternals, hydrateChildren);
                } else if (shapeFlag & 128) nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, $ffe19d932e7e7bce$var$getContainerType(parentNode(node)), slotScopeIds, optimized, rendererInternals, hydrateNode);
                else if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__) $ffe19d932e7e7bce$var$warn$1("Invalid HostVNode type:", type, `(${typeof type})`);
        }
        if (ref != null) $ffe19d932e7e7bce$var$setRef(ref, null, parentSuspense, vnode);
        return nextNode;
    };
    const hydrateElement = (el, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const { type: type, props: props, patchFlag: patchFlag, shapeFlag: shapeFlag, dirs: dirs, transition: transition } = vnode;
        const forcePatch = type === "input" || type === "option";
        if (forcePatch || patchFlag !== -1) {
            if (dirs) $ffe19d932e7e7bce$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
            let needCallTransitionHooks = false;
            if (isTemplateNode(el)) {
                needCallTransitionHooks = $ffe19d932e7e7bce$var$needTransition(parentSuspense, transition) && parentComponent && parentComponent.vnode.props && parentComponent.vnode.props.appear;
                const content = el.content.firstChild;
                if (needCallTransitionHooks) transition.beforeEnter(content);
                replaceNode(content, el, parentComponent);
                vnode.el = el = content;
            }
            if (shapeFlag & 16 && // skip if element has innerHTML / textContent
            !(props && (props.innerHTML || props.textContent))) {
                let next = hydrateChildren(el.firstChild, vnode, el, parentComponent, parentSuspense, slotScopeIds, optimized);
                let hasWarned = false;
                while(next){
                    $ffe19d932e7e7bce$var$hasMismatch = true;
                    if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && !hasWarned) {
                        $ffe19d932e7e7bce$var$warn$1(`Hydration children mismatch on`, el, `
Server rendered element contains more child nodes than client vdom.`);
                        hasWarned = true;
                    }
                    const cur = next;
                    next = next.nextSibling;
                    remove(cur);
                }
            } else if (shapeFlag & 8) {
                if (el.textContent !== vnode.children) {
                    $ffe19d932e7e7bce$var$hasMismatch = true;
                    __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $ffe19d932e7e7bce$var$warn$1(`Hydration text content mismatch on`, el, `
  - rendered on server: ${el.textContent}
  - expected on client: ${vnode.children}`);
                    el.textContent = vnode.children;
                }
            }
            if (props) {
                if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ || forcePatch || !optimized || patchFlag & 48) for(const key in props){
                    if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $ffe19d932e7e7bce$var$propHasMismatch(el, key, props[key], vnode, parentComponent)) $ffe19d932e7e7bce$var$hasMismatch = true;
                    if (forcePatch && (key.endsWith("value") || key === "indeterminate") || (0, $16Sl1.isOn)(key) && !(0, $16Sl1.isReservedProp)(key) || // force hydrate v-bind with .prop modifiers
                    key[0] === ".") patchProp(el, key, null, props[key], void 0, void 0, parentComponent);
                }
                else if (props.onClick) patchProp(el, "onClick", null, props.onClick, void 0, void 0, parentComponent);
            }
            let vnodeHooks;
            if (vnodeHooks = props && props.onVnodeBeforeMount) $ffe19d932e7e7bce$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
            if (dirs) $ffe19d932e7e7bce$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
            if ((vnodeHooks = props && props.onVnodeMounted) || dirs || needCallTransitionHooks) $ffe19d932e7e7bce$var$queueEffectWithSuspense(()=>{
                vnodeHooks && $ffe19d932e7e7bce$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
                needCallTransitionHooks && transition.enter(el);
                dirs && $ffe19d932e7e7bce$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
            }, parentSuspense);
        }
        return el.nextSibling;
    };
    const hydrateChildren = (node, parentVNode, container, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!parentVNode.dynamicChildren;
        const children = parentVNode.children;
        const l = children.length;
        let hasWarned = false;
        for(let i = 0; i < l; i++){
            const vnode = optimized ? children[i] : children[i] = $ffe19d932e7e7bce$var$normalizeVNode(children[i]);
            if (node) node = hydrateNode(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
            else if (vnode.type === $ffe19d932e7e7bce$export$5f1af8db9871e1d6 && !vnode.children) continue;
            else {
                $ffe19d932e7e7bce$var$hasMismatch = true;
                if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && !hasWarned) {
                    $ffe19d932e7e7bce$var$warn$1(`Hydration children mismatch on`, container, `
Server rendered element contains fewer child nodes than client vdom.`);
                    hasWarned = true;
                }
                patch(null, vnode, container, null, parentComponent, parentSuspense, $ffe19d932e7e7bce$var$getContainerType(container), slotScopeIds);
            }
        }
        return node;
    };
    const hydrateFragment = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        const { slotScopeIds: fragmentSlotScopeIds } = vnode;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        const container = parentNode(node);
        const next = hydrateChildren(nextSibling(node), vnode, container, parentComponent, parentSuspense, slotScopeIds, optimized);
        if (next && $ffe19d932e7e7bce$var$isComment(next) && next.data === "]") return nextSibling(vnode.anchor = next);
        else {
            $ffe19d932e7e7bce$var$hasMismatch = true;
            insert(vnode.anchor = createComment(`]`), container, next);
            return next;
        }
    };
    const handleMismatch = (node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragment)=>{
        $ffe19d932e7e7bce$var$hasMismatch = true;
        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $ffe19d932e7e7bce$var$warn$1(`Hydration node mismatch:
- rendered on server:`, node, node.nodeType === 3 /* TEXT */  ? `(text)` : $ffe19d932e7e7bce$var$isComment(node) && node.data === "[" ? `(start of fragment)` : ``, `
- expected on client:`, vnode.type);
        vnode.el = null;
        if (isFragment) {
            const end = locateClosingAnchor(node);
            while(true){
                const next2 = nextSibling(node);
                if (next2 && next2 !== end) remove(next2);
                else break;
            }
        }
        const next = nextSibling(node);
        const container = parentNode(node);
        remove(node);
        patch(null, vnode, container, next, parentComponent, parentSuspense, $ffe19d932e7e7bce$var$getContainerType(container), slotScopeIds);
        return next;
    };
    const locateClosingAnchor = (node, open = "[", close = "]")=>{
        let match = 0;
        while(node){
            node = nextSibling(node);
            if (node && $ffe19d932e7e7bce$var$isComment(node)) {
                if (node.data === open) match++;
                if (node.data === close) {
                    if (match === 0) return nextSibling(node);
                    else match--;
                }
            }
        }
        return node;
    };
    const replaceNode = (newNode, oldNode, parentComponent)=>{
        const parentNode2 = oldNode.parentNode;
        if (parentNode2) parentNode2.replaceChild(newNode, oldNode);
        let parent = parentComponent;
        while(parent){
            if (parent.vnode.el === oldNode) parent.vnode.el = parent.subTree.el = newNode;
            parent = parent.parent;
        }
    };
    const isTemplateNode = (node)=>{
        return node.nodeType === 1 /* ELEMENT */  && node.tagName.toLowerCase() === "template";
    };
    return [
        hydrate,
        hydrateNode
    ];
}
function $ffe19d932e7e7bce$var$propHasMismatch(el, key, clientValue, vnode, instance) {
    var _a;
    let mismatchType;
    let mismatchKey;
    let actual;
    let expected;
    if (key === "class") {
        actual = el.getAttribute("class");
        expected = (0, $16Sl1.normalizeClass)(clientValue);
        if (!$ffe19d932e7e7bce$var$isSetEqual($ffe19d932e7e7bce$var$toClassSet(actual || ""), $ffe19d932e7e7bce$var$toClassSet(expected))) mismatchType = mismatchKey = `class`;
    } else if (key === "style") {
        actual = el.getAttribute("style");
        expected = (0, $16Sl1.isString)(clientValue) ? clientValue : (0, $16Sl1.stringifyStyle)((0, $16Sl1.normalizeStyle)(clientValue));
        const actualMap = $ffe19d932e7e7bce$var$toStyleMap(actual);
        const expectedMap = $ffe19d932e7e7bce$var$toStyleMap(expected);
        if (vnode.dirs) {
            for (const { dir: dir, value: value } of vnode.dirs)if (dir.name === "show" && !value) expectedMap.set("display", "none");
        }
        const root = instance == null ? void 0 : instance.subTree;
        if (vnode === root || (root == null ? void 0 : root.type) === $ffe19d932e7e7bce$export$ffb0004e005737fa && root.children.includes(vnode)) {
            const cssVars = (_a = instance == null ? void 0 : instance.getCssVars) == null ? void 0 : _a.call(instance);
            for(const key2 in cssVars)expectedMap.set(`--${key2}`, String(cssVars[key2]));
        }
        if (!$ffe19d932e7e7bce$var$isMapEqual(actualMap, expectedMap)) mismatchType = mismatchKey = "style";
    } else if (el instanceof SVGElement && (0, $16Sl1.isKnownSvgAttr)(key) || el instanceof HTMLElement && ((0, $16Sl1.isBooleanAttr)(key) || (0, $16Sl1.isKnownHtmlAttr)(key))) {
        if ((0, $16Sl1.isBooleanAttr)(key)) {
            actual = el.hasAttribute(key);
            expected = (0, $16Sl1.includeBooleanAttr)(clientValue);
        } else if (clientValue == null) {
            actual = el.hasAttribute(key);
            expected = false;
        } else {
            if (el.hasAttribute(key)) actual = el.getAttribute(key);
            else if (key === "value" && el.tagName === "TEXTAREA") actual = el.value;
            else actual = false;
            expected = (0, $16Sl1.isRenderableAttrValue)(clientValue) ? String(clientValue) : false;
        }
        if (actual !== expected) {
            mismatchType = `attribute`;
            mismatchKey = key;
        }
    }
    if (mismatchType) {
        const format = (v1)=>v1 === false ? `(not rendered)` : `${mismatchKey}="${v1}"`;
        const preSegment = `Hydration ${mismatchType} mismatch on`;
        const postSegment = `
  - rendered on server: ${format(actual)}
  - expected on client: ${format(expected)}
  Note: this mismatch is check-only. The DOM will not be rectified in production due to performance overhead.
  You should fix the source of the mismatch.`;
        $ffe19d932e7e7bce$var$warn$1(preSegment, el, postSegment);
        return true;
    }
    return false;
}
function $ffe19d932e7e7bce$var$toClassSet(str) {
    return new Set(str.trim().split(/\s+/));
}
function $ffe19d932e7e7bce$var$isSetEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const s of a){
        if (!b.has(s)) return false;
    }
    return true;
}
function $ffe19d932e7e7bce$var$toStyleMap(str) {
    const styleMap = /* @__PURE__ */ new Map();
    for (const item of str.split(";")){
        let [key, value] = item.split(":");
        key = key == null ? void 0 : key.trim();
        value = value == null ? void 0 : value.trim();
        if (key && value) styleMap.set(key, value);
    }
    return styleMap;
}
function $ffe19d932e7e7bce$var$isMapEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const [key, value] of a){
        if (value !== b.get(key)) return false;
    }
    return true;
}
let $ffe19d932e7e7bce$var$supported;
let $ffe19d932e7e7bce$var$perf;
function $ffe19d932e7e7bce$var$startMeasure(instance, type) {
    if (instance.appContext.config.performance && $ffe19d932e7e7bce$var$isSupported()) $ffe19d932e7e7bce$var$perf.mark(`vue-${type}-${instance.uid}`);
    if (__VUE_PROD_DEVTOOLS__) $ffe19d932e7e7bce$var$devtoolsPerfStart(instance, type, $ffe19d932e7e7bce$var$isSupported() ? $ffe19d932e7e7bce$var$perf.now() : Date.now());
}
function $ffe19d932e7e7bce$var$endMeasure(instance, type) {
    if (instance.appContext.config.performance && $ffe19d932e7e7bce$var$isSupported()) {
        const startTag = `vue-${type}-${instance.uid}`;
        const endTag = startTag + `:end`;
        $ffe19d932e7e7bce$var$perf.mark(endTag);
        $ffe19d932e7e7bce$var$perf.measure(`<${$ffe19d932e7e7bce$var$formatComponentName(instance, instance.type)}> ${type}`, startTag, endTag);
        $ffe19d932e7e7bce$var$perf.clearMarks(startTag);
        $ffe19d932e7e7bce$var$perf.clearMarks(endTag);
    }
    if (__VUE_PROD_DEVTOOLS__) $ffe19d932e7e7bce$var$devtoolsPerfEnd(instance, type, $ffe19d932e7e7bce$var$isSupported() ? $ffe19d932e7e7bce$var$perf.now() : Date.now());
}
function $ffe19d932e7e7bce$var$isSupported() {
    if ($ffe19d932e7e7bce$var$supported !== void 0) return $ffe19d932e7e7bce$var$supported;
    if (typeof window !== "undefined" && window.performance) {
        $ffe19d932e7e7bce$var$supported = true;
        $ffe19d932e7e7bce$var$perf = window.performance;
    } else $ffe19d932e7e7bce$var$supported = false;
    return $ffe19d932e7e7bce$var$supported;
}
function $ffe19d932e7e7bce$var$initFeatureFlags() {
    const needWarn = [];
    if (typeof __VUE_OPTIONS_API__ !== "boolean") (0, $16Sl1.getGlobalThis)().__VUE_OPTIONS_API__ = true;
    if (typeof __VUE_PROD_DEVTOOLS__ !== "boolean") (0, $16Sl1.getGlobalThis)().__VUE_PROD_DEVTOOLS__ = false;
    if (typeof __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ !== "boolean") (0, $16Sl1.getGlobalThis)().__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;
}
const $ffe19d932e7e7bce$var$queuePostRenderEffect = $ffe19d932e7e7bce$var$queueEffectWithSuspense;
function $ffe19d932e7e7bce$export$53ae2f996c64e9a(options) {
    return $ffe19d932e7e7bce$var$baseCreateRenderer(options);
}
function $ffe19d932e7e7bce$export$200524cf0d997ff0(options) {
    return $ffe19d932e7e7bce$var$baseCreateRenderer(options, $ffe19d932e7e7bce$var$createHydrationFunctions);
}
function $ffe19d932e7e7bce$var$baseCreateRenderer(options, createHydrationFns) {
    $ffe19d932e7e7bce$var$initFeatureFlags();
    const target = (0, $16Sl1.getGlobalThis)();
    target.__VUE__ = true;
    if (__VUE_PROD_DEVTOOLS__) $ffe19d932e7e7bce$var$setDevtoolsHook$1(target.__VUE_DEVTOOLS_GLOBAL_HOOK__, target);
    const { insert: hostInsert, remove: hostRemove, patchProp: hostPatchProp, createElement: hostCreateElement, createText: hostCreateText, createComment: hostCreateComment, setText: hostSetText, setElementText: hostSetElementText, parentNode: hostParentNode, nextSibling: hostNextSibling, setScopeId: hostSetScopeId = (0, $16Sl1.NOOP), insertStaticContent: hostInsertStaticContent } = options;
    const patch = (n1, n2, container, anchor = null, parentComponent = null, parentSuspense = null, namespace, slotScopeIds = null, optimized = !!n2.dynamicChildren)=>{
        if (n1 === n2) return;
        if (n1 && !$ffe19d932e7e7bce$var$isSameVNodeType(n1, n2)) {
            anchor = getNextHostNode(n1);
            unmount(n1, parentComponent, parentSuspense, true);
            n1 = null;
        }
        if (n2.patchFlag === -2) {
            optimized = false;
            n2.dynamicChildren = null;
        }
        const { type: type, ref: ref, shapeFlag: shapeFlag } = n2;
        switch(type){
            case $ffe19d932e7e7bce$export$5f1af8db9871e1d6:
                processText(n1, n2, container, anchor);
                break;
            case $ffe19d932e7e7bce$export$4d299b491347818a:
                processCommentNode(n1, n2, container, anchor);
                break;
            case $ffe19d932e7e7bce$export$c1b9a1d3af45b7b6:
                if (n1 == null) mountStaticNode(n2, container, anchor, namespace);
                break;
            case $ffe19d932e7e7bce$export$ffb0004e005737fa:
                processFragment(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) processElement(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 6) processComponent(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 64) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
                else if (shapeFlag & 128) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
        }
        if (ref != null && parentComponent) $ffe19d932e7e7bce$var$setRef(ref, n1 && n1.ref, parentSuspense, n2 || n1, !n2);
    };
    const processText = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateText(n2.children), container, anchor);
        else {
            const el = n2.el = n1.el;
            if (n2.children !== n1.children) hostSetText(el, n2.children);
        }
    };
    const processCommentNode = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateComment(n2.children || ""), container, anchor);
        else n2.el = n1.el;
    };
    const mountStaticNode = (n2, container, anchor, namespace)=>{
        [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace, n2.el, n2.anchor);
    };
    const patchStaticNode = (n1, n2, container, namespace)=>{
        if (n2.children !== n1.children) {
            const anchor = hostNextSibling(n1.anchor);
            removeStaticNode(n1);
            [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace);
        } else {
            n2.el = n1.el;
            n2.anchor = n1.anchor;
        }
    };
    const moveStaticNode = ({ el: el, anchor: anchor }, container, nextSibling)=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostInsert(el, container, nextSibling);
            el = next;
        }
        hostInsert(anchor, container, nextSibling);
    };
    const removeStaticNode = ({ el: el, anchor: anchor })=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostRemove(el);
            el = next;
        }
        hostRemove(anchor);
    };
    const processElement = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        if (n2.type === "svg") namespace = "svg";
        else if (n2.type === "math") namespace = "mathml";
        if (n1 == null) mountElement(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        else patchElement(n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
    };
    const mountElement = (vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let el;
        let vnodeHook;
        const { props: props, shapeFlag: shapeFlag, transition: transition, dirs: dirs } = vnode;
        el = vnode.el = hostCreateElement(vnode.type, namespace, props && props.is, props);
        if (shapeFlag & 8) hostSetElementText(el, vnode.children);
        else if (shapeFlag & 16) mountChildren(vnode.children, el, null, parentComponent, parentSuspense, $ffe19d932e7e7bce$var$resolveChildrenNamespace(vnode, namespace), slotScopeIds, optimized);
        if (dirs) $ffe19d932e7e7bce$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
        setScopeId(el, vnode, vnode.scopeId, slotScopeIds, parentComponent);
        if (props) {
            for(const key in props)if (key !== "value" && !(0, $16Sl1.isReservedProp)(key)) hostPatchProp(el, key, null, props[key], namespace, vnode.children, parentComponent, parentSuspense, unmountChildren);
            if ("value" in props) hostPatchProp(el, "value", null, props.value, namespace);
            if (vnodeHook = props.onVnodeBeforeMount) $ffe19d932e7e7bce$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        }
        if (__VUE_PROD_DEVTOOLS__) {
            Object.defineProperty(el, "__vnode", {
                value: vnode,
                enumerable: false
            });
            Object.defineProperty(el, "__vueParentComponent", {
                value: parentComponent,
                enumerable: false
            });
        }
        if (dirs) $ffe19d932e7e7bce$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
        const needCallTransitionHooks = $ffe19d932e7e7bce$var$needTransition(parentSuspense, transition);
        if (needCallTransitionHooks) transition.beforeEnter(el);
        hostInsert(el, container, anchor);
        if ((vnodeHook = props && props.onVnodeMounted) || needCallTransitionHooks || dirs) $ffe19d932e7e7bce$var$queuePostRenderEffect(()=>{
            vnodeHook && $ffe19d932e7e7bce$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            needCallTransitionHooks && transition.enter(el);
            dirs && $ffe19d932e7e7bce$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
        }, parentSuspense);
    };
    const setScopeId = (el, vnode, scopeId, slotScopeIds, parentComponent)=>{
        if (scopeId) hostSetScopeId(el, scopeId);
        if (slotScopeIds) for(let i = 0; i < slotScopeIds.length; i++)hostSetScopeId(el, slotScopeIds[i]);
        if (parentComponent) {
            let subTree = parentComponent.subTree;
            if (vnode === subTree) {
                const parentVNode = parentComponent.vnode;
                setScopeId(el, parentVNode, parentVNode.scopeId, parentVNode.slotScopeIds, parentComponent.parent);
            }
        }
    };
    const mountChildren = (children, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, start = 0)=>{
        for(let i = start; i < children.length; i++){
            const child = children[i] = optimized ? $ffe19d932e7e7bce$var$cloneIfMounted(children[i]) : $ffe19d932e7e7bce$var$normalizeVNode(children[i]);
            patch(null, child, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchElement = (n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const el = n2.el = n1.el;
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, dirs: dirs } = n2;
        patchFlag |= n1.patchFlag & 16;
        const oldProps = n1.props || (0, $16Sl1.EMPTY_OBJ);
        const newProps = n2.props || (0, $16Sl1.EMPTY_OBJ);
        let vnodeHook;
        parentComponent && $ffe19d932e7e7bce$var$toggleRecurse(parentComponent, false);
        if (vnodeHook = newProps.onVnodeBeforeUpdate) $ffe19d932e7e7bce$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
        if (dirs) $ffe19d932e7e7bce$var$invokeDirectiveHook(n2, n1, parentComponent, "beforeUpdate");
        parentComponent && $ffe19d932e7e7bce$var$toggleRecurse(parentComponent, true);
        if (dynamicChildren) patchBlockChildren(n1.dynamicChildren, dynamicChildren, el, parentComponent, parentSuspense, $ffe19d932e7e7bce$var$resolveChildrenNamespace(n2, namespace), slotScopeIds);
        else if (!optimized) patchChildren(n1, n2, el, null, parentComponent, parentSuspense, $ffe19d932e7e7bce$var$resolveChildrenNamespace(n2, namespace), slotScopeIds, false);
        if (patchFlag > 0) {
            if (patchFlag & 16) patchProps(el, n2, oldProps, newProps, parentComponent, parentSuspense, namespace);
            else {
                if (patchFlag & 2) {
                    if (oldProps.class !== newProps.class) hostPatchProp(el, "class", null, newProps.class, namespace);
                }
                if (patchFlag & 4) hostPatchProp(el, "style", oldProps.style, newProps.style, namespace);
                if (patchFlag & 8) {
                    const propsToUpdate = n2.dynamicProps;
                    for(let i = 0; i < propsToUpdate.length; i++){
                        const key = propsToUpdate[i];
                        const prev = oldProps[key];
                        const next = newProps[key];
                        if (next !== prev || key === "value") hostPatchProp(el, key, prev, next, namespace, n1.children, parentComponent, parentSuspense, unmountChildren);
                    }
                }
            }
            if (patchFlag & 1) {
                if (n1.children !== n2.children) hostSetElementText(el, n2.children);
            }
        } else if (!optimized && dynamicChildren == null) patchProps(el, n2, oldProps, newProps, parentComponent, parentSuspense, namespace);
        if ((vnodeHook = newProps.onVnodeUpdated) || dirs) $ffe19d932e7e7bce$var$queuePostRenderEffect(()=>{
            vnodeHook && $ffe19d932e7e7bce$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
            dirs && $ffe19d932e7e7bce$var$invokeDirectiveHook(n2, n1, parentComponent, "updated");
        }, parentSuspense);
    };
    const patchBlockChildren = (oldChildren, newChildren, fallbackContainer, parentComponent, parentSuspense, namespace, slotScopeIds)=>{
        for(let i = 0; i < newChildren.length; i++){
            const oldVNode = oldChildren[i];
            const newVNode = newChildren[i];
            const container = // oldVNode may be an errored async setup() component inside Suspense
            // which will not have a mounted element
            oldVNode.el && // - In the case of a Fragment, we need to provide the actual parent
            // of the Fragment itself so it can move its children.
            (oldVNode.type === $ffe19d932e7e7bce$export$ffb0004e005737fa || // - In the case of different nodes, there is going to be a replacement
            // which also requires the correct parent container
            !$ffe19d932e7e7bce$var$isSameVNodeType(oldVNode, newVNode) || // - In the case of a component, it could contain anything.
            oldVNode.shapeFlag & 70) ? hostParentNode(oldVNode.el) : // In other cases, the parent container is not actually used so we
            // just pass the block element here to avoid a DOM parentNode call.
            fallbackContainer;
            patch(oldVNode, newVNode, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, true);
        }
    };
    const patchProps = (el, vnode, oldProps, newProps, parentComponent, parentSuspense, namespace)=>{
        if (oldProps !== newProps) {
            if (oldProps !== (0, $16Sl1.EMPTY_OBJ)) {
                for(const key in oldProps)if (!(0, $16Sl1.isReservedProp)(key) && !(key in newProps)) hostPatchProp(el, key, oldProps[key], null, namespace, vnode.children, parentComponent, parentSuspense, unmountChildren);
            }
            for(const key in newProps){
                if ((0, $16Sl1.isReservedProp)(key)) continue;
                const next = newProps[key];
                const prev = oldProps[key];
                if (next !== prev && key !== "value") hostPatchProp(el, key, prev, next, namespace, vnode.children, parentComponent, parentSuspense, unmountChildren);
            }
            if ("value" in newProps) hostPatchProp(el, "value", oldProps.value, newProps.value, namespace);
        }
    };
    const processFragment = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const fragmentStartAnchor = n2.el = n1 ? n1.el : hostCreateText("");
        const fragmentEndAnchor = n2.anchor = n1 ? n1.anchor : hostCreateText("");
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, slotScopeIds: fragmentSlotScopeIds } = n2;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        if (n1 == null) {
            hostInsert(fragmentStartAnchor, container, anchor);
            hostInsert(fragmentEndAnchor, container, anchor);
            mountChildren(// #10007
            // such fragment like `<></>` will be compiled into
            // a fragment which doesn't have a children.
            // In this case fallback to an empty array
            n2.children || [], container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        } else if (patchFlag > 0 && patchFlag & 64 && dynamicChildren && // #2715 the previous fragment could've been a BAILed one as a result
        // of renderSlot() with no valid children
        n1.dynamicChildren) {
            patchBlockChildren(n1.dynamicChildren, dynamicChildren, container, parentComponent, parentSuspense, namespace, slotScopeIds);
            if (// #2080 if the stable fragment has a key, it's a <template v-for> that may
            //  get moved around. Make sure all root level vnodes inherit el.
            // #2134 or if it's a component root, it may also get moved around
            // as the component is being moved.
            n2.key != null || parentComponent && n2 === parentComponent.subTree) $ffe19d932e7e7bce$var$traverseStaticChildren(n1, n2, true);
        } else patchChildren(n1, n2, container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
    };
    const processComponent = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        n2.slotScopeIds = slotScopeIds;
        if (n1 == null) {
            if (n2.shapeFlag & 512) parentComponent.ctx.activate(n2, container, anchor, namespace, optimized);
            else mountComponent(n2, container, anchor, parentComponent, parentSuspense, namespace, optimized);
        } else updateComponent(n1, n2, optimized);
    };
    const mountComponent = (initialVNode, container, anchor, parentComponent, parentSuspense, namespace, optimized)=>{
        const instance = initialVNode.component = $ffe19d932e7e7bce$var$createComponentInstance(initialVNode, parentComponent, parentSuspense);
        if ($ffe19d932e7e7bce$var$isKeepAlive(initialVNode)) instance.ctx.renderer = internals;
        $ffe19d932e7e7bce$var$setupComponent(instance);
        if (instance.asyncDep) {
            parentSuspense && parentSuspense.registerDep(instance, setupRenderEffect);
            if (!initialVNode.el) {
                const placeholder = instance.subTree = $ffe19d932e7e7bce$export$bf5c4cf060303d58($ffe19d932e7e7bce$export$4d299b491347818a);
                processCommentNode(null, placeholder, container, anchor);
            }
        } else setupRenderEffect(instance, initialVNode, container, anchor, parentSuspense, namespace, optimized);
    };
    const updateComponent = (n1, n2, optimized)=>{
        const instance = n2.component = n1.component;
        if ($ffe19d932e7e7bce$var$shouldUpdateComponent(n1, n2, optimized)) {
            if (instance.asyncDep && !instance.asyncResolved) {
                updateComponentPreRender(instance, n2, optimized);
                return;
            } else {
                instance.next = n2;
                $ffe19d932e7e7bce$var$invalidateJob(instance.update);
                instance.effect.dirty = true;
                instance.update();
            }
        } else {
            n2.el = n1.el;
            instance.vnode = n2;
        }
    };
    const setupRenderEffect = (instance, initialVNode, container, anchor, parentSuspense, namespace, optimized)=>{
        const componentUpdateFn = ()=>{
            if (!instance.isMounted) {
                let vnodeHook;
                const { el: el, props: props } = initialVNode;
                const { bm: bm, m: m, parent: parent } = instance;
                const isAsyncWrapperVNode = $ffe19d932e7e7bce$var$isAsyncWrapper(initialVNode);
                $ffe19d932e7e7bce$var$toggleRecurse(instance, false);
                if (bm) (0, $16Sl1.invokeArrayFns)(bm);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeBeforeMount)) $ffe19d932e7e7bce$var$invokeVNodeHook(vnodeHook, parent, initialVNode);
                $ffe19d932e7e7bce$var$toggleRecurse(instance, true);
                if (el && hydrateNode) {
                    const hydrateSubTree = ()=>{
                        instance.subTree = $ffe19d932e7e7bce$var$renderComponentRoot(instance);
                        hydrateNode(el, instance.subTree, instance, parentSuspense, null);
                    };
                    if (isAsyncWrapperVNode) initialVNode.type.__asyncLoader().then(// note: we are moving the render call into an async callback,
                    // which means it won't track dependencies - but it's ok because
                    // a server-rendered async wrapper is already in resolved state
                    // and it will never need to change.
                    ()=>!instance.isUnmounted && hydrateSubTree());
                    else hydrateSubTree();
                } else {
                    const subTree = instance.subTree = $ffe19d932e7e7bce$var$renderComponentRoot(instance);
                    patch(null, subTree, container, anchor, instance, parentSuspense, namespace);
                    initialVNode.el = subTree.el;
                }
                if (m) $ffe19d932e7e7bce$var$queuePostRenderEffect(m, parentSuspense);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeMounted)) {
                    const scopedInitialVNode = initialVNode;
                    $ffe19d932e7e7bce$var$queuePostRenderEffect(()=>$ffe19d932e7e7bce$var$invokeVNodeHook(vnodeHook, parent, scopedInitialVNode), parentSuspense);
                }
                if (initialVNode.shapeFlag & 256 || parent && $ffe19d932e7e7bce$var$isAsyncWrapper(parent.vnode) && parent.vnode.shapeFlag & 256) instance.a && $ffe19d932e7e7bce$var$queuePostRenderEffect(instance.a, parentSuspense);
                instance.isMounted = true;
                if (__VUE_PROD_DEVTOOLS__) $ffe19d932e7e7bce$var$devtoolsComponentAdded(instance);
                initialVNode = container = anchor = null;
            } else {
                let { next: next, bu: bu, u: u, parent: parent, vnode: vnode } = instance;
                {
                    const nonHydratedAsyncRoot = $ffe19d932e7e7bce$var$locateNonHydratedAsyncRoot(instance);
                    if (nonHydratedAsyncRoot) {
                        if (next) {
                            next.el = vnode.el;
                            updateComponentPreRender(instance, next, optimized);
                        }
                        nonHydratedAsyncRoot.asyncDep.then(()=>{
                            if (!instance.isUnmounted) componentUpdateFn();
                        });
                        return;
                    }
                }
                let originNext = next;
                let vnodeHook;
                $ffe19d932e7e7bce$var$toggleRecurse(instance, false);
                if (next) {
                    next.el = vnode.el;
                    updateComponentPreRender(instance, next, optimized);
                } else next = vnode;
                if (bu) (0, $16Sl1.invokeArrayFns)(bu);
                if (vnodeHook = next.props && next.props.onVnodeBeforeUpdate) $ffe19d932e7e7bce$var$invokeVNodeHook(vnodeHook, parent, next, vnode);
                $ffe19d932e7e7bce$var$toggleRecurse(instance, true);
                const nextTree = $ffe19d932e7e7bce$var$renderComponentRoot(instance);
                const prevTree = instance.subTree;
                instance.subTree = nextTree;
                patch(prevTree, nextTree, // parent may have changed if it's in a teleport
                hostParentNode(prevTree.el), // anchor may have changed if it's in a fragment
                getNextHostNode(prevTree), instance, parentSuspense, namespace);
                next.el = nextTree.el;
                if (originNext === null) $ffe19d932e7e7bce$var$updateHOCHostEl(instance, nextTree.el);
                if (u) $ffe19d932e7e7bce$var$queuePostRenderEffect(u, parentSuspense);
                if (vnodeHook = next.props && next.props.onVnodeUpdated) $ffe19d932e7e7bce$var$queuePostRenderEffect(()=>$ffe19d932e7e7bce$var$invokeVNodeHook(vnodeHook, parent, next, vnode), parentSuspense);
                if (__VUE_PROD_DEVTOOLS__) $ffe19d932e7e7bce$var$devtoolsComponentUpdated(instance);
            }
        };
        const effect = instance.effect = new (0, $99kuS.ReactiveEffect)(componentUpdateFn, (0, $16Sl1.NOOP), ()=>$ffe19d932e7e7bce$var$queueJob(update), instance.scope);
        const update = instance.update = ()=>{
            if (effect.dirty) effect.run();
        };
        update.id = instance.uid;
        $ffe19d932e7e7bce$var$toggleRecurse(instance, true);
        var e, e1;
        update();
    };
    const updateComponentPreRender = (instance, nextVNode, optimized)=>{
        nextVNode.component = instance;
        const prevProps = instance.vnode.props;
        instance.vnode = nextVNode;
        instance.next = null;
        $ffe19d932e7e7bce$var$updateProps(instance, nextVNode.props, prevProps, optimized);
        $ffe19d932e7e7bce$var$updateSlots(instance, nextVNode.children, optimized);
        (0, $99kuS.pauseTracking)();
        $ffe19d932e7e7bce$var$flushPreFlushCbs(instance);
        (0, $99kuS.resetTracking)();
    };
    const patchChildren = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized = false)=>{
        const c1 = n1 && n1.children;
        const prevShapeFlag = n1 ? n1.shapeFlag : 0;
        const c2 = n2.children;
        const { patchFlag: patchFlag, shapeFlag: shapeFlag } = n2;
        if (patchFlag > 0) {
            if (patchFlag & 128) {
                patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            } else if (patchFlag & 256) {
                patchUnkeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            }
        }
        if (shapeFlag & 8) {
            if (prevShapeFlag & 16) unmountChildren(c1, parentComponent, parentSuspense);
            if (c2 !== c1) hostSetElementText(container, c2);
        } else if (prevShapeFlag & 16) {
            if (shapeFlag & 16) patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else unmountChildren(c1, parentComponent, parentSuspense, true);
        } else {
            if (prevShapeFlag & 8) hostSetElementText(container, "");
            if (shapeFlag & 16) mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchUnkeyedChildren = (c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        c1 = c1 || (0, $16Sl1.EMPTY_ARR);
        c2 = c2 || (0, $16Sl1.EMPTY_ARR);
        const oldLength = c1.length;
        const newLength = c2.length;
        const commonLength = Math.min(oldLength, newLength);
        let i;
        for(i = 0; i < commonLength; i++){
            const nextChild = c2[i] = optimized ? $ffe19d932e7e7bce$var$cloneIfMounted(c2[i]) : $ffe19d932e7e7bce$var$normalizeVNode(c2[i]);
            patch(c1[i], nextChild, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
        if (oldLength > newLength) unmountChildren(c1, parentComponent, parentSuspense, true, false, commonLength);
        else mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, commonLength);
    };
    const patchKeyedChildren = (c1, c2, container, parentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let i = 0;
        const l2 = c2.length;
        let e1 = c1.length - 1;
        let e2 = l2 - 1;
        while(i <= e1 && i <= e2){
            const n1 = c1[i];
            const n2 = c2[i] = optimized ? $ffe19d932e7e7bce$var$cloneIfMounted(c2[i]) : $ffe19d932e7e7bce$var$normalizeVNode(c2[i]);
            if ($ffe19d932e7e7bce$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            i++;
        }
        while(i <= e1 && i <= e2){
            const n1 = c1[e1];
            const n2 = c2[e2] = optimized ? $ffe19d932e7e7bce$var$cloneIfMounted(c2[e2]) : $ffe19d932e7e7bce$var$normalizeVNode(c2[e2]);
            if ($ffe19d932e7e7bce$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            e1--;
            e2--;
        }
        if (i > e1) {
            if (i <= e2) {
                const nextPos = e2 + 1;
                const anchor = nextPos < l2 ? c2[nextPos].el : parentAnchor;
                while(i <= e2){
                    patch(null, c2[i] = optimized ? $ffe19d932e7e7bce$var$cloneIfMounted(c2[i]) : $ffe19d932e7e7bce$var$normalizeVNode(c2[i]), container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    i++;
                }
            }
        } else if (i > e2) while(i <= e1){
            unmount(c1[i], parentComponent, parentSuspense, true);
            i++;
        }
        else {
            const s1 = i;
            const s2 = i;
            const keyToNewIndexMap = /* @__PURE__ */ new Map();
            for(i = s2; i <= e2; i++){
                const nextChild = c2[i] = optimized ? $ffe19d932e7e7bce$var$cloneIfMounted(c2[i]) : $ffe19d932e7e7bce$var$normalizeVNode(c2[i]);
                if (nextChild.key != null) keyToNewIndexMap.set(nextChild.key, i);
            }
            let j;
            let patched = 0;
            const toBePatched = e2 - s2 + 1;
            let moved = false;
            let maxNewIndexSoFar = 0;
            const newIndexToOldIndexMap = new Array(toBePatched);
            for(i = 0; i < toBePatched; i++)newIndexToOldIndexMap[i] = 0;
            for(i = s1; i <= e1; i++){
                const prevChild = c1[i];
                if (patched >= toBePatched) {
                    unmount(prevChild, parentComponent, parentSuspense, true);
                    continue;
                }
                let newIndex;
                if (prevChild.key != null) newIndex = keyToNewIndexMap.get(prevChild.key);
                else {
                    for(j = s2; j <= e2; j++)if (newIndexToOldIndexMap[j - s2] === 0 && $ffe19d932e7e7bce$var$isSameVNodeType(prevChild, c2[j])) {
                        newIndex = j;
                        break;
                    }
                }
                if (newIndex === void 0) unmount(prevChild, parentComponent, parentSuspense, true);
                else {
                    newIndexToOldIndexMap[newIndex - s2] = i + 1;
                    if (newIndex >= maxNewIndexSoFar) maxNewIndexSoFar = newIndex;
                    else moved = true;
                    patch(prevChild, c2[newIndex], container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    patched++;
                }
            }
            const increasingNewIndexSequence = moved ? $ffe19d932e7e7bce$var$getSequence(newIndexToOldIndexMap) : (0, $16Sl1.EMPTY_ARR);
            j = increasingNewIndexSequence.length - 1;
            for(i = toBePatched - 1; i >= 0; i--){
                const nextIndex = s2 + i;
                const nextChild = c2[nextIndex];
                const anchor = nextIndex + 1 < l2 ? c2[nextIndex + 1].el : parentAnchor;
                if (newIndexToOldIndexMap[i] === 0) patch(null, nextChild, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (moved) {
                    if (j < 0 || i !== increasingNewIndexSequence[j]) move(nextChild, container, anchor, 2);
                    else j--;
                }
            }
        }
    };
    const move = (vnode, container, anchor, moveType, parentSuspense = null)=>{
        const { el: el, type: type, transition: transition, children: children, shapeFlag: shapeFlag } = vnode;
        if (shapeFlag & 6) {
            move(vnode.component.subTree, container, anchor, moveType);
            return;
        }
        if (shapeFlag & 128) {
            vnode.suspense.move(container, anchor, moveType);
            return;
        }
        if (shapeFlag & 64) {
            type.move(vnode, container, anchor, internals);
            return;
        }
        if (type === $ffe19d932e7e7bce$export$ffb0004e005737fa) {
            hostInsert(el, container, anchor);
            for(let i = 0; i < children.length; i++)move(children[i], container, anchor, moveType);
            hostInsert(vnode.anchor, container, anchor);
            return;
        }
        if (type === $ffe19d932e7e7bce$export$c1b9a1d3af45b7b6) {
            moveStaticNode(vnode, container, anchor);
            return;
        }
        const needTransition2 = moveType !== 2 && shapeFlag & 1 && transition;
        if (needTransition2) {
            if (moveType === 0) {
                transition.beforeEnter(el);
                hostInsert(el, container, anchor);
                $ffe19d932e7e7bce$var$queuePostRenderEffect(()=>transition.enter(el), parentSuspense);
            } else {
                const { leave: leave, delayLeave: delayLeave, afterLeave: afterLeave } = transition;
                const remove2 = ()=>hostInsert(el, container, anchor);
                const performLeave = ()=>{
                    leave(el, ()=>{
                        remove2();
                        afterLeave && afterLeave();
                    });
                };
                if (delayLeave) delayLeave(el, remove2, performLeave);
                else performLeave();
            }
        } else hostInsert(el, container, anchor);
    };
    const unmount = (vnode, parentComponent, parentSuspense, doRemove = false, optimized = false)=>{
        const { type: type, props: props, ref: ref, children: children, dynamicChildren: dynamicChildren, shapeFlag: shapeFlag, patchFlag: patchFlag, dirs: dirs } = vnode;
        if (ref != null) $ffe19d932e7e7bce$var$setRef(ref, null, parentSuspense, vnode, true);
        if (shapeFlag & 256) {
            parentComponent.ctx.deactivate(vnode);
            return;
        }
        const shouldInvokeDirs = shapeFlag & 1 && dirs;
        const shouldInvokeVnodeHook = !$ffe19d932e7e7bce$var$isAsyncWrapper(vnode);
        let vnodeHook;
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeBeforeUnmount)) $ffe19d932e7e7bce$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        if (shapeFlag & 6) unmountComponent(vnode.component, parentSuspense, doRemove);
        else {
            if (shapeFlag & 128) {
                vnode.suspense.unmount(parentSuspense, doRemove);
                return;
            }
            if (shouldInvokeDirs) $ffe19d932e7e7bce$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeUnmount");
            if (shapeFlag & 64) vnode.type.remove(vnode, parentComponent, parentSuspense, optimized, internals, doRemove);
            else if (dynamicChildren && // #1153: fast path should not be taken for non-stable (v-for) fragments
            (type !== $ffe19d932e7e7bce$export$ffb0004e005737fa || patchFlag > 0 && patchFlag & 64)) unmountChildren(dynamicChildren, parentComponent, parentSuspense, false, true);
            else if (type === $ffe19d932e7e7bce$export$ffb0004e005737fa && patchFlag & 384 || !optimized && shapeFlag & 16) unmountChildren(children, parentComponent, parentSuspense);
            if (doRemove) remove(vnode);
        }
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeUnmounted) || shouldInvokeDirs) $ffe19d932e7e7bce$var$queuePostRenderEffect(()=>{
            vnodeHook && $ffe19d932e7e7bce$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            shouldInvokeDirs && $ffe19d932e7e7bce$var$invokeDirectiveHook(vnode, null, parentComponent, "unmounted");
        }, parentSuspense);
    };
    const remove = (vnode)=>{
        const { type: type, el: el, anchor: anchor, transition: transition } = vnode;
        if (type === $ffe19d932e7e7bce$export$ffb0004e005737fa) {
            var child;
            removeFragment(el, anchor);
            return;
        }
        if (type === $ffe19d932e7e7bce$export$c1b9a1d3af45b7b6) {
            removeStaticNode(vnode);
            return;
        }
        const performRemove = ()=>{
            hostRemove(el);
            if (transition && !transition.persisted && transition.afterLeave) transition.afterLeave();
        };
        if (vnode.shapeFlag & 1 && transition && !transition.persisted) {
            const { leave: leave, delayLeave: delayLeave } = transition;
            const performLeave = ()=>leave(el, performRemove);
            if (delayLeave) delayLeave(vnode.el, performRemove, performLeave);
            else performLeave();
        } else performRemove();
    };
    const removeFragment = (cur, end)=>{
        let next;
        while(cur !== end){
            next = hostNextSibling(cur);
            hostRemove(cur);
            cur = next;
        }
        hostRemove(end);
    };
    const unmountComponent = (instance, parentSuspense, doRemove)=>{
        const { bum: bum, scope: scope, update: update, subTree: subTree, um: um } = instance;
        if (bum) (0, $16Sl1.invokeArrayFns)(bum);
        scope.stop();
        if (update) {
            update.active = false;
            unmount(subTree, instance, parentSuspense, doRemove);
        }
        if (um) $ffe19d932e7e7bce$var$queuePostRenderEffect(um, parentSuspense);
        $ffe19d932e7e7bce$var$queuePostRenderEffect(()=>{
            instance.isUnmounted = true;
        }, parentSuspense);
        if (parentSuspense && parentSuspense.pendingBranch && !parentSuspense.isUnmounted && instance.asyncDep && !instance.asyncResolved && instance.suspenseId === parentSuspense.pendingId) {
            parentSuspense.deps--;
            if (parentSuspense.deps === 0) parentSuspense.resolve();
        }
        if (__VUE_PROD_DEVTOOLS__) $ffe19d932e7e7bce$var$devtoolsComponentRemoved(instance);
    };
    const unmountChildren = (children, parentComponent, parentSuspense, doRemove = false, optimized = false, start = 0)=>{
        for(let i = start; i < children.length; i++)unmount(children[i], parentComponent, parentSuspense, doRemove, optimized);
    };
    const getNextHostNode = (vnode)=>{
        if (vnode.shapeFlag & 6) return getNextHostNode(vnode.component.subTree);
        if (vnode.shapeFlag & 128) return vnode.suspense.next();
        return hostNextSibling(vnode.anchor || vnode.el);
    };
    let isFlushing = false;
    const render = (vnode, container, namespace)=>{
        if (vnode == null) {
            if (container._vnode) unmount(container._vnode, null, null, true);
        } else patch(container._vnode || null, vnode, container, null, null, null, namespace);
        if (!isFlushing) {
            isFlushing = true;
            $ffe19d932e7e7bce$var$flushPreFlushCbs();
            $ffe19d932e7e7bce$var$flushPostFlushCbs();
            isFlushing = false;
        }
        container._vnode = vnode;
    };
    const internals = {
        p: patch,
        um: unmount,
        m: move,
        r: remove,
        mt: mountComponent,
        mc: mountChildren,
        pc: patchChildren,
        pbc: patchBlockChildren,
        n: getNextHostNode,
        o: options
    };
    let hydrate;
    let hydrateNode;
    if (createHydrationFns) [hydrate, hydrateNode] = createHydrationFns(internals);
    return {
        render: render,
        hydrate: hydrate,
        createApp: $ffe19d932e7e7bce$var$createAppAPI(render, hydrate)
    };
}
function $ffe19d932e7e7bce$var$resolveChildrenNamespace({ type: type, props: props }, currentNamespace) {
    return currentNamespace === "svg" && type === "foreignObject" || currentNamespace === "mathml" && type === "annotation-xml" && props && props.encoding && props.encoding.includes("html") ? void 0 : currentNamespace;
}
function $ffe19d932e7e7bce$var$toggleRecurse({ effect: effect, update: update }, allowed) {
    effect.allowRecurse = update.allowRecurse = allowed;
}
function $ffe19d932e7e7bce$var$needTransition(parentSuspense, transition) {
    return (!parentSuspense || parentSuspense && !parentSuspense.pendingBranch) && transition && !transition.persisted;
}
function $ffe19d932e7e7bce$var$traverseStaticChildren(n1, n2, shallow = false) {
    const ch1 = n1.children;
    const ch2 = n2.children;
    if ((0, $16Sl1.isArray)(ch1) && (0, $16Sl1.isArray)(ch2)) for(let i = 0; i < ch1.length; i++){
        const c1 = ch1[i];
        let c2 = ch2[i];
        if (c2.shapeFlag & 1 && !c2.dynamicChildren) {
            if (c2.patchFlag <= 0 || c2.patchFlag === 32) {
                c2 = ch2[i] = $ffe19d932e7e7bce$var$cloneIfMounted(ch2[i]);
                c2.el = c1.el;
            }
            if (!shallow) $ffe19d932e7e7bce$var$traverseStaticChildren(c1, c2);
        }
        if (c2.type === $ffe19d932e7e7bce$export$5f1af8db9871e1d6) c2.el = c1.el;
    }
}
function $ffe19d932e7e7bce$var$getSequence(arr) {
    const p = arr.slice();
    const result = [
        0
    ];
    let i, j, u, v1, c;
    const len = arr.length;
    for(i = 0; i < len; i++){
        const arrI = arr[i];
        if (arrI !== 0) {
            j = result[result.length - 1];
            if (arr[j] < arrI) {
                p[i] = j;
                result.push(i);
                continue;
            }
            u = 0;
            v1 = result.length - 1;
            while(u < v1){
                c = u + v1 >> 1;
                if (arr[result[c]] < arrI) u = c + 1;
                else v1 = c;
            }
            if (arrI < arr[result[u]]) {
                if (u > 0) p[i] = result[u - 1];
                result[u] = i;
            }
        }
    }
    u = result.length;
    v1 = result[u - 1];
    while(u-- > 0){
        result[u] = v1;
        v1 = p[v1];
    }
    return result;
}
function $ffe19d932e7e7bce$var$locateNonHydratedAsyncRoot(instance) {
    const subComponent = instance.subTree.component;
    if (subComponent) {
        if (subComponent.asyncDep && !subComponent.asyncResolved) return subComponent;
        else return $ffe19d932e7e7bce$var$locateNonHydratedAsyncRoot(subComponent);
    }
}
const $ffe19d932e7e7bce$var$isTeleport = (type)=>type.__isTeleport;
const $ffe19d932e7e7bce$var$isTeleportDisabled = (props)=>props && (props.disabled || props.disabled === "");
const $ffe19d932e7e7bce$var$isTargetSVG = (target)=>typeof SVGElement !== "undefined" && target instanceof SVGElement;
const $ffe19d932e7e7bce$var$isTargetMathML = (target)=>typeof MathMLElement === "function" && target instanceof MathMLElement;
const $ffe19d932e7e7bce$var$resolveTarget = (props, select)=>{
    const targetSelector = props && props.to;
    if ((0, $16Sl1.isString)(targetSelector)) {
        if (!select) return null;
        else {
            const target = select(targetSelector);
            target;
            return target;
        }
    } else return targetSelector;
};
const $ffe19d932e7e7bce$var$TeleportImpl = {
    name: "Teleport",
    __isTeleport: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals) {
        const { mc: mountChildren, pc: patchChildren, pbc: patchBlockChildren, o: { insert: insert, querySelector: querySelector, createText: createText, createComment: createComment } } = internals;
        const disabled = $ffe19d932e7e7bce$var$isTeleportDisabled(n2.props);
        let { shapeFlag: shapeFlag, children: children, dynamicChildren: dynamicChildren } = n2;
        if (n1 == null) {
            const placeholder = n2.el = createText("");
            const mainAnchor = n2.anchor = createText("");
            insert(placeholder, container, anchor);
            insert(mainAnchor, container, anchor);
            const target = n2.target = $ffe19d932e7e7bce$var$resolveTarget(n2.props, querySelector);
            const targetAnchor = n2.targetAnchor = createText("");
            if (target) {
                insert(targetAnchor, target);
                if (namespace === "svg" || $ffe19d932e7e7bce$var$isTargetSVG(target)) namespace = "svg";
                else if (namespace === "mathml" || $ffe19d932e7e7bce$var$isTargetMathML(target)) namespace = "mathml";
            }
            const mount = (container2, anchor2)=>{
                if (shapeFlag & 16) mountChildren(children, container2, anchor2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            };
            if (disabled) mount(container, mainAnchor);
            else if (target) mount(target, targetAnchor);
        } else {
            n2.el = n1.el;
            const mainAnchor = n2.anchor = n1.anchor;
            const target = n2.target = n1.target;
            const targetAnchor = n2.targetAnchor = n1.targetAnchor;
            const wasDisabled = $ffe19d932e7e7bce$var$isTeleportDisabled(n1.props);
            const currentContainer = wasDisabled ? container : target;
            const currentAnchor = wasDisabled ? mainAnchor : targetAnchor;
            if (namespace === "svg" || $ffe19d932e7e7bce$var$isTargetSVG(target)) namespace = "svg";
            else if (namespace === "mathml" || $ffe19d932e7e7bce$var$isTargetMathML(target)) namespace = "mathml";
            if (dynamicChildren) {
                patchBlockChildren(n1.dynamicChildren, dynamicChildren, currentContainer, parentComponent, parentSuspense, namespace, slotScopeIds);
                $ffe19d932e7e7bce$var$traverseStaticChildren(n1, n2, true);
            } else if (!optimized) patchChildren(n1, n2, currentContainer, currentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, false);
            if (disabled) {
                if (!wasDisabled) $ffe19d932e7e7bce$var$moveTeleport(n2, container, mainAnchor, internals, 1);
                else if (n2.props && n1.props && n2.props.to !== n1.props.to) n2.props.to = n1.props.to;
            } else {
                if ((n2.props && n2.props.to) !== (n1.props && n1.props.to)) {
                    const nextTarget = n2.target = $ffe19d932e7e7bce$var$resolveTarget(n2.props, querySelector);
                    if (nextTarget) $ffe19d932e7e7bce$var$moveTeleport(n2, nextTarget, null, internals, 0);
                } else if (wasDisabled) $ffe19d932e7e7bce$var$moveTeleport(n2, target, targetAnchor, internals, 1);
            }
        }
        $ffe19d932e7e7bce$var$updateCssVars(n2);
    },
    remove (vnode, parentComponent, parentSuspense, optimized, { um: unmount, o: { remove: hostRemove } }, doRemove) {
        const { shapeFlag: shapeFlag, children: children, anchor: anchor, targetAnchor: targetAnchor, target: target, props: props } = vnode;
        if (target) hostRemove(targetAnchor);
        doRemove && hostRemove(anchor);
        if (shapeFlag & 16) {
            const shouldRemove = doRemove || !$ffe19d932e7e7bce$var$isTeleportDisabled(props);
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                unmount(child, parentComponent, parentSuspense, shouldRemove, !!child.dynamicChildren);
            }
        }
    },
    move: $ffe19d932e7e7bce$var$moveTeleport,
    hydrate: $ffe19d932e7e7bce$var$hydrateTeleport
};
function $ffe19d932e7e7bce$var$moveTeleport(vnode, container, parentAnchor, { o: { insert: insert }, m: move }, moveType = 2) {
    if (moveType === 0) insert(vnode.targetAnchor, container, parentAnchor);
    const { el: el, anchor: anchor, shapeFlag: shapeFlag, children: children, props: props } = vnode;
    const isReorder = moveType === 2;
    if (isReorder) insert(el, container, parentAnchor);
    if (!isReorder || $ffe19d932e7e7bce$var$isTeleportDisabled(props)) {
        if (shapeFlag & 16) for(let i = 0; i < children.length; i++)move(children[i], container, parentAnchor, 2);
    }
    if (isReorder) insert(anchor, container, parentAnchor);
}
function $ffe19d932e7e7bce$var$hydrateTeleport(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, { o: { nextSibling: nextSibling, parentNode: parentNode, querySelector: querySelector } }, hydrateChildren) {
    const target = vnode.target = $ffe19d932e7e7bce$var$resolveTarget(vnode.props, querySelector);
    if (target) {
        const targetNode = target._lpa || target.firstChild;
        if (vnode.shapeFlag & 16) {
            if ($ffe19d932e7e7bce$var$isTeleportDisabled(vnode.props)) {
                vnode.anchor = hydrateChildren(nextSibling(node), vnode, parentNode(node), parentComponent, parentSuspense, slotScopeIds, optimized);
                vnode.targetAnchor = targetNode;
            } else {
                vnode.anchor = nextSibling(node);
                let targetAnchor = targetNode;
                while(targetAnchor){
                    targetAnchor = nextSibling(targetAnchor);
                    if (targetAnchor && targetAnchor.nodeType === 8 && targetAnchor.data === "teleport anchor") {
                        vnode.targetAnchor = targetAnchor;
                        target._lpa = vnode.targetAnchor && nextSibling(vnode.targetAnchor);
                        break;
                    }
                }
                hydrateChildren(targetNode, vnode, target, parentComponent, parentSuspense, slotScopeIds, optimized);
            }
        }
        $ffe19d932e7e7bce$var$updateCssVars(vnode);
    }
    return vnode.anchor && nextSibling(vnode.anchor);
}
const $ffe19d932e7e7bce$export$76d55a0304a371f4 = $ffe19d932e7e7bce$var$TeleportImpl;
function $ffe19d932e7e7bce$var$updateCssVars(vnode) {
    const ctx = vnode.ctx;
    if (ctx && ctx.ut) {
        let node = vnode.children[0].el;
        while(node && node !== vnode.targetAnchor){
            if (node.nodeType === 1) node.setAttribute("data-v-owner", ctx.uid);
            node = node.nextSibling;
        }
        ctx.ut();
    }
}
const $ffe19d932e7e7bce$export$ffb0004e005737fa = Symbol.for("v-fgt");
const $ffe19d932e7e7bce$export$5f1af8db9871e1d6 = Symbol.for("v-txt");
const $ffe19d932e7e7bce$export$4d299b491347818a = Symbol.for("v-cmt");
const $ffe19d932e7e7bce$export$c1b9a1d3af45b7b6 = Symbol.for("v-stc");
const $ffe19d932e7e7bce$var$blockStack = [];
let $ffe19d932e7e7bce$var$currentBlock = null;
function $ffe19d932e7e7bce$export$e7eaa45e502fe5cc(disableTracking = false) {
    $ffe19d932e7e7bce$var$blockStack.push($ffe19d932e7e7bce$var$currentBlock = disableTracking ? null : []);
}
function $ffe19d932e7e7bce$var$closeBlock() {
    $ffe19d932e7e7bce$var$blockStack.pop();
    $ffe19d932e7e7bce$var$currentBlock = $ffe19d932e7e7bce$var$blockStack[$ffe19d932e7e7bce$var$blockStack.length - 1] || null;
}
let $ffe19d932e7e7bce$var$isBlockTreeEnabled = 1;
function $ffe19d932e7e7bce$export$c20bee82f26f1e27(value) {
    $ffe19d932e7e7bce$var$isBlockTreeEnabled += value;
}
function $ffe19d932e7e7bce$var$setupBlock(vnode) {
    vnode.dynamicChildren = $ffe19d932e7e7bce$var$isBlockTreeEnabled > 0 ? $ffe19d932e7e7bce$var$currentBlock || (0, $16Sl1.EMPTY_ARR) : null;
    $ffe19d932e7e7bce$var$closeBlock();
    if ($ffe19d932e7e7bce$var$isBlockTreeEnabled > 0 && $ffe19d932e7e7bce$var$currentBlock) $ffe19d932e7e7bce$var$currentBlock.push(vnode);
    return vnode;
}
function $ffe19d932e7e7bce$export$167055419fc69ec1(type, props, children, patchFlag, dynamicProps, shapeFlag) {
    return $ffe19d932e7e7bce$var$setupBlock($ffe19d932e7e7bce$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, true));
}
function $ffe19d932e7e7bce$export$9f2dfe8048dfb22b(type, props, children, patchFlag, dynamicProps) {
    return $ffe19d932e7e7bce$var$setupBlock($ffe19d932e7e7bce$export$bf5c4cf060303d58(type, props, children, patchFlag, dynamicProps, true));
}
function $ffe19d932e7e7bce$export$3868d13f8734ae81(value) {
    return value ? value.__v_isVNode === true : false;
}
function $ffe19d932e7e7bce$var$isSameVNodeType(n1, n2) {
    return n1.type === n2.type && n1.key === n2.key;
}
let $ffe19d932e7e7bce$var$vnodeArgsTransformer;
function $ffe19d932e7e7bce$export$83beccd3afeeb809(transformer) {
    $ffe19d932e7e7bce$var$vnodeArgsTransformer = transformer;
}
const $ffe19d932e7e7bce$var$createVNodeWithArgsTransform = (...args)=>{
    return $ffe19d932e7e7bce$var$_createVNode(...$ffe19d932e7e7bce$var$vnodeArgsTransformer ? $ffe19d932e7e7bce$var$vnodeArgsTransformer(args, $ffe19d932e7e7bce$var$currentRenderingInstance) : args);
};
const $ffe19d932e7e7bce$var$normalizeKey = ({ key: key })=>key != null ? key : null;
const $ffe19d932e7e7bce$var$normalizeRef = ({ ref: ref, ref_key: ref_key, ref_for: ref_for })=>{
    if (typeof ref === "number") ref = "" + ref;
    return ref != null ? (0, $16Sl1.isString)(ref) || (0, $99kuS.isRef)(ref) || (0, $16Sl1.isFunction)(ref) ? {
        i: $ffe19d932e7e7bce$var$currentRenderingInstance,
        r: ref,
        k: ref_key,
        f: !!ref_for
    } : ref : null;
};
function $ffe19d932e7e7bce$export$42098e0eaa15c48e(type, props = null, children = null, patchFlag = 0, dynamicProps = null, shapeFlag = type === $ffe19d932e7e7bce$export$ffb0004e005737fa ? 0 : 1, isBlockNode = false, needFullChildrenNormalization = false) {
    const vnode = {
        __v_isVNode: true,
        __v_skip: true,
        type: type,
        props: props,
        key: props && $ffe19d932e7e7bce$var$normalizeKey(props),
        ref: props && $ffe19d932e7e7bce$var$normalizeRef(props),
        scopeId: $ffe19d932e7e7bce$var$currentScopeId,
        slotScopeIds: null,
        children: children,
        component: null,
        suspense: null,
        ssContent: null,
        ssFallback: null,
        dirs: null,
        transition: null,
        el: null,
        anchor: null,
        target: null,
        targetAnchor: null,
        staticCount: 0,
        shapeFlag: shapeFlag,
        patchFlag: patchFlag,
        dynamicProps: dynamicProps,
        dynamicChildren: null,
        appContext: null,
        ctx: $ffe19d932e7e7bce$var$currentRenderingInstance
    };
    if (needFullChildrenNormalization) {
        $ffe19d932e7e7bce$var$normalizeChildren(vnode, children);
        if (shapeFlag & 128) type.normalize(vnode);
    } else if (children) vnode.shapeFlag |= (0, $16Sl1.isString)(children) ? 8 : 16;
    if ($ffe19d932e7e7bce$var$isBlockTreeEnabled > 0 && // avoid a block node from tracking itself
    !isBlockNode && // has current parent block
    $ffe19d932e7e7bce$var$currentBlock && // presence of a patch flag indicates this node needs patching on updates.
    // component nodes also should always be patched, because even if the
    // component doesn't need to update, it needs to persist the instance on to
    // the next vnode so that it can be properly unmounted later.
    (vnode.patchFlag > 0 || shapeFlag & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
    // vnode should not be considered dynamic due to handler caching.
    vnode.patchFlag !== 32) $ffe19d932e7e7bce$var$currentBlock.push(vnode);
    return vnode;
}
const $ffe19d932e7e7bce$export$bf5c4cf060303d58 = $ffe19d932e7e7bce$var$_createVNode;
function $ffe19d932e7e7bce$var$_createVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, isBlockNode = false) {
    if (!type || type === $ffe19d932e7e7bce$var$NULL_DYNAMIC_COMPONENT) type = $ffe19d932e7e7bce$export$4d299b491347818a;
    if ($ffe19d932e7e7bce$export$3868d13f8734ae81(type)) {
        const cloned = $ffe19d932e7e7bce$export$ee4f9e12c0a92a1a(type, props, true);
        if (children) $ffe19d932e7e7bce$var$normalizeChildren(cloned, children);
        if ($ffe19d932e7e7bce$var$isBlockTreeEnabled > 0 && !isBlockNode && $ffe19d932e7e7bce$var$currentBlock) {
            if (cloned.shapeFlag & 6) $ffe19d932e7e7bce$var$currentBlock[$ffe19d932e7e7bce$var$currentBlock.indexOf(type)] = cloned;
            else $ffe19d932e7e7bce$var$currentBlock.push(cloned);
        }
        cloned.patchFlag |= -2;
        return cloned;
    }
    if ($ffe19d932e7e7bce$var$isClassComponent(type)) type = type.__vccOpts;
    if (props) {
        props = $ffe19d932e7e7bce$export$1f1be0e0e384d7d2(props);
        let { class: klass, style: style } = props;
        if (klass && !(0, $16Sl1.isString)(klass)) props.class = (0, $16Sl1.normalizeClass)(klass);
        if ((0, $16Sl1.isObject)(style)) {
            if ((0, $99kuS.isProxy)(style) && !(0, $16Sl1.isArray)(style)) style = (0, $16Sl1.extend)({}, style);
            props.style = (0, $16Sl1.normalizeStyle)(style);
        }
    }
    const shapeFlag = (0, $16Sl1.isString)(type) ? 1 : $ffe19d932e7e7bce$var$isSuspense(type) ? 128 : $ffe19d932e7e7bce$var$isTeleport(type) ? 64 : (0, $16Sl1.isObject)(type) ? 4 : (0, $16Sl1.isFunction)(type) ? 2 : 0;
    return $ffe19d932e7e7bce$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, isBlockNode, true);
}
function $ffe19d932e7e7bce$export$1f1be0e0e384d7d2(props) {
    if (!props) return null;
    return (0, $99kuS.isProxy)(props) || $ffe19d932e7e7bce$var$isInternalObject(props) ? (0, $16Sl1.extend)({}, props) : props;
}
function $ffe19d932e7e7bce$export$ee4f9e12c0a92a1a(vnode, extraProps, mergeRef = false) {
    const { props: props, ref: ref, patchFlag: patchFlag, children: children } = vnode;
    const mergedProps = extraProps ? $ffe19d932e7e7bce$export$9d1611c77c2fe928(props || {}, extraProps) : props;
    const cloned = {
        __v_isVNode: true,
        __v_skip: true,
        type: vnode.type,
        props: mergedProps,
        key: mergedProps && $ffe19d932e7e7bce$var$normalizeKey(mergedProps),
        ref: extraProps && extraProps.ref ? // #2078 in the case of <component :is="vnode" ref="extra"/>
        // if the vnode itself already has a ref, cloneVNode will need to merge
        // the refs so the single vnode can be set on multiple refs
        mergeRef && ref ? (0, $16Sl1.isArray)(ref) ? ref.concat($ffe19d932e7e7bce$var$normalizeRef(extraProps)) : [
            ref,
            $ffe19d932e7e7bce$var$normalizeRef(extraProps)
        ] : $ffe19d932e7e7bce$var$normalizeRef(extraProps) : ref,
        scopeId: vnode.scopeId,
        slotScopeIds: vnode.slotScopeIds,
        children: children,
        target: vnode.target,
        targetAnchor: vnode.targetAnchor,
        staticCount: vnode.staticCount,
        shapeFlag: vnode.shapeFlag,
        // if the vnode is cloned with extra props, we can no longer assume its
        // existing patch flag to be reliable and need to add the FULL_PROPS flag.
        // note: preserve flag for fragments since they use the flag for children
        // fast paths only.
        patchFlag: extraProps && vnode.type !== $ffe19d932e7e7bce$export$ffb0004e005737fa ? patchFlag === -1 ? 16 : patchFlag | 16 : patchFlag,
        dynamicProps: vnode.dynamicProps,
        dynamicChildren: vnode.dynamicChildren,
        appContext: vnode.appContext,
        dirs: vnode.dirs,
        transition: vnode.transition,
        // These should technically only be non-null on mounted VNodes. However,
        // they *should* be copied for kept-alive vnodes. So we just always copy
        // them since them being non-null during a mount doesn't affect the logic as
        // they will simply be overwritten.
        component: vnode.component,
        suspense: vnode.suspense,
        ssContent: vnode.ssContent && $ffe19d932e7e7bce$export$ee4f9e12c0a92a1a(vnode.ssContent),
        ssFallback: vnode.ssFallback && $ffe19d932e7e7bce$export$ee4f9e12c0a92a1a(vnode.ssFallback),
        el: vnode.el,
        anchor: vnode.anchor,
        ctx: vnode.ctx,
        ce: vnode.ce
    };
    return cloned;
}
function $ffe19d932e7e7bce$var$deepCloneVNode(vnode) {
    const cloned = $ffe19d932e7e7bce$export$ee4f9e12c0a92a1a(vnode);
    if ((0, $16Sl1.isArray)(vnode.children)) cloned.children = vnode.children.map($ffe19d932e7e7bce$var$deepCloneVNode);
    return cloned;
}
function $ffe19d932e7e7bce$export$22f9b5ffd89dac9(text = " ", flag = 0) {
    return $ffe19d932e7e7bce$export$bf5c4cf060303d58($ffe19d932e7e7bce$export$5f1af8db9871e1d6, null, text, flag);
}
function $ffe19d932e7e7bce$export$33a9f6dd2840e6bb(content, numberOfNodes) {
    const vnode = $ffe19d932e7e7bce$export$bf5c4cf060303d58($ffe19d932e7e7bce$export$c1b9a1d3af45b7b6, null, content);
    vnode.staticCount = numberOfNodes;
    return vnode;
}
function $ffe19d932e7e7bce$export$49553837c7236d3c(text = "", asBlock = false) {
    return asBlock ? ($ffe19d932e7e7bce$export$e7eaa45e502fe5cc(), $ffe19d932e7e7bce$export$9f2dfe8048dfb22b($ffe19d932e7e7bce$export$4d299b491347818a, null, text)) : $ffe19d932e7e7bce$export$bf5c4cf060303d58($ffe19d932e7e7bce$export$4d299b491347818a, null, text);
}
function $ffe19d932e7e7bce$var$normalizeVNode(child) {
    if (child == null || typeof child === "boolean") return $ffe19d932e7e7bce$export$bf5c4cf060303d58($ffe19d932e7e7bce$export$4d299b491347818a);
    else if ((0, $16Sl1.isArray)(child)) return $ffe19d932e7e7bce$export$bf5c4cf060303d58($ffe19d932e7e7bce$export$ffb0004e005737fa, null, // #3666, avoid reference pollution when reusing vnode
    child.slice());
    else if (typeof child === "object") return $ffe19d932e7e7bce$var$cloneIfMounted(child);
    else return $ffe19d932e7e7bce$export$bf5c4cf060303d58($ffe19d932e7e7bce$export$5f1af8db9871e1d6, null, String(child));
}
function $ffe19d932e7e7bce$var$cloneIfMounted(child) {
    return child.el === null && child.patchFlag !== -1 || child.memo ? child : $ffe19d932e7e7bce$export$ee4f9e12c0a92a1a(child);
}
function $ffe19d932e7e7bce$var$normalizeChildren(vnode, children) {
    let type = 0;
    const { shapeFlag: shapeFlag } = vnode;
    if (children == null) children = null;
    else if ((0, $16Sl1.isArray)(children)) type = 16;
    else if (typeof children === "object") {
        if (shapeFlag & 65) {
            const slot = children.default;
            if (slot) {
                slot._c && (slot._d = false);
                $ffe19d932e7e7bce$var$normalizeChildren(vnode, slot());
                slot._c && (slot._d = true);
            }
            return;
        } else {
            type = 32;
            const slotFlag = children._;
            if (!slotFlag && !$ffe19d932e7e7bce$var$isInternalObject(children)) children._ctx = $ffe19d932e7e7bce$var$currentRenderingInstance;
            else if (slotFlag === 3 && $ffe19d932e7e7bce$var$currentRenderingInstance) {
                if ($ffe19d932e7e7bce$var$currentRenderingInstance.slots._ === 1) children._ = 1;
                else {
                    children._ = 2;
                    vnode.patchFlag |= 1024;
                }
            }
        }
    } else if ((0, $16Sl1.isFunction)(children)) {
        children = {
            default: children,
            _ctx: $ffe19d932e7e7bce$var$currentRenderingInstance
        };
        type = 32;
    } else {
        children = String(children);
        if (shapeFlag & 64) {
            type = 16;
            children = [
                $ffe19d932e7e7bce$export$22f9b5ffd89dac9(children)
            ];
        } else type = 8;
    }
    vnode.children = children;
    vnode.shapeFlag |= type;
}
function $ffe19d932e7e7bce$export$9d1611c77c2fe928(...args) {
    const ret = {};
    for(let i = 0; i < args.length; i++){
        const toMerge = args[i];
        for(const key in toMerge){
            if (key === "class") {
                if (ret.class !== toMerge.class) ret.class = (0, $16Sl1.normalizeClass)([
                    ret.class,
                    toMerge.class
                ]);
            } else if (key === "style") ret.style = (0, $16Sl1.normalizeStyle)([
                ret.style,
                toMerge.style
            ]);
            else if ((0, $16Sl1.isOn)(key)) {
                const existing = ret[key];
                const incoming = toMerge[key];
                if (incoming && existing !== incoming && !((0, $16Sl1.isArray)(existing) && existing.includes(incoming))) ret[key] = existing ? [].concat(existing, incoming) : incoming;
            } else if (key !== "") ret[key] = toMerge[key];
        }
    }
    return ret;
}
function $ffe19d932e7e7bce$var$invokeVNodeHook(hook, instance, vnode, prevVNode = null) {
    $ffe19d932e7e7bce$export$dae85862a8d94378(hook, instance, 7, [
        vnode,
        prevVNode
    ]);
}
const $ffe19d932e7e7bce$var$emptyAppContext = $ffe19d932e7e7bce$var$createAppContext();
let $ffe19d932e7e7bce$var$uid = 0;
function $ffe19d932e7e7bce$var$createComponentInstance(vnode, parent, suspense) {
    const type = vnode.type;
    const appContext = (parent ? parent.appContext : vnode.appContext) || $ffe19d932e7e7bce$var$emptyAppContext;
    const instance = {
        uid: $ffe19d932e7e7bce$var$uid++,
        vnode: vnode,
        type: type,
        parent: parent,
        appContext: appContext,
        root: null,
        // to be immediately set
        next: null,
        subTree: null,
        // will be set synchronously right after creation
        effect: null,
        update: null,
        // will be set synchronously right after creation
        scope: new (0, $99kuS.EffectScope)(true),
        render: null,
        proxy: null,
        exposed: null,
        exposeProxy: null,
        withProxy: null,
        provides: parent ? parent.provides : Object.create(appContext.provides),
        accessCache: null,
        renderCache: [],
        // local resolved assets
        components: null,
        directives: null,
        // resolved props and emits options
        propsOptions: $ffe19d932e7e7bce$var$normalizePropsOptions(type, appContext),
        emitsOptions: $ffe19d932e7e7bce$var$normalizeEmitsOptions(type, appContext),
        // emit
        emit: null,
        // to be set immediately
        emitted: null,
        // props default value
        propsDefaults: (0, $16Sl1.EMPTY_OBJ),
        // inheritAttrs
        inheritAttrs: type.inheritAttrs,
        // state
        ctx: (0, $16Sl1.EMPTY_OBJ),
        data: (0, $16Sl1.EMPTY_OBJ),
        props: (0, $16Sl1.EMPTY_OBJ),
        attrs: (0, $16Sl1.EMPTY_OBJ),
        slots: (0, $16Sl1.EMPTY_OBJ),
        refs: (0, $16Sl1.EMPTY_OBJ),
        setupState: (0, $16Sl1.EMPTY_OBJ),
        setupContext: null,
        attrsProxy: null,
        slotsProxy: null,
        suspense: // suspense related
        suspense,
        suspenseId: suspense ? suspense.pendingId : 0,
        asyncDep: null,
        asyncResolved: false,
        // lifecycle hooks
        // not using enums here because it results in computed properties
        isMounted: false,
        isUnmounted: false,
        isDeactivated: false,
        bc: null,
        c: null,
        bm: null,
        m: null,
        bu: null,
        u: null,
        um: null,
        bum: null,
        da: null,
        a: null,
        rtg: null,
        rtc: null,
        ec: null,
        sp: null
    };
    instance.ctx = {
        _: instance
    };
    instance.root = parent ? parent.root : instance;
    instance.emit = $ffe19d932e7e7bce$var$emit.bind(null, instance);
    if (vnode.ce) vnode.ce(instance);
    return instance;
}
let $ffe19d932e7e7bce$var$currentInstance = null;
const $ffe19d932e7e7bce$export$f13e630aa3915748 = ()=>$ffe19d932e7e7bce$var$currentInstance || $ffe19d932e7e7bce$var$currentRenderingInstance;
let $ffe19d932e7e7bce$var$internalSetCurrentInstance;
let $ffe19d932e7e7bce$var$setInSSRSetupState;
{
    const g = (0, $16Sl1.getGlobalThis)();
    const registerGlobalSetter = (key, setter)=>{
        let setters;
        if (!(setters = g[key])) setters = g[key] = [];
        setters.push(setter);
        return (v1)=>{
            if (setters.length > 1) setters.forEach((set)=>set(v1));
            else setters[0](v1);
        };
    };
    $ffe19d932e7e7bce$var$internalSetCurrentInstance = registerGlobalSetter(`__VUE_INSTANCE_SETTERS__`, (v1)=>$ffe19d932e7e7bce$var$currentInstance = v1);
    $ffe19d932e7e7bce$var$setInSSRSetupState = registerGlobalSetter(`__VUE_SSR_SETTERS__`, (v1)=>$ffe19d932e7e7bce$var$isInSSRComponentSetup = v1);
}const $ffe19d932e7e7bce$var$setCurrentInstance = (instance)=>{
    const prev = $ffe19d932e7e7bce$var$currentInstance;
    $ffe19d932e7e7bce$var$internalSetCurrentInstance(instance);
    instance.scope.on();
    return ()=>{
        instance.scope.off();
        $ffe19d932e7e7bce$var$internalSetCurrentInstance(prev);
    };
};
const $ffe19d932e7e7bce$var$unsetCurrentInstance = ()=>{
    $ffe19d932e7e7bce$var$currentInstance && $ffe19d932e7e7bce$var$currentInstance.scope.off();
    $ffe19d932e7e7bce$var$internalSetCurrentInstance(null);
};
const $ffe19d932e7e7bce$var$isBuiltInTag = /* @__PURE__ */ (0, $16Sl1.makeMap)("slot,component");
function $ffe19d932e7e7bce$var$validateComponentName(name, { isNativeTag: isNativeTag }) {
    if ($ffe19d932e7e7bce$var$isBuiltInTag(name) || isNativeTag(name)) $ffe19d932e7e7bce$var$warn$1("Do not use built-in or reserved HTML elements as component id: " + name);
}
function $ffe19d932e7e7bce$var$isStatefulComponent(instance) {
    return instance.vnode.shapeFlag & 4;
}
let $ffe19d932e7e7bce$var$isInSSRComponentSetup = false;
function $ffe19d932e7e7bce$var$setupComponent(instance, isSSR = false) {
    isSSR && $ffe19d932e7e7bce$var$setInSSRSetupState(isSSR);
    const { props: props, children: children } = instance.vnode;
    const isStateful = $ffe19d932e7e7bce$var$isStatefulComponent(instance);
    $ffe19d932e7e7bce$var$initProps(instance, props, isStateful, isSSR);
    $ffe19d932e7e7bce$var$initSlots(instance, children);
    const setupResult = isStateful ? $ffe19d932e7e7bce$var$setupStatefulComponent(instance, isSSR) : void 0;
    isSSR && $ffe19d932e7e7bce$var$setInSSRSetupState(false);
    return setupResult;
}
function $ffe19d932e7e7bce$var$setupStatefulComponent(instance, isSSR) {
    var _a;
    const Component = instance.type;
    instance.accessCache = /* @__PURE__ */ Object.create(null);
    instance.proxy = new Proxy(instance.ctx, $ffe19d932e7e7bce$var$PublicInstanceProxyHandlers);
    const { setup: setup } = Component;
    if (setup) {
        const setupContext = instance.setupContext = setup.length > 1 ? $ffe19d932e7e7bce$var$createSetupContext(instance) : null;
        const reset = $ffe19d932e7e7bce$var$setCurrentInstance(instance);
        (0, $99kuS.pauseTracking)();
        const setupResult = $ffe19d932e7e7bce$export$b22fcaf88446e9bf(setup, instance, 0, [
            (0, instance.props),
            setupContext
        ]);
        (0, $99kuS.resetTracking)();
        reset();
        if ((0, $16Sl1.isPromise)(setupResult)) {
            setupResult.then($ffe19d932e7e7bce$var$unsetCurrentInstance, $ffe19d932e7e7bce$var$unsetCurrentInstance);
            if (isSSR) return setupResult.then((resolvedResult)=>{
                $ffe19d932e7e7bce$var$handleSetupResult(instance, resolvedResult, isSSR);
            }).catch((e)=>{
                $ffe19d932e7e7bce$export$d3da1ecaf1206c58(e, instance, 0);
            });
            else instance.asyncDep = setupResult;
        } else $ffe19d932e7e7bce$var$handleSetupResult(instance, setupResult, isSSR);
    } else $ffe19d932e7e7bce$var$finishComponentSetup(instance, isSSR);
}
function $ffe19d932e7e7bce$var$handleSetupResult(instance, setupResult, isSSR) {
    if ((0, $16Sl1.isFunction)(setupResult)) {
        if (instance.type.__ssrInlineRender) instance.ssrRender = setupResult;
        else instance.render = setupResult;
    } else if ((0, $16Sl1.isObject)(setupResult)) {
        if (__VUE_PROD_DEVTOOLS__) instance.devtoolsRawSetupState = setupResult;
        instance.setupState = (0, $99kuS.proxyRefs)(setupResult);
    }
    $ffe19d932e7e7bce$var$finishComponentSetup(instance, isSSR);
}
let $ffe19d932e7e7bce$var$compile;
let $ffe19d932e7e7bce$var$installWithProxy;
function $ffe19d932e7e7bce$export$667bb5a67822b941(_compile) {
    $ffe19d932e7e7bce$var$compile = _compile;
    $ffe19d932e7e7bce$var$installWithProxy = (i)=>{
        if (i.render._rc) i.withProxy = new Proxy(i.ctx, $ffe19d932e7e7bce$var$RuntimeCompiledPublicInstanceProxyHandlers);
    };
}
const $ffe19d932e7e7bce$export$c93a9c496c5211fa = ()=>!$ffe19d932e7e7bce$var$compile;
function $ffe19d932e7e7bce$var$finishComponentSetup(instance, isSSR, skipOptions) {
    const Component = instance.type;
    if (!instance.render) {
        if (!isSSR && $ffe19d932e7e7bce$var$compile && !Component.render) {
            const template = Component.template || $ffe19d932e7e7bce$var$resolveMergedOptions(instance).template;
            if (template) {
                const { isCustomElement: isCustomElement, compilerOptions: compilerOptions } = instance.appContext.config;
                const { delimiters: delimiters, compilerOptions: componentCompilerOptions } = Component;
                const finalCompilerOptions = (0, $16Sl1.extend)((0, $16Sl1.extend)({
                    isCustomElement: isCustomElement,
                    delimiters: delimiters
                }, compilerOptions), componentCompilerOptions);
                Component.render = $ffe19d932e7e7bce$var$compile(template, finalCompilerOptions);
            }
        }
        instance.render = Component.render || (0, $16Sl1.NOOP);
        if ($ffe19d932e7e7bce$var$installWithProxy) $ffe19d932e7e7bce$var$installWithProxy(instance);
    }
    if (__VUE_OPTIONS_API__ && true) {
        const reset = $ffe19d932e7e7bce$var$setCurrentInstance(instance);
        (0, $99kuS.pauseTracking)();
        try {
            $ffe19d932e7e7bce$var$applyOptions(instance);
        } finally{
            (0, $99kuS.resetTracking)();
            reset();
        }
    }
}
const $ffe19d932e7e7bce$var$attrsProxyHandlers = {
    get (target, key) {
        (0, $99kuS.track)(target, "get", "");
        return target[key];
    }
};
function $ffe19d932e7e7bce$var$getSlotsProxy(instance) {
    return instance.slotsProxy || (instance.slotsProxy = new Proxy(instance.slots, {
        get (target, key) {
            (0, $99kuS.track)(instance, "get", "$slots");
            return target[key];
        }
    }));
}
function $ffe19d932e7e7bce$var$createSetupContext(instance) {
    const expose = (exposed)=>{
        instance.exposed = exposed || {};
    };
    var event, args;
    return {
        attrs: new Proxy(instance.attrs, $ffe19d932e7e7bce$var$attrsProxyHandlers),
        slots: instance.slots,
        emit: instance.emit,
        expose: expose
    };
}
function $ffe19d932e7e7bce$var$getExposeProxy(instance) {
    if (instance.exposed) return instance.exposeProxy || (instance.exposeProxy = new Proxy((0, $99kuS.proxyRefs)((0, $99kuS.markRaw)(instance.exposed)), {
        get (target, key) {
            if (key in target) return target[key];
            else if (key in $ffe19d932e7e7bce$var$publicPropertiesMap) return $ffe19d932e7e7bce$var$publicPropertiesMap[key](instance);
        },
        has (target, key) {
            return key in target || key in $ffe19d932e7e7bce$var$publicPropertiesMap;
        }
    }));
}
const $ffe19d932e7e7bce$var$classifyRE = /(?:^|[-_])(\w)/g;
const $ffe19d932e7e7bce$var$classify = (str)=>str.replace($ffe19d932e7e7bce$var$classifyRE, (c)=>c.toUpperCase()).replace(/[-_]/g, "");
function $ffe19d932e7e7bce$var$getComponentName(Component, includeInferred = true) {
    return (0, $16Sl1.isFunction)(Component) ? Component.displayName || Component.name : Component.name || includeInferred && Component.__name;
}
function $ffe19d932e7e7bce$var$formatComponentName(instance, Component, isRoot = false) {
    let name = $ffe19d932e7e7bce$var$getComponentName(Component);
    if (!name && Component.__file) {
        const match = Component.__file.match(/([^/\\]+)\.\w+$/);
        if (match) name = match[1];
    }
    if (!name && instance && instance.parent) {
        const inferFromRegistry = (registry)=>{
            for(const key in registry){
                if (registry[key] === Component) return key;
            }
        };
        name = inferFromRegistry(instance.components || instance.parent.type.components) || inferFromRegistry(instance.appContext.components);
    }
    return name ? $ffe19d932e7e7bce$var$classify(name) : isRoot ? `App` : `Anonymous`;
}
function $ffe19d932e7e7bce$var$isClassComponent(value) {
    return (0, $16Sl1.isFunction)(value) && "__vccOpts" in value;
}
const $ffe19d932e7e7bce$export$2983e091f1a1e8e2 = (getterOrOptions, debugOptions)=>{
    const c = (0, $99kuS.computed)(getterOrOptions, debugOptions, $ffe19d932e7e7bce$var$isInSSRComponentSetup);
    return c;
};
function $ffe19d932e7e7bce$export$fb78bd113157f1a1(props, name, options = (0, $16Sl1.EMPTY_OBJ)) {
    const i = $ffe19d932e7e7bce$export$f13e630aa3915748();
    const camelizedName = (0, $16Sl1.camelize)(name);
    const hyphenatedName = (0, $16Sl1.hyphenate)(name);
    const res = (0, $99kuS.customRef)((track, trigger)=>{
        let localValue;
        $ffe19d932e7e7bce$export$2035654f31b0e555(()=>{
            const propValue = props[name];
            if ((0, $16Sl1.hasChanged)(localValue, propValue)) {
                localValue = propValue;
                trigger();
            }
        });
        return {
            get () {
                track();
                return options.get ? options.get(localValue) : localValue;
            },
            set (value) {
                const rawProps = i.vnode.props;
                if (!(rawProps && // check if parent has passed v-model
                (name in rawProps || camelizedName in rawProps || hyphenatedName in rawProps) && (`onUpdate:${name}` in rawProps || `onUpdate:${camelizedName}` in rawProps || `onUpdate:${hyphenatedName}` in rawProps)) && (0, $16Sl1.hasChanged)(value, localValue)) {
                    localValue = value;
                    trigger();
                }
                i.emit(`update:${name}`, options.set ? options.set(value) : value);
            }
        };
    });
    const modifierKey = name === "modelValue" ? "modelModifiers" : `${name}Modifiers`;
    res[Symbol.iterator] = ()=>{
        let i2 = 0;
        return {
            next () {
                if (i2 < 2) return {
                    value: i2++ ? props[modifierKey] || {} : res,
                    done: false
                };
                else return {
                    done: true
                };
            }
        };
    };
    return res;
}
function $ffe19d932e7e7bce$export$dda1d9f60106f0e9(type, propsOrChildren, children) {
    const l = arguments.length;
    if (l === 2) {
        if ((0, $16Sl1.isObject)(propsOrChildren) && !(0, $16Sl1.isArray)(propsOrChildren)) {
            if ($ffe19d932e7e7bce$export$3868d13f8734ae81(propsOrChildren)) return $ffe19d932e7e7bce$export$bf5c4cf060303d58(type, null, [
                propsOrChildren
            ]);
            return $ffe19d932e7e7bce$export$bf5c4cf060303d58(type, propsOrChildren);
        } else return $ffe19d932e7e7bce$export$bf5c4cf060303d58(type, null, propsOrChildren);
    } else {
        if (l > 3) children = Array.prototype.slice.call(arguments, 2);
        else if (l === 3 && $ffe19d932e7e7bce$export$3868d13f8734ae81(children)) children = [
            children
        ];
        return $ffe19d932e7e7bce$export$bf5c4cf060303d58(type, propsOrChildren, children);
    }
}
function $ffe19d932e7e7bce$export$aed4979be6a60047() {
    return;
    function formatInstance(instance) {
        const blocks = [];
        if (instance.type.props && instance.props) blocks.push(createInstanceBlock("props", (0, $99kuS.toRaw)(instance.props)));
        if (instance.setupState !== (0, $16Sl1.EMPTY_OBJ)) blocks.push(createInstanceBlock("setup", instance.setupState));
        if (instance.data !== (0, $16Sl1.EMPTY_OBJ)) blocks.push(createInstanceBlock("data", (0, $99kuS.toRaw)(instance.data)));
        const computed = extractKeys(instance, "computed");
        if (computed) blocks.push(createInstanceBlock("computed", computed));
        const injected = extractKeys(instance, "inject");
        if (injected) blocks.push(createInstanceBlock("injected", injected));
        blocks.push([
            "div",
            {},
            [
                "span",
                {
                    style: keywordStyle.style + ";opacity:0.66"
                },
                "$ (internal): "
            ],
            [
                "object",
                {
                    object: instance
                }
            ]
        ]);
        return blocks;
    }
    function createInstanceBlock(type, target) {
        target = (0, $16Sl1.extend)({}, target);
        if (!Object.keys(target).length) return [
            "span",
            {}
        ];
        return [
            "div",
            {
                style: "line-height:1.25em;margin-bottom:0.6em"
            },
            [
                "div",
                {
                    style: "color:#476582"
                },
                type
            ],
            [
                "div",
                {
                    style: "padding-left:1.25em"
                },
                ...Object.keys(target).map((key)=>{
                    return [
                        "div",
                        {},
                        [
                            "span",
                            keywordStyle,
                            key + ": "
                        ],
                        formatValue(target[key], false)
                    ];
                })
            ]
        ];
    }
    function formatValue(v1, asRaw = true) {
        if (typeof v1 === "number") return [
            "span",
            numberStyle,
            v1
        ];
        else if (typeof v1 === "string") return [
            "span",
            stringStyle,
            JSON.stringify(v1)
        ];
        else if (typeof v1 === "boolean") return [
            "span",
            keywordStyle,
            v1
        ];
        else if ((0, $16Sl1.isObject)(v1)) return [
            "object",
            {
                object: asRaw ? (0, $99kuS.toRaw)(v1) : v1
            }
        ];
        else return [
            "span",
            stringStyle,
            String(v1)
        ];
    }
    function extractKeys(instance, type) {
        const Comp = instance.type;
        if ((0, $16Sl1.isFunction)(Comp)) return;
        const extracted = {};
        for(const key in instance.ctx)if (isKeyOfType(Comp, key, type)) extracted[key] = instance.ctx[key];
        return extracted;
    }
    function isKeyOfType(Comp, key, type) {
        const opts = Comp[type];
        if ((0, $16Sl1.isArray)(opts) && opts.includes(key) || (0, $16Sl1.isObject)(opts) && key in opts) return true;
        if (Comp.extends && isKeyOfType(Comp.extends, key, type)) return true;
        if (Comp.mixins && Comp.mixins.some((m)=>isKeyOfType(m, key, type))) return true;
    }
    function genRefFlag(v1) {
        if ((0, $99kuS.isShallow)(v1)) return `ShallowRef`;
        if (v1.effect) return `ComputedRef`;
        return `Ref`;
    }
}
function $ffe19d932e7e7bce$export$2a6d714a4d738ae(memo, render, cache, index) {
    const cached = cache[index];
    if (cached && $ffe19d932e7e7bce$export$bf525184d622787c(cached, memo)) return cached;
    const ret = render();
    ret.memo = memo.slice();
    return cache[index] = ret;
}
function $ffe19d932e7e7bce$export$bf525184d622787c(cached, memo) {
    const prev = cached.memo;
    if (prev.length != memo.length) return false;
    for(let i = 0; i < prev.length; i++){
        if ((0, $16Sl1.hasChanged)(prev[i], memo[i])) return false;
    }
    if ($ffe19d932e7e7bce$var$isBlockTreeEnabled > 0 && $ffe19d932e7e7bce$var$currentBlock) $ffe19d932e7e7bce$var$currentBlock.push(cached);
    return true;
}
const $ffe19d932e7e7bce$export$83d89fbfd8236492 = "3.4.25";
const $ffe19d932e7e7bce$export$c106dd0671a0fc2d = (0, $16Sl1.NOOP);
const $ffe19d932e7e7bce$export$795e0ad4a0e2ed30 = $ffe19d932e7e7bce$var$ErrorTypeStrings$1;
const $ffe19d932e7e7bce$export$6922d3b3a607469e = $ffe19d932e7e7bce$var$devtools$1;
const $ffe19d932e7e7bce$export$b0c258b32c26c785 = $ffe19d932e7e7bce$var$setDevtoolsHook$1;
const $ffe19d932e7e7bce$var$_ssrUtils = {
    createComponentInstance: $ffe19d932e7e7bce$var$createComponentInstance,
    setupComponent: $ffe19d932e7e7bce$var$setupComponent,
    renderComponentRoot: $ffe19d932e7e7bce$var$renderComponentRoot,
    setCurrentRenderingInstance: $ffe19d932e7e7bce$var$setCurrentRenderingInstance,
    isVNode: $ffe19d932e7e7bce$export$3868d13f8734ae81,
    normalizeVNode: $ffe19d932e7e7bce$var$normalizeVNode
};
const $ffe19d932e7e7bce$export$a9679033567b336d = $ffe19d932e7e7bce$var$_ssrUtils;
const $ffe19d932e7e7bce$export$83cf26e06ea620e1 = null;
const $ffe19d932e7e7bce$export$dc678eddf276286e = null;
const $ffe19d932e7e7bce$export$22072a82865312f6 = null;

});
parcelRegister("99kuS", function(module, exports) {

$parcel$export(module.exports, "EffectScope", function () { return $6a94da97f0c28d33$export$1168ed9dbc71ddbd; });
$parcel$export(module.exports, "getCurrentScope", function () { return $6a94da97f0c28d33$export$c7be4b0125a10cba; });
$parcel$export(module.exports, "ReactiveEffect", function () { return $6a94da97f0c28d33$export$28352bb4dd362521; });
$parcel$export(module.exports, "pauseTracking", function () { return $6a94da97f0c28d33$export$938a971395fef855; });
$parcel$export(module.exports, "resetTracking", function () { return $6a94da97f0c28d33$export$c39176b1babaa8b8; });
$parcel$export(module.exports, "track", function () { return $6a94da97f0c28d33$export$6b2a7d5132615086; });
$parcel$export(module.exports, "trigger", function () { return $6a94da97f0c28d33$export$e614dc9140f7ae71; });
$parcel$export(module.exports, "toRaw", function () { return $6a94da97f0c28d33$export$ab18938b9fc5f28e; });
$parcel$export(module.exports, "isRef", function () { return $6a94da97f0c28d33$export$4f9f5282de18fc69; });
$parcel$export(module.exports, "reactive", function () { return $6a94da97f0c28d33$export$90a44edba14e47be; });
$parcel$export(module.exports, "isShallow", function () { return $6a94da97f0c28d33$export$7f3fe6025abfa26e; });
$parcel$export(module.exports, "shallowReactive", function () { return $6a94da97f0c28d33$export$8d81cefd22d22260; });
$parcel$export(module.exports, "isReactive", function () { return $6a94da97f0c28d33$export$352205f445242f02; });
$parcel$export(module.exports, "isProxy", function () { return $6a94da97f0c28d33$export$5f3ca29d057519b3; });
$parcel$export(module.exports, "markRaw", function () { return $6a94da97f0c28d33$export$995ab8b13ad7a9d0; });
$parcel$export(module.exports, "computed", function () { return $6a94da97f0c28d33$export$2983e091f1a1e8e2; });
$parcel$export(module.exports, "ref", function () { return $6a94da97f0c28d33$export$eff4d24c3ff7876e; });
$parcel$export(module.exports, "proxyRefs", function () { return $6a94da97f0c28d33$export$f353fd1b97db3fa0; });
$parcel$export(module.exports, "customRef", function () { return $6a94da97f0c28d33$export$a20c2dd6199824cb; });
/**
* @vue/reactivity v3.4.25
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $16Sl1 = parcelRequire("16Sl1");
function $6a94da97f0c28d33$var$warn(msg, ...args) {
    console.warn(`[Vue warn] ${msg}`, ...args);
}
let $6a94da97f0c28d33$var$activeEffectScope;
class $6a94da97f0c28d33$export$1168ed9dbc71ddbd {
    constructor(detached = false){
        this.detached = detached;
        /**
     * @internal
     */ this._active = true;
        /**
     * @internal
     */ this.effects = [];
        /**
     * @internal
     */ this.cleanups = [];
        this.parent = $6a94da97f0c28d33$var$activeEffectScope;
        if (!detached && $6a94da97f0c28d33$var$activeEffectScope) this.index = ($6a94da97f0c28d33$var$activeEffectScope.scopes || ($6a94da97f0c28d33$var$activeEffectScope.scopes = [])).push(this) - 1;
    }
    get active() {
        return this._active;
    }
    run(fn) {
        if (this._active) {
            const currentEffectScope = $6a94da97f0c28d33$var$activeEffectScope;
            try {
                $6a94da97f0c28d33$var$activeEffectScope = this;
                return fn();
            } finally{
                $6a94da97f0c28d33$var$activeEffectScope = currentEffectScope;
            }
        }
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ on() {
        $6a94da97f0c28d33$var$activeEffectScope = this;
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ off() {
        $6a94da97f0c28d33$var$activeEffectScope = this.parent;
    }
    stop(fromParent) {
        if (this._active) {
            let i, l;
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].stop();
            for(i = 0, l = this.cleanups.length; i < l; i++)this.cleanups[i]();
            if (this.scopes) for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].stop(true);
            if (!this.detached && this.parent && !fromParent) {
                const last = this.parent.scopes.pop();
                if (last && last !== this) {
                    this.parent.scopes[this.index] = last;
                    last.index = this.index;
                }
            }
            this.parent = void 0;
            this._active = false;
        }
    }
}
function $6a94da97f0c28d33$export$7056603ea81600be(detached) {
    return new $6a94da97f0c28d33$export$1168ed9dbc71ddbd(detached);
}
function $6a94da97f0c28d33$var$recordEffectScope(effect, scope = $6a94da97f0c28d33$var$activeEffectScope) {
    if (scope && scope.active) scope.effects.push(effect);
}
function $6a94da97f0c28d33$export$c7be4b0125a10cba() {
    return $6a94da97f0c28d33$var$activeEffectScope;
}
function $6a94da97f0c28d33$export$a780418acd4762da(fn) {
    if ($6a94da97f0c28d33$var$activeEffectScope) $6a94da97f0c28d33$var$activeEffectScope.cleanups.push(fn);
}
let $6a94da97f0c28d33$var$activeEffect;
class $6a94da97f0c28d33$export$28352bb4dd362521 {
    constructor(fn, trigger, scheduler, scope){
        this.fn = fn;
        this.trigger = trigger;
        this.scheduler = scheduler;
        this.active = true;
        this.deps = [];
        /**
     * @internal
     */ this._dirtyLevel = 4;
        /**
     * @internal
     */ this._trackId = 0;
        /**
     * @internal
     */ this._runnings = 0;
        /**
     * @internal
     */ this._shouldSchedule = false;
        /**
     * @internal
     */ this._depsLength = 0;
        $6a94da97f0c28d33$var$recordEffectScope(this, scope);
    }
    get dirty() {
        if (this._dirtyLevel === 2 || this._dirtyLevel === 3) {
            this._dirtyLevel = 1;
            $6a94da97f0c28d33$export$938a971395fef855();
            for(let i = 0; i < this._depsLength; i++){
                const dep = this.deps[i];
                if (dep.computed) {
                    $6a94da97f0c28d33$var$triggerComputed(dep.computed);
                    if (this._dirtyLevel >= 4) break;
                }
            }
            if (this._dirtyLevel === 1) this._dirtyLevel = 0;
            $6a94da97f0c28d33$export$c39176b1babaa8b8();
        }
        return this._dirtyLevel >= 4;
    }
    set dirty(v) {
        this._dirtyLevel = v ? 4 : 0;
    }
    run() {
        this._dirtyLevel = 0;
        if (!this.active) return this.fn();
        let lastShouldTrack = $6a94da97f0c28d33$var$shouldTrack;
        let lastEffect = $6a94da97f0c28d33$var$activeEffect;
        try {
            $6a94da97f0c28d33$var$shouldTrack = true;
            $6a94da97f0c28d33$var$activeEffect = this;
            this._runnings++;
            $6a94da97f0c28d33$var$preCleanupEffect(this);
            return this.fn();
        } finally{
            $6a94da97f0c28d33$var$postCleanupEffect(this);
            this._runnings--;
            $6a94da97f0c28d33$var$activeEffect = lastEffect;
            $6a94da97f0c28d33$var$shouldTrack = lastShouldTrack;
        }
    }
    stop() {
        var _a;
        if (this.active) {
            $6a94da97f0c28d33$var$preCleanupEffect(this);
            $6a94da97f0c28d33$var$postCleanupEffect(this);
            (_a = this.onStop) == null || _a.call(this);
            this.active = false;
        }
    }
}
function $6a94da97f0c28d33$var$triggerComputed(computed) {
    return computed.value;
}
function $6a94da97f0c28d33$var$preCleanupEffect(effect2) {
    effect2._trackId++;
    effect2._depsLength = 0;
}
function $6a94da97f0c28d33$var$postCleanupEffect(effect2) {
    if (effect2.deps.length > effect2._depsLength) {
        for(let i = effect2._depsLength; i < effect2.deps.length; i++)$6a94da97f0c28d33$var$cleanupDepEffect(effect2.deps[i], effect2);
        effect2.deps.length = effect2._depsLength;
    }
}
function $6a94da97f0c28d33$var$cleanupDepEffect(dep, effect2) {
    const trackId = dep.get(effect2);
    if (trackId !== void 0 && effect2._trackId !== trackId) {
        dep.delete(effect2);
        if (dep.size === 0) dep.cleanup();
    }
}
function $6a94da97f0c28d33$export$dc573d8a6576cdb3(fn, options) {
    if (fn.effect instanceof $6a94da97f0c28d33$export$28352bb4dd362521) fn = fn.effect.fn;
    const _effect = new $6a94da97f0c28d33$export$28352bb4dd362521(fn, (0, $16Sl1.NOOP), ()=>{
        if (_effect.dirty) _effect.run();
    });
    if (options) {
        (0, $16Sl1.extend)(_effect, options);
        if (options.scope) $6a94da97f0c28d33$var$recordEffectScope(_effect, options.scope);
    }
    if (!options || !options.lazy) _effect.run();
    const runner = _effect.run.bind(_effect);
    runner.effect = _effect;
    return runner;
}
function $6a94da97f0c28d33$export$fa6813432f753b0d(runner) {
    runner.effect.stop();
}
let $6a94da97f0c28d33$var$shouldTrack = true;
let $6a94da97f0c28d33$var$pauseScheduleStack = 0;
const $6a94da97f0c28d33$var$trackStack = [];
function $6a94da97f0c28d33$export$938a971395fef855() {
    $6a94da97f0c28d33$var$trackStack.push($6a94da97f0c28d33$var$shouldTrack);
    $6a94da97f0c28d33$var$shouldTrack = false;
}
function $6a94da97f0c28d33$export$1f8ffc6fd33b1d16() {
    $6a94da97f0c28d33$var$trackStack.push($6a94da97f0c28d33$var$shouldTrack);
    $6a94da97f0c28d33$var$shouldTrack = true;
}
function $6a94da97f0c28d33$export$c39176b1babaa8b8() {
    const last = $6a94da97f0c28d33$var$trackStack.pop();
    $6a94da97f0c28d33$var$shouldTrack = last === void 0 ? true : last;
}
function $6a94da97f0c28d33$export$262a949f95482a17() {
    $6a94da97f0c28d33$var$pauseScheduleStack++;
}
function $6a94da97f0c28d33$export$3539fa10306ef581() {
    $6a94da97f0c28d33$var$pauseScheduleStack--;
    while(!$6a94da97f0c28d33$var$pauseScheduleStack && $6a94da97f0c28d33$var$queueEffectSchedulers.length)$6a94da97f0c28d33$var$queueEffectSchedulers.shift()();
}
function $6a94da97f0c28d33$var$trackEffect(effect2, dep, debuggerEventExtraInfo) {
    var _a;
    if (dep.get(effect2) !== effect2._trackId) {
        dep.set(effect2, effect2._trackId);
        const oldDep = effect2.deps[effect2._depsLength];
        if (oldDep !== dep) {
            if (oldDep) $6a94da97f0c28d33$var$cleanupDepEffect(oldDep, effect2);
            effect2.deps[effect2._depsLength++] = dep;
        } else effect2._depsLength++;
    }
}
const $6a94da97f0c28d33$var$queueEffectSchedulers = [];
function $6a94da97f0c28d33$var$triggerEffects(dep, dirtyLevel, debuggerEventExtraInfo) {
    var _a;
    $6a94da97f0c28d33$export$262a949f95482a17();
    for (const effect2 of dep.keys()){
        let tracking;
        if (effect2._dirtyLevel < dirtyLevel && (tracking != null ? tracking : tracking = dep.get(effect2) === effect2._trackId)) {
            effect2._shouldSchedule || (effect2._shouldSchedule = effect2._dirtyLevel === 0);
            effect2._dirtyLevel = dirtyLevel;
        }
        if (effect2._shouldSchedule && (tracking != null ? tracking : tracking = dep.get(effect2) === effect2._trackId)) {
            effect2.trigger();
            if ((!effect2._runnings || effect2.allowRecurse) && effect2._dirtyLevel !== 2) {
                effect2._shouldSchedule = false;
                if (effect2.scheduler) $6a94da97f0c28d33$var$queueEffectSchedulers.push(effect2.scheduler);
            }
        }
    }
    $6a94da97f0c28d33$export$3539fa10306ef581();
}
const $6a94da97f0c28d33$var$createDep = (cleanup, computed)=>{
    const dep = /* @__PURE__ */ new Map();
    dep.cleanup = cleanup;
    dep.computed = computed;
    return dep;
};
const $6a94da97f0c28d33$var$targetMap = /* @__PURE__ */ new WeakMap();
const $6a94da97f0c28d33$export$3c41b1a4e06acc14 = Symbol("");
const $6a94da97f0c28d33$var$MAP_KEY_ITERATE_KEY = Symbol("");
function $6a94da97f0c28d33$export$6b2a7d5132615086(target, type, key) {
    if ($6a94da97f0c28d33$var$shouldTrack && $6a94da97f0c28d33$var$activeEffect) {
        let depsMap = $6a94da97f0c28d33$var$targetMap.get(target);
        if (!depsMap) $6a94da97f0c28d33$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
        let dep = depsMap.get(key);
        if (!dep) depsMap.set(key, dep = $6a94da97f0c28d33$var$createDep(()=>depsMap.delete(key)));
        $6a94da97f0c28d33$var$trackEffect($6a94da97f0c28d33$var$activeEffect, dep, void 0);
    }
}
function $6a94da97f0c28d33$export$e614dc9140f7ae71(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $6a94da97f0c28d33$var$targetMap.get(target);
    if (!depsMap) return;
    let deps = [];
    if (type === "clear") deps = [
        ...depsMap.values()
    ];
    else if (key === "length" && (0, $16Sl1.isArray)(target)) {
        const newLength = Number(newValue);
        depsMap.forEach((dep, key2)=>{
            if (key2 === "length" || !(0, $16Sl1.isSymbol)(key2) && key2 >= newLength) deps.push(dep);
        });
    } else {
        if (key !== void 0) deps.push(depsMap.get(key));
        switch(type){
            case "add":
                if (!(0, $16Sl1.isArray)(target)) {
                    deps.push(depsMap.get($6a94da97f0c28d33$export$3c41b1a4e06acc14));
                    if ((0, $16Sl1.isMap)(target)) deps.push(depsMap.get($6a94da97f0c28d33$var$MAP_KEY_ITERATE_KEY));
                } else if ((0, $16Sl1.isIntegerKey)(key)) deps.push(depsMap.get("length"));
                break;
            case "delete":
                if (!(0, $16Sl1.isArray)(target)) {
                    deps.push(depsMap.get($6a94da97f0c28d33$export$3c41b1a4e06acc14));
                    if ((0, $16Sl1.isMap)(target)) deps.push(depsMap.get($6a94da97f0c28d33$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set":
                if ((0, $16Sl1.isMap)(target)) deps.push(depsMap.get($6a94da97f0c28d33$export$3c41b1a4e06acc14));
                break;
        }
    }
    $6a94da97f0c28d33$export$262a949f95482a17();
    for (const dep of deps)if (dep) $6a94da97f0c28d33$var$triggerEffects(dep, 4, void 0);
    $6a94da97f0c28d33$export$3539fa10306ef581();
}
function $6a94da97f0c28d33$var$getDepFromReactive(object, key) {
    var _a;
    return (_a = $6a94da97f0c28d33$var$targetMap.get(object)) == null ? void 0 : _a.get(key);
}
const $6a94da97f0c28d33$var$isNonTrackableKeys = /* @__PURE__ */ (0, $16Sl1.makeMap)(`__proto__,__v_isRef,__isVue`);
const $6a94da97f0c28d33$var$builtInSymbols = new Set(/* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((key)=>key !== "arguments" && key !== "caller").map((key)=>Symbol[key]).filter((0, $16Sl1.isSymbol)));
const $6a94da97f0c28d33$var$arrayInstrumentations = /* @__PURE__ */ $6a94da97f0c28d33$var$createArrayInstrumentations();
function $6a94da97f0c28d33$var$createArrayInstrumentations() {
    const instrumentations = {};
    [
        "includes",
        "indexOf",
        "lastIndexOf"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            const arr = $6a94da97f0c28d33$export$ab18938b9fc5f28e(this);
            for(let i = 0, l = this.length; i < l; i++)$6a94da97f0c28d33$export$6b2a7d5132615086(arr, "get", i + "");
            const res = arr[key](...args);
            if (res === -1 || res === false) return arr[key](...args.map($6a94da97f0c28d33$export$ab18938b9fc5f28e));
            else return res;
        };
    });
    [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            $6a94da97f0c28d33$export$938a971395fef855();
            $6a94da97f0c28d33$export$262a949f95482a17();
            const res = $6a94da97f0c28d33$export$ab18938b9fc5f28e(this)[key].apply(this, args);
            $6a94da97f0c28d33$export$3539fa10306ef581();
            $6a94da97f0c28d33$export$c39176b1babaa8b8();
            return res;
        };
    });
    return instrumentations;
}
function $6a94da97f0c28d33$var$hasOwnProperty(key) {
    if (!(0, $16Sl1.isSymbol)(key)) key = String(key);
    const obj = $6a94da97f0c28d33$export$ab18938b9fc5f28e(this);
    $6a94da97f0c28d33$export$6b2a7d5132615086(obj, "has", key);
    return obj.hasOwnProperty(key);
}
class $6a94da97f0c28d33$var$BaseReactiveHandler {
    constructor(_isReadonly = false, _isShallow = false){
        this._isReadonly = _isReadonly;
        this._isShallow = _isShallow;
    }
    get(target, key, receiver) {
        const isReadonly2 = this._isReadonly, isShallow2 = this._isShallow;
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_isShallow") return isShallow2;
        else if (key === "__v_raw") {
            if (receiver === (isReadonly2 ? isShallow2 ? $6a94da97f0c28d33$var$shallowReadonlyMap : $6a94da97f0c28d33$var$readonlyMap : isShallow2 ? $6a94da97f0c28d33$var$shallowReactiveMap : $6a94da97f0c28d33$var$reactiveMap).get(target) || // receiver is not the reactive proxy, but has the same prototype
            // this means the reciever is a user proxy of the reactive proxy
            Object.getPrototypeOf(target) === Object.getPrototypeOf(receiver)) return target;
            return;
        }
        const targetIsArray = (0, $16Sl1.isArray)(target);
        if (!isReadonly2) {
            if (targetIsArray && (0, $16Sl1.hasOwn)($6a94da97f0c28d33$var$arrayInstrumentations, key)) return Reflect.get($6a94da97f0c28d33$var$arrayInstrumentations, key, receiver);
            if (key === "hasOwnProperty") return $6a94da97f0c28d33$var$hasOwnProperty;
        }
        const res = Reflect.get(target, key, receiver);
        if ((0, $16Sl1.isSymbol)(key) ? $6a94da97f0c28d33$var$builtInSymbols.has(key) : $6a94da97f0c28d33$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly2) $6a94da97f0c28d33$export$6b2a7d5132615086(target, "get", key);
        if (isShallow2) return res;
        if ($6a94da97f0c28d33$export$4f9f5282de18fc69(res)) return targetIsArray && (0, $16Sl1.isIntegerKey)(key) ? res : res.value;
        if ((0, $16Sl1.isObject)(res)) return isReadonly2 ? $6a94da97f0c28d33$export$6ec456bd5b7b3c51(res) : $6a94da97f0c28d33$export$90a44edba14e47be(res);
        return res;
    }
}
class $6a94da97f0c28d33$var$MutableReactiveHandler extends $6a94da97f0c28d33$var$BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(false, isShallow2);
    }
    set(target, key, value, receiver) {
        let oldValue = target[key];
        if (!this._isShallow) {
            const isOldValueReadonly = $6a94da97f0c28d33$export$92d09b48637741e7(oldValue);
            if (!$6a94da97f0c28d33$export$7f3fe6025abfa26e(value) && !$6a94da97f0c28d33$export$92d09b48637741e7(value)) {
                oldValue = $6a94da97f0c28d33$export$ab18938b9fc5f28e(oldValue);
                value = $6a94da97f0c28d33$export$ab18938b9fc5f28e(value);
            }
            if (!(0, $16Sl1.isArray)(target) && $6a94da97f0c28d33$export$4f9f5282de18fc69(oldValue) && !$6a94da97f0c28d33$export$4f9f5282de18fc69(value)) {
                if (isOldValueReadonly) return false;
                else {
                    oldValue.value = value;
                    return true;
                }
            }
        }
        const hadKey = (0, $16Sl1.isArray)(target) && (0, $16Sl1.isIntegerKey)(key) ? Number(key) < target.length : (0, $16Sl1.hasOwn)(target, key);
        const result = Reflect.set(target, key, value, receiver);
        if (target === $6a94da97f0c28d33$export$ab18938b9fc5f28e(receiver)) {
            if (!hadKey) $6a94da97f0c28d33$export$e614dc9140f7ae71(target, "add", key, value);
            else if ((0, $16Sl1.hasChanged)(value, oldValue)) $6a94da97f0c28d33$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
        }
        return result;
    }
    deleteProperty(target, key) {
        const hadKey = (0, $16Sl1.hasOwn)(target, key);
        const oldValue = target[key];
        const result = Reflect.deleteProperty(target, key);
        if (result && hadKey) $6a94da97f0c28d33$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
        return result;
    }
    has(target, key) {
        const result = Reflect.has(target, key);
        if (!(0, $16Sl1.isSymbol)(key) || !$6a94da97f0c28d33$var$builtInSymbols.has(key)) $6a94da97f0c28d33$export$6b2a7d5132615086(target, "has", key);
        return result;
    }
    ownKeys(target) {
        $6a94da97f0c28d33$export$6b2a7d5132615086(target, "iterate", (0, $16Sl1.isArray)(target) ? "length" : $6a94da97f0c28d33$export$3c41b1a4e06acc14);
        return Reflect.ownKeys(target);
    }
}
class $6a94da97f0c28d33$var$ReadonlyReactiveHandler extends $6a94da97f0c28d33$var$BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(true, isShallow2);
    }
    set(target, key) {
        return true;
    }
    deleteProperty(target, key) {
        return true;
    }
}
const $6a94da97f0c28d33$var$mutableHandlers = /* @__PURE__ */ new $6a94da97f0c28d33$var$MutableReactiveHandler();
const $6a94da97f0c28d33$var$readonlyHandlers = /* @__PURE__ */ new $6a94da97f0c28d33$var$ReadonlyReactiveHandler();
const $6a94da97f0c28d33$var$shallowReactiveHandlers = /* @__PURE__ */ new $6a94da97f0c28d33$var$MutableReactiveHandler(true);
const $6a94da97f0c28d33$var$shallowReadonlyHandlers = /* @__PURE__ */ new $6a94da97f0c28d33$var$ReadonlyReactiveHandler(true);
const $6a94da97f0c28d33$var$toShallow = (value)=>value;
const $6a94da97f0c28d33$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $6a94da97f0c28d33$var$get(target, key, isReadonly = false, isShallow = false) {
    target = target["__v_raw"];
    const rawTarget = $6a94da97f0c28d33$export$ab18938b9fc5f28e(target);
    const rawKey = $6a94da97f0c28d33$export$ab18938b9fc5f28e(key);
    if (!isReadonly) {
        if ((0, $16Sl1.hasChanged)(key, rawKey)) $6a94da97f0c28d33$export$6b2a7d5132615086(rawTarget, "get", key);
        $6a94da97f0c28d33$export$6b2a7d5132615086(rawTarget, "get", rawKey);
    }
    const { has: has2 } = $6a94da97f0c28d33$var$getProto(rawTarget);
    const wrap = isShallow ? $6a94da97f0c28d33$var$toShallow : isReadonly ? $6a94da97f0c28d33$var$toReadonly : $6a94da97f0c28d33$var$toReactive;
    if (has2.call(rawTarget, key)) return wrap(target.get(key));
    else if (has2.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) target.get(key);
}
function $6a94da97f0c28d33$var$has(key, isReadonly = false) {
    const target = this["__v_raw"];
    const rawTarget = $6a94da97f0c28d33$export$ab18938b9fc5f28e(target);
    const rawKey = $6a94da97f0c28d33$export$ab18938b9fc5f28e(key);
    if (!isReadonly) {
        if ((0, $16Sl1.hasChanged)(key, rawKey)) $6a94da97f0c28d33$export$6b2a7d5132615086(rawTarget, "has", key);
        $6a94da97f0c28d33$export$6b2a7d5132615086(rawTarget, "has", rawKey);
    }
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $6a94da97f0c28d33$var$size(target, isReadonly = false) {
    target = target["__v_raw"];
    !isReadonly && $6a94da97f0c28d33$export$6b2a7d5132615086($6a94da97f0c28d33$export$ab18938b9fc5f28e(target), "iterate", $6a94da97f0c28d33$export$3c41b1a4e06acc14);
    return Reflect.get(target, "size", target);
}
function $6a94da97f0c28d33$var$add(value) {
    value = $6a94da97f0c28d33$export$ab18938b9fc5f28e(value);
    const target = $6a94da97f0c28d33$export$ab18938b9fc5f28e(this);
    const proto = $6a94da97f0c28d33$var$getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $6a94da97f0c28d33$export$e614dc9140f7ae71(target, "add", value, value);
    }
    return this;
}
function $6a94da97f0c28d33$var$set(key, value) {
    value = $6a94da97f0c28d33$export$ab18938b9fc5f28e(value);
    const target = $6a94da97f0c28d33$export$ab18938b9fc5f28e(this);
    const { has: has2, get: get2 } = $6a94da97f0c28d33$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $6a94da97f0c28d33$export$ab18938b9fc5f28e(key);
        hadKey = has2.call(target, key);
    }
    const oldValue = get2.call(target, key);
    target.set(key, value);
    if (!hadKey) $6a94da97f0c28d33$export$e614dc9140f7ae71(target, "add", key, value);
    else if ((0, $16Sl1.hasChanged)(value, oldValue)) $6a94da97f0c28d33$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
    return this;
}
function $6a94da97f0c28d33$var$deleteEntry(key) {
    const target = $6a94da97f0c28d33$export$ab18938b9fc5f28e(this);
    const { has: has2, get: get2 } = $6a94da97f0c28d33$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $6a94da97f0c28d33$export$ab18938b9fc5f28e(key);
        hadKey = has2.call(target, key);
    }
    const oldValue = get2 ? get2.call(target, key) : void 0;
    const result = target.delete(key);
    if (hadKey) $6a94da97f0c28d33$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
    return result;
}
function $6a94da97f0c28d33$var$clear() {
    const target = $6a94da97f0c28d33$export$ab18938b9fc5f28e(this);
    const hadItems = target.size !== 0;
    const oldTarget = void 0;
    const result = target.clear();
    if (hadItems) $6a94da97f0c28d33$export$e614dc9140f7ae71(target, "clear", void 0, void 0, oldTarget);
    return result;
}
function $6a94da97f0c28d33$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw"];
        const rawTarget = $6a94da97f0c28d33$export$ab18938b9fc5f28e(target);
        const wrap = isShallow ? $6a94da97f0c28d33$var$toShallow : isReadonly ? $6a94da97f0c28d33$var$toReadonly : $6a94da97f0c28d33$var$toReactive;
        !isReadonly && $6a94da97f0c28d33$export$6b2a7d5132615086(rawTarget, "iterate", $6a94da97f0c28d33$export$3c41b1a4e06acc14);
        return target.forEach((value, key)=>{
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $6a94da97f0c28d33$var$createIterableMethod(method, isReadonly, isShallow) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $6a94da97f0c28d33$export$ab18938b9fc5f28e(target);
        const targetIsMap = (0, $16Sl1.isMap)(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow ? $6a94da97f0c28d33$var$toShallow : isReadonly ? $6a94da97f0c28d33$var$toReadonly : $6a94da97f0c28d33$var$toReactive;
        !isReadonly && $6a94da97f0c28d33$export$6b2a7d5132615086(rawTarget, "iterate", isKeyOnly ? $6a94da97f0c28d33$var$MAP_KEY_ITERATE_KEY : $6a94da97f0c28d33$export$3c41b1a4e06acc14);
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $6a94da97f0c28d33$var$createReadonlyMethod(type) {
    return function(...args) {
        return type === "delete" ? false : type === "clear" ? void 0 : this;
    };
}
function $6a94da97f0c28d33$var$createInstrumentations() {
    const mutableInstrumentations2 = {
        get (key) {
            return $6a94da97f0c28d33$var$get(this, key);
        },
        get size () {
            return $6a94da97f0c28d33$var$size(this);
        },
        has: $6a94da97f0c28d33$var$has,
        add: $6a94da97f0c28d33$var$add,
        set: $6a94da97f0c28d33$var$set,
        delete: $6a94da97f0c28d33$var$deleteEntry,
        clear: $6a94da97f0c28d33$var$clear,
        forEach: $6a94da97f0c28d33$var$createForEach(false, false)
    };
    const shallowInstrumentations2 = {
        get (key) {
            return $6a94da97f0c28d33$var$get(this, key, false, true);
        },
        get size () {
            return $6a94da97f0c28d33$var$size(this);
        },
        has: $6a94da97f0c28d33$var$has,
        add: $6a94da97f0c28d33$var$add,
        set: $6a94da97f0c28d33$var$set,
        delete: $6a94da97f0c28d33$var$deleteEntry,
        clear: $6a94da97f0c28d33$var$clear,
        forEach: $6a94da97f0c28d33$var$createForEach(false, true)
    };
    const readonlyInstrumentations2 = {
        get (key) {
            return $6a94da97f0c28d33$var$get(this, key, true);
        },
        get size () {
            return $6a94da97f0c28d33$var$size(this, true);
        },
        has (key) {
            return $6a94da97f0c28d33$var$has.call(this, key, true);
        },
        add: $6a94da97f0c28d33$var$createReadonlyMethod("add"),
        set: $6a94da97f0c28d33$var$createReadonlyMethod("set"),
        delete: $6a94da97f0c28d33$var$createReadonlyMethod("delete"),
        clear: $6a94da97f0c28d33$var$createReadonlyMethod("clear"),
        forEach: $6a94da97f0c28d33$var$createForEach(true, false)
    };
    const shallowReadonlyInstrumentations2 = {
        get (key) {
            return $6a94da97f0c28d33$var$get(this, key, true, true);
        },
        get size () {
            return $6a94da97f0c28d33$var$size(this, true);
        },
        has (key) {
            return $6a94da97f0c28d33$var$has.call(this, key, true);
        },
        add: $6a94da97f0c28d33$var$createReadonlyMethod("add"),
        set: $6a94da97f0c28d33$var$createReadonlyMethod("set"),
        delete: $6a94da97f0c28d33$var$createReadonlyMethod("delete"),
        clear: $6a94da97f0c28d33$var$createReadonlyMethod("clear"),
        forEach: $6a94da97f0c28d33$var$createForEach(true, true)
    };
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        mutableInstrumentations2[method] = $6a94da97f0c28d33$var$createIterableMethod(method, false, false);
        readonlyInstrumentations2[method] = $6a94da97f0c28d33$var$createIterableMethod(method, true, false);
        shallowInstrumentations2[method] = $6a94da97f0c28d33$var$createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations2[method] = $6a94da97f0c28d33$var$createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations2,
        readonlyInstrumentations2,
        shallowInstrumentations2,
        shallowReadonlyInstrumentations2
    ];
}
const [$6a94da97f0c28d33$var$mutableInstrumentations, $6a94da97f0c28d33$var$readonlyInstrumentations, $6a94da97f0c28d33$var$shallowInstrumentations, $6a94da97f0c28d33$var$shallowReadonlyInstrumentations] = /* @__PURE__ */ $6a94da97f0c28d33$var$createInstrumentations();
function $6a94da97f0c28d33$var$createInstrumentationGetter(isReadonly, shallow) {
    const instrumentations = shallow ? isReadonly ? $6a94da97f0c28d33$var$shallowReadonlyInstrumentations : $6a94da97f0c28d33$var$shallowInstrumentations : isReadonly ? $6a94da97f0c28d33$var$readonlyInstrumentations : $6a94da97f0c28d33$var$mutableInstrumentations;
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw") return target;
        return Reflect.get((0, $16Sl1.hasOwn)(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
const $6a94da97f0c28d33$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $6a94da97f0c28d33$var$createInstrumentationGetter(false, false)
};
const $6a94da97f0c28d33$var$shallowCollectionHandlers = {
    get: /* @__PURE__ */ $6a94da97f0c28d33$var$createInstrumentationGetter(false, true)
};
const $6a94da97f0c28d33$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $6a94da97f0c28d33$var$createInstrumentationGetter(true, false)
};
const $6a94da97f0c28d33$var$shallowReadonlyCollectionHandlers = {
    get: /* @__PURE__ */ $6a94da97f0c28d33$var$createInstrumentationGetter(true, true)
};
function $6a94da97f0c28d33$var$checkIdentityKeys(target, has2, key) {
    const rawKey = $6a94da97f0c28d33$export$ab18938b9fc5f28e(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
        const type = (0, $16Sl1.toRawType)(target);
        $6a94da97f0c28d33$var$warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
const $6a94da97f0c28d33$var$reactiveMap = /* @__PURE__ */ new WeakMap();
const $6a94da97f0c28d33$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
const $6a94da97f0c28d33$var$readonlyMap = /* @__PURE__ */ new WeakMap();
const $6a94da97f0c28d33$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $6a94da97f0c28d33$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1 /* COMMON */ ;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2 /* COLLECTION */ ;
        default:
            return 0 /* INVALID */ ;
    }
}
function $6a94da97f0c28d33$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 /* INVALID */  : $6a94da97f0c28d33$var$targetTypeMap((0, $16Sl1.toRawType)(value));
}
function $6a94da97f0c28d33$export$90a44edba14e47be(target) {
    if ($6a94da97f0c28d33$export$92d09b48637741e7(target)) return target;
    return $6a94da97f0c28d33$var$createReactiveObject(target, false, $6a94da97f0c28d33$var$mutableHandlers, $6a94da97f0c28d33$var$mutableCollectionHandlers, $6a94da97f0c28d33$var$reactiveMap);
}
function $6a94da97f0c28d33$export$8d81cefd22d22260(target) {
    return $6a94da97f0c28d33$var$createReactiveObject(target, false, $6a94da97f0c28d33$var$shallowReactiveHandlers, $6a94da97f0c28d33$var$shallowCollectionHandlers, $6a94da97f0c28d33$var$shallowReactiveMap);
}
function $6a94da97f0c28d33$export$6ec456bd5b7b3c51(target) {
    return $6a94da97f0c28d33$var$createReactiveObject(target, true, $6a94da97f0c28d33$var$readonlyHandlers, $6a94da97f0c28d33$var$readonlyCollectionHandlers, $6a94da97f0c28d33$var$readonlyMap);
}
function $6a94da97f0c28d33$export$7c4b5f2b50f09f6b(target) {
    return $6a94da97f0c28d33$var$createReactiveObject(target, true, $6a94da97f0c28d33$var$shallowReadonlyHandlers, $6a94da97f0c28d33$var$shallowReadonlyCollectionHandlers, $6a94da97f0c28d33$var$shallowReadonlyMap);
}
function $6a94da97f0c28d33$var$createReactiveObject(target, isReadonly2, baseHandlers, collectionHandlers, proxyMap) {
    if (!(0, $16Sl1.isObject)(target)) return target;
    if (target["__v_raw"] && !(isReadonly2 && target["__v_isReactive"])) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $6a94da97f0c28d33$var$getTargetType(target);
    if (targetType === 0 /* INVALID */ ) return target;
    const proxy = new Proxy(target, targetType === 2 /* COLLECTION */  ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $6a94da97f0c28d33$export$352205f445242f02(value) {
    if ($6a94da97f0c28d33$export$92d09b48637741e7(value)) return $6a94da97f0c28d33$export$352205f445242f02(value["__v_raw"]);
    return !!(value && value["__v_isReactive"]);
}
function $6a94da97f0c28d33$export$92d09b48637741e7(value) {
    return !!(value && value["__v_isReadonly"]);
}
function $6a94da97f0c28d33$export$7f3fe6025abfa26e(value) {
    return !!(value && value["__v_isShallow"]);
}
function $6a94da97f0c28d33$export$5f3ca29d057519b3(value) {
    return value ? !!value["__v_raw"] : false;
}
function $6a94da97f0c28d33$export$ab18938b9fc5f28e(observed) {
    const raw = observed && observed["__v_raw"];
    return raw ? $6a94da97f0c28d33$export$ab18938b9fc5f28e(raw) : observed;
}
function $6a94da97f0c28d33$export$995ab8b13ad7a9d0(value) {
    if (Object.isExtensible(value)) (0, $16Sl1.def)(value, "__v_skip", true);
    return value;
}
const $6a94da97f0c28d33$var$toReactive = (value)=>(0, $16Sl1.isObject)(value) ? $6a94da97f0c28d33$export$90a44edba14e47be(value) : value;
const $6a94da97f0c28d33$var$toReadonly = (value)=>(0, $16Sl1.isObject)(value) ? $6a94da97f0c28d33$export$6ec456bd5b7b3c51(value) : value;
const $6a94da97f0c28d33$var$COMPUTED_SIDE_EFFECT_WARN = `Computed is still dirty after getter evaluation, likely because a computed is mutating its own dependency in its getter. State mutations in computed getters should be avoided.  Check the docs for more details: https://vuejs.org/guide/essentials/computed.html#getters-should-be-side-effect-free`;
class $6a94da97f0c28d33$var$ComputedRefImpl {
    constructor(getter, _setter, isReadonly, isSSR){
        this.getter = getter;
        this._setter = _setter;
        this.dep = void 0;
        this.__v_isRef = true;
        this["__v_isReadonly"] = false;
        this.effect = new $6a94da97f0c28d33$export$28352bb4dd362521(()=>getter(this._value), ()=>$6a94da97f0c28d33$var$triggerRefValue(this, this.effect._dirtyLevel === 2 ? 2 : 3));
        this.effect.computed = this;
        this.effect.active = this._cacheable = !isSSR;
        this["__v_isReadonly"] = isReadonly;
    }
    get value() {
        const self = $6a94da97f0c28d33$export$ab18938b9fc5f28e(this);
        if ((!self._cacheable || self.effect.dirty) && (0, $16Sl1.hasChanged)(self._value, self._value = self.effect.run())) $6a94da97f0c28d33$var$triggerRefValue(self, 4);
        $6a94da97f0c28d33$var$trackRefValue(self);
        if (self.effect._dirtyLevel >= 2) $6a94da97f0c28d33$var$triggerRefValue(self, 2);
        return self._value;
    }
    set value(newValue) {
        this._setter(newValue);
    }
    // #region polyfill _dirty for backward compatibility third party code for Vue <= 3.3.x
    get _dirty() {
        return this.effect.dirty;
    }
    set _dirty(v) {
        this.effect.dirty = v;
    }
}
function $6a94da97f0c28d33$export$2983e091f1a1e8e2(getterOrOptions, debugOptions, isSSR = false) {
    let getter;
    let setter;
    const onlyGetter = (0, $16Sl1.isFunction)(getterOrOptions);
    if (onlyGetter) {
        getter = getterOrOptions;
        setter = (0, $16Sl1.NOOP);
    } else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    const cRef = new $6a94da97f0c28d33$var$ComputedRefImpl(getter, setter, onlyGetter || !setter, isSSR);
    return cRef;
}
function $6a94da97f0c28d33$var$trackRefValue(ref2) {
    var _a;
    if ($6a94da97f0c28d33$var$shouldTrack && $6a94da97f0c28d33$var$activeEffect) {
        ref2 = $6a94da97f0c28d33$export$ab18938b9fc5f28e(ref2);
        $6a94da97f0c28d33$var$trackEffect($6a94da97f0c28d33$var$activeEffect, (_a = ref2.dep) != null ? _a : ref2.dep = $6a94da97f0c28d33$var$createDep(()=>ref2.dep = void 0, ref2 instanceof $6a94da97f0c28d33$var$ComputedRefImpl ? ref2 : void 0), void 0);
    }
}
function $6a94da97f0c28d33$var$triggerRefValue(ref2, dirtyLevel = 4, newVal) {
    ref2 = $6a94da97f0c28d33$export$ab18938b9fc5f28e(ref2);
    const dep = ref2.dep;
    if (dep) $6a94da97f0c28d33$var$triggerEffects(dep, dirtyLevel, void 0);
}
function $6a94da97f0c28d33$export$4f9f5282de18fc69(r) {
    return !!(r && r.__v_isRef === true);
}
function $6a94da97f0c28d33$export$eff4d24c3ff7876e(value) {
    return $6a94da97f0c28d33$var$createRef(value, false);
}
function $6a94da97f0c28d33$export$9b7bc5fe3b17c8b3(value) {
    return $6a94da97f0c28d33$var$createRef(value, true);
}
function $6a94da97f0c28d33$var$createRef(rawValue, shallow) {
    if ($6a94da97f0c28d33$export$4f9f5282de18fc69(rawValue)) return rawValue;
    return new $6a94da97f0c28d33$var$RefImpl(rawValue, shallow);
}
class $6a94da97f0c28d33$var$RefImpl {
    constructor(value, __v_isShallow){
        this.__v_isShallow = __v_isShallow;
        this.dep = void 0;
        this.__v_isRef = true;
        this._rawValue = __v_isShallow ? value : $6a94da97f0c28d33$export$ab18938b9fc5f28e(value);
        this._value = __v_isShallow ? value : $6a94da97f0c28d33$var$toReactive(value);
    }
    get value() {
        $6a94da97f0c28d33$var$trackRefValue(this);
        return this._value;
    }
    set value(newVal) {
        const useDirectValue = this.__v_isShallow || $6a94da97f0c28d33$export$7f3fe6025abfa26e(newVal) || $6a94da97f0c28d33$export$92d09b48637741e7(newVal);
        newVal = useDirectValue ? newVal : $6a94da97f0c28d33$export$ab18938b9fc5f28e(newVal);
        if ((0, $16Sl1.hasChanged)(newVal, this._rawValue)) {
            this._rawValue = newVal;
            this._value = useDirectValue ? newVal : $6a94da97f0c28d33$var$toReactive(newVal);
            $6a94da97f0c28d33$var$triggerRefValue(this, 4, newVal);
        }
    }
}
function $6a94da97f0c28d33$export$f402f86588575ccc(ref2) {
    $6a94da97f0c28d33$var$triggerRefValue(ref2, 4, void 0);
}
function $6a94da97f0c28d33$export$a239a76781616204(ref2) {
    return $6a94da97f0c28d33$export$4f9f5282de18fc69(ref2) ? ref2.value : ref2;
}
function $6a94da97f0c28d33$export$30bdcc2218aa9458(source) {
    return (0, $16Sl1.isFunction)(source) ? source() : $6a94da97f0c28d33$export$a239a76781616204(source);
}
const $6a94da97f0c28d33$var$shallowUnwrapHandlers = {
    get: (target, key, receiver)=>$6a94da97f0c28d33$export$a239a76781616204(Reflect.get(target, key, receiver)),
    set: (target, key, value, receiver)=>{
        const oldValue = target[key];
        if ($6a94da97f0c28d33$export$4f9f5282de18fc69(oldValue) && !$6a94da97f0c28d33$export$4f9f5282de18fc69(value)) {
            oldValue.value = value;
            return true;
        } else return Reflect.set(target, key, value, receiver);
    }
};
function $6a94da97f0c28d33$export$f353fd1b97db3fa0(objectWithRefs) {
    return $6a94da97f0c28d33$export$352205f445242f02(objectWithRefs) ? objectWithRefs : new Proxy(objectWithRefs, $6a94da97f0c28d33$var$shallowUnwrapHandlers);
}
class $6a94da97f0c28d33$var$CustomRefImpl {
    constructor(factory){
        this.dep = void 0;
        this.__v_isRef = true;
        const { get: get, set: set } = factory(()=>$6a94da97f0c28d33$var$trackRefValue(this), ()=>$6a94da97f0c28d33$var$triggerRefValue(this));
        this._get = get;
        this._set = set;
    }
    get value() {
        return this._get();
    }
    set value(newVal) {
        this._set(newVal);
    }
}
function $6a94da97f0c28d33$export$a20c2dd6199824cb(factory) {
    return new $6a94da97f0c28d33$var$CustomRefImpl(factory);
}
function $6a94da97f0c28d33$export$2e9533675e5e70e0(object) {
    const ret = (0, $16Sl1.isArray)(object) ? new Array(object.length) : {};
    for(const key in object)ret[key] = $6a94da97f0c28d33$var$propertyToRef(object, key);
    return ret;
}
class $6a94da97f0c28d33$var$ObjectRefImpl {
    constructor(_object, _key, _defaultValue){
        this._object = _object;
        this._key = _key;
        this._defaultValue = _defaultValue;
        this.__v_isRef = true;
    }
    get value() {
        const val = this._object[this._key];
        return val === void 0 ? this._defaultValue : val;
    }
    set value(newVal) {
        this._object[this._key] = newVal;
    }
    get dep() {
        return $6a94da97f0c28d33$var$getDepFromReactive($6a94da97f0c28d33$export$ab18938b9fc5f28e(this._object), this._key);
    }
}
class $6a94da97f0c28d33$var$GetterRefImpl {
    constructor(_getter){
        this._getter = _getter;
        this.__v_isRef = true;
        this.__v_isReadonly = true;
    }
    get value() {
        return this._getter();
    }
}
function $6a94da97f0c28d33$export$1f60508e4f47b4b7(source, key, defaultValue) {
    if ($6a94da97f0c28d33$export$4f9f5282de18fc69(source)) return source;
    else if ((0, $16Sl1.isFunction)(source)) return new $6a94da97f0c28d33$var$GetterRefImpl(source);
    else if ((0, $16Sl1.isObject)(source) && arguments.length > 1) return $6a94da97f0c28d33$var$propertyToRef(source, key, defaultValue);
    else return $6a94da97f0c28d33$export$eff4d24c3ff7876e(source);
}
function $6a94da97f0c28d33$var$propertyToRef(source, key, defaultValue) {
    const val = source[key];
    return $6a94da97f0c28d33$export$4f9f5282de18fc69(val) ? val : new $6a94da97f0c28d33$var$ObjectRefImpl(source, key, defaultValue);
}
const $6a94da97f0c28d33$export$483264c4ec4c46ce = $6a94da97f0c28d33$export$2983e091f1a1e8e2;
const $6a94da97f0c28d33$export$2ac2bd0a56e04551 = {
    "GET": "get",
    "HAS": "has",
    "ITERATE": "iterate"
};
const $6a94da97f0c28d33$export$1e8941c92696a26 = {
    "SET": "set",
    "ADD": "add",
    "DELETE": "delete",
    "CLEAR": "clear"
};
const $6a94da97f0c28d33$export$e738ba173768902d = {
    "SKIP": "__v_skip",
    "IS_REACTIVE": "__v_isReactive",
    "IS_READONLY": "__v_isReadonly",
    "IS_SHALLOW": "__v_isShallow",
    "RAW": "__v_raw"
};

});
parcelRegister("16Sl1", function(module, exports) {

$parcel$export(module.exports, "makeMap", function () { return $0cf0806a653faaaa$export$b41394a5437791c8; });
$parcel$export(module.exports, "EMPTY_OBJ", function () { return $0cf0806a653faaaa$export$cf583d23ab39677c; });
$parcel$export(module.exports, "EMPTY_ARR", function () { return $0cf0806a653faaaa$export$6bd8558f433f1cc1; });
$parcel$export(module.exports, "NOOP", function () { return $0cf0806a653faaaa$export$5702a91a6f42969f; });
$parcel$export(module.exports, "NO", function () { return $0cf0806a653faaaa$export$c01351c0af048e39; });
$parcel$export(module.exports, "isOn", function () { return $0cf0806a653faaaa$export$1a2d97de39ecbb75; });
$parcel$export(module.exports, "isModelListener", function () { return $0cf0806a653faaaa$export$793aa5469768d691; });
$parcel$export(module.exports, "extend", function () { return $0cf0806a653faaaa$export$8b58be045bf06082; });
$parcel$export(module.exports, "remove", function () { return $0cf0806a653faaaa$export$cd7f480d6b8286c3; });
$parcel$export(module.exports, "hasOwn", function () { return $0cf0806a653faaaa$export$b5a638e9b3fff9f3; });
$parcel$export(module.exports, "isArray", function () { return $0cf0806a653faaaa$export$43bee75e5e14138e; });
$parcel$export(module.exports, "isMap", function () { return $0cf0806a653faaaa$export$5c90113a285f2241; });
$parcel$export(module.exports, "isSet", function () { return $0cf0806a653faaaa$export$6750766a7c7ec627; });
$parcel$export(module.exports, "isRegExp", function () { return $0cf0806a653faaaa$export$49841c62b9eff15; });
$parcel$export(module.exports, "isFunction", function () { return $0cf0806a653faaaa$export$f6e2535fb5126e54; });
$parcel$export(module.exports, "isString", function () { return $0cf0806a653faaaa$export$844ec244b1367d54; });
$parcel$export(module.exports, "isSymbol", function () { return $0cf0806a653faaaa$export$a244864fd9645c7f; });
$parcel$export(module.exports, "isObject", function () { return $0cf0806a653faaaa$export$a6cdc56e425d0d0a; });
$parcel$export(module.exports, "isPromise", function () { return $0cf0806a653faaaa$export$4369c812aac99591; });
$parcel$export(module.exports, "toRawType", function () { return $0cf0806a653faaaa$export$5ad0a3c360b8fbb5; });
$parcel$export(module.exports, "isPlainObject", function () { return $0cf0806a653faaaa$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "isIntegerKey", function () { return $0cf0806a653faaaa$export$e2a2b93446ec9fe; });
$parcel$export(module.exports, "isReservedProp", function () { return $0cf0806a653faaaa$export$bf7d3c0236f0aa85; });
$parcel$export(module.exports, "isBuiltInDirective", function () { return $0cf0806a653faaaa$export$a9c1fdb3030c2a6b; });
$parcel$export(module.exports, "camelize", function () { return $0cf0806a653faaaa$export$161d051f5dd25de7; });
$parcel$export(module.exports, "hyphenate", function () { return $0cf0806a653faaaa$export$6e6a0a3676c4b8bb; });
$parcel$export(module.exports, "capitalize", function () { return $0cf0806a653faaaa$export$9a00dee1beb8f576; });
$parcel$export(module.exports, "toHandlerKey", function () { return $0cf0806a653faaaa$export$8c022799eeaaefcd; });
$parcel$export(module.exports, "hasChanged", function () { return $0cf0806a653faaaa$export$f619eb8b89076d23; });
$parcel$export(module.exports, "invokeArrayFns", function () { return $0cf0806a653faaaa$export$39951422d618a9d3; });
$parcel$export(module.exports, "def", function () { return $0cf0806a653faaaa$export$8afb76124cf08683; });
$parcel$export(module.exports, "looseToNumber", function () { return $0cf0806a653faaaa$export$d3be7195bcc2f31b; });
$parcel$export(module.exports, "toNumber", function () { return $0cf0806a653faaaa$export$a0a81dc3380ce7d3; });
$parcel$export(module.exports, "getGlobalThis", function () { return $0cf0806a653faaaa$export$ff5f2eeb11fc7e14; });
$parcel$export(module.exports, "isGloballyAllowed", function () { return $0cf0806a653faaaa$export$f73b8c13b7f97ebf; });
$parcel$export(module.exports, "normalizeStyle", function () { return $0cf0806a653faaaa$export$8756898546458274; });
$parcel$export(module.exports, "stringifyStyle", function () { return $0cf0806a653faaaa$export$9466a5a0ee6f1479; });
$parcel$export(module.exports, "normalizeClass", function () { return $0cf0806a653faaaa$export$4f7022d2d68e2c5a; });
$parcel$export(module.exports, "isHTMLTag", function () { return $0cf0806a653faaaa$export$1ccf854a0984f890; });
$parcel$export(module.exports, "isSVGTag", function () { return $0cf0806a653faaaa$export$6328ce7565ea1049; });
$parcel$export(module.exports, "isMathMLTag", function () { return $0cf0806a653faaaa$export$4a46ca4c5be17b20; });
$parcel$export(module.exports, "isSpecialBooleanAttr", function () { return $0cf0806a653faaaa$export$d186f5eb2e810715; });
$parcel$export(module.exports, "isBooleanAttr", function () { return $0cf0806a653faaaa$export$f763ba3b84e9cd8c; });
$parcel$export(module.exports, "includeBooleanAttr", function () { return $0cf0806a653faaaa$export$e3f3cdb1390d56ce; });
$parcel$export(module.exports, "isKnownHtmlAttr", function () { return $0cf0806a653faaaa$export$f7e7a1cc7da8d5e9; });
$parcel$export(module.exports, "isKnownSvgAttr", function () { return $0cf0806a653faaaa$export$80da416f43933831; });
$parcel$export(module.exports, "isRenderableAttrValue", function () { return $0cf0806a653faaaa$export$921dd2acf0d386a3; });
$parcel$export(module.exports, "looseEqual", function () { return $0cf0806a653faaaa$export$ae8015769846262c; });
$parcel$export(module.exports, "looseIndexOf", function () { return $0cf0806a653faaaa$export$42912a80cedb8bd4; });
$parcel$export(module.exports, "toDisplayString", function () { return $0cf0806a653faaaa$export$b5b1545233b45293; });
/**
* @vue/shared v3.4.25
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ /*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $0cf0806a653faaaa$export$b41394a5437791c8(str, expectsLowerCase) {
    const set = new Set(str.split(","));
    return expectsLowerCase ? (val)=>set.has(val.toLowerCase()) : (val)=>set.has(val);
}
const $0cf0806a653faaaa$export$cf583d23ab39677c = {};
const $0cf0806a653faaaa$export$6bd8558f433f1cc1 = [];
const $0cf0806a653faaaa$export$5702a91a6f42969f = ()=>{};
const $0cf0806a653faaaa$export$c01351c0af048e39 = ()=>false;
const $0cf0806a653faaaa$export$1a2d97de39ecbb75 = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // uppercase letter
    (key.charCodeAt(2) > 122 || key.charCodeAt(2) < 97);
const $0cf0806a653faaaa$export$793aa5469768d691 = (key)=>key.startsWith("onUpdate:");
const $0cf0806a653faaaa$export$8b58be045bf06082 = Object.assign;
const $0cf0806a653faaaa$export$cd7f480d6b8286c3 = (arr, el)=>{
    const i = arr.indexOf(el);
    if (i > -1) arr.splice(i, 1);
};
const $0cf0806a653faaaa$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $0cf0806a653faaaa$export$b5a638e9b3fff9f3 = (val, key)=>$0cf0806a653faaaa$var$hasOwnProperty.call(val, key);
const $0cf0806a653faaaa$export$43bee75e5e14138e = Array.isArray;
const $0cf0806a653faaaa$export$5c90113a285f2241 = (val)=>$0cf0806a653faaaa$export$1dccc787cc36538b(val) === "[object Map]";
const $0cf0806a653faaaa$export$6750766a7c7ec627 = (val)=>$0cf0806a653faaaa$export$1dccc787cc36538b(val) === "[object Set]";
const $0cf0806a653faaaa$export$871608497c498473 = (val)=>$0cf0806a653faaaa$export$1dccc787cc36538b(val) === "[object Date]";
const $0cf0806a653faaaa$export$49841c62b9eff15 = (val)=>$0cf0806a653faaaa$export$1dccc787cc36538b(val) === "[object RegExp]";
const $0cf0806a653faaaa$export$f6e2535fb5126e54 = (val)=>typeof val === "function";
const $0cf0806a653faaaa$export$844ec244b1367d54 = (val)=>typeof val === "string";
const $0cf0806a653faaaa$export$a244864fd9645c7f = (val)=>typeof val === "symbol";
const $0cf0806a653faaaa$export$a6cdc56e425d0d0a = (val)=>val !== null && typeof val === "object";
const $0cf0806a653faaaa$export$4369c812aac99591 = (val)=>{
    return ($0cf0806a653faaaa$export$a6cdc56e425d0d0a(val) || $0cf0806a653faaaa$export$f6e2535fb5126e54(val)) && $0cf0806a653faaaa$export$f6e2535fb5126e54(val.then) && $0cf0806a653faaaa$export$f6e2535fb5126e54(val.catch);
};
const $0cf0806a653faaaa$export$830c053460e5ddf6 = Object.prototype.toString;
const $0cf0806a653faaaa$export$1dccc787cc36538b = (value)=>$0cf0806a653faaaa$export$830c053460e5ddf6.call(value);
const $0cf0806a653faaaa$export$5ad0a3c360b8fbb5 = (value)=>{
    return $0cf0806a653faaaa$export$1dccc787cc36538b(value).slice(8, -1);
};
const $0cf0806a653faaaa$export$53b83ca8eaab0383 = (val)=>$0cf0806a653faaaa$export$1dccc787cc36538b(val) === "[object Object]";
const $0cf0806a653faaaa$export$e2a2b93446ec9fe = (key)=>$0cf0806a653faaaa$export$844ec244b1367d54(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
const $0cf0806a653faaaa$export$bf7d3c0236f0aa85 = /* @__PURE__ */ $0cf0806a653faaaa$export$b41394a5437791c8(// the leading comma is intentional so empty string "" is also included
",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted");
const $0cf0806a653faaaa$export$a9c1fdb3030c2a6b = /* @__PURE__ */ $0cf0806a653faaaa$export$b41394a5437791c8("bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo");
const $0cf0806a653faaaa$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
const $0cf0806a653faaaa$var$camelizeRE = /-(\w)/g;
const $0cf0806a653faaaa$export$161d051f5dd25de7 = $0cf0806a653faaaa$var$cacheStringFunction((str)=>{
    return str.replace($0cf0806a653faaaa$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
const $0cf0806a653faaaa$var$hyphenateRE = /\B([A-Z])/g;
const $0cf0806a653faaaa$export$6e6a0a3676c4b8bb = $0cf0806a653faaaa$var$cacheStringFunction((str)=>str.replace($0cf0806a653faaaa$var$hyphenateRE, "-$1").toLowerCase());
const $0cf0806a653faaaa$export$9a00dee1beb8f576 = $0cf0806a653faaaa$var$cacheStringFunction((str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
});
const $0cf0806a653faaaa$export$8c022799eeaaefcd = $0cf0806a653faaaa$var$cacheStringFunction((str)=>{
    const s = str ? `on${$0cf0806a653faaaa$export$9a00dee1beb8f576(str)}` : ``;
    return s;
});
const $0cf0806a653faaaa$export$f619eb8b89076d23 = (value, oldValue)=>!Object.is(value, oldValue);
const $0cf0806a653faaaa$export$39951422d618a9d3 = (fns, arg)=>{
    for(let i = 0; i < fns.length; i++)fns[i](arg);
};
const $0cf0806a653faaaa$export$8afb76124cf08683 = (obj, key, value)=>{
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: false,
        value: value
    });
};
const $0cf0806a653faaaa$export$d3be7195bcc2f31b = (val)=>{
    const n = parseFloat(val);
    return isNaN(n) ? val : n;
};
const $0cf0806a653faaaa$export$a0a81dc3380ce7d3 = (val)=>{
    const n = $0cf0806a653faaaa$export$844ec244b1367d54(val) ? Number(val) : NaN;
    return isNaN(n) ? val : n;
};
let $0cf0806a653faaaa$var$_globalThis;
const $0cf0806a653faaaa$export$ff5f2eeb11fc7e14 = ()=>{
    return $0cf0806a653faaaa$var$_globalThis || ($0cf0806a653faaaa$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {});
};
const $0cf0806a653faaaa$var$identRE = /^[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*$/;
function $0cf0806a653faaaa$export$53d5e12f9a1d3cde(name) {
    return $0cf0806a653faaaa$var$identRE.test(name) ? `__props.${name}` : `__props[${JSON.stringify(name)}]`;
}
const $0cf0806a653faaaa$export$4bcc674e2ac54ab0 = {
    "TEXT": 1,
    "1": "TEXT",
    "CLASS": 2,
    "2": "CLASS",
    "STYLE": 4,
    "4": "STYLE",
    "PROPS": 8,
    "8": "PROPS",
    "FULL_PROPS": 16,
    "16": "FULL_PROPS",
    "NEED_HYDRATION": 32,
    "32": "NEED_HYDRATION",
    "STABLE_FRAGMENT": 64,
    "64": "STABLE_FRAGMENT",
    "KEYED_FRAGMENT": 128,
    "128": "KEYED_FRAGMENT",
    "UNKEYED_FRAGMENT": 256,
    "256": "UNKEYED_FRAGMENT",
    "NEED_PATCH": 512,
    "512": "NEED_PATCH",
    "DYNAMIC_SLOTS": 1024,
    "1024": "DYNAMIC_SLOTS",
    "DEV_ROOT_FRAGMENT": 2048,
    "2048": "DEV_ROOT_FRAGMENT",
    "HOISTED": -1,
    "-1": "HOISTED",
    "BAIL": -2,
    "-2": "BAIL"
};
const $0cf0806a653faaaa$export$def7dc2c2e95a08a = {
    [1]: `TEXT`,
    [2]: `CLASS`,
    [4]: `STYLE`,
    [8]: `PROPS`,
    [16]: `FULL_PROPS`,
    [32]: `NEED_HYDRATION`,
    [64]: `STABLE_FRAGMENT`,
    [128]: `KEYED_FRAGMENT`,
    [256]: `UNKEYED_FRAGMENT`,
    [512]: `NEED_PATCH`,
    [1024]: `DYNAMIC_SLOTS`,
    [2048]: `DEV_ROOT_FRAGMENT`,
    [-1]: `HOISTED`,
    [-2]: `BAIL`
};
const $0cf0806a653faaaa$export$ff27c1ebf2311072 = {
    "ELEMENT": 1,
    "1": "ELEMENT",
    "FUNCTIONAL_COMPONENT": 2,
    "2": "FUNCTIONAL_COMPONENT",
    "STATEFUL_COMPONENT": 4,
    "4": "STATEFUL_COMPONENT",
    "TEXT_CHILDREN": 8,
    "8": "TEXT_CHILDREN",
    "ARRAY_CHILDREN": 16,
    "16": "ARRAY_CHILDREN",
    "SLOTS_CHILDREN": 32,
    "32": "SLOTS_CHILDREN",
    "TELEPORT": 64,
    "64": "TELEPORT",
    "SUSPENSE": 128,
    "128": "SUSPENSE",
    "COMPONENT_SHOULD_KEEP_ALIVE": 256,
    "256": "COMPONENT_SHOULD_KEEP_ALIVE",
    "COMPONENT_KEPT_ALIVE": 512,
    "512": "COMPONENT_KEPT_ALIVE",
    "COMPONENT": 6,
    "6": "COMPONENT"
};
const $0cf0806a653faaaa$export$b1e6fe37bcdef5be = {
    "STABLE": 1,
    "1": "STABLE",
    "DYNAMIC": 2,
    "2": "DYNAMIC",
    "FORWARDED": 3,
    "3": "FORWARDED"
};
const $0cf0806a653faaaa$export$624972196ed3745f = {
    [1]: "STABLE",
    [2]: "DYNAMIC",
    [3]: "FORWARDED"
};
const $0cf0806a653faaaa$var$GLOBALS_ALLOWED = "Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,console,Error";
const $0cf0806a653faaaa$export$f73b8c13b7f97ebf = /* @__PURE__ */ $0cf0806a653faaaa$export$b41394a5437791c8($0cf0806a653faaaa$var$GLOBALS_ALLOWED);
const $0cf0806a653faaaa$export$d6571a1911e4f27e = $0cf0806a653faaaa$export$f73b8c13b7f97ebf;
const $0cf0806a653faaaa$var$range = 2;
function $0cf0806a653faaaa$export$f9c0d8b6684a279b(source, start = 0, end = source.length) {
    let lines = source.split(/(\r?\n)/);
    const newlineSequences = lines.filter((_, idx)=>idx % 2 === 1);
    lines = lines.filter((_, idx)=>idx % 2 === 0);
    let count = 0;
    const res = [];
    for(let i = 0; i < lines.length; i++){
        count += lines[i].length + (newlineSequences[i] && newlineSequences[i].length || 0);
        if (count >= start) {
            for(let j = i - $0cf0806a653faaaa$var$range; j <= i + $0cf0806a653faaaa$var$range || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                const line = j + 1;
                res.push(`${line}${" ".repeat(Math.max(3 - String(line).length, 0))}|  ${lines[j]}`);
                const lineLength = lines[j].length;
                const newLineSeqLength = newlineSequences[j] && newlineSequences[j].length || 0;
                if (j === i) {
                    const pad = start - (count - (lineLength + newLineSeqLength));
                    const length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push(`   |  ` + " ".repeat(pad) + "^".repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        const length = Math.max(Math.min(end - count, lineLength), 1);
                        res.push(`   |  ` + "^".repeat(length));
                    }
                    count += lineLength + newLineSeqLength;
                }
            }
            break;
        }
    }
    return res.join("\n");
}
function $0cf0806a653faaaa$export$8756898546458274(value) {
    if ($0cf0806a653faaaa$export$43bee75e5e14138e(value)) {
        const res = {};
        for(let i = 0; i < value.length; i++){
            const item = value[i];
            const normalized = $0cf0806a653faaaa$export$844ec244b1367d54(item) ? $0cf0806a653faaaa$export$76a205ce979d066a(item) : $0cf0806a653faaaa$export$8756898546458274(item);
            if (normalized) for(const key in normalized)res[key] = normalized[key];
        }
        return res;
    } else if ($0cf0806a653faaaa$export$844ec244b1367d54(value) || $0cf0806a653faaaa$export$a6cdc56e425d0d0a(value)) return value;
}
const $0cf0806a653faaaa$var$listDelimiterRE = /;(?![^(]*\))/g;
const $0cf0806a653faaaa$var$propertyDelimiterRE = /:([^]+)/;
const $0cf0806a653faaaa$var$styleCommentRE = /\/\*[^]*?\*\//g;
function $0cf0806a653faaaa$export$76a205ce979d066a(cssText) {
    const ret = {};
    cssText.replace($0cf0806a653faaaa$var$styleCommentRE, "").split($0cf0806a653faaaa$var$listDelimiterRE).forEach((item)=>{
        if (item) {
            const tmp = item.split($0cf0806a653faaaa$var$propertyDelimiterRE);
            tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return ret;
}
function $0cf0806a653faaaa$export$9466a5a0ee6f1479(styles) {
    let ret = "";
    if (!styles || $0cf0806a653faaaa$export$844ec244b1367d54(styles)) return ret;
    for(const key in styles){
        const value = styles[key];
        const normalizedKey = key.startsWith(`--`) ? key : $0cf0806a653faaaa$export$6e6a0a3676c4b8bb(key);
        if ($0cf0806a653faaaa$export$844ec244b1367d54(value) || typeof value === "number") ret += `${normalizedKey}:${value};`;
    }
    return ret;
}
function $0cf0806a653faaaa$export$4f7022d2d68e2c5a(value) {
    let res = "";
    if ($0cf0806a653faaaa$export$844ec244b1367d54(value)) res = value;
    else if ($0cf0806a653faaaa$export$43bee75e5e14138e(value)) for(let i = 0; i < value.length; i++){
        const normalized = $0cf0806a653faaaa$export$4f7022d2d68e2c5a(value[i]);
        if (normalized) res += normalized + " ";
    }
    else if ($0cf0806a653faaaa$export$a6cdc56e425d0d0a(value)) {
        for(const name in value)if (value[name]) res += name + " ";
    }
    return res.trim();
}
function $0cf0806a653faaaa$export$601abcd8103db5e4(props) {
    if (!props) return null;
    let { class: klass, style: style } = props;
    if (klass && !$0cf0806a653faaaa$export$844ec244b1367d54(klass)) props.class = $0cf0806a653faaaa$export$4f7022d2d68e2c5a(klass);
    if (style) props.style = $0cf0806a653faaaa$export$8756898546458274(style);
    return props;
}
const $0cf0806a653faaaa$var$HTML_TAGS = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot";
const $0cf0806a653faaaa$var$SVG_TAGS = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view";
const $0cf0806a653faaaa$var$MATH_TAGS = "annotation,annotation-xml,maction,maligngroup,malignmark,math,menclose,merror,mfenced,mfrac,mfraction,mglyph,mi,mlabeledtr,mlongdiv,mmultiscripts,mn,mo,mover,mpadded,mphantom,mprescripts,mroot,mrow,ms,mscarries,mscarry,msgroup,msline,mspace,msqrt,msrow,mstack,mstyle,msub,msubsup,msup,mtable,mtd,mtext,mtr,munder,munderover,none,semantics";
const $0cf0806a653faaaa$var$VOID_TAGS = "area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr";
const $0cf0806a653faaaa$export$1ccf854a0984f890 = /* @__PURE__ */ $0cf0806a653faaaa$export$b41394a5437791c8($0cf0806a653faaaa$var$HTML_TAGS);
const $0cf0806a653faaaa$export$6328ce7565ea1049 = /* @__PURE__ */ $0cf0806a653faaaa$export$b41394a5437791c8($0cf0806a653faaaa$var$SVG_TAGS);
const $0cf0806a653faaaa$export$4a46ca4c5be17b20 = /* @__PURE__ */ $0cf0806a653faaaa$export$b41394a5437791c8($0cf0806a653faaaa$var$MATH_TAGS);
const $0cf0806a653faaaa$export$e5f2d3d97d9367a4 = /* @__PURE__ */ $0cf0806a653faaaa$export$b41394a5437791c8($0cf0806a653faaaa$var$VOID_TAGS);
const $0cf0806a653faaaa$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
const $0cf0806a653faaaa$export$d186f5eb2e810715 = /* @__PURE__ */ $0cf0806a653faaaa$export$b41394a5437791c8($0cf0806a653faaaa$var$specialBooleanAttrs);
const $0cf0806a653faaaa$export$f763ba3b84e9cd8c = /* @__PURE__ */ $0cf0806a653faaaa$export$b41394a5437791c8($0cf0806a653faaaa$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,inert,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
function $0cf0806a653faaaa$export$e3f3cdb1390d56ce(value) {
    return !!value || value === "";
}
const $0cf0806a653faaaa$var$unsafeAttrCharRE = /[>/="'\u0009\u000a\u000c\u0020]/;
const $0cf0806a653faaaa$var$attrValidationCache = {};
function $0cf0806a653faaaa$export$d55ef77660f30d12(name) {
    if ($0cf0806a653faaaa$var$attrValidationCache.hasOwnProperty(name)) return $0cf0806a653faaaa$var$attrValidationCache[name];
    const isUnsafe = $0cf0806a653faaaa$var$unsafeAttrCharRE.test(name);
    if (isUnsafe) console.error(`unsafe attribute name: ${name}`);
    return $0cf0806a653faaaa$var$attrValidationCache[name] = !isUnsafe;
}
const $0cf0806a653faaaa$export$b66fd0cae8dec3c8 = {
    acceptCharset: "accept-charset",
    className: "class",
    htmlFor: "for",
    httpEquiv: "http-equiv"
};
const $0cf0806a653faaaa$export$f7e7a1cc7da8d5e9 = /* @__PURE__ */ $0cf0806a653faaaa$export$b41394a5437791c8(`accept,accept-charset,accesskey,action,align,allow,alt,async,autocapitalize,autocomplete,autofocus,autoplay,background,bgcolor,border,buffered,capture,challenge,charset,checked,cite,class,code,codebase,color,cols,colspan,content,contenteditable,contextmenu,controls,coords,crossorigin,csp,data,datetime,decoding,default,defer,dir,dirname,disabled,download,draggable,dropzone,enctype,enterkeyhint,for,form,formaction,formenctype,formmethod,formnovalidate,formtarget,headers,height,hidden,high,href,hreflang,http-equiv,icon,id,importance,inert,integrity,ismap,itemprop,keytype,kind,label,lang,language,loading,list,loop,low,manifest,max,maxlength,minlength,media,min,multiple,muted,name,novalidate,open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,referrerpolicy,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,selected,shape,size,sizes,slot,span,spellcheck,src,srcdoc,srclang,srcset,start,step,style,summary,tabindex,target,title,translate,type,usemap,value,width,wrap`);
const $0cf0806a653faaaa$export$80da416f43933831 = /* @__PURE__ */ $0cf0806a653faaaa$export$b41394a5437791c8(`xmlns,accent-height,accumulate,additive,alignment-baseline,alphabetic,amplitude,arabic-form,ascent,attributeName,attributeType,azimuth,baseFrequency,baseline-shift,baseProfile,bbox,begin,bias,by,calcMode,cap-height,class,clip,clipPathUnits,clip-path,clip-rule,color,color-interpolation,color-interpolation-filters,color-profile,color-rendering,contentScriptType,contentStyleType,crossorigin,cursor,cx,cy,d,decelerate,descent,diffuseConstant,direction,display,divisor,dominant-baseline,dur,dx,dy,edgeMode,elevation,enable-background,end,exponent,fill,fill-opacity,fill-rule,filter,filterRes,filterUnits,flood-color,flood-opacity,font-family,font-size,font-size-adjust,font-stretch,font-style,font-variant,font-weight,format,from,fr,fx,fy,g1,g2,glyph-name,glyph-orientation-horizontal,glyph-orientation-vertical,glyphRef,gradientTransform,gradientUnits,hanging,height,href,hreflang,horiz-adv-x,horiz-origin-x,id,ideographic,image-rendering,in,in2,intercept,k,k1,k2,k3,k4,kernelMatrix,kernelUnitLength,kerning,keyPoints,keySplines,keyTimes,lang,lengthAdjust,letter-spacing,lighting-color,limitingConeAngle,local,marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mask,maskContentUnits,maskUnits,mathematical,max,media,method,min,mode,name,numOctaves,offset,opacity,operator,order,orient,orientation,origin,overflow,overline-position,overline-thickness,panose-1,paint-order,path,pathLength,patternContentUnits,patternTransform,patternUnits,ping,pointer-events,points,pointsAtX,pointsAtY,pointsAtZ,preserveAlpha,preserveAspectRatio,primitiveUnits,r,radius,referrerPolicy,refX,refY,rel,rendering-intent,repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,result,rotate,rx,ry,scale,seed,shape-rendering,slope,spacing,specularConstant,specularExponent,speed,spreadMethod,startOffset,stdDeviation,stemh,stemv,stitchTiles,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,string,stroke,stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,stroke-width,style,surfaceScale,systemLanguage,tabindex,tableValues,target,targetX,targetY,text-anchor,text-decoration,text-rendering,textLength,to,transform,transform-origin,type,u1,u2,underline-position,underline-thickness,unicode,unicode-bidi,unicode-range,units-per-em,v-alphabetic,v-hanging,v-ideographic,v-mathematical,values,vector-effect,version,vert-adv-y,vert-origin-x,vert-origin-y,viewBox,viewTarget,visibility,width,widths,word-spacing,writing-mode,x,x-height,x1,x2,xChannelSelector,xlink:actuate,xlink:arcrole,xlink:href,xlink:role,xlink:show,xlink:title,xlink:type,xmlns:xlink,xml:base,xml:lang,xml:space,y,y1,y2,yChannelSelector,z,zoomAndPan`);
function $0cf0806a653faaaa$export$921dd2acf0d386a3(value) {
    if (value == null) return false;
    const type = typeof value;
    return type === "string" || type === "number" || type === "boolean";
}
const $0cf0806a653faaaa$var$escapeRE = /["'&<>]/;
function $0cf0806a653faaaa$export$4cf11838cdc2a8a8(string) {
    const str = "" + string;
    const match = $0cf0806a653faaaa$var$escapeRE.exec(str);
    if (!match) return str;
    let html = "";
    let escaped;
    let index;
    let lastIndex = 0;
    for(index = match.index; index < str.length; index++){
        switch(str.charCodeAt(index)){
            case 34:
                escaped = "&quot;";
                break;
            case 38:
                escaped = "&amp;";
                break;
            case 39:
                escaped = "&#39;";
                break;
            case 60:
                escaped = "&lt;";
                break;
            case 62:
                escaped = "&gt;";
                break;
            default:
                continue;
        }
        if (lastIndex !== index) html += str.slice(lastIndex, index);
        lastIndex = index + 1;
        html += escaped;
    }
    return lastIndex !== index ? html + str.slice(lastIndex, index) : html;
}
const $0cf0806a653faaaa$var$commentStripRE = /^-?>|<!--|-->|--!>|<!-$/g;
function $0cf0806a653faaaa$export$7b105034a53bde5f(src) {
    return src.replace($0cf0806a653faaaa$var$commentStripRE, "");
}
function $0cf0806a653faaaa$var$looseCompareArrays(a, b) {
    if (a.length !== b.length) return false;
    let equal = true;
    for(let i = 0; equal && i < a.length; i++)equal = $0cf0806a653faaaa$export$ae8015769846262c(a[i], b[i]);
    return equal;
}
function $0cf0806a653faaaa$export$ae8015769846262c(a, b) {
    if (a === b) return true;
    let aValidType = $0cf0806a653faaaa$export$871608497c498473(a);
    let bValidType = $0cf0806a653faaaa$export$871608497c498473(b);
    if (aValidType || bValidType) return aValidType && bValidType ? a.getTime() === b.getTime() : false;
    aValidType = $0cf0806a653faaaa$export$a244864fd9645c7f(a);
    bValidType = $0cf0806a653faaaa$export$a244864fd9645c7f(b);
    if (aValidType || bValidType) return a === b;
    aValidType = $0cf0806a653faaaa$export$43bee75e5e14138e(a);
    bValidType = $0cf0806a653faaaa$export$43bee75e5e14138e(b);
    if (aValidType || bValidType) return aValidType && bValidType ? $0cf0806a653faaaa$var$looseCompareArrays(a, b) : false;
    aValidType = $0cf0806a653faaaa$export$a6cdc56e425d0d0a(a);
    bValidType = $0cf0806a653faaaa$export$a6cdc56e425d0d0a(b);
    if (aValidType || bValidType) {
        if (!aValidType || !bValidType) return false;
        const aKeysCount = Object.keys(a).length;
        const bKeysCount = Object.keys(b).length;
        if (aKeysCount !== bKeysCount) return false;
        for(const key in a){
            const aHasKey = a.hasOwnProperty(key);
            const bHasKey = b.hasOwnProperty(key);
            if (aHasKey && !bHasKey || !aHasKey && bHasKey || !$0cf0806a653faaaa$export$ae8015769846262c(a[key], b[key])) return false;
        }
    }
    return String(a) === String(b);
}
function $0cf0806a653faaaa$export$42912a80cedb8bd4(arr, val) {
    return arr.findIndex((item)=>$0cf0806a653faaaa$export$ae8015769846262c(item, val));
}
const $0cf0806a653faaaa$export$b5b1545233b45293 = (val)=>{
    return $0cf0806a653faaaa$export$844ec244b1367d54(val) ? val : val == null ? "" : $0cf0806a653faaaa$export$43bee75e5e14138e(val) || $0cf0806a653faaaa$export$a6cdc56e425d0d0a(val) && (val.toString === $0cf0806a653faaaa$export$830c053460e5ddf6 || !$0cf0806a653faaaa$export$f6e2535fb5126e54(val.toString)) ? JSON.stringify(val, $0cf0806a653faaaa$var$replacer, 2) : String(val);
};
const $0cf0806a653faaaa$var$replacer = (_key, val)=>{
    if (val && val.__v_isRef) return $0cf0806a653faaaa$var$replacer(_key, val.value);
    else if ($0cf0806a653faaaa$export$5c90113a285f2241(val)) return {
        [`Map(${val.size})`]: [
            ...val.entries()
        ].reduce((entries, [key, val2], i)=>{
            entries[$0cf0806a653faaaa$var$stringifySymbol(key, i) + " =>"] = val2;
            return entries;
        }, {})
    };
    else if ($0cf0806a653faaaa$export$6750766a7c7ec627(val)) return {
        [`Set(${val.size})`]: [
            ...val.values()
        ].map((v)=>$0cf0806a653faaaa$var$stringifySymbol(v))
    };
    else if ($0cf0806a653faaaa$export$a244864fd9645c7f(val)) return $0cf0806a653faaaa$var$stringifySymbol(val);
    else if ($0cf0806a653faaaa$export$a6cdc56e425d0d0a(val) && !$0cf0806a653faaaa$export$43bee75e5e14138e(val) && !$0cf0806a653faaaa$export$53b83ca8eaab0383(val)) return String(val);
    return val;
};
const $0cf0806a653faaaa$var$stringifySymbol = (v, i = "")=>{
    var _a;
    return(// Symbol.description in es2019+ so we need to cast here to pass
    // the lib: es2016 check
    $0cf0806a653faaaa$export$a244864fd9645c7f(v) ? `Symbol(${(_a = v.description) != null ? _a : i})` : v);
};

});






parcelRegister("9oNrh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6d7cb47f4d4defb7$export$2e2bcd8739ae039; });
let $6d7cb47f4d4defb7$var$NOOP = ()=>{};
var $6d7cb47f4d4defb7$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("iEUGM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d957efab0f8d132b$export$2e2bcd8739ae039; });
// Might need this for test harnesses...
// const L = (window['L'] || import('leaflet'));
class $d957efab0f8d132b$export$2e2bcd8739ae039 {
    constructor(myKey, instance){
        this.inst = instance;
        this.id = myKey;
        this.name = "";
        this.popupName = "";
        this.options = {};
        this.options.hasPanRefresh = true;
        this.options.hasAutoRefresh = true;
        this.layer = null;
        this.tasks = {};
    }
    attachLayer() {
        if (this.isAttached()) return true;
        // Wire up to parent instance
        this.inst.layers[this.id] = this.layer = new L.LayerGroup();
        this.inst.map.addLayer(this.layer);
        if (this.options.hasPanRefresh) this.inst.mapMoveListeners[this.id] = this.id;
        if (this.options.hasAutoRefresh) this.inst.autoUpdateListeners[this.id] = this.id;
        this.createSublayers();
        this.refreshLayer();
    }
    detachLayer() {
        if (!this.isAttached()) return true;
        if (this.options.hasPanRefresh) delete this.inst.mapMoveListeners[this.id];
        if (this.options.hasAutoRefresh) delete this.inst.autoUpdateListeners[this.id];
        this.inst.map.removeLayer(this.layer);
        delete this.inst.layers[this.id];
        // FIXME Before null layer, should cancel all this.tasks
        this.cleanup();
        this.layer = null;
    }
    // does this Manager have layer(s) attached to map?
    // return bool
    isAttached() {
        return this.layer !== null && this.inst.layers[this.id] && this.inst.layers[this.id] === this.layer;
    }
    isVisible() {
        return this.layer !== null && this.inst.map.hasLayer(this.layer);
    }
    toggleLayer(active) {
        if (active && !this.isAttached()) this.attachLayer();
        else if (!active && this.isAttached()) this.detachLayer();
    }
    hideLayer() {
        this.inst.map.removeLayer(this.layer);
    }
    showLayer() {
        this.inst.map.addLayer(this.layer);
    }
    refreshLayer() {
    // Stub that gets overridden in child class
    }
    createSublayers() {
    // Stub that gets overridden in child class
    }
    cleanup() {}
}

});

parcelRegister("8tjc5", function(module, exports) {


module.exports = (parcelRequire("lkPAR"))((parcelRequire("7NZgr")).resolve("8Fbfr")).then(()=>parcelRequire("13Tyk"));

});
parcelRegister("lkPAR", function(module, exports) {
"use strict";

var $elHer = parcelRequire("elHer");
module.exports = $elHer(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});
parcelRegister("elHer", function(module, exports) {
"use strict";
var $a7248fc9fb59eaef$var$cachedBundles = {};
var $a7248fc9fb59eaef$var$cachedPreloads = {};
var $a7248fc9fb59eaef$var$cachedPrefetches = {};
function $a7248fc9fb59eaef$var$getCache(type) {
    switch(type){
        case "preload":
            return $a7248fc9fb59eaef$var$cachedPreloads;
        case "prefetch":
            return $a7248fc9fb59eaef$var$cachedPrefetches;
        default:
            return $a7248fc9fb59eaef$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $a7248fc9fb59eaef$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("eGBeZ", function(module, exports) {


module.exports = (parcelRequire("lkPAR"))((parcelRequire("7NZgr")).resolve("fk8np")).then(()=>parcelRequire("3sP2D"));

});

var $a183061a4ee72d63$exports = {};


(parcelRequire("7NZgr")).register((parcelRequire("kdZVT")).getBundleURL("4jfoK"), JSON.parse('["4jfoK","weatherNetLive.js","8Fbfr","GLRadarLayer.08a90042.js","fk8np","ClientAssetsLayerManager.67ad2918.js","9pP9q","weatherNetLive.css"]'));

// import 'babel-polyfill';
/* @preserve
   WeatherNet Map
   Javascript Library for weatherUSA slippy (web/interactive) weather maps
   (c) 2012-2019 weatherUSA, LLC
*/ // Core-JS polyfill support
"use strict";
var $54e13f33f64be1ee$exports = {};
"use strict";
var $54e13f33f64be1ee$var$check = function(it) {
    return it && it.Math === Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
$54e13f33f64be1ee$exports = // eslint-disable-next-line es/no-global-this -- safe
$54e13f33f64be1ee$var$check(typeof globalThis == "object" && globalThis) || $54e13f33f64be1ee$var$check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
$54e13f33f64be1ee$var$check(typeof self == "object" && self) || $54e13f33f64be1ee$var$check(typeof $parcel$global == "object" && $parcel$global) || $54e13f33f64be1ee$var$check(typeof $54e13f33f64be1ee$exports == "object" && $54e13f33f64be1ee$exports) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function("return this")();


var $5a26683efafc8f53$exports = {};
"use strict";
var $499dc2a41f52af84$exports = {};
"use strict";
$499dc2a41f52af84$exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};


// Detect IE8's incomplete defineProperty implementation
$5a26683efafc8f53$exports = !$499dc2a41f52af84$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] !== 7;
});


var $cbea80d6fef6e2ad$exports = {};
"use strict";
var $1a6a38dc8724cd5b$exports = {};
"use strict";
var $97283d7e30dd0ca9$exports = {};
"use strict";
var $7f8fc9069c29a8c3$exports = {};
"use strict";

$7f8fc9069c29a8c3$exports = !$499dc2a41f52af84$exports(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != "function" || test.hasOwnProperty("prototype");
});


var $97283d7e30dd0ca9$var$FunctionPrototype = Function.prototype;
var $97283d7e30dd0ca9$var$call = $97283d7e30dd0ca9$var$FunctionPrototype.call;
var $97283d7e30dd0ca9$var$uncurryThisWithBind = $7f8fc9069c29a8c3$exports && $97283d7e30dd0ca9$var$FunctionPrototype.bind.bind($97283d7e30dd0ca9$var$call, $97283d7e30dd0ca9$var$call);
$97283d7e30dd0ca9$exports = $7f8fc9069c29a8c3$exports ? $97283d7e30dd0ca9$var$uncurryThisWithBind : function(fn) {
    return function() {
        return $97283d7e30dd0ca9$var$call.apply(fn, arguments);
    };
};



var $cc96a210e25dba22$exports = {};
"use strict";
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var $cc96a210e25dba22$var$documentAll = typeof document == "object" && document.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
$cc96a210e25dba22$exports = typeof $cc96a210e25dba22$var$documentAll == "undefined" && $cc96a210e25dba22$var$documentAll !== undefined ? function(argument) {
    return typeof argument == "function" || argument === $cc96a210e25dba22$var$documentAll;
} : function(argument) {
    return typeof argument == "function";
};


var $72a1af5443fcd78e$exports = {};
"use strict";

var $483e3f8d0ab383ee$exports = {};
"use strict";
var $ab9d518c84de69ff$exports = {};
"use strict";
var $0b474519da97b67f$exports = {};
"use strict";
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
$0b474519da97b67f$exports = function(it) {
    return it === null || it === undefined;
};


var $ab9d518c84de69ff$var$$TypeError = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
$ab9d518c84de69ff$exports = function(it) {
    if ($0b474519da97b67f$exports(it)) throw new $ab9d518c84de69ff$var$$TypeError("Can't call method on " + it);
    return it;
};


var $483e3f8d0ab383ee$var$$Object = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
$483e3f8d0ab383ee$exports = function(argument) {
    return $483e3f8d0ab383ee$var$$Object($ab9d518c84de69ff$exports(argument));
};


var $72a1af5443fcd78e$var$hasOwnProperty = $97283d7e30dd0ca9$exports({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
$72a1af5443fcd78e$exports = Object.hasOwn || function hasOwn(it, key) {
    return $72a1af5443fcd78e$var$hasOwnProperty($483e3f8d0ab383ee$exports(it), key);
};



var $74117ac48fbed883$exports = {};
"use strict";


var $74117ac48fbed883$var$FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $74117ac48fbed883$var$getDescriptor = $5a26683efafc8f53$exports && Object.getOwnPropertyDescriptor;
var $74117ac48fbed883$var$EXISTS = $72a1af5443fcd78e$exports($74117ac48fbed883$var$FunctionPrototype, "name");
// additional protection from minified / mangled / dropped function names
var $74117ac48fbed883$var$PROPER = $74117ac48fbed883$var$EXISTS && (function something() {}).name === "something";
var $74117ac48fbed883$var$CONFIGURABLE = $74117ac48fbed883$var$EXISTS && (!$5a26683efafc8f53$exports || $5a26683efafc8f53$exports && $74117ac48fbed883$var$getDescriptor($74117ac48fbed883$var$FunctionPrototype, "name").configurable);
$74117ac48fbed883$exports = {
    EXISTS: $74117ac48fbed883$var$EXISTS,
    PROPER: $74117ac48fbed883$var$PROPER,
    CONFIGURABLE: $74117ac48fbed883$var$CONFIGURABLE
};


var $1a6a38dc8724cd5b$require$CONFIGURABLE_FUNCTION_NAME = $74117ac48fbed883$exports.CONFIGURABLE;
var $dbbc9eaffa604d09$exports = {};
"use strict";


var $f1b6ea46842ac698$exports = {};
"use strict";
var $323e21026531e79f$exports = {};
"use strict";
$323e21026531e79f$exports = false;



var $f709f760ebfea8d4$exports = {};
"use strict";

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $f709f760ebfea8d4$var$defineProperty = Object.defineProperty;
$f709f760ebfea8d4$exports = function(key, value) {
    try {
        $f709f760ebfea8d4$var$defineProperty($54e13f33f64be1ee$exports, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $54e13f33f64be1ee$exports[key] = value;
    }
    return value;
};


var $f1b6ea46842ac698$var$SHARED = "__core-js_shared__";
var $f1b6ea46842ac698$var$store = $f1b6ea46842ac698$exports = $54e13f33f64be1ee$exports[$f1b6ea46842ac698$var$SHARED] || $f709f760ebfea8d4$exports($f1b6ea46842ac698$var$SHARED, {});
($f1b6ea46842ac698$var$store.versions || ($f1b6ea46842ac698$var$store.versions = [])).push({
    version: "3.37.0",
    mode: $323e21026531e79f$exports ? "pure" : "global",
    copyright: "\xa9 2014-2024 Denis Pushkarev (zloirock.ru)",
    license: "https://github.com/zloirock/core-js/blob/v3.37.0/LICENSE",
    source: "https://github.com/zloirock/core-js"
});


var $dbbc9eaffa604d09$var$functionToString = $97283d7e30dd0ca9$exports(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$cc96a210e25dba22$exports($f1b6ea46842ac698$exports.inspectSource)) $f1b6ea46842ac698$exports.inspectSource = function(it) {
    return $dbbc9eaffa604d09$var$functionToString(it);
};
$dbbc9eaffa604d09$exports = $f1b6ea46842ac698$exports.inspectSource;


var $2a3d98c1d5808b15$exports = {};
"use strict";
var $b5b4b1da22fa85bd$exports = {};
"use strict";


var $b5b4b1da22fa85bd$var$WeakMap = $54e13f33f64be1ee$exports.WeakMap;
$b5b4b1da22fa85bd$exports = $cc96a210e25dba22$exports($b5b4b1da22fa85bd$var$WeakMap) && /native code/.test(String($b5b4b1da22fa85bd$var$WeakMap));



var $0a98e8cd18e86b5f$exports = {};
"use strict";

$0a98e8cd18e86b5f$exports = function(it) {
    return typeof it == "object" ? it !== null : $cc96a210e25dba22$exports(it);
};


var $5e1d2d7a1a3c497e$exports = {};
"use strict";

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var $81a4a50564ee687b$export$2d1720544b23b823;
"use strict";

var $9b2f2febf93ea538$exports = {};
"use strict";


var $504371fda82e7133$exports = {};
"use strict";


var $504371fda82e7133$var$document = $54e13f33f64be1ee$exports.document;
// typeof document.createElement is 'object' in old IE
var $504371fda82e7133$var$EXISTS = $0a98e8cd18e86b5f$exports($504371fda82e7133$var$document) && $0a98e8cd18e86b5f$exports($504371fda82e7133$var$document.createElement);
$504371fda82e7133$exports = function(it) {
    return $504371fda82e7133$var$EXISTS ? $504371fda82e7133$var$document.createElement(it) : {};
};


// Thanks to IE8 for its funny defineProperty
$9b2f2febf93ea538$exports = !$5a26683efafc8f53$exports && !$499dc2a41f52af84$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty($504371fda82e7133$exports("div"), "a", {
        get: function() {
            return 7;
        }
    }).a !== 7;
});


var $dfc9a68bfe178d6e$exports = {};
"use strict";


// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
$dfc9a68bfe178d6e$exports = $5a26683efafc8f53$exports && $499dc2a41f52af84$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, "prototype", {
        value: 42,
        writable: false
    }).prototype !== 42;
});


var $1cfdcb8afd61bc2c$exports = {};
"use strict";

var $1cfdcb8afd61bc2c$var$$String = String;
var $1cfdcb8afd61bc2c$var$$TypeError = TypeError;
// `Assert: Type(argument) is Object`
$1cfdcb8afd61bc2c$exports = function(argument) {
    if ($0a98e8cd18e86b5f$exports(argument)) return argument;
    throw new $1cfdcb8afd61bc2c$var$$TypeError($1cfdcb8afd61bc2c$var$$String(argument) + " is not an object");
};


var $29fddb489ab41fa8$exports = {};
"use strict";
var $939730f95e40d433$exports = {};
"use strict";
var $29b3598cf8a2a88f$exports = {};
"use strict";

var $29b3598cf8a2a88f$var$call = Function.prototype.call;
$29b3598cf8a2a88f$exports = $7f8fc9069c29a8c3$exports ? $29b3598cf8a2a88f$var$call.bind($29b3598cf8a2a88f$var$call) : function() {
    return $29b3598cf8a2a88f$var$call.apply($29b3598cf8a2a88f$var$call, arguments);
};



var $b459ddaffbbda7ec$exports = {};
"use strict";
var $c79267720bb7c43c$exports = {};
"use strict";


var $c79267720bb7c43c$var$aFunction = function(argument) {
    return $cc96a210e25dba22$exports(argument) ? argument : undefined;
};
$c79267720bb7c43c$exports = function(namespace, method) {
    return arguments.length < 2 ? $c79267720bb7c43c$var$aFunction($54e13f33f64be1ee$exports[namespace]) : $54e13f33f64be1ee$exports[namespace] && $54e13f33f64be1ee$exports[namespace][method];
};



var $5da97af4e61f76a9$exports = {};
"use strict";

$5da97af4e61f76a9$exports = $97283d7e30dd0ca9$exports({}.isPrototypeOf);


var $79b56af06ab50834$exports = {};
"use strict";
var $7d60a8e5bf08933e$exports = {};
"use strict";
var $146e58e5f7900c9e$exports = {};
"use strict";

var $e8918cc7d66e6963$exports = {};
"use strict";
$e8918cc7d66e6963$exports = typeof navigator != "undefined" && String(navigator.userAgent) || "";


var $146e58e5f7900c9e$var$process = $54e13f33f64be1ee$exports.process;
var $146e58e5f7900c9e$var$Deno = $54e13f33f64be1ee$exports.Deno;
var $146e58e5f7900c9e$var$versions = $146e58e5f7900c9e$var$process && $146e58e5f7900c9e$var$process.versions || $146e58e5f7900c9e$var$Deno && $146e58e5f7900c9e$var$Deno.version;
var $146e58e5f7900c9e$var$v8 = $146e58e5f7900c9e$var$versions && $146e58e5f7900c9e$var$versions.v8;
var $146e58e5f7900c9e$var$match, $146e58e5f7900c9e$var$version;
if ($146e58e5f7900c9e$var$v8) {
    $146e58e5f7900c9e$var$match = $146e58e5f7900c9e$var$v8.split(".");
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $146e58e5f7900c9e$var$version = $146e58e5f7900c9e$var$match[0] > 0 && $146e58e5f7900c9e$var$match[0] < 4 ? 1 : +($146e58e5f7900c9e$var$match[0] + $146e58e5f7900c9e$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$146e58e5f7900c9e$var$version && $e8918cc7d66e6963$exports) {
    $146e58e5f7900c9e$var$match = $e8918cc7d66e6963$exports.match(/Edge\/(\d+)/);
    if (!$146e58e5f7900c9e$var$match || $146e58e5f7900c9e$var$match[1] >= 74) {
        $146e58e5f7900c9e$var$match = $e8918cc7d66e6963$exports.match(/Chrome\/(\d+)/);
        if ($146e58e5f7900c9e$var$match) $146e58e5f7900c9e$var$version = +$146e58e5f7900c9e$var$match[1];
    }
}
$146e58e5f7900c9e$exports = $146e58e5f7900c9e$var$version;




var $7d60a8e5bf08933e$var$$String = $54e13f33f64be1ee$exports.String;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
$7d60a8e5bf08933e$exports = !!Object.getOwnPropertySymbols && !$499dc2a41f52af84$exports(function() {
    var symbol = Symbol("symbol detection");
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
    // of course, fail.
    return !$7d60a8e5bf08933e$var$$String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $146e58e5f7900c9e$exports && $146e58e5f7900c9e$exports < 41;
});


$79b56af06ab50834$exports = $7d60a8e5bf08933e$exports && !Symbol.sham && typeof Symbol.iterator == "symbol";


var $b459ddaffbbda7ec$var$$Object = Object;
$b459ddaffbbda7ec$exports = $79b56af06ab50834$exports ? function(it) {
    return typeof it == "symbol";
} : function(it) {
    var $Symbol = $c79267720bb7c43c$exports("Symbol");
    return $cc96a210e25dba22$exports($Symbol) && $5da97af4e61f76a9$exports($Symbol.prototype, $b459ddaffbbda7ec$var$$Object(it));
};


var $1c65b73e534b26e0$exports = {};
"use strict";
var $8a339882022cc0dc$exports = {};
"use strict";

var $6720839d0baaffc4$exports = {};
"use strict";
var $6720839d0baaffc4$var$$String = String;
$6720839d0baaffc4$exports = function(argument) {
    try {
        return $6720839d0baaffc4$var$$String(argument);
    } catch (error) {
        return "Object";
    }
};


var $8a339882022cc0dc$var$$TypeError = TypeError;
// `Assert: IsCallable(argument) is true`
$8a339882022cc0dc$exports = function(argument) {
    if ($cc96a210e25dba22$exports(argument)) return argument;
    throw new $8a339882022cc0dc$var$$TypeError($6720839d0baaffc4$exports(argument) + " is not a function");
};



// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
$1c65b73e534b26e0$exports = function(V, P) {
    var func = V[P];
    return $0b474519da97b67f$exports(func) ? undefined : $8a339882022cc0dc$exports(func);
};


var $ab6d009a0dc66798$exports = {};
"use strict";



var $ab6d009a0dc66798$var$$TypeError = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
$ab6d009a0dc66798$exports = function(input, pref) {
    var fn, val;
    if (pref === "string" && $cc96a210e25dba22$exports(fn = input.toString) && !$0a98e8cd18e86b5f$exports(val = $29b3598cf8a2a88f$exports(fn, input))) return val;
    if ($cc96a210e25dba22$exports(fn = input.valueOf) && !$0a98e8cd18e86b5f$exports(val = $29b3598cf8a2a88f$exports(fn, input))) return val;
    if (pref !== "string" && $cc96a210e25dba22$exports(fn = input.toString) && !$0a98e8cd18e86b5f$exports(val = $29b3598cf8a2a88f$exports(fn, input))) return val;
    throw new $ab6d009a0dc66798$var$$TypeError("Can't convert object to primitive value");
};


var $8c2ace1008dc2c03$exports = {};
"use strict";

var $d1cb9ff5ef694e5e$exports = {};
"use strict";

$d1cb9ff5ef694e5e$exports = function(key, value) {
    return $f1b6ea46842ac698$exports[key] || ($f1b6ea46842ac698$exports[key] = value || {});
};



var $b86aeef394ee8ada$exports = {};
"use strict";

var $b86aeef394ee8ada$var$id = 0;
var $b86aeef394ee8ada$var$postfix = Math.random();
var $b86aeef394ee8ada$var$toString = $97283d7e30dd0ca9$exports(1.0.toString);
$b86aeef394ee8ada$exports = function(key) {
    return "Symbol(" + (key === undefined ? "" : key) + ")_" + $b86aeef394ee8ada$var$toString(++$b86aeef394ee8ada$var$id + $b86aeef394ee8ada$var$postfix, 36);
};




var $8c2ace1008dc2c03$var$Symbol = $54e13f33f64be1ee$exports.Symbol;
var $8c2ace1008dc2c03$var$WellKnownSymbolsStore = $d1cb9ff5ef694e5e$exports("wks");
var $8c2ace1008dc2c03$var$createWellKnownSymbol = $79b56af06ab50834$exports ? $8c2ace1008dc2c03$var$Symbol["for"] || $8c2ace1008dc2c03$var$Symbol : $8c2ace1008dc2c03$var$Symbol && $8c2ace1008dc2c03$var$Symbol.withoutSetter || $b86aeef394ee8ada$exports;
$8c2ace1008dc2c03$exports = function(name) {
    if (!$72a1af5443fcd78e$exports($8c2ace1008dc2c03$var$WellKnownSymbolsStore, name)) $8c2ace1008dc2c03$var$WellKnownSymbolsStore[name] = $7d60a8e5bf08933e$exports && $72a1af5443fcd78e$exports($8c2ace1008dc2c03$var$Symbol, name) ? $8c2ace1008dc2c03$var$Symbol[name] : $8c2ace1008dc2c03$var$createWellKnownSymbol("Symbol." + name);
    return $8c2ace1008dc2c03$var$WellKnownSymbolsStore[name];
};


var $939730f95e40d433$var$$TypeError = TypeError;
var $939730f95e40d433$var$TO_PRIMITIVE = $8c2ace1008dc2c03$exports("toPrimitive");
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
$939730f95e40d433$exports = function(input, pref) {
    if (!$0a98e8cd18e86b5f$exports(input) || $b459ddaffbbda7ec$exports(input)) return input;
    var exoticToPrim = $1c65b73e534b26e0$exports(input, $939730f95e40d433$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = "default";
        result = $29b3598cf8a2a88f$exports(exoticToPrim, input, pref);
        if (!$0a98e8cd18e86b5f$exports(result) || $b459ddaffbbda7ec$exports(result)) return result;
        throw new $939730f95e40d433$var$$TypeError("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = "number";
    return $ab6d009a0dc66798$exports(input, pref);
};



// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
$29fddb489ab41fa8$exports = function(argument) {
    var key = $939730f95e40d433$exports(argument, "string");
    return $b459ddaffbbda7ec$exports(key) ? key : key + "";
};


var $81a4a50564ee687b$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $81a4a50564ee687b$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $81a4a50564ee687b$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $81a4a50564ee687b$var$ENUMERABLE = "enumerable";
var $81a4a50564ee687b$var$CONFIGURABLE = "configurable";
var $81a4a50564ee687b$var$WRITABLE = "writable";
$81a4a50564ee687b$export$2d1720544b23b823 = $5a26683efafc8f53$exports ? $dfc9a68bfe178d6e$exports ? function defineProperty(O, P, Attributes) {
    $1cfdcb8afd61bc2c$exports(O);
    P = $29fddb489ab41fa8$exports(P);
    $1cfdcb8afd61bc2c$exports(Attributes);
    if (typeof O === "function" && P === "prototype" && "value" in Attributes && $81a4a50564ee687b$var$WRITABLE in Attributes && !Attributes[$81a4a50564ee687b$var$WRITABLE]) {
        var current = $81a4a50564ee687b$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$81a4a50564ee687b$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $81a4a50564ee687b$var$CONFIGURABLE in Attributes ? Attributes[$81a4a50564ee687b$var$CONFIGURABLE] : current[$81a4a50564ee687b$var$CONFIGURABLE],
                enumerable: $81a4a50564ee687b$var$ENUMERABLE in Attributes ? Attributes[$81a4a50564ee687b$var$ENUMERABLE] : current[$81a4a50564ee687b$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $81a4a50564ee687b$var$$defineProperty(O, P, Attributes);
} : $81a4a50564ee687b$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $1cfdcb8afd61bc2c$exports(O);
    P = $29fddb489ab41fa8$exports(P);
    $1cfdcb8afd61bc2c$exports(Attributes);
    if ($9b2f2febf93ea538$exports) try {
        return $81a4a50564ee687b$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ("get" in Attributes || "set" in Attributes) throw new $81a4a50564ee687b$var$$TypeError("Accessors not supported");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};


var $26212d496867782e$exports = {};
"use strict";
$26212d496867782e$exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};


$5e1d2d7a1a3c497e$exports = $5a26683efafc8f53$exports ? function(object, key, value) {
    return $81a4a50564ee687b$export$2d1720544b23b823(object, key, $26212d496867782e$exports(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};




var $d158c736b3b0aa56$exports = {};
"use strict";


var $d158c736b3b0aa56$var$keys = $d1cb9ff5ef694e5e$exports("keys");
$d158c736b3b0aa56$exports = function(key) {
    return $d158c736b3b0aa56$var$keys[key] || ($d158c736b3b0aa56$var$keys[key] = $b86aeef394ee8ada$exports(key));
};


var $fd01047612a5676f$exports = {};
"use strict";
$fd01047612a5676f$exports = {};


var $2a3d98c1d5808b15$var$OBJECT_ALREADY_INITIALIZED = "Object already initialized";
var $2a3d98c1d5808b15$var$TypeError = $54e13f33f64be1ee$exports.TypeError;
var $2a3d98c1d5808b15$var$WeakMap = $54e13f33f64be1ee$exports.WeakMap;
var $2a3d98c1d5808b15$var$set, $2a3d98c1d5808b15$var$get, $2a3d98c1d5808b15$var$has;
var $2a3d98c1d5808b15$var$enforce = function(it) {
    return $2a3d98c1d5808b15$var$has(it) ? $2a3d98c1d5808b15$var$get(it) : $2a3d98c1d5808b15$var$set(it, {});
};
var $2a3d98c1d5808b15$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$0a98e8cd18e86b5f$exports(it) || (state = $2a3d98c1d5808b15$var$get(it)).type !== TYPE) throw new $2a3d98c1d5808b15$var$TypeError("Incompatible receiver, " + TYPE + " required");
        return state;
    };
};
if ($b5b4b1da22fa85bd$exports || $f1b6ea46842ac698$exports.state) {
    var $2a3d98c1d5808b15$var$store = $f1b6ea46842ac698$exports.state || ($f1b6ea46842ac698$exports.state = new $2a3d98c1d5808b15$var$WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ $2a3d98c1d5808b15$var$store.get = $2a3d98c1d5808b15$var$store.get;
    $2a3d98c1d5808b15$var$store.has = $2a3d98c1d5808b15$var$store.has;
    $2a3d98c1d5808b15$var$store.set = $2a3d98c1d5808b15$var$store.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ $2a3d98c1d5808b15$var$set = function(it, metadata) {
        if ($2a3d98c1d5808b15$var$store.has(it)) throw new $2a3d98c1d5808b15$var$TypeError($2a3d98c1d5808b15$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $2a3d98c1d5808b15$var$store.set(it, metadata);
        return metadata;
    };
    $2a3d98c1d5808b15$var$get = function(it) {
        return $2a3d98c1d5808b15$var$store.get(it) || {};
    };
    $2a3d98c1d5808b15$var$has = function(it) {
        return $2a3d98c1d5808b15$var$store.has(it);
    };
} else {
    var $2a3d98c1d5808b15$var$STATE = $d158c736b3b0aa56$exports("state");
    $fd01047612a5676f$exports[$2a3d98c1d5808b15$var$STATE] = true;
    $2a3d98c1d5808b15$var$set = function(it, metadata) {
        if ($72a1af5443fcd78e$exports(it, $2a3d98c1d5808b15$var$STATE)) throw new $2a3d98c1d5808b15$var$TypeError($2a3d98c1d5808b15$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $5e1d2d7a1a3c497e$exports(it, $2a3d98c1d5808b15$var$STATE, metadata);
        return metadata;
    };
    $2a3d98c1d5808b15$var$get = function(it) {
        return $72a1af5443fcd78e$exports(it, $2a3d98c1d5808b15$var$STATE) ? it[$2a3d98c1d5808b15$var$STATE] : {};
    };
    $2a3d98c1d5808b15$var$has = function(it) {
        return $72a1af5443fcd78e$exports(it, $2a3d98c1d5808b15$var$STATE);
    };
}
$2a3d98c1d5808b15$exports = {
    set: $2a3d98c1d5808b15$var$set,
    get: $2a3d98c1d5808b15$var$get,
    has: $2a3d98c1d5808b15$var$has,
    enforce: $2a3d98c1d5808b15$var$enforce,
    getterFor: $2a3d98c1d5808b15$var$getterFor
};


var $1a6a38dc8724cd5b$var$enforceInternalState = $2a3d98c1d5808b15$exports.enforce;
var $1a6a38dc8724cd5b$var$getInternalState = $2a3d98c1d5808b15$exports.get;
var $1a6a38dc8724cd5b$var$$String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $1a6a38dc8724cd5b$var$defineProperty = Object.defineProperty;
var $1a6a38dc8724cd5b$var$stringSlice = $97283d7e30dd0ca9$exports("".slice);
var $1a6a38dc8724cd5b$var$replace = $97283d7e30dd0ca9$exports("".replace);
var $1a6a38dc8724cd5b$var$join = $97283d7e30dd0ca9$exports([].join);
var $1a6a38dc8724cd5b$var$CONFIGURABLE_LENGTH = $5a26683efafc8f53$exports && !$499dc2a41f52af84$exports(function() {
    return $1a6a38dc8724cd5b$var$defineProperty(function() {}, "length", {
        value: 8
    }).length !== 8;
});
var $1a6a38dc8724cd5b$var$TEMPLATE = String(String).split("String");
var $1a6a38dc8724cd5b$var$makeBuiltIn = $1a6a38dc8724cd5b$exports = function(value, name, options) {
    if ($1a6a38dc8724cd5b$var$stringSlice($1a6a38dc8724cd5b$var$$String(name), 0, 7) === "Symbol(") name = "[" + $1a6a38dc8724cd5b$var$replace($1a6a38dc8724cd5b$var$$String(name), /^Symbol\(([^)]*)\).*$/, "$1") + "]";
    if (options && options.getter) name = "get " + name;
    if (options && options.setter) name = "set " + name;
    if (!$72a1af5443fcd78e$exports(value, "name") || $1a6a38dc8724cd5b$require$CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
        if ($5a26683efafc8f53$exports) $1a6a38dc8724cd5b$var$defineProperty(value, "name", {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if ($1a6a38dc8724cd5b$var$CONFIGURABLE_LENGTH && options && $72a1af5443fcd78e$exports(options, "arity") && value.length !== options.arity) $1a6a38dc8724cd5b$var$defineProperty(value, "length", {
        value: options.arity
    });
    try {
        if (options && $72a1af5443fcd78e$exports(options, "constructor") && options.constructor) {
            if ($5a26683efafc8f53$exports) $1a6a38dc8724cd5b$var$defineProperty(value, "prototype", {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = $1a6a38dc8724cd5b$var$enforceInternalState(value);
    if (!$72a1af5443fcd78e$exports(state, "source")) state.source = $1a6a38dc8724cd5b$var$join($1a6a38dc8724cd5b$var$TEMPLATE, typeof name == "string" ? name : "");
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = $1a6a38dc8724cd5b$var$makeBuiltIn(function toString() {
    return $cc96a210e25dba22$exports(this) && $1a6a38dc8724cd5b$var$getInternalState(this).source || $dbbc9eaffa604d09$exports(this);
}, "toString");



$cbea80d6fef6e2ad$exports = function(target, name, descriptor) {
    if (descriptor.get) $1a6a38dc8724cd5b$exports(descriptor.get, name, {
        getter: true
    });
    if (descriptor.set) $1a6a38dc8724cd5b$exports(descriptor.set, name, {
        setter: true
    });
    return $81a4a50564ee687b$export$2d1720544b23b823(target, name, descriptor);
};


var $e8fc1b1c80d4dca0$exports = {};
"use strict";

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
$e8fc1b1c80d4dca0$exports = function() {
    var that = $1cfdcb8afd61bc2c$exports(this);
    var result = "";
    if (that.hasIndices) result += "d";
    if (that.global) result += "g";
    if (that.ignoreCase) result += "i";
    if (that.multiline) result += "m";
    if (that.dotAll) result += "s";
    if (that.unicode) result += "u";
    if (that.unicodeSets) result += "v";
    if (that.sticky) result += "y";
    return result;
};



// babel-minify and Closure Compiler transpiles RegExp('.', 'd') -> /./d and it causes SyntaxError
var $5804da1f2b5fb9a5$var$RegExp = $54e13f33f64be1ee$exports.RegExp;
var $5804da1f2b5fb9a5$var$RegExpPrototype = $5804da1f2b5fb9a5$var$RegExp.prototype;
var $5804da1f2b5fb9a5$var$FORCED = $5a26683efafc8f53$exports && $499dc2a41f52af84$exports(function() {
    var INDICES_SUPPORT = true;
    try {
        $5804da1f2b5fb9a5$var$RegExp(".", "d");
    } catch (error) {
        INDICES_SUPPORT = false;
    }
    var O = {};
    // modern V8 bug
    var calls = "";
    var expected = INDICES_SUPPORT ? "dgimsy" : "gimsy";
    var addGetter = function(key, chr) {
        // eslint-disable-next-line es/no-object-defineproperty -- safe
        Object.defineProperty(O, key, {
            get: function() {
                calls += chr;
                return true;
            }
        });
    };
    var pairs = {
        dotAll: "s",
        global: "g",
        ignoreCase: "i",
        multiline: "m",
        sticky: "y"
    };
    if (INDICES_SUPPORT) pairs.hasIndices = "d";
    for(var key in pairs)addGetter(key, pairs[key]);
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    var result = Object.getOwnPropertyDescriptor($5804da1f2b5fb9a5$var$RegExpPrototype, "flags").get.call(O);
    return result !== expected || calls !== expected;
});
// `RegExp.prototype.flags` getter
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
if ($5804da1f2b5fb9a5$var$FORCED) $cbea80d6fef6e2ad$exports($5804da1f2b5fb9a5$var$RegExpPrototype, "flags", {
    configurable: true,
    get: $e8fc1b1c80d4dca0$exports
});


"use strict";


var $f206884ead0dd1b9$exports = {};
"use strict";
var $c64c104d53bffa93$exports = {};
"use strict";
// eslint-disable-next-line es/no-typed-arrays -- safe
$c64c104d53bffa93$exports = typeof ArrayBuffer != "undefined" && typeof DataView != "undefined";







var $295b31a1e2977813$exports = {};
"use strict";
var $653ab3235233efed$exports = {};
"use strict";

var $653ab3235233efed$var$TO_STRING_TAG = $8c2ace1008dc2c03$exports("toStringTag");
var $653ab3235233efed$var$test = {};
$653ab3235233efed$var$test[$653ab3235233efed$var$TO_STRING_TAG] = "z";
$653ab3235233efed$exports = String($653ab3235233efed$var$test) === "[object z]";



var $481083f58985dae7$exports = {};
"use strict";

var $481083f58985dae7$var$toString = $97283d7e30dd0ca9$exports({}.toString);
var $481083f58985dae7$var$stringSlice = $97283d7e30dd0ca9$exports("".slice);
$481083f58985dae7$exports = function(it) {
    return $481083f58985dae7$var$stringSlice($481083f58985dae7$var$toString(it), 8, -1);
};



var $295b31a1e2977813$var$TO_STRING_TAG = $8c2ace1008dc2c03$exports("toStringTag");
var $295b31a1e2977813$var$$Object = Object;
// ES3 wrong here
var $295b31a1e2977813$var$CORRECT_ARGUMENTS = $481083f58985dae7$exports(function() {
    return arguments;
}()) === "Arguments";
// fallback for IE11 Script Access Denied error
var $295b31a1e2977813$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
$295b31a1e2977813$exports = $653ab3235233efed$exports ? $481083f58985dae7$exports : function(it) {
    var O, tag, result;
    return it === undefined ? "Undefined" : it === null ? "Null" : typeof (tag = $295b31a1e2977813$var$tryGet(O = $295b31a1e2977813$var$$Object(it), $295b31a1e2977813$var$TO_STRING_TAG)) == "string" ? tag : $295b31a1e2977813$var$CORRECT_ARGUMENTS ? $481083f58985dae7$exports(O) : (result = $481083f58985dae7$exports(O)) === "Object" && $cc96a210e25dba22$exports(O.callee) ? "Arguments" : result;
};




var $142756e6545d97bd$exports = {};
"use strict";




$142756e6545d97bd$exports = function(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if ($cc96a210e25dba22$exports(value)) $1a6a38dc8724cd5b$exports(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else $f709f760ebfea8d4$exports(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else $81a4a50564ee687b$export$2d1720544b23b823(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};




var $0e3db11b1e54ce56$exports = {};
"use strict";




var $91e9a6fd8090a5e9$exports = {};
"use strict";

$91e9a6fd8090a5e9$exports = !$499dc2a41f52af84$exports(function() {
    function F() {}
    F.prototype.constructor = null;
    // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
    return Object.getPrototypeOf(new F()) !== F.prototype;
});


var $0e3db11b1e54ce56$var$IE_PROTO = $d158c736b3b0aa56$exports("IE_PROTO");
var $0e3db11b1e54ce56$var$$Object = Object;
var $0e3db11b1e54ce56$var$ObjectPrototype = $0e3db11b1e54ce56$var$$Object.prototype;
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
$0e3db11b1e54ce56$exports = $91e9a6fd8090a5e9$exports ? $0e3db11b1e54ce56$var$$Object.getPrototypeOf : function(O) {
    var object = $483e3f8d0ab383ee$exports(O);
    if ($72a1af5443fcd78e$exports(object, $0e3db11b1e54ce56$var$IE_PROTO)) return object[$0e3db11b1e54ce56$var$IE_PROTO];
    var constructor = object.constructor;
    if ($cc96a210e25dba22$exports(constructor) && object instanceof constructor) return constructor.prototype;
    return object instanceof $0e3db11b1e54ce56$var$$Object ? $0e3db11b1e54ce56$var$ObjectPrototype : null;
};


var $cd698c3eb5248bf5$exports = {};
"use strict";
var $6fe8aa87b79f09ba$exports = {};
"use strict";


$6fe8aa87b79f09ba$exports = function(object, key, method) {
    try {
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        return $97283d7e30dd0ca9$exports($8a339882022cc0dc$exports(Object.getOwnPropertyDescriptor(object, key)[method]));
    } catch (error) {}
};




var $1231022f1b621269$exports = {};
"use strict";
var $5481df3d26d0904c$exports = {};
"use strict";

$5481df3d26d0904c$exports = function(argument) {
    return $0a98e8cd18e86b5f$exports(argument) || argument === null;
};


var $1231022f1b621269$var$$String = String;
var $1231022f1b621269$var$$TypeError = TypeError;
$1231022f1b621269$exports = function(argument) {
    if ($5481df3d26d0904c$exports(argument)) return argument;
    throw new $1231022f1b621269$var$$TypeError("Can't set " + $1231022f1b621269$var$$String(argument) + " as a prototype");
};


// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
$cd698c3eb5248bf5$exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
    var CORRECT_SETTER = false;
    var test = {};
    var setter;
    try {
        setter = $6fe8aa87b79f09ba$exports(Object.prototype, "__proto__", "set");
        setter(test, []);
        CORRECT_SETTER = test instanceof Array;
    } catch (error) {}
    return function setPrototypeOf(O, proto) {
        $ab9d518c84de69ff$exports(O);
        $1231022f1b621269$exports(proto);
        if (!$0a98e8cd18e86b5f$exports(O)) return O;
        if (CORRECT_SETTER) setter(O, proto);
        else O.__proto__ = proto;
        return O;
    };
}() : undefined);





var $f206884ead0dd1b9$var$enforceInternalState = $2a3d98c1d5808b15$exports.enforce;
var $f206884ead0dd1b9$var$getInternalState = $2a3d98c1d5808b15$exports.get;
var $f206884ead0dd1b9$var$Int8Array = $54e13f33f64be1ee$exports.Int8Array;
var $f206884ead0dd1b9$var$Int8ArrayPrototype = $f206884ead0dd1b9$var$Int8Array && $f206884ead0dd1b9$var$Int8Array.prototype;
var $f206884ead0dd1b9$var$Uint8ClampedArray = $54e13f33f64be1ee$exports.Uint8ClampedArray;
var $f206884ead0dd1b9$var$Uint8ClampedArrayPrototype = $f206884ead0dd1b9$var$Uint8ClampedArray && $f206884ead0dd1b9$var$Uint8ClampedArray.prototype;
var $f206884ead0dd1b9$var$TypedArray = $f206884ead0dd1b9$var$Int8Array && $0e3db11b1e54ce56$exports($f206884ead0dd1b9$var$Int8Array);
var $f206884ead0dd1b9$var$TypedArrayPrototype = $f206884ead0dd1b9$var$Int8ArrayPrototype && $0e3db11b1e54ce56$exports($f206884ead0dd1b9$var$Int8ArrayPrototype);
var $f206884ead0dd1b9$var$ObjectPrototype = Object.prototype;
var $f206884ead0dd1b9$var$TypeError = $54e13f33f64be1ee$exports.TypeError;
var $f206884ead0dd1b9$var$TO_STRING_TAG = $8c2ace1008dc2c03$exports("toStringTag");
var $f206884ead0dd1b9$var$TYPED_ARRAY_TAG = $b86aeef394ee8ada$exports("TYPED_ARRAY_TAG");
var $f206884ead0dd1b9$var$TYPED_ARRAY_CONSTRUCTOR = "TypedArrayConstructor";
// Fixing native typed arrays in Opera Presto crashes the browser, see #595
var $f206884ead0dd1b9$var$NATIVE_ARRAY_BUFFER_VIEWS = $c64c104d53bffa93$exports && !!$cd698c3eb5248bf5$exports && $295b31a1e2977813$exports($54e13f33f64be1ee$exports.opera) !== "Opera";
var $f206884ead0dd1b9$var$TYPED_ARRAY_TAG_REQUIRED = false;
var $f206884ead0dd1b9$var$NAME, $f206884ead0dd1b9$var$Constructor, $f206884ead0dd1b9$var$Prototype;
var $f206884ead0dd1b9$var$TypedArrayConstructorsList = {
    Int8Array: 1,
    Uint8Array: 1,
    Uint8ClampedArray: 1,
    Int16Array: 2,
    Uint16Array: 2,
    Int32Array: 4,
    Uint32Array: 4,
    Float32Array: 4,
    Float64Array: 8
};
var $f206884ead0dd1b9$var$BigIntArrayConstructorsList = {
    BigInt64Array: 8,
    BigUint64Array: 8
};
var $f206884ead0dd1b9$var$isView = function isView(it) {
    if (!$0a98e8cd18e86b5f$exports(it)) return false;
    var klass = $295b31a1e2977813$exports(it);
    return klass === "DataView" || $72a1af5443fcd78e$exports($f206884ead0dd1b9$var$TypedArrayConstructorsList, klass) || $72a1af5443fcd78e$exports($f206884ead0dd1b9$var$BigIntArrayConstructorsList, klass);
};
var $f206884ead0dd1b9$var$getTypedArrayConstructor = function(it) {
    var proto = $0e3db11b1e54ce56$exports(it);
    if (!$0a98e8cd18e86b5f$exports(proto)) return;
    var state = $f206884ead0dd1b9$var$getInternalState(proto);
    return state && $72a1af5443fcd78e$exports(state, $f206884ead0dd1b9$var$TYPED_ARRAY_CONSTRUCTOR) ? state[$f206884ead0dd1b9$var$TYPED_ARRAY_CONSTRUCTOR] : $f206884ead0dd1b9$var$getTypedArrayConstructor(proto);
};
var $f206884ead0dd1b9$var$isTypedArray = function(it) {
    if (!$0a98e8cd18e86b5f$exports(it)) return false;
    var klass = $295b31a1e2977813$exports(it);
    return $72a1af5443fcd78e$exports($f206884ead0dd1b9$var$TypedArrayConstructorsList, klass) || $72a1af5443fcd78e$exports($f206884ead0dd1b9$var$BigIntArrayConstructorsList, klass);
};
var $f206884ead0dd1b9$var$aTypedArray = function(it) {
    if ($f206884ead0dd1b9$var$isTypedArray(it)) return it;
    throw new $f206884ead0dd1b9$var$TypeError("Target is not a typed array");
};
var $f206884ead0dd1b9$var$aTypedArrayConstructor = function(C) {
    if ($cc96a210e25dba22$exports(C) && (!$cd698c3eb5248bf5$exports || $5da97af4e61f76a9$exports($f206884ead0dd1b9$var$TypedArray, C))) return C;
    throw new $f206884ead0dd1b9$var$TypeError($6720839d0baaffc4$exports(C) + " is not a typed array constructor");
};
var $f206884ead0dd1b9$var$exportTypedArrayMethod = function(KEY, property, forced, options) {
    if (!$5a26683efafc8f53$exports) return;
    if (forced) for(var ARRAY in $f206884ead0dd1b9$var$TypedArrayConstructorsList){
        var TypedArrayConstructor = $54e13f33f64be1ee$exports[ARRAY];
        if (TypedArrayConstructor && $72a1af5443fcd78e$exports(TypedArrayConstructor.prototype, KEY)) try {
            delete TypedArrayConstructor.prototype[KEY];
        } catch (error) {
            // old WebKit bug - some methods are non-configurable
            try {
                TypedArrayConstructor.prototype[KEY] = property;
            } catch (error2) {}
        }
    }
    if (!$f206884ead0dd1b9$var$TypedArrayPrototype[KEY] || forced) $142756e6545d97bd$exports($f206884ead0dd1b9$var$TypedArrayPrototype, KEY, forced ? property : $f206884ead0dd1b9$var$NATIVE_ARRAY_BUFFER_VIEWS && $f206884ead0dd1b9$var$Int8ArrayPrototype[KEY] || property, options);
};
var $f206884ead0dd1b9$var$exportTypedArrayStaticMethod = function(KEY, property, forced) {
    var ARRAY, TypedArrayConstructor;
    if (!$5a26683efafc8f53$exports) return;
    if ($cd698c3eb5248bf5$exports) {
        if (forced) for(ARRAY in $f206884ead0dd1b9$var$TypedArrayConstructorsList){
            TypedArrayConstructor = $54e13f33f64be1ee$exports[ARRAY];
            if (TypedArrayConstructor && $72a1af5443fcd78e$exports(TypedArrayConstructor, KEY)) try {
                delete TypedArrayConstructor[KEY];
            } catch (error) {}
        }
        if (!$f206884ead0dd1b9$var$TypedArray[KEY] || forced) // V8 ~ Chrome 49-50 `%TypedArray%` methods are non-writable non-configurable
        try {
            return $142756e6545d97bd$exports($f206884ead0dd1b9$var$TypedArray, KEY, forced ? property : $f206884ead0dd1b9$var$NATIVE_ARRAY_BUFFER_VIEWS && $f206884ead0dd1b9$var$TypedArray[KEY] || property);
        } catch (error) {}
        else return;
    }
    for(ARRAY in $f206884ead0dd1b9$var$TypedArrayConstructorsList){
        TypedArrayConstructor = $54e13f33f64be1ee$exports[ARRAY];
        if (TypedArrayConstructor && (!TypedArrayConstructor[KEY] || forced)) $142756e6545d97bd$exports(TypedArrayConstructor, KEY, property);
    }
};
for($f206884ead0dd1b9$var$NAME in $f206884ead0dd1b9$var$TypedArrayConstructorsList){
    $f206884ead0dd1b9$var$Constructor = $54e13f33f64be1ee$exports[$f206884ead0dd1b9$var$NAME];
    $f206884ead0dd1b9$var$Prototype = $f206884ead0dd1b9$var$Constructor && $f206884ead0dd1b9$var$Constructor.prototype;
    if ($f206884ead0dd1b9$var$Prototype) $f206884ead0dd1b9$var$enforceInternalState($f206884ead0dd1b9$var$Prototype)[$f206884ead0dd1b9$var$TYPED_ARRAY_CONSTRUCTOR] = $f206884ead0dd1b9$var$Constructor;
    else $f206884ead0dd1b9$var$NATIVE_ARRAY_BUFFER_VIEWS = false;
}
for($f206884ead0dd1b9$var$NAME in $f206884ead0dd1b9$var$BigIntArrayConstructorsList){
    $f206884ead0dd1b9$var$Constructor = $54e13f33f64be1ee$exports[$f206884ead0dd1b9$var$NAME];
    $f206884ead0dd1b9$var$Prototype = $f206884ead0dd1b9$var$Constructor && $f206884ead0dd1b9$var$Constructor.prototype;
    if ($f206884ead0dd1b9$var$Prototype) $f206884ead0dd1b9$var$enforceInternalState($f206884ead0dd1b9$var$Prototype)[$f206884ead0dd1b9$var$TYPED_ARRAY_CONSTRUCTOR] = $f206884ead0dd1b9$var$Constructor;
}
// WebKit bug - typed arrays constructors prototype is Object.prototype
if (!$f206884ead0dd1b9$var$NATIVE_ARRAY_BUFFER_VIEWS || !$cc96a210e25dba22$exports($f206884ead0dd1b9$var$TypedArray) || $f206884ead0dd1b9$var$TypedArray === Function.prototype) {
    // eslint-disable-next-line no-shadow -- safe
    $f206884ead0dd1b9$var$TypedArray = function TypedArray() {
        throw new $f206884ead0dd1b9$var$TypeError("Incorrect invocation");
    };
    if ($f206884ead0dd1b9$var$NATIVE_ARRAY_BUFFER_VIEWS) {
        for($f206884ead0dd1b9$var$NAME in $f206884ead0dd1b9$var$TypedArrayConstructorsList)if ($54e13f33f64be1ee$exports[$f206884ead0dd1b9$var$NAME]) $cd698c3eb5248bf5$exports($54e13f33f64be1ee$exports[$f206884ead0dd1b9$var$NAME], $f206884ead0dd1b9$var$TypedArray);
    }
}
if (!$f206884ead0dd1b9$var$NATIVE_ARRAY_BUFFER_VIEWS || !$f206884ead0dd1b9$var$TypedArrayPrototype || $f206884ead0dd1b9$var$TypedArrayPrototype === $f206884ead0dd1b9$var$ObjectPrototype) {
    $f206884ead0dd1b9$var$TypedArrayPrototype = $f206884ead0dd1b9$var$TypedArray.prototype;
    if ($f206884ead0dd1b9$var$NATIVE_ARRAY_BUFFER_VIEWS) {
        for($f206884ead0dd1b9$var$NAME in $f206884ead0dd1b9$var$TypedArrayConstructorsList)if ($54e13f33f64be1ee$exports[$f206884ead0dd1b9$var$NAME]) $cd698c3eb5248bf5$exports($54e13f33f64be1ee$exports[$f206884ead0dd1b9$var$NAME].prototype, $f206884ead0dd1b9$var$TypedArrayPrototype);
    }
}
// WebKit bug - one more object in Uint8ClampedArray prototype chain
if ($f206884ead0dd1b9$var$NATIVE_ARRAY_BUFFER_VIEWS && $0e3db11b1e54ce56$exports($f206884ead0dd1b9$var$Uint8ClampedArrayPrototype) !== $f206884ead0dd1b9$var$TypedArrayPrototype) $cd698c3eb5248bf5$exports($f206884ead0dd1b9$var$Uint8ClampedArrayPrototype, $f206884ead0dd1b9$var$TypedArrayPrototype);
if ($5a26683efafc8f53$exports && !$72a1af5443fcd78e$exports($f206884ead0dd1b9$var$TypedArrayPrototype, $f206884ead0dd1b9$var$TO_STRING_TAG)) {
    $f206884ead0dd1b9$var$TYPED_ARRAY_TAG_REQUIRED = true;
    $cbea80d6fef6e2ad$exports($f206884ead0dd1b9$var$TypedArrayPrototype, $f206884ead0dd1b9$var$TO_STRING_TAG, {
        configurable: true,
        get: function() {
            return $0a98e8cd18e86b5f$exports(this) ? this[$f206884ead0dd1b9$var$TYPED_ARRAY_TAG] : undefined;
        }
    });
    for($f206884ead0dd1b9$var$NAME in $f206884ead0dd1b9$var$TypedArrayConstructorsList)if ($54e13f33f64be1ee$exports[$f206884ead0dd1b9$var$NAME]) $5e1d2d7a1a3c497e$exports($54e13f33f64be1ee$exports[$f206884ead0dd1b9$var$NAME], $f206884ead0dd1b9$var$TYPED_ARRAY_TAG, $f206884ead0dd1b9$var$NAME);
}
$f206884ead0dd1b9$exports = {
    NATIVE_ARRAY_BUFFER_VIEWS: $f206884ead0dd1b9$var$NATIVE_ARRAY_BUFFER_VIEWS,
    TYPED_ARRAY_TAG: $f206884ead0dd1b9$var$TYPED_ARRAY_TAG_REQUIRED && $f206884ead0dd1b9$var$TYPED_ARRAY_TAG,
    aTypedArray: $f206884ead0dd1b9$var$aTypedArray,
    aTypedArrayConstructor: $f206884ead0dd1b9$var$aTypedArrayConstructor,
    exportTypedArrayMethod: $f206884ead0dd1b9$var$exportTypedArrayMethod,
    exportTypedArrayStaticMethod: $f206884ead0dd1b9$var$exportTypedArrayStaticMethod,
    getTypedArrayConstructor: $f206884ead0dd1b9$var$getTypedArrayConstructor,
    isView: $f206884ead0dd1b9$var$isView,
    isTypedArray: $f206884ead0dd1b9$var$isTypedArray,
    TypedArray: $f206884ead0dd1b9$var$TypedArray,
    TypedArrayPrototype: $f206884ead0dd1b9$var$TypedArrayPrototype
};


var $ead15e2cabad5f47$exports = {};
"use strict";
var $a66d138f5002d43b$exports = {};
"use strict";
var $06e70e620d248233$exports = {};
"use strict";
var $9b446a2445591d04$exports = {};
"use strict";
var $9b446a2445591d04$var$ceil = Math.ceil;
var $9b446a2445591d04$var$floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
$9b446a2445591d04$exports = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $9b446a2445591d04$var$floor : $9b446a2445591d04$var$ceil)(n);
};


// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
$06e70e620d248233$exports = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $9b446a2445591d04$exports(number);
};


var $a66d138f5002d43b$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
$a66d138f5002d43b$exports = function(argument) {
    var len = $06e70e620d248233$exports(argument);
    return len > 0 ? $a66d138f5002d43b$var$min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
$ead15e2cabad5f47$exports = function(obj) {
    return $a66d138f5002d43b$exports(obj.length);
};


var $92d452a06787d1f5$exports = {};
"use strict";
var $3c1c093ead3d403b$exports = {};
"use strict";

var $3c1c093ead3d403b$var$$RangeError = RangeError;
$3c1c093ead3d403b$exports = function(it) {
    var result = $06e70e620d248233$exports(it);
    if (result < 0) throw new $3c1c093ead3d403b$var$$RangeError("The argument can't be less than 0");
    return result;
};


var $92d452a06787d1f5$var$$RangeError = RangeError;
$92d452a06787d1f5$exports = function(it, BYTES) {
    var offset = $3c1c093ead3d403b$exports(it);
    if (offset % BYTES) throw new $92d452a06787d1f5$var$$RangeError("Wrong offset");
    return offset;
};




var $ae41c8b4f05fc605$var$RangeError = $54e13f33f64be1ee$exports.RangeError;
var $ae41c8b4f05fc605$var$Int8Array = $54e13f33f64be1ee$exports.Int8Array;
var $ae41c8b4f05fc605$var$Int8ArrayPrototype = $ae41c8b4f05fc605$var$Int8Array && $ae41c8b4f05fc605$var$Int8Array.prototype;
var $ae41c8b4f05fc605$var$$set = $ae41c8b4f05fc605$var$Int8ArrayPrototype && $ae41c8b4f05fc605$var$Int8ArrayPrototype.set;
var $ae41c8b4f05fc605$var$aTypedArray = $f206884ead0dd1b9$exports.aTypedArray;
var $ae41c8b4f05fc605$var$exportTypedArrayMethod = $f206884ead0dd1b9$exports.exportTypedArrayMethod;
var $ae41c8b4f05fc605$var$WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS = !$499dc2a41f52af84$exports(function() {
    // eslint-disable-next-line es/no-typed-arrays -- required for testing
    var array = new Uint8ClampedArray(2);
    $29b3598cf8a2a88f$exports($ae41c8b4f05fc605$var$$set, array, {
        length: 1,
        0: 3
    }, 1);
    return array[1] !== 3;
});
// https://bugs.chromium.org/p/v8/issues/detail?id=11294 and other
var $ae41c8b4f05fc605$var$TO_OBJECT_BUG = $ae41c8b4f05fc605$var$WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS && $f206884ead0dd1b9$exports.NATIVE_ARRAY_BUFFER_VIEWS && $499dc2a41f52af84$exports(function() {
    var array = new $ae41c8b4f05fc605$var$Int8Array(2);
    array.set(1);
    array.set("2", 1);
    return array[0] !== 0 || array[1] !== 2;
});
// `%TypedArray%.prototype.set` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.set
$ae41c8b4f05fc605$var$exportTypedArrayMethod("set", function set(arrayLike /* , offset */ ) {
    $ae41c8b4f05fc605$var$aTypedArray(this);
    var offset = $92d452a06787d1f5$exports(arguments.length > 1 ? arguments[1] : undefined, 1);
    var src = $483e3f8d0ab383ee$exports(arrayLike);
    if ($ae41c8b4f05fc605$var$WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS) return $29b3598cf8a2a88f$exports($ae41c8b4f05fc605$var$$set, this, src, offset);
    var length = this.length;
    var len = $ead15e2cabad5f47$exports(src);
    var index = 0;
    if (len + offset > length) throw new $ae41c8b4f05fc605$var$RangeError("Wrong length");
    while(index < len)this[offset + index] = src[index++];
}, !$ae41c8b4f05fc605$var$WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS || $ae41c8b4f05fc605$var$TO_OBJECT_BUG);


"use strict";
"use strict";
var $a9f898cbef3a1b61$exports = {};
"use strict";

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var $45ce0a9c54cf4e4f$export$2d1720544b23b823;
"use strict";


// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var $8db1a6afd2200543$export$2d1720544b23b823;
"use strict";
var $8db1a6afd2200543$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $8db1a6afd2200543$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $8db1a6afd2200543$var$NASHORN_BUG = $8db1a6afd2200543$var$getOwnPropertyDescriptor && !$8db1a6afd2200543$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
$8db1a6afd2200543$export$2d1720544b23b823 = $8db1a6afd2200543$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $8db1a6afd2200543$var$getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $8db1a6afd2200543$var$$propertyIsEnumerable;



var $5ff9c047d5022f28$exports = {};
"use strict";
var $abc8b1451bcf7f07$exports = {};
"use strict";



var $abc8b1451bcf7f07$var$$Object = Object;
var $abc8b1451bcf7f07$var$split = $97283d7e30dd0ca9$exports("".split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
$abc8b1451bcf7f07$exports = $499dc2a41f52af84$exports(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$abc8b1451bcf7f07$var$$Object("z").propertyIsEnumerable(0);
}) ? function(it) {
    return $481083f58985dae7$exports(it) === "String" ? $abc8b1451bcf7f07$var$split(it, "") : $abc8b1451bcf7f07$var$$Object(it);
} : $abc8b1451bcf7f07$var$$Object;



$5ff9c047d5022f28$exports = function(it) {
    return $abc8b1451bcf7f07$exports($ab9d518c84de69ff$exports(it));
};





// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $45ce0a9c54cf4e4f$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
$45ce0a9c54cf4e4f$export$2d1720544b23b823 = $5a26683efafc8f53$exports ? $45ce0a9c54cf4e4f$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $5ff9c047d5022f28$exports(O);
    P = $29fddb489ab41fa8$exports(P);
    if ($9b2f2febf93ea538$exports) try {
        return $45ce0a9c54cf4e4f$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($72a1af5443fcd78e$exports(O, P)) return $26212d496867782e$exports(!$29b3598cf8a2a88f$exports($8db1a6afd2200543$export$2d1720544b23b823, O, P), O[P]);
};


var $a9f898cbef3a1b61$require$getOwnPropertyDescriptor = $45ce0a9c54cf4e4f$export$2d1720544b23b823;



var $f139864e4d85b8fe$exports = {};
"use strict";

var $d2d0cd71845fe1b0$exports = {};
"use strict";


// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var $260e8b30170abdbe$export$2d1720544b23b823;
"use strict";
var $bbc6d06ee6f2a754$exports = {};
"use strict";



var $71380416ad504e31$exports = {};
"use strict";

var $43405878d8b18a14$exports = {};
"use strict";

var $43405878d8b18a14$var$max = Math.max;
var $43405878d8b18a14$var$min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
$43405878d8b18a14$exports = function(index, length) {
    var integer = $06e70e620d248233$exports(index);
    return integer < 0 ? $43405878d8b18a14$var$max(integer + length, 0) : $43405878d8b18a14$var$min(integer, length);
};



// `Array.prototype.{ indexOf, includes }` methods implementation
var $71380416ad504e31$var$createMethod = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $5ff9c047d5022f28$exports($this);
        var length = $ead15e2cabad5f47$exports(O);
        if (length === 0) return !IS_INCLUDES && -1;
        var index = $43405878d8b18a14$exports(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el !== el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value !== value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
$71380416ad504e31$exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $71380416ad504e31$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $71380416ad504e31$var$createMethod(false)
};


var $bbc6d06ee6f2a754$require$indexOf = $71380416ad504e31$exports.indexOf;

var $bbc6d06ee6f2a754$var$push = $97283d7e30dd0ca9$exports([].push);
$bbc6d06ee6f2a754$exports = function(object, names) {
    var O = $5ff9c047d5022f28$exports(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$72a1af5443fcd78e$exports($fd01047612a5676f$exports, key) && $72a1af5443fcd78e$exports(O, key) && $bbc6d06ee6f2a754$var$push(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($72a1af5443fcd78e$exports(O, key = names[i++])) ~$bbc6d06ee6f2a754$require$indexOf(result, key) || $bbc6d06ee6f2a754$var$push(result, key);
    return result;
};


var $b656ff3a0ca75027$exports = {};
"use strict";
// IE8- don't enum bug keys
$b656ff3a0ca75027$exports = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
];


var $260e8b30170abdbe$var$hiddenKeys = $b656ff3a0ca75027$exports.concat("length", "prototype");
$260e8b30170abdbe$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $bbc6d06ee6f2a754$exports(O, $260e8b30170abdbe$var$hiddenKeys);
};


// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var $6fa07a9ead6cb148$export$2d1720544b23b823;
"use strict";
$6fa07a9ead6cb148$export$2d1720544b23b823 = Object.getOwnPropertySymbols;



var $d2d0cd71845fe1b0$var$concat = $97283d7e30dd0ca9$exports([].concat);
// all object keys, includes non-enumerable and symbols
$d2d0cd71845fe1b0$exports = $c79267720bb7c43c$exports("Reflect", "ownKeys") || function ownKeys(it) {
    var keys = $260e8b30170abdbe$export$2d1720544b23b823($1cfdcb8afd61bc2c$exports(it));
    var getOwnPropertySymbols = $6fa07a9ead6cb148$export$2d1720544b23b823;
    return getOwnPropertySymbols ? $d2d0cd71845fe1b0$var$concat(keys, getOwnPropertySymbols(it)) : keys;
};




$f139864e4d85b8fe$exports = function(target, source, exceptions) {
    var keys = $d2d0cd71845fe1b0$exports(source);
    var defineProperty = $81a4a50564ee687b$export$2d1720544b23b823;
    var getOwnPropertyDescriptor = $45ce0a9c54cf4e4f$export$2d1720544b23b823;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$72a1af5443fcd78e$exports(target, key) && !(exceptions && $72a1af5443fcd78e$exports(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};


var $58d73197402776a5$exports = {};
"use strict";


var $58d73197402776a5$var$replacement = /#|\.prototype\./;
var $58d73197402776a5$var$isForced = function(feature, detection) {
    var value = $58d73197402776a5$var$data[$58d73197402776a5$var$normalize(feature)];
    return value === $58d73197402776a5$var$POLYFILL ? true : value === $58d73197402776a5$var$NATIVE ? false : $cc96a210e25dba22$exports(detection) ? $499dc2a41f52af84$exports(detection) : !!detection;
};
var $58d73197402776a5$var$normalize = $58d73197402776a5$var$isForced.normalize = function(string) {
    return String(string).replace($58d73197402776a5$var$replacement, ".").toLowerCase();
};
var $58d73197402776a5$var$data = $58d73197402776a5$var$isForced.data = {};
var $58d73197402776a5$var$NATIVE = $58d73197402776a5$var$isForced.NATIVE = "N";
var $58d73197402776a5$var$POLYFILL = $58d73197402776a5$var$isForced.POLYFILL = "P";
$58d73197402776a5$exports = $58d73197402776a5$var$isForced;


/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ $a9f898cbef3a1b61$exports = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $54e13f33f64be1ee$exports;
    else if (STATIC) target = $54e13f33f64be1ee$exports[TARGET] || $f709f760ebfea8d4$exports(TARGET, {});
    else target = $54e13f33f64be1ee$exports[TARGET] && $54e13f33f64be1ee$exports[TARGET].prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = $a9f898cbef3a1b61$require$getOwnPropertyDescriptor(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $58d73197402776a5$exports(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty == typeof targetProperty) continue;
            $f139864e4d85b8fe$exports(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $5e1d2d7a1a3c497e$exports(sourceProperty, "sham", true);
        $142756e6545d97bd$exports(target, key, sourceProperty, options);
    }
};





var $013bb8aa61fddc08$exports = {};
"use strict";
var $5eaa7110872ba45b$exports = {};
"use strict";
var $1ba5c747b98654f0$exports = {};
"use strict";


$1ba5c747b98654f0$exports = function(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if ($481083f58985dae7$exports(fn) === "Function") return $97283d7e30dd0ca9$exports(fn);
};




var $5eaa7110872ba45b$var$bind = $1ba5c747b98654f0$exports($1ba5c747b98654f0$exports.bind);
// optional / simple context binding
$5eaa7110872ba45b$exports = function(fn, that) {
    $8a339882022cc0dc$exports(fn);
    return that === undefined ? fn : $7f8fc9069c29a8c3$exports ? $5eaa7110872ba45b$var$bind(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};





var $61354d8462721ffc$exports = {};
"use strict";

var $d396b53aba9a102e$exports = {};
"use strict";
$d396b53aba9a102e$exports = {};


var $61354d8462721ffc$var$ITERATOR = $8c2ace1008dc2c03$exports("iterator");
var $61354d8462721ffc$var$ArrayPrototype = Array.prototype;
// check on default Array iterator
$61354d8462721ffc$exports = function(it) {
    return it !== undefined && ($d396b53aba9a102e$exports.Array === it || $61354d8462721ffc$var$ArrayPrototype[$61354d8462721ffc$var$ITERATOR] === it);
};




var $2be6c3d901766850$exports = {};
"use strict";




var $3d8b059d0d613c4d$exports = {};
"use strict";





var $3d8b059d0d613c4d$var$ITERATOR = $8c2ace1008dc2c03$exports("iterator");
$3d8b059d0d613c4d$exports = function(it) {
    if (!$0b474519da97b67f$exports(it)) return $1c65b73e534b26e0$exports(it, $3d8b059d0d613c4d$var$ITERATOR) || $1c65b73e534b26e0$exports(it, "@@iterator") || $d396b53aba9a102e$exports[$295b31a1e2977813$exports(it)];
};


var $2be6c3d901766850$var$$TypeError = TypeError;
$2be6c3d901766850$exports = function(argument, usingIterator) {
    var iteratorMethod = arguments.length < 2 ? $3d8b059d0d613c4d$exports(argument) : usingIterator;
    if ($8a339882022cc0dc$exports(iteratorMethod)) return $1cfdcb8afd61bc2c$exports($29b3598cf8a2a88f$exports(iteratorMethod, argument));
    throw new $2be6c3d901766850$var$$TypeError($6720839d0baaffc4$exports(argument) + " is not iterable");
};



var $c4dee435cf953cb3$exports = {};
"use strict";



$c4dee435cf953cb3$exports = function(iterator, kind, value) {
    var innerResult, innerError;
    $1cfdcb8afd61bc2c$exports(iterator);
    try {
        innerResult = $1c65b73e534b26e0$exports(iterator, "return");
        if (!innerResult) {
            if (kind === "throw") throw value;
            return value;
        }
        innerResult = $29b3598cf8a2a88f$exports(innerResult, iterator);
    } catch (error) {
        innerError = true;
        innerResult = error;
    }
    if (kind === "throw") throw value;
    if (innerError) throw innerResult;
    $1cfdcb8afd61bc2c$exports(innerResult);
    return value;
};


var $013bb8aa61fddc08$var$$TypeError = TypeError;
var $013bb8aa61fddc08$var$Result = function(stopped, result) {
    this.stopped = stopped;
    this.result = result;
};
var $013bb8aa61fddc08$var$ResultPrototype = $013bb8aa61fddc08$var$Result.prototype;
$013bb8aa61fddc08$exports = function(iterable, unboundFunction, options) {
    var that = options && options.that;
    var AS_ENTRIES = !!(options && options.AS_ENTRIES);
    var IS_RECORD = !!(options && options.IS_RECORD);
    var IS_ITERATOR = !!(options && options.IS_ITERATOR);
    var INTERRUPTED = !!(options && options.INTERRUPTED);
    var fn = $5eaa7110872ba45b$exports(unboundFunction, that);
    var iterator, iterFn, index, length, result, next, step;
    var stop = function(condition) {
        if (iterator) $c4dee435cf953cb3$exports(iterator, "normal", condition);
        return new $013bb8aa61fddc08$var$Result(true, condition);
    };
    var callFn = function(value) {
        if (AS_ENTRIES) {
            $1cfdcb8afd61bc2c$exports(value);
            return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
        }
        return INTERRUPTED ? fn(value, stop) : fn(value);
    };
    if (IS_RECORD) iterator = iterable.iterator;
    else if (IS_ITERATOR) iterator = iterable;
    else {
        iterFn = $3d8b059d0d613c4d$exports(iterable);
        if (!iterFn) throw new $013bb8aa61fddc08$var$$TypeError($6720839d0baaffc4$exports(iterable) + " is not iterable");
        // optimisation for array iterators
        if ($61354d8462721ffc$exports(iterFn)) {
            for(index = 0, length = $ead15e2cabad5f47$exports(iterable); length > index; index++){
                result = callFn(iterable[index]);
                if (result && $5da97af4e61f76a9$exports($013bb8aa61fddc08$var$ResultPrototype, result)) return result;
            }
            return new $013bb8aa61fddc08$var$Result(false);
        }
        iterator = $2be6c3d901766850$exports(iterable, iterFn);
    }
    next = IS_RECORD ? iterable.next : iterator.next;
    while(!(step = $29b3598cf8a2a88f$exports(next, iterator)).done){
        try {
            result = callFn(step.value);
        } catch (error) {
            $c4dee435cf953cb3$exports(iterator, "throw", error);
        }
        if (typeof result == "object" && result && $5da97af4e61f76a9$exports($013bb8aa61fddc08$var$ResultPrototype, result)) return result;
    }
    return new $013bb8aa61fddc08$var$Result(false);
};


var $b7f1c2fd4757f311$exports = {};
"use strict";

// eslint-disable-next-line es/no-map -- safe
var $b7f1c2fd4757f311$var$MapPrototype = Map.prototype;
$b7f1c2fd4757f311$exports = {
    // eslint-disable-next-line es/no-map -- safe
    Map: Map,
    set: $97283d7e30dd0ca9$exports($b7f1c2fd4757f311$var$MapPrototype.set),
    get: $97283d7e30dd0ca9$exports($b7f1c2fd4757f311$var$MapPrototype.get),
    has: $97283d7e30dd0ca9$exports($b7f1c2fd4757f311$var$MapPrototype.has),
    remove: $97283d7e30dd0ca9$exports($b7f1c2fd4757f311$var$MapPrototype["delete"]),
    proto: $b7f1c2fd4757f311$var$MapPrototype
};




var $a168a696d1044220$var$Map = $b7f1c2fd4757f311$exports.Map;
var $a168a696d1044220$var$has = $b7f1c2fd4757f311$exports.has;
var $a168a696d1044220$var$get = $b7f1c2fd4757f311$exports.get;
var $a168a696d1044220$var$set = $b7f1c2fd4757f311$exports.set;
var $a168a696d1044220$var$push = $97283d7e30dd0ca9$exports([].push);
var $a168a696d1044220$var$DOES_NOT_WORK_WITH_PRIMITIVES = $323e21026531e79f$exports || $499dc2a41f52af84$exports(function() {
    return $a168a696d1044220$var$Map.groupBy("ab", function(it) {
        return it;
    }).get("a").length !== 1;
});
// `Map.groupBy` method
// https://github.com/tc39/proposal-array-grouping
$a9f898cbef3a1b61$exports({
    target: "Map",
    stat: true,
    forced: $323e21026531e79f$exports || $a168a696d1044220$var$DOES_NOT_WORK_WITH_PRIMITIVES
}, {
    groupBy: function groupBy(items, callbackfn) {
        $ab9d518c84de69ff$exports(items);
        $8a339882022cc0dc$exports(callbackfn);
        var map = new $a168a696d1044220$var$Map();
        var k = 0;
        $013bb8aa61fddc08$exports(items, function(value) {
            var key = callbackfn(value, k++);
            if (!$a168a696d1044220$var$has(map, key)) $a168a696d1044220$var$set(map, key, [
                value
            ]);
            else $a168a696d1044220$var$push($a168a696d1044220$var$get(map, key), value);
        });
        return map;
    }
});




"use strict";

var $2667ca50883ac867$exports = {};
"use strict";
var $2217533aed19b047$exports = {};
"use strict";

$2217533aed19b047$exports = $54e13f33f64be1ee$exports;



var $18c18dc17fcf20a6$export$2d1720544b23b823;
"use strict";

$18c18dc17fcf20a6$export$2d1720544b23b823 = $8c2ace1008dc2c03$exports;



var $2667ca50883ac867$require$defineProperty = $81a4a50564ee687b$export$2d1720544b23b823;
$2667ca50883ac867$exports = function(NAME) {
    var Symbol = $2217533aed19b047$exports.Symbol || ($2217533aed19b047$exports.Symbol = {});
    if (!$72a1af5443fcd78e$exports(Symbol, NAME)) $2667ca50883ac867$require$defineProperty(Symbol, NAME, {
        value: $18c18dc17fcf20a6$export$2d1720544b23b823(NAME)
    });
};



var $32bfc247411452ef$require$defineProperty = $81a4a50564ee687b$export$2d1720544b23b823;

var $32bfc247411452ef$require$getOwnPropertyDescriptor = $45ce0a9c54cf4e4f$export$2d1720544b23b823;
var $32bfc247411452ef$var$Symbol = $54e13f33f64be1ee$exports.Symbol;
// `Symbol.dispose` well-known symbol
// https://github.com/tc39/proposal-explicit-resource-management
$2667ca50883ac867$exports("dispose");
if ($32bfc247411452ef$var$Symbol) {
    var $32bfc247411452ef$var$descriptor = $32bfc247411452ef$require$getOwnPropertyDescriptor($32bfc247411452ef$var$Symbol, "dispose");
    // workaround of NodeJS 20.4 bug
    // https://github.com/nodejs/node/issues/48699
    // and incorrect descriptor from some transpilers and userland helpers
    if ($32bfc247411452ef$var$descriptor.enumerable && $32bfc247411452ef$var$descriptor.configurable && $32bfc247411452ef$var$descriptor.writable) $32bfc247411452ef$require$defineProperty($32bfc247411452ef$var$Symbol, "dispose", {
        value: $32bfc247411452ef$var$descriptor.value,
        enumerable: false,
        configurable: false,
        writable: false
    });
}


"use strict";
"use strict";


var $50f925e7058db030$exports = {};
"use strict";

var $ad9959165e9a18f2$exports = {};
"use strict";

var $ad9959165e9a18f2$var$FunctionPrototype = Function.prototype;
var $ad9959165e9a18f2$var$apply = $ad9959165e9a18f2$var$FunctionPrototype.apply;
var $ad9959165e9a18f2$var$call = $ad9959165e9a18f2$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-reflect -- safe
$ad9959165e9a18f2$exports = typeof Reflect == "object" && Reflect.apply || ($7f8fc9069c29a8c3$exports ? $ad9959165e9a18f2$var$call.bind($ad9959165e9a18f2$var$apply) : function() {
    return $ad9959165e9a18f2$var$call.apply($ad9959165e9a18f2$var$apply, arguments);
});






var $bfe4e7a664fcb76e$exports = {};
"use strict";

$bfe4e7a664fcb76e$exports = $c79267720bb7c43c$exports("document", "documentElement");


var $385543826e3d67c8$exports = {};
"use strict";

$385543826e3d67c8$exports = $97283d7e30dd0ca9$exports([].slice);



var $6b6ad40bee8dcbad$exports = {};
"use strict";
var $6b6ad40bee8dcbad$var$$TypeError = TypeError;
$6b6ad40bee8dcbad$exports = function(passed, required) {
    if (passed < required) throw new $6b6ad40bee8dcbad$var$$TypeError("Not enough arguments");
    return passed;
};


var $c91994a689f6b37c$exports = {};
"use strict";

// eslint-disable-next-line redos/no-vulnerable -- safe
$c91994a689f6b37c$exports = /(?:ipad|iphone|ipod).*applewebkit/i.test($e8918cc7d66e6963$exports);


var $54f67c6d9e15c407$exports = {};
"use strict";


$54f67c6d9e15c407$exports = $481083f58985dae7$exports($54e13f33f64be1ee$exports.process) === "process";


var $50f925e7058db030$var$set = $54e13f33f64be1ee$exports.setImmediate;
var $50f925e7058db030$var$clear = $54e13f33f64be1ee$exports.clearImmediate;
var $50f925e7058db030$var$process = $54e13f33f64be1ee$exports.process;
var $50f925e7058db030$var$Dispatch = $54e13f33f64be1ee$exports.Dispatch;
var $50f925e7058db030$var$Function = $54e13f33f64be1ee$exports.Function;
var $50f925e7058db030$var$MessageChannel = $54e13f33f64be1ee$exports.MessageChannel;
var $50f925e7058db030$var$String = $54e13f33f64be1ee$exports.String;
var $50f925e7058db030$var$counter = 0;
var $50f925e7058db030$var$queue = {};
var $50f925e7058db030$var$ONREADYSTATECHANGE = "onreadystatechange";
var $50f925e7058db030$var$$location, $50f925e7058db030$var$defer, $50f925e7058db030$var$channel, $50f925e7058db030$var$port;
$499dc2a41f52af84$exports(function() {
    // Deno throws a ReferenceError on `location` access without `--location` flag
    $50f925e7058db030$var$$location = $54e13f33f64be1ee$exports.location;
});
var $50f925e7058db030$var$run = function(id) {
    if ($72a1af5443fcd78e$exports($50f925e7058db030$var$queue, id)) {
        var fn = $50f925e7058db030$var$queue[id];
        delete $50f925e7058db030$var$queue[id];
        fn();
    }
};
var $50f925e7058db030$var$runner = function(id) {
    return function() {
        $50f925e7058db030$var$run(id);
    };
};
var $50f925e7058db030$var$eventListener = function(event) {
    $50f925e7058db030$var$run(event.data);
};
var $50f925e7058db030$var$globalPostMessageDefer = function(id) {
    // old engines have not location.origin
    $54e13f33f64be1ee$exports.postMessage($50f925e7058db030$var$String(id), $50f925e7058db030$var$$location.protocol + "//" + $50f925e7058db030$var$$location.host);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!$50f925e7058db030$var$set || !$50f925e7058db030$var$clear) {
    $50f925e7058db030$var$set = function setImmediate(handler) {
        $6b6ad40bee8dcbad$exports(arguments.length, 1);
        var fn = $cc96a210e25dba22$exports(handler) ? handler : $50f925e7058db030$var$Function(handler);
        var args = $385543826e3d67c8$exports(arguments, 1);
        $50f925e7058db030$var$queue[++$50f925e7058db030$var$counter] = function() {
            $ad9959165e9a18f2$exports(fn, undefined, args);
        };
        $50f925e7058db030$var$defer($50f925e7058db030$var$counter);
        return $50f925e7058db030$var$counter;
    };
    $50f925e7058db030$var$clear = function clearImmediate(id) {
        delete $50f925e7058db030$var$queue[id];
    };
    // Node.js 0.8-
    if ($54f67c6d9e15c407$exports) $50f925e7058db030$var$defer = function(id) {
        $50f925e7058db030$var$process.nextTick($50f925e7058db030$var$runner(id));
    };
    else if ($50f925e7058db030$var$Dispatch && $50f925e7058db030$var$Dispatch.now) $50f925e7058db030$var$defer = function(id) {
        $50f925e7058db030$var$Dispatch.now($50f925e7058db030$var$runner(id));
    };
    else if ($50f925e7058db030$var$MessageChannel && !$c91994a689f6b37c$exports) {
        $50f925e7058db030$var$channel = new $50f925e7058db030$var$MessageChannel();
        $50f925e7058db030$var$port = $50f925e7058db030$var$channel.port2;
        $50f925e7058db030$var$channel.port1.onmessage = $50f925e7058db030$var$eventListener;
        $50f925e7058db030$var$defer = $5eaa7110872ba45b$exports($50f925e7058db030$var$port.postMessage, $50f925e7058db030$var$port);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if ($54e13f33f64be1ee$exports.addEventListener && $cc96a210e25dba22$exports($54e13f33f64be1ee$exports.postMessage) && !$54e13f33f64be1ee$exports.importScripts && $50f925e7058db030$var$$location && $50f925e7058db030$var$$location.protocol !== "file:" && !$499dc2a41f52af84$exports($50f925e7058db030$var$globalPostMessageDefer)) {
        $50f925e7058db030$var$defer = $50f925e7058db030$var$globalPostMessageDefer;
        $54e13f33f64be1ee$exports.addEventListener("message", $50f925e7058db030$var$eventListener, false);
    // IE8-
    } else if ($50f925e7058db030$var$ONREADYSTATECHANGE in $504371fda82e7133$exports("script")) $50f925e7058db030$var$defer = function(id) {
        $bfe4e7a664fcb76e$exports.appendChild($504371fda82e7133$exports("script"))[$50f925e7058db030$var$ONREADYSTATECHANGE] = function() {
            $bfe4e7a664fcb76e$exports.removeChild(this);
            $50f925e7058db030$var$run(id);
        };
    };
    else $50f925e7058db030$var$defer = function(id) {
        setTimeout($50f925e7058db030$var$runner(id), 0);
    };
}
$50f925e7058db030$exports = {
    set: $50f925e7058db030$var$set,
    clear: $50f925e7058db030$var$clear
};


var $bd9a1cf0597c5d3c$require$clearImmediate = $50f925e7058db030$exports.clear;
// `clearImmediate` method
// http://w3c.github.io/setImmediate/#si-clearImmediate
$a9f898cbef3a1b61$exports({
    global: true,
    bind: true,
    enumerable: true,
    forced: $54e13f33f64be1ee$exports.clearImmediate !== $bd9a1cf0597c5d3c$require$clearImmediate
}, {
    clearImmediate: $bd9a1cf0597c5d3c$require$clearImmediate
});


"use strict";



var $9764aaac1a243f3a$require$setTask = $50f925e7058db030$exports.set;
var $628d74d719c34b41$exports = {};
"use strict";



var $cf30a4a49de4b018$exports = {};
"use strict";
/* global Bun -- Bun case */ $cf30a4a49de4b018$exports = typeof Bun == "function" && Bun && typeof Bun.version == "string";





var $628d74d719c34b41$var$Function = $54e13f33f64be1ee$exports.Function;
// dirty IE9- and Bun 0.3.0- checks
var $628d74d719c34b41$var$WRAP = /MSIE .\./.test($e8918cc7d66e6963$exports) || $cf30a4a49de4b018$exports && function() {
    var version = $54e13f33f64be1ee$exports.Bun.version.split(".");
    return version.length < 3 || version[0] === "0" && (version[1] < 3 || version[1] === "3" && version[2] === "0");
}();
// IE9- / Bun 0.3.0- setTimeout / setInterval / setImmediate additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers
// https://github.com/oven-sh/bun/issues/1633
$628d74d719c34b41$exports = function(scheduler, hasTimeArg) {
    var firstParamIndex = hasTimeArg ? 2 : 1;
    return $628d74d719c34b41$var$WRAP ? function(handler, timeout /* , ...arguments */ ) {
        var boundArgs = $6b6ad40bee8dcbad$exports(arguments.length, 1) > firstParamIndex;
        var fn = $cc96a210e25dba22$exports(handler) ? handler : $628d74d719c34b41$var$Function(handler);
        var params = boundArgs ? $385543826e3d67c8$exports(arguments, firstParamIndex) : [];
        var callback = boundArgs ? function() {
            $ad9959165e9a18f2$exports(fn, this, params);
        } : fn;
        return hasTimeArg ? scheduler(callback, timeout) : scheduler(callback);
    } : scheduler;
};


// https://github.com/oven-sh/bun/issues/1633
var $9764aaac1a243f3a$var$setImmediate = $54e13f33f64be1ee$exports.setImmediate ? $628d74d719c34b41$exports($9764aaac1a243f3a$require$setTask, false) : $9764aaac1a243f3a$require$setTask;
// `setImmediate` method
// http://w3c.github.io/setImmediate/#si-setImmediate
$a9f898cbef3a1b61$exports({
    global: true,
    bind: true,
    enumerable: true,
    forced: $54e13f33f64be1ee$exports.setImmediate !== $9764aaac1a243f3a$var$setImmediate
}, {
    setImmediate: $9764aaac1a243f3a$var$setImmediate
});




var $225a69c41e277f4c$exports = {};
var $0687b27b1e881858$exports = {};

var $eZjDd = parcelRequire("eZjDd");
var $7c09081c5d311986$exports = {};

var $kWy0a = parcelRequire("kWy0a");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $7c09081c5d311986$var$now = function() {
    return $kWy0a.Date.now();
};
$7c09081c5d311986$exports = $7c09081c5d311986$var$now;


var $e9f6612c61d6c1e4$exports = {};
var $90a9c650b34f7322$exports = {};
var $bedd379dd49e0db3$exports = {};
/** Used to match a single whitespace character. */ var $bedd379dd49e0db3$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $bedd379dd49e0db3$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $bedd379dd49e0db3$var$reWhitespace.test(string.charAt(index)));
    return index;
}
$bedd379dd49e0db3$exports = $bedd379dd49e0db3$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $90a9c650b34f7322$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $90a9c650b34f7322$var$baseTrim(string) {
    return string ? string.slice(0, $bedd379dd49e0db3$exports(string) + 1).replace($90a9c650b34f7322$var$reTrimStart, "") : string;
}
$90a9c650b34f7322$exports = $90a9c650b34f7322$var$baseTrim;



var $eZjDd = parcelRequire("eZjDd");
var $4a79c599baf2b4db$exports = {};

var $ch48J = parcelRequire("ch48J");

var $bCo5h = parcelRequire("bCo5h");
/** `Object#toString` result references. */ var $4a79c599baf2b4db$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $4a79c599baf2b4db$var$isSymbol(value) {
    return typeof value == "symbol" || $bCo5h(value) && $ch48J(value) == $4a79c599baf2b4db$var$symbolTag;
}
$4a79c599baf2b4db$exports = $4a79c599baf2b4db$var$isSymbol;


/** Used as references for various `Number` constants. */ var $e9f6612c61d6c1e4$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $e9f6612c61d6c1e4$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $e9f6612c61d6c1e4$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $e9f6612c61d6c1e4$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $e9f6612c61d6c1e4$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $e9f6612c61d6c1e4$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($4a79c599baf2b4db$exports(value)) return $e9f6612c61d6c1e4$var$NAN;
    if ($eZjDd(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $eZjDd(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = $90a9c650b34f7322$exports(value);
    var isBinary = $e9f6612c61d6c1e4$var$reIsBinary.test(value);
    return isBinary || $e9f6612c61d6c1e4$var$reIsOctal.test(value) ? $e9f6612c61d6c1e4$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $e9f6612c61d6c1e4$var$reIsBadHex.test(value) ? $e9f6612c61d6c1e4$var$NAN : +value;
}
$e9f6612c61d6c1e4$exports = $e9f6612c61d6c1e4$var$toNumber;


/** Error message constants. */ var $0687b27b1e881858$var$FUNC_ERROR_TEXT = "Expected a function";
/* Built-in method references for those with the same name as other `lodash` methods. */ var $0687b27b1e881858$var$nativeMax = Math.max, $0687b27b1e881858$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $0687b27b1e881858$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($0687b27b1e881858$var$FUNC_ERROR_TEXT);
    wait = $e9f6612c61d6c1e4$exports(wait) || 0;
    if ($eZjDd(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $0687b27b1e881858$var$nativeMax($e9f6612c61d6c1e4$exports(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $0687b27b1e881858$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $7c09081c5d311986$exports();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($7c09081c5d311986$exports());
    }
    function debounced() {
        var time = $7c09081c5d311986$exports(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
$0687b27b1e881858$exports = $0687b27b1e881858$var$debounce;



var $eZjDd = parcelRequire("eZjDd");
/** Error message constants. */ var $225a69c41e277f4c$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $225a69c41e277f4c$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != "function") throw new TypeError($225a69c41e277f4c$var$FUNC_ERROR_TEXT);
    if ($eZjDd(options)) {
        leading = "leading" in options ? !!options.leading : leading;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    return $0687b27b1e881858$exports(func, wait, {
        "leading": leading,
        "maxWait": wait,
        "trailing": trailing
    });
}
$225a69c41e277f4c$exports = $225a69c41e277f4c$var$throttle;



var $c8e7279b4e2eb9b3$exports = {};
var $52dee674ab6cf934$exports = {};
var $9e4072e1588dc418$exports = {};
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $9e4072e1588dc418$var$identity(value) {
    return value;
}
$9e4072e1588dc418$exports = $9e4072e1588dc418$var$identity;


var $b8ff5e0817c4a7db$exports = {};
var $f0b7cae725cc66cc$exports = {};
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $f0b7cae725cc66cc$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
$f0b7cae725cc66cc$exports = $f0b7cae725cc66cc$var$apply;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $b8ff5e0817c4a7db$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $b8ff5e0817c4a7db$var$overRest(func, start, transform) {
    start = $b8ff5e0817c4a7db$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $b8ff5e0817c4a7db$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $f0b7cae725cc66cc$exports(func, this, otherArgs);
    };
}
$b8ff5e0817c4a7db$exports = $b8ff5e0817c4a7db$var$overRest;


var $b46bbf2e2e2b8a92$exports = {};
var $e2bfbe8dc06a9533$exports = {};
var $7721191008c46353$exports = {};
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $7721191008c46353$var$constant(value) {
    return function() {
        return value;
    };
}
$7721191008c46353$exports = $7721191008c46353$var$constant;



var $a4YUs = parcelRequire("a4YUs");

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $e2bfbe8dc06a9533$var$baseSetToString = !$a4YUs ? $9e4072e1588dc418$exports : function(func, string) {
    return $a4YUs(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": $7721191008c46353$exports(string),
        "writable": true
    });
};
$e2bfbe8dc06a9533$exports = $e2bfbe8dc06a9533$var$baseSetToString;


var $f8743e048ab40b59$exports = {};
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $f8743e048ab40b59$var$HOT_COUNT = 800, $f8743e048ab40b59$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $f8743e048ab40b59$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $f8743e048ab40b59$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $f8743e048ab40b59$var$nativeNow(), remaining = $f8743e048ab40b59$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $f8743e048ab40b59$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
$f8743e048ab40b59$exports = $f8743e048ab40b59$var$shortOut;


/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $b46bbf2e2e2b8a92$var$setToString = $f8743e048ab40b59$exports($e2bfbe8dc06a9533$exports);
$b46bbf2e2e2b8a92$exports = $b46bbf2e2e2b8a92$var$setToString;


/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $52dee674ab6cf934$var$baseRest(func, start) {
    return $b46bbf2e2e2b8a92$exports($b8ff5e0817c4a7db$exports(func, start, $9e4072e1588dc418$exports), func + "");
}
$52dee674ab6cf934$exports = $52dee674ab6cf934$var$baseRest;


var $ecb273f3e187f9b4$exports = {};
var $f83ec547fadf8edd$exports = {};
var $7f75a5b3fcc6cfb1$exports = {};
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $7f75a5b3fcc6cfb1$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
$7f75a5b3fcc6cfb1$exports = $7f75a5b3fcc6cfb1$var$arrayMap;


var $b6279e88621ca301$exports = {};
var $aae159a853b6ba1c$exports = {};
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $aae159a853b6ba1c$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
$aae159a853b6ba1c$exports = $aae159a853b6ba1c$var$baseFindIndex;


var $f4ea9d443731fbdf$exports = {};
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $f4ea9d443731fbdf$var$baseIsNaN(value) {
    return value !== value;
}
$f4ea9d443731fbdf$exports = $f4ea9d443731fbdf$var$baseIsNaN;


var $085ddf50d0a1c8f0$exports = {};
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $085ddf50d0a1c8f0$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
$085ddf50d0a1c8f0$exports = $085ddf50d0a1c8f0$var$strictIndexOf;


/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $b6279e88621ca301$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $085ddf50d0a1c8f0$exports(array, value, fromIndex) : $aae159a853b6ba1c$exports(array, $f4ea9d443731fbdf$exports, fromIndex);
}
$b6279e88621ca301$exports = $b6279e88621ca301$var$baseIndexOf;


var $394004082dba7e63$exports = {};
/**
 * This function is like `baseIndexOf` except that it accepts a comparator.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $394004082dba7e63$var$baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (comparator(array[index], value)) return index;
    }
    return -1;
}
$394004082dba7e63$exports = $394004082dba7e63$var$baseIndexOfWith;



var $bBLW9 = parcelRequire("bBLW9");

var $o1vzS = parcelRequire("o1vzS");
/** Used for built-in method references. */ var $f83ec547fadf8edd$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $f83ec547fadf8edd$var$splice = $f83ec547fadf8edd$var$arrayProto.splice;
/**
 * The base implementation of `_.pullAllBy` without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns `array`.
 */ function $f83ec547fadf8edd$var$basePullAll(array, values, iteratee, comparator) {
    var indexOf = comparator ? $394004082dba7e63$exports : $b6279e88621ca301$exports, index = -1, length = values.length, seen = array;
    if (array === values) values = $o1vzS(values);
    if (iteratee) seen = $7f75a5b3fcc6cfb1$exports(array, $bBLW9(iteratee));
    while(++index < length){
        var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
        while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
            if (seen !== array) $f83ec547fadf8edd$var$splice.call(seen, fromIndex, 1);
            $f83ec547fadf8edd$var$splice.call(array, fromIndex, 1);
        }
    }
    return array;
}
$f83ec547fadf8edd$exports = $f83ec547fadf8edd$var$basePullAll;


/**
 * This method is like `_.pull` except that it accepts an array of values to remove.
 *
 * **Note:** Unlike `_.difference`, this method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pullAll(array, ['a', 'c']);
 * console.log(array);
 * // => ['b', 'b']
 */ function $ecb273f3e187f9b4$var$pullAll(array, values) {
    return array && array.length && values && values.length ? $f83ec547fadf8edd$exports(array, values) : array;
}
$ecb273f3e187f9b4$exports = $ecb273f3e187f9b4$var$pullAll;


/**
 * Removes all given values from `array` using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
 * to remove elements from an array by predicate.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {...*} [values] The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pull(array, 'a', 'c');
 * console.log(array);
 * // => ['b', 'b']
 */ var $c8e7279b4e2eb9b3$var$pull = $52dee674ab6cf934$exports($ecb273f3e187f9b4$exports);
$c8e7279b4e2eb9b3$exports = $c8e7279b4e2eb9b3$var$pull;



var $8wu30 = parcelRequire("8wu30");
parcelRequire("bOEk0");

L.TileLayer.WMTS = L.TileLayer.extend({
    defaultWmtsParams: {
        service: "WMTS",
        request: "GetTile",
        version: "1.0.0",
        layers: "",
        styles: "",
        tilematrixSet: "",
        format: "image/jpeg"
    },
    initialize: function(url, options) {
        // (String, Object)
        this._url = url;
        var wmtsParams = L.extend({}, this.defaultWmtsParams);
        var tileSize = options.tileSize || this.options.tileSize;
        if (options.detectRetina && L.Browser.retina) wmtsParams.width = wmtsParams.height = tileSize * 2;
        else wmtsParams.width = wmtsParams.height = tileSize;
        for(var i in options)// all keys that are not TileLayer options go to WMTS params
        if (!this.options.hasOwnProperty(i) && i != "matrixIds") wmtsParams[i] = options[i];
        this.wmtsParams = wmtsParams;
        this.matrixIds = options.matrixIds || this.getDefaultMatrix();
        L.setOptions(this, options);
    },
    onAdd: function(map) {
        this._crs = this.options.crs || map.options.crs;
        L.TileLayer.prototype.onAdd.call(this, map);
    },
    getTileUrl: function(coords) {
        // (Point, Number) -> String
        var tileSize = this.options.tileSize;
        var nwPoint = coords.multiplyBy(tileSize);
        nwPoint.x += 1;
        nwPoint.y -= 1;
        var sePoint = nwPoint.add(new L.Point(tileSize, tileSize));
        var zoom = this._tileZoom;
        var nw = this._crs.project(this._map.unproject(nwPoint, zoom));
        var se = this._crs.project(this._map.unproject(sePoint, zoom));
        var tilewidth = se.x - nw.x;
        //zoom = this._map.getZoom();
        var ident = this.matrixIds[zoom].identifier;
        var tilematrix = this.wmtsParams.tilematrixSet + ":" + ident;
        var X0 = this.matrixIds[zoom].topLeftCorner.lng;
        var Y0 = this.matrixIds[zoom].topLeftCorner.lat;
        var tilecol = Math.floor((nw.x - X0) / tilewidth);
        var tilerow = -Math.floor((nw.y - Y0) / tilewidth);
        var url = L.Util.template(this._url, {
            s: this._getSubdomain(coords)
        });
        return url + L.Util.getParamString(this.wmtsParams, url) + "&tilematrix=" + tilematrix + "&tilerow=" + tilerow + "&tilecol=" + tilecol;
    },
    setParams: function(params, noRedraw) {
        L.extend(this.wmtsParams, params);
        if (!noRedraw) this.redraw();
        return this;
    },
    getDefaultMatrix: function() {
        /**
     * the matrix3857 represents the projection 
     * for in the IGN WMTS for the google coordinates.
     */ var matrixIds3857 = new Array(22);
        for(var i = 0; i < 22; i++)matrixIds3857[i] = {
            identifier: "" + i,
            topLeftCorner: new L.LatLng(20037508.3428, -20037508.3428)
        };
        return matrixIds3857;
    }
});
L.tileLayer.wmts = function(url, options) {
    return new L.TileLayer.WMTS(url, options);
};


var $9c08a8e498775e1b$exports = {};

(function(global, factory) {
    factory((parcelRequire("8wu30")));
})($9c08a8e498775e1b$exports, function(L$1) {
    "use strict";
    L$1 = L$1 && L$1.hasOwnProperty("default") ? L$1["default"] : L$1;
    // functional re-impl of L.Point.distanceTo,
    // with no dependency on Leaflet for easier testing
    function pointDistance(ptA, ptB) {
        var x = ptB.x - ptA.x;
        var y = ptB.y - ptA.y;
        return Math.sqrt(x * x + y * y);
    }
    var computeSegmentHeading = function computeSegmentHeading(a, b) {
        return (Math.atan2(b.y - a.y, b.x - a.x) * 180 / Math.PI + 90 + 360) % 360;
    };
    var asRatioToPathLength = function asRatioToPathLength(_ref, totalPathLength) {
        var value = _ref.value, isInPixels = _ref.isInPixels;
        return isInPixels ? value / totalPathLength : value;
    };
    function parseRelativeOrAbsoluteValue(value) {
        if (typeof value === "string" && value.indexOf("%") !== -1) return {
            value: parseFloat(value) / 100,
            isInPixels: false
        };
        var parsedValue = value ? parseFloat(value) : 0;
        return {
            value: parsedValue,
            isInPixels: parsedValue > 0
        };
    }
    var pointsEqual = function pointsEqual(a, b) {
        return a.x === b.x && a.y === b.y;
    };
    function pointsToSegments(pts) {
        return pts.reduce(function(segments, b, idx, points) {
            // this test skips same adjacent points
            if (idx > 0 && !pointsEqual(b, points[idx - 1])) {
                var a = points[idx - 1];
                var distA = segments.length > 0 ? segments[segments.length - 1].distB : 0;
                var distAB = pointDistance(a, b);
                segments.push({
                    a: a,
                    b: b,
                    distA: distA,
                    distB: distA + distAB,
                    heading: computeSegmentHeading(a, b)
                });
            }
            return segments;
        }, []);
    }
    function projectPatternOnPointPath(pts, pattern) {
        // 1. split the path into segment infos
        var segments = pointsToSegments(pts);
        var nbSegments = segments.length;
        if (nbSegments === 0) return [];
        var totalPathLength = segments[nbSegments - 1].distB;
        var offset = asRatioToPathLength(pattern.offset, totalPathLength);
        var endOffset = asRatioToPathLength(pattern.endOffset, totalPathLength);
        var repeat = asRatioToPathLength(pattern.repeat, totalPathLength);
        var repeatIntervalPixels = totalPathLength * repeat;
        var startOffsetPixels = offset > 0 ? totalPathLength * offset : 0;
        var endOffsetPixels = endOffset > 0 ? totalPathLength * endOffset : 0;
        // 2. generate the positions of the pattern as offsets from the path start
        var positionOffsets = [];
        var positionOffset = startOffsetPixels;
        do {
            positionOffsets.push(positionOffset);
            positionOffset += repeatIntervalPixels;
        }while (repeatIntervalPixels > 0 && positionOffset < totalPathLength - endOffsetPixels);
        // 3. projects offsets to segments
        var segmentIndex = 0;
        var segment = segments[0];
        return positionOffsets.map(function(positionOffset) {
            // find the segment matching the offset,
            // starting from the previous one as offsets are ordered
            while(positionOffset > segment.distB && segmentIndex < nbSegments - 1){
                segmentIndex++;
                segment = segments[segmentIndex];
            }
            var segmentRatio = (positionOffset - segment.distA) / (segment.distB - segment.distA);
            return {
                pt: interpolateBetweenPoints(segment.a, segment.b, segmentRatio),
                heading: segment.heading
            };
        });
    }
    /**
* Finds the point which lies on the segment defined by points A and B,
* at the given ratio of the distance from A to B, by linear interpolation.
*/ function interpolateBetweenPoints(ptA, ptB, ratio) {
        if (ptB.x !== ptA.x) return {
            x: ptA.x + ratio * (ptB.x - ptA.x),
            y: ptA.y + ratio * (ptB.y - ptA.y)
        };
        // special case where points lie on the same vertical axis
        return {
            x: ptA.x,
            y: ptA.y + (ptB.y - ptA.y) * ratio
        };
    }
    (function() {
        // save these original methods before they are overwritten
        var proto_initIcon = L.Marker.prototype._initIcon;
        var proto_setPos = L.Marker.prototype._setPos;
        var oldIE = L.DomUtil.TRANSFORM === "msTransform";
        L.Marker.addInitHook(function() {
            var iconOptions = this.options.icon && this.options.icon.options;
            var iconAnchor = iconOptions && this.options.icon.options.iconAnchor;
            if (iconAnchor) iconAnchor = iconAnchor[0] + "px " + iconAnchor[1] + "px";
            this.options.rotationOrigin = this.options.rotationOrigin || iconAnchor || "center bottom";
            this.options.rotationAngle = this.options.rotationAngle || 0;
            // Ensure marker keeps rotated during dragging
            this.on("drag", function(e) {
                e.target._applyRotation();
            });
        });
        L.Marker.include({
            _initIcon: function() {
                proto_initIcon.call(this);
            },
            _setPos: function(pos) {
                proto_setPos.call(this, pos);
                this._applyRotation();
            },
            _applyRotation: function() {
                if (this.options.rotationAngle) {
                    this._icon.style[L.DomUtil.TRANSFORM + "Origin"] = this.options.rotationOrigin;
                    if (oldIE) // for IE 9, use the 2D rotation
                    this._icon.style[L.DomUtil.TRANSFORM] = "rotate(" + this.options.rotationAngle + "deg)";
                    else // for modern browsers, prefer the 3D accelerated version
                    this._icon.style[L.DomUtil.TRANSFORM] += " rotateZ(" + this.options.rotationAngle + "deg)";
                }
            },
            setRotationAngle: function(angle) {
                this.options.rotationAngle = angle;
                this.update();
                return this;
            },
            setRotationOrigin: function(origin) {
                this.options.rotationOrigin = origin;
                this.update();
                return this;
            }
        });
    })();
    L$1.Symbol = L$1.Symbol || {};
    /**
* A simple dash symbol, drawn as a Polyline.
* Can also be used for dots, if 'pixelSize' option is given the 0 value.
*/ L$1.Symbol.Dash = L$1.Class.extend({
        options: {
            pixelSize: 10,
            pathOptions: {}
        },
        initialize: function initialize(options) {
            L$1.Util.setOptions(this, options);
            this.options.pathOptions.clickable = false;
        },
        buildSymbol: function buildSymbol(dirPoint, latLngs, map, index, total) {
            var opts = this.options;
            var d2r = Math.PI / 180;
            // for a dot, nothing more to compute
            if (opts.pixelSize <= 1) return L$1.polyline([
                dirPoint.latLng,
                dirPoint.latLng
            ], opts.pathOptions);
            var midPoint = map.project(dirPoint.latLng);
            var angle = -(dirPoint.heading - 90) * d2r;
            var a = L$1.point(midPoint.x + opts.pixelSize * Math.cos(angle + Math.PI) / 2, midPoint.y + opts.pixelSize * Math.sin(angle) / 2);
            // compute second point by central symmetry to avoid unecessary cos/sin
            var b = midPoint.add(midPoint.subtract(a));
            return L$1.polyline([
                map.unproject(a),
                map.unproject(b)
            ], opts.pathOptions);
        }
    });
    L$1.Symbol.dash = function(options) {
        return new L$1.Symbol.Dash(options);
    };
    L$1.Symbol.ArrowHead = L$1.Class.extend({
        options: {
            polygon: true,
            pixelSize: 10,
            headAngle: 60,
            pathOptions: {
                stroke: false,
                weight: 2
            }
        },
        initialize: function initialize(options) {
            L$1.Util.setOptions(this, options);
            this.options.pathOptions.clickable = false;
        },
        buildSymbol: function buildSymbol(dirPoint, latLngs, map, index, total) {
            return this.options.polygon ? L$1.polygon(this._buildArrowPath(dirPoint, map), this.options.pathOptions) : L$1.polyline(this._buildArrowPath(dirPoint, map), this.options.pathOptions);
        },
        _buildArrowPath: function _buildArrowPath(dirPoint, map) {
            var d2r = Math.PI / 180;
            var tipPoint = map.project(dirPoint.latLng);
            var direction = -(dirPoint.heading - 90) * d2r;
            var radianArrowAngle = this.options.headAngle / 2 * d2r;
            var headAngle1 = direction + radianArrowAngle;
            var headAngle2 = direction - radianArrowAngle;
            var arrowHead1 = L$1.point(tipPoint.x - this.options.pixelSize * Math.cos(headAngle1), tipPoint.y + this.options.pixelSize * Math.sin(headAngle1));
            var arrowHead2 = L$1.point(tipPoint.x - this.options.pixelSize * Math.cos(headAngle2), tipPoint.y + this.options.pixelSize * Math.sin(headAngle2));
            return [
                map.unproject(arrowHead1),
                dirPoint.latLng,
                map.unproject(arrowHead2)
            ];
        }
    });
    L$1.Symbol.arrowHead = function(options) {
        return new L$1.Symbol.ArrowHead(options);
    };
    L$1.Symbol.Marker = L$1.Class.extend({
        options: {
            markerOptions: {},
            rotate: false
        },
        initialize: function initialize(options) {
            L$1.Util.setOptions(this, options);
            this.options.markerOptions.clickable = false;
            this.options.markerOptions.draggable = false;
        },
        buildSymbol: function buildSymbol(directionPoint, latLngs, map, index, total) {
            if (this.options.rotate) this.options.markerOptions.rotationAngle = directionPoint.heading + (this.options.angleCorrection || 0);
            return L$1.marker(directionPoint.latLng, this.options.markerOptions);
        }
    });
    L$1.Symbol.marker = function(options) {
        return new L$1.Symbol.Marker(options);
    };
    var isCoord = function isCoord(c) {
        return c instanceof L$1.LatLng || Array.isArray(c) && c.length === 2 && typeof c[0] === "number";
    };
    var isCoordArray = function isCoordArray(ll) {
        return Array.isArray(ll) && isCoord(ll[0]);
    };
    L$1.PolylineDecorator = L$1.FeatureGroup.extend({
        options: {
            patterns: []
        },
        initialize: function initialize(paths, options) {
            L$1.FeatureGroup.prototype.initialize.call(this);
            L$1.Util.setOptions(this, options);
            this._map = null;
            this._paths = this._initPaths(paths);
            this._bounds = this._initBounds();
            this._patterns = this._initPatterns(this.options.patterns);
        },
        /**
    * Deals with all the different cases. input can be one of these types:
    * array of LatLng, array of 2-number arrays, Polyline, Polygon,
    * array of one of the previous.
    */ _initPaths: function _initPaths(input, isPolygon) {
            var _this = this;
            if (isCoordArray(input)) {
                // Leaflet Polygons don't need the first point to be repeated, but we do
                var coords = isPolygon ? input.concat([
                    input[0]
                ]) : input;
                return [
                    coords
                ];
            }
            if (input instanceof L$1.Polyline) // we need some recursivity to support multi-poly*
            return this._initPaths(input.getLatLngs(), input instanceof L$1.Polygon);
            if (Array.isArray(input)) // flatten everything, we just need coordinate lists to apply patterns
            return input.reduce(function(flatArray, p) {
                return flatArray.concat(_this._initPaths(p, isPolygon));
            }, []);
            return [];
        },
        // parse pattern definitions and precompute some values
        _initPatterns: function _initPatterns(patternDefs) {
            return patternDefs.map(this._parsePatternDef);
        },
        /**
    * Changes the patterns used by this decorator
    * and redraws the new one.
    */ setPatterns: function setPatterns(patterns) {
            this.options.patterns = patterns;
            this._patterns = this._initPatterns(this.options.patterns);
            this.redraw();
        },
        /**
    * Changes the patterns used by this decorator
    * and redraws the new one.
    */ setPaths: function setPaths(paths) {
            this._paths = this._initPaths(paths);
            this._bounds = this._initBounds();
            this.redraw();
        },
        /**
    * Parse the pattern definition
    */ _parsePatternDef: function _parsePatternDef(patternDef, latLngs) {
            return {
                symbolFactory: patternDef.symbol,
                // Parse offset and repeat values, managing the two cases:
                // absolute (in pixels) or relative (in percentage of the polyline length)
                offset: parseRelativeOrAbsoluteValue(patternDef.offset),
                endOffset: parseRelativeOrAbsoluteValue(patternDef.endOffset),
                repeat: parseRelativeOrAbsoluteValue(patternDef.repeat)
            };
        },
        onAdd: function onAdd(map) {
            this._map = map;
            this._draw();
            this._map.on("moveend", this.redraw, this);
        },
        onRemove: function onRemove(map) {
            this._map.off("moveend", this.redraw, this);
            this._map = null;
            L$1.FeatureGroup.prototype.onRemove.call(this, map);
        },
        /**
    * As real pattern bounds depends on map zoom and bounds,
    * we just compute the total bounds of all paths decorated by this instance.
    */ _initBounds: function _initBounds() {
            var allPathCoords = this._paths.reduce(function(acc, path) {
                return acc.concat(path);
            }, []);
            return L$1.latLngBounds(allPathCoords);
        },
        getBounds: function getBounds() {
            return this._bounds;
        },
        /**
    * Returns an array of ILayers object
    */ _buildSymbols: function _buildSymbols(latLngs, symbolFactory, directionPoints) {
            var _this2 = this;
            return directionPoints.map(function(directionPoint, i) {
                return symbolFactory.buildSymbol(directionPoint, latLngs, _this2._map, i, directionPoints.length);
            });
        },
        /**
    * Compute pairs of LatLng and heading angle,
    * that define positions and directions of the symbols on the path
    */ _getDirectionPoints: function _getDirectionPoints(latLngs, pattern) {
            var _this3 = this;
            if (latLngs.length < 2) return [];
            var pathAsPoints = latLngs.map(function(latLng) {
                return _this3._map.project(latLng);
            });
            return projectPatternOnPointPath(pathAsPoints, pattern).map(function(point) {
                return {
                    latLng: _this3._map.unproject(L$1.point(point.pt)),
                    heading: point.heading
                };
            });
        },
        redraw: function redraw() {
            if (!this._map) return;
            this.clearLayers();
            this._draw();
        },
        /**
    * Returns all symbols for a given pattern as an array of FeatureGroup
    */ _getPatternLayers: function _getPatternLayers(pattern) {
            var _this4 = this;
            var mapBounds = this._map.getBounds().pad(0.1);
            return this._paths.map(function(path) {
                var directionPoints = _this4._getDirectionPoints(path, pattern)// filter out invisible points
                .filter(function(point) {
                    return mapBounds.contains(point.latLng);
                });
                return L$1.featureGroup(_this4._buildSymbols(path, pattern.symbolFactory, directionPoints));
            });
        },
        /**
    * Draw all patterns
    */ _draw: function _draw() {
            var _this5 = this;
            this._patterns.map(function(pattern) {
                return _this5._getPatternLayers(pattern);
            }).forEach(function(layers) {
                _this5.addLayer(L$1.featureGroup(layers));
            });
        }
    });
    /*
 * Allows compact syntax to be used
 */ L$1.polylineDecorator = function(paths, options) {
        return new L$1.PolylineDecorator(paths, options);
    };
});


var $dc7bd81a7a5a6a8e$exports = {};

(function(root, factory) {
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define([
        "leaflet"
    ], factory);
    else if (typeof modules === "object" && $dc7bd81a7a5a6a8e$exports) // define a Common JS module that relies on 'leaflet'
    $dc7bd81a7a5a6a8e$exports = factory((parcelRequire("8wu30")));
    else // Assume Leaflet is loaded into global object L already
    factory(L);
})($dc7bd81a7a5a6a8e$exports, function(L1) {
    "use strict";
    L1.TileLayer.Provider = L1.TileLayer.extend({
        initialize: function(arg, options) {
            var providers = L1.TileLayer.Provider.providers;
            var parts = arg.split(".");
            var providerName = parts[0];
            var variantName = parts[1];
            if (!providers[providerName]) throw "No such provider (" + providerName + ")";
            var provider = {
                url: providers[providerName].url,
                options: providers[providerName].options
            };
            // overwrite values in provider from variant.
            if (variantName && "variants" in providers[providerName]) {
                if (!(variantName in providers[providerName].variants)) throw "No such variant of " + providerName + " (" + variantName + ")";
                var variant = providers[providerName].variants[variantName];
                var variantOptions;
                if (typeof variant === "string") variantOptions = {
                    variant: variant
                };
                else variantOptions = variant.options;
                provider = {
                    url: variant.url || provider.url,
                    options: L1.Util.extend({}, provider.options, variantOptions)
                };
            }
            // replace attribution placeholders with their values from toplevel provider attribution,
            // recursively
            var attributionReplacer = function(attr) {
                if (attr.indexOf("{attribution.") === -1) return attr;
                return attr.replace(/\{attribution.(\w*)\}/g, function(match, attributionName) {
                    return attributionReplacer(providers[attributionName].options.attribution);
                });
            };
            provider.options.attribution = attributionReplacer(provider.options.attribution);
            // Compute final options combining provider options with any user overrides
            var layerOpts = L1.Util.extend({}, provider.options, options);
            L1.TileLayer.prototype.initialize.call(this, provider.url, layerOpts);
        }
    });
    /**
	 * Definition of providers.
	 * see http://leafletjs.com/reference.html#tilelayer for options in the options map.
	 */ L1.TileLayer.Provider.providers = {
        OpenStreetMap: {
            url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
            options: {
                maxZoom: 19,
                attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            },
            variants: {
                Mapnik: {},
                DE: {
                    url: "https://{s}.tile.openstreetmap.de/tiles/osmde/{z}/{x}/{y}.png",
                    options: {
                        maxZoom: 18
                    }
                },
                CH: {
                    url: "https://tile.osm.ch/switzerland/{z}/{x}/{y}.png",
                    options: {
                        maxZoom: 18,
                        bounds: [
                            [
                                45,
                                5
                            ],
                            [
                                48,
                                11
                            ]
                        ]
                    }
                },
                France: {
                    url: "https://{s}.tile.openstreetmap.fr/osmfr/{z}/{x}/{y}.png",
                    options: {
                        maxZoom: 20,
                        attribution: "&copy; Openstreetmap France | {attribution.OpenStreetMap}"
                    }
                },
                HOT: {
                    url: "https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png",
                    options: {
                        attribution: '{attribution.OpenStreetMap}, Tiles style by <a href="https://www.hotosm.org/" target="_blank">Humanitarian OpenStreetMap Team</a> hosted by <a href="https://openstreetmap.fr/" target="_blank">OpenStreetMap France</a>'
                    }
                },
                BZH: {
                    url: "https://tile.openstreetmap.bzh/br/{z}/{x}/{y}.png",
                    options: {
                        attribution: '{attribution.OpenStreetMap}, Tiles courtesy of <a href="http://www.openstreetmap.bzh/" target="_blank">Breton OpenStreetMap Team</a>',
                        bounds: [
                            [
                                46.2,
                                -5.5
                            ],
                            [
                                50,
                                0.7
                            ]
                        ]
                    }
                }
            }
        },
        OpenSeaMap: {
            url: "https://tiles.openseamap.org/seamark/{z}/{x}/{y}.png",
            options: {
                attribution: 'Map data: &copy; <a href="http://www.openseamap.org">OpenSeaMap</a> contributors'
            }
        },
        OpenPtMap: {
            url: "http://openptmap.org/tiles/{z}/{x}/{y}.png",
            options: {
                maxZoom: 17,
                attribution: 'Map data: &copy; <a href="http://www.openptmap.org">OpenPtMap</a> contributors'
            }
        },
        OpenTopoMap: {
            url: "https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png",
            options: {
                maxZoom: 17,
                attribution: 'Map data: {attribution.OpenStreetMap}, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)'
            }
        },
        OpenRailwayMap: {
            url: "https://{s}.tiles.openrailwaymap.org/standard/{z}/{x}/{y}.png",
            options: {
                maxZoom: 19,
                attribution: 'Map data: {attribution.OpenStreetMap} | Map style: &copy; <a href="https://www.OpenRailwayMap.org">OpenRailwayMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)'
            }
        },
        OpenFireMap: {
            url: "http://openfiremap.org/hytiles/{z}/{x}/{y}.png",
            options: {
                maxZoom: 19,
                attribution: 'Map data: {attribution.OpenStreetMap} | Map style: &copy; <a href="http://www.openfiremap.org">OpenFireMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)'
            }
        },
        SafeCast: {
            url: "https://s3.amazonaws.com/te512.safecast.org/{z}/{x}/{y}.png",
            options: {
                maxZoom: 16,
                attribution: 'Map data: {attribution.OpenStreetMap} | Map style: &copy; <a href="https://blog.safecast.org/about/">SafeCast</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)'
            }
        },
        Stadia: {
            url: "https://tiles.stadiamaps.com/tiles/alidade_smooth/{z}/{x}/{y}{r}.png",
            options: {
                maxZoom: 20,
                attribution: '&copy; <a href="https://stadiamaps.com/">Stadia Maps</a>, &copy; <a href="https://openmaptiles.org/">OpenMapTiles</a> &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors'
            },
            variants: {
                AlidadeSmooth: {
                    url: "https://tiles.stadiamaps.com/tiles/alidade_smooth/{z}/{x}/{y}{r}.png"
                },
                AlidadeSmoothDark: {
                    url: "https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}.png"
                },
                OSMBright: {
                    url: "https://tiles.stadiamaps.com/tiles/osm_bright/{z}/{x}/{y}{r}.png"
                },
                Outdoors: {
                    url: "https://tiles.stadiamaps.com/tiles/outdoors/{z}/{x}/{y}{r}.png"
                }
            }
        },
        Thunderforest: {
            url: "https://{s}.tile.thunderforest.com/{variant}/{z}/{x}/{y}.png?apikey={apikey}",
            options: {
                attribution: '&copy; <a href="http://www.thunderforest.com/">Thunderforest</a>, {attribution.OpenStreetMap}',
                variant: "cycle",
                apikey: "<insert your api key here>",
                maxZoom: 22
            },
            variants: {
                OpenCycleMap: "cycle",
                Transport: {
                    options: {
                        variant: "transport"
                    }
                },
                TransportDark: {
                    options: {
                        variant: "transport-dark"
                    }
                },
                SpinalMap: {
                    options: {
                        variant: "spinal-map"
                    }
                },
                Landscape: "landscape",
                Outdoors: "outdoors",
                Pioneer: "pioneer",
                MobileAtlas: "mobile-atlas",
                Neighbourhood: "neighbourhood"
            }
        },
        CyclOSM: {
            url: "https://dev.{s}.tile.openstreetmap.fr/cyclosm/{z}/{x}/{y}.png",
            options: {
                maxZoom: 20,
                attribution: '<a href="https://github.com/cyclosm/cyclosm-cartocss-style/releases" title="CyclOSM - Open Bicycle render">CyclOSM</a> | Map data: {attribution.OpenStreetMap}'
            }
        },
        Hydda: {
            url: "https://{s}.tile.openstreetmap.se/hydda/{variant}/{z}/{x}/{y}.png",
            options: {
                maxZoom: 20,
                variant: "full",
                attribution: 'Tiles courtesy of <a href="http://openstreetmap.se/" target="_blank">OpenStreetMap Sweden</a> &mdash; Map data {attribution.OpenStreetMap}'
            },
            variants: {
                Full: "full",
                Base: "base",
                RoadsAndLabels: "roads_and_labels"
            }
        },
        Jawg: {
            url: "https://{s}.tile.jawg.io/{variant}/{z}/{x}/{y}{r}.png?access-token={accessToken}",
            options: {
                attribution: '<a href="http://jawg.io" title="Tiles Courtesy of Jawg Maps" target="_blank">&copy; <b>Jawg</b>Maps</a> {attribution.OpenStreetMap}',
                minZoom: 0,
                maxZoom: 22,
                subdomains: "abcd",
                variant: "jawg-terrain",
                // Get your own Jawg access token here : https://www.jawg.io/lab/
                // NB : this is a demonstration key that comes with no guarantee
                accessToken: "<insert your access token here>"
            },
            variants: {
                Streets: "jawg-streets",
                Terrain: "jawg-terrain",
                Sunny: "jawg-sunny",
                Dark: "jawg-dark",
                Light: "jawg-light",
                Matrix: "jawg-matrix"
            }
        },
        MapBox: {
            url: "https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}{r}?access_token={accessToken}",
            options: {
                attribution: '&copy; <a href="https://www.mapbox.com/about/maps/" target="_blank">Mapbox</a> {attribution.OpenStreetMap} <a href="https://www.mapbox.com/map-feedback/" target="_blank">Improve this map</a>',
                tileSize: 512,
                maxZoom: 18,
                zoomOffset: -1,
                id: "mapbox/streets-v11",
                accessToken: "<insert your access token here>"
            }
        },
        MapTiler: {
            url: "https://api.maptiler.com/maps/{variant}/{z}/{x}/{y}{r}.{ext}?key={key}",
            options: {
                attribution: '<a href="https://www.maptiler.com/copyright/" target="_blank">&copy; MapTiler</a> <a href="https://www.openstreetmap.org/copyright" target="_blank">&copy; OpenStreetMap contributors</a>',
                variant: "streets",
                ext: "png",
                key: "<insert your MapTiler Cloud API key here>",
                tileSize: 512,
                zoomOffset: -1,
                minZoom: 0,
                maxZoom: 21
            },
            variants: {
                Streets: "streets",
                Basic: "basic",
                Bright: "bright",
                Pastel: "pastel",
                Positron: "positron",
                Hybrid: {
                    options: {
                        variant: "hybrid",
                        ext: "jpg"
                    }
                },
                Toner: "toner",
                Topo: "topo",
                Voyager: "voyager"
            }
        },
        Stamen: {
            url: "https://stamen-tiles-{s}.a.ssl.fastly.net/{variant}/{z}/{x}/{y}{r}.{ext}",
            options: {
                attribution: 'Map tiles by <a href="http://stamen.com">Stamen Design</a>, <a href="http://creativecommons.org/licenses/by/3.0">CC BY 3.0</a> &mdash; Map data {attribution.OpenStreetMap}',
                subdomains: "abcd",
                minZoom: 0,
                maxZoom: 20,
                variant: "toner",
                ext: "png"
            },
            variants: {
                Toner: "toner",
                TonerBackground: "toner-background",
                TonerHybrid: "toner-hybrid",
                TonerLines: "toner-lines",
                TonerLabels: "toner-labels",
                TonerLite: "toner-lite",
                Watercolor: {
                    url: "https://stamen-tiles-{s}.a.ssl.fastly.net/{variant}/{z}/{x}/{y}.{ext}",
                    options: {
                        variant: "watercolor",
                        ext: "jpg",
                        minZoom: 1,
                        maxZoom: 16
                    }
                },
                Terrain: {
                    options: {
                        variant: "terrain",
                        minZoom: 0,
                        maxZoom: 18
                    }
                },
                TerrainBackground: {
                    options: {
                        variant: "terrain-background",
                        minZoom: 0,
                        maxZoom: 18
                    }
                },
                TerrainLabels: {
                    options: {
                        variant: "terrain-labels",
                        minZoom: 0,
                        maxZoom: 18
                    }
                },
                TopOSMRelief: {
                    url: "https://stamen-tiles-{s}.a.ssl.fastly.net/{variant}/{z}/{x}/{y}.{ext}",
                    options: {
                        variant: "toposm-color-relief",
                        ext: "jpg",
                        bounds: [
                            [
                                22,
                                -132
                            ],
                            [
                                51,
                                -56
                            ]
                        ]
                    }
                },
                TopOSMFeatures: {
                    options: {
                        variant: "toposm-features",
                        bounds: [
                            [
                                22,
                                -132
                            ],
                            [
                                51,
                                -56
                            ]
                        ],
                        opacity: 0.9
                    }
                }
            }
        },
        TomTom: {
            url: "https://{s}.api.tomtom.com/map/1/tile/{variant}/{style}/{z}/{x}/{y}.{ext}?key={apikey}",
            options: {
                variant: "basic",
                maxZoom: 22,
                attribution: '<a href="https://tomtom.com" target="_blank">&copy;  1992 - ' + new Date().getFullYear() + " TomTom.</a> ",
                subdomains: "abcd",
                style: "main",
                ext: "png",
                apikey: "<insert your API key here>"
            },
            variants: {
                Basic: "basic",
                Hybrid: "hybrid",
                Labels: "labels"
            }
        },
        Esri: {
            url: "https://server.arcgisonline.com/ArcGIS/rest/services/{variant}/MapServer/tile/{z}/{y}/{x}",
            options: {
                variant: "World_Street_Map",
                attribution: "Tiles &copy; Esri"
            },
            variants: {
                WorldStreetMap: {
                    options: {
                        attribution: "{attribution.Esri} &mdash; Source: Esri, DeLorme, NAVTEQ, USGS, Intermap, iPC, NRCAN, Esri Japan, METI, Esri China (Hong Kong), Esri (Thailand), TomTom, 2012"
                    }
                },
                DeLorme: {
                    options: {
                        variant: "Specialty/DeLorme_World_Base_Map",
                        minZoom: 1,
                        maxZoom: 11,
                        attribution: "{attribution.Esri} &mdash; Copyright: &copy;2012 DeLorme"
                    }
                },
                WorldTopoMap: {
                    options: {
                        variant: "World_Topo_Map",
                        attribution: "{attribution.Esri} &mdash; Esri, DeLorme, NAVTEQ, TomTom, Intermap, iPC, USGS, FAO, NPS, NRCAN, GeoBase, Kadaster NL, Ordnance Survey, Esri Japan, METI, Esri China (Hong Kong), and the GIS User Community"
                    }
                },
                WorldImagery: {
                    options: {
                        variant: "World_Imagery",
                        attribution: "{attribution.Esri} &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community"
                    }
                },
                WorldTerrain: {
                    options: {
                        variant: "World_Terrain_Base",
                        maxZoom: 13,
                        attribution: "{attribution.Esri} &mdash; Source: USGS, Esri, TANA, DeLorme, and NPS"
                    }
                },
                WorldShadedRelief: {
                    options: {
                        variant: "World_Shaded_Relief",
                        maxZoom: 13,
                        attribution: "{attribution.Esri} &mdash; Source: Esri"
                    }
                },
                WorldPhysical: {
                    options: {
                        variant: "World_Physical_Map",
                        maxZoom: 8,
                        attribution: "{attribution.Esri} &mdash; Source: US National Park Service"
                    }
                },
                OceanBasemap: {
                    options: {
                        variant: "Ocean_Basemap",
                        maxZoom: 13,
                        attribution: "{attribution.Esri} &mdash; Sources: GEBCO, NOAA, CHS, OSU, UNH, CSUMB, National Geographic, DeLorme, NAVTEQ, and Esri"
                    }
                },
                NatGeoWorldMap: {
                    options: {
                        variant: "NatGeo_World_Map",
                        maxZoom: 16,
                        attribution: "{attribution.Esri} &mdash; National Geographic, Esri, DeLorme, NAVTEQ, UNEP-WCMC, USGS, NASA, ESA, METI, NRCAN, GEBCO, NOAA, iPC"
                    }
                },
                WorldGrayCanvas: {
                    options: {
                        variant: "Canvas/World_Light_Gray_Base",
                        maxZoom: 16,
                        attribution: "{attribution.Esri} &mdash; Esri, DeLorme, NAVTEQ"
                    }
                }
            }
        },
        OpenWeatherMap: {
            url: "http://{s}.tile.openweathermap.org/map/{variant}/{z}/{x}/{y}.png?appid={apiKey}",
            options: {
                maxZoom: 19,
                attribution: 'Map data &copy; <a href="http://openweathermap.org">OpenWeatherMap</a>',
                apiKey: "<insert your api key here>",
                opacity: 0.5
            },
            variants: {
                Clouds: "clouds",
                CloudsClassic: "clouds_cls",
                Precipitation: "precipitation",
                PrecipitationClassic: "precipitation_cls",
                Rain: "rain",
                RainClassic: "rain_cls",
                Pressure: "pressure",
                PressureContour: "pressure_cntr",
                Wind: "wind",
                Temperature: "temp",
                Snow: "snow"
            }
        },
        HERE: {
            /*
			 * HERE maps, formerly Nokia maps.
			 * These basemaps are free, but you need an api id and app key. Please sign up at
			 * https://developer.here.com/plans
			 */ url: "https://{s}.{base}.maps.api.here.com/maptile/2.1/{type}/{mapID}/{variant}/{z}/{x}/{y}/{size}/{format}?app_id={app_id}&app_code={app_code}&lg={language}",
            options: {
                attribution: "Map &copy; 1987-" + new Date().getFullYear() + ' <a href="http://developer.here.com">HERE</a>',
                subdomains: "1234",
                mapID: "newest",
                "app_id": "<insert your app_id here>",
                "app_code": "<insert your app_code here>",
                base: "base",
                variant: "normal.day",
                maxZoom: 20,
                type: "maptile",
                language: "eng",
                format: "png8",
                size: "256"
            },
            variants: {
                normalDay: "normal.day",
                normalDayCustom: "normal.day.custom",
                normalDayGrey: "normal.day.grey",
                normalDayMobile: "normal.day.mobile",
                normalDayGreyMobile: "normal.day.grey.mobile",
                normalDayTransit: "normal.day.transit",
                normalDayTransitMobile: "normal.day.transit.mobile",
                normalDayTraffic: {
                    options: {
                        variant: "normal.traffic.day",
                        base: "traffic",
                        type: "traffictile"
                    }
                },
                normalNight: "normal.night",
                normalNightMobile: "normal.night.mobile",
                normalNightGrey: "normal.night.grey",
                normalNightGreyMobile: "normal.night.grey.mobile",
                normalNightTransit: "normal.night.transit",
                normalNightTransitMobile: "normal.night.transit.mobile",
                reducedDay: "reduced.day",
                reducedNight: "reduced.night",
                basicMap: {
                    options: {
                        type: "basetile"
                    }
                },
                mapLabels: {
                    options: {
                        type: "labeltile",
                        format: "png"
                    }
                },
                trafficFlow: {
                    options: {
                        base: "traffic",
                        type: "flowtile"
                    }
                },
                carnavDayGrey: "carnav.day.grey",
                hybridDay: {
                    options: {
                        base: "aerial",
                        variant: "hybrid.day"
                    }
                },
                hybridDayMobile: {
                    options: {
                        base: "aerial",
                        variant: "hybrid.day.mobile"
                    }
                },
                hybridDayTransit: {
                    options: {
                        base: "aerial",
                        variant: "hybrid.day.transit"
                    }
                },
                hybridDayGrey: {
                    options: {
                        base: "aerial",
                        variant: "hybrid.grey.day"
                    }
                },
                hybridDayTraffic: {
                    options: {
                        variant: "hybrid.traffic.day",
                        base: "traffic",
                        type: "traffictile"
                    }
                },
                pedestrianDay: "pedestrian.day",
                pedestrianNight: "pedestrian.night",
                satelliteDay: {
                    options: {
                        base: "aerial",
                        variant: "satellite.day"
                    }
                },
                terrainDay: {
                    options: {
                        base: "aerial",
                        variant: "terrain.day"
                    }
                },
                terrainDayMobile: {
                    options: {
                        base: "aerial",
                        variant: "terrain.day.mobile"
                    }
                }
            }
        },
        HEREv3: {
            /*
			 * HERE maps API Version 3.
			 * These basemaps are free, but you need an API key. Please sign up at
			 * https://developer.here.com/plans
			 * Version 3 deprecates the app_id and app_code access in favor of apiKey
			 *
			 * Supported access methods as of 2019/12/21:
			 * @see https://developer.here.com/faqs#access-control-1--how-do-you-control-access-to-here-location-services
			 */ url: "https://{s}.{base}.maps.ls.hereapi.com/maptile/2.1/{type}/{mapID}/{variant}/{z}/{x}/{y}/{size}/{format}?apiKey={apiKey}&lg={language}",
            options: {
                attribution: "Map &copy; 1987-" + new Date().getFullYear() + ' <a href="http://developer.here.com">HERE</a>',
                subdomains: "1234",
                mapID: "newest",
                apiKey: "<insert your apiKey here>",
                base: "base",
                variant: "normal.day",
                maxZoom: 20,
                type: "maptile",
                language: "eng",
                format: "png8",
                size: "256"
            },
            variants: {
                normalDay: "normal.day",
                normalDayCustom: "normal.day.custom",
                normalDayGrey: "normal.day.grey",
                normalDayMobile: "normal.day.mobile",
                normalDayGreyMobile: "normal.day.grey.mobile",
                normalDayTransit: "normal.day.transit",
                normalDayTransitMobile: "normal.day.transit.mobile",
                normalNight: "normal.night",
                normalNightMobile: "normal.night.mobile",
                normalNightGrey: "normal.night.grey",
                normalNightGreyMobile: "normal.night.grey.mobile",
                normalNightTransit: "normal.night.transit",
                normalNightTransitMobile: "normal.night.transit.mobile",
                reducedDay: "reduced.day",
                reducedNight: "reduced.night",
                basicMap: {
                    options: {
                        type: "basetile"
                    }
                },
                mapLabels: {
                    options: {
                        type: "labeltile",
                        format: "png"
                    }
                },
                trafficFlow: {
                    options: {
                        base: "traffic",
                        type: "flowtile"
                    }
                },
                carnavDayGrey: "carnav.day.grey",
                hybridDay: {
                    options: {
                        base: "aerial",
                        variant: "hybrid.day"
                    }
                },
                hybridDayMobile: {
                    options: {
                        base: "aerial",
                        variant: "hybrid.day.mobile"
                    }
                },
                hybridDayTransit: {
                    options: {
                        base: "aerial",
                        variant: "hybrid.day.transit"
                    }
                },
                hybridDayGrey: {
                    options: {
                        base: "aerial",
                        variant: "hybrid.grey.day"
                    }
                },
                pedestrianDay: "pedestrian.day",
                pedestrianNight: "pedestrian.night",
                satelliteDay: {
                    options: {
                        base: "aerial",
                        variant: "satellite.day"
                    }
                },
                terrainDay: {
                    options: {
                        base: "aerial",
                        variant: "terrain.day"
                    }
                },
                terrainDayMobile: {
                    options: {
                        base: "aerial",
                        variant: "terrain.day.mobile"
                    }
                }
            }
        },
        FreeMapSK: {
            url: "http://t{s}.freemap.sk/T/{z}/{x}/{y}.jpeg",
            options: {
                minZoom: 8,
                maxZoom: 16,
                subdomains: "1234",
                bounds: [
                    [
                        47.204642,
                        15.996093
                    ],
                    [
                        49.830896,
                        22.576904
                    ]
                ],
                attribution: '{attribution.OpenStreetMap}, vizualization CC-By-SA 2.0 <a href="http://freemap.sk">Freemap.sk</a>'
            }
        },
        MtbMap: {
            url: "http://tile.mtbmap.cz/mtbmap_tiles/{z}/{x}/{y}.png",
            options: {
                attribution: "{attribution.OpenStreetMap} &amp; USGS"
            }
        },
        CartoDB: {
            url: "https://{s}.basemaps.cartocdn.com/{variant}/{z}/{x}/{y}{r}.png",
            options: {
                attribution: '{attribution.OpenStreetMap} &copy; <a href="https://carto.com/attributions">CARTO</a>',
                subdomains: "abcd",
                maxZoom: 19,
                variant: "light_all"
            },
            variants: {
                Positron: "light_all",
                PositronNoLabels: "light_nolabels",
                PositronOnlyLabels: "light_only_labels",
                DarkMatter: "dark_all",
                DarkMatterNoLabels: "dark_nolabels",
                DarkMatterOnlyLabels: "dark_only_labels",
                Voyager: "rastertiles/voyager",
                VoyagerNoLabels: "rastertiles/voyager_nolabels",
                VoyagerOnlyLabels: "rastertiles/voyager_only_labels",
                VoyagerLabelsUnder: "rastertiles/voyager_labels_under"
            }
        },
        HikeBike: {
            url: "https://tiles.wmflabs.org/{variant}/{z}/{x}/{y}.png",
            options: {
                maxZoom: 19,
                attribution: "{attribution.OpenStreetMap}",
                variant: "hikebike"
            },
            variants: {
                HikeBike: {},
                HillShading: {
                    options: {
                        maxZoom: 15,
                        variant: "hillshading"
                    }
                }
            }
        },
        BasemapAT: {
            url: "https://maps{s}.wien.gv.at/basemap/{variant}/{type}/google3857/{z}/{y}/{x}.{format}",
            options: {
                maxZoom: 19,
                attribution: 'Datenquelle: <a href="https://www.basemap.at">basemap.at</a>',
                subdomains: [
                    "",
                    "1",
                    "2",
                    "3",
                    "4"
                ],
                type: "normal",
                format: "png",
                bounds: [
                    [
                        46.358770,
                        8.782379
                    ],
                    [
                        49.037872,
                        17.189532
                    ]
                ],
                variant: "geolandbasemap"
            },
            variants: {
                basemap: {
                    options: {
                        maxZoom: 20,
                        variant: "geolandbasemap"
                    }
                },
                grau: "bmapgrau",
                overlay: "bmapoverlay",
                terrain: {
                    options: {
                        variant: "bmapgelaende",
                        type: "grau",
                        format: "jpeg"
                    }
                },
                surface: {
                    options: {
                        variant: "bmapoberflaeche",
                        type: "grau",
                        format: "jpeg"
                    }
                },
                highdpi: {
                    options: {
                        variant: "bmaphidpi",
                        format: "jpeg"
                    }
                },
                orthofoto: {
                    options: {
                        maxZoom: 20,
                        variant: "bmaporthofoto30cm",
                        format: "jpeg"
                    }
                }
            }
        },
        nlmaps: {
            url: "https://geodata.nationaalgeoregister.nl/tiles/service/wmts/{variant}/EPSG:3857/{z}/{x}/{y}.png",
            options: {
                minZoom: 6,
                maxZoom: 19,
                bounds: [
                    [
                        50.5,
                        3.25
                    ],
                    [
                        54,
                        7.6
                    ]
                ],
                attribution: 'Kaartgegevens &copy; <a href="kadaster.nl">Kadaster</a>'
            },
            variants: {
                "standaard": "brtachtergrondkaart",
                "pastel": "brtachtergrondkaartpastel",
                "grijs": "brtachtergrondkaartgrijs",
                "luchtfoto": {
                    "url": "https://geodata.nationaalgeoregister.nl/luchtfoto/rgb/wmts/2018_ortho25/EPSG:3857/{z}/{x}/{y}.png"
                }
            }
        },
        NASAGIBS: {
            url: "https://map1.vis.earthdata.nasa.gov/wmts-webmerc/{variant}/default/{time}/{tilematrixset}{maxZoom}/{z}/{y}/{x}.{format}",
            options: {
                attribution: 'Imagery provided by services from the Global Imagery Browse Services (GIBS), operated by the NASA/GSFC/Earth Science Data and Information System (<a href="https://earthdata.nasa.gov">ESDIS</a>) with funding provided by NASA/HQ.',
                bounds: [
                    [
                        -85.0511287776,
                        -179.999999975
                    ],
                    [
                        85.0511287776,
                        179.999999975
                    ]
                ],
                minZoom: 1,
                maxZoom: 9,
                format: "jpg",
                time: "",
                tilematrixset: "GoogleMapsCompatible_Level"
            },
            variants: {
                ModisTerraTrueColorCR: "MODIS_Terra_CorrectedReflectance_TrueColor",
                ModisTerraBands367CR: "MODIS_Terra_CorrectedReflectance_Bands367",
                ViirsEarthAtNight2012: {
                    options: {
                        variant: "VIIRS_CityLights_2012",
                        maxZoom: 8
                    }
                },
                ModisTerraLSTDay: {
                    options: {
                        variant: "MODIS_Terra_Land_Surface_Temp_Day",
                        format: "png",
                        maxZoom: 7,
                        opacity: 0.75
                    }
                },
                ModisTerraSnowCover: {
                    options: {
                        variant: "MODIS_Terra_Snow_Cover",
                        format: "png",
                        maxZoom: 8,
                        opacity: 0.75
                    }
                },
                ModisTerraAOD: {
                    options: {
                        variant: "MODIS_Terra_Aerosol",
                        format: "png",
                        maxZoom: 6,
                        opacity: 0.75
                    }
                },
                ModisTerraChlorophyll: {
                    options: {
                        variant: "MODIS_Terra_Chlorophyll_A",
                        format: "png",
                        maxZoom: 7,
                        opacity: 0.75
                    }
                }
            }
        },
        NLS: {
            // NLS maps are copyright National library of Scotland.
            // http://maps.nls.uk/projects/api/index.html
            // Please contact NLS for anything other than non-commercial low volume usage
            //
            // Map sources: Ordnance Survey 1:1m to 1:63K, 1920s-1940s
            //   z0-9  - 1:1m
            //  z10-11 - quarter inch (1:253440)
            //  z12-18 - one inch (1:63360)
            url: "https://nls-{s}.tileserver.com/nls/{z}/{x}/{y}.jpg",
            options: {
                attribution: '<a href="http://geo.nls.uk/maps/">National Library of Scotland Historic Maps</a>',
                bounds: [
                    [
                        49.6,
                        -12
                    ],
                    [
                        61.7,
                        3
                    ]
                ],
                minZoom: 1,
                maxZoom: 18,
                subdomains: "0123"
            }
        },
        JusticeMap: {
            // Justice Map (http://www.justicemap.org/)
            // Visualize race and income data for your community, county and country.
            // Includes tools for data journalists, bloggers and community activists.
            url: "http://www.justicemap.org/tile/{size}/{variant}/{z}/{x}/{y}.png",
            options: {
                attribution: '<a href="http://www.justicemap.org/terms.php">Justice Map</a>',
                // one of 'county', 'tract', 'block'
                size: "county",
                // Bounds for USA, including Alaska and Hawaii
                bounds: [
                    [
                        14,
                        -180
                    ],
                    [
                        72,
                        -56
                    ]
                ]
            },
            variants: {
                income: "income",
                americanIndian: "indian",
                asian: "asian",
                black: "black",
                hispanic: "hispanic",
                multi: "multi",
                nonWhite: "nonwhite",
                white: "white",
                plurality: "plural"
            }
        },
        Wikimedia: {
            url: "https://maps.wikimedia.org/osm-intl/{z}/{x}/{y}{r}.png",
            options: {
                attribution: '<a href="https://wikimediafoundation.org/wiki/Maps_Terms_of_Use">Wikimedia</a>',
                minZoom: 1,
                maxZoom: 19
            }
        },
        GeoportailFrance: {
            url: "https://wxs.ign.fr/{apikey}/geoportail/wmts?REQUEST=GetTile&SERVICE=WMTS&VERSION=1.0.0&STYLE={style}&TILEMATRIXSET=PM&FORMAT={format}&LAYER={variant}&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}",
            options: {
                attribution: '<a target="_blank" href="https://www.geoportail.gouv.fr/">Geoportail France</a>',
                bounds: [
                    [
                        -75,
                        -180
                    ],
                    [
                        81,
                        180
                    ]
                ],
                minZoom: 2,
                maxZoom: 18,
                // Get your own geoportail apikey here : http://professionnels.ign.fr/ign/contrats/
                // NB : 'choisirgeoportail' is a demonstration key that comes with no guarantee
                apikey: "choisirgeoportail",
                format: "image/jpeg",
                style: "normal",
                variant: "GEOGRAPHICALGRIDSYSTEMS.MAPS.SCAN-EXPRESS.STANDARD"
            },
            variants: {
                parcels: {
                    options: {
                        variant: "CADASTRALPARCELS.PARCELS",
                        maxZoom: 20,
                        style: "bdparcellaire",
                        format: "image/png"
                    }
                },
                ignMaps: "GEOGRAPHICALGRIDSYSTEMS.MAPS",
                maps: "GEOGRAPHICALGRIDSYSTEMS.MAPS.SCAN-EXPRESS.STANDARD",
                orthos: {
                    options: {
                        maxZoom: 19,
                        variant: "ORTHOIMAGERY.ORTHOPHOTOS"
                    }
                }
            }
        },
        OneMapSG: {
            url: "https://maps-{s}.onemap.sg/v3/{variant}/{z}/{x}/{y}.png",
            options: {
                variant: "Default",
                minZoom: 11,
                maxZoom: 18,
                bounds: [
                    [
                        1.56073,
                        104.11475
                    ],
                    [
                        1.16,
                        103.502
                    ]
                ],
                attribution: '<img src="https://docs.onemap.sg/maps/images/oneMap64-01.png" style="height:20px;width:20px;"/> New OneMap | Map data &copy; contributors, <a href="http://SLA.gov.sg">Singapore Land Authority</a>'
            },
            variants: {
                Default: "Default",
                Night: "Night",
                Original: "Original",
                Grey: "Grey",
                LandLot: "LandLot"
            }
        }
    };
    L1.tileLayer.provider = function(provider, options) {
        return new L1.TileLayer.Provider(provider, options);
    };
    return L1;
});


var $fbe7df132a48aa50$exports = {};


/* 
 * Leaflet TimeDimension v1.1.1 - 2019-11-05 
 * 
 * Copyright 2019 Biel Frontera (ICTS SOCIB) 
 * datacenter@socib.es 
 * http://www.socib.es/ 
 * 
 * Licensed under the MIT license. 
 * 
 * Demos: 
 * http://apps.socib.es/Leaflet.TimeDimension/ 
 * 
 * Source: 
 * git://github.com/socib/Leaflet.TimeDimension.git 
 * 
 */ (function(factory, window1) {
    if (typeof define === "function" && define.amd) // define an AMD module that relies on leaflet
    define([
        "leaflet",
        "iso8601-js-period"
    ], factory);
    else {
        var iso8601;
        // define a Common JS module that relies on leaflet
        $fbe7df132a48aa50$exports = factory((parcelRequire("8wu30")), (parcelRequire("iSVU0")));
    }
})(function(L, iso8601) {
    // make sure iso8601 module js period module is available under the nezasa scope
    if (typeof nezasa === "undefined") var nezasa = {
        iso8601: iso8601
    };
    // TimeDimension plugin implementation
    /*jshint indent: 4, browser:true*/ /*global L*/ /*
 * L.TimeDimension: TimeDimension object manages the time component of a layer.
 * It can be shared among different layers and it can be added to a map, and become
 * the default timedimension component for any layer added to the map.
 */ L.TimeDimension = (L.Layer || L.Class).extend({
        includes: L.Evented || L.Mixin.Events,
        initialize: function(options) {
            L.setOptions(this, options);
            // _availableTimes is an array with all the available times in ms.
            this._availableTimes = this._generateAvailableTimes();
            this._currentTimeIndex = -1;
            this._loadingTimeIndex = -1;
            this._loadingTimeout = this.options.loadingTimeout || 3000;
            this._syncedLayers = [];
            if (this._availableTimes.length > 0) this.setCurrentTime(this.options.currentTime || this._getDefaultCurrentTime());
            if (this.options.lowerLimitTime) this.setLowerLimit(this.options.lowerLimitTime);
            if (this.options.upperLimitTime) this.setUpperLimit(this.options.upperLimitTime);
        },
        getAvailableTimes: function() {
            return this._availableTimes;
        },
        getCurrentTimeIndex: function() {
            if (this._currentTimeIndex === -1) return this._availableTimes.length - 1;
            return this._currentTimeIndex;
        },
        getCurrentTime: function() {
            var index = -1;
            if (this._loadingTimeIndex !== -1) index = this._loadingTimeIndex;
            else index = this.getCurrentTimeIndex();
            if (index >= 0) return this._availableTimes[index];
            else return null;
        },
        isLoading: function() {
            return this._loadingTimeIndex !== -1;
        },
        setCurrentTimeIndex: function(newIndex) {
            var upperLimit = this._upperLimit || this._availableTimes.length - 1;
            var lowerLimit = this._lowerLimit || 0;
            //clamp the value
            newIndex = Math.min(Math.max(lowerLimit, newIndex), upperLimit);
            if (newIndex < 0) return;
            this._loadingTimeIndex = newIndex;
            var newTime = this._availableTimes[newIndex];
            if (this._checkSyncedLayersReady(this._availableTimes[this._loadingTimeIndex])) this._newTimeIndexLoaded();
            else {
                this.fire("timeloading", {
                    time: newTime
                });
                // add timeout of 3 seconds if layers doesn't response
                setTimeout((function(index) {
                    if (index == this._loadingTimeIndex) this._newTimeIndexLoaded();
                }).bind(this, newIndex), this._loadingTimeout);
            }
        },
        _newTimeIndexLoaded: function() {
            if (this._loadingTimeIndex === -1) return;
            var time = this._availableTimes[this._loadingTimeIndex];
            this._currentTimeIndex = this._loadingTimeIndex;
            this.fire("timeload", {
                time: time
            });
            this._loadingTimeIndex = -1;
        },
        _checkSyncedLayersReady: function(time) {
            for(var i = 0, len = this._syncedLayers.length; i < len; i++)if (this._syncedLayers[i].isReady) {
                if (!this._syncedLayers[i].isReady(time)) return false;
            }
            return true;
        },
        setCurrentTime: function(time) {
            var newIndex = this._seekNearestTimeIndex(time);
            this.setCurrentTimeIndex(newIndex);
        },
        seekNearestTime: function(time) {
            var index = this._seekNearestTimeIndex(time);
            return this._availableTimes[index];
        },
        nextTime: function(numSteps, loop) {
            if (!numSteps) numSteps = 1;
            var newIndex = this._currentTimeIndex;
            var upperLimit = this._upperLimit || this._availableTimes.length - 1;
            var lowerLimit = this._lowerLimit || 0;
            if (this._loadingTimeIndex > -1) newIndex = this._loadingTimeIndex;
            newIndex = newIndex + numSteps;
            if (newIndex > upperLimit) {
                if (!!loop) newIndex = lowerLimit;
                else newIndex = upperLimit;
            }
            // loop backwards
            if (newIndex < lowerLimit) {
                if (!!loop) newIndex = upperLimit;
                else newIndex = lowerLimit;
            }
            this.setCurrentTimeIndex(newIndex);
        },
        prepareNextTimes: function(numSteps, howmany, loop) {
            if (!numSteps) numSteps = 1;
            var newIndex = this._currentTimeIndex;
            var currentIndex = newIndex;
            if (this._loadingTimeIndex > -1) newIndex = this._loadingTimeIndex;
            // assure synced layers have a buffer/cache of at least howmany elements
            for(var i = 0, len = this._syncedLayers.length; i < len; i++)if (this._syncedLayers[i].setMinimumForwardCache) this._syncedLayers[i].setMinimumForwardCache(howmany);
            var count = howmany;
            var upperLimit = this._upperLimit || this._availableTimes.length - 1;
            var lowerLimit = this._lowerLimit || 0;
            while(count > 0){
                newIndex = newIndex + numSteps;
                if (newIndex > upperLimit) {
                    if (!!loop) newIndex = lowerLimit;
                    else break;
                }
                if (newIndex < lowerLimit) {
                    if (!!loop) newIndex = upperLimit;
                    else break;
                }
                if (currentIndex === newIndex) break;
                this.fire("timeloading", {
                    time: this._availableTimes[newIndex]
                });
                count--;
            }
        },
        getNumberNextTimesReady: function(numSteps, howmany, loop) {
            if (!numSteps) numSteps = 1;
            var newIndex = this._currentTimeIndex;
            if (this._loadingTimeIndex > -1) newIndex = this._loadingTimeIndex;
            var count = howmany;
            var ready = 0;
            var upperLimit = this._upperLimit || this._availableTimes.length - 1;
            var lowerLimit = this._lowerLimit || 0;
            while(count > 0){
                newIndex = newIndex + numSteps;
                if (newIndex > upperLimit) {
                    if (!!loop) newIndex = lowerLimit;
                    else {
                        count = 0;
                        ready = howmany;
                        break;
                    }
                }
                if (newIndex < lowerLimit) {
                    if (!!loop) newIndex = upperLimit;
                    else {
                        count = 0;
                        ready = howmany;
                        break;
                    }
                }
                var time = this._availableTimes[newIndex];
                if (this._checkSyncedLayersReady(time)) ready++;
                count--;
            }
            return ready;
        },
        previousTime: function(numSteps, loop) {
            this.nextTime(numSteps * -1, loop);
        },
        registerSyncedLayer: function(layer) {
            this._syncedLayers.push(layer);
            layer.on("timeload", this._onSyncedLayerLoaded, this);
        },
        unregisterSyncedLayer: function(layer) {
            var index = this._syncedLayers.indexOf(layer);
            if (index != -1) this._syncedLayers.splice(index, 1);
            layer.off("timeload", this._onSyncedLayerLoaded, this);
        },
        _onSyncedLayerLoaded: function(e) {
            if (e.time == this._availableTimes[this._loadingTimeIndex] && this._checkSyncedLayersReady(e.time)) this._newTimeIndexLoaded();
        },
        _generateAvailableTimes: function() {
            if (this.options.times) return L.TimeDimension.Util.parseTimesExpression(this.options.times);
            else if (this.options.timeInterval) {
                var tiArray = L.TimeDimension.Util.parseTimeInterval(this.options.timeInterval);
                var period = this.options.period || "P1D";
                var validTimeRange = this.options.validTimeRange || undefined;
                return L.TimeDimension.Util.explodeTimeRange(tiArray[0], tiArray[1], period, validTimeRange);
            } else return [];
        },
        _getDefaultCurrentTime: function() {
            var index = this._seekNearestTimeIndex(new Date().getTime());
            return this._availableTimes[index];
        },
        _seekNearestTimeIndex: function(time) {
            var newIndex = 0;
            var len = this._availableTimes.length;
            for(; newIndex < len; newIndex++){
                if (time < this._availableTimes[newIndex]) break;
            }
            // We've found the first index greater than the time. Return the previous
            if (newIndex > 0) newIndex--;
            return newIndex;
        },
        setAvailableTimes: function(times, mode) {
            var currentTime = this.getCurrentTime(), lowerLimitTime = this.getLowerLimit(), upperLimitTime = this.getUpperLimit();
            if (mode == "extremes") {
                var period = this.options.period || "P1D";
                this._availableTimes = L.TimeDimension.Util.explodeTimeRange(new Date(times[0]), new Date(times[times.length - 1]), period);
            } else {
                var parsedTimes = L.TimeDimension.Util.parseTimesExpression(times);
                if (this._availableTimes.length === 0) this._availableTimes = parsedTimes;
                else if (mode == "intersect") this._availableTimes = L.TimeDimension.Util.intersect_arrays(parsedTimes, this._availableTimes);
                else if (mode == "union") this._availableTimes = L.TimeDimension.Util.union_arrays(parsedTimes, this._availableTimes);
                else if (mode == "replace") this._availableTimes = parsedTimes;
                else throw "Merge available times mode not implemented: " + mode;
            }
            if (lowerLimitTime) this.setLowerLimit(lowerLimitTime); //restore lower limit
            if (upperLimitTime) this.setUpperLimit(upperLimitTime); //restore upper limit
            this.setCurrentTime(currentTime);
            this.fire("availabletimeschanged", {
                availableTimes: this._availableTimes,
                currentTime: currentTime
            });
        },
        getLowerLimit: function() {
            return this._availableTimes[this.getLowerLimitIndex()];
        },
        getUpperLimit: function() {
            return this._availableTimes[this.getUpperLimitIndex()];
        },
        setLowerLimit: function(time) {
            var index = this._seekNearestTimeIndex(time);
            this.setLowerLimitIndex(index);
        },
        setUpperLimit: function(time) {
            var index = this._seekNearestTimeIndex(time);
            this.setUpperLimitIndex(index);
        },
        setLowerLimitIndex: function(index) {
            this._lowerLimit = Math.min(Math.max(index || 0, 0), this._upperLimit || this._availableTimes.length - 1);
            this.fire("limitschanged", {
                lowerLimit: this._lowerLimit,
                upperLimit: this._upperLimit
            });
        },
        setUpperLimitIndex: function(index) {
            this._upperLimit = Math.max(Math.min(index, this._availableTimes.length - 1), this._lowerLimit || 0);
            this.fire("limitschanged", {
                lowerLimit: this._lowerLimit,
                upperLimit: this._upperLimit
            });
        },
        getLowerLimitIndex: function() {
            return this._lowerLimit;
        },
        getUpperLimitIndex: function() {
            return this._upperLimit;
        }
    });
    L.Map.addInitHook(function() {
        if (this.options.timeDimension) this.timeDimension = L.timeDimension(this.options.timeDimensionOptions || {});
    });
    L.timeDimension = function(options) {
        return new L.TimeDimension(options);
    };
    /*
 * L.TimeDimension.Util
 */ L.TimeDimension.Util = {
        getTimeDuration: function(ISODuration) {
            if (typeof nezasa === "undefined") throw "iso8601-js-period library is required for Leatlet.TimeDimension: https://github.com/nezasa/iso8601-js-period";
            return nezasa.iso8601.Period.parse(ISODuration, true);
        },
        addTimeDuration: function(date, duration, utc) {
            if (typeof utc === "undefined") utc = true;
            if (typeof duration == "string" || duration instanceof String) duration = this.getTimeDuration(duration);
            var l = duration.length;
            var get = utc ? "getUTC" : "get";
            var set = utc ? "setUTC" : "set";
            if (l > 0 && duration[0] != 0) date[set + "FullYear"](date[get + "FullYear"]() + duration[0]);
            if (l > 1 && duration[1] != 0) date[set + "Month"](date[get + "Month"]() + duration[1]);
            if (l > 2 && duration[2] != 0) // weeks
            date[set + "Date"](date[get + "Date"]() + duration[2] * 7);
            if (l > 3 && duration[3] != 0) date[set + "Date"](date[get + "Date"]() + duration[3]);
            if (l > 4 && duration[4] != 0) date[set + "Hours"](date[get + "Hours"]() + duration[4]);
            if (l > 5 && duration[5] != 0) date[set + "Minutes"](date[get + "Minutes"]() + duration[5]);
            if (l > 6 && duration[6] != 0) date[set + "Seconds"](date[get + "Seconds"]() + duration[6]);
        },
        subtractTimeDuration: function(date, duration, utc) {
            if (typeof duration == "string" || duration instanceof String) duration = this.getTimeDuration(duration);
            var subDuration = [];
            for(var i = 0, l = duration.length; i < l; i++)subDuration.push(-duration[i]);
            this.addTimeDuration(date, subDuration, utc);
        },
        parseAndExplodeTimeRange: function(timeRange, overwritePeriod) {
            var tr = timeRange.split("/");
            var startTime = new Date(Date.parse(tr[0]));
            var endTime = new Date(Date.parse(tr[1]));
            var period = tr.length > 2 && tr[2].length ? tr[2] : "P1D";
            if (overwritePeriod !== undefined && overwritePeriod !== null) period = overwritePeriod;
            return this.explodeTimeRange(startTime, endTime, period);
        },
        explodeTimeRange: function(startTime, endTime, ISODuration, validTimeRange) {
            var duration = this.getTimeDuration(ISODuration);
            var result = [];
            var currentTime = new Date(startTime.getTime());
            var minHour = null, minMinutes = null, maxHour = null, maxMinutes = null;
            if (validTimeRange !== undefined) {
                var validTimeRangeArray = validTimeRange.split("/");
                minHour = validTimeRangeArray[0].split(":")[0];
                minMinutes = validTimeRangeArray[0].split(":")[1];
                maxHour = validTimeRangeArray[1].split(":")[0];
                maxMinutes = validTimeRangeArray[1].split(":")[1];
            }
            while(currentTime < endTime){
                if (validTimeRange === undefined || currentTime.getUTCHours() >= minHour && currentTime.getUTCHours() <= maxHour) {
                    if ((currentTime.getUTCHours() != minHour || currentTime.getUTCMinutes() >= minMinutes) && (currentTime.getUTCHours() != maxHour || currentTime.getUTCMinutes() <= maxMinutes)) result.push(currentTime.getTime());
                }
                this.addTimeDuration(currentTime, duration);
            }
            if (currentTime >= endTime) result.push(endTime.getTime());
            return result;
        },
        parseTimeInterval: function(timeInterval) {
            var parts = timeInterval.split("/");
            if (parts.length != 2) throw "Incorrect ISO9601 TimeInterval: " + timeInterval;
            var startTime = Date.parse(parts[0]);
            var endTime = null;
            var duration = null;
            if (isNaN(startTime)) {
                // -> format duration/endTime
                duration = this.getTimeDuration(parts[0]);
                endTime = Date.parse(parts[1]);
                startTime = new Date(endTime);
                this.subtractTimeDuration(startTime, duration, true);
                endTime = new Date(endTime);
            } else {
                endTime = Date.parse(parts[1]);
                if (isNaN(endTime)) {
                    // -> format startTime/duration
                    duration = this.getTimeDuration(parts[1]);
                    endTime = new Date(startTime);
                    this.addTimeDuration(endTime, duration, true);
                } else // -> format startTime/endTime
                endTime = new Date(endTime);
                startTime = new Date(startTime);
            }
            return [
                startTime,
                endTime
            ];
        },
        parseTimesExpression: function(times, overwritePeriod) {
            var result = [];
            if (!times) return result;
            if (typeof times == "string" || times instanceof String) {
                var timeRanges = times.split(",");
                var timeRange;
                var timeValue;
                for(var i = 0, l = timeRanges.length; i < l; i++){
                    timeRange = timeRanges[i];
                    if (timeRange.split("/").length == 3) result = result.concat(this.parseAndExplodeTimeRange(timeRange, overwritePeriod));
                    else {
                        timeValue = Date.parse(timeRange);
                        if (!isNaN(timeValue)) result.push(timeValue);
                    }
                }
            } else result = times;
            return result.sort(function(a, b) {
                return a - b;
            });
        },
        intersect_arrays: function(arrayA, arrayB) {
            var a = arrayA.slice(0);
            var b = arrayB.slice(0);
            var result = [];
            while(a.length > 0 && b.length > 0){
                if (a[0] < b[0]) a.shift();
                else if (a[0] > b[0]) b.shift();
                else /* they're equal */ {
                    result.push(a.shift());
                    b.shift();
                }
            }
            return result;
        },
        union_arrays: function(arrayA, arrayB) {
            var a = arrayA.slice(0);
            var b = arrayB.slice(0);
            var result = [];
            while(a.length > 0 && b.length > 0){
                if (a[0] < b[0]) result.push(a.shift());
                else if (a[0] > b[0]) result.push(b.shift());
                else /* they're equal */ {
                    result.push(a.shift());
                    b.shift();
                }
            }
            if (a.length > 0) result = result.concat(a);
            else if (b.length > 0) result = result.concat(b);
            return result;
        },
        sort_and_deduplicate: function(arr) {
            arr = arr.slice(0).sort();
            var result = [];
            var last = null;
            for(var i = 0, l = arr.length; i < l; i++)if (arr[i] !== last) {
                result.push(arr[i]);
                last = arr[i];
            }
            return result;
        }
    };
    /*
 * L.TimeDimension.Layer:  an abstract Layer that can be managed/synchronized with a TimeDimension.
 * The constructor recieves a layer (of any kind) and options.
 * Any children class should implement `_onNewTimeLoading`, `isReady` and `_update` functions
 * to react to time changes.
 */ L.TimeDimension.Layer = (L.Layer || L.Class).extend({
        includes: L.Evented || L.Mixin.Events,
        options: {
            opacity: 1,
            zIndex: 1
        },
        initialize: function(layer, options) {
            L.setOptions(this, options || {});
            this._map = null;
            this._baseLayer = layer;
            this._currentLayer = null;
            this._timeDimension = this.options.timeDimension || null;
        },
        addTo: function(map) {
            map.addLayer(this);
            return this;
        },
        onAdd: function(map) {
            this._map = map;
            if (!this._timeDimension && map.timeDimension) this._timeDimension = map.timeDimension;
            this._timeDimension.on("timeloading", this._onNewTimeLoading, this);
            this._timeDimension.on("timeload", this._update, this);
            this._timeDimension.registerSyncedLayer(this);
            this._update();
        },
        onRemove: function(map) {
            this._timeDimension.unregisterSyncedLayer(this);
            this._timeDimension.off("timeloading", this._onNewTimeLoading, this);
            this._timeDimension.off("timeload", this._update, this);
            this.eachLayer(map.removeLayer, map);
            this._map = null;
        },
        eachLayer: function(method, context) {
            method.call(context, this._baseLayer);
            return this;
        },
        setZIndex: function(zIndex) {
            this.options.zIndex = zIndex;
            if (this._baseLayer.setZIndex) this._baseLayer.setZIndex(zIndex);
            if (this._currentLayer && this._currentLayer.setZIndex) this._currentLayer.setZIndex(zIndex);
            return this;
        },
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._baseLayer.setOpacity) this._baseLayer.setOpacity(opacity);
            if (this._currentLayer && this._currentLayer.setOpacity) this._currentLayer.setOpacity(opacity);
            return this;
        },
        bringToBack: function() {
            if (!this._currentLayer) return;
            this._currentLayer.bringToBack();
            return this;
        },
        bringToFront: function() {
            if (!this._currentLayer) return;
            this._currentLayer.bringToFront();
            return this;
        },
        _onNewTimeLoading: function(ev) {
            // to be implemented for each type of layer
            this.fire("timeload", {
                time: ev.time
            });
            return;
        },
        isReady: function(time) {
            // to be implemented for each type of layer
            return true;
        },
        _update: function() {
            // to be implemented for each type of layer
            return true;
        },
        getBaseLayer: function() {
            return this._baseLayer;
        },
        getBounds: function() {
            var bounds = new L.LatLngBounds();
            if (this._currentLayer) bounds.extend(this._currentLayer.getBounds ? this._currentLayer.getBounds() : this._currentLayer.getLatLng());
            return bounds;
        }
    });
    L.timeDimension.layer = function(layer, options) {
        return new L.TimeDimension.Layer(layer, options);
    };
    /*
 * L.TimeDimension.Layer.WMS: wms Layer associated to a TimeDimension
 */ L.TimeDimension.Layer.WMS = L.TimeDimension.Layer.extend({
        initialize: function(layer, options) {
            L.TimeDimension.Layer.prototype.initialize.call(this, layer, options);
            this._timeCacheBackward = this.options.cacheBackward || this.options.cache || 0;
            this._timeCacheForward = this.options.cacheForward || this.options.cache || 0;
            this._wmsVersion = this.options.wmsVersion || this.options.version || layer.options.version || "1.1.1";
            this._getCapabilitiesParams = this.options.getCapabilitiesParams || {};
            this._getCapabilitiesAlternateUrl = this.options.getCapabilitiesUrl || null;
            this._getCapabilitiesAlternateLayerName = this.options.getCapabilitiesLayerName || null;
            this._proxy = this.options.proxy || null;
            this._updateTimeDimension = this.options.updateTimeDimension || false;
            this._setDefaultTime = this.options.setDefaultTime || false;
            this._updateTimeDimensionMode = this.options.updateTimeDimensionMode || "intersect"; // 'union' or 'replace'
            this._period = this.options.period || null;
            this._layers = {};
            this._defaultTime = 0;
            this._availableTimes = [];
            this._capabilitiesRequested = false;
            if (this._updateTimeDimension || this.options.requestTimeFromCapabilities) this._requestTimeDimensionFromCapabilities();
            this._baseLayer.on("load", (function() {
                this._baseLayer.setLoaded(true);
                this.fire("timeload", {
                    time: this._defaultTime
                });
            }).bind(this));
        },
        getEvents: function() {
            var clearCache = L.bind(this._unvalidateCache, this);
            return {
                moveend: clearCache,
                zoomend: clearCache
            };
        },
        eachLayer: function(method, context) {
            for(var prop in this._layers)if (this._layers.hasOwnProperty(prop)) method.call(context, this._layers[prop]);
            return L.TimeDimension.Layer.prototype.eachLayer.call(this, method, context);
        },
        _onNewTimeLoading: function(ev) {
            // 
            var layer = this._getLayerForTime(ev.time);
            if (!this._map.hasLayer(layer)) this._map.addLayer(layer);
        },
        isReady: function(time) {
            var layer = this._getLayerForTime(time);
            if (this.options.bounds && this._map) {
                if (!this._map.getBounds().contains(this.options.bounds)) return true;
            }
            return layer.isLoaded();
        },
        onAdd: function(map) {
            L.TimeDimension.Layer.prototype.onAdd.call(this, map);
            if (this._availableTimes.length == 0) this._requestTimeDimensionFromCapabilities();
            else this._updateTimeDimensionAvailableTimes();
        },
        _update: function() {
            if (!this._map) return;
            var time = this._timeDimension.getCurrentTime();
            // It will get the layer for this time (create or get)
            // Then, the layer will be loaded if necessary, adding it to the map (and show it after loading).
            // If it already on the map (but probably hidden), it will be shown
            var layer = this._getLayerForTime(time);
            if (this._currentLayer == null) this._currentLayer = layer;
            if (!this._map.hasLayer(layer)) this._map.addLayer(layer);
            else this._showLayer(layer, time);
        },
        setOpacity: function(opacity) {
            L.TimeDimension.Layer.prototype.setOpacity.apply(this, arguments);
            // apply to all preloaded caches
            for(var prop in this._layers)if (this._layers.hasOwnProperty(prop) && this._layers[prop].setOpacity) this._layers[prop].setOpacity(opacity);
        },
        setZIndex: function(zIndex) {
            L.TimeDimension.Layer.prototype.setZIndex.apply(this, arguments);
            // apply to all preloaded caches
            for(var prop in this._layers)if (this._layers.hasOwnProperty(prop) && this._layers[prop].setZIndex) this._layers[prop].setZIndex(zIndex);
        },
        setParams: function(params, noRedraw) {
            L.extend(this._baseLayer.options, params);
            if (this._baseLayer.setParams) this._baseLayer.setParams(params, noRedraw);
            for(var prop in this._layers)if (this._layers.hasOwnProperty(prop) && this._layers[prop].setParams) {
                this._layers[prop].setLoaded(false); // mark it as unloaded
                this._layers[prop].setParams(params, noRedraw);
            }
            return this;
        },
        _unvalidateCache: function() {
            var time = this._timeDimension.getCurrentTime();
            for(var prop in this._layers)if (time != prop && this._layers.hasOwnProperty(prop)) {
                this._layers[prop].setLoaded(false); // mark it as unloaded
                this._layers[prop].redraw();
            }
        },
        _evictCachedTimes: function(keepforward, keepbackward) {
            // Cache management
            var times = this._getLoadedTimes();
            var strTime = String(this._currentTime);
            var index = times.indexOf(strTime);
            var remove = [];
            // remove times before current time
            if (keepbackward > -1) {
                var objectsToRemove = index - keepbackward;
                if (objectsToRemove > 0) {
                    remove = times.splice(0, objectsToRemove);
                    this._removeLayers(remove);
                }
            }
            if (keepforward > -1) {
                index = times.indexOf(strTime);
                var objectsToRemove = times.length - index - keepforward - 1;
                if (objectsToRemove > 0) {
                    remove = times.splice(index + keepforward + 1, objectsToRemove);
                    this._removeLayers(remove);
                }
            }
        },
        _showLayer: function(layer, time) {
            if (this._currentLayer && this._currentLayer !== layer) this._currentLayer.hide();
            layer.show();
            if (this._currentLayer && this._currentLayer === layer) return;
            this._currentLayer = layer;
            this._currentTime = time;
            this._evictCachedTimes(this._timeCacheForward, this._timeCacheBackward);
        },
        _getLayerForTime: function(time) {
            if (time == 0 || time == this._defaultTime || time == null) return this._baseLayer;
            if (this._layers.hasOwnProperty(time)) return this._layers[time];
            var nearestTime = this._getNearestTime(time);
            if (this._layers.hasOwnProperty(nearestTime)) return this._layers[nearestTime];
            var newLayer = this._createLayerForTime(nearestTime);
            this._layers[time] = newLayer;
            newLayer.on("load", (function(layer, time) {
                layer.setLoaded(true);
                // this time entry should exists inside _layers
                // but it might be deleted by cache management
                if (!this._layers[time]) this._layers[time] = layer;
                if (this._timeDimension && time == this._timeDimension.getCurrentTime() && !this._timeDimension.isLoading()) this._showLayer(layer, time);
                // 
                this.fire("timeload", {
                    time: time
                });
            }).bind(this, newLayer, time));
            // Hack to hide the layer when added to the map.
            // It will be shown when timeload event is fired from the map (after all layers are loaded)
            newLayer.onAdd = (function(map) {
                Object.getPrototypeOf(this).onAdd.call(this, map);
                this.hide();
            }).bind(newLayer);
            return newLayer;
        },
        _createLayerForTime: function(time) {
            var wmsParams = this._baseLayer.options;
            wmsParams.time = new Date(time).toISOString();
            return new this._baseLayer.constructor(this._baseLayer.getURL(), wmsParams);
        },
        _getLoadedTimes: function() {
            var result = [];
            for(var prop in this._layers)if (this._layers.hasOwnProperty(prop)) result.push(prop);
            return result.sort(function(a, b) {
                return a - b;
            });
        },
        _removeLayers: function(times) {
            for(var i = 0, l = times.length; i < l; i++){
                if (this._map) this._map.removeLayer(this._layers[times[i]]);
                delete this._layers[times[i]];
            }
        },
        setMinimumForwardCache: function(value) {
            if (value > this._timeCacheForward) this._timeCacheForward = value;
        },
        _requestTimeDimensionFromCapabilities: function() {
            if (this._capabilitiesRequested) return;
            this._capabilitiesRequested = true;
            var url = this._getCapabilitiesUrl();
            if (this._proxy) url = this._proxy + "?url=" + encodeURIComponent(url);
            var oReq = new XMLHttpRequest();
            oReq.addEventListener("load", (function(xhr) {
                var data = xhr.currentTarget.responseXML;
                if (data !== null) {
                    this._defaultTime = Date.parse(this._getDefaultTimeFromCapabilities(data));
                    this._setDefaultTime = this._setDefaultTime || this._timeDimension && this._timeDimension.getAvailableTimes().length == 0;
                    this.setAvailableTimes(this._parseTimeDimensionFromCapabilities(data));
                    if (this._setDefaultTime && this._timeDimension) this._timeDimension.setCurrentTime(this._defaultTime);
                }
            }).bind(this));
            oReq.overrideMimeType("application/xml");
            oReq.open("GET", url);
            oReq.send();
        },
        _getCapabilitiesUrl: function() {
            var url = this._baseLayer.getURL();
            if (this._getCapabilitiesAlternateUrl) url = this._getCapabilitiesAlternateUrl;
            var params = L.extend({}, this._getCapabilitiesParams, {
                "request": "GetCapabilities",
                "service": "WMS",
                "version": this._wmsVersion
            });
            url = url + L.Util.getParamString(params, url, params.uppercase);
            return url;
        },
        _parseTimeDimensionFromCapabilities: function(xml) {
            var layers = xml.querySelectorAll('Layer[queryable="1"]');
            var layerName = this._baseLayer.wmsParams.layers;
            var layer = null;
            var times = null;
            layers.forEach(function(current) {
                if (current.querySelector("Name").innerHTML === layerName) layer = current;
            });
            if (layer) {
                times = this._getTimesFromLayerCapabilities(layer);
                if (!times) times = this._getTimesFromLayerCapabilities(layer.parentNode);
            }
            return times;
        },
        _getTimesFromLayerCapabilities: function(layer) {
            var times = null;
            var nodes = layer.children;
            for(var i = 0, l = nodes.length; i < l; i++){
                if (nodes[i].nodeName !== "Extent" && nodes[i].nodeName !== "Dimension") continue;
                if (nodes[i].getAttribute("name") !== "time") continue;
                if (!nodes[i].textContent.length) continue;
                times = nodes[i].textContent.trim();
                break;
            }
            return times;
        },
        _getDefaultTimeFromCapabilities: function(xml) {
            var layers = xml.querySelectorAll('Layer[queryable="1"]');
            var layerName = this._baseLayer.wmsParams.layers;
            var layer = null;
            layers.forEach(function(current) {
                if (current.querySelector("Name").innerHTML === layerName) layer = current;
            });
            var defaultTime = 0;
            if (layer) {
                defaultTime = this._getDefaultTimeFromLayerCapabilities(layer);
                if (defaultTime == 0) defaultTime = this._getDefaultTimeFromLayerCapabilities(layer.parentNode);
            }
            return defaultTime;
        },
        _getDefaultTimeFromLayerCapabilities: function(layer) {
            var defaultTime = 0;
            var nodes = layer.children;
            for(var i = 0, l = nodes.length; i < l; i++){
                if (nodes[i].nodeName !== "Extent" && nodes[i].nodeName !== "Dimension") continue;
                if (nodes[i].getAttribute("name") !== "time") continue;
                if (!nodes[i].attributes.default) continue;
                if (!nodes[i].attributes.default.textContent.length) continue;
                defaultTime = nodes[i].attributes.default.textContent.trim();
                break;
            }
            return defaultTime;
        },
        setAvailableTimes: function(times) {
            this._availableTimes = L.TimeDimension.Util.parseTimesExpression(times, this._period);
            this._updateTimeDimensionAvailableTimes();
        },
        _updateTimeDimensionAvailableTimes: function() {
            if (this._timeDimension && this._updateTimeDimension || this._timeDimension && this._timeDimension.getAvailableTimes().length == 0) {
                this._timeDimension.setAvailableTimes(this._availableTimes, this._updateTimeDimensionMode);
                if (this._setDefaultTime && this._defaultTime > 0) this._timeDimension.setCurrentTime(this._defaultTime);
            }
        },
        _getNearestTime: function(time) {
            if (this._layers.hasOwnProperty(time)) return time;
            if (this._availableTimes.length == 0) return time;
            var index = 0;
            var len = this._availableTimes.length;
            for(; index < len; index++){
                if (time < this._availableTimes[index]) break;
            }
            // We've found the first index greater than the time. Get the previous
            if (index > 0) index--;
            this._availableTimes[index];
            return this._availableTimes[index];
        }
    });
    if (!L.NonTiledLayer) L.NonTiledLayer = (L.Layer || L.Class).extend({});
    L.NonTiledLayer.include({
        _visible: true,
        _loaded: false,
        _originalUpdate: L.NonTiledLayer.prototype._update,
        _originalOnRemove: L.NonTiledLayer.prototype.onRemove,
        _update: function() {
            if (!this._visible && this._loaded) return;
            this._originalUpdate();
        },
        onRemove: function(map) {
            this._loaded = false;
            this._originalOnRemove(map);
        },
        setLoaded: function(loaded) {
            this._loaded = loaded;
        },
        isLoaded: function() {
            return this._loaded;
        },
        hide: function() {
            this._visible = false;
            this._div.style.display = "none";
        },
        show: function() {
            this._visible = true;
            this._div.style.display = "block";
        },
        getURL: function() {
            return this._wmsUrl;
        }
    });
    L.TileLayer.include({
        _visible: true,
        _loaded: false,
        _originalUpdate: L.TileLayer.prototype._update,
        _update: function() {
            if (!this._visible && this._loaded) return;
            this._originalUpdate();
        },
        setLoaded: function(loaded) {
            this._loaded = loaded;
        },
        isLoaded: function() {
            return this._loaded;
        },
        hide: function() {
            this._visible = false;
            if (this._container) this._container.style.display = "none";
        },
        show: function() {
            this._visible = true;
            if (this._container) this._container.style.display = "block";
        },
        getURL: function() {
            return this._url;
        }
    });
    L.timeDimension.layer.wms = function(layer, options) {
        return new L.TimeDimension.Layer.WMS(layer, options);
    };
    /*
 * L.TimeDimension.Layer.GeoJson:
 */ L.TimeDimension.Layer.GeoJson = L.TimeDimension.Layer.extend({
        initialize: function(layer, options) {
            L.TimeDimension.Layer.prototype.initialize.call(this, layer, options);
            this._updateTimeDimension = this.options.updateTimeDimension || false;
            this._updateTimeDimensionMode = this.options.updateTimeDimensionMode || "extremes"; // 'union', 'replace' or extremes
            this._duration = this.options.duration || null;
            this._addlastPoint = this.options.addlastPoint || false;
            this._waitForReady = this.options.waitForReady || false;
            this._defaultTime = 0;
            this._availableTimes = [];
            this._loaded = false;
            if (this._baseLayer.getLayers().length == 0) {
                if (this._waitForReady) this._baseLayer.on("ready", this._onReadyBaseLayer, this);
                else this._loaded = true;
            } else {
                this._loaded = true;
                this._setAvailableTimes();
            }
            // reload available times if data is added to the base layer
            this._baseLayer.on("layeradd", (function() {
                if (this._loaded) this._setAvailableTimes();
            }).bind(this));
        },
        onAdd: function(map) {
            L.TimeDimension.Layer.prototype.onAdd.call(this, map);
            if (this._loaded) this._setAvailableTimes();
        },
        eachLayer: function(method, context) {
            if (this._currentLayer) method.call(context, this._currentLayer);
            return L.TimeDimension.Layer.prototype.eachLayer.call(this, method, context);
        },
        isReady: function(time) {
            return this._loaded;
        },
        _update: function() {
            if (!this._map) return;
            if (!this._loaded) return;
            var time = this._timeDimension.getCurrentTime();
            var maxTime = this._timeDimension.getCurrentTime(), minTime = 0;
            if (this._duration) {
                var date = new Date(maxTime);
                L.TimeDimension.Util.subtractTimeDuration(date, this._duration, true);
                minTime = date.getTime();
            }
            // new coordinates:
            var layer = L.geoJson(null, this._baseLayer.options);
            var layers = this._baseLayer.getLayers();
            for(var i = 0, l = layers.length; i < l; i++){
                var feature = this._getFeatureBetweenDates(layers[i].feature, minTime, maxTime);
                if (feature) {
                    layer.addData(feature);
                    if (this._addlastPoint && feature.geometry.type == "LineString") {
                        if (feature.geometry.coordinates.length > 0) {
                            var properties = feature.properties;
                            properties.last = true;
                            layer.addData({
                                type: "Feature",
                                properties: properties,
                                geometry: {
                                    type: "Point",
                                    coordinates: feature.geometry.coordinates[feature.geometry.coordinates.length - 1]
                                }
                            });
                        }
                    }
                }
            }
            if (this._currentLayer) this._map.removeLayer(this._currentLayer);
            if (layer.getLayers().length) {
                layer.addTo(this._map);
                this._currentLayer = layer;
            }
        },
        _setAvailableTimes: function() {
            var times = [];
            var layers = this._baseLayer.getLayers();
            for(var i = 0, l = layers.length; i < l; i++)if (layers[i].feature) {
                var featureTimes = this._getFeatureTimes(layers[i].feature);
                for(var j = 0, m = featureTimes.length; j < m; j++)times.push(featureTimes[j]);
            }
            this._availableTimes = L.TimeDimension.Util.sort_and_deduplicate(times);
            if (this._timeDimension && (this._updateTimeDimension || this._timeDimension.getAvailableTimes().length == 0)) this._timeDimension.setAvailableTimes(this._availableTimes, this._updateTimeDimensionMode);
        },
        _getFeatureTimes: function(feature) {
            if (!feature.featureTimes) {
                if (!feature.properties) feature.featureTimes = [];
                else if (feature.properties.hasOwnProperty("coordTimes")) feature.featureTimes = feature.properties.coordTimes;
                else if (feature.properties.hasOwnProperty("times")) feature.featureTimes = feature.properties.times;
                else if (feature.properties.hasOwnProperty("linestringTimestamps")) feature.featureTimes = feature.properties.linestringTimestamps;
                else if (feature.properties.hasOwnProperty("time")) feature.featureTimes = [
                    feature.properties.time
                ];
                else feature.featureTimes = [];
                // String dates to ms
                for(var i = 0, l = feature.featureTimes.length; i < l; i++){
                    var time = feature.featureTimes[i];
                    if (typeof time == "string" || time instanceof String) {
                        time = Date.parse(time.trim());
                        feature.featureTimes[i] = time;
                    }
                }
            }
            return feature.featureTimes;
        },
        _getFeatureBetweenDates: function(feature, minTime, maxTime) {
            var featureTimes = this._getFeatureTimes(feature);
            if (featureTimes.length == 0) return feature;
            var index_min = null, index_max = null, l = featureTimes.length;
            if (featureTimes[0] > maxTime || featureTimes[l - 1] < minTime) return null;
            if (featureTimes[l - 1] > minTime) for(var i = 0; i < l; i++){
                if (index_min === null && featureTimes[i] > minTime) // set index_min the first time that current time is greater the minTime
                index_min = i;
                if (featureTimes[i] > maxTime) {
                    index_max = i;
                    break;
                }
            }
            if (index_min === null) index_min = 0;
            if (index_max === null) index_max = l;
            var new_coordinates = [];
            if (feature.geometry.coordinates[0].length) new_coordinates = feature.geometry.coordinates.slice(index_min, index_max);
            else new_coordinates = feature.geometry.coordinates;
            return {
                type: "Feature",
                properties: feature.properties,
                geometry: {
                    type: feature.geometry.type,
                    coordinates: new_coordinates
                }
            };
        },
        _onReadyBaseLayer: function() {
            this._loaded = true;
            this._setAvailableTimes();
            this._update();
        }
    });
    L.timeDimension.layer.geoJson = function(layer, options) {
        return new L.TimeDimension.Layer.GeoJson(layer, options);
    };
    /*jshint indent: 4, browser:true*/ /*global L*/ /*
 * L.TimeDimension.Player
 */ //'use strict';
    L.TimeDimension.Player = (L.Layer || L.Class).extend({
        includes: L.Evented || L.Mixin.Events,
        initialize: function(options, timeDimension) {
            L.setOptions(this, options);
            this._timeDimension = timeDimension;
            this._paused = false;
            this._buffer = this.options.buffer || 5;
            this._minBufferReady = this.options.minBufferReady || 1;
            this._waitingForBuffer = false;
            this._loop = this.options.loop || false;
            this._steps = 1;
            this._timeDimension.on("timeload", (function(data) {
                this.release(); // free clock
                this._waitingForBuffer = false; // reset buffer
            }).bind(this));
            this.setTransitionTime(this.options.transitionTime || 1000);
            this._timeDimension.on("limitschanged availabletimeschanged timeload", (function(data) {
                this._timeDimension.prepareNextTimes(this._steps, this._minBufferReady, this._loop);
            }).bind(this));
        },
        _tick: function() {
            var maxIndex = this._getMaxIndex();
            var maxForward = this._timeDimension.getCurrentTimeIndex() >= maxIndex && this._steps > 0;
            var maxBackward = this._timeDimension.getCurrentTimeIndex() == 0 && this._steps < 0;
            if (maxForward || maxBackward) // we reached the last step
            {
                if (!this._loop) {
                    this.pause();
                    this.stop();
                    this.fire("animationfinished");
                    return;
                }
            }
            if (this._paused) return;
            var numberNextTimesReady = 0, buffer = this._bufferSize;
            if (this._minBufferReady > 0) {
                numberNextTimesReady = this._timeDimension.getNumberNextTimesReady(this._steps, buffer, this._loop);
                // If the player was waiting, check if all times are loaded
                if (this._waitingForBuffer) {
                    if (numberNextTimesReady < buffer) {
                        this.fire("waiting", {
                            buffer: buffer,
                            available: numberNextTimesReady
                        });
                        return;
                    } else {
                        // all times loaded
                        this.fire("running");
                        this._waitingForBuffer = false;
                    }
                } else // check if player has to stop to wait and force to full all the buffer
                if (numberNextTimesReady < this._minBufferReady) {
                    this._waitingForBuffer = true;
                    this._timeDimension.prepareNextTimes(this._steps, buffer, this._loop);
                    this.fire("waiting", {
                        buffer: buffer,
                        available: numberNextTimesReady
                    });
                    return;
                }
            }
            this.pause();
            this._timeDimension.nextTime(this._steps, this._loop);
            if (buffer > 0) this._timeDimension.prepareNextTimes(this._steps, buffer, this._loop);
        },
        _getMaxIndex: function() {
            return Math.min(this._timeDimension.getAvailableTimes().length - 1, this._timeDimension.getUpperLimitIndex() || Infinity);
        },
        start: function(numSteps) {
            if (this._intervalID) return;
            this._steps = numSteps || 1;
            this._waitingForBuffer = false;
            if (this.options.startOver) {
                if (this._timeDimension.getCurrentTimeIndex() === this._getMaxIndex()) this._timeDimension.setCurrentTimeIndex(this._timeDimension.getLowerLimitIndex() || 0);
            }
            this.release();
            this._intervalID = window.setInterval(L.bind(this._tick, this), this._transitionTime);
            this._tick();
            this.fire("play");
            this.fire("running");
        },
        stop: function() {
            if (!this._intervalID) return;
            clearInterval(this._intervalID);
            this._intervalID = null;
            this._waitingForBuffer = false;
            this.fire("stop");
        },
        pause: function() {
            this._paused = true;
        },
        release: function() {
            this._paused = false;
        },
        getTransitionTime: function() {
            return this._transitionTime;
        },
        isPlaying: function() {
            return this._intervalID ? true : false;
        },
        isWaiting: function() {
            return this._waitingForBuffer;
        },
        isLooped: function() {
            return this._loop;
        },
        setLooped: function(looped) {
            this._loop = looped;
            this.fire("loopchange", {
                loop: looped
            });
        },
        setTransitionTime: function(transitionTime) {
            this._transitionTime = transitionTime;
            if (typeof this._buffer === "function") this._bufferSize = this._buffer.call(this, this._transitionTime, this._minBufferReady, this._loop);
            else this._bufferSize = this._buffer;
            if (this._intervalID) {
                this.stop();
                this.start(this._steps);
            }
            this.fire("speedchange", {
                transitionTime: transitionTime,
                buffer: this._bufferSize
            });
        },
        getSteps: function() {
            return this._steps;
        }
    });
    /*jshint indent: 4, browser:true*/ /*global L*/ /*
 * L.Control.TimeDimension: Leaflet control to manage a timeDimension
 */ L.UI = L.ui = L.UI || {};
    L.UI.Knob = L.Draggable.extend({
        options: {
            className: "knob",
            step: 1,
            rangeMin: 0,
            rangeMax: 10
        },
        initialize: function(slider, options) {
            L.setOptions(this, options);
            this._element = L.DomUtil.create("div", this.options.className || "knob", slider);
            L.Draggable.prototype.initialize.call(this, this._element, this._element);
            this._container = slider;
            this.on("predrag", function() {
                this._newPos.y = 0;
                this._newPos.x = this._adjustX(this._newPos.x);
            }, this);
            this.on("dragstart", function() {
                L.DomUtil.addClass(slider, "dragging");
            });
            this.on("dragend", function() {
                L.DomUtil.removeClass(slider, "dragging");
            });
            L.DomEvent.on(this._element, "dblclick", function(e) {
                this.fire("dblclick", e);
            }, this);
            L.DomEvent.disableClickPropagation(this._element);
            this.enable();
        },
        _getProjectionCoef: function() {
            return (this.options.rangeMax - this.options.rangeMin) / (this._container.offsetWidth || this._container.style.width);
        },
        _update: function() {
            this.setPosition(L.DomUtil.getPosition(this._element).x);
        },
        _adjustX: function(x) {
            var value = this._toValue(x) || this.getMinValue();
            return this._toX(this._adjustValue(value));
        },
        _adjustValue: function(value) {
            value = Math.max(this.getMinValue(), Math.min(this.getMaxValue(), value)); //clamp value
            value = value - this.options.rangeMin; //offsets to zero
            //snap the value to the closet step
            value = Math.round(value / this.options.step) * this.options.step;
            value = value + this.options.rangeMin; //restore offset
            value = Math.round(value * 100) / 100; // *100/100 to avoid floating point precision problems
            return value;
        },
        _toX: function(value) {
            var x = (value - this.options.rangeMin) / this._getProjectionCoef();
            //
            return x;
        },
        _toValue: function(x) {
            var v = x * this._getProjectionCoef() + this.options.rangeMin;
            //
            return v;
        },
        getMinValue: function() {
            return this.options.minValue || this.options.rangeMin;
        },
        getMaxValue: function() {
            return this.options.maxValue || this.options.rangeMax;
        },
        setStep: function(step) {
            this.options.step = step;
            this._update();
        },
        setPosition: function(x) {
            L.DomUtil.setPosition(this._element, L.point(this._adjustX(x), 0));
            this.fire("positionchanged");
        },
        getPosition: function() {
            return L.DomUtil.getPosition(this._element).x;
        },
        setValue: function(v) {
            //
            this.setPosition(this._toX(v));
        },
        getValue: function() {
            return this._adjustValue(this._toValue(this.getPosition()));
        }
    });
    /*
 * L.Control.TimeDimension: Leaflet control to manage a timeDimension
 */ L.Control.TimeDimension = L.Control.extend({
        options: {
            styleNS: "leaflet-control-timecontrol",
            position: "bottomleft",
            title: "Time Control",
            backwardButton: true,
            forwardButton: true,
            playButton: true,
            playReverseButton: false,
            loopButton: false,
            displayDate: true,
            timeSlider: true,
            timeSliderDragUpdate: false,
            limitSliders: false,
            limitMinimumRange: 5,
            speedSlider: true,
            minSpeed: 0.1,
            maxSpeed: 10,
            speedStep: 0.1,
            timeSteps: 1,
            autoPlay: false,
            playerOptions: {
                transitionTime: 1000
            },
            timeZones: [
                "UTC",
                "Local"
            ]
        },
        initialize: function(options) {
            L.setOptions(options);
            L.Control.prototype.initialize.call(this, options);
            this._timeZoneIndex = 0;
            this._timeDimension = this.options.timeDimension || null;
        },
        onAdd: function(map) {
            var container;
            this._map = map;
            if (!this._timeDimension && map.timeDimension) this._timeDimension = map.timeDimension;
            this._initPlayer();
            container = L.DomUtil.create("div", "leaflet-bar leaflet-bar-horizontal leaflet-bar-timecontrol");
            if (this.options.backwardButton) this._buttonBackward = this._createButton("Backward", container);
            if (this.options.playReverseButton) this._buttonPlayReversePause = this._createButton("Play Reverse", container);
            if (this.options.playButton) this._buttonPlayPause = this._createButton("Play", container);
            if (this.options.forwardButton) this._buttonForward = this._createButton("Forward", container);
            if (this.options.loopButton) this._buttonLoop = this._createButton("Loop", container);
            if (this.options.displayDate) this._displayDate = this._createButton("Date", container);
            if (this.options.timeSlider) this._sliderTime = this._createSliderTime(this.options.styleNS + " timecontrol-slider timecontrol-dateslider", container);
            if (this.options.speedSlider) this._sliderSpeed = this._createSliderSpeed(this.options.styleNS + " timecontrol-slider timecontrol-speed", container);
            this._steps = this.options.timeSteps || 1;
            this._timeDimension.on("timeload", this._update, this);
            this._timeDimension.on("timeload", this._onPlayerStateChange, this);
            this._timeDimension.on("timeloading", this._onTimeLoading, this);
            this._timeDimension.on("limitschanged availabletimeschanged", this._onTimeLimitsChanged, this);
            L.DomEvent.disableClickPropagation(container);
            return container;
        },
        addTo: function() {
            //To be notified AFTER the component was added to the DOM
            L.Control.prototype.addTo.apply(this, arguments);
            this._onPlayerStateChange();
            this._onTimeLimitsChanged();
            this._update();
            return this;
        },
        onRemove: function() {
            this._player.off("play stop running loopchange speedchange", this._onPlayerStateChange, this);
            this._player.off("waiting", this._onPlayerWaiting, this);
            //this._player = null;  keep it for later re-add
            this._timeDimension.off("timeload", this._update, this);
            this._timeDimension.off("timeload", this._onPlayerStateChange, this);
            this._timeDimension.off("timeloading", this._onTimeLoading, this);
            this._timeDimension.off("limitschanged availabletimeschanged", this._onTimeLimitsChanged, this);
        },
        _initPlayer: function() {
            if (!this._player) {
                if (this.options.player) this._player = this.options.player;
                else this._player = new L.TimeDimension.Player(this.options.playerOptions, this._timeDimension);
            }
            if (this.options.autoPlay) this._player.start(this._steps);
            this._player.on("play stop running loopchange speedchange", this._onPlayerStateChange, this);
            this._player.on("waiting", this._onPlayerWaiting, this);
            this._onPlayerStateChange();
        },
        _onTimeLoading: function(data) {
            if (data.time == this._timeDimension.getCurrentTime()) {
                if (this._displayDate) L.DomUtil.addClass(this._displayDate, "loading");
            }
        },
        _onTimeLimitsChanged: function() {
            var lowerIndex = this._timeDimension.getLowerLimitIndex(), upperIndex = this._timeDimension.getUpperLimitIndex(), max = this._timeDimension.getAvailableTimes().length - 1;
            if (this._limitKnobs) {
                this._limitKnobs[0].options.rangeMax = max;
                this._limitKnobs[1].options.rangeMax = max;
                this._limitKnobs[0].setValue(lowerIndex || 0);
                this._limitKnobs[1].setValue(upperIndex || max);
            }
            if (this._sliderTime) {
                this._sliderTime.options.rangeMax = max;
                this._sliderTime._update();
            }
        },
        _onPlayerWaiting: function(evt) {
            if (this._buttonPlayPause && this._player.getSteps() > 0) {
                L.DomUtil.addClass(this._buttonPlayPause, "loading");
                this._buttonPlayPause.innerHTML = this._getDisplayLoadingText(evt.available, evt.buffer);
            }
            if (this._buttonPlayReversePause && this._player.getSteps() < 0) {
                L.DomUtil.addClass(this._buttonPlayReversePause, "loading");
                this._buttonPlayReversePause.innerHTML = this._getDisplayLoadingText(evt.available, evt.buffer);
            }
        },
        _onPlayerStateChange: function() {
            if (this._buttonPlayPause) {
                if (this._player.isPlaying() && this._player.getSteps() > 0) {
                    L.DomUtil.addClass(this._buttonPlayPause, "pause");
                    L.DomUtil.removeClass(this._buttonPlayPause, "play");
                } else {
                    L.DomUtil.removeClass(this._buttonPlayPause, "pause");
                    L.DomUtil.addClass(this._buttonPlayPause, "play");
                }
                if (this._player.isWaiting() && this._player.getSteps() > 0) L.DomUtil.addClass(this._buttonPlayPause, "loading");
                else {
                    this._buttonPlayPause.innerHTML = "";
                    L.DomUtil.removeClass(this._buttonPlayPause, "loading");
                }
            }
            if (this._buttonPlayReversePause) {
                if (this._player.isPlaying() && this._player.getSteps() < 0) L.DomUtil.addClass(this._buttonPlayReversePause, "pause");
                else L.DomUtil.removeClass(this._buttonPlayReversePause, "pause");
                if (this._player.isWaiting() && this._player.getSteps() < 0) L.DomUtil.addClass(this._buttonPlayReversePause, "loading");
                else {
                    this._buttonPlayReversePause.innerHTML = "";
                    L.DomUtil.removeClass(this._buttonPlayReversePause, "loading");
                }
            }
            if (this._buttonLoop) {
                if (this._player.isLooped()) L.DomUtil.addClass(this._buttonLoop, "looped");
                else L.DomUtil.removeClass(this._buttonLoop, "looped");
            }
            if (this._sliderSpeed && !this._draggingSpeed) {
                var speed = this._player.getTransitionTime() || 1000; //transitionTime
                speed = Math.round(10000 / speed) / 10; // 1s / transition
                this._sliderSpeed.setValue(speed);
            }
        },
        _update: function() {
            if (!this._timeDimension) return;
            if (this._timeDimension.getCurrentTimeIndex() >= 0) {
                var date = new Date(this._timeDimension.getCurrentTime());
                if (this._displayDate) {
                    L.DomUtil.removeClass(this._displayDate, "loading");
                    this._displayDate.innerHTML = this._getDisplayDateFormat(date);
                }
                if (this._sliderTime && !this._slidingTimeSlider) this._sliderTime.setValue(this._timeDimension.getCurrentTimeIndex());
            } else if (this._displayDate) this._displayDate.innerHTML = this._getDisplayNoTimeError();
        },
        _createButton: function(title, container) {
            var link = L.DomUtil.create("a", this.options.styleNS + " timecontrol-" + title.toLowerCase(), container);
            link.href = "#";
            link.title = title;
            L.DomEvent.addListener(link, "click", L.DomEvent.stopPropagation).addListener(link, "click", L.DomEvent.preventDefault).addListener(link, "click", this["_button" + title.replace(/ /i, "") + "Clicked"], this);
            return link;
        },
        _createSliderTime: function(className, container) {
            var sliderContainer, sliderbar, max, knob, limits;
            sliderContainer = L.DomUtil.create("div", className, container);
            /*L.DomEvent
            .addListener(sliderContainer, 'click', L.DomEvent.stopPropagation)
            .addListener(sliderContainer, 'click', L.DomEvent.preventDefault);*/ sliderbar = L.DomUtil.create("div", "slider", sliderContainer);
            max = this._timeDimension.getAvailableTimes().length - 1;
            if (this.options.limitSliders) limits = this._limitKnobs = this._createLimitKnobs(sliderbar);
            knob = new L.UI.Knob(sliderbar, {
                className: "knob main",
                rangeMin: 0,
                rangeMax: max
            });
            knob.on("dragend", function(e) {
                var value = e.target.getValue();
                this._sliderTimeValueChanged(value);
                this._slidingTimeSlider = false;
            }, this);
            knob.on("drag", function(e) {
                this._slidingTimeSlider = true;
                var time = this._timeDimension.getAvailableTimes()[e.target.getValue()];
                if (time) {
                    var date = new Date(time);
                    if (this._displayDate) this._displayDate.innerHTML = this._getDisplayDateFormat(date);
                    if (this.options.timeSliderDragUpdate) this._sliderTimeValueChanged(e.target.getValue());
                }
            }, this);
            knob.on("predrag", function() {
                var minPosition, maxPosition;
                if (limits) {
                    //limits the position between lower and upper knobs
                    minPosition = limits[0].getPosition();
                    maxPosition = limits[1].getPosition();
                    if (this._newPos.x < minPosition) this._newPos.x = minPosition;
                    if (this._newPos.x > maxPosition) this._newPos.x = maxPosition;
                }
            }, knob);
            L.DomEvent.on(sliderbar, "click", function(e) {
                if (L.DomUtil.hasClass(e.target, "knob")) return; //prevent value changes on drag release
                var first = e.touches && e.touches.length === 1 ? e.touches[0] : e, x = L.DomEvent.getMousePosition(first, sliderbar).x;
                if (limits) {
                    if (limits[0].getPosition() <= x && x <= limits[1].getPosition()) {
                        knob.setPosition(x);
                        this._sliderTimeValueChanged(knob.getValue());
                    }
                } else {
                    knob.setPosition(x);
                    this._sliderTimeValueChanged(knob.getValue());
                }
            }, this);
            knob.setPosition(0);
            return knob;
        },
        _createLimitKnobs: function(sliderbar) {
            L.DomUtil.addClass(sliderbar, "has-limits");
            var max = this._timeDimension.getAvailableTimes().length - 1;
            var rangeBar = L.DomUtil.create("div", "range", sliderbar);
            var lknob = new L.UI.Knob(sliderbar, {
                className: "knob lower",
                rangeMin: 0,
                rangeMax: max
            });
            var uknob = new L.UI.Knob(sliderbar, {
                className: "knob upper",
                rangeMin: 0,
                rangeMax: max
            });
            L.DomUtil.setPosition(rangeBar, 0);
            lknob.setPosition(0);
            uknob.setPosition(max);
            //Add listeners for value changes
            lknob.on("dragend", function(e) {
                var value = e.target.getValue();
                this._sliderLimitsValueChanged(value, uknob.getValue());
            }, this);
            uknob.on("dragend", function(e) {
                var value = e.target.getValue();
                this._sliderLimitsValueChanged(lknob.getValue(), value);
            }, this);
            //Add listeners to position the range bar
            lknob.on("drag positionchanged", function() {
                L.DomUtil.setPosition(rangeBar, L.point(lknob.getPosition(), 0));
                rangeBar.style.width = uknob.getPosition() - lknob.getPosition() + "px";
            }, this);
            uknob.on("drag positionchanged", function() {
                rangeBar.style.width = uknob.getPosition() - lknob.getPosition() + "px";
            }, this);
            //Add listeners to prevent overlaps
            uknob.on("predrag", function() {
                //bond upper to lower
                var lowerPosition = lknob._toX(lknob.getValue() + this.options.limitMinimumRange);
                if (uknob._newPos.x <= lowerPosition) uknob._newPos.x = lowerPosition;
            }, this);
            lknob.on("predrag", function() {
                //bond lower to upper
                var upperPosition = uknob._toX(uknob.getValue() - this.options.limitMinimumRange);
                if (lknob._newPos.x >= upperPosition) lknob._newPos.x = upperPosition;
            }, this);
            lknob.on("dblclick", function() {
                this._timeDimension.setLowerLimitIndex(0);
            }, this);
            uknob.on("dblclick", function() {
                this._timeDimension.setUpperLimitIndex(this._timeDimension.getAvailableTimes().length - 1);
            }, this);
            return [
                lknob,
                uknob
            ];
        },
        _createSliderSpeed: function(className, container) {
            var sliderContainer = L.DomUtil.create("div", className, container);
            /* L.DomEvent
            .addListener(sliderContainer, 'click', L.DomEvent.stopPropagation)
            .addListener(sliderContainer, 'click', L.DomEvent.preventDefault);
*/ var speedLabel = L.DomUtil.create("span", "speed", sliderContainer);
            var sliderbar = L.DomUtil.create("div", "slider", sliderContainer);
            var initialSpeed = Math.round(10000 / (this._player.getTransitionTime() || 1000)) / 10;
            speedLabel.innerHTML = this._getDisplaySpeed(initialSpeed);
            var knob = new L.UI.Knob(sliderbar, {
                step: this.options.speedStep,
                rangeMin: this.options.minSpeed,
                rangeMax: this.options.maxSpeed
            });
            knob.on("dragend", function(e) {
                var value = e.target.getValue();
                this._draggingSpeed = false;
                speedLabel.innerHTML = this._getDisplaySpeed(value);
                this._sliderSpeedValueChanged(value);
            }, this);
            knob.on("drag", function(e) {
                this._draggingSpeed = true;
                speedLabel.innerHTML = this._getDisplaySpeed(e.target.getValue());
            }, this);
            knob.on("positionchanged", function(e) {
                speedLabel.innerHTML = this._getDisplaySpeed(e.target.getValue());
            }, this);
            L.DomEvent.on(sliderbar, "click", function(e) {
                if (e.target === knob._element) return; //prevent value changes on drag release
                var first = e.touches && e.touches.length === 1 ? e.touches[0] : e, x = L.DomEvent.getMousePosition(first, sliderbar).x;
                knob.setPosition(x);
                speedLabel.innerHTML = this._getDisplaySpeed(knob.getValue());
                this._sliderSpeedValueChanged(knob.getValue());
            }, this);
            return knob;
        },
        _buttonBackwardClicked: function() {
            this._timeDimension.previousTime(this._steps);
        },
        _buttonForwardClicked: function() {
            this._timeDimension.nextTime(this._steps);
        },
        _buttonLoopClicked: function() {
            this._player.setLooped(!this._player.isLooped());
        },
        _buttonPlayClicked: function() {
            if (this._player.isPlaying()) this._player.stop();
            else this._player.start(this._steps);
        },
        _buttonPlayReverseClicked: function() {
            if (this._player.isPlaying()) this._player.stop();
            else this._player.start(this._steps * -1);
        },
        _buttonDateClicked: function() {
            this._switchTimeZone();
        },
        _sliderTimeValueChanged: function(newValue) {
            this._timeDimension.setCurrentTimeIndex(newValue);
        },
        _sliderLimitsValueChanged: function(lowerLimit, upperLimit) {
            this._timeDimension.setLowerLimitIndex(lowerLimit);
            this._timeDimension.setUpperLimitIndex(upperLimit);
        },
        _sliderSpeedValueChanged: function(newValue) {
            this._player.setTransitionTime(1000 / newValue);
        },
        _getCurrentTimeZone: function() {
            return this.options.timeZones[this._timeZoneIndex];
        },
        _switchTimeZone: function() {
            if (this._getCurrentTimeZone().toLowerCase() == "utc") L.DomUtil.removeClass(this._displayDate, "utc");
            this._timeZoneIndex = (this._timeZoneIndex + 1) % this.options.timeZones.length;
            var timeZone = this._getCurrentTimeZone();
            if (timeZone.toLowerCase() == "utc") {
                L.DomUtil.addClass(this._displayDate, "utc");
                this._displayDate.title = "UTC Time";
            } else if (timeZone.toLowerCase() == "local") this._displayDate.title = "Local Time";
            else this._displayDate.title = timeZone;
            this._update();
        },
        _getDisplayDateFormat: function(date) {
            var timeZone = this._getCurrentTimeZone();
            if (timeZone.toLowerCase() == "utc") return date.toISOString();
            if (timeZone.toLowerCase() == "local") return date.toLocaleString();
            return date.toLocaleString([], {
                timeZone: timeZone,
                timeZoneName: "short"
            });
        },
        _getDisplaySpeed: function(fps) {
            return fps + "fps";
        },
        _getDisplayLoadingText: function(available, buffer) {
            return "<span>" + Math.floor(available / buffer * 100) + "%</span>";
        },
        _getDisplayNoTimeError: function() {
            return "Time not available";
        }
    });
    L.Map.addInitHook(function() {
        if (this.options.timeDimensionControl) {
            this.timeDimensionControl = L.control.timeDimension(this.options.timeDimensionControlOptions || {});
            this.addControl(this.timeDimensionControl);
        }
    });
    L.control.timeDimension = function(options) {
        return new L.Control.TimeDimension(options);
    };
    return L.TimeDimension;
}, window);




class $d7ccdeb70b525f3c$export$2e2bcd8739ae039 {
    constructor(id, options){
        var defaultOptions = {
            mapStartCenter: (0, (/*@__PURE__*/$parcel$interopDefault($8wu30))).latLng(39.20, -109.518),
            // nice position for fullscreen map of the US
            mapStartZoom: 4,
            refreshWait: 300000,
            panWait: 600,
            infoBoxId: null
        };
        this.el = id;
        this.options = defaultOptions;
        (0, (/*@__PURE__*/$parcel$interopDefault($8wu30))).Util.setOptions(this, options); // merge constructor options with this.options (defaults)
        this.is_chrome = navigator.userAgent.toLowerCase().indexOf("chrome") > -1;
        this.is_ie = $("html").hasClass("ie");
        this.mapControls = {};
        this.layers = {}; // type L.Layer
        this.layerManagers = {}; // type AbstractLayerManager
        this.auxFeeds = {};
        this.auxRequestTasks = [];
        this.mapLastPosPx;
        this.loadingStack = [];
        this.loadingListeners = {}; // UI listeners for loading change events (e.g. spinner)
        this.autoUpdateListeners = {};
        this.mapMoveListeners = {};
        this.gpsTracked = false;
        this.Plugins = {};
        this.activeTimers = {};
        this.clickResponderCache = {};
        this.clickResponderCacheIdx = [];
        this.popup = null;
        this.hookListeners = {};
        // Compute required options
        if (this.options.mobileDevice === undefined) this.options.mobileDevice = (0, (/*@__PURE__*/$parcel$interopDefault($8wu30))).Browser.mobile;
        this.options.smallScreen = window.matchMedia("(max-width: 760px)").matches;
        // Hack to allow this L to refer to plugins not using import() syntax
        this.L = window["L"];
    }
    mapInit() {
        // Hack to allow this L to refer to plugins not using import() syntax
        const L = window["L"];
        // Instantiate map
        this.setLoadingMonitor("mapInit", true);
        const _self = this;
        this.map = L.map(this.el, {
            center: this.options.mapStartCenter,
            zoom: this.options.mapStartZoom,
            attributionControl: false,
            markerZoomAnimation: false
        });
        var attrib = L.control.attribution({
            prefix: false
        });
        attrib.addTo(this.map);
        // Create Panes
        this.map.createPane("labels");
        this.map.getPane("labels").style.zIndex = 420;
        this.map.getPane("labels").style.pointerEvents = "none";
        this.map.createPane("overlayOther");
        this.map.getPane("overlayOther").style.zIndex = 620;
        // Create default layers
        var defaultLayer = L.tileLayer.provider("Esri.WorldImagery", {
            attribution: "Tiles &copy; Esri",
            className: "tile-container-satellite"
        });
        this.map.addLayer(defaultLayer);
        var baseLayers = {
            "Satellite": defaultLayer
        };
        this.layerManagers.labelsOverlay = new L.TileLayer("https://tiles-{s}.gis.weatherusa.net/overlay{r}/{z}/{x}/{y}.png", {
            subdomains: "1234",
            zIndex: 1004,
            attribution: 'Labels \xa9 weatherUSA, Map data \xa9 <a href="http://www.openstreetmap.org/copyright">OpenStreetMap contributors</a>',
            pane: "labels",
            className: "tile-container-labels"
        });
        // Turn on city labels by default for satellite base layer
        this.map.addLayer(this.layerManagers.labelsOverlay);
        // Setup map view change events
        this.mapLastPosPx = this.map.getPixelBounds().min;
        this.mapLastPosPx.x = -10;
        this.mapLastPosPx.y = -10;
        this.map.on("moveend zoomend", this.updateMapOnMove, this);
        this.setLoadingMonitor("mapInit", false);
    }
    launchFullScreen(el) {
        if (el.requestFullScreen) el.requestFullScreen();
        else if (el.mozRequestFullScreen) el.mozRequestFullScreen();
        else if (el.webkitRequestFullScreen) el.webkitRequestFullScreen();
    }
    // FIXME broken
    geocodeLocation(field, zoom) {
        this.setLoadingMonitor("geocode", true);
        if (this.requestTasks.jsonRequestGeocode == undefined) this.requestTasks.jsonRequestGeocode = new Request.JSON({
            url: "/api/feed",
            timeout: 10,
            link: "cancel",
            onSuccess: (function(obj) {
                if (typeof obj === "object" && "place" in obj && obj.place[0]) {
                    if (zoom) var zFinal = zoom;
                    else var zFinal = 11;
                    this.updateLocation(obj.place[0].lat, obj.place[0].lon, zFinal);
                }
                this.setLoadingMonitor("geocode", false);
            }).bind(this),
            onError: (function(text, error) {
                // console.log(error);
                this.setLoadingMonitor("geocode", false);
            }).bind(this)
        });
        this.requestTasks.jsonRequestGeocode.get({
            "type": "place",
            "q": field
        });
    }
    updateLocation(lat, lon, zoom) {
        if (zoom) var zFinal = zoom;
        else var zFinal = 12;
        this.map.setView([
            lat,
            lon
        ], zFinal);
    }
    geolocated(pos) {
        this.updateLocation(pos.coords.latitude, pos.coords.longitude, 12);
        var myPosIcon = new (0, (/*@__PURE__*/$parcel$interopDefault($8wu30))).DivIcon({
            iconSize: [
                20,
                20
            ],
            className: "icon-mylocation pulsate",
            html: "<div></div><strong></strong>"
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8wu30))).marker([
            pos.coords.latitude,
            pos.coords.longitude
        ], {
            icon: myPosIcon
        }).addTo(this.map);
    }
    geolocationError(e) {
        switch(e.code){
            case e.PERMISSION_DENIED:
                return false;
            case e.POSITION_UNAVAILABLE:
                msg = "Location information is not available. Please check your GPS settings.";
                break;
            case e.TIMEOUT:
                msg = "Location information temporarily unavailable.";
                break;
            case e.UNKNOWN_ERROR:
                msg = "An unknown error occurred while getting location.";
                break;
        }
        alert(msg);
    }
    setLoadingMonitor(id, on) {
        if (on === false) (0, (/*@__PURE__*/$parcel$interopDefault($c8e7279b4e2eb9b3$exports)))(this.loadingStack, id);
        else this.loadingStack.push(id);
        Object.keys(this.loadingListeners).forEach((k)=>{
            this.loadingListeners[k](this.loadingStack);
        });
    }
    updateMapOnMove() {
        if (!this.activeTimers.hasOwnProperty("mapMoveRefresh")) this.activeTimers.mapMoveRefresh = (0, (/*@__PURE__*/$parcel$interopDefault($0687b27b1e881858$exports)))(this.updateLayersOnViewChange.bind(this), this.options.panWait);
        this.activeTimers.mapMoveRefresh();
    }
    updateLayersOnViewChange() {
        if (Math.abs(this.mapLastPosPx.x - this.map.getPixelBounds().min.x) > 3 || Math.abs(this.mapLastPosPx.y - this.map.getPixelBounds().min.y) > 3) {
            this.mapLastPosPx = this.map.getPixelBounds().min;
            Object.keys(this.mapMoveListeners).forEach(function(k) {
                var fn = this.mapMoveListeners[k];
                if (typeof fn === "string") // name of active layer
                this.layerManagers[fn].refreshLayer();
                else if (typeof fn === "function") // ref to function callee
                return fn();
            }, this);
        }
    }
    updateAllLayersPeriodic() {
        if (!this.activeTimers.hasOwnProperty("globalRefresh")) this.activeTimers.globalRefresh = setInterval(this.updateAllLayers.bind(this), this.options.refreshWait);
    }
    cancelUpdatePeriodic() {
        if (this.activeTimers.hasOwnProperty("globalRefresh")) clearInterval(this.activeTimers.globalRefresh);
        delete this.activeTimers.globalRefresh;
    }
    updateAllLayers() {
        Object.keys(this.autoUpdateListeners).forEach(function(k) {
            var fn = this.autoUpdateListeners[k];
            if (typeof fn === "string") // name of active layer
            this.layerManagers[fn].refreshLayer();
            else if (typeof fn === "function") // ref to function callee
            return fn();
        }, this);
    }
    // from = layer.id, e = event, content = popup HTML content
    // e.singleton = stop event if layer can have overlapping triggers
    // e.
    forwardedClickHandler(from, e, content) {
        if (e._stopped) return;
        var layerManager = this.layerManagers[from];
        // Layer with multiple overlaying polygons or markers should be stopped early
        if (e.singleton === true && this.clickResponderCache[from]) return false;
        if (content) {
            if (!this.clickResponderCache[from]) {
                this.clickResponderCache[from] = {
                    "tablabel": layerManager.popupName || layerManager.name || "",
                    "contents": []
                };
                this.clickResponderCacheIdx.push(from);
            }
            if (!e.coalesce || e.coalesce && this.clickResponderCache[from].contents.length === 0) this.clickResponderCache[from].contents.push(content);
        }
        // Don't propogate simulated clicks, master click will handle cascading thru layers
        if (e._simulatedEvent) return true;
        var target;
        if (e.layer) target = e.layer._icon || e.layer._path || e.target;
        else if (e.target) target = e.target._icon || e.target._path || e.target;
        var removed = [];
        removed.push({
            node: target,
            pointerEvents: target.style.pointerEvents
        });
        target.style.pointerEvents = "none";
        while(target){
            target = document.elementFromPoint(e.clientX || e.originalEvent.clientX, e.clientX || e.originalEvent.clientY);
            if (!target || !target._leaflet_id || target === this.map._container) break;
            let eventedTarget = this.map._targets[target._leaflet_id];
            if (!eventedTarget) break;
            let stopped = !eventedTarget.fire("click", {
                "_simulatedEvent": true,
                latlng: e.latlng
            }, true);
            if (stopped) break;
            removed.push({
                node: target,
                pointerEvents: target.style.pointerEvents
            });
            target.style.pointerEvents = "none";
        }
        for (let rem of removed)rem.node.style.pointerEvents = rem.pointerEvents;
        var popupTabs = '<ul class="nav nav-tabs" role="tablist">';
        var popupTabContent = '<div class="tab-content">';
        // console.log(this.clickResponderCache);
        var shown = false;
        for (let layerId of this.clickResponderCacheIdx){
            let tablabel = this.clickResponderCache[layerId].tablabel;
            let contents = this.clickResponderCache[layerId].contents;
            popupTabs = popupTabs + '<li class="nav-item"><a class="nav-link' + (!shown ? " active" : "") + '" href="#popup_tab_' + layerId + '" data-toggle="tab" role="tab" aria-controls="home" aria-selected="true">' + tablabel + "</a></li>";
            popupTabContent = popupTabContent + '<div class="tab-pane' + (!shown ? " show active" : "") + '" id="popup_tab_' + layerId + '" role="tabpanel">';
            for (let c of contents)popupTabContent = popupTabContent + '<div class="content-section">' + c + "</div>";
            popupTabContent = popupTabContent + "</div>";
            shown = true;
        }
        popupTabs = popupTabs + "</ul>";
        popupTabContent = popupTabContent + "</div>";
        var popupContent = '<div id="popup_silly_container">' + popupTabs + popupTabContent + "</div>";
        // Parse pop-up content so we can call popup.update() later without rebuilding DOM
        var $el = $(popupContent);
        $el.find(".nav-link").on("shown.bs.tab", (e)=>{
            this.popup.update();
        });
        var el = $el.get(0);
        if (this.options.infoBoxId && this.options.smallScreen) {
            document.getElementById(this.options.infoBoxId).innerHTML = popupContent;
            document.getElementById(this.options.infoBoxId + "_wrapper").classList.add("open");
        } else {
            if (this.popup) {
                // Clear old popup first to avoid DOM issue
                let oldPopup = this.popup;
                this.map.closePopup(oldPopup);
            }
            var newPopup = this.L.popup({
                autoPanPadding: this.L.point(32, 10),
                minWidth: 320,
                maxWidth: 555,
                maxHeight: 360
            }).setLatLng(e.latlng).setContent(el);
            this.map.openPopup(newPopup);
            this.popup = newPopup;
        }
        this.clickResponderCache = {};
        this.clickResponderCacheIdx = [];
        return true;
    }
    /* Hooking */ addHook(hid, id, cb) {
        if (this.hookListeners[hid] === undefined) this.hookListeners[hid] = {};
        this.hookListeners[hid][id] = cb;
    }
    removeHook(hid, id) {
        if (this.hookListeners[hid] && this.hookListeners[hid][id]) delete this.hookListeners[hid][id];
    }
    doHook(hid, data) {
        if (hid in this.hookListeners) Object.keys(this.hookListeners[hid]).forEach((k)=>{
            this.hookListeners[hid][k](data);
        });
    }
}
window.weatherNetMap = $d7ccdeb70b525f3c$export$2e2bcd8739ae039;



var $6vz4b = parcelRequire("6vz4b");
/*
 * @namespace Util
 *
 * Various utility functions, used by Leaflet internally.
 */ // @function extend(dest: Object, src?: Object): Object
// Merges the properties of the `src` object (or multiple objects) into `dest` object and returns the latter. Has an `L.extend` shortcut.
function $108a07b41ac6c3b8$export$8b58be045bf06082(dest) {
    var i, j, len, src;
    for(j = 1, len = arguments.length; j < len; j++){
        src = arguments[j];
        for(i in src)dest[i] = src[i];
    }
    return dest;
}
var $108a07b41ac6c3b8$export$185802fd694ee1f5 = Object.create || function() {
    function F() {}
    return function(proto) {
        F.prototype = proto;
        return new F();
    };
}();
function $108a07b41ac6c3b8$export$2385a24977818dd0(fn, obj) {
    var slice = Array.prototype.slice;
    if (fn.bind) return fn.bind.apply(fn, slice.call(arguments, 1));
    var args = slice.call(arguments, 2);
    return function() {
        return fn.apply(obj, args.length ? args.concat(slice.call(arguments)) : arguments);
    };
}
var $108a07b41ac6c3b8$export$be5d847186e3cff2 = 0;
function $108a07b41ac6c3b8$export$bd3fba034e28f6b(obj) {
    if (!("_leaflet_id" in obj)) obj["_leaflet_id"] = ++$108a07b41ac6c3b8$export$be5d847186e3cff2;
    return obj._leaflet_id;
}
function $108a07b41ac6c3b8$export$de363e709c412c8a(fn, time, context) {
    var lock, args, wrapperFn, later;
    later = function() {
        // reset lock and call if queued
        lock = false;
        if (args) {
            wrapperFn.apply(context, args);
            args = false;
        }
    };
    wrapperFn = function() {
        if (lock) // called too soon, queue to call later
        args = arguments;
        else {
            // call and lock until later
            fn.apply(context, arguments);
            setTimeout(later, time);
            lock = true;
        }
    };
    return wrapperFn;
}
function $108a07b41ac6c3b8$export$f6cd9682189b118b(x, range, includeMax) {
    var max = range[1], min = range[0], d = max - min;
    return x === max && includeMax ? x : ((x - min) % d + d) % d + min;
}
function $108a07b41ac6c3b8$export$a3891e81a74c5e40() {
    return false;
}
function $108a07b41ac6c3b8$export$533e61f4ff7f35ce(num, precision) {
    if (precision === false) return num;
    var pow = Math.pow(10, precision === undefined ? 6 : precision);
    return Math.round(num * pow) / pow;
}
function $108a07b41ac6c3b8$export$87c2784dc9fc4ab(str) {
    return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
}
function $108a07b41ac6c3b8$export$3ea6d3c1e1f67aaa(str) {
    return $108a07b41ac6c3b8$export$87c2784dc9fc4ab(str).split(/\s+/);
}
function $108a07b41ac6c3b8$export$add91eafeaeab287(obj, options) {
    if (!Object.prototype.hasOwnProperty.call(obj, "options")) obj.options = obj.options ? $108a07b41ac6c3b8$export$185802fd694ee1f5(obj.options) : {};
    for(var i in options)obj.options[i] = options[i];
    return obj.options;
}
function $108a07b41ac6c3b8$export$27213b73b2075e98(obj, existingUrl, uppercase) {
    var params = [];
    for(var i in obj)params.push(encodeURIComponent(uppercase ? i.toUpperCase() : i) + "=" + encodeURIComponent(obj[i]));
    return (!existingUrl || existingUrl.indexOf("?") === -1 ? "?" : "&") + params.join("&");
}
var $108a07b41ac6c3b8$var$templateRe = /\{ *([\w_ -]+) *\}/g;
function $108a07b41ac6c3b8$export$ce69bd05624d0c48(str, data) {
    return str.replace($108a07b41ac6c3b8$var$templateRe, function(str, key) {
        var value = data[key];
        if (value === undefined) throw new Error("No value provided for variable " + str);
        else if (typeof value === "function") value = value(data);
        return value;
    });
}
var $108a07b41ac6c3b8$export$43bee75e5e14138e = Array.isArray || function(obj) {
    return Object.prototype.toString.call(obj) === "[object Array]";
};
function $108a07b41ac6c3b8$export$305f7d4e9d4624f2(array, el) {
    for(var i = 0; i < array.length; i++){
        if (array[i] === el) return i;
    }
    return -1;
}
var $108a07b41ac6c3b8$export$993f7e5c731d5268 = "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=";
// inspired by https://paulirish.com/2011/requestanimationframe-for-smart-animating/
function $108a07b41ac6c3b8$var$getPrefixed(name) {
    return window["webkit" + name] || window["moz" + name] || window["ms" + name];
}
var $108a07b41ac6c3b8$var$lastTime = 0;
// fallback for IE 7-8
function $108a07b41ac6c3b8$var$timeoutDefer(fn) {
    var time = +new Date(), timeToCall = Math.max(0, 16 - (time - $108a07b41ac6c3b8$var$lastTime));
    $108a07b41ac6c3b8$var$lastTime = time + timeToCall;
    return window.setTimeout(fn, timeToCall);
}
var $108a07b41ac6c3b8$export$2d6f2967c7dddd06 = window.requestAnimationFrame || $108a07b41ac6c3b8$var$getPrefixed("RequestAnimationFrame") || $108a07b41ac6c3b8$var$timeoutDefer;
var $108a07b41ac6c3b8$export$e76ec94050cfc5fa = window.cancelAnimationFrame || $108a07b41ac6c3b8$var$getPrefixed("CancelAnimationFrame") || $108a07b41ac6c3b8$var$getPrefixed("CancelRequestAnimationFrame") || function(id) {
    window.clearTimeout(id);
};
function $108a07b41ac6c3b8$export$d371ad015c199c06(fn, context, immediate) {
    if (immediate && $108a07b41ac6c3b8$export$2d6f2967c7dddd06 === $108a07b41ac6c3b8$var$timeoutDefer) fn.call(context);
    else return $108a07b41ac6c3b8$export$2d6f2967c7dddd06.call(window, $108a07b41ac6c3b8$export$2385a24977818dd0(fn, context));
}
function $108a07b41ac6c3b8$export$e1ed83507f55dc9d(id) {
    if (id) $108a07b41ac6c3b8$export$e76ec94050cfc5fa.call(window, id);
}


class $b2ad9c2bf819e404$export$2e2bcd8739ae039 {
    constructor(id, resultsId, options){
        this.options = {
            resultLimit: 10,
            minInputLength: 2
        };
        this.el = id;
        this.elResults = resultsId;
        (0, $108a07b41ac6c3b8$export$add91eafeaeab287)(this, options); // merge constructor options with this.options (defaults)
        this.request = new (0, $6vz4b.default)({
            url: "https://api.weatherusa.net/v1/feed/place",
            link: "cancel",
            timeout: 15000,
            onSuccess: this.handleResponse.bind(this)
        });
    }
    attachSearchFormListeners() {
        var handler = this;
        $(this.el).on("focus", function() {
            $(this.el).trigger("click");
        });
        $(this.el).on("input", function() {
            if (this.value.length >= handler.options.minInputLength) handler.handleInput(this);
            else $(handler.elResults).empty().append('<a class="dropdown-item" href="#"><em>Enter more characters</em></a>');
        });
    }
    handleInput(el) {
        // FIXME handleInput should be debounced...
        let $e = $(el);
        this.request.get({
            "q": $e.val(),
            "callbackEl": $e.attr("id")
        });
    }
    handleResponse(obj) {
        let resp = obj.body;
        if (!resp.callbackEl) return false;
        var fieldId = "#" + resp.callbackEl;
        if ($(fieldId).length === 0) return false;
        $(fieldId + "_dropdown").empty();
        if (resp.place == false) {
            $(fieldId).empty().append('<a class="dropdown-item" href="#"><em>No matches</em></a>');
            return false;
        }
        // FIXME this part could go into a callback anonymous function to abstract the class
        for (let row of resp.place){
            var placeNameFull = row.name + ", " + row.state;
            if (row.zip) placeNameFull = placeNameFull + " (" + row.zip + ")";
            $(fieldId + "_dropdown").append($('<a class="dropdown-item" href="#"></a>').attr("data-placeid", row.id).attr("data-placename", placeNameFull).attr("data-lat", row.lat).attr("data-lon", row.lon).prop("draggable", false).html(placeNameFull));
        }
        $(fieldId + "_dropdown > a").on("click", function(e) {
            e.preventDefault();
            window.liveMap.updateLocation(this.dataset.lat, this.dataset.lon, 12);
            $("#fullscreen_search").removeClass("search-mobile");
        });
    }
}





var $bOEk0 = parcelRequire("bOEk0");

var $hxUF9 = parcelRequire("hxUF9");
parcelRequire("gMau8");
var $aFJJk = parcelRequire("aFJJk");
let $b9d9a242c3166ba0$var$script;



let $b9d9a242c3166ba0$var$initialize = ()=>{
    $b9d9a242c3166ba0$var$script = (parcelRequire("9V98A"));
    if ($b9d9a242c3166ba0$var$script.__esModule) $b9d9a242c3166ba0$var$script = $b9d9a242c3166ba0$var$script.default;
    $b9d9a242c3166ba0$var$script.render = (parcelRequire("lA4pq")).render;
    (parcelRequire("9oNrh")).default($b9d9a242c3166ba0$var$script);
    $b9d9a242c3166ba0$var$script.__scopeId = "data-v-88865c";
    $b9d9a242c3166ba0$var$script.__file = "MapSidebar.vue";
};
$b9d9a242c3166ba0$var$initialize();
var $b9d9a242c3166ba0$export$2e2bcd8739ae039 = $b9d9a242c3166ba0$var$script;




var $iEUGM = parcelRequire("iEUGM");

var $6vz4b = parcelRequire("6vz4b");
class $cc16344d71b0ced3$export$2e2bcd8739ae039 extends (0, $iEUGM.default) {
    constructor(myKey, instance){
        super(myKey, instance);
        this.name = "Observations";
        this.popupName = "Observation";
        this.options.hasPanRefresh = true;
        this.options.hasAutoRefresh = true;
        this.dataOptions = {
            "mVar": "ticon"
        };
    }
    refreshLayer() {
        this.requestWxObs();
    }
    requestWxObs() {
        console.log("requestWxObs called");
        this.inst.setLoadingMonitor(this.id, true);
        if (this.tasks.fetchObs === undefined) this.tasks.fetchObs = new (0, $6vz4b.default)({
            url: "https://api.weatherusa.net/v1/feed/obs",
            link: "cancel",
            timeout: 30000,
            onSuccess: this.handleResp.bind(this),
            onError: this.handleError.bind(this)
        });
        this.tasks.fetchObs.get({
            bounds: this.inst.map.getBounds().toBBoxString(),
            zoom: this.inst.map.getZoom(),
            icon: true
        });
    }
    handleError(err) {
        console.error(err);
        this.inst.setLoadingMonitor(this.id, false);
    }
    handleResp(resp) {
        if (!this.layer) {
            console.error("Could not find layer for layer ID: " + this.id);
            return false;
        }
        let wxObs = resp.body;
        this.layer.clearLayers();
        this.stations = {};
        for (const [id, data] of Object.entries(wxObs)){
            //			if((data.sky.length > 0 || data.cond.length > 0))
            //			{
            //				var size = [92, 64];
            //				var anchor = [45, 31];
            //			}
            //			else
            //			{
            var size = [
                64,
                64
            ];
            var anchor = [
                31,
                31
            ];
            //			}
            var localIcon = null;
            var obs_var = this.dataOptions.mVar || $("#wxObs_option").val(); // jq
            if (obs_var == "ticon") {
                if (data.t_f === null || !data.icon) continue;
                // iconUrl: 'https://www.weatherusa.net/weathernet/icon_svg.php?t=' + data.t_f + '&cond=' + encodeURIComponent(data.cond) + '&sky=' + data.sky + '&ws=' + data.wspeed_mph + '&wd=' + data.wdir_compass,
                localIcon = new L.Icon({
                    iconUrl: data.icon,
                    iconSize: size,
                    iconAnchor: anchor
                });
            } else if (obs_var == "t" || obs_var == "td") {
                if (obs_var == "t") var res = data.t_f;
                else var res = data.td_f;
                if (res === null) continue;
                var txtEls = '<span class="r' + Math.floor(res / 10) + '">' + res + "\xb0</span>";
                if (this.is_ie === true) txtEls += '<span class="ieshadow1 r' + Math.floor(res / 10) + '">' + res + '\xb0</span><span class="ieshadow2 r' + Math.floor(res / 10) + '">' + res + "\xb0</span>";
                localIcon = new L.DivIcon({
                    iconSize: [
                        46,
                        19
                    ],
                    className: "map_marker_t",
                    html: txtEls
                });
            } else if (obs_var == "chill") {
                if (data.chill === null) continue;
                localIcon = new L.DivIcon({
                    iconSize: [
                        46,
                        19
                    ],
                    className: "map_marker_t",
                    html: '<span class="r' + Math.floor(data.chill / 10) + '">' + data.chill + "</span>"
                });
            } else if (obs_var == "wgust") {
                if (data.wgust_mph === null) continue;
                localIcon = new L.DivIcon({
                    iconSize: [
                        36,
                        19
                    ],
                    className: "map_marker_wgust",
                    html: '<span class="r' + Math.floor(data.wgust_mph / 10) + '">' + data.wgust_mph + "</span>"
                });
            }
            if (localIcon) {
                this.stations[id] = new L.Marker(new L.LatLng(data.lat, data.lon), {
                    icon: localIcon,
                    title: data.stname + " (" + id + ")",
                    zIndexOffset: 1119
                }).addTo(this.layer);
                var contentStr = '<div class="row no-gutters"><div class="data-box col"><div class="data-label"><strong>Station Name</strong></div><div class="data-value">' + data.stname + " (" + id + ")</div></div></div>" + '<div class="row no-gutters"><div class="data-box col"><div class="data-label">Temperature</div><div class="data-value">' + data.t_f + "\xb0F</div></div>" + '<div class="data-box col"><div class="data-label">Network</div><div class="data-value">' + data.net + "</div></div></div>";
                contentStr += '<div class="row no-gutters">';
                if (data.feelslike !== null) contentStr += '<div class="data-box col"><div class="data-label">Feels like</div><div class="data-value">' + data.feelslike + "\xb0F</div></div>";
                if (data.td_f !== null) contentStr += '<div class="data-box col"><div class="data-label">Dewpoint</div><div class="data-value">' + data.td_f + "\xb0F</div></div>";
                contentStr += "</div>";
                if (data.wspeed_mph !== null) {
                    contentStr += '<div class="row no-gutters"><div class="data-box col"><div class="data-label">Winds</div>';
                    if (data.wdir_compass === null) data.wdir_compass = "";
                    if (data.wspeed_mph > 0) contentStr += '<div class="data-value">' + data.wdir_compass + " " + data.wspeed_mph + " MPH</div>";
                    else contentStr += '<div class="data-value">Calm</div>';
                    if (data.wgust_mph != null && data.wgust_mph > 0 && data.wspeed_mph > 0) contentStr += '<div class="data-value">G ' + data.wgust_mph + " MPH</div>";
                    contentStr += "</div></div>";
                }
                if (data.p_hpa !== null) contentStr += '<div class="row no-gutters"><div class="data-box col"><div class="data-label">Pressure</div><div class="data-value">' + data.p_hpa + " hPa (" + data.p_in + " in.)</div></div></div>";
                contentStr += '<div class="row no-gutters"><div class="data-box col"><div class="data-label">Last updated</div><div class="data-value">' + data.obstime + "</div></div></div>";
                this.stations[id].details = contentStr;
                this.stations[id].on("click", this.handleClick, this);
            }
        }
        this.inst.setLoadingMonitor(this.id, false);
    }
    handleClick(e) {
        this.inst.forwardedClickHandler(this.id, e, e.target.details);
    }
    getLayerPopupContent(layer) {
        return layer.details;
    }
}



var $iEUGM = parcelRequire("iEUGM");

var $6vz4b = parcelRequire("6vz4b");
class $ac95cb39fe96e1e8$export$2e2bcd8739ae039 extends (0, $iEUGM.default) {
    constructor(myKey, instance){
        super(myKey, instance);
        this.name = "Weather Alerts";
        this.popupName = "Alerts";
        this.options.hasPanRefresh = false;
        this.options.hasAutoRefresh = true;
        this.alerts = {};
        this.dataOptions = {};
        this.filters = {
            "sf": [
                "TOR",
                "SVR",
                "FFW",
                "SMW",
                "SVS",
                "SPS"
            ],
            "wsw": [
                "WSW"
            ]
        };
    }
    refreshLayer() {
        this.requestAlerts();
    }
    requestAlerts() {
        this.inst.setLoadingMonitor(this.id, true);
        if (typeof this.dataOptions.queryType === "undefined") this.dataOptions.queryType = "all";
        if (this.tasks.fetchAlerts === undefined) this.tasks.fetchAlerts = new (0, $6vz4b.default)({
            url: "https://api.weatherusa.net/v1.2/feed/alerts",
            data: {
                mode: "layer"
            },
            link: "cancel",
            timeout: 45000,
            onSuccess: this.handleResp.bind(this),
            onError: this.handleError.bind(this)
        });
        this.tasks.fetchAlerts.get({
            only: this.dataOptions.queryType
        }, true);
    }
    requestAlertsForLocation(q, callbackEl) {
        if (this.tasks.fetchAlertText === undefined) this.tasks.fetchAlertText = new (0, $6vz4b.default)({
            url: "https://api.weatherusa.net/v1.2/feed/alerts",
            link: "cancel",
            timeout: 45000,
            onSuccess: this.handleAlertSearchResp.bind(this),
            onError: this.handleError.bind(this)
        });
        this.tasks.fetchAlertText.get({
            q: q,
            data: 1,
            callbackEl: callbackEl
        });
    }
    handleError(err) {
        console.error(err);
        this.inst.setLoadingMonitor(this.id, false);
    }
    handleResp(resp) {
        if (!this.layer) {
            console.error("Could not find layer for layer ID: " + this.id);
            return false;
        }
        var alertFilter = $("#alerts_option").val() || "all";
        let list = resp.body;
        // Remove all paths from LayerGroup
        this.layer.clearLayers();
        this.alerts = {};
        for (const [id, data] of Object.entries(list)){
            // Alert type filter
            if (alertFilter !== "all" && !this.filters[alertFilter].includes(data.prod)) continue;
            let pathOptions = {
                fillColor: data.fill,
                fillOpacity: 0.30,
                color: data.outl,
                weight: 1,
                opacity: 1.0
            };
            if (data.prod == "TOR" || data.prod == "SVR" || data.prod == "FFW" || data.prod == "SVS") {
                pathOptions["weight"] = 2;
                pathOptions["fillOpacity"] = 0.16;
            }
            if (data.pds === true) pathOptions["weight"] = 3;
            if (data.poly.type) // GeoJSON
            this.alerts[id] = L.geoJSON(data.poly, pathOptions).addTo(this.layer);
            else {
                var polyPath = [];
                try {
                    data.poly.forEach(function(pt) {
                        polyPath.push(L.latLng(pt[0], pt[1]));
                    });
                    this.alerts[id] = L.polygon([
                        polyPath
                    ], pathOptions).addTo(this.layer);
                } catch (e1) {
                    console.log(e1, data);
                    continue;
                }
            }
            // this.alerts[id]._wxdata = data;
            this.alerts[id].on("click", this.handleClick, this);
            this.alerts[id].productId = data.id;
            this.alerts[id].productType = data.prod;
        }
        // Kinda hack to make important polys come to front
        for (const [id, item] of Object.entries(this.alerts))if (item.productType == "TOR" || item.productType == "SVR" || item.productType == "FFW" || item.productType == "SVS" || item.productType == "SPS") item.bringToFront();
        this.inst.setLoadingMonitor(this.id, false);
    }
    // Alert polygon clicked
    handleAlertSearchResp(resp) {
        let obj = resp.body;
        let $container = $("#" + obj.callbackEl);
        if ($container.length == 0) // Pop-up closed or container ID not found
        return false;
        let content = "";
        for (let prod of obj.data)content = content + '<a target="_blank" href="/wxwarnings?id=' + prod.id + '">' + prod.name + "</a><br>" + prod.data + "<hr>";
        if (content === "") content = "<em>No alerts found at chosen location. Zoom in for higher accuracy.</em>";
        $container.html(content);
        if (this.inst.popup && this.inst.popup.isOpen()) this.inst.popup.update();
    //this.inst.doHook('alerts_poly_selected', {nws_products_id: nws_product_id, callbackEl: obj.callbackEl});
    }
    handleClick(e1) {
        // Show one tab in popup
        e1.coalesce = true;
        // Dynamic content (lat/lon search) or layer has multiple features that overlap each other, stop all bubbled events
        e1.singleton = true;
        var containerId = "view_alerts_" + new Date().getTime();
        var bubbled = this.inst.forwardedClickHandler(this.id, e1, '<div id="' + containerId + '" class="alerts-text-view"><img src="/images/mediabox/loading_sun_blue.gif" width="28" style="vertical-align: middle" alt="Please wait..." /> Loading...</div>');
        if (bubbled) // Fetch actual alert text from API...
        this.requestAlertsForLocation("" + e1.latlng.lat + "," + e1.latlng.lng, containerId);
    }
    getLayerPopupContent(layer) {
        // TODO not used
        // Show one tab in popup
        e.coalesce = true;
        // Dynamic content (lat/lon search) or layer has multiple features that overlap each other, stop all bubbled events
        e.singleton = true;
        var containerId = "view_alerts_" + layer.productId;
        // Fetch actual alert text from API...
        this.requestAlertsForLocation("" + layer.latlng.lat + "," + layer.latlng.lng, containerId);
    }
}



var $iEUGM = parcelRequire("iEUGM");
class $86a4f3cd09be9e01$export$2e2bcd8739ae039 extends (0, $iEUGM.default) {
    constructor(myKey, instance, layerType, url, options, sublayers){
        super(myKey, instance);
        this.options.hasPanRefresh = false;
        this.options.hasAutoRefresh = true;
        this.layerType = layerType;
        this.url = url;
        this.dataOptions = options || {};
        this.sublayers = {};
        this.currentSublayer = null;
        if (typeof sublayers === "object" && sublayers.length) for (let l of sublayers)this.sublayers[l.layerId] = l;
    }
    /* @override */ attachLayer() {
        if (this.isAttached()) return true;
        // Set any dynamic options
        if (this.dataOptions.time) this.dataOptions.time = new Date().getTime();
        // Wire up to parent instance
        if (this.layerType === "wms") this.inst.layers[this.id] = this.layer = new L.TileLayer.WMS(this.url, this.dataOptions);
        else if (this.layerType === "wmts") this.inst.layers[this.id] = this.layer = new L.TileLayer.WMTS(this.url, this.dataOptions);
        else this.inst.layers[this.id] = this.layer = new L.TileLayer(this.url, this.dataOptions);
        if (this.options.hasPanRefresh) this.inst.mapMoveListeners[this.id] = this.id;
        if (this.options.hasAutoRefresh) this.inst.autoUpdateListeners[this.id] = this.id;
        this.layer.on("loading", ()=>{
            this.inst.setLoadingMonitor(this.id, true);
        });
        this.layer.on("load", ()=>{
            this.inst.setLoadingMonitor(this.id, false);
        });
        // Sublayer support
        let ks = Object.keys(this.sublayers);
        if (ks.length) // Force set element (sublayer) to either default in list or last used
        this.setElement(this.currentSublayer || ks[0]);
        this.inst.map.addLayer(this.layer);
    }
    refreshLayer() {
        this.setOption("time", new Date().getTime());
        this.layer.redraw();
    }
    setOptions(o) {
        for (const [k, v] of Object.entries(o))this.setOption(k, v);
    }
    setOption(k, v) {
        // FIXME could conflict with WMS Params...
        if (typeof this.layer.setParams === "function") {
            let o = {};
            o[k] = v;
            this.layer.setParams(o);
        }
        this.layer.options[k] = v;
    }
    setUrl(url) {
        this.url = url;
        this.layer.setUrl(url);
    }
    setElement(id) {
        if (this.sublayers && this.sublayers[id]) {
            this.currentSublayer = id;
            if (this.sublayers[id].options) this.setOptions(this.sublayers[id].options);
            this.setUrl(this.sublayers[id].url);
        }
    }
}



var $iEUGM = parcelRequire("iEUGM");

var $6vz4b = parcelRequire("6vz4b");
class $659ab7393afe953c$export$2e2bcd8739ae039 extends (0, $iEUGM.default) {
    constructor(myKey, instance){
        super(myKey, instance);
        this.name = "Local Storm Reports";
        this.popupName = "Local Storm Report";
        this.options.hasPanRefresh = false;
        this.options.hasAutoRefresh = true;
        this.lsr = {};
        this.dataOptions = {};
        this.filters = {};
    }
    refreshLayer() {
        this.requestLSR();
    }
    requestLSR() {
        if (typeof this.dataOptions.queryType === "undefined") this.dataOptions.queryType = "all";
        if (this.tasks.fetchLSR === undefined) this.tasks.fetchLSR = new (0, $6vz4b.default)({
            url: "https://api.weatherusa.net/v1/feed/lsr",
            link: "cancel",
            timeout: 30000,
            onSuccess: this.handleResp.bind(this),
            onError: this.handleError.bind(this)
        });
        this.tasks.fetchLSR.get({
            filters: this.filters
        });
    }
    handleError(err) {
        console.error(err);
    }
    handleResp(resp) {
        if (!this.layer) {
            console.error("Could not find layer for layer ID: " + this.id);
            return false;
        }
        let list = resp.body;
        // Remove all paths from LayerGroup
        this.layer.clearLayers();
        this.lsr = {};
        for (const [id, data] of Object.entries(list)){
            var iconBase = "other.png";
            if (data.event.search(/avalanche/i) != -1) iconBase = "avalanche.gif";
            else if (data.event.search(/blizzard/i) != -1) iconBase = "blizzard.png";
            else if (data.event.search(/\bcold|wind chill/i) != -1) iconBase = "cold.png";
            else if (data.event.search(/downburst/i) != -1) iconBase = "downburst.png";
            else if (data.event.search(/drought/i) != -1) iconBase = "drought.png";
            else if (data.event.search(/flood/i) != -1) iconBase = "flood.png";
            else if (data.event.search(/\bfog/i) != -1) iconBase = "fog.png";
            else if (data.event.search(/freezing|\bice/i) != -1) iconBase = "ice.png";
            else if (data.event.search(/funnel cloud/i) != -1) iconBase = "funnelcloud.png";
            else if (data.event.search(/hail/i) != -1) iconBase = "hail.png";
            else if (data.event.search(/\bheat/i) != -1) iconBase = "hot.png";
            else if (data.event.search(/heavy rain/i) != -1) iconBase = "heavyrain.png";
            else if (data.event.search(/lightning/i) != -1) iconBase = "lightning.gif";
            else if (data.event.search(/snow/i) != -1) iconBase = "snow.png";
            else if (data.event.search(/sleet/i) != -1) iconBase = "sleet.png";
            else if (data.event.search(/tornado/i) != -1) iconBase = "tornado.png";
            else if (data.event.search(/wi?nd dmg/i) != -1) // This before generic wind, so we match on "dmg" first
            iconBase = "winddamage.png";
            else if (data.event.search(/\bwi?nd/i) != -1) iconBase = "wind.png";
            else if (data.event.search(/water\s?spout/i) != -1) iconBase = "waterspout.png";
            else if (data.event.search(/fire/i) != -1) iconBase = "fire.png";
            else if (data.event.search(/hurricane|tropical/i) != -1) iconBase = "tropicalstorm.gif";
            var localIcon = new L.Icon({
                iconUrl: "/assets/icons/lsr/" + iconBase,
                iconSize: [
                    32,
                    32
                ],
                iconAnchor: [
                    16,
                    32
                ]
            });
            var magMeasured = "";
            if (data.magnitude_meas == "M") magMeasured = "<br />(measured)";
            else if (data.magnitude_meas == "E") magMeasured = "<br />(estimated)";
            var popStr = '<div class="lsr-event"><img src="/assets/icons/lsr/' + iconBase + '" height="25" />&nbsp;' + data.event + "</div>" + '<div class="row no-gutters">' + '<div class="data-box col"><div class="data-label">Magnitude</div><div class="data-value">' + (data.magnitude.length ? data.magnitude + magMeasured : "(none)") + "</div></div>" + '<div class="data-box col"><div class="data-label">Time</div><div class="data-value">' + data.date + "</div></div>" + '</div><div class="row no-gutters">' + '<div class="data-box col"><div class="data-label">Location</div><div class="data-value">' + data.city + ", " + data.state + "</div></div>" + '<div class="data-box col"><div class="data-label">Source</div><div class="data-value">' + data.source + "</div></div>" + '</div><div class="row no-gutters">' + '<div class="data-box col"><div class="data-label">NWS Office</div><div class="data-value">' + data.issuing_office + "</div></div>" + '<div class="data-box col"><div class="data-label">Coordinates</div><div class="data-value">' + data.lat + ", " + data.lon + "</div></div>" + "</div>";
            if (data.remarks.length > 0) popStr = popStr + '<div class="row no-gutters"><div class="col"><div class="data-label">Remarks</div><p class="lsr-remarks">' + data.remarks + "</p></div></div>";
            this.lsr[data.id] = L.marker(new L.LatLng(data.lat, data.lon), {
                icon: localIcon,
                title: data.event + (data.magnitude.length ? ": " + data.magnitude : "")
            }).on("click", this.handleClick, this).addTo(this.layer);
            this.lsr[data.id].details = popStr;
        }
    }
    handleClick(e) {
        this.inst.forwardedClickHandler(this.id, e, e.target.details);
    }
    getLayerPopupContent(layer) {
        return layer.details;
    }
}



var $iEUGM = parcelRequire("iEUGM");

var $6vz4b = parcelRequire("6vz4b");
class $8edef51f16c09cfe$export$2e2bcd8739ae039 extends (0, $iEUGM.default) {
    constructor(myKey, instance){
        super(myKey, instance);
        this.name = "Surface Analysis";
        this.popupName = "Surface Analysis";
        this.options.hasPanRefresh = false;
        this.options.hasAutoRefresh = true;
    }
    refreshLayer() {
        this.requestSFCAnalysis();
    }
    requestSFCAnalysis() {
        console.log("requestSFCAnalysis called");
        if (this.tasks.fetchSFCAnal === undefined) this.tasks.fetchSFCAnal = new (0, $6vz4b.default)({
            url: "https://api.weatherusa.net/v1/feed/sfcanalysis",
            link: "cancel",
            timeout: 30000,
            onSuccess: this.handleResp.bind(this),
            onError: this.handleError.bind(this)
        });
        this.tasks.fetchSFCAnal.get();
    }
    handleError(err) {
        console.error(err);
    }
    handleResp(resp) {
        if (!this.layer) {
            console.error("Could not find layer for layer ID: " + this.id);
            return false;
        }
        let sfcAnl = resp.body;
        this.layer.clearLayers();
        var frontIconSize = [
            16,
            16
        ];
        var frontIconAnchor = [
            8,
            8
        ];
        // Create smoother lines
        for (let il of sfcAnl.geojson.features)// let still uses Array by reference automatically
        if (il.geometry && il.geometry.type === "LineString") il.geometry.coordinates = this.getCurvePoints(il.geometry.coordinates);
        L.geoJSON(sfcAnl.geojson, {
            pointToLayer: function(feature, ll) {
                // Handle L and H pressure centers
                switch(feature.properties.title){
                    case "highs":
                        var lhicon = '<span style="color: #0000dd;">H</span>';
                        break;
                    default:
                        var lhicon = '<span style="color: #dd0000;">L</span>';
                }
                var myIcon = L.divIcon({
                    iconSize: [
                        36,
                        36
                    ],
                    className: "map-marker-pressure-center",
                    html: lhicon
                });
                return L.marker(ll, {
                    icon: myIcon
                });
            },
            style: function(feature) {
                // Handle Front colors
                switch(feature.properties.title){
                    case "trof":
                        return {
                            "color": "#ff7800",
                            "weight": 3,
                            "opacity": 0.71
                        };
                    case "cold":
                        return {
                            "color": "#0000ff",
                            "weight": 3,
                            "opacity": 1.0
                        };
                    case "warm":
                        return {
                            "color": "#ff0000",
                            "weight": 3,
                            "opacity": 1.0
                        };
                    case "ocfnt":
                        return {
                            "color": "#a300a3",
                            "weight": 3,
                            "opacity": 1.0
                        };
                    case "stnry":
                        return {
                            "color": "#0000ff",
                            "weight": 3,
                            "opacity": 1.0
                        };
                }
            },
            onEachFeature: (function(feature, ll) {
                // Handle Front decorations
                switch(feature.properties.title){
                    case "cold":
                        L.polylineDecorator(ll, {
                            patterns: [
                                {
                                    offset: 25,
                                    repeat: 50,
                                    endOffset: frontIconAnchor[0],
                                    symbol: L.Symbol.marker({
                                        rotate: true,
                                        markerOptions: {
                                            icon: L.icon({
                                                iconUrl: "https://www.weatherusa.net/assets/icons/front_cold.png",
                                                iconSize: frontIconSize,
                                                iconAnchor: frontIconAnchor
                                            })
                                        }
                                    })
                                }
                            ]
                        }).addTo(this.layer);
                        break;
                    case "warm":
                        L.polylineDecorator(ll, {
                            patterns: [
                                {
                                    offset: 25,
                                    repeat: 50,
                                    endOffset: frontIconAnchor[0],
                                    symbol: L.Symbol.marker({
                                        rotate: true,
                                        markerOptions: {
                                            icon: L.icon({
                                                iconUrl: "https://www.weatherusa.net/assets/icons/front_warm.png",
                                                iconSize: frontIconSize,
                                                iconAnchor: frontIconAnchor
                                            })
                                        }
                                    })
                                }
                            ]
                        }).addTo(this.layer);
                        break;
                    case "ocfnt":
                        L.polylineDecorator(ll, {
                            patterns: [
                                {
                                    offset: 8,
                                    repeat: 100,
                                    endOffset: frontIconAnchor[0],
                                    symbol: L.Symbol.marker({
                                        rotate: true,
                                        markerOptions: {
                                            icon: L.icon({
                                                iconUrl: "https://www.weatherusa.net/assets/icons/front_cold_ocfnt.png",
                                                iconSize: frontIconSize,
                                                iconAnchor: frontIconAnchor
                                            })
                                        }
                                    })
                                },
                                {
                                    offset: 58,
                                    repeat: 100,
                                    endOffset: frontIconAnchor[0],
                                    symbol: L.Symbol.marker({
                                        rotate: true,
                                        markerOptions: {
                                            icon: L.icon({
                                                iconUrl: "https://www.weatherusa.net/assets/icons/front_warm_ocfnt.png",
                                                iconSize: frontIconSize,
                                                iconAnchor: frontIconAnchor
                                            })
                                        }
                                    })
                                }
                            ]
                        }).addTo(this.layer);
                        break;
                    case "stnry":
                        L.polylineDecorator(ll, {
                            patterns: [
                                {
                                    offset: 58,
                                    repeat: 100,
                                    symbol: L.Symbol.dash({
                                        pixelSize: 44,
                                        pathOptions: {
                                            color: "#ff0000",
                                            "weight": 3,
                                            "opacity": 0.9
                                        }
                                    })
                                },
                                {
                                    offset: 8,
                                    repeat: 100,
                                    endOffset: frontIconAnchor[0],
                                    symbol: L.Symbol.marker({
                                        rotate: true,
                                        markerOptions: {
                                            icon: L.icon({
                                                iconUrl: "https://www.weatherusa.net/assets/icons/front_cold_stnry.png",
                                                iconSize: frontIconSize,
                                                iconAnchor: frontIconAnchor
                                            })
                                        }
                                    })
                                },
                                {
                                    offset: 58,
                                    repeat: 100,
                                    endOffset: frontIconAnchor[0],
                                    symbol: L.Symbol.marker({
                                        rotate: true,
                                        markerOptions: {
                                            icon: L.icon({
                                                iconUrl: "https://www.weatherusa.net/assets/icons/front_warm_stnry.png",
                                                iconSize: frontIconSize,
                                                iconAnchor: [
                                                    frontIconAnchor[0],
                                                    frontIconAnchor[1] + 1
                                                ]
                                            })
                                        }
                                    })
                                }
                            ]
                        }).addTo(this.layer);
                        break;
                }
            }).bind(this)
        }).addTo(this.layer); // Now add geojson to my layer
    }
    // Stolen from WPC...
    getCurvePoints(pts, tension, isClosed, numOfSegments) {
        var points = [];
        for(i = 0; i < pts.length; i++){
            points.push([
                pts[i][0]
            ]);
            points.push([
                pts[i][1]
            ]);
        }
        pts = points;
        // use input value if provided, or use a default value   
        tension = typeof tension != "undefined" ? tension : 0.5;
        isClosed = isClosed ? isClosed : false;
        numOfSegments = numOfSegments ? numOfSegments : 16;
        var _pts = [], res = [], // clone array
        x, y, // our x,y coords
        t1x, t2x, t1y, t2y, // tension vectors
        c1, c2, c3, c4, // cardinal points
        st, t, i; // steps based on num. of segments
        // clone array so we don't change the original
        _pts = pts.slice(0);
        // The algorithm require a previous and next point to the actual point array.
        // Check if we will draw closed or open curve.
        // If closed, copy end points to beginning and first points to end
        // If open, duplicate first points to beginning, end points to end
        if (isClosed) {
            _pts.unshift(pts[pts.length - 1]);
            _pts.unshift(pts[pts.length - 2]);
            _pts.unshift(pts[pts.length - 1]);
            _pts.unshift(pts[pts.length - 2]);
            _pts.push(pts[0]);
            _pts.push(pts[1]);
        } else {
            _pts.unshift(pts[1]); //copy 1. point and insert at beginning
            _pts.unshift(pts[0]);
            _pts.push(pts[pts.length - 2]); //copy last point and append
            _pts.push(pts[pts.length - 1]);
        }
        // ok, lets start...
        // 1. loop goes through point array
        // 2. loop goes through each segment between the 2 pts + 1e point before and after
        for(i = 2; i < _pts.length - 4; i += 2)for(t = 0; t <= numOfSegments; t++){
            // calc tension vectors
            t1x = (_pts[i + 2] - _pts[i - 2]) * tension;
            t2x = (_pts[i + 4] - _pts[i]) * tension;
            t1y = (_pts[i + 3] - _pts[i - 1]) * tension;
            t2y = (_pts[i + 5] - _pts[i + 1]) * tension;
            // calc step
            st = t / numOfSegments;
            // calc cardinals
            c1 = 2 * Math.pow(st, 3) - 3 * Math.pow(st, 2) + 1;
            c2 = -(2 * Math.pow(st, 3)) + 3 * Math.pow(st, 2);
            c3 = Math.pow(st, 3) - 2 * Math.pow(st, 2) + st;
            c4 = Math.pow(st, 3) - Math.pow(st, 2);
            // calc x and y cords with common control vectors
            x = c1 * _pts[i] + c2 * _pts[i + 2] + c3 * t1x + c4 * t2x;
            y = c1 * _pts[i + 1] + c2 * _pts[i + 3] + c3 * t1y + c4 * t2y;
            //store points in array
            res.push([
                x,
                y
            ]);
        }
        return res;
    }
    handleClick(e) {
    //		this.inst.forwardedClickHandler(this.id, e, e.target.details);
    }
}



var $iEUGM = parcelRequire("iEUGM");

var $6vz4b = parcelRequire("6vz4b");
class $9584431d8e116ee4$export$2e2bcd8739ae039 extends (0, $iEUGM.default) {
    constructor(myKey, instance){
        super(myKey, instance);
        this.name = "Weather Cameras";
        this.popupName = "Weather Cameras";
        this.options.hasPanRefresh = true;
        this.options.hasAutoRefresh = true;
        this.cams = {};
    }
    refreshLayer() {
        this.requestCameras();
    }
    requestCameras() {
        if (this.tasks.fetchSkyCam === undefined) this.tasks.fetchSkyCam = new (0, $6vz4b.default)({
            url: "https://api.weatherusa.net/v1/feed/skycams",
            link: "cancel",
            timeout: 30000,
            onSuccess: this.handleResp.bind(this),
            onError: this.handleError.bind(this)
        });
        this.tasks.fetchSkyCam.get({
            bounds: this.inst.map.getBounds().toBBoxString(),
            zoom: this.inst.map.getZoom()
        });
    }
    handleError(err) {
        console.error(err);
    }
    handleResp(resp) {
        if (!this.layer) {
            console.error("Could not find layer for layer ID: " + this.id);
            return false;
        }
        let list = resp.body;
        this.layer.clearLayers();
        this.cams = {};
        for (const [id, data] of Object.entries(list)){
            this.cams[id] = new L.Marker(new L.LatLng(data.lat, data.lon), {
                icon: new L.Icon({
                    iconUrl: "/archive/cache.php?file=" + encodeURIComponent(data.img) + "&width=48&height=32&type=jpg",
                    iconSize: [
                        48,
                        32
                    ],
                    iconAnchor: [
                        23,
                        17
                    ]
                }),
                title: data.name,
                alt: ""
            }).on("click", this.handleClick, this).addTo(this.layer);
            var contentStr = '<a target="_blank" href="' + data.url + '">' + data.name + "</a><br />" + data.loc + ", " + data.state + '<br /><img src="/archive/cache.php?file=' + encodeURIComponent(data.img) + '" width="256" alt="No image available" />';
            this.cams[id].desc = contentStr;
            this.cams[id].minWidth = 256;
            this.cams[id].maxHeight = 300;
        }
    }
    handleClick(e) {
        this.inst.forwardedClickHandler(this.id, e, e.target.desc);
    }
    getLayerPopupContent(layer) {
        return layer.desc;
    }
}



var $iEUGM = parcelRequire("iEUGM");

var $6vz4b = parcelRequire("6vz4b");
class $857cbd75c64b11e4$export$2e2bcd8739ae039 extends (0, $iEUGM.default) {
    constructor(myKey, instance){
        super(myKey, instance);
        this.name = "Storm tracks";
        this.popupName = "Storm tracks";
        this.options.hasPanRefresh = false;
        this.options.hasAutoRefresh = true;
        // this.layer is the base layer for this Manager created in AbstractLayerManager->attachLayer
        // create a set of sublayers grouped under this.layer
        this.layers = {};
    }
    createSublayers() {
        // init the sublayers
        this.layers.tropTrack = L.featureGroup().addTo(this.layer);
        this.layers.tropForecast = L.featureGroup().addTo(this.layer);
        this.layers.tropForecastMarkers = L.featureGroup().addTo(this.layer);
    }
    cleanup() {
        this.layer.removeLayer(this.layers.tropTrack);
        this.layer.removeLayer(this.layers.tropForecast);
        this.layer.removeLayer(this.layers.tropForecastMarkers);
        this.layers = {};
    }
    refreshLayer() {
        this.requestTropical();
    }
    requestTropical() {
        this.inst.setLoadingMonitor(this.id, true);
        if (this.tasks.fetchTropical === undefined) this.tasks.fetchTropical = new (0, $6vz4b.default)({
            url: "https://api.weatherusa.net/v1.2/feed/tropical",
            data: {
                "storm": "active"
            },
            link: "cancel",
            timeout: 30000,
            onSuccess: this.handleResp.bind(this),
            onError: this.handleError.bind(this)
        });
        this.tasks.fetchTropical.get();
    }
    handleError(err) {
        this.inst.setLoadingMonitor(this.id, false);
        console.error(err);
    }
    handleResp(resp) {
        if (!this.layer) {
            console.error("Could not find layer for layer ID: " + this.id);
            return false;
        }
        let storms = resp.body.data;
        // Clear sublayers from our groups
        for (const [id, l] of Object.entries(this.layers))l.clearLayers();
        for (const [id, storm] of Object.entries(storms)){
            var i = 0;
            var prevCoord = {};
            var prevWind = 0;
            for (const marker of storm.history){
                // Fixup for Leaflet issue #1293
                if (marker.lon > 0) marker.lon = marker.lon - 360;
                if (prevCoord.lat) {
                    var color = this.windToColor(prevWind);
                    L.polyline([
                        prevCoord,
                        new L.LatLng(marker.lat, marker.lon)
                    ], {
                        color: color,
                        weight: 3,
                        opacity: 1.0
                    }).addTo(this.layers.tropTrack);
                }
                prevCoord = new L.LatLng(marker.lat, marker.lon);
                prevWind = marker.winds;
            }
            // Now pop off the last marker for lastMarker
            var lastMarker = storm.history.pop();
            // Fixup for Leaflet issue #1293
            if (lastMarker.lon > 0) lastMarker.lon = lastMarker.lon - 360;
            // Display past storm position markers
            for (const marker of storm.history){
                // Fixup for Leaflet issue #1293
                if (marker.lon > 0) marker.lon = marker.lon - 360;
                var color = this.windToColor(marker.winds);
                L.circleMarker(new L.LatLng(marker.lat, marker.lon), {
                    radius: 8,
                    stroke: true,
                    color: "#e0e0e0",
                    weight: 1,
                    opacity: 1.0,
                    fill: true,
                    fillColor: color,
                    fillOpacity: 1.0
                }).bindPopup("<strong><em>" + marker.name + "</em></strong><br /><strong>Position time:</strong> " + marker.date + "<br /><strong>Winds:</strong> " + marker.winds + " " + " MPH<br /><strong>Moving:</strong> " + marker.dir + " at " + marker.speed + " MPH<br /><strong>Central Pressure:</strong> " + marker.pressure + " mb", {
                    autoPanPadding: L.point(46, 36)
                }).addTo(this.layers.tropTrack);
            }
            if (lastMarker) {
                // Draw a nice TC icon
                if (lastMarker.storm_id < 90) {
                    // silly init
                    var iconClass = "tc_td";
                    var symClass = "";
                    var txt = "L";
                    if (lastMarker.winds < 39) {
                        iconClass = "tc_td";
                        symClass = "";
                        txt = "L";
                    } else if (lastMarker.winds >= 39 && lastMarker.winds <= 73) {
                        iconClass = "tc_ts";
                        symClass = "tc_spin";
                        txt = ""; // TS
                    } else if (lastMarker.winds >= 74 && lastMarker.winds <= 95) {
                        iconClass = "tc_cat1";
                        symClass = "tc_spin";
                        txt = "1";
                    } else if (lastMarker.winds >= 96 && lastMarker.winds <= 110) {
                        iconClass = "tc_cat2";
                        symClass = "tc_spin";
                        txt = "2";
                    } else if (lastMarker.winds >= 111 && lastMarker.winds <= 129) {
                        iconClass = "tc_cat3";
                        symClass = "tc_spin";
                        txt = "3";
                    } else if (lastMarker.winds >= 130 && lastMarker.winds <= 156) {
                        iconClass = "tc_cat4";
                        symClass = "tc_spin";
                        txt = "4";
                    } else if (lastMarker.winds > 156) {
                        iconClass = "tc_cat5";
                        symClass = "tc_spin";
                        txt = "5";
                    }
                    var stormIcon = new L.DivIcon({
                        iconSize: [
                            40,
                            45
                        ],
                        className: "map_marker_tc " + iconClass,
                        html: '<span class="tc_sym ' + symClass + '"></span><span class="tc_symlabel">' + txt + '</span><span class="tc_name">' + lastMarker.name.substr(lastMarker.name.lastIndexOf(" ") + 1) + "</span>"
                    });
                } else // Draw an X for the disturbance
                var stormIcon = new L.DivIcon({
                    iconSize: [
                        26,
                        42
                    ],
                    className: "map_marker_tc tc_inv",
                    html: '<span class="tc_symlabel">&times;</span><span class="tc_name">' + lastMarker.name.substr(lastMarker.name.lastIndexOf(" ") + 1) + "</span>"
                });
                L.marker(new L.LatLng(lastMarker.lat, lastMarker.lon), {
                    icon: stormIcon,
                    title: lastMarker.name
                }).bindPopup("<strong><em>" + lastMarker.name + "</em></strong><br /><strong>Observation time:</strong> " + lastMarker.date + "<br /><strong>Winds:</strong> " + lastMarker.winds + " " + " MPH<br /><strong>Moving:</strong> " + lastMarker.dir + " at " + lastMarker.speed + " MPH<br /><strong>Central Pressure:</strong> " + lastMarker.pressure + " mb", {
                    autoPanPadding: L.point(46, 36)
                }).addTo(this.layers.tropTrack);
                if (storm.forecast) this.loadTropForecast(storm, lastMarker);
            }
        }
        //	map.maxZoom = 7;
        //	map.fitBounds(map_layers.TropTrack.getBounds());
        //	map.maxZoom = 12;
        this.inst.setLoadingMonitor(this.id, false);
    }
    loadTropForecast(storm, init) {
        var color = "#eee";
        var prevCoord = {};
        var prevWind = 0;
        // Add forecast error cone
        if (storm.cone) {
            var polyPath = [];
            try {
                for (const pt of storm.cone){
                    // FIXME Fixup for Leaflet issue #1293
                    if (pt[0] > 0) pt[0] = pt[0] - 360;
                    polyPath.push(L.latLng(pt[1], pt[0]));
                }
                L.polygon(polyPath, {
                    fillColor: "#eee",
                    weight: 0,
                    fillOpacity: 0.43
                }).addTo(this.layers.tropForecast);
            } catch (e) {}
        }
        for (const [id, pos] of Object.entries(storm.forecast)){
            // Fixup for Leaflet issue #1293
            if (pos.lon > 0) pos.lon = pos.lon - 360;
            // Add overlay lines
            if (!prevCoord.lat) {
                prevCoord = {
                    lat: init.lat,
                    lon: init.lon
                };
                prevWind = init.winds;
            }
            // Add forecast track line
            color = this.windToColor(prevWind);
            L.polyline([
                prevCoord,
                L.latLng(pos.lat, pos.lon)
            ], {
                color: color,
                weight: 3,
                opacity: 1.0,
                dashArray: "8,7"
            }).addTo(this.layers.tropForecast);
            prevCoord = L.latLng(pos.lat, pos.lon);
            prevWind = pos.winds_mph;
            // Add forecast points
            L.circleMarker(L.latLng(pos.lat, pos.lon), {
                radius: 9,
                stroke: true,
                color: "#eee",
                weight: 2,
                opacity: 0.9,
                fill: true,
                fillColor: "#fff",
                fillOpacity: 0.38
            }).bindPopup("<strong>Forecast time:</strong> " + pos.time + "<br /><strong>Winds:</strong> " + pos.winds_mph + " " + " MPH, Gusts to " + pos.gusts_mph + " MPH", {
                autoPanPadding: L.point(46, 36)
            }).addTo(this.layers.tropForecastMarkers);
        }
        this.layers.tropForecast.bringToBack();
    }
    handleClick(e) {
        this.inst.forwardedClickHandler(this.id, e, e.target.details);
    }
    windToColor(prevWind) {
        var color = "#abe7f1";
        if (prevWind < 39) color = "#abe7f1";
        else if (prevWind >= 39 && prevWind <= 73) color = "#58c4e6";
        else if (prevWind >= 74 && prevWind <= 95) color = "#e8e264";
        else if (prevWind >= 96 && prevWind <= 110) color = "#f8bb44";
        else if (prevWind >= 111 && prevWind <= 129) color = "#f58954";
        else if (prevWind >= 130 && prevWind <= 156) color = "#e96d6b";
        else if (prevWind > 156) color = "#ef8fb1";
        return color;
    }
}



var $iEUGM = parcelRequire("iEUGM");

var $6vz4b = parcelRequire("6vz4b");
/* global window, exports, define */ var $e884cb3c7dc6d9bb$export$63151d8bb18a49f9;
var $e884cb3c7dc6d9bb$export$790fb69b1a2884f9;
!function() {
    "use strict";
    var re = {
        not_string: /[^s]/,
        not_bool: /[^t]/,
        not_type: /[^T]/,
        not_primitive: /[^v]/,
        number: /[diefg]/,
        numeric_arg: /[bcdiefguxX]/,
        json: /[j]/,
        not_json: /[^j]/,
        text: /^[^\x25]+/,
        modulo: /^\x25{2}/,
        placeholder: /^\x25(?:([1-9]\d*)\$|\(([^)]+)\))?(\+)?(0|'[^$])?(-)?(\d+)?(?:\.(\d+))?([b-gijostTuvxX])/,
        key: /^([a-z_][a-z_\d]*)/i,
        key_access: /^\.([a-z_][a-z_\d]*)/i,
        index_access: /^\[(\d+)\]/,
        sign: /^[+-]/
    };
    function sprintf(key) {
        // `arguments` is not an array, but should be fine for this call
        return sprintf_format(sprintf_parse(key), arguments);
    }
    function vsprintf(fmt, argv) {
        return sprintf.apply(null, [
            fmt
        ].concat(argv || []));
    }
    function sprintf_format(parse_tree, argv) {
        var cursor = 1, tree_length = parse_tree.length, arg, output = "", i, k, ph, pad, pad_character, pad_length, is_positive, sign;
        for(i = 0; i < tree_length; i++){
            if (typeof parse_tree[i] === "string") output += parse_tree[i];
            else if (typeof parse_tree[i] === "object") {
                ph = parse_tree[i] // convenience purposes only
                ;
                if (ph.keys) {
                    arg = argv[cursor];
                    for(k = 0; k < ph.keys.length; k++){
                        if (arg == undefined) throw new Error(sprintf('[sprintf] Cannot access property "%s" of undefined value "%s"', ph.keys[k], ph.keys[k - 1]));
                        arg = arg[ph.keys[k]];
                    }
                } else if (ph.param_no) arg = argv[ph.param_no];
                else arg = argv[cursor++];
                if (re.not_type.test(ph.type) && re.not_primitive.test(ph.type) && arg instanceof Function) arg = arg();
                if (re.numeric_arg.test(ph.type) && typeof arg !== "number" && isNaN(arg)) throw new TypeError(sprintf("[sprintf] expecting number but found %T", arg));
                if (re.number.test(ph.type)) is_positive = arg >= 0;
                switch(ph.type){
                    case "b":
                        arg = parseInt(arg, 10).toString(2);
                        break;
                    case "c":
                        arg = String.fromCharCode(parseInt(arg, 10));
                        break;
                    case "d":
                    case "i":
                        arg = parseInt(arg, 10);
                        break;
                    case "j":
                        arg = JSON.stringify(arg, null, ph.width ? parseInt(ph.width) : 0);
                        break;
                    case "e":
                        arg = ph.precision ? parseFloat(arg).toExponential(ph.precision) : parseFloat(arg).toExponential();
                        break;
                    case "f":
                        arg = ph.precision ? parseFloat(arg).toFixed(ph.precision) : parseFloat(arg);
                        break;
                    case "g":
                        arg = ph.precision ? String(Number(arg.toPrecision(ph.precision))) : parseFloat(arg);
                        break;
                    case "o":
                        arg = (parseInt(arg, 10) >>> 0).toString(8);
                        break;
                    case "s":
                        arg = String(arg);
                        arg = ph.precision ? arg.substring(0, ph.precision) : arg;
                        break;
                    case "t":
                        arg = String(!!arg);
                        arg = ph.precision ? arg.substring(0, ph.precision) : arg;
                        break;
                    case "T":
                        arg = Object.prototype.toString.call(arg).slice(8, -1).toLowerCase();
                        arg = ph.precision ? arg.substring(0, ph.precision) : arg;
                        break;
                    case "u":
                        arg = parseInt(arg, 10) >>> 0;
                        break;
                    case "v":
                        arg = arg.valueOf();
                        arg = ph.precision ? arg.substring(0, ph.precision) : arg;
                        break;
                    case "x":
                        arg = (parseInt(arg, 10) >>> 0).toString(16);
                        break;
                    case "X":
                        arg = (parseInt(arg, 10) >>> 0).toString(16).toUpperCase();
                        break;
                }
                if (re.json.test(ph.type)) output += arg;
                else {
                    if (re.number.test(ph.type) && (!is_positive || ph.sign)) {
                        sign = is_positive ? "+" : "-";
                        arg = arg.toString().replace(re.sign, "");
                    } else sign = "";
                    pad_character = ph.pad_char ? ph.pad_char === "0" ? "0" : ph.pad_char.charAt(1) : " ";
                    pad_length = ph.width - (sign + arg).length;
                    pad = ph.width ? pad_length > 0 ? pad_character.repeat(pad_length) : "" : "";
                    output += ph.align ? sign + arg + pad : pad_character === "0" ? sign + pad + arg : pad + sign + arg;
                }
            }
        }
        return output;
    }
    var sprintf_cache = Object.create(null);
    function sprintf_parse(fmt) {
        if (sprintf_cache[fmt]) return sprintf_cache[fmt];
        var _fmt = fmt, match, parse_tree = [], arg_names = 0;
        while(_fmt){
            if ((match = re.text.exec(_fmt)) !== null) parse_tree.push(match[0]);
            else if ((match = re.modulo.exec(_fmt)) !== null) parse_tree.push("%");
            else if ((match = re.placeholder.exec(_fmt)) !== null) {
                if (match[2]) {
                    arg_names |= 1;
                    var field_list = [], replacement_field = match[2], field_match = [];
                    if ((field_match = re.key.exec(replacement_field)) !== null) {
                        field_list.push(field_match[1]);
                        while((replacement_field = replacement_field.substring(field_match[0].length)) !== ""){
                            if ((field_match = re.key_access.exec(replacement_field)) !== null) field_list.push(field_match[1]);
                            else if ((field_match = re.index_access.exec(replacement_field)) !== null) field_list.push(field_match[1]);
                            else throw new SyntaxError("[sprintf] failed to parse named argument key");
                        }
                    } else throw new SyntaxError("[sprintf] failed to parse named argument key");
                    match[2] = field_list;
                } else arg_names |= 2;
                if (arg_names === 3) throw new Error("[sprintf] mixing positional and named placeholders is not (yet) supported");
                parse_tree.push({
                    placeholder: match[0],
                    param_no: match[1],
                    keys: match[2],
                    sign: match[3],
                    pad_char: match[4],
                    align: match[5],
                    width: match[6],
                    precision: match[7],
                    type: match[8]
                });
            } else throw new SyntaxError("[sprintf] unexpected placeholder");
            _fmt = _fmt.substring(match[0].length);
        }
        return sprintf_cache[fmt] = parse_tree;
    }
    $e884cb3c7dc6d9bb$export$63151d8bb18a49f9 = sprintf;
    $e884cb3c7dc6d9bb$export$790fb69b1a2884f9 = vsprintf;
    if (typeof window !== "undefined") {
        window["sprintf"] = sprintf;
        window["vsprintf"] = vsprintf;
        if (typeof define === "function" && define["amd"]) define(function() {
            return {
                "sprintf": sprintf,
                "vsprintf": vsprintf
            };
        });
    }
/* eslint-enable quote-props */ }(); // eslint-disable-line


class $f1ed327efddff4cb$export$2e2bcd8739ae039 extends (0, $iEUGM.default) {
    constructor(myKey, instance){
        super(myKey, instance);
        this.name = "Mesoscale Discussion";
        this.popupName = "Mesoscale Discussion";
        this.options.hasPanRefresh = false;
        this.options.hasAutoRefresh = true;
    }
    refreshLayer() {
        this.requestData();
    }
    requestData() {
        this.inst.setLoadingMonitor(this.id, true);
        if (this.tasks.fetchData === undefined) this.tasks.fetchData = new (0, $6vz4b.default)({
            url: "https://api.weatherusa.net/v1/feed/specprod",
            data: {
                product_id: "SWO"
            },
            link: "cancel",
            timeout: 30000,
            onSuccess: this.handleResp.bind(this),
            onError: this.handleError.bind(this)
        });
        this.tasks.fetchData.get();
    }
    handleError(err) {
        console.error(err);
        this.inst.setLoadingMonitor(this.id, false);
    }
    handleResp(resp) {
        if (!this.layer) {
            console.error("Could not find layer for layer ID: " + this.id);
            return false;
        }
        let list = resp.body;
        // Remove all paths from LayerGroup
        this.layer.clearLayers();
        for (const [id, data] of Object.entries(list)){
            var polyPath = [];
            for (const pt of data.poly)polyPath.push(new L.LatLng(pt[0], pt[1]));
            var obj = new L.Polygon(polyPath, {
                fillColor: data.fill,
                fillOpacity: 0.11,
                color: data.outl,
                weight: 2,
                opacity: 1.0
            }).on("click", this.handleClick, this).addTo(this.layer);
            obj.nwsProductId = data.id;
            obj.details = data.text;
            obj.eventId = data.eventId;
        }
        this.inst.setLoadingMonitor(this.id, false);
    }
    handleClick(e1) {
        var eventSPC = (0, $e884cb3c7dc6d9bb$export$63151d8bb18a49f9)("%04u", e1.target.eventId);
        this.inst.forwardedClickHandler(this.id, e1, '<div class="alerts-text-view"><a target="_blank" href="https://www.spc.noaa.gov/products/md/md' + eventSPC + '.html"><img class="img-fluid" src="https://www.spc.noaa.gov/products/md/mcd' + eventSPC + '_full.png" /></a><br /><br />' + e1.target.details + "</div>");
    }
    getLayerPopupContent(layer) {
        var eventSPC = (0, $e884cb3c7dc6d9bb$export$63151d8bb18a49f9)("%04u", layer.eventId);
        return '<div class="alerts-text-view"><a target="_blank" href="https://www.spc.noaa.gov/products/md/md' + eventSPC + '.html"><img class="img-fluid" src="https://www.spc.noaa.gov/products/md/mcd' + eventSPC + '_full.png" /></a><br /><br />' + e.target.details + "</div>";
    }
}



var $iEUGM = parcelRequire("iEUGM");

var $6vz4b = parcelRequire("6vz4b");
class $2c8cfba025ea0979$export$2e2bcd8739ae039 extends (0, $iEUGM.default) {
    constructor(myKey, instance){
        super(myKey, instance);
        this.name = "Convective Outlook";
        this.popupName = "Convective Outlook";
        this.options.hasPanRefresh = false;
        this.options.hasAutoRefresh = true;
        this.dataOptions = {};
        this.dataOptions.productId = "SWO";
        this.dataOptions.productLocId = "DY1";
        this.storage = {};
        this.storage.text = null;
    }
    refreshLayer() {
        this.requestData();
    }
    requestData() {
        this.inst.setLoadingMonitor(this.id, true);
        if (this.tasks.fetchData === undefined) this.tasks.fetchData = new (0, $6vz4b.default)({
            url: "https://dev.weatherusa.net/api/v1/feed/specprod",
            data: {
                product_id: "SWO",
                "product_loc_id": "DY1"
            },
            link: "cancel",
            timeout: 30000,
            onSuccess: this.handleResp.bind(this),
            onError: this.handleError.bind(this)
        });
        this.tasks.fetchData.get({
            product_id: this.dataOptions.productId,
            product_loc_id: this.dataOptions.productLocId
        });
    }
    handleError(err) {
        console.error(err);
        this.inst.setLoadingMonitor(this.id, false);
    }
    handleResp(resp) {
        if (!this.layer) {
            console.error("Could not find layer for layer ID: " + this.id);
            return false;
        }
        let data = resp.body.geojson;
        if (data === undefined) throw "SWO product empty";
        // Remove all paths from LayerGroup
        this.layer.clearLayers();
        //this.storage.text = data.text;
        L.geoJson(data, {
            onEachFeature: this.handleFeature.bind(this),
            style: function(feature) {
                return {
                    color: feature.properties.stroke,
                    fillColor: feature.properties.fill,
                    opacity: 1.0,
                    fillOpacity: 0.70,
                    weight: 2
                };
            }
        }).addTo(this.layer);
        this.inst.setLoadingMonitor(this.id, false);
    }
    handleFeature(feature, layer) {
        layer.on("click", this.handleClick, this);
    }
    handleClick(e1) {
        var props = e1.target.feature.properties;
        this.inst.forwardedClickHandler(this.id, e1, '<div class="alerts-text-view"><b>' + props.LABEL + " - " + props.LABEL2 + "</b></div>");
    }
    getLayerPopupContent(layer) {
        var eventSPC = sprintf("%04u", layer.eventId);
        return '<div class="alerts-text-view"><a target="_blank" href="https://www.spc.noaa.gov/products/md/md' + eventSPC + '.html"><img class="img-responsive" src="https://www.spc.noaa.gov/products/md/mcd' + eventSPC + '.gif" /></a><br /><br />' + e.target.details + "</div>";
    }
}



var $iEUGM = parcelRequire("iEUGM");

var $6vz4b = parcelRequire("6vz4b");
class $7499894043646551$export$2e2bcd8739ae039 extends (0, $iEUGM.default) {
    constructor(myKey, instance){
        super(myKey, instance);
        this.name = "Active Wildfires";
        this.popupName = "Wildfire";
        this.options.hasPanRefresh = false;
        this.options.hasAutoRefresh = true;
        this.dataOptions = {};
    }
    refreshLayer() {
        this.requestData();
    }
    requestData() {
        this.inst.setLoadingMonitor(this.id, true);
        if (this.tasks.fetchData === undefined) this.tasks.fetchData = new (0, $6vz4b.default)({
            url: "https://api.weatherusa.net/v1/feed/fire",
            data: {
                "perimeters": "true"
            },
            link: "cancel",
            timeout: 30000,
            onSuccess: this.handleResp.bind(this),
            onError: this.handleError.bind(this)
        });
        this.tasks.fetchData.get();
    }
    handleError(err) {
        console.error(err);
        this.inst.setLoadingMonitor(this.id, false);
    }
    handleResp(resp) {
        if (!this.layer) {
            console.error("Could not find layer for layer ID: " + this.id);
            return false;
        }
        let firesGeoJson = resp.body.data;
        if (firesGeoJson === undefined) throw "Fires undefined or API error";
        // Remove all paths from LayerGroup
        this.layer.clearLayers();
        L.geoJson(firesGeoJson, {
            onEachFeature: this.handleFeature.bind(this),
            pointToLayer: this.pointToLayer.bind(this),
            style: function(feature) {
                return {
                    color: "#f3f300",
                    opacity: 0.9,
                    weight: 3,
                    fillColor: "#d9d900",
                    fillOpacity: 0.19
                };
            }
        }).addTo(this.layer);
        this.inst.setLoadingMonitor(this.id, false);
    }
    handleFeature(feature, layer) {
        layer.on("click", this.handleClick, this);
    }
    pointToLayer(feature, ll) {
        return L.marker(ll, {
            icon: new L.Icon.Default({
                "imagePath": "https://www.weatherusa.net/assets/js/images/"
            }),
            title: feature.properties.name
        });
    }
    handleClick(e) {
        // Show one tab in popup
        e.coalesce = true;
        let data = e.target.feature.properties;
        var popStr = '<div class="fire-event"><p>' + data.name + "</p>" + '<div class="row no-gutters">' + '<div class="data-box col"><div class="data-label">Acres</div><div class="data-value">' + (data.acres ? data.acres : "") + "</div></div>" + '<div class="data-box col"><div class="data-label">% Contained</div><div class="data-value">' + (data.percent_contained ? data.percent_contained : "") + "</div></div>" + '</div><div class="row no-gutters">' + '<div class="data-box col"><div class="data-label">Fire Cause</div><div class="data-value">' + data.firecause + "</div></div>" + '<div class="data-box col"><div class="data-label">Unit ID</div><div class="data-value">' + data.unit_id + "</div></div>" + "</div>" + "</div>";
        this.inst.forwardedClickHandler(this.id, e, popStr);
    }
}



var $iEUGM = parcelRequire("iEUGM");

var $6vz4b = parcelRequire("6vz4b");
class $37cec9c5946386eb$export$2e2bcd8739ae039 extends (0, $iEUGM.default) {
    constructor(myKey, instance){
        super(myKey, instance);
        this.name = "Recent Earthquakes";
        this.popupName = "Earthquake";
        this.options.hasPanRefresh = false;
        this.options.hasAutoRefresh = true;
        this.dataOptions = {};
    }
    refreshLayer() {
        this.requestData();
    }
    requestData() {
        this.inst.setLoadingMonitor(this.id, true);
        if (this.tasks.fetchData === undefined) this.tasks.fetchData = new (0, $6vz4b.default)({
            url: "https://api.weatherusa.net/v1/feed/earthquake",
            data: {},
            link: "cancel",
            timeout: 30000,
            onSuccess: this.handleResp.bind(this),
            onError: this.handleError.bind(this)
        });
        this.tasks.fetchData.get();
    }
    handleError(err) {
        console.error(err);
        this.inst.setLoadingMonitor(this.id, false);
    }
    handleResp(resp) {
        if (!this.layer) {
            console.error("Could not find layer for layer ID: " + this.id);
            return false;
        }
        let earthquakeGeoJson = resp.body.data;
        if (earthquakeGeoJson === undefined) throw "Earthquakes undefined or API error";
        // Remove all paths from LayerGroup
        this.layer.clearLayers();
        L.geoJson(earthquakeGeoJson, {
            onEachFeature: this.handleFeature.bind(this),
            pointToLayer: this.pointToLayer.bind(this),
            style: function(feature) {
                return {
                    color: "#f3f300",
                    opacity: 0.9,
                    weight: 3,
                    fillColor: "#d9d900",
                    fillOpacity: 0.19
                };
            }
        }).addTo(this.layer);
        this.inst.setLoadingMonitor(this.id, false);
    }
    handleFeature(feature, layer) {
        layer.on("click", this.handleClick, this);
    }
    pointToLayer(feature, ll) {
        return L.marker(ll, {
            icon: new L.Icon.Default({
                "imagePath": "https://www.weatherusa.net/assets/js/images/"
            }),
            title: "M" + feature.properties.magnitude + " @ " + feature.properties.place
        });
    }
    handleClick(e) {
        // Show one tab in popup
        e.coalesce = true;
        let data = e.target.feature.properties;
        var popStr = '<div class="earthquake-event"><p style="font-size: 13pt; margin: 0.5em 0;">M ' + data.magnitude + "</p>" + '<div class="row no-gutters">' + '<div class="data-box col"><div class="data-label">Time</div><div class="data-value">' + data.time + " UTC</div></div>" + '<div class="data-box col"><div class="data-label">Status</div><div class="data-value">' + data.status + "</div></div>" + '</div><div class="row no-gutters">' + '<div class="data-box col"><div class="data-label">Location</div><div class="data-value">' + data.place + "</div></div>" + '<div class="data-box col"><div class="data-label">Depth</div><div class="data-value">' + data.depth + " km</div></div>" + "</div>" + "</div>";
        this.inst.forwardedClickHandler(this.id, e, popStr);
    }
}



var $iEUGM = parcelRequire("iEUGM");
class $5823c3d68f538dd4$export$2e2bcd8739ae039 extends (0, $iEUGM.default) {
    constructor(myKey, instance, layerType, url, options, sublayers){
        super(myKey, instance);
        this.options.hasPanRefresh = false;
        this.options.hasAutoRefresh = true;
        this.layerType = layerType;
        this.url = url;
        this.dataOptions = options || {};
        this.layers = [];
        this.layerLoadingStack = [];
        this.currentFrameId = null;
        this.preloading = false;
        this.myTimer = null;
        // TODO TESTING
        this.urls = [
            "https://tiles-{s}.gis.weatherusa.net/wmscache/tms/1.0.0/Radar_NA_RALA_60m-t512@EPSG3857-t512{r}/{z}/{x}/{y}.png?{time}",
            "https://tiles-{s}.gis.weatherusa.net/wmscache/tms/1.0.0/Radar_NA_RALA_50m-t512@EPSG3857-t512{r}/{z}/{x}/{y}.png?{time}",
            "https://tiles-{s}.gis.weatherusa.net/wmscache/tms/1.0.0/Radar_NA_RALA_40m-t512@EPSG3857-t512{r}/{z}/{x}/{y}.png?{time}",
            "https://tiles-{s}.gis.weatherusa.net/wmscache/tms/1.0.0/Radar_NA_RALA_30m-t512@EPSG3857-t512{r}/{z}/{x}/{y}.png?{time}",
            "https://tiles-{s}.gis.weatherusa.net/wmscache/tms/1.0.0/Radar_NA_RALA_20m-t512@EPSG3857-t512{r}/{z}/{x}/{y}.png?{time}",
            "https://tiles-{s}.gis.weatherusa.net/wmscache/tms/1.0.0/Radar_NA_RALA_10m-t512@EPSG3857-t512{r}/{z}/{x}/{y}.png?{time}",
            "https://tiles-{s}.gis.weatherusa.net/wmscache/tms/1.0.0/Radar_NA_RALA-t512@EPSG3857-t512{r}/{z}/{x}/{y}.png?{time}"
        ];
        this.dataOptions = {
            "subdomains": "1234",
            "layers": "Radar_NA_RALA",
            "tms": true,
            "transparent": true,
            "opacity": 0.0,
            "time": "{{unixtime}}",
            "zIndex": 999,
            "detectRetina": true,
            "tileSize": 512,
            "keepBuffer": 1
        };
    }
    /* @override */ attachLayer() {
        if (this.isAttached()) return true;
        // Set any dynamic options
        if (this.dataOptions.time) this.dataOptions.time = new Date().getTime();
        // On attach, set visible layer to most recent (last in stack)
        this.currentFrameId = this.urls.length - 1;
        this.url = this.urls[this.currentFrameId];
        for (const [i, v] of this.urls.entries()){
            if (this.layerType === "wms") this.layers[i] = new L.TileLayer.WMS(v, this.dataOptions);
            else if (this.layerType === "wmts") this.layers[i] = new L.TileLayer.WMTS(v, this.dataOptions);
            else this.layers[i] = new L.TileLayer(v, this.dataOptions);
            // Initialize layer status
            this.layerLoadingStack[i] = true;
            // Add invisible layers to map instance
            this.inst.map.addLayer(this.layers[i]);
            // Set layer events
            this.layers[i].on("loading", ()=>{
                this.setFrameLoadingStatus(i, true);
            });
            this.layers[i].on("load", ()=>{
                this.setFrameLoadingStatus(i, false);
            });
        }
        if (this.options.hasPanRefresh) this.inst.mapMoveListeners[this.id] = this.id;
        if (this.options.hasAutoRefresh) this.inst.autoUpdateListeners[this.id] = this.id;
        /*
    this.layer.on('loading', () => {
    	this.inst.setLoadingMonitor(this.id, true);
    });
    this.layer.on('load', () => {
    	this.inst.setLoadingMonitor(this.id, false);
    });
    */ this.startLooping();
    }
    refreshLayer() {
        this.setOption("time", new Date().getTime());
        for(var i = 0; i < this.layers.length; i++)this.layers[i].redraw();
    }
    setOptions(o) {
        for (const [k, v] of Object.entries(o))this.setOption(k, v);
    }
    setOption(k, v) {
        // FIXME could conflict with WMS Params...
        for(var i = 0; i < this.layers.length; i++){
            if (typeof this.layers[i].setParams === "function") {
                let o = {};
                o[k] = v;
                this.layers[i].setParams(o);
            }
            this.layers[i].options[k] = v;
        }
    }
    startLooping() {
        // preload frames
        var resp = this.getFrameStatus();
        console.log("startLooping", resp);
        // TODO force-reload if any sublayers are out of date
        if (resp.loading > 0) {
            this.preloading = true;
            return false;
        } else {
            this.preloading = false;
            return this.goLooping();
        }
    }
    stopLooping() {
        if (this.myTimer) clearTimeout(this.myTimer);
        this.myTimer = null;
    }
    goLooping() {
        if (this.preloading) return false; // dont allow looping if not currently loaded
        this.showNextFrameAndWait();
        return true;
    }
    showFrame(id) {
        this.currentFrameId = id;
        this.url = this.urls[id];
        this.inst.layers[this.id] = this.layers[id];
        // TODO do we need requestAnimationFrame?
        for(var i = 0; i < this.layers.length; i++)if (i == id) this.layers[i].setOpacity(0.75);
        else this.layers[i].setOpacity(0.0);
    }
    showNextFrameAndWait() {
        // Compute next frame, or wait & loop to beginning
        var nextFrameId = this.currentFrameId + 1;
        var lastStackId = this.layers.length - 1;
        var nextWait = 600; // ms
        //console.log(nextFrameId, lastStackId);
        if (nextFrameId > lastStackId) // At end of stack, reset loop
        this.showFrame(0);
        else if (nextFrameId == lastStackId) {
            // Next frame is the last one, pause on it longer
            this.showFrame(nextFrameId);
            nextWait = 2000;
        } else this.showFrame(nextFrameId);
        var self = this;
        this.myTimer = setTimeout(function() {
            self.showNextFrameAndWait();
        }, nextWait);
    }
    getFrameStatus() {
        var pendingCount = 0;
        for (const loading of this.layerLoadingStack)if (loading) pendingCount++;
        return {
            "steps": this.urls.length,
            "loading": pendingCount,
            "loaded": this.urls.length - pendingCount
        };
    }
    setFrameLoadingStatus(layer_id, status) {
        this.layerLoadingStack[layer_id] = status;
        this.frameLoadingStatusCallback(this.getFrameStatus());
    }
    frameLoadingStatusCallback(status) {
        console.log(status, this.layerLoadingStack);
        if (status.loading == 0 && this.preloading) {
            // Fully loaded, Immediately begin looping
            this.preloading = false;
            this.goLooping();
        }
    }
}


var $32b2e646f1d79cc3$var$liveMap;
$(function() {
    $32b2e646f1d79cc3$var$initLiveMap();
    $32b2e646f1d79cc3$var$setupUI();
});


function $32b2e646f1d79cc3$var$initLiveMap() {
    var liveMapOptions = {
        infoBoxId: "infobox"
    };
    var uri = (0, (/*@__PURE__*/$parcel$interopDefault($bOEk0))).parse(document.location.href);
    var uriqs = (0, (/*@__PURE__*/$parcel$interopDefault($hxUF9))).parse(uri.query);
    try {
        // Lazy handling of stored map view, ignore if anything is invalid
        var storedMapView = null;
        if (window.localStorage) storedMapView = window.localStorage.getItem("weatherusa.weatherlive.mapview");
        if (typeof uriqs.q === "string") {
            // Use map position from URL (priority)
            var ll = uriqs.q.split(",");
            if (ll.length > 1) liveMapOptions.mapStartCenter = L.latLng(parseFloat(ll[0]), parseFloat(ll[1]));
            if (typeof uriqs.zoom === "string") liveMapOptions.mapStartZoom = uriqs.zoom;
        } else if (storedMapView) {
            // Use map position from localStorage
            var ll = storedMapView.split(",");
            if (ll.length === 3) {
                var lat = parseFloat(ll[0]);
                var lon = parseFloat(ll[1]);
                var z = parseInt(ll[2]);
                liveMapOptions.mapStartCenter = L.latLng(lat, lon);
                liveMapOptions.mapStartZoom = z;
            }
        }
    } catch (err) {
        console.log(err);
    }
    $32b2e646f1d79cc3$var$liveMap = new (0, $d7ccdeb70b525f3c$export$2e2bcd8739ae039)("map_canvas", liveMapOptions);
    $32b2e646f1d79cc3$var$liveMap.loadingListeners["toolbar"] = function(stack) {
        // console.log(stack, stack.length);
        if (stack.length > 0) $("#indicator_loading").removeClass("d-none");
        else $("#indicator_loading").addClass("d-none");
    };
    // Load the Leaflet map core and layers
    $32b2e646f1d79cc3$var$liveMap.mapInit();
    if (window.localStorage) {
        var funcStoreMapView = (0, (/*@__PURE__*/$parcel$interopDefault($0687b27b1e881858$exports)))(function() {
            // Save map view to localStorage
            var ll = $32b2e646f1d79cc3$var$liveMap.map.getCenter();
            var z = $32b2e646f1d79cc3$var$liveMap.map.getZoom();
            var str = "" + ll.lat + "," + ll.lng + "," + z;
            window.localStorage.setItem("weatherusa.weatherlive.mapview", str);
        }, 2000);
        // Listen for map view changes - goes here after init and conveniently ignores trying to use original map position
        $32b2e646f1d79cc3$var$liveMap.map.on("moveend zoomend", function() {
            funcStoreMapView();
        });
    }
    // Setup sidebar and layer management
    var layerUIList = [];
    // Load map plugins and extended layers
    $32b2e646f1d79cc3$var$liveMap.layerManagers.radarNexradL2 = null;
    $32b2e646f1d79cc3$var$liveMap.Plugins.GLRadarLayer = (parcelRequire("8tjc5")).then((addon)=>{
        $32b2e646f1d79cc3$var$liveMap.layerManagers.radarNexradL2 = new addon.default("radarNexradL2", $32b2e646f1d79cc3$var$liveMap);
    });
    if (window._userProxy && window._userProxy.hasAssets) {
        $32b2e646f1d79cc3$var$liveMap.layerManagers.clientAssets = null;
        $32b2e646f1d79cc3$var$liveMap.Plugins.ClientAssets = (parcelRequire("eGBeZ")).then((addon)=>{
            $32b2e646f1d79cc3$var$liveMap.layerManagers.clientAssets = new addon.default("clientAssets", $32b2e646f1d79cc3$var$liveMap);
            $32b2e646f1d79cc3$var$liveMap.layerManagers.clientAssets.attachLayer();
        });
        $("#map_controls_tabs").removeClass("d-none");
        $("#map_controls_tabs a").on("click", function(e) {
            e.preventDefault();
            var tabRef = $(this).attr("href");
            //console.log(this, tabRef);
            $("#tab_assets, #vue_MapSidebar").addClass("d-none");
            $("#map_controls_tabs a").removeClass("active");
            $(tabRef).removeClass("d-none");
            $(this).addClass("active");
        });
    }
    // Load all Layer Managers
    $32b2e646f1d79cc3$var$liveMap.layerManagers.wxObs = new (0, $cc16344d71b0ced3$export$2e2bcd8739ae039)("wxObs", $32b2e646f1d79cc3$var$liveMap);
    $32b2e646f1d79cc3$var$liveMap.layerManagers.alerts = new (0, $ac95cb39fe96e1e8$export$2e2bcd8739ae039)("alerts", $32b2e646f1d79cc3$var$liveMap);
    $32b2e646f1d79cc3$var$liveMap.layerManagers.lsr = new (0, $659ab7393afe953c$export$2e2bcd8739ae039)("lsr", $32b2e646f1d79cc3$var$liveMap);
    $32b2e646f1d79cc3$var$liveMap.layerManagers.sfcanalysis = new (0, $8edef51f16c09cfe$export$2e2bcd8739ae039)("sfcanalysis", $32b2e646f1d79cc3$var$liveMap);
    $32b2e646f1d79cc3$var$liveMap.layerManagers.skyCams = new (0, $9584431d8e116ee4$export$2e2bcd8739ae039)("skyCams", $32b2e646f1d79cc3$var$liveMap);
    $32b2e646f1d79cc3$var$liveMap.layerManagers.tropical = new (0, $857cbd75c64b11e4$export$2e2bcd8739ae039)("tropical", $32b2e646f1d79cc3$var$liveMap);
    $32b2e646f1d79cc3$var$liveMap.layerManagers.convective = new (0, $f1ed327efddff4cb$export$2e2bcd8739ae039)("convective", $32b2e646f1d79cc3$var$liveMap);
    $32b2e646f1d79cc3$var$liveMap.layerManagers.swo = new (0, $2c8cfba025ea0979$export$2e2bcd8739ae039)("swo", $32b2e646f1d79cc3$var$liveMap);
    $32b2e646f1d79cc3$var$liveMap.layerManagers.fire = new (0, $7499894043646551$export$2e2bcd8739ae039)("fire", $32b2e646f1d79cc3$var$liveMap);
    $32b2e646f1d79cc3$var$liveMap.layerManagers.earthquake = new (0, $37cec9c5946386eb$export$2e2bcd8739ae039)("earthquake", $32b2e646f1d79cc3$var$liveMap);
    // TODO TESTING
    $32b2e646f1d79cc3$var$liveMap.layerManagers.radarLoop = new (0, $5823c3d68f538dd4$export$2e2bcd8739ae039)("radarLoop", $32b2e646f1d79cc3$var$liveMap);
    // Callback: setup injected layer managers & attach default layers once Vue has fully loaded the sidebar
    $32b2e646f1d79cc3$var$liveMap._handleLayerList = function() {
        for (let cl of $32b2e646f1d79cc3$var$liveMap._layerList){
            for (let layer of cl.layers)if (layer.type === "tile" || layer.type === "wms" || layer.type === "wmts") $32b2e646f1d79cc3$var$liveMap.layerManagers[layer.layerId] = new (0, $86a4f3cd09be9e01$export$2e2bcd8739ae039)(layer.layerId, $32b2e646f1d79cc3$var$liveMap, layer.type, layer.url, layer.options, layer.sublayers);
        }
        var defaultEnabled = [
            "radar",
            "alerts",
            "wxObs"
        ];
        var storedLayers = null;
        if (window.localStorage) storedLayers = JSON.parse(window.localStorage.getItem("weatherusa.weatherlive.layers"));
        var inlayers = [];
        var invalids = [];
        if (typeof uriqs.layers === "string") // Use layers list from URL (priority)
        inlayers = uriqs.layers.split(",");
        else if (storedLayers) // Use saved layers list in localStorage
        inlayers = storedLayers;
        if (inlayers.length) {
            for(let inl = 0; inl < inlayers.length; inl++){
                // Shim for v1 map (app & private links) to replace "obs-t" with "wxObs-t"
                if (inlayers[inl] == "obs-t") inlayers[inl] = "wxObs-t";
                if (inlayers[inl] == "obs") inlayers[inl] = "wxObs";
                // Find layer base ID, if needed
                // see if '-' in name, if so this is sublayer or filter option
                var larr = inlayers[inl].split("-");
                var lbase = larr[0];
                // FIXME should use SetOption not direct variable access
                if (larr.length > 1 && window.liveMap.layerManagers[lbase] && window.liveMap.layerManagers[lbase].dataOptions && window.liveMap.layerManagers[lbase].dataOptions.mVar) {
                    window.liveMap.layerManagers[lbase].dataOptions.mVar = larr[1];
                    inlayers[inl] = lbase;
                }
                if (!(lbase in window.liveMap.layerManagers)) invalids.push(inlayers[inl]);
            }
            // Remove any invalid layer names
            (0, (/*@__PURE__*/$parcel$interopDefault($ecb273f3e187f9b4$exports)))(inlayers, invalids);
            defaultEnabled = inlayers;
        }
        $32b2e646f1d79cc3$var$liveMap.sidebar.activeLayers = defaultEnabled;
    };
    window.liveMap = $32b2e646f1d79cc3$var$liveMap;
}
function $32b2e646f1d79cc3$var$setupUI() {
    $32b2e646f1d79cc3$var$liveMap.sidebar = (0, $aFJJk.createApp)((0, $b9d9a242c3166ba0$export$2e2bcd8739ae039)).mount("#vue_MapSidebar");
    $("#map_controls_handle").on("click", function() {
        if (!$("#map_controls_wrapper").hasClass("controls-open") && !$("#map_controls_wrapper").hasClass("controls-closed")) {
            // Detect initial state for proper toggle
            if ($("#map_controls_wrapper").css("right") === "0px") $("#map_controls_wrapper, #map_canvas").addClass("controls-open");
            else $("#map_controls_wrapper, #map_canvas").addClass("controls-closed");
        }
        if ($("#map_controls_wrapper").hasClass("controls-open")) // Close it
        $("#map_controls_wrapper, #map_canvas").removeClass("controls-open").addClass("controls-closed");
        else // Open it
        $("#map_controls_wrapper, #map_canvas").removeClass("controls-closed").addClass("controls-open");
    });
    $(function() {
        $('[data-toggle="tooltip"]').tooltip();
    });
    document.getElementById("map_controls_wrapper").addEventListener("transitionend", function() {
        // console.log('transition END');
        $32b2e646f1d79cc3$var$liveMap.map.invalidateSize();
    });
    document.getElementById("map_controls").addEventListener("transitionend", function(e) {
        e.stopPropagation();
    });
    $("#infobox_wrapper .close-button").on("click", function(e) {
        e.preventDefault();
        $("#infobox_wrapper").removeClass("open");
    });
    $32b2e646f1d79cc3$var$liveMap._searchDialog = new (0, $b2ad9c2bf819e404$export$2e2bcd8739ae039)("#qstr", "#qstr_dropdown");
    $32b2e646f1d79cc3$var$liveMap._searchDialog.attachSearchFormListeners();
    $("#action_geolocate").on("click", (e)=>{
        e.preventDefault();
        if (navigator.geolocation) navigator.geolocation.getCurrentPosition($32b2e646f1d79cc3$var$liveMap.geolocated.bind($32b2e646f1d79cc3$var$liveMap), $32b2e646f1d79cc3$var$liveMap.geolocationError.bind($32b2e646f1d79cc3$var$liveMap));
        $("#fullscreen_search").removeClass("search-mobile");
    });
    $("#action_fullscreen").on("click", (e)=>{
        e.preventDefault();
        $32b2e646f1d79cc3$var$liveMap.launchFullScreen(document.documentElement);
    });
    $("#action_search").on("click", (e)=>{
        e.preventDefault();
        $("#fullscreen_search").toggleClass("search-mobile");
    });
    // Refresh map layers automatically
    $32b2e646f1d79cc3$var$liveMap.updateAllLayersPeriodic();
}

})();
//# sourceMappingURL=weatherNetLive.js.map
